/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type JSONValueLevel1 = string | number | boolean; export type JSONValue = { [x: string]: JSONValueLevel1 } | JSONValueLevel1[] | JSONValueLevel1; 
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: string; output: string; }
  citext: { input: string; output: string; }
  date: { input: string; output: string; }
  grid_insert_position_enum: { input: string; output: string; }
  inet: { input: string; output: string; }
  jsonb: { input: JSONValue; output: JSONValue; }
  mfa_mode_enum: { input: string; output: string; }
  numeric: { input: number; output: number; }
  page_main_column_type: { input: string; output: string; }
  page_type: { input: string; output: string; }
  persona_enum: { input: string; output: string; }
  range_summary_calc_enum: { input: string; output: string; }
  smallint: { input: number; output: number; }
  theme_enum: { input: string; output: string; }
  timestamptz: { input: string; output: string; }
  tstzrange: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gte?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lte?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['Int']['input']>;
  readonly _gt?: InputMaybe<Scalars['Int']['input']>;
  readonly _gte?: InputMaybe<Scalars['Int']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['Int']['input']>;
  readonly _lte?: InputMaybe<Scalars['Int']['input']>;
  readonly _neq?: InputMaybe<Scalars['Int']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  readonly _contained_in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** does the array contain the given value */
  readonly _contains?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _eq?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _gt?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _gte?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _in?: InputMaybe<ReadonlyArray<ReadonlyArray<Scalars['String']['input']>>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _lte?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _neq?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _nin?: InputMaybe<ReadonlyArray<ReadonlyArray<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['String']['input']>;
  readonly _gt?: InputMaybe<Scalars['String']['input']>;
  readonly _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  readonly _ilike?: InputMaybe<Scalars['String']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  readonly _iregex?: InputMaybe<Scalars['String']['input']>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  readonly _like?: InputMaybe<Scalars['String']['input']>;
  readonly _lt?: InputMaybe<Scalars['String']['input']>;
  readonly _lte?: InputMaybe<Scalars['String']['input']>;
  readonly _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  readonly _nilike?: InputMaybe<Scalars['String']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  readonly _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  readonly _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  readonly _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  readonly _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  readonly _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  readonly _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "alerts" */
export type Alerts = {
  readonly __typename?: 'alerts';
  /** An array relationship */
  readonly Members: ReadonlyArray<Page_Member>;
  /** An aggregate relationship */
  readonly Members_aggregate: Page_Member_Aggregate;
  /** An object relationship */
  readonly Page: Pages;
  readonly _id?: Maybe<Scalars['String']['output']>;
  readonly column_id: Scalars['String']['output'];
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly desktop_notification_sent?: Maybe<Scalars['Boolean']['output']>;
  readonly expired_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly field_selector?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly id: Scalars['String']['output'];
  readonly limit: Scalars['String']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly page_id: Scalars['String']['output'];
  readonly product_id: Scalars['String']['output'];
  readonly push_notification_sent?: Maybe<Scalars['Boolean']['output']>;
  readonly recurring?: Maybe<Scalars['Boolean']['output']>;
  readonly row_id: Scalars['String']['output'];
  readonly sound?: Maybe<Scalars['Boolean']['output']>;
  readonly status: Scalars['String']['output'];
  readonly triggered_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id: Scalars['String']['output'];
  readonly value_below_limit: Scalars['Boolean']['output'];
};


/** columns and relationships of "alerts" */
export type AlertsMembersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


/** columns and relationships of "alerts" */
export type AlertsMembers_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};

/** aggregated selection of "alerts" */
export type Alerts_Aggregate = {
  readonly __typename?: 'alerts_aggregate';
  readonly aggregate?: Maybe<Alerts_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Alerts>;
};

export type Alerts_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Alerts_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Alerts_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Alerts_Aggregate_Bool_Exp_Count>;
};

export type Alerts_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Alerts_Select_Column_Alerts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Alerts_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Alerts_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Alerts_Select_Column_Alerts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Alerts_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Alerts_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Alerts_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "alerts" */
export type Alerts_Aggregate_Fields = {
  readonly __typename?: 'alerts_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Alerts_Max_Fields>;
  readonly min?: Maybe<Alerts_Min_Fields>;
};


/** aggregate fields of "alerts" */
export type Alerts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "alerts" */
export type Alerts_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Alerts_Max_Order_By>;
  readonly min?: InputMaybe<Alerts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "alerts" */
export type Alerts_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Alerts_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Alerts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "alerts". All fields are combined with a logical 'AND'. */
export type Alerts_Bool_Exp = {
  readonly Members?: InputMaybe<Page_Member_Bool_Exp>;
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Bool_Exp>;
  readonly Page?: InputMaybe<Pages_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Alerts_Bool_Exp>>;
  readonly _id?: InputMaybe<String_Comparison_Exp>;
  readonly _not?: InputMaybe<Alerts_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Alerts_Bool_Exp>>;
  readonly column_id?: InputMaybe<String_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly desktop_notification_sent?: InputMaybe<Boolean_Comparison_Exp>;
  readonly expired_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly field_selector?: InputMaybe<String_Comparison_Exp>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly limit?: InputMaybe<String_Comparison_Exp>;
  readonly note?: InputMaybe<String_Comparison_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly product_id?: InputMaybe<String_Comparison_Exp>;
  readonly push_notification_sent?: InputMaybe<Boolean_Comparison_Exp>;
  readonly recurring?: InputMaybe<Boolean_Comparison_Exp>;
  readonly row_id?: InputMaybe<String_Comparison_Exp>;
  readonly sound?: InputMaybe<Boolean_Comparison_Exp>;
  readonly status?: InputMaybe<String_Comparison_Exp>;
  readonly triggered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
  readonly value_below_limit?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "alerts" */
export type Alerts_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'alerts_pkey';

/** input type for inserting data into table "alerts" */
export type Alerts_Insert_Input = {
  readonly Members?: InputMaybe<Page_Member_Arr_Rel_Insert_Input>;
  readonly Page?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly _id?: InputMaybe<Scalars['String']['input']>;
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly desktop_notification_sent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly field_selector?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly limit?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly push_notification_sent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly recurring?: InputMaybe<Scalars['Boolean']['input']>;
  readonly row_id?: InputMaybe<Scalars['String']['input']>;
  readonly sound?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly value_below_limit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Alerts_Max_Fields = {
  readonly __typename?: 'alerts_max_fields';
  readonly _id?: Maybe<Scalars['String']['output']>;
  readonly column_id?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly expired_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly field_selector?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly limit?: Maybe<Scalars['String']['output']>;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly row_id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly triggered_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "alerts" */
export type Alerts_Max_Order_By = {
  readonly _id?: InputMaybe<Order_By>;
  readonly column_id?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly expired_at?: InputMaybe<Order_By>;
  readonly field_selector?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly limit?: InputMaybe<Order_By>;
  readonly note?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly row_id?: InputMaybe<Order_By>;
  readonly status?: InputMaybe<Order_By>;
  readonly triggered_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Alerts_Min_Fields = {
  readonly __typename?: 'alerts_min_fields';
  readonly _id?: Maybe<Scalars['String']['output']>;
  readonly column_id?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly expired_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly field_selector?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly limit?: Maybe<Scalars['String']['output']>;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly row_id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly triggered_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "alerts" */
export type Alerts_Min_Order_By = {
  readonly _id?: InputMaybe<Order_By>;
  readonly column_id?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly expired_at?: InputMaybe<Order_By>;
  readonly field_selector?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly limit?: InputMaybe<Order_By>;
  readonly note?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly row_id?: InputMaybe<Order_By>;
  readonly status?: InputMaybe<Order_By>;
  readonly triggered_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "alerts" */
export type Alerts_Mutation_Response = {
  readonly __typename?: 'alerts_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Alerts>;
};

/** on_conflict condition type for table "alerts" */
export type Alerts_On_Conflict = {
  readonly constraint: Alerts_Constraint;
  readonly update_columns?: ReadonlyArray<Alerts_Update_Column>;
  readonly where?: InputMaybe<Alerts_Bool_Exp>;
};

/** Ordering options when selecting data from "alerts". */
export type Alerts_Order_By = {
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Order_By>;
  readonly Page?: InputMaybe<Pages_Order_By>;
  readonly _id?: InputMaybe<Order_By>;
  readonly column_id?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly desktop_notification_sent?: InputMaybe<Order_By>;
  readonly expired_at?: InputMaybe<Order_By>;
  readonly field_selector?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly limit?: InputMaybe<Order_By>;
  readonly note?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly push_notification_sent?: InputMaybe<Order_By>;
  readonly recurring?: InputMaybe<Order_By>;
  readonly row_id?: InputMaybe<Order_By>;
  readonly sound?: InputMaybe<Order_By>;
  readonly status?: InputMaybe<Order_By>;
  readonly triggered_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
  readonly value_below_limit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: alerts */
export type Alerts_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "alerts" */
export type Alerts_Select_Column =
  /** column name */
  | '_id'
  /** column name */
  | 'column_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'desktop_notification_sent'
  /** column name */
  | 'expired_at'
  /** column name */
  | 'field_selector'
  /** column name */
  | 'id'
  /** column name */
  | 'limit'
  /** column name */
  | 'note'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'push_notification_sent'
  /** column name */
  | 'recurring'
  /** column name */
  | 'row_id'
  /** column name */
  | 'sound'
  /** column name */
  | 'status'
  /** column name */
  | 'triggered_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'value_below_limit';

/** select "alerts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "alerts" */
export type Alerts_Select_Column_Alerts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'desktop_notification_sent'
  /** column name */
  | 'push_notification_sent'
  /** column name */
  | 'recurring'
  /** column name */
  | 'sound'
  /** column name */
  | 'value_below_limit';

/** select "alerts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "alerts" */
export type Alerts_Select_Column_Alerts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'desktop_notification_sent'
  /** column name */
  | 'push_notification_sent'
  /** column name */
  | 'recurring'
  /** column name */
  | 'sound'
  /** column name */
  | 'value_below_limit';

/** input type for updating data in table "alerts" */
export type Alerts_Set_Input = {
  readonly _id?: InputMaybe<Scalars['String']['input']>;
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly desktop_notification_sent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly field_selector?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly limit?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly push_notification_sent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly recurring?: InputMaybe<Scalars['Boolean']['input']>;
  readonly row_id?: InputMaybe<Scalars['String']['input']>;
  readonly sound?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly value_below_limit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "alerts" */
export type Alerts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Alerts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alerts_Stream_Cursor_Value_Input = {
  readonly _id?: InputMaybe<Scalars['String']['input']>;
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly desktop_notification_sent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly field_selector?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly limit?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly push_notification_sent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly recurring?: InputMaybe<Scalars['Boolean']['input']>;
  readonly row_id?: InputMaybe<Scalars['String']['input']>;
  readonly sound?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly value_below_limit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "alerts" */
export type Alerts_Update_Column =
  /** column name */
  | '_id'
  /** column name */
  | 'column_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'desktop_notification_sent'
  /** column name */
  | 'expired_at'
  /** column name */
  | 'field_selector'
  /** column name */
  | 'id'
  /** column name */
  | 'limit'
  /** column name */
  | 'note'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'push_notification_sent'
  /** column name */
  | 'recurring'
  /** column name */
  | 'row_id'
  /** column name */
  | 'sound'
  /** column name */
  | 'status'
  /** column name */
  | 'triggered_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'value_below_limit';

export type Alerts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Alerts_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Alerts_Bool_Exp;
};

/** columns and relationships of "audit.logged_actions" */
export type Audit_Logged_Actions = {
  readonly __typename?: 'audit_logged_actions';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  readonly action: Scalars['String']['output'];
  /** Transaction start timestamp for tx in which audited event occurred */
  readonly action_tstamp_tx: Scalars['timestamptz']['output'];
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  readonly application_name?: Maybe<Scalars['String']['output']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: Maybe<Scalars['jsonb']['output']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  readonly client_addr?: Maybe<Scalars['inet']['output']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id: Scalars['bigint']['output'];
  readonly hasura_org?: Maybe<Scalars['String']['output']>;
  readonly hasura_user?: Maybe<Scalars['String']['output']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: Maybe<Scalars['jsonb']['output']>;
  /** Database schema audited table for this event is in */
  readonly schema_name: Scalars['String']['output'];
  /** Login / session user whose statement caused the audited event */
  readonly session_user_name?: Maybe<Scalars['String']['output']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  readonly statement_only: Scalars['Boolean']['output'];
  /** Non-schema-qualified table name of table event occured in */
  readonly table_name: Scalars['String']['output'];
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "audit.logged_actions" */
export type Audit_Logged_ActionsChanged_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audit.logged_actions" */
export type Audit_Logged_ActionsRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "audit.logged_actions" */
export type Audit_Logged_Actions_Aggregate = {
  readonly __typename?: 'audit_logged_actions_aggregate';
  readonly aggregate?: Maybe<Audit_Logged_Actions_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Audit_Logged_Actions>;
};

/** aggregate fields of "audit.logged_actions" */
export type Audit_Logged_Actions_Aggregate_Fields = {
  readonly __typename?: 'audit_logged_actions_aggregate_fields';
  readonly avg?: Maybe<Audit_Logged_Actions_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Audit_Logged_Actions_Max_Fields>;
  readonly min?: Maybe<Audit_Logged_Actions_Min_Fields>;
  readonly stddev?: Maybe<Audit_Logged_Actions_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Audit_Logged_Actions_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Audit_Logged_Actions_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Audit_Logged_Actions_Sum_Fields>;
  readonly var_pop?: Maybe<Audit_Logged_Actions_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Audit_Logged_Actions_Var_Samp_Fields>;
  readonly variance?: Maybe<Audit_Logged_Actions_Variance_Fields>;
};


/** aggregate fields of "audit.logged_actions" */
export type Audit_Logged_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Audit_Logged_Actions_Append_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Audit_Logged_Actions_Avg_Fields = {
  readonly __typename?: 'audit_logged_actions_avg_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "audit.logged_actions". All fields are combined with a logical 'AND'. */
export type Audit_Logged_Actions_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Bool_Exp>>;
  readonly _not?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Bool_Exp>>;
  readonly action?: InputMaybe<String_Comparison_Exp>;
  readonly action_tstamp_tx?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly application_name?: InputMaybe<String_Comparison_Exp>;
  readonly changed_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly client_addr?: InputMaybe<Inet_Comparison_Exp>;
  readonly client_port?: InputMaybe<Int_Comparison_Exp>;
  readonly event_id?: InputMaybe<Bigint_Comparison_Exp>;
  readonly hasura_org?: InputMaybe<String_Comparison_Exp>;
  readonly hasura_user?: InputMaybe<String_Comparison_Exp>;
  readonly row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly schema_name?: InputMaybe<String_Comparison_Exp>;
  readonly session_user_name?: InputMaybe<String_Comparison_Exp>;
  readonly statement_only?: InputMaybe<Boolean_Comparison_Exp>;
  readonly table_name?: InputMaybe<String_Comparison_Exp>;
  readonly transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "audit.logged_actions" */
export type Audit_Logged_Actions_Constraint =
  /** unique or primary key constraint on columns "event_id" */
  | 'logged_actions_pkey1';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Audit_Logged_Actions_Delete_At_Path_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Audit_Logged_Actions_Delete_Elem_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['Int']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Audit_Logged_Actions_Delete_Key_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['String']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "audit.logged_actions" */
export type Audit_Logged_Actions_Inc_Input = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "audit.logged_actions" */
export type Audit_Logged_Actions_Insert_Input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  readonly action?: InputMaybe<Scalars['String']['input']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  readonly action_tstamp_tx?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  readonly application_name?: InputMaybe<Scalars['String']['input']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  readonly client_addr?: InputMaybe<Scalars['inet']['input']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: InputMaybe<Scalars['bigint']['input']>;
  readonly hasura_org?: InputMaybe<Scalars['String']['input']>;
  readonly hasura_user?: InputMaybe<Scalars['String']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Database schema audited table for this event is in */
  readonly schema_name?: InputMaybe<Scalars['String']['input']>;
  /** Login / session user whose statement caused the audited event */
  readonly session_user_name?: InputMaybe<Scalars['String']['input']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  readonly statement_only?: InputMaybe<Scalars['Boolean']['input']>;
  /** Non-schema-qualified table name of table event occured in */
  readonly table_name?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Audit_Logged_Actions_Max_Fields = {
  readonly __typename?: 'audit_logged_actions_max_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  readonly action?: Maybe<Scalars['String']['output']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  readonly action_tstamp_tx?: Maybe<Scalars['timestamptz']['output']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  readonly application_name?: Maybe<Scalars['String']['output']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['bigint']['output']>;
  readonly hasura_org?: Maybe<Scalars['String']['output']>;
  readonly hasura_user?: Maybe<Scalars['String']['output']>;
  /** Database schema audited table for this event is in */
  readonly schema_name?: Maybe<Scalars['String']['output']>;
  /** Login / session user whose statement caused the audited event */
  readonly session_user_name?: Maybe<Scalars['String']['output']>;
  /** Non-schema-qualified table name of table event occured in */
  readonly table_name?: Maybe<Scalars['String']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Audit_Logged_Actions_Min_Fields = {
  readonly __typename?: 'audit_logged_actions_min_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  readonly action?: Maybe<Scalars['String']['output']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  readonly action_tstamp_tx?: Maybe<Scalars['timestamptz']['output']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  readonly application_name?: Maybe<Scalars['String']['output']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['bigint']['output']>;
  readonly hasura_org?: Maybe<Scalars['String']['output']>;
  readonly hasura_user?: Maybe<Scalars['String']['output']>;
  /** Database schema audited table for this event is in */
  readonly schema_name?: Maybe<Scalars['String']['output']>;
  /** Login / session user whose statement caused the audited event */
  readonly session_user_name?: Maybe<Scalars['String']['output']>;
  /** Non-schema-qualified table name of table event occured in */
  readonly table_name?: Maybe<Scalars['String']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "audit.logged_actions" */
export type Audit_Logged_Actions_Mutation_Response = {
  readonly __typename?: 'audit_logged_actions_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Audit_Logged_Actions>;
};

/** on_conflict condition type for table "audit.logged_actions" */
export type Audit_Logged_Actions_On_Conflict = {
  readonly constraint: Audit_Logged_Actions_Constraint;
  readonly update_columns?: ReadonlyArray<Audit_Logged_Actions_Update_Column>;
  readonly where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "audit.logged_actions". */
export type Audit_Logged_Actions_Order_By = {
  readonly action?: InputMaybe<Order_By>;
  readonly action_tstamp_tx?: InputMaybe<Order_By>;
  readonly application_name?: InputMaybe<Order_By>;
  readonly changed_fields?: InputMaybe<Order_By>;
  readonly client_addr?: InputMaybe<Order_By>;
  readonly client_port?: InputMaybe<Order_By>;
  readonly event_id?: InputMaybe<Order_By>;
  readonly hasura_org?: InputMaybe<Order_By>;
  readonly hasura_user?: InputMaybe<Order_By>;
  readonly row_data?: InputMaybe<Order_By>;
  readonly schema_name?: InputMaybe<Order_By>;
  readonly session_user_name?: InputMaybe<Order_By>;
  readonly statement_only?: InputMaybe<Order_By>;
  readonly table_name?: InputMaybe<Order_By>;
  readonly transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audit.logged_actions */
export type Audit_Logged_Actions_Pk_Columns_Input = {
  /** Unique identifier for each auditable event */
  readonly event_id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Audit_Logged_Actions_Prepend_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "audit.logged_actions" */
export type Audit_Logged_Actions_Select_Column =
  /** column name */
  | 'action'
  /** column name */
  | 'action_tstamp_tx'
  /** column name */
  | 'application_name'
  /** column name */
  | 'changed_fields'
  /** column name */
  | 'client_addr'
  /** column name */
  | 'client_port'
  /** column name */
  | 'event_id'
  /** column name */
  | 'hasura_org'
  /** column name */
  | 'hasura_user'
  /** column name */
  | 'row_data'
  /** column name */
  | 'schema_name'
  /** column name */
  | 'session_user_name'
  /** column name */
  | 'statement_only'
  /** column name */
  | 'table_name'
  /** column name */
  | 'transaction_id';

/** input type for updating data in table "audit.logged_actions" */
export type Audit_Logged_Actions_Set_Input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  readonly action?: InputMaybe<Scalars['String']['input']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  readonly action_tstamp_tx?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  readonly application_name?: InputMaybe<Scalars['String']['input']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  readonly client_addr?: InputMaybe<Scalars['inet']['input']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: InputMaybe<Scalars['bigint']['input']>;
  readonly hasura_org?: InputMaybe<Scalars['String']['input']>;
  readonly hasura_user?: InputMaybe<Scalars['String']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Database schema audited table for this event is in */
  readonly schema_name?: InputMaybe<Scalars['String']['input']>;
  /** Login / session user whose statement caused the audited event */
  readonly session_user_name?: InputMaybe<Scalars['String']['input']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  readonly statement_only?: InputMaybe<Scalars['Boolean']['input']>;
  /** Non-schema-qualified table name of table event occured in */
  readonly table_name?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Audit_Logged_Actions_Stddev_Fields = {
  readonly __typename?: 'audit_logged_actions_stddev_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Audit_Logged_Actions_Stddev_Pop_Fields = {
  readonly __typename?: 'audit_logged_actions_stddev_pop_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Audit_Logged_Actions_Stddev_Samp_Fields = {
  readonly __typename?: 'audit_logged_actions_stddev_samp_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "audit_logged_actions" */
export type Audit_Logged_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Audit_Logged_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Logged_Actions_Stream_Cursor_Value_Input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  readonly action?: InputMaybe<Scalars['String']['input']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  readonly action_tstamp_tx?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  readonly application_name?: InputMaybe<Scalars['String']['input']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  readonly changed_fields?: InputMaybe<Scalars['jsonb']['input']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  readonly client_addr?: InputMaybe<Scalars['inet']['input']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: InputMaybe<Scalars['bigint']['input']>;
  readonly hasura_org?: InputMaybe<Scalars['String']['input']>;
  readonly hasura_user?: InputMaybe<Scalars['String']['input']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Database schema audited table for this event is in */
  readonly schema_name?: InputMaybe<Scalars['String']['input']>;
  /** Login / session user whose statement caused the audited event */
  readonly session_user_name?: InputMaybe<Scalars['String']['input']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  readonly statement_only?: InputMaybe<Scalars['Boolean']['input']>;
  /** Non-schema-qualified table name of table event occured in */
  readonly table_name?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Audit_Logged_Actions_Sum_Fields = {
  readonly __typename?: 'audit_logged_actions_sum_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['bigint']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "audit.logged_actions" */
export type Audit_Logged_Actions_Update_Column =
  /** column name */
  | 'action'
  /** column name */
  | 'action_tstamp_tx'
  /** column name */
  | 'application_name'
  /** column name */
  | 'changed_fields'
  /** column name */
  | 'client_addr'
  /** column name */
  | 'client_port'
  /** column name */
  | 'event_id'
  /** column name */
  | 'hasura_org'
  /** column name */
  | 'hasura_user'
  /** column name */
  | 'row_data'
  /** column name */
  | 'schema_name'
  /** column name */
  | 'session_user_name'
  /** column name */
  | 'statement_only'
  /** column name */
  | 'table_name'
  /** column name */
  | 'transaction_id';

export type Audit_Logged_Actions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Audit_Logged_Actions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Audit_Logged_Actions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Audit_Logged_Actions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Audit_Logged_Actions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Audit_Logged_Actions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Audit_Logged_Actions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Audit_Logged_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Audit_Logged_Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audit_Logged_Actions_Var_Pop_Fields = {
  readonly __typename?: 'audit_logged_actions_var_pop_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Audit_Logged_Actions_Var_Samp_Fields = {
  readonly __typename?: 'audit_logged_actions_var_samp_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Audit_Logged_Actions_Variance_Fields = {
  readonly __typename?: 'audit_logged_actions_variance_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  readonly client_port?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for each auditable event */
  readonly event_id?: Maybe<Scalars['Float']['output']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  readonly transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** https://app.shortcut.com/artis-works/story/3391/ability-to-see-an-audit-history-in-umi-and-rollback-changes */
export type Audit_Umi_Actions = {
  readonly __typename?: 'audit_umi_actions';
  readonly action_name: Scalars['String']['output'];
  readonly created_at: Scalars['timestamptz']['output'];
  readonly event_data: Scalars['jsonb']['output'];
  readonly id: Scalars['Int']['output'];
  readonly umi_user_id: Scalars['String']['output'];
};


/** https://app.shortcut.com/artis-works/story/3391/ability-to-see-an-audit-history-in-umi-and-rollback-changes */
export type Audit_Umi_ActionsEvent_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "audit.umi_actions" */
export type Audit_Umi_Actions_Aggregate = {
  readonly __typename?: 'audit_umi_actions_aggregate';
  readonly aggregate?: Maybe<Audit_Umi_Actions_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Audit_Umi_Actions>;
};

/** aggregate fields of "audit.umi_actions" */
export type Audit_Umi_Actions_Aggregate_Fields = {
  readonly __typename?: 'audit_umi_actions_aggregate_fields';
  readonly avg?: Maybe<Audit_Umi_Actions_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Audit_Umi_Actions_Max_Fields>;
  readonly min?: Maybe<Audit_Umi_Actions_Min_Fields>;
  readonly stddev?: Maybe<Audit_Umi_Actions_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Audit_Umi_Actions_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Audit_Umi_Actions_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Audit_Umi_Actions_Sum_Fields>;
  readonly var_pop?: Maybe<Audit_Umi_Actions_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Audit_Umi_Actions_Var_Samp_Fields>;
  readonly variance?: Maybe<Audit_Umi_Actions_Variance_Fields>;
};


/** aggregate fields of "audit.umi_actions" */
export type Audit_Umi_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Audit_Umi_Actions_Append_Input = {
  readonly event_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Audit_Umi_Actions_Avg_Fields = {
  readonly __typename?: 'audit_umi_actions_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "audit.umi_actions". All fields are combined with a logical 'AND'. */
export type Audit_Umi_Actions_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Bool_Exp>>;
  readonly _not?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Bool_Exp>>;
  readonly action_name?: InputMaybe<String_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly event_data?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly umi_user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "audit.umi_actions" */
export type Audit_Umi_Actions_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'umi_actions_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Audit_Umi_Actions_Delete_At_Path_Input = {
  readonly event_data?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Audit_Umi_Actions_Delete_Elem_Input = {
  readonly event_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Audit_Umi_Actions_Delete_Key_Input = {
  readonly event_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "audit.umi_actions" */
export type Audit_Umi_Actions_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "audit.umi_actions" */
export type Audit_Umi_Actions_Insert_Input = {
  readonly action_name?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly event_data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly umi_user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Audit_Umi_Actions_Max_Fields = {
  readonly __typename?: 'audit_umi_actions_max_fields';
  readonly action_name?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly umi_user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Audit_Umi_Actions_Min_Fields = {
  readonly __typename?: 'audit_umi_actions_min_fields';
  readonly action_name?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly umi_user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "audit.umi_actions" */
export type Audit_Umi_Actions_Mutation_Response = {
  readonly __typename?: 'audit_umi_actions_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Audit_Umi_Actions>;
};

/** on_conflict condition type for table "audit.umi_actions" */
export type Audit_Umi_Actions_On_Conflict = {
  readonly constraint: Audit_Umi_Actions_Constraint;
  readonly update_columns?: ReadonlyArray<Audit_Umi_Actions_Update_Column>;
  readonly where?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "audit.umi_actions". */
export type Audit_Umi_Actions_Order_By = {
  readonly action_name?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly event_data?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly umi_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audit.umi_actions */
export type Audit_Umi_Actions_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Audit_Umi_Actions_Prepend_Input = {
  readonly event_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "audit.umi_actions" */
export type Audit_Umi_Actions_Select_Column =
  /** column name */
  | 'action_name'
  /** column name */
  | 'created_at'
  /** column name */
  | 'event_data'
  /** column name */
  | 'id'
  /** column name */
  | 'umi_user_id';

/** input type for updating data in table "audit.umi_actions" */
export type Audit_Umi_Actions_Set_Input = {
  readonly action_name?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly event_data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly umi_user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Audit_Umi_Actions_Stddev_Fields = {
  readonly __typename?: 'audit_umi_actions_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Audit_Umi_Actions_Stddev_Pop_Fields = {
  readonly __typename?: 'audit_umi_actions_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Audit_Umi_Actions_Stddev_Samp_Fields = {
  readonly __typename?: 'audit_umi_actions_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "audit_umi_actions" */
export type Audit_Umi_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Audit_Umi_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Umi_Actions_Stream_Cursor_Value_Input = {
  readonly action_name?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly event_data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly umi_user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Audit_Umi_Actions_Sum_Fields = {
  readonly __typename?: 'audit_umi_actions_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "audit.umi_actions" */
export type Audit_Umi_Actions_Update_Column =
  /** column name */
  | 'action_name'
  /** column name */
  | 'created_at'
  /** column name */
  | 'event_data'
  /** column name */
  | 'id'
  /** column name */
  | 'umi_user_id';

export type Audit_Umi_Actions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Audit_Umi_Actions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Audit_Umi_Actions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Audit_Umi_Actions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Audit_Umi_Actions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Audit_Umi_Actions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Audit_Umi_Actions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Audit_Umi_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Audit_Umi_Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audit_Umi_Actions_Var_Pop_Fields = {
  readonly __typename?: 'audit_umi_actions_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Audit_Umi_Actions_Var_Samp_Fields = {
  readonly __typename?: 'audit_umi_actions_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Audit_Umi_Actions_Variance_Fields = {
  readonly __typename?: 'audit_umi_actions_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['bigint']['input']>;
  readonly _gt?: InputMaybe<Scalars['bigint']['input']>;
  readonly _gte?: InputMaybe<Scalars['bigint']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['bigint']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['bigint']['input']>;
  readonly _lte?: InputMaybe<Scalars['bigint']['input']>;
  readonly _neq?: InputMaybe<Scalars['bigint']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['citext']['input']>;
  readonly _gt?: InputMaybe<Scalars['citext']['input']>;
  readonly _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  readonly _ilike?: InputMaybe<Scalars['citext']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  readonly _iregex?: InputMaybe<Scalars['citext']['input']>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  readonly _like?: InputMaybe<Scalars['citext']['input']>;
  readonly _lt?: InputMaybe<Scalars['citext']['input']>;
  readonly _lte?: InputMaybe<Scalars['citext']['input']>;
  readonly _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  readonly _nilike?: InputMaybe<Scalars['citext']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  readonly _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  readonly _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  readonly _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  readonly _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  readonly _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  readonly _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "commodity_group" */
export type Commodity_Group = {
  readonly __typename?: 'commodity_group';
  /** An object relationship */
  readonly commodity_parent_group: Commodity_Parent_Group;
  /** An array relationship */
  readonly global_products: ReadonlyArray<Global_Product>;
  /** An aggregate relationship */
  readonly global_products_aggregate: Global_Product_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly parent: Scalars['Int']['output'];
  /** An array relationship */
  readonly product_overrides: ReadonlyArray<Product_Overrides>;
  /** An aggregate relationship */
  readonly product_overrides_aggregate: Product_Overrides_Aggregate;
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly value?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "commodity_group" */
export type Commodity_GroupGlobal_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "commodity_group" */
export type Commodity_GroupGlobal_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "commodity_group" */
export type Commodity_GroupProduct_OverridesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "commodity_group" */
export type Commodity_GroupProduct_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "commodity_group" */
export type Commodity_GroupProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "commodity_group" */
export type Commodity_GroupProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "commodity_group" */
export type Commodity_Group_Aggregate = {
  readonly __typename?: 'commodity_group_aggregate';
  readonly aggregate?: Maybe<Commodity_Group_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Commodity_Group>;
};

export type Commodity_Group_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Commodity_Group_Aggregate_Bool_Exp_Count>;
};

export type Commodity_Group_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Commodity_Group_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "commodity_group" */
export type Commodity_Group_Aggregate_Fields = {
  readonly __typename?: 'commodity_group_aggregate_fields';
  readonly avg?: Maybe<Commodity_Group_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Commodity_Group_Max_Fields>;
  readonly min?: Maybe<Commodity_Group_Min_Fields>;
  readonly stddev?: Maybe<Commodity_Group_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Commodity_Group_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Commodity_Group_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Commodity_Group_Sum_Fields>;
  readonly var_pop?: Maybe<Commodity_Group_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Commodity_Group_Var_Samp_Fields>;
  readonly variance?: Maybe<Commodity_Group_Variance_Fields>;
};


/** aggregate fields of "commodity_group" */
export type Commodity_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "commodity_group" */
export type Commodity_Group_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Commodity_Group_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Commodity_Group_Max_Order_By>;
  readonly min?: InputMaybe<Commodity_Group_Min_Order_By>;
  readonly stddev?: InputMaybe<Commodity_Group_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Commodity_Group_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Commodity_Group_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Commodity_Group_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Commodity_Group_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Commodity_Group_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Commodity_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "commodity_group" */
export type Commodity_Group_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Commodity_Group_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Commodity_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Group_Avg_Fields = {
  readonly __typename?: 'commodity_group_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "commodity_group" */
export type Commodity_Group_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity_group". All fields are combined with a logical 'AND'. */
export type Commodity_Group_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Commodity_Group_Bool_Exp>>;
  readonly _not?: InputMaybe<Commodity_Group_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Commodity_Group_Bool_Exp>>;
  readonly commodity_parent_group?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
  readonly global_products?: InputMaybe<Global_Product_Bool_Exp>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly parent?: InputMaybe<Int_Comparison_Exp>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Bool_Exp>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Bool_Exp>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "commodity_group" */
export type Commodity_Group_Constraint =
  /** unique or primary key constraint on columns "value", "parent" */
  | 'commodity_group_parent_value_key'
  /** unique or primary key constraint on columns "id" */
  | 'commodity_group_pkey';

/** input type for incrementing numeric columns in table "commodity_group" */
export type Commodity_Group_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "commodity_group" */
export type Commodity_Group_Insert_Input = {
  readonly commodity_parent_group?: InputMaybe<Commodity_Parent_Group_Obj_Rel_Insert_Input>;
  readonly global_products?: InputMaybe<Global_Product_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Arr_Rel_Insert_Input>;
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Commodity_Group_Max_Fields = {
  readonly __typename?: 'commodity_group_max_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly parent?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "commodity_group" */
export type Commodity_Group_Max_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Group_Min_Fields = {
  readonly __typename?: 'commodity_group_min_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly parent?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "commodity_group" */
export type Commodity_Group_Min_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity_group" */
export type Commodity_Group_Mutation_Response = {
  readonly __typename?: 'commodity_group_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Commodity_Group>;
};

/** input type for inserting object relation for remote table "commodity_group" */
export type Commodity_Group_Obj_Rel_Insert_Input = {
  readonly data: Commodity_Group_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Commodity_Group_On_Conflict>;
};

/** on_conflict condition type for table "commodity_group" */
export type Commodity_Group_On_Conflict = {
  readonly constraint: Commodity_Group_Constraint;
  readonly update_columns?: ReadonlyArray<Commodity_Group_Update_Column>;
  readonly where?: InputMaybe<Commodity_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity_group". */
export type Commodity_Group_Order_By = {
  readonly commodity_parent_group?: InputMaybe<Commodity_Parent_Group_Order_By>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Order_By>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commodity_group */
export type Commodity_Group_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "commodity_group" */
export type Commodity_Group_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'parent'
  /** column name */
  | 'value';

/** input type for updating data in table "commodity_group" */
export type Commodity_Group_Set_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Commodity_Group_Stddev_Fields = {
  readonly __typename?: 'commodity_group_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "commodity_group" */
export type Commodity_Group_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Group_Stddev_Pop_Fields = {
  readonly __typename?: 'commodity_group_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "commodity_group" */
export type Commodity_Group_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Group_Stddev_Samp_Fields = {
  readonly __typename?: 'commodity_group_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "commodity_group" */
export type Commodity_Group_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity_group" */
export type Commodity_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Commodity_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Group_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly parent?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Commodity_Group_Sum_Fields = {
  readonly __typename?: 'commodity_group_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly parent?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "commodity_group" */
export type Commodity_Group_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** update columns of table "commodity_group" */
export type Commodity_Group_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'parent'
  /** column name */
  | 'value';

export type Commodity_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Commodity_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Commodity_Group_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Commodity_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Group_Var_Pop_Fields = {
  readonly __typename?: 'commodity_group_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "commodity_group" */
export type Commodity_Group_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Group_Var_Samp_Fields = {
  readonly __typename?: 'commodity_group_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "commodity_group" */
export type Commodity_Group_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Group_Variance_Fields = {
  readonly __typename?: 'commodity_group_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "commodity_group" */
export type Commodity_Group_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly parent?: InputMaybe<Order_By>;
};

/** columns and relationships of "commodity_parent_group" */
export type Commodity_Parent_Group = {
  readonly __typename?: 'commodity_parent_group';
  /** An array relationship */
  readonly commodity_groups: ReadonlyArray<Commodity_Group>;
  /** An aggregate relationship */
  readonly commodity_groups_aggregate: Commodity_Group_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  readonly organisationByOrganisation?: Maybe<Organisation>;
  readonly value?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "commodity_parent_group" */
export type Commodity_Parent_GroupCommodity_GroupsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Group_Order_By>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};


/** columns and relationships of "commodity_parent_group" */
export type Commodity_Parent_GroupCommodity_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Group_Order_By>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};

/** aggregated selection of "commodity_parent_group" */
export type Commodity_Parent_Group_Aggregate = {
  readonly __typename?: 'commodity_parent_group_aggregate';
  readonly aggregate?: Maybe<Commodity_Parent_Group_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Commodity_Parent_Group>;
};

export type Commodity_Parent_Group_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Commodity_Parent_Group_Aggregate_Bool_Exp_Count>;
};

export type Commodity_Parent_Group_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "commodity_parent_group" */
export type Commodity_Parent_Group_Aggregate_Fields = {
  readonly __typename?: 'commodity_parent_group_aggregate_fields';
  readonly avg?: Maybe<Commodity_Parent_Group_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Commodity_Parent_Group_Max_Fields>;
  readonly min?: Maybe<Commodity_Parent_Group_Min_Fields>;
  readonly stddev?: Maybe<Commodity_Parent_Group_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Commodity_Parent_Group_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Commodity_Parent_Group_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Commodity_Parent_Group_Sum_Fields>;
  readonly var_pop?: Maybe<Commodity_Parent_Group_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Commodity_Parent_Group_Var_Samp_Fields>;
  readonly variance?: Maybe<Commodity_Parent_Group_Variance_Fields>;
};


/** aggregate fields of "commodity_parent_group" */
export type Commodity_Parent_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "commodity_parent_group" */
export type Commodity_Parent_Group_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Commodity_Parent_Group_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Commodity_Parent_Group_Max_Order_By>;
  readonly min?: InputMaybe<Commodity_Parent_Group_Min_Order_By>;
  readonly stddev?: InputMaybe<Commodity_Parent_Group_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Commodity_Parent_Group_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Commodity_Parent_Group_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Commodity_Parent_Group_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Commodity_Parent_Group_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Commodity_Parent_Group_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Commodity_Parent_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "commodity_parent_group" */
export type Commodity_Parent_Group_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Commodity_Parent_Group_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Commodity_Parent_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Parent_Group_Avg_Fields = {
  readonly __typename?: 'commodity_parent_group_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity_parent_group". All fields are combined with a logical 'AND'. */
export type Commodity_Parent_Group_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Bool_Exp>>;
  readonly _not?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Bool_Exp>>;
  readonly commodity_groups?: InputMaybe<Commodity_Group_Bool_Exp>;
  readonly commodity_groups_aggregate?: InputMaybe<Commodity_Group_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "commodity_parent_group" */
export type Commodity_Parent_Group_Constraint =
  /** unique or primary key constraint on columns "organisation", "value" */
  | 'commodity_parent_group_organisation_value_key'
  /** unique or primary key constraint on columns "id" */
  | 'commodity_parent_group_pkey';

/** input type for incrementing numeric columns in table "commodity_parent_group" */
export type Commodity_Parent_Group_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "commodity_parent_group" */
export type Commodity_Parent_Group_Insert_Input = {
  readonly commodity_groups?: InputMaybe<Commodity_Group_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Commodity_Parent_Group_Max_Fields = {
  readonly __typename?: 'commodity_parent_group_max_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Max_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Parent_Group_Min_Fields = {
  readonly __typename?: 'commodity_parent_group_min_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Min_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity_parent_group" */
export type Commodity_Parent_Group_Mutation_Response = {
  readonly __typename?: 'commodity_parent_group_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Commodity_Parent_Group>;
};

/** input type for inserting object relation for remote table "commodity_parent_group" */
export type Commodity_Parent_Group_Obj_Rel_Insert_Input = {
  readonly data: Commodity_Parent_Group_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Commodity_Parent_Group_On_Conflict>;
};

/** on_conflict condition type for table "commodity_parent_group" */
export type Commodity_Parent_Group_On_Conflict = {
  readonly constraint: Commodity_Parent_Group_Constraint;
  readonly update_columns?: ReadonlyArray<Commodity_Parent_Group_Update_Column>;
  readonly where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity_parent_group". */
export type Commodity_Parent_Group_Order_By = {
  readonly commodity_groups_aggregate?: InputMaybe<Commodity_Group_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commodity_parent_group */
export type Commodity_Parent_Group_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'organisation'
  /** column name */
  | 'value';

/** input type for updating data in table "commodity_parent_group" */
export type Commodity_Parent_Group_Set_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Commodity_Parent_Group_Stddev_Fields = {
  readonly __typename?: 'commodity_parent_group_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Parent_Group_Stddev_Pop_Fields = {
  readonly __typename?: 'commodity_parent_group_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Parent_Group_Stddev_Samp_Fields = {
  readonly __typename?: 'commodity_parent_group_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity_parent_group" */
export type Commodity_Parent_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Commodity_Parent_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Parent_Group_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Commodity_Parent_Group_Sum_Fields = {
  readonly __typename?: 'commodity_parent_group_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** update columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'organisation'
  /** column name */
  | 'value';

export type Commodity_Parent_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Commodity_Parent_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Commodity_Parent_Group_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Commodity_Parent_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Parent_Group_Var_Pop_Fields = {
  readonly __typename?: 'commodity_parent_group_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Parent_Group_Var_Samp_Fields = {
  readonly __typename?: 'commodity_parent_group_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Parent_Group_Variance_Fields = {
  readonly __typename?: 'commodity_parent_group_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "commodity_parent_group" */
export type Commodity_Parent_Group_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** columns and relationships of "conditional_formatting_rules" */
export type Conditional_Formatting_Rules = {
  readonly __typename?: 'conditional_formatting_rules';
  /** An object relationship */
  readonly Members?: Maybe<Page_Member>;
  /** An object relationship */
  readonly Page: Pages;
  readonly _id?: Maybe<Scalars['String']['output']>;
  readonly bg_color?: Maybe<Scalars['String']['output']>;
  readonly bold_text: Scalars['Boolean']['output'];
  readonly column_id: Scalars['String']['output'];
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly expired_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly id: Scalars['String']['output'];
  readonly invert_text_color: Scalars['Boolean']['output'];
  readonly limit: Scalars['String']['output'];
  readonly note: Scalars['String']['output'];
  readonly page_id: Scalars['String']['output'];
  readonly priority_idx: Scalars['String']['output'];
  readonly row_id: Scalars['String']['output'];
  readonly rule: Scalars['String']['output'];
  readonly stop_if_true: Scalars['Boolean']['output'];
  readonly user_id: Scalars['String']['output'];
};

/** aggregated selection of "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Aggregate = {
  readonly __typename?: 'conditional_formatting_rules_aggregate';
  readonly aggregate?: Maybe<Conditional_Formatting_Rules_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Conditional_Formatting_Rules>;
};

export type Conditional_Formatting_Rules_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Conditional_Formatting_Rules_Aggregate_Bool_Exp_Count>;
};

export type Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Conditional_Formatting_Rules_Select_Column_Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Conditional_Formatting_Rules_Select_Column_Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Conditional_Formatting_Rules_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Aggregate_Fields = {
  readonly __typename?: 'conditional_formatting_rules_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Conditional_Formatting_Rules_Max_Fields>;
  readonly min?: Maybe<Conditional_Formatting_Rules_Min_Fields>;
};


/** aggregate fields of "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Conditional_Formatting_Rules_Max_Order_By>;
  readonly min?: InputMaybe<Conditional_Formatting_Rules_Min_Order_By>;
};

/** input type for inserting array relation for remote table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Conditional_Formatting_Rules_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Conditional_Formatting_Rules_On_Conflict>;
};

/** Boolean expression to filter rows from the table "conditional_formatting_rules". All fields are combined with a logical 'AND'. */
export type Conditional_Formatting_Rules_Bool_Exp = {
  readonly Members?: InputMaybe<Page_Member_Bool_Exp>;
  readonly Page?: InputMaybe<Pages_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Bool_Exp>>;
  readonly _id?: InputMaybe<String_Comparison_Exp>;
  readonly _not?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Bool_Exp>>;
  readonly bg_color?: InputMaybe<String_Comparison_Exp>;
  readonly bold_text?: InputMaybe<Boolean_Comparison_Exp>;
  readonly column_id?: InputMaybe<String_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly expired_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly invert_text_color?: InputMaybe<Boolean_Comparison_Exp>;
  readonly limit?: InputMaybe<String_Comparison_Exp>;
  readonly note?: InputMaybe<String_Comparison_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly priority_idx?: InputMaybe<String_Comparison_Exp>;
  readonly row_id?: InputMaybe<String_Comparison_Exp>;
  readonly rule?: InputMaybe<String_Comparison_Exp>;
  readonly stop_if_true?: InputMaybe<Boolean_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'conditional_formatting_rules_pkey';

/** input type for inserting data into table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Insert_Input = {
  readonly Members?: InputMaybe<Page_Member_Obj_Rel_Insert_Input>;
  readonly Page?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly _id?: InputMaybe<Scalars['String']['input']>;
  readonly bg_color?: InputMaybe<Scalars['String']['input']>;
  readonly bold_text?: InputMaybe<Scalars['Boolean']['input']>;
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly invert_text_color?: InputMaybe<Scalars['Boolean']['input']>;
  readonly limit?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly priority_idx?: InputMaybe<Scalars['String']['input']>;
  readonly row_id?: InputMaybe<Scalars['String']['input']>;
  readonly rule?: InputMaybe<Scalars['String']['input']>;
  readonly stop_if_true?: InputMaybe<Scalars['Boolean']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Conditional_Formatting_Rules_Max_Fields = {
  readonly __typename?: 'conditional_formatting_rules_max_fields';
  readonly _id?: Maybe<Scalars['String']['output']>;
  readonly bg_color?: Maybe<Scalars['String']['output']>;
  readonly column_id?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly expired_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly limit?: Maybe<Scalars['String']['output']>;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly priority_idx?: Maybe<Scalars['String']['output']>;
  readonly row_id?: Maybe<Scalars['String']['output']>;
  readonly rule?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Max_Order_By = {
  readonly _id?: InputMaybe<Order_By>;
  readonly bg_color?: InputMaybe<Order_By>;
  readonly column_id?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly expired_at?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly limit?: InputMaybe<Order_By>;
  readonly note?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly priority_idx?: InputMaybe<Order_By>;
  readonly row_id?: InputMaybe<Order_By>;
  readonly rule?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Conditional_Formatting_Rules_Min_Fields = {
  readonly __typename?: 'conditional_formatting_rules_min_fields';
  readonly _id?: Maybe<Scalars['String']['output']>;
  readonly bg_color?: Maybe<Scalars['String']['output']>;
  readonly column_id?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly expired_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly limit?: Maybe<Scalars['String']['output']>;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly priority_idx?: Maybe<Scalars['String']['output']>;
  readonly row_id?: Maybe<Scalars['String']['output']>;
  readonly rule?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Min_Order_By = {
  readonly _id?: InputMaybe<Order_By>;
  readonly bg_color?: InputMaybe<Order_By>;
  readonly column_id?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly expired_at?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly limit?: InputMaybe<Order_By>;
  readonly note?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly priority_idx?: InputMaybe<Order_By>;
  readonly row_id?: InputMaybe<Order_By>;
  readonly rule?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Mutation_Response = {
  readonly __typename?: 'conditional_formatting_rules_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Conditional_Formatting_Rules>;
};

/** on_conflict condition type for table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_On_Conflict = {
  readonly constraint: Conditional_Formatting_Rules_Constraint;
  readonly update_columns?: ReadonlyArray<Conditional_Formatting_Rules_Update_Column>;
  readonly where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "conditional_formatting_rules". */
export type Conditional_Formatting_Rules_Order_By = {
  readonly Members?: InputMaybe<Page_Member_Order_By>;
  readonly Page?: InputMaybe<Pages_Order_By>;
  readonly _id?: InputMaybe<Order_By>;
  readonly bg_color?: InputMaybe<Order_By>;
  readonly bold_text?: InputMaybe<Order_By>;
  readonly column_id?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly expired_at?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly invert_text_color?: InputMaybe<Order_By>;
  readonly limit?: InputMaybe<Order_By>;
  readonly note?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly priority_idx?: InputMaybe<Order_By>;
  readonly row_id?: InputMaybe<Order_By>;
  readonly rule?: InputMaybe<Order_By>;
  readonly stop_if_true?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: conditional_formatting_rules */
export type Conditional_Formatting_Rules_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Select_Column =
  /** column name */
  | '_id'
  /** column name */
  | 'bg_color'
  /** column name */
  | 'bold_text'
  /** column name */
  | 'column_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'expired_at'
  /** column name */
  | 'id'
  /** column name */
  | 'invert_text_color'
  /** column name */
  | 'limit'
  /** column name */
  | 'note'
  /** column name */
  | 'page_id'
  /** column name */
  | 'priority_idx'
  /** column name */
  | 'row_id'
  /** column name */
  | 'rule'
  /** column name */
  | 'stop_if_true'
  /** column name */
  | 'user_id';

/** select "conditional_formatting_rules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Select_Column_Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'bold_text'
  /** column name */
  | 'invert_text_color'
  /** column name */
  | 'stop_if_true';

/** select "conditional_formatting_rules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Select_Column_Conditional_Formatting_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'bold_text'
  /** column name */
  | 'invert_text_color'
  /** column name */
  | 'stop_if_true';

/** input type for updating data in table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Set_Input = {
  readonly _id?: InputMaybe<Scalars['String']['input']>;
  readonly bg_color?: InputMaybe<Scalars['String']['input']>;
  readonly bold_text?: InputMaybe<Scalars['Boolean']['input']>;
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly invert_text_color?: InputMaybe<Scalars['Boolean']['input']>;
  readonly limit?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly priority_idx?: InputMaybe<Scalars['String']['input']>;
  readonly row_id?: InputMaybe<Scalars['String']['input']>;
  readonly rule?: InputMaybe<Scalars['String']['input']>;
  readonly stop_if_true?: InputMaybe<Scalars['Boolean']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Conditional_Formatting_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Conditional_Formatting_Rules_Stream_Cursor_Value_Input = {
  readonly _id?: InputMaybe<Scalars['String']['input']>;
  readonly bg_color?: InputMaybe<Scalars['String']['input']>;
  readonly bold_text?: InputMaybe<Scalars['Boolean']['input']>;
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly expired_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly invert_text_color?: InputMaybe<Scalars['Boolean']['input']>;
  readonly limit?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly priority_idx?: InputMaybe<Scalars['String']['input']>;
  readonly row_id?: InputMaybe<Scalars['String']['input']>;
  readonly rule?: InputMaybe<Scalars['String']['input']>;
  readonly stop_if_true?: InputMaybe<Scalars['Boolean']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "conditional_formatting_rules" */
export type Conditional_Formatting_Rules_Update_Column =
  /** column name */
  | '_id'
  /** column name */
  | 'bg_color'
  /** column name */
  | 'bold_text'
  /** column name */
  | 'column_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'expired_at'
  /** column name */
  | 'id'
  /** column name */
  | 'invert_text_color'
  /** column name */
  | 'limit'
  /** column name */
  | 'note'
  /** column name */
  | 'page_id'
  /** column name */
  | 'priority_idx'
  /** column name */
  | 'row_id'
  /** column name */
  | 'rule'
  /** column name */
  | 'stop_if_true'
  /** column name */
  | 'user_id';

export type Conditional_Formatting_Rules_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Conditional_Formatting_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Conditional_Formatting_Rules_Bool_Exp;
};

/** ordering argument of a cursor */
export type Cursor_Ordering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC';

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['date']['input']>;
  readonly _gt?: InputMaybe<Scalars['date']['input']>;
  readonly _gte?: InputMaybe<Scalars['date']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['date']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['date']['input']>;
  readonly _lte?: InputMaybe<Scalars['date']['input']>;
  readonly _neq?: InputMaybe<Scalars['date']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['date']['input']>>;
};

/** columns and relationships of "eod" */
export type Eod = {
  readonly __typename?: 'eod';
  readonly id: Scalars['Int']['output'];
  readonly source: Scalars['Int']['output'];
  /** An object relationship */
  readonly sourceBySource: Source;
};

/** aggregated selection of "eod" */
export type Eod_Aggregate = {
  readonly __typename?: 'eod_aggregate';
  readonly aggregate?: Maybe<Eod_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Eod>;
};

export type Eod_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Eod_Aggregate_Bool_Exp_Count>;
};

export type Eod_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Eod_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eod" */
export type Eod_Aggregate_Fields = {
  readonly __typename?: 'eod_aggregate_fields';
  readonly avg?: Maybe<Eod_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Eod_Max_Fields>;
  readonly min?: Maybe<Eod_Min_Fields>;
  readonly stddev?: Maybe<Eod_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Eod_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Eod_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Eod_Sum_Fields>;
  readonly var_pop?: Maybe<Eod_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Eod_Var_Samp_Fields>;
  readonly variance?: Maybe<Eod_Variance_Fields>;
};


/** aggregate fields of "eod" */
export type Eod_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eod" */
export type Eod_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Eod_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Eod_Max_Order_By>;
  readonly min?: InputMaybe<Eod_Min_Order_By>;
  readonly stddev?: InputMaybe<Eod_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Eod_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Eod_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Eod_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Eod_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Eod_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Eod_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eod" */
export type Eod_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Eod_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Eod_On_Conflict>;
};

/** aggregate avg on columns */
export type Eod_Avg_Fields = {
  readonly __typename?: 'eod_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eod" */
export type Eod_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eod". All fields are combined with a logical 'AND'. */
export type Eod_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Eod_Bool_Exp>>;
  readonly _not?: InputMaybe<Eod_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Eod_Bool_Exp>>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
  readonly sourceBySource?: InputMaybe<Source_Bool_Exp>;
};

/** unique or primary key constraints on table "eod" */
export type Eod_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'eod_pkey'
  /** unique or primary key constraint on columns "source" */
  | 'eod_source_key';

/** columns and relationships of "eod_entry" */
export type Eod_Entry = {
  readonly __typename?: 'eod_entry';
  readonly evaluation_date: Scalars['date']['output'];
  readonly id: Scalars['bigint']['output'];
  readonly month: Scalars['date']['output'];
  readonly ppend?: Maybe<Scalars['date']['output']>;
  readonly ppstart?: Maybe<Scalars['date']['output']>;
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByProduct: Product;
  readonly relative_period?: Maybe<Scalars['Int']['output']>;
  readonly value: Scalars['numeric']['output'];
};

/** aggregated selection of "eod_entry" */
export type Eod_Entry_Aggregate = {
  readonly __typename?: 'eod_entry_aggregate';
  readonly aggregate?: Maybe<Eod_Entry_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Eod_Entry>;
};

export type Eod_Entry_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Eod_Entry_Aggregate_Bool_Exp_Count>;
};

export type Eod_Entry_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Eod_Entry_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eod_entry" */
export type Eod_Entry_Aggregate_Fields = {
  readonly __typename?: 'eod_entry_aggregate_fields';
  readonly avg?: Maybe<Eod_Entry_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Eod_Entry_Max_Fields>;
  readonly min?: Maybe<Eod_Entry_Min_Fields>;
  readonly stddev?: Maybe<Eod_Entry_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Eod_Entry_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Eod_Entry_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Eod_Entry_Sum_Fields>;
  readonly var_pop?: Maybe<Eod_Entry_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Eod_Entry_Var_Samp_Fields>;
  readonly variance?: Maybe<Eod_Entry_Variance_Fields>;
};


/** aggregate fields of "eod_entry" */
export type Eod_Entry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eod_entry" */
export type Eod_Entry_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Eod_Entry_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Eod_Entry_Max_Order_By>;
  readonly min?: InputMaybe<Eod_Entry_Min_Order_By>;
  readonly stddev?: InputMaybe<Eod_Entry_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Eod_Entry_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Eod_Entry_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Eod_Entry_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Eod_Entry_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Eod_Entry_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Eod_Entry_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eod_entry" */
export type Eod_Entry_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Eod_Entry_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Eod_Entry_On_Conflict>;
};

/** aggregate avg on columns */
export type Eod_Entry_Avg_Fields = {
  readonly __typename?: 'eod_entry_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eod_entry" */
export type Eod_Entry_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eod_entry". All fields are combined with a logical 'AND'. */
export type Eod_Entry_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Eod_Entry_Bool_Exp>>;
  readonly _not?: InputMaybe<Eod_Entry_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Eod_Entry_Bool_Exp>>;
  readonly evaluation_date?: InputMaybe<Date_Comparison_Exp>;
  readonly id?: InputMaybe<Bigint_Comparison_Exp>;
  readonly month?: InputMaybe<Date_Comparison_Exp>;
  readonly ppend?: InputMaybe<Date_Comparison_Exp>;
  readonly ppstart?: InputMaybe<Date_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
  readonly relative_period?: InputMaybe<Int_Comparison_Exp>;
  readonly value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "eod_entry" */
export type Eod_Entry_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'eod_entry_id_key'
  /** unique or primary key constraint on columns "product", "evaluation_date", "month" */
  | 'eod_entry_pkey';

/** input type for incrementing numeric columns in table "eod_entry" */
export type Eod_Entry_Inc_Input = {
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly relative_period?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "eod_entry" */
export type Eod_Entry_Insert_Input = {
  readonly evaluation_date?: InputMaybe<Scalars['date']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly ppend?: InputMaybe<Scalars['date']['input']>;
  readonly ppstart?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly relative_period?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Eod_Entry_Max_Fields = {
  readonly __typename?: 'eod_entry_max_fields';
  readonly evaluation_date?: Maybe<Scalars['date']['output']>;
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly ppend?: Maybe<Scalars['date']['output']>;
  readonly ppstart?: Maybe<Scalars['date']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly relative_period?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "eod_entry" */
export type Eod_Entry_Max_Order_By = {
  readonly evaluation_date?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly ppend?: InputMaybe<Order_By>;
  readonly ppstart?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eod_Entry_Min_Fields = {
  readonly __typename?: 'eod_entry_min_fields';
  readonly evaluation_date?: Maybe<Scalars['date']['output']>;
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly ppend?: Maybe<Scalars['date']['output']>;
  readonly ppstart?: Maybe<Scalars['date']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly relative_period?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "eod_entry" */
export type Eod_Entry_Min_Order_By = {
  readonly evaluation_date?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly ppend?: InputMaybe<Order_By>;
  readonly ppstart?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eod_entry" */
export type Eod_Entry_Mutation_Response = {
  readonly __typename?: 'eod_entry_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Eod_Entry>;
};

/** on_conflict condition type for table "eod_entry" */
export type Eod_Entry_On_Conflict = {
  readonly constraint: Eod_Entry_Constraint;
  readonly update_columns?: ReadonlyArray<Eod_Entry_Update_Column>;
  readonly where?: InputMaybe<Eod_Entry_Bool_Exp>;
};

/** Ordering options when selecting data from "eod_entry". */
export type Eod_Entry_Order_By = {
  readonly evaluation_date?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly ppend?: InputMaybe<Order_By>;
  readonly ppstart?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eod_entry */
export type Eod_Entry_Pk_Columns_Input = {
  readonly evaluation_date: Scalars['date']['input'];
  readonly month: Scalars['date']['input'];
  readonly product: Scalars['uuid']['input'];
};

/** select columns of table "eod_entry" */
export type Eod_Entry_Select_Column =
  /** column name */
  | 'evaluation_date'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'ppend'
  /** column name */
  | 'ppstart'
  /** column name */
  | 'product'
  /** column name */
  | 'relative_period'
  /** column name */
  | 'value';

/** input type for updating data in table "eod_entry" */
export type Eod_Entry_Set_Input = {
  readonly evaluation_date?: InputMaybe<Scalars['date']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly ppend?: InputMaybe<Scalars['date']['input']>;
  readonly ppstart?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_period?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Eod_Entry_Stddev_Fields = {
  readonly __typename?: 'eod_entry_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eod_entry" */
export type Eod_Entry_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eod_Entry_Stddev_Pop_Fields = {
  readonly __typename?: 'eod_entry_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eod_entry" */
export type Eod_Entry_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eod_Entry_Stddev_Samp_Fields = {
  readonly __typename?: 'eod_entry_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eod_entry" */
export type Eod_Entry_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eod_entry" */
export type Eod_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Eod_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eod_Entry_Stream_Cursor_Value_Input = {
  readonly evaluation_date?: InputMaybe<Scalars['date']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly ppend?: InputMaybe<Scalars['date']['input']>;
  readonly ppstart?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_period?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Eod_Entry_Sum_Fields = {
  readonly __typename?: 'eod_entry_sum_fields';
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly relative_period?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "eod_entry" */
export type Eod_Entry_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** update columns of table "eod_entry" */
export type Eod_Entry_Update_Column =
  /** column name */
  | 'evaluation_date'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'ppend'
  /** column name */
  | 'ppstart'
  /** column name */
  | 'product'
  /** column name */
  | 'relative_period'
  /** column name */
  | 'value';

export type Eod_Entry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Eod_Entry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Eod_Entry_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Eod_Entry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eod_Entry_Var_Pop_Fields = {
  readonly __typename?: 'eod_entry_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eod_entry" */
export type Eod_Entry_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eod_Entry_Var_Samp_Fields = {
  readonly __typename?: 'eod_entry_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eod_entry" */
export type Eod_Entry_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eod_Entry_Variance_Fields = {
  readonly __typename?: 'eod_entry_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_period?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eod_entry" */
export type Eod_Entry_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_period?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "eod" */
export type Eod_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eod" */
export type Eod_Insert_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
  readonly sourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eod_Max_Fields = {
  readonly __typename?: 'eod_max_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "eod" */
export type Eod_Max_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eod_Min_Fields = {
  readonly __typename?: 'eod_min_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "eod" */
export type Eod_Min_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eod" */
export type Eod_Mutation_Response = {
  readonly __typename?: 'eod_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Eod>;
};

/** input type for inserting object relation for remote table "eod" */
export type Eod_Obj_Rel_Insert_Input = {
  readonly data: Eod_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Eod_On_Conflict>;
};

/** on_conflict condition type for table "eod" */
export type Eod_On_Conflict = {
  readonly constraint: Eod_Constraint;
  readonly update_columns?: ReadonlyArray<Eod_Update_Column>;
  readonly where?: InputMaybe<Eod_Bool_Exp>;
};

/** Ordering options when selecting data from "eod". */
export type Eod_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly sourceBySource?: InputMaybe<Source_Order_By>;
};

/** primary key columns input for table: eod */
export type Eod_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "eod" */
export type Eod_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'source';

/** input type for updating data in table "eod" */
export type Eod_Set_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Eod_Stddev_Fields = {
  readonly __typename?: 'eod_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eod" */
export type Eod_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eod_Stddev_Pop_Fields = {
  readonly __typename?: 'eod_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eod" */
export type Eod_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eod_Stddev_Samp_Fields = {
  readonly __typename?: 'eod_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eod" */
export type Eod_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eod" */
export type Eod_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Eod_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eod_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Eod_Sum_Fields = {
  readonly __typename?: 'eod_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eod" */
export type Eod_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** update columns of table "eod" */
export type Eod_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'source';

export type Eod_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Eod_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Eod_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Eod_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eod_Var_Pop_Fields = {
  readonly __typename?: 'eod_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eod" */
export type Eod_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eod_Var_Samp_Fields = {
  readonly __typename?: 'eod_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eod" */
export type Eod_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eod_Variance_Fields = {
  readonly __typename?: 'eod_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eod" */
export type Eod_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** columns and relationships of "exchange" */
export type Exchange = {
  readonly __typename?: 'exchange';
  readonly code: Scalars['Int']['output'];
  readonly future_code_gen_template: Scalars['String']['output'];
  readonly future_code_parse_template: Scalars['String']['output'];
  readonly future_time_spread_gen_template: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly source: Scalars['Int']['output'];
  /** An object relationship */
  readonly sourceBySource: Source;
};

/** aggregated selection of "exchange" */
export type Exchange_Aggregate = {
  readonly __typename?: 'exchange_aggregate';
  readonly aggregate?: Maybe<Exchange_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Exchange>;
};

export type Exchange_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Exchange_Aggregate_Bool_Exp_Count>;
};

export type Exchange_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Exchange_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "exchange" */
export type Exchange_Aggregate_Fields = {
  readonly __typename?: 'exchange_aggregate_fields';
  readonly avg?: Maybe<Exchange_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Exchange_Max_Fields>;
  readonly min?: Maybe<Exchange_Min_Fields>;
  readonly stddev?: Maybe<Exchange_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Exchange_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Exchange_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Exchange_Sum_Fields>;
  readonly var_pop?: Maybe<Exchange_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Exchange_Var_Samp_Fields>;
  readonly variance?: Maybe<Exchange_Variance_Fields>;
};


/** aggregate fields of "exchange" */
export type Exchange_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "exchange" */
export type Exchange_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Exchange_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Exchange_Max_Order_By>;
  readonly min?: InputMaybe<Exchange_Min_Order_By>;
  readonly stddev?: InputMaybe<Exchange_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Exchange_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Exchange_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Exchange_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Exchange_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Exchange_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Exchange_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exchange" */
export type Exchange_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Exchange_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Exchange_On_Conflict>;
};

/** aggregate avg on columns */
export type Exchange_Avg_Fields = {
  readonly __typename?: 'exchange_avg_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "exchange" */
export type Exchange_Avg_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "exchange". All fields are combined with a logical 'AND'. */
export type Exchange_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Exchange_Bool_Exp>>;
  readonly _not?: InputMaybe<Exchange_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Exchange_Bool_Exp>>;
  readonly code?: InputMaybe<Int_Comparison_Exp>;
  readonly future_code_gen_template?: InputMaybe<String_Comparison_Exp>;
  readonly future_code_parse_template?: InputMaybe<String_Comparison_Exp>;
  readonly future_time_spread_gen_template?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
  readonly sourceBySource?: InputMaybe<Source_Bool_Exp>;
};

/** unique or primary key constraints on table "exchange" */
export type Exchange_Constraint =
  /** unique or primary key constraint on columns "code" */
  | 'exchange_code_key'
  /** unique or primary key constraint on columns "id" */
  | 'exchange_pkey'
  /** unique or primary key constraint on columns "source" */
  | 'exchange_source_key';

/** columns and relationships of "exchange_event_type" */
export type Exchange_Event_Type = {
  readonly __typename?: 'exchange_event_type';
  /** An array relationship */
  readonly exchange_usages: ReadonlyArray<Exchange_Usage>;
  /** An aggregate relationship */
  readonly exchange_usages_aggregate: Exchange_Usage_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "exchange_event_type" */
export type Exchange_Event_TypeExchange_UsagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


/** columns and relationships of "exchange_event_type" */
export type Exchange_Event_TypeExchange_Usages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};

/** aggregated selection of "exchange_event_type" */
export type Exchange_Event_Type_Aggregate = {
  readonly __typename?: 'exchange_event_type_aggregate';
  readonly aggregate?: Maybe<Exchange_Event_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Exchange_Event_Type>;
};

/** aggregate fields of "exchange_event_type" */
export type Exchange_Event_Type_Aggregate_Fields = {
  readonly __typename?: 'exchange_event_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Exchange_Event_Type_Max_Fields>;
  readonly min?: Maybe<Exchange_Event_Type_Min_Fields>;
};


/** aggregate fields of "exchange_event_type" */
export type Exchange_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "exchange_event_type". All fields are combined with a logical 'AND'. */
export type Exchange_Event_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Bool_Exp>>;
  readonly exchange_usages?: InputMaybe<Exchange_Usage_Bool_Exp>;
  readonly exchange_usages_aggregate?: InputMaybe<Exchange_Usage_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exchange_event_type" */
export type Exchange_Event_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'exchange_event_type_pkey';

/** input type for inserting data into table "exchange_event_type" */
export type Exchange_Event_Type_Insert_Input = {
  readonly exchange_usages?: InputMaybe<Exchange_Usage_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Exchange_Event_Type_Max_Fields = {
  readonly __typename?: 'exchange_event_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Exchange_Event_Type_Min_Fields = {
  readonly __typename?: 'exchange_event_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "exchange_event_type" */
export type Exchange_Event_Type_Mutation_Response = {
  readonly __typename?: 'exchange_event_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Exchange_Event_Type>;
};

/** input type for inserting object relation for remote table "exchange_event_type" */
export type Exchange_Event_Type_Obj_Rel_Insert_Input = {
  readonly data: Exchange_Event_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Exchange_Event_Type_On_Conflict>;
};

/** on_conflict condition type for table "exchange_event_type" */
export type Exchange_Event_Type_On_Conflict = {
  readonly constraint: Exchange_Event_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Exchange_Event_Type_Update_Column>;
  readonly where?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "exchange_event_type". */
export type Exchange_Event_Type_Order_By = {
  readonly exchange_usages_aggregate?: InputMaybe<Exchange_Usage_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exchange_event_type */
export type Exchange_Event_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "exchange_event_type" */
export type Exchange_Event_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "exchange_event_type" */
export type Exchange_Event_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "exchange_event_type" */
export type Exchange_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Exchange_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Event_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "exchange_event_type" */
export type Exchange_Event_Type_Update_Column =
  /** column name */
  | 'value';

export type Exchange_Event_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Exchange_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Exchange_Event_Type_Bool_Exp;
};

/** input type for incrementing numeric columns in table "exchange" */
export type Exchange_Inc_Input = {
  readonly code?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "exchange" */
export type Exchange_Insert_Input = {
  readonly code?: InputMaybe<Scalars['Int']['input']>;
  readonly future_code_gen_template?: InputMaybe<Scalars['String']['input']>;
  readonly future_code_parse_template?: InputMaybe<Scalars['String']['input']>;
  readonly future_time_spread_gen_template?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
  readonly sourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Exchange_Max_Fields = {
  readonly __typename?: 'exchange_max_fields';
  readonly code?: Maybe<Scalars['Int']['output']>;
  readonly future_code_gen_template?: Maybe<Scalars['String']['output']>;
  readonly future_code_parse_template?: Maybe<Scalars['String']['output']>;
  readonly future_time_spread_gen_template?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "exchange" */
export type Exchange_Max_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly future_code_gen_template?: InputMaybe<Order_By>;
  readonly future_code_parse_template?: InputMaybe<Order_By>;
  readonly future_time_spread_gen_template?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exchange_Min_Fields = {
  readonly __typename?: 'exchange_min_fields';
  readonly code?: Maybe<Scalars['Int']['output']>;
  readonly future_code_gen_template?: Maybe<Scalars['String']['output']>;
  readonly future_code_parse_template?: Maybe<Scalars['String']['output']>;
  readonly future_time_spread_gen_template?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "exchange" */
export type Exchange_Min_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly future_code_gen_template?: InputMaybe<Order_By>;
  readonly future_code_parse_template?: InputMaybe<Order_By>;
  readonly future_time_spread_gen_template?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exchange" */
export type Exchange_Mutation_Response = {
  readonly __typename?: 'exchange_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Exchange>;
};

/** input type for inserting object relation for remote table "exchange" */
export type Exchange_Obj_Rel_Insert_Input = {
  readonly data: Exchange_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Exchange_On_Conflict>;
};

/** on_conflict condition type for table "exchange" */
export type Exchange_On_Conflict = {
  readonly constraint: Exchange_Constraint;
  readonly update_columns?: ReadonlyArray<Exchange_Update_Column>;
  readonly where?: InputMaybe<Exchange_Bool_Exp>;
};

/** Ordering options when selecting data from "exchange". */
export type Exchange_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly future_code_gen_template?: InputMaybe<Order_By>;
  readonly future_code_parse_template?: InputMaybe<Order_By>;
  readonly future_time_spread_gen_template?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly sourceBySource?: InputMaybe<Source_Order_By>;
};

/** primary key columns input for table: exchange */
export type Exchange_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "exchange" */
export type Exchange_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'future_code_gen_template'
  /** column name */
  | 'future_code_parse_template'
  /** column name */
  | 'future_time_spread_gen_template'
  /** column name */
  | 'id'
  /** column name */
  | 'source';

/** input type for updating data in table "exchange" */
export type Exchange_Set_Input = {
  readonly code?: InputMaybe<Scalars['Int']['input']>;
  readonly future_code_gen_template?: InputMaybe<Scalars['String']['input']>;
  readonly future_code_parse_template?: InputMaybe<Scalars['String']['input']>;
  readonly future_time_spread_gen_template?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Exchange_Stddev_Fields = {
  readonly __typename?: 'exchange_stddev_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "exchange" */
export type Exchange_Stddev_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Exchange_Stddev_Pop_Fields = {
  readonly __typename?: 'exchange_stddev_pop_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "exchange" */
export type Exchange_Stddev_Pop_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Exchange_Stddev_Samp_Fields = {
  readonly __typename?: 'exchange_stddev_samp_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "exchange" */
export type Exchange_Stddev_Samp_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "exchange" */
export type Exchange_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Exchange_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Stream_Cursor_Value_Input = {
  readonly code?: InputMaybe<Scalars['Int']['input']>;
  readonly future_code_gen_template?: InputMaybe<Scalars['String']['input']>;
  readonly future_code_parse_template?: InputMaybe<Scalars['String']['input']>;
  readonly future_time_spread_gen_template?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Exchange_Sum_Fields = {
  readonly __typename?: 'exchange_sum_fields';
  readonly code?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "exchange" */
export type Exchange_Sum_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** update columns of table "exchange" */
export type Exchange_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'future_code_gen_template'
  /** column name */
  | 'future_code_parse_template'
  /** column name */
  | 'future_time_spread_gen_template'
  /** column name */
  | 'id'
  /** column name */
  | 'source';

export type Exchange_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Exchange_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Exchange_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Exchange_Bool_Exp;
};

/** columns and relationships of "exchange_usage" */
export type Exchange_Usage = {
  readonly __typename?: 'exchange_usage';
  readonly event: Scalars['String']['output'];
  readonly event_date: Scalars['timestamptz']['output'];
  /** An object relationship */
  readonly exchangeBySource?: Maybe<Exchange>;
  /** An object relationship */
  readonly exchangeUsageByFolioUser?: Maybe<Folio_User>;
  /** An object relationship */
  readonly exchange_event_type: Exchange_Event_Type;
  readonly folio_user: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly source: Scalars['Int']['output'];
  /** An object relationship */
  readonly sourceBySource: Source;
};

/** aggregated selection of "exchange_usage" */
export type Exchange_Usage_Aggregate = {
  readonly __typename?: 'exchange_usage_aggregate';
  readonly aggregate?: Maybe<Exchange_Usage_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Exchange_Usage>;
};

export type Exchange_Usage_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Exchange_Usage_Aggregate_Bool_Exp_Count>;
};

export type Exchange_Usage_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Exchange_Usage_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "exchange_usage" */
export type Exchange_Usage_Aggregate_Fields = {
  readonly __typename?: 'exchange_usage_aggregate_fields';
  readonly avg?: Maybe<Exchange_Usage_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Exchange_Usage_Max_Fields>;
  readonly min?: Maybe<Exchange_Usage_Min_Fields>;
  readonly stddev?: Maybe<Exchange_Usage_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Exchange_Usage_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Exchange_Usage_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Exchange_Usage_Sum_Fields>;
  readonly var_pop?: Maybe<Exchange_Usage_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Exchange_Usage_Var_Samp_Fields>;
  readonly variance?: Maybe<Exchange_Usage_Variance_Fields>;
};


/** aggregate fields of "exchange_usage" */
export type Exchange_Usage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "exchange_usage" */
export type Exchange_Usage_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Exchange_Usage_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Exchange_Usage_Max_Order_By>;
  readonly min?: InputMaybe<Exchange_Usage_Min_Order_By>;
  readonly stddev?: InputMaybe<Exchange_Usage_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Exchange_Usage_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Exchange_Usage_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Exchange_Usage_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Exchange_Usage_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Exchange_Usage_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Exchange_Usage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exchange_usage" */
export type Exchange_Usage_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Exchange_Usage_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Exchange_Usage_On_Conflict>;
};

/** aggregate avg on columns */
export type Exchange_Usage_Avg_Fields = {
  readonly __typename?: 'exchange_usage_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "exchange_usage" */
export type Exchange_Usage_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "exchange_usage". All fields are combined with a logical 'AND'. */
export type Exchange_Usage_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Exchange_Usage_Bool_Exp>>;
  readonly _not?: InputMaybe<Exchange_Usage_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Exchange_Usage_Bool_Exp>>;
  readonly event?: InputMaybe<String_Comparison_Exp>;
  readonly event_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly exchangeBySource?: InputMaybe<Exchange_Bool_Exp>;
  readonly exchangeUsageByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly exchange_event_type?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
  readonly sourceBySource?: InputMaybe<Source_Bool_Exp>;
};

/** unique or primary key constraints on table "exchange_usage" */
export type Exchange_Usage_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'exchange_usage_pkey';

/** input type for incrementing numeric columns in table "exchange_usage" */
export type Exchange_Usage_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "exchange_usage" */
export type Exchange_Usage_Insert_Input = {
  readonly event?: InputMaybe<Scalars['String']['input']>;
  readonly event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly exchangeBySource?: InputMaybe<Exchange_Obj_Rel_Insert_Input>;
  readonly exchangeUsageByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly exchange_event_type?: InputMaybe<Exchange_Event_Type_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
  readonly sourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "exchange_usage_last" */
export type Exchange_Usage_Last = {
  readonly __typename?: 'exchange_usage_last';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "exchange_usage_last" */
export type Exchange_Usage_Last_Aggregate = {
  readonly __typename?: 'exchange_usage_last_aggregate';
  readonly aggregate?: Maybe<Exchange_Usage_Last_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Exchange_Usage_Last>;
};

/** aggregate fields of "exchange_usage_last" */
export type Exchange_Usage_Last_Aggregate_Fields = {
  readonly __typename?: 'exchange_usage_last_aggregate_fields';
  readonly avg?: Maybe<Exchange_Usage_Last_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Exchange_Usage_Last_Max_Fields>;
  readonly min?: Maybe<Exchange_Usage_Last_Min_Fields>;
  readonly stddev?: Maybe<Exchange_Usage_Last_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Exchange_Usage_Last_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Exchange_Usage_Last_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Exchange_Usage_Last_Sum_Fields>;
  readonly var_pop?: Maybe<Exchange_Usage_Last_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Exchange_Usage_Last_Var_Samp_Fields>;
  readonly variance?: Maybe<Exchange_Usage_Last_Variance_Fields>;
};


/** aggregate fields of "exchange_usage_last" */
export type Exchange_Usage_Last_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Exchange_Usage_Last_Avg_Fields = {
  readonly __typename?: 'exchange_usage_last_avg_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "exchange_usage_last". All fields are combined with a logical 'AND'. */
export type Exchange_Usage_Last_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Bool_Exp>>;
  readonly _not?: InputMaybe<Exchange_Usage_Last_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Bool_Exp>>;
  readonly event?: InputMaybe<String_Comparison_Exp>;
  readonly event_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Exchange_Usage_Last_Max_Fields = {
  readonly __typename?: 'exchange_usage_last_max_fields';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Exchange_Usage_Last_Min_Fields = {
  readonly __typename?: 'exchange_usage_last_min_fields';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "exchange_usage_last". */
export type Exchange_Usage_Last_Order_By = {
  readonly event?: InputMaybe<Order_By>;
  readonly event_date?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** select columns of table "exchange_usage_last" */
export type Exchange_Usage_Last_Select_Column =
  /** column name */
  | 'event'
  /** column name */
  | 'event_date'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'source';

/** aggregate stddev on columns */
export type Exchange_Usage_Last_Stddev_Fields = {
  readonly __typename?: 'exchange_usage_last_stddev_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Exchange_Usage_Last_Stddev_Pop_Fields = {
  readonly __typename?: 'exchange_usage_last_stddev_pop_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Exchange_Usage_Last_Stddev_Samp_Fields = {
  readonly __typename?: 'exchange_usage_last_stddev_samp_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "exchange_usage_last" */
export type Exchange_Usage_Last_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Exchange_Usage_Last_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Usage_Last_Stream_Cursor_Value_Input = {
  readonly event?: InputMaybe<Scalars['String']['input']>;
  readonly event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Exchange_Usage_Last_Sum_Fields = {
  readonly __typename?: 'exchange_usage_last_sum_fields';
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Exchange_Usage_Last_Var_Pop_Fields = {
  readonly __typename?: 'exchange_usage_last_var_pop_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Exchange_Usage_Last_Var_Samp_Fields = {
  readonly __typename?: 'exchange_usage_last_var_samp_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Exchange_Usage_Last_Variance_Fields = {
  readonly __typename?: 'exchange_usage_last_variance_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Exchange_Usage_Max_Fields = {
  readonly __typename?: 'exchange_usage_max_fields';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "exchange_usage" */
export type Exchange_Usage_Max_Order_By = {
  readonly event?: InputMaybe<Order_By>;
  readonly event_date?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exchange_Usage_Min_Fields = {
  readonly __typename?: 'exchange_usage_min_fields';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "exchange_usage" */
export type Exchange_Usage_Min_Order_By = {
  readonly event?: InputMaybe<Order_By>;
  readonly event_date?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exchange_usage" */
export type Exchange_Usage_Mutation_Response = {
  readonly __typename?: 'exchange_usage_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Exchange_Usage>;
};

/** on_conflict condition type for table "exchange_usage" */
export type Exchange_Usage_On_Conflict = {
  readonly constraint: Exchange_Usage_Constraint;
  readonly update_columns?: ReadonlyArray<Exchange_Usage_Update_Column>;
  readonly where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};

/** Ordering options when selecting data from "exchange_usage". */
export type Exchange_Usage_Order_By = {
  readonly event?: InputMaybe<Order_By>;
  readonly event_date?: InputMaybe<Order_By>;
  readonly exchangeBySource?: InputMaybe<Exchange_Order_By>;
  readonly exchangeUsageByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly exchange_event_type?: InputMaybe<Exchange_Event_Type_Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly sourceBySource?: InputMaybe<Source_Order_By>;
};

/** primary key columns input for table: exchange_usage */
export type Exchange_Usage_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "exchange_usage" */
export type Exchange_Usage_Select_Column =
  /** column name */
  | 'event'
  /** column name */
  | 'event_date'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'source';

/** input type for updating data in table "exchange_usage" */
export type Exchange_Usage_Set_Input = {
  readonly event?: InputMaybe<Scalars['String']['input']>;
  readonly event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "exchange_usage_start" */
export type Exchange_Usage_Start = {
  readonly __typename?: 'exchange_usage_start';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "exchange_usage_start" */
export type Exchange_Usage_Start_Aggregate = {
  readonly __typename?: 'exchange_usage_start_aggregate';
  readonly aggregate?: Maybe<Exchange_Usage_Start_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Exchange_Usage_Start>;
};

/** aggregate fields of "exchange_usage_start" */
export type Exchange_Usage_Start_Aggregate_Fields = {
  readonly __typename?: 'exchange_usage_start_aggregate_fields';
  readonly avg?: Maybe<Exchange_Usage_Start_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Exchange_Usage_Start_Max_Fields>;
  readonly min?: Maybe<Exchange_Usage_Start_Min_Fields>;
  readonly stddev?: Maybe<Exchange_Usage_Start_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Exchange_Usage_Start_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Exchange_Usage_Start_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Exchange_Usage_Start_Sum_Fields>;
  readonly var_pop?: Maybe<Exchange_Usage_Start_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Exchange_Usage_Start_Var_Samp_Fields>;
  readonly variance?: Maybe<Exchange_Usage_Start_Variance_Fields>;
};


/** aggregate fields of "exchange_usage_start" */
export type Exchange_Usage_Start_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Exchange_Usage_Start_Avg_Fields = {
  readonly __typename?: 'exchange_usage_start_avg_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "exchange_usage_start". All fields are combined with a logical 'AND'. */
export type Exchange_Usage_Start_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Bool_Exp>>;
  readonly _not?: InputMaybe<Exchange_Usage_Start_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Bool_Exp>>;
  readonly event?: InputMaybe<String_Comparison_Exp>;
  readonly event_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Exchange_Usage_Start_Max_Fields = {
  readonly __typename?: 'exchange_usage_start_max_fields';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Exchange_Usage_Start_Min_Fields = {
  readonly __typename?: 'exchange_usage_start_min_fields';
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly event_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "exchange_usage_start". */
export type Exchange_Usage_Start_Order_By = {
  readonly event?: InputMaybe<Order_By>;
  readonly event_date?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** select columns of table "exchange_usage_start" */
export type Exchange_Usage_Start_Select_Column =
  /** column name */
  | 'event'
  /** column name */
  | 'event_date'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'source';

/** aggregate stddev on columns */
export type Exchange_Usage_Start_Stddev_Fields = {
  readonly __typename?: 'exchange_usage_start_stddev_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Exchange_Usage_Start_Stddev_Pop_Fields = {
  readonly __typename?: 'exchange_usage_start_stddev_pop_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Exchange_Usage_Start_Stddev_Samp_Fields = {
  readonly __typename?: 'exchange_usage_start_stddev_samp_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "exchange_usage_start" */
export type Exchange_Usage_Start_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Exchange_Usage_Start_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Usage_Start_Stream_Cursor_Value_Input = {
  readonly event?: InputMaybe<Scalars['String']['input']>;
  readonly event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Exchange_Usage_Start_Sum_Fields = {
  readonly __typename?: 'exchange_usage_start_sum_fields';
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Exchange_Usage_Start_Var_Pop_Fields = {
  readonly __typename?: 'exchange_usage_start_var_pop_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Exchange_Usage_Start_Var_Samp_Fields = {
  readonly __typename?: 'exchange_usage_start_var_samp_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Exchange_Usage_Start_Variance_Fields = {
  readonly __typename?: 'exchange_usage_start_variance_fields';
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev on columns */
export type Exchange_Usage_Stddev_Fields = {
  readonly __typename?: 'exchange_usage_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "exchange_usage" */
export type Exchange_Usage_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Exchange_Usage_Stddev_Pop_Fields = {
  readonly __typename?: 'exchange_usage_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "exchange_usage" */
export type Exchange_Usage_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Exchange_Usage_Stddev_Samp_Fields = {
  readonly __typename?: 'exchange_usage_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "exchange_usage" */
export type Exchange_Usage_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "exchange_usage" */
export type Exchange_Usage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Exchange_Usage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Usage_Stream_Cursor_Value_Input = {
  readonly event?: InputMaybe<Scalars['String']['input']>;
  readonly event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Exchange_Usage_Sum_Fields = {
  readonly __typename?: 'exchange_usage_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "exchange_usage" */
export type Exchange_Usage_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** update columns of table "exchange_usage" */
export type Exchange_Usage_Update_Column =
  /** column name */
  | 'event'
  /** column name */
  | 'event_date'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'source';

export type Exchange_Usage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Exchange_Usage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Exchange_Usage_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Exchange_Usage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Exchange_Usage_Var_Pop_Fields = {
  readonly __typename?: 'exchange_usage_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "exchange_usage" */
export type Exchange_Usage_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Exchange_Usage_Var_Samp_Fields = {
  readonly __typename?: 'exchange_usage_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "exchange_usage" */
export type Exchange_Usage_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Exchange_Usage_Variance_Fields = {
  readonly __typename?: 'exchange_usage_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "exchange_usage" */
export type Exchange_Usage_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Exchange_Var_Pop_Fields = {
  readonly __typename?: 'exchange_var_pop_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "exchange" */
export type Exchange_Var_Pop_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Exchange_Var_Samp_Fields = {
  readonly __typename?: 'exchange_var_samp_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "exchange" */
export type Exchange_Var_Samp_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Exchange_Variance_Fields = {
  readonly __typename?: 'exchange_variance_fields';
  readonly code?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "exchange" */
export type Exchange_Variance_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** columns and relationships of "feature_flags" */
export type Feature_Flags = {
  readonly __typename?: 'feature_flags';
  readonly created_at: Scalars['timestamptz']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['uuid']['output'];
  readonly metadata?: Maybe<Scalars['jsonb']['output']>;
  readonly name: Scalars['String']['output'];
  readonly org_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly updated_at: Scalars['timestamptz']['output'];
  readonly user_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};


/** columns and relationships of "feature_flags" */
export type Feature_FlagsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "feature_flags" */
export type Feature_Flags_Aggregate = {
  readonly __typename?: 'feature_flags_aggregate';
  readonly aggregate?: Maybe<Feature_Flags_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Feature_Flags>;
};

/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_Fields = {
  readonly __typename?: 'feature_flags_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Feature_Flags_Max_Fields>;
  readonly min?: Maybe<Feature_Flags_Min_Fields>;
};


/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Feature_Flags_Append_Input = {
  readonly metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "feature_flags". All fields are combined with a logical 'AND'. */
export type Feature_Flags_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Feature_Flags_Bool_Exp>>;
  readonly _not?: InputMaybe<Feature_Flags_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Feature_Flags_Bool_Exp>>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly enabled?: InputMaybe<Boolean_Comparison_Exp>;
  readonly id?: InputMaybe<Uuid_Comparison_Exp>;
  readonly metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly org_ids?: InputMaybe<String_Array_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_ids?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_flags" */
export type Feature_Flags_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'feature_flags_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Feature_Flags_Delete_At_Path_Input = {
  readonly metadata?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Feature_Flags_Delete_Elem_Input = {
  readonly metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Feature_Flags_Delete_Key_Input = {
  readonly metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "feature_flags" */
export type Feature_Flags_Insert_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly metadata?: InputMaybe<Scalars['jsonb']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly org_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Feature_Flags_Max_Fields = {
  readonly __typename?: 'feature_flags_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly org_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** aggregate min on columns */
export type Feature_Flags_Min_Fields = {
  readonly __typename?: 'feature_flags_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly org_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** response of any mutation on the table "feature_flags" */
export type Feature_Flags_Mutation_Response = {
  readonly __typename?: 'feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Feature_Flags>;
};

/** on_conflict condition type for table "feature_flags" */
export type Feature_Flags_On_Conflict = {
  readonly constraint: Feature_Flags_Constraint;
  readonly update_columns?: ReadonlyArray<Feature_Flags_Update_Column>;
  readonly where?: InputMaybe<Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_flags". */
export type Feature_Flags_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly enabled?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly metadata?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly org_ids?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_ids?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_flags */
export type Feature_Flags_Pk_Columns_Input = {
  readonly id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Feature_Flags_Prepend_Input = {
  readonly metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "feature_flags" */
export type Feature_Flags_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'enabled'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'org_ids'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_ids';

/** input type for updating data in table "feature_flags" */
export type Feature_Flags_Set_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly metadata?: InputMaybe<Scalars['jsonb']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly org_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Streaming cursor of the table "feature_flags" */
export type Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flags_Stream_Cursor_Value_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly metadata?: InputMaybe<Scalars['jsonb']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly org_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** update columns of table "feature_flags" */
export type Feature_Flags_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'enabled'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'org_ids'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_ids';

export type Feature_Flags_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Feature_Flags_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Feature_Flags_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Feature_Flags_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Feature_Flags_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Feature_Flags_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Feature_Flags_Bool_Exp;
};

/** Stores state of 'shadow' curves like extra months and divider columns. Separated from page settings so it doesn't interfere with the api or openfin */
export type Folio_Shadow_Curves = {
  readonly __typename?: 'folio_shadow_curves';
  readonly folio_user: Scalars['String']['output'];
  readonly state: Scalars['jsonb']['output'];
};


/** Stores state of 'shadow' curves like extra months and divider columns. Separated from page settings so it doesn't interfere with the api or openfin */
export type Folio_Shadow_CurvesStateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "folio_shadow_curves" */
export type Folio_Shadow_Curves_Aggregate = {
  readonly __typename?: 'folio_shadow_curves_aggregate';
  readonly aggregate?: Maybe<Folio_Shadow_Curves_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Folio_Shadow_Curves>;
};

/** aggregate fields of "folio_shadow_curves" */
export type Folio_Shadow_Curves_Aggregate_Fields = {
  readonly __typename?: 'folio_shadow_curves_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Folio_Shadow_Curves_Max_Fields>;
  readonly min?: Maybe<Folio_Shadow_Curves_Min_Fields>;
};


/** aggregate fields of "folio_shadow_curves" */
export type Folio_Shadow_Curves_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Folio_Shadow_Curves_Append_Input = {
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "folio_shadow_curves". All fields are combined with a logical 'AND'. */
export type Folio_Shadow_Curves_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Bool_Exp>>;
  readonly _not?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Bool_Exp>>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly state?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Constraint =
  /** unique or primary key constraint on columns "folio_user" */
  | 'folio_shadow_curves_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Folio_Shadow_Curves_Delete_At_Path_Input = {
  readonly state?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Folio_Shadow_Curves_Delete_Elem_Input = {
  readonly state?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Folio_Shadow_Curves_Delete_Key_Input = {
  readonly state?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Insert_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Folio_Shadow_Curves_Max_Fields = {
  readonly __typename?: 'folio_shadow_curves_max_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Folio_Shadow_Curves_Min_Fields = {
  readonly __typename?: 'folio_shadow_curves_min_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Mutation_Response = {
  readonly __typename?: 'folio_shadow_curves_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Folio_Shadow_Curves>;
};

/** on_conflict condition type for table "folio_shadow_curves" */
export type Folio_Shadow_Curves_On_Conflict = {
  readonly constraint: Folio_Shadow_Curves_Constraint;
  readonly update_columns?: ReadonlyArray<Folio_Shadow_Curves_Update_Column>;
  readonly where?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
};

/** Ordering options when selecting data from "folio_shadow_curves". */
export type Folio_Shadow_Curves_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folio_shadow_curves */
export type Folio_Shadow_Curves_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Folio_Shadow_Curves_Prepend_Input = {
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Select_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'state';

/** input type for updating data in table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Set_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Folio_Shadow_Curves_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folio_Shadow_Curves_Stream_Cursor_Value_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "folio_shadow_curves" */
export type Folio_Shadow_Curves_Update_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'state';

export type Folio_Shadow_Curves_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Folio_Shadow_Curves_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Folio_Shadow_Curves_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Folio_Shadow_Curves_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Folio_Shadow_Curves_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Folio_Shadow_Curves_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Folio_Shadow_Curves_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Folio_Shadow_Curves_Bool_Exp;
};

/** columns and relationships of "folio_user" */
export type Folio_User = {
  readonly __typename?: 'folio_user';
  /** An array relationship */
  readonly alerts: ReadonlyArray<Alerts>;
  /** An aggregate relationship */
  readonly alerts_aggregate: Alerts_Aggregate;
  readonly blocked: Scalars['Boolean']['output'];
  /** An array relationship */
  readonly conditional_formatting_rules: ReadonlyArray<Conditional_Formatting_Rules>;
  /** An aggregate relationship */
  readonly conditional_formatting_rules_aggregate: Conditional_Formatting_Rules_Aggregate;
  readonly contract_end?: Maybe<Scalars['timestamptz']['output']>;
  readonly contract_start?: Maybe<Scalars['timestamptz']['output']>;
  readonly created: Scalars['timestamptz']['output'];
  readonly email: Scalars['citext']['output'];
  /** An object relationship */
  readonly entitlement?: Maybe<User_Entitlement_Active>;
  /** An array relationship */
  readonly exchange_usages: ReadonlyArray<Exchange_Usage>;
  /** An aggregate relationship */
  readonly exchange_usages_aggregate: Exchange_Usage_Aggregate;
  readonly firstname: Scalars['String']['output'];
  /** An array relationship */
  readonly global_permissions: ReadonlyArray<Global_Permission>;
  /** An aggregate relationship */
  readonly global_permissions_aggregate: Global_Permission_Aggregate;
  /** An object relationship */
  readonly hfc_card_setting?: Maybe<Hfc_Card_Settings>;
  /** An object relationship */
  readonly hfc_user_setting?: Maybe<Hfc_User_Settings>;
  readonly id: Scalars['String']['output'];
  readonly is_artis_lite: Scalars['Boolean']['output'];
  readonly last_login: Scalars['timestamptz']['output'];
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly lastname: Scalars['String']['output'];
  readonly licence_agreements: Scalars['jsonb']['output'];
  /** An array relationship */
  readonly local_instruments: ReadonlyArray<Local_Instrument>;
  /** An aggregate relationship */
  readonly local_instruments_aggregate: Local_Instrument_Aggregate;
  readonly login_count: Scalars['Int']['output'];
  readonly logout_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  readonly logout_requests: ReadonlyArray<Logout_Request>;
  /** An aggregate relationship */
  readonly logout_requests_aggregate: Logout_Request_Aggregate;
  readonly mfa_opted_out: Scalars['Boolean']['output'];
  readonly multisession_check_disabled?: Maybe<Scalars['Boolean']['output']>;
  readonly organisation: Scalars['Int']['output'];
  /** An object relationship */
  readonly organisationByOrganisation: Organisation;
  readonly package?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  readonly page_products: ReadonlyArray<Page_Products>;
  /** An aggregate relationship */
  readonly page_products_aggregate: Page_Products_Aggregate;
  /** An object relationship */
  readonly page_setting?: Maybe<Page_Settings>;
  /** An array relationship */
  readonly page_settings: ReadonlyArray<Page_Settings>;
  /** An aggregate relationship */
  readonly page_settings_aggregate: Page_Settings_Aggregate;
  readonly paid_user?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  readonly permissions: ReadonlyArray<Permission>;
  /** An aggregate relationship */
  readonly permissions_aggregate: Permission_Aggregate;
  readonly persona?: Maybe<Scalars['persona_enum']['output']>;
  readonly roles: Scalars['jsonb']['output'];
  /** An array relationship */
  readonly scratchpads: ReadonlyArray<Scratchpad>;
  /** An aggregate relationship */
  readonly scratchpads_aggregate: Scratchpad_Aggregate;
  /** An array relationship */
  readonly sessions: ReadonlyArray<Session>;
  /** An aggregate relationship */
  readonly sessions_aggregate: Session_Aggregate;
  /** An array relationship */
  readonly shared_instruments: ReadonlyArray<Shared_Instrument>;
  /** An aggregate relationship */
  readonly shared_instruments_aggregate: Shared_Instrument_Aggregate;
  /** An array relationship */
  readonly spreader_states: ReadonlyArray<Spreader_State>;
  /** An aggregate relationship */
  readonly spreader_states_aggregate: Spreader_State_Aggregate;
  readonly subscription_tier: Subscription_Tier_Enum;
  readonly trial_end?: Maybe<Scalars['timestamptz']['output']>;
  readonly trial_start?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  readonly user_subscription_tier?: Maybe<Subscription_Tier>;
  readonly username: Scalars['citext']['output'];
  /** An object relationship */
  readonly userpackageByUser?: Maybe<Package>;
  readonly webapp2?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserAlertsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserAlerts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserConditional_Formatting_RulesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Order_By>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserConditional_Formatting_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Order_By>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserExchange_UsagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserExchange_Usages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserGlobal_PermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserGlobal_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserLicence_AgreementsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserLocal_InstrumentsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserLocal_Instruments_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserLogout_RequestsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserLogout_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserPage_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Products_Order_By>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserPage_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Products_Order_By>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserPage_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Settings_Order_By>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserPage_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Settings_Order_By>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserPermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserRolesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserScratchpadsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Scratchpad_Order_By>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserScratchpads_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Scratchpad_Order_By>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserSessionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Order_By>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserSessions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Order_By>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserShared_InstrumentsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserShared_Instruments_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserSpreader_StatesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Spreader_State_Order_By>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};


/** columns and relationships of "folio_user" */
export type Folio_UserSpreader_States_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Spreader_State_Order_By>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};

/** aggregated selection of "folio_user" */
export type Folio_User_Aggregate = {
  readonly __typename?: 'folio_user_aggregate';
  readonly aggregate?: Maybe<Folio_User_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Folio_User>;
};

export type Folio_User_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Folio_User_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Folio_User_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Folio_User_Aggregate_Bool_Exp_Count>;
};

export type Folio_User_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Folio_User_Select_Column_Folio_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Folio_User_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Folio_User_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Folio_User_Select_Column_Folio_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Folio_User_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Folio_User_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Folio_User_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "folio_user" */
export type Folio_User_Aggregate_Fields = {
  readonly __typename?: 'folio_user_aggregate_fields';
  readonly avg?: Maybe<Folio_User_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Folio_User_Max_Fields>;
  readonly min?: Maybe<Folio_User_Min_Fields>;
  readonly stddev?: Maybe<Folio_User_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Folio_User_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Folio_User_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Folio_User_Sum_Fields>;
  readonly var_pop?: Maybe<Folio_User_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Folio_User_Var_Samp_Fields>;
  readonly variance?: Maybe<Folio_User_Variance_Fields>;
};


/** aggregate fields of "folio_user" */
export type Folio_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "folio_user" */
export type Folio_User_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Folio_User_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Folio_User_Max_Order_By>;
  readonly min?: InputMaybe<Folio_User_Min_Order_By>;
  readonly stddev?: InputMaybe<Folio_User_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Folio_User_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Folio_User_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Folio_User_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Folio_User_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Folio_User_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Folio_User_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Folio_User_Append_Input = {
  readonly licence_agreements?: InputMaybe<Scalars['jsonb']['input']>;
  readonly roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "folio_user" */
export type Folio_User_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Folio_User_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Folio_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Folio_User_Avg_Fields = {
  readonly __typename?: 'folio_user_avg_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "folio_user" */
export type Folio_User_Avg_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** columns and relationships of "folio_user_basic_profile" */
export type Folio_User_Basic_Profile = {
  readonly __typename?: 'folio_user_basic_profile';
  readonly blocked?: Maybe<Scalars['Boolean']['output']>;
  readonly firstname?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly is_staff?: Maybe<Scalars['Boolean']['output']>;
  readonly lastname?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly subscription_tier?: Maybe<Scalars['String']['output']>;
  readonly username?: Maybe<Scalars['citext']['output']>;
};

/** aggregated selection of "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Aggregate = {
  readonly __typename?: 'folio_user_basic_profile_aggregate';
  readonly aggregate?: Maybe<Folio_User_Basic_Profile_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Folio_User_Basic_Profile>;
};

/** aggregate fields of "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Aggregate_Fields = {
  readonly __typename?: 'folio_user_basic_profile_aggregate_fields';
  readonly avg?: Maybe<Folio_User_Basic_Profile_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Folio_User_Basic_Profile_Max_Fields>;
  readonly min?: Maybe<Folio_User_Basic_Profile_Min_Fields>;
  readonly stddev?: Maybe<Folio_User_Basic_Profile_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Folio_User_Basic_Profile_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Folio_User_Basic_Profile_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Folio_User_Basic_Profile_Sum_Fields>;
  readonly var_pop?: Maybe<Folio_User_Basic_Profile_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Folio_User_Basic_Profile_Var_Samp_Fields>;
  readonly variance?: Maybe<Folio_User_Basic_Profile_Variance_Fields>;
};


/** aggregate fields of "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Folio_User_Basic_Profile_Avg_Fields = {
  readonly __typename?: 'folio_user_basic_profile_avg_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "folio_user_basic_profile". All fields are combined with a logical 'AND'. */
export type Folio_User_Basic_Profile_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Bool_Exp>>;
  readonly _not?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Bool_Exp>>;
  readonly blocked?: InputMaybe<Boolean_Comparison_Exp>;
  readonly firstname?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  readonly lastname?: InputMaybe<String_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
  readonly subscription_tier?: InputMaybe<String_Comparison_Exp>;
  readonly username?: InputMaybe<Citext_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Inc_Input = {
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Insert_Input = {
  readonly blocked?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_staff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly subscription_tier?: InputMaybe<Scalars['String']['input']>;
  readonly username?: InputMaybe<Scalars['citext']['input']>;
};

/** aggregate max on columns */
export type Folio_User_Basic_Profile_Max_Fields = {
  readonly __typename?: 'folio_user_basic_profile_max_fields';
  readonly firstname?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastname?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly subscription_tier?: Maybe<Scalars['String']['output']>;
  readonly username?: Maybe<Scalars['citext']['output']>;
};

/** aggregate min on columns */
export type Folio_User_Basic_Profile_Min_Fields = {
  readonly __typename?: 'folio_user_basic_profile_min_fields';
  readonly firstname?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastname?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly subscription_tier?: Maybe<Scalars['String']['output']>;
  readonly username?: Maybe<Scalars['citext']['output']>;
};

/** response of any mutation on the table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Mutation_Response = {
  readonly __typename?: 'folio_user_basic_profile_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Folio_User_Basic_Profile>;
};

/** input type for inserting object relation for remote table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Obj_Rel_Insert_Input = {
  readonly data: Folio_User_Basic_Profile_Insert_Input;
};

/** Ordering options when selecting data from "folio_user_basic_profile". */
export type Folio_User_Basic_Profile_Order_By = {
  readonly blocked?: InputMaybe<Order_By>;
  readonly firstname?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_staff?: InputMaybe<Order_By>;
  readonly lastname?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly subscription_tier?: InputMaybe<Order_By>;
  readonly username?: InputMaybe<Order_By>;
};

/** select columns of table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Select_Column =
  /** column name */
  | 'blocked'
  /** column name */
  | 'firstname'
  /** column name */
  | 'id'
  /** column name */
  | 'is_staff'
  /** column name */
  | 'lastname'
  /** column name */
  | 'organisation'
  /** column name */
  | 'subscription_tier'
  /** column name */
  | 'username';

/** input type for updating data in table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Set_Input = {
  readonly blocked?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_staff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly subscription_tier?: InputMaybe<Scalars['String']['input']>;
  readonly username?: InputMaybe<Scalars['citext']['input']>;
};

/** aggregate stddev on columns */
export type Folio_User_Basic_Profile_Stddev_Fields = {
  readonly __typename?: 'folio_user_basic_profile_stddev_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Folio_User_Basic_Profile_Stddev_Pop_Fields = {
  readonly __typename?: 'folio_user_basic_profile_stddev_pop_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Folio_User_Basic_Profile_Stddev_Samp_Fields = {
  readonly __typename?: 'folio_user_basic_profile_stddev_samp_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "folio_user_basic_profile" */
export type Folio_User_Basic_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Folio_User_Basic_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folio_User_Basic_Profile_Stream_Cursor_Value_Input = {
  readonly blocked?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_staff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly subscription_tier?: InputMaybe<Scalars['String']['input']>;
  readonly username?: InputMaybe<Scalars['citext']['input']>;
};

/** aggregate sum on columns */
export type Folio_User_Basic_Profile_Sum_Fields = {
  readonly __typename?: 'folio_user_basic_profile_sum_fields';
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

export type Folio_User_Basic_Profile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Folio_User_Basic_Profile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Folio_User_Basic_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Folio_User_Basic_Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Folio_User_Basic_Profile_Var_Pop_Fields = {
  readonly __typename?: 'folio_user_basic_profile_var_pop_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Folio_User_Basic_Profile_Var_Samp_Fields = {
  readonly __typename?: 'folio_user_basic_profile_var_samp_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Folio_User_Basic_Profile_Variance_Fields = {
  readonly __typename?: 'folio_user_basic_profile_variance_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "folio_user". All fields are combined with a logical 'AND'. */
export type Folio_User_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Folio_User_Bool_Exp>>;
  readonly _not?: InputMaybe<Folio_User_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Folio_User_Bool_Exp>>;
  readonly alerts?: InputMaybe<Alerts_Bool_Exp>;
  readonly alerts_aggregate?: InputMaybe<Alerts_Aggregate_Bool_Exp>;
  readonly blocked?: InputMaybe<Boolean_Comparison_Exp>;
  readonly conditional_formatting_rules?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
  readonly conditional_formatting_rules_aggregate?: InputMaybe<Conditional_Formatting_Rules_Aggregate_Bool_Exp>;
  readonly contract_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly contract_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly created?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly email?: InputMaybe<Citext_Comparison_Exp>;
  readonly entitlement?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
  readonly exchange_usages?: InputMaybe<Exchange_Usage_Bool_Exp>;
  readonly exchange_usages_aggregate?: InputMaybe<Exchange_Usage_Aggregate_Bool_Exp>;
  readonly firstname?: InputMaybe<String_Comparison_Exp>;
  readonly global_permissions?: InputMaybe<Global_Permission_Bool_Exp>;
  readonly global_permissions_aggregate?: InputMaybe<Global_Permission_Aggregate_Bool_Exp>;
  readonly hfc_card_setting?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
  readonly hfc_user_setting?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly is_artis_lite?: InputMaybe<Boolean_Comparison_Exp>;
  readonly last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly lastname?: InputMaybe<String_Comparison_Exp>;
  readonly licence_agreements?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly local_instruments?: InputMaybe<Local_Instrument_Bool_Exp>;
  readonly local_instruments_aggregate?: InputMaybe<Local_Instrument_Aggregate_Bool_Exp>;
  readonly login_count?: InputMaybe<Int_Comparison_Exp>;
  readonly logout_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly logout_requests?: InputMaybe<Logout_Request_Bool_Exp>;
  readonly logout_requests_aggregate?: InputMaybe<Logout_Request_Aggregate_Bool_Exp>;
  readonly mfa_opted_out?: InputMaybe<Boolean_Comparison_Exp>;
  readonly multisession_check_disabled?: InputMaybe<Boolean_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Bool_Exp>;
  readonly package?: InputMaybe<Int_Comparison_Exp>;
  readonly page_products?: InputMaybe<Page_Products_Bool_Exp>;
  readonly page_products_aggregate?: InputMaybe<Page_Products_Aggregate_Bool_Exp>;
  readonly page_setting?: InputMaybe<Page_Settings_Bool_Exp>;
  readonly page_settings?: InputMaybe<Page_Settings_Bool_Exp>;
  readonly page_settings_aggregate?: InputMaybe<Page_Settings_Aggregate_Bool_Exp>;
  readonly paid_user?: InputMaybe<Boolean_Comparison_Exp>;
  readonly permissions?: InputMaybe<Permission_Bool_Exp>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Bool_Exp>;
  readonly persona?: InputMaybe<Persona_Enum_Comparison_Exp>;
  readonly roles?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly scratchpads?: InputMaybe<Scratchpad_Bool_Exp>;
  readonly scratchpads_aggregate?: InputMaybe<Scratchpad_Aggregate_Bool_Exp>;
  readonly sessions?: InputMaybe<Session_Bool_Exp>;
  readonly sessions_aggregate?: InputMaybe<Session_Aggregate_Bool_Exp>;
  readonly shared_instruments?: InputMaybe<Shared_Instrument_Bool_Exp>;
  readonly shared_instruments_aggregate?: InputMaybe<Shared_Instrument_Aggregate_Bool_Exp>;
  readonly spreader_states?: InputMaybe<Spreader_State_Bool_Exp>;
  readonly spreader_states_aggregate?: InputMaybe<Spreader_State_Aggregate_Bool_Exp>;
  readonly subscription_tier?: InputMaybe<Subscription_Tier_Enum_Comparison_Exp>;
  readonly trial_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly trial_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_subscription_tier?: InputMaybe<Subscription_Tier_Bool_Exp>;
  readonly username?: InputMaybe<Citext_Comparison_Exp>;
  readonly userpackageByUser?: InputMaybe<Package_Bool_Exp>;
  readonly webapp2?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "folio_user" */
export type Folio_User_Constraint =
  /** unique or primary key constraint on columns "email", "organisation" */
  | 'folio_user_email_organisation_key'
  /** unique or primary key constraint on columns "id" */
  | 'folio_user_pkey'
  /** unique or primary key constraint on columns "organisation", "username" */
  | 'folio_user_username_organisation_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Folio_User_Delete_At_Path_Input = {
  readonly licence_agreements?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly roles?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Folio_User_Delete_Elem_Input = {
  readonly licence_agreements?: InputMaybe<Scalars['Int']['input']>;
  readonly roles?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Folio_User_Delete_Key_Input = {
  readonly licence_agreements?: InputMaybe<Scalars['String']['input']>;
  readonly roles?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "folio_user" */
export type Folio_User_Inc_Input = {
  readonly login_count?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "folio_user" */
export type Folio_User_Insert_Input = {
  readonly alerts?: InputMaybe<Alerts_Arr_Rel_Insert_Input>;
  readonly blocked?: InputMaybe<Scalars['Boolean']['input']>;
  readonly conditional_formatting_rules?: InputMaybe<Conditional_Formatting_Rules_Arr_Rel_Insert_Input>;
  readonly contract_end?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly contract_start?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly created?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly email?: InputMaybe<Scalars['citext']['input']>;
  readonly entitlement?: InputMaybe<User_Entitlement_Active_Obj_Rel_Insert_Input>;
  readonly exchange_usages?: InputMaybe<Exchange_Usage_Arr_Rel_Insert_Input>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly global_permissions?: InputMaybe<Global_Permission_Arr_Rel_Insert_Input>;
  readonly hfc_card_setting?: InputMaybe<Hfc_Card_Settings_Obj_Rel_Insert_Input>;
  readonly hfc_user_setting?: InputMaybe<Hfc_User_Settings_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly licence_agreements?: InputMaybe<Scalars['jsonb']['input']>;
  readonly local_instruments?: InputMaybe<Local_Instrument_Arr_Rel_Insert_Input>;
  readonly login_count?: InputMaybe<Scalars['Int']['input']>;
  readonly logout_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly logout_requests?: InputMaybe<Logout_Request_Arr_Rel_Insert_Input>;
  readonly mfa_opted_out?: InputMaybe<Scalars['Boolean']['input']>;
  readonly multisession_check_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly page_products?: InputMaybe<Page_Products_Arr_Rel_Insert_Input>;
  readonly page_setting?: InputMaybe<Page_Settings_Obj_Rel_Insert_Input>;
  readonly page_settings?: InputMaybe<Page_Settings_Arr_Rel_Insert_Input>;
  readonly paid_user?: InputMaybe<Scalars['Boolean']['input']>;
  readonly permissions?: InputMaybe<Permission_Arr_Rel_Insert_Input>;
  readonly persona?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly roles?: InputMaybe<Scalars['jsonb']['input']>;
  readonly scratchpads?: InputMaybe<Scratchpad_Arr_Rel_Insert_Input>;
  readonly sessions?: InputMaybe<Session_Arr_Rel_Insert_Input>;
  readonly shared_instruments?: InputMaybe<Shared_Instrument_Arr_Rel_Insert_Input>;
  readonly spreader_states?: InputMaybe<Spreader_State_Arr_Rel_Insert_Input>;
  readonly subscription_tier?: InputMaybe<Subscription_Tier_Enum>;
  readonly trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_subscription_tier?: InputMaybe<Subscription_Tier_Obj_Rel_Insert_Input>;
  readonly username?: InputMaybe<Scalars['citext']['input']>;
  readonly userpackageByUser?: InputMaybe<Package_Obj_Rel_Insert_Input>;
  readonly webapp2?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Folio_User_Max_Fields = {
  readonly __typename?: 'folio_user_max_fields';
  readonly contract_end?: Maybe<Scalars['timestamptz']['output']>;
  readonly contract_start?: Maybe<Scalars['timestamptz']['output']>;
  readonly created?: Maybe<Scalars['timestamptz']['output']>;
  readonly email?: Maybe<Scalars['citext']['output']>;
  readonly firstname?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly last_login?: Maybe<Scalars['timestamptz']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly lastname?: Maybe<Scalars['String']['output']>;
  readonly login_count?: Maybe<Scalars['Int']['output']>;
  readonly logout_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
  readonly persona?: Maybe<Scalars['persona_enum']['output']>;
  readonly trial_end?: Maybe<Scalars['timestamptz']['output']>;
  readonly trial_start?: Maybe<Scalars['timestamptz']['output']>;
  readonly username?: Maybe<Scalars['citext']['output']>;
};

/** order by max() on columns of table "folio_user" */
export type Folio_User_Max_Order_By = {
  readonly contract_end?: InputMaybe<Order_By>;
  readonly contract_start?: InputMaybe<Order_By>;
  readonly created?: InputMaybe<Order_By>;
  readonly email?: InputMaybe<Order_By>;
  readonly firstname?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly last_login?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly lastname?: InputMaybe<Order_By>;
  readonly login_count?: InputMaybe<Order_By>;
  readonly logout_requested_at?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly persona?: InputMaybe<Order_By>;
  readonly trial_end?: InputMaybe<Order_By>;
  readonly trial_start?: InputMaybe<Order_By>;
  readonly username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Folio_User_Min_Fields = {
  readonly __typename?: 'folio_user_min_fields';
  readonly contract_end?: Maybe<Scalars['timestamptz']['output']>;
  readonly contract_start?: Maybe<Scalars['timestamptz']['output']>;
  readonly created?: Maybe<Scalars['timestamptz']['output']>;
  readonly email?: Maybe<Scalars['citext']['output']>;
  readonly firstname?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly last_login?: Maybe<Scalars['timestamptz']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly lastname?: Maybe<Scalars['String']['output']>;
  readonly login_count?: Maybe<Scalars['Int']['output']>;
  readonly logout_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
  readonly persona?: Maybe<Scalars['persona_enum']['output']>;
  readonly trial_end?: Maybe<Scalars['timestamptz']['output']>;
  readonly trial_start?: Maybe<Scalars['timestamptz']['output']>;
  readonly username?: Maybe<Scalars['citext']['output']>;
};

/** order by min() on columns of table "folio_user" */
export type Folio_User_Min_Order_By = {
  readonly contract_end?: InputMaybe<Order_By>;
  readonly contract_start?: InputMaybe<Order_By>;
  readonly created?: InputMaybe<Order_By>;
  readonly email?: InputMaybe<Order_By>;
  readonly firstname?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly last_login?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly lastname?: InputMaybe<Order_By>;
  readonly login_count?: InputMaybe<Order_By>;
  readonly logout_requested_at?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly persona?: InputMaybe<Order_By>;
  readonly trial_end?: InputMaybe<Order_By>;
  readonly trial_start?: InputMaybe<Order_By>;
  readonly username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "folio_user" */
export type Folio_User_Mutation_Response = {
  readonly __typename?: 'folio_user_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Folio_User>;
};

/** input type for inserting object relation for remote table "folio_user" */
export type Folio_User_Obj_Rel_Insert_Input = {
  readonly data: Folio_User_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Folio_User_On_Conflict>;
};

/** on_conflict condition type for table "folio_user" */
export type Folio_User_On_Conflict = {
  readonly constraint: Folio_User_Constraint;
  readonly update_columns?: ReadonlyArray<Folio_User_Update_Column>;
  readonly where?: InputMaybe<Folio_User_Bool_Exp>;
};

/** Ordering options when selecting data from "folio_user". */
export type Folio_User_Order_By = {
  readonly alerts_aggregate?: InputMaybe<Alerts_Aggregate_Order_By>;
  readonly blocked?: InputMaybe<Order_By>;
  readonly conditional_formatting_rules_aggregate?: InputMaybe<Conditional_Formatting_Rules_Aggregate_Order_By>;
  readonly contract_end?: InputMaybe<Order_By>;
  readonly contract_start?: InputMaybe<Order_By>;
  readonly created?: InputMaybe<Order_By>;
  readonly email?: InputMaybe<Order_By>;
  readonly entitlement?: InputMaybe<User_Entitlement_Active_Order_By>;
  readonly exchange_usages_aggregate?: InputMaybe<Exchange_Usage_Aggregate_Order_By>;
  readonly firstname?: InputMaybe<Order_By>;
  readonly global_permissions_aggregate?: InputMaybe<Global_Permission_Aggregate_Order_By>;
  readonly hfc_card_setting?: InputMaybe<Hfc_Card_Settings_Order_By>;
  readonly hfc_user_setting?: InputMaybe<Hfc_User_Settings_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_artis_lite?: InputMaybe<Order_By>;
  readonly last_login?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly lastname?: InputMaybe<Order_By>;
  readonly licence_agreements?: InputMaybe<Order_By>;
  readonly local_instruments_aggregate?: InputMaybe<Local_Instrument_Aggregate_Order_By>;
  readonly login_count?: InputMaybe<Order_By>;
  readonly logout_requested_at?: InputMaybe<Order_By>;
  readonly logout_requests_aggregate?: InputMaybe<Logout_Request_Aggregate_Order_By>;
  readonly mfa_opted_out?: InputMaybe<Order_By>;
  readonly multisession_check_disabled?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly page_products_aggregate?: InputMaybe<Page_Products_Aggregate_Order_By>;
  readonly page_setting?: InputMaybe<Page_Settings_Order_By>;
  readonly page_settings_aggregate?: InputMaybe<Page_Settings_Aggregate_Order_By>;
  readonly paid_user?: InputMaybe<Order_By>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Order_By>;
  readonly persona?: InputMaybe<Order_By>;
  readonly roles?: InputMaybe<Order_By>;
  readonly scratchpads_aggregate?: InputMaybe<Scratchpad_Aggregate_Order_By>;
  readonly sessions_aggregate?: InputMaybe<Session_Aggregate_Order_By>;
  readonly shared_instruments_aggregate?: InputMaybe<Shared_Instrument_Aggregate_Order_By>;
  readonly spreader_states_aggregate?: InputMaybe<Spreader_State_Aggregate_Order_By>;
  readonly subscription_tier?: InputMaybe<Order_By>;
  readonly trial_end?: InputMaybe<Order_By>;
  readonly trial_start?: InputMaybe<Order_By>;
  readonly user_subscription_tier?: InputMaybe<Subscription_Tier_Order_By>;
  readonly username?: InputMaybe<Order_By>;
  readonly userpackageByUser?: InputMaybe<Package_Order_By>;
  readonly webapp2?: InputMaybe<Order_By>;
};

/** primary key columns input for table: folio_user */
export type Folio_User_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Folio_User_Prepend_Input = {
  readonly licence_agreements?: InputMaybe<Scalars['jsonb']['input']>;
  readonly roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "folio_user" */
export type Folio_User_Select_Column =
  /** column name */
  | 'blocked'
  /** column name */
  | 'contract_end'
  /** column name */
  | 'contract_start'
  /** column name */
  | 'created'
  /** column name */
  | 'email'
  /** column name */
  | 'firstname'
  /** column name */
  | 'id'
  /** column name */
  | 'is_artis_lite'
  /** column name */
  | 'last_login'
  /** column name */
  | 'last_seen'
  /** column name */
  | 'lastname'
  /** column name */
  | 'licence_agreements'
  /** column name */
  | 'login_count'
  /** column name */
  | 'logout_requested_at'
  /** column name */
  | 'mfa_opted_out'
  /** column name */
  | 'multisession_check_disabled'
  /** column name */
  | 'organisation'
  /** column name */
  | 'package'
  /** column name */
  | 'paid_user'
  /** column name */
  | 'persona'
  /** column name */
  | 'roles'
  /** column name */
  | 'subscription_tier'
  /** column name */
  | 'trial_end'
  /** column name */
  | 'trial_start'
  /** column name */
  | 'username'
  /** column name */
  | 'webapp2';

/** select "folio_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "folio_user" */
export type Folio_User_Select_Column_Folio_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'blocked'
  /** column name */
  | 'is_artis_lite'
  /** column name */
  | 'mfa_opted_out'
  /** column name */
  | 'multisession_check_disabled'
  /** column name */
  | 'paid_user'
  /** column name */
  | 'webapp2';

/** select "folio_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "folio_user" */
export type Folio_User_Select_Column_Folio_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'blocked'
  /** column name */
  | 'is_artis_lite'
  /** column name */
  | 'mfa_opted_out'
  /** column name */
  | 'multisession_check_disabled'
  /** column name */
  | 'paid_user'
  /** column name */
  | 'webapp2';

/** input type for updating data in table "folio_user" */
export type Folio_User_Set_Input = {
  readonly blocked?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contract_end?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly contract_start?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly created?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly email?: InputMaybe<Scalars['citext']['input']>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly licence_agreements?: InputMaybe<Scalars['jsonb']['input']>;
  readonly login_count?: InputMaybe<Scalars['Int']['input']>;
  readonly logout_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly mfa_opted_out?: InputMaybe<Scalars['Boolean']['input']>;
  readonly multisession_check_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly paid_user?: InputMaybe<Scalars['Boolean']['input']>;
  readonly persona?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly roles?: InputMaybe<Scalars['jsonb']['input']>;
  readonly subscription_tier?: InputMaybe<Subscription_Tier_Enum>;
  readonly trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly username?: InputMaybe<Scalars['citext']['input']>;
  readonly webapp2?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Folio_User_Stddev_Fields = {
  readonly __typename?: 'folio_user_stddev_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "folio_user" */
export type Folio_User_Stddev_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Folio_User_Stddev_Pop_Fields = {
  readonly __typename?: 'folio_user_stddev_pop_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "folio_user" */
export type Folio_User_Stddev_Pop_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Folio_User_Stddev_Samp_Fields = {
  readonly __typename?: 'folio_user_stddev_samp_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "folio_user" */
export type Folio_User_Stddev_Samp_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "folio_user" */
export type Folio_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Folio_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Folio_User_Stream_Cursor_Value_Input = {
  readonly blocked?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contract_end?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly contract_start?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly created?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly email?: InputMaybe<Scalars['citext']['input']>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_artis_lite?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly licence_agreements?: InputMaybe<Scalars['jsonb']['input']>;
  readonly login_count?: InputMaybe<Scalars['Int']['input']>;
  readonly logout_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly mfa_opted_out?: InputMaybe<Scalars['Boolean']['input']>;
  readonly multisession_check_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly paid_user?: InputMaybe<Scalars['Boolean']['input']>;
  readonly persona?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly roles?: InputMaybe<Scalars['jsonb']['input']>;
  readonly subscription_tier?: InputMaybe<Subscription_Tier_Enum>;
  readonly trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly username?: InputMaybe<Scalars['citext']['input']>;
  readonly webapp2?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Folio_User_Sum_Fields = {
  readonly __typename?: 'folio_user_sum_fields';
  readonly login_count?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "folio_user" */
export type Folio_User_Sum_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** update columns of table "folio_user" */
export type Folio_User_Update_Column =
  /** column name */
  | 'blocked'
  /** column name */
  | 'contract_end'
  /** column name */
  | 'contract_start'
  /** column name */
  | 'created'
  /** column name */
  | 'email'
  /** column name */
  | 'firstname'
  /** column name */
  | 'id'
  /** column name */
  | 'last_login'
  /** column name */
  | 'last_seen'
  /** column name */
  | 'lastname'
  /** column name */
  | 'licence_agreements'
  /** column name */
  | 'login_count'
  /** column name */
  | 'logout_requested_at'
  /** column name */
  | 'mfa_opted_out'
  /** column name */
  | 'multisession_check_disabled'
  /** column name */
  | 'organisation'
  /** column name */
  | 'package'
  /** column name */
  | 'paid_user'
  /** column name */
  | 'persona'
  /** column name */
  | 'roles'
  /** column name */
  | 'subscription_tier'
  /** column name */
  | 'trial_end'
  /** column name */
  | 'trial_start'
  /** column name */
  | 'username'
  /** column name */
  | 'webapp2';

export type Folio_User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Folio_User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Folio_User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Folio_User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Folio_User_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Folio_User_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Folio_User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Folio_User_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Folio_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Folio_User_Var_Pop_Fields = {
  readonly __typename?: 'folio_user_var_pop_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "folio_user" */
export type Folio_User_Var_Pop_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Folio_User_Var_Samp_Fields = {
  readonly __typename?: 'folio_user_var_samp_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "folio_user" */
export type Folio_User_Var_Samp_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Folio_User_Variance_Fields = {
  readonly __typename?: 'folio_user_variance_fields';
  readonly login_count?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "folio_user" */
export type Folio_User_Variance_Order_By = {
  readonly login_count?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** columns and relationships of "geographical_region" */
export type Geographical_Region = {
  readonly __typename?: 'geographical_region';
  /** An array relationship */
  readonly global_products: ReadonlyArray<Global_Product>;
  /** An aggregate relationship */
  readonly global_products_aggregate: Global_Product_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  readonly organisationByOrganisation?: Maybe<Organisation>;
  /** An array relationship */
  readonly product_overrides: ReadonlyArray<Product_Overrides>;
  /** An aggregate relationship */
  readonly product_overrides_aggregate: Product_Overrides_Aggregate;
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly value?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "geographical_region" */
export type Geographical_RegionGlobal_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "geographical_region" */
export type Geographical_RegionGlobal_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "geographical_region" */
export type Geographical_RegionProduct_OverridesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "geographical_region" */
export type Geographical_RegionProduct_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "geographical_region" */
export type Geographical_RegionProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "geographical_region" */
export type Geographical_RegionProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "geographical_region" */
export type Geographical_Region_Aggregate = {
  readonly __typename?: 'geographical_region_aggregate';
  readonly aggregate?: Maybe<Geographical_Region_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Geographical_Region>;
};

export type Geographical_Region_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Geographical_Region_Aggregate_Bool_Exp_Count>;
};

export type Geographical_Region_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Geographical_Region_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "geographical_region" */
export type Geographical_Region_Aggregate_Fields = {
  readonly __typename?: 'geographical_region_aggregate_fields';
  readonly avg?: Maybe<Geographical_Region_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Geographical_Region_Max_Fields>;
  readonly min?: Maybe<Geographical_Region_Min_Fields>;
  readonly stddev?: Maybe<Geographical_Region_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Geographical_Region_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Geographical_Region_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Geographical_Region_Sum_Fields>;
  readonly var_pop?: Maybe<Geographical_Region_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Geographical_Region_Var_Samp_Fields>;
  readonly variance?: Maybe<Geographical_Region_Variance_Fields>;
};


/** aggregate fields of "geographical_region" */
export type Geographical_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "geographical_region" */
export type Geographical_Region_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Geographical_Region_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Geographical_Region_Max_Order_By>;
  readonly min?: InputMaybe<Geographical_Region_Min_Order_By>;
  readonly stddev?: InputMaybe<Geographical_Region_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Geographical_Region_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Geographical_Region_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Geographical_Region_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Geographical_Region_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Geographical_Region_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Geographical_Region_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "geographical_region" */
export type Geographical_Region_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Geographical_Region_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Geographical_Region_On_Conflict>;
};

/** aggregate avg on columns */
export type Geographical_Region_Avg_Fields = {
  readonly __typename?: 'geographical_region_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "geographical_region" */
export type Geographical_Region_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "geographical_region". All fields are combined with a logical 'AND'. */
export type Geographical_Region_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Geographical_Region_Bool_Exp>>;
  readonly _not?: InputMaybe<Geographical_Region_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Geographical_Region_Bool_Exp>>;
  readonly global_products?: InputMaybe<Global_Product_Bool_Exp>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Bool_Exp>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Bool_Exp>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Bool_Exp>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "geographical_region" */
export type Geographical_Region_Constraint =
  /** unique or primary key constraint on columns "organisation", "value" */
  | 'geographical_region_organisation_value_key'
  /** unique or primary key constraint on columns "id" */
  | 'geographical_region_pkey';

/** input type for incrementing numeric columns in table "geographical_region" */
export type Geographical_Region_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "geographical_region" */
export type Geographical_Region_Insert_Input = {
  readonly global_products?: InputMaybe<Global_Product_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Arr_Rel_Insert_Input>;
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Geographical_Region_Max_Fields = {
  readonly __typename?: 'geographical_region_max_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "geographical_region" */
export type Geographical_Region_Max_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Geographical_Region_Min_Fields = {
  readonly __typename?: 'geographical_region_min_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "geographical_region" */
export type Geographical_Region_Min_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "geographical_region" */
export type Geographical_Region_Mutation_Response = {
  readonly __typename?: 'geographical_region_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Geographical_Region>;
};

/** input type for inserting object relation for remote table "geographical_region" */
export type Geographical_Region_Obj_Rel_Insert_Input = {
  readonly data: Geographical_Region_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Geographical_Region_On_Conflict>;
};

/** on_conflict condition type for table "geographical_region" */
export type Geographical_Region_On_Conflict = {
  readonly constraint: Geographical_Region_Constraint;
  readonly update_columns?: ReadonlyArray<Geographical_Region_Update_Column>;
  readonly where?: InputMaybe<Geographical_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "geographical_region". */
export type Geographical_Region_Order_By = {
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Order_By>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Order_By>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: geographical_region */
export type Geographical_Region_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "geographical_region" */
export type Geographical_Region_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'organisation'
  /** column name */
  | 'value';

/** input type for updating data in table "geographical_region" */
export type Geographical_Region_Set_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Geographical_Region_Stddev_Fields = {
  readonly __typename?: 'geographical_region_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "geographical_region" */
export type Geographical_Region_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Geographical_Region_Stddev_Pop_Fields = {
  readonly __typename?: 'geographical_region_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "geographical_region" */
export type Geographical_Region_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Geographical_Region_Stddev_Samp_Fields = {
  readonly __typename?: 'geographical_region_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "geographical_region" */
export type Geographical_Region_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "geographical_region" */
export type Geographical_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Geographical_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geographical_Region_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Geographical_Region_Sum_Fields = {
  readonly __typename?: 'geographical_region_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "geographical_region" */
export type Geographical_Region_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** update columns of table "geographical_region" */
export type Geographical_Region_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'organisation'
  /** column name */
  | 'value';

export type Geographical_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Geographical_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Geographical_Region_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Geographical_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Geographical_Region_Var_Pop_Fields = {
  readonly __typename?: 'geographical_region_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "geographical_region" */
export type Geographical_Region_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Geographical_Region_Var_Samp_Fields = {
  readonly __typename?: 'geographical_region_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "geographical_region" */
export type Geographical_Region_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Geographical_Region_Variance_Fields = {
  readonly __typename?: 'geographical_region_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "geographical_region" */
export type Geographical_Region_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** columns and relationships of "global_instrument" */
export type Global_Instrument = {
  readonly __typename?: 'global_instrument';
  readonly edited_at: Scalars['timestamptz']['output'];
  readonly edited_by: Scalars['String']['output'];
  /** An object relationship */
  readonly globalProductByGlobalProduct: Global_Product;
  readonly global_product: Scalars['uuid']['output'];
  readonly id: Scalars['Int']['output'];
  readonly month: Scalars['date']['output'];
  readonly shared_at: Scalars['timestamptz']['output'];
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "global_instrument" */
export type Global_Instrument_Aggregate = {
  readonly __typename?: 'global_instrument_aggregate';
  readonly aggregate?: Maybe<Global_Instrument_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Global_Instrument>;
};

export type Global_Instrument_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Global_Instrument_Aggregate_Bool_Exp_Count>;
};

export type Global_Instrument_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Global_Instrument_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "global_instrument" */
export type Global_Instrument_Aggregate_Fields = {
  readonly __typename?: 'global_instrument_aggregate_fields';
  readonly avg?: Maybe<Global_Instrument_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Global_Instrument_Max_Fields>;
  readonly min?: Maybe<Global_Instrument_Min_Fields>;
  readonly stddev?: Maybe<Global_Instrument_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Global_Instrument_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Global_Instrument_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Global_Instrument_Sum_Fields>;
  readonly var_pop?: Maybe<Global_Instrument_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Global_Instrument_Var_Samp_Fields>;
  readonly variance?: Maybe<Global_Instrument_Variance_Fields>;
};


/** aggregate fields of "global_instrument" */
export type Global_Instrument_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "global_instrument" */
export type Global_Instrument_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Global_Instrument_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Global_Instrument_Max_Order_By>;
  readonly min?: InputMaybe<Global_Instrument_Min_Order_By>;
  readonly stddev?: InputMaybe<Global_Instrument_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Global_Instrument_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Global_Instrument_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Global_Instrument_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Global_Instrument_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Global_Instrument_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Global_Instrument_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "global_instrument" */
export type Global_Instrument_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Global_Instrument_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Instrument_On_Conflict>;
};

/** aggregate avg on columns */
export type Global_Instrument_Avg_Fields = {
  readonly __typename?: 'global_instrument_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "global_instrument" */
export type Global_Instrument_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "global_instrument". All fields are combined with a logical 'AND'. */
export type Global_Instrument_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Global_Instrument_Bool_Exp>>;
  readonly _not?: InputMaybe<Global_Instrument_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Global_Instrument_Bool_Exp>>;
  readonly edited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly edited_by?: InputMaybe<String_Comparison_Exp>;
  readonly globalProductByGlobalProduct?: InputMaybe<Global_Product_Bool_Exp>;
  readonly global_product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly month?: InputMaybe<Date_Comparison_Exp>;
  readonly shared_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "global_instrument" */
export type Global_Instrument_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'global_instrument_id_key'
  /** unique or primary key constraint on columns "global_product", "month" */
  | 'global_instrument_pkey';

/** input type for incrementing numeric columns in table "global_instrument" */
export type Global_Instrument_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "global_instrument" */
export type Global_Instrument_Insert_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly edited_by?: InputMaybe<Scalars['String']['input']>;
  readonly globalProductByGlobalProduct?: InputMaybe<Global_Product_Obj_Rel_Insert_Input>;
  readonly global_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly shared_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Global_Instrument_Max_Fields = {
  readonly __typename?: 'global_instrument_max_fields';
  readonly edited_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly edited_by?: Maybe<Scalars['String']['output']>;
  readonly global_product?: Maybe<Scalars['uuid']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly shared_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "global_instrument" */
export type Global_Instrument_Max_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly edited_by?: InputMaybe<Order_By>;
  readonly global_product?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly shared_at?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Global_Instrument_Min_Fields = {
  readonly __typename?: 'global_instrument_min_fields';
  readonly edited_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly edited_by?: Maybe<Scalars['String']['output']>;
  readonly global_product?: Maybe<Scalars['uuid']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly shared_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "global_instrument" */
export type Global_Instrument_Min_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly edited_by?: InputMaybe<Order_By>;
  readonly global_product?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly shared_at?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "global_instrument" */
export type Global_Instrument_Mutation_Response = {
  readonly __typename?: 'global_instrument_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Global_Instrument>;
};

/** on_conflict condition type for table "global_instrument" */
export type Global_Instrument_On_Conflict = {
  readonly constraint: Global_Instrument_Constraint;
  readonly update_columns?: ReadonlyArray<Global_Instrument_Update_Column>;
  readonly where?: InputMaybe<Global_Instrument_Bool_Exp>;
};

/** Ordering options when selecting data from "global_instrument". */
export type Global_Instrument_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly edited_by?: InputMaybe<Order_By>;
  readonly globalProductByGlobalProduct?: InputMaybe<Global_Product_Order_By>;
  readonly global_product?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly shared_at?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: global_instrument */
export type Global_Instrument_Pk_Columns_Input = {
  readonly global_product: Scalars['uuid']['input'];
  readonly month: Scalars['date']['input'];
};

/** select columns of table "global_instrument" */
export type Global_Instrument_Select_Column =
  /** column name */
  | 'edited_at'
  /** column name */
  | 'edited_by'
  /** column name */
  | 'global_product'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'shared_at'
  /** column name */
  | 'value';

/** input type for updating data in table "global_instrument" */
export type Global_Instrument_Set_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly edited_by?: InputMaybe<Scalars['String']['input']>;
  readonly global_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly shared_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Global_Instrument_Stddev_Fields = {
  readonly __typename?: 'global_instrument_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "global_instrument" */
export type Global_Instrument_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Global_Instrument_Stddev_Pop_Fields = {
  readonly __typename?: 'global_instrument_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "global_instrument" */
export type Global_Instrument_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Global_Instrument_Stddev_Samp_Fields = {
  readonly __typename?: 'global_instrument_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "global_instrument" */
export type Global_Instrument_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "global_instrument" */
export type Global_Instrument_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Global_Instrument_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Instrument_Stream_Cursor_Value_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly edited_by?: InputMaybe<Scalars['String']['input']>;
  readonly global_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly shared_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Global_Instrument_Sum_Fields = {
  readonly __typename?: 'global_instrument_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "global_instrument" */
export type Global_Instrument_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** update columns of table "global_instrument" */
export type Global_Instrument_Update_Column =
  /** column name */
  | 'edited_at'
  /** column name */
  | 'edited_by'
  /** column name */
  | 'global_product'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'shared_at'
  /** column name */
  | 'value';

export type Global_Instrument_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Global_Instrument_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Global_Instrument_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Global_Instrument_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Instrument_Var_Pop_Fields = {
  readonly __typename?: 'global_instrument_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "global_instrument" */
export type Global_Instrument_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Global_Instrument_Var_Samp_Fields = {
  readonly __typename?: 'global_instrument_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "global_instrument" */
export type Global_Instrument_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Global_Instrument_Variance_Fields = {
  readonly __typename?: 'global_instrument_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "global_instrument" */
export type Global_Instrument_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** columns and relationships of "global_package" */
export type Global_Package = {
  readonly __typename?: 'global_package';
  readonly description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  readonly global_permissions: ReadonlyArray<Global_Permission>;
  /** An aggregate relationship */
  readonly global_permissions_aggregate: Global_Permission_Aggregate;
  /** An array relationship */
  readonly global_products: ReadonlyArray<Global_Product>;
  /** An aggregate relationship */
  readonly global_products_aggregate: Global_Product_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly package_type?: Maybe<Scalars['String']['output']>;
  readonly source: Scalars['Int']['output'];
  /** An object relationship */
  readonly sourceBySource?: Maybe<Source>;
};


/** columns and relationships of "global_package" */
export type Global_PackageGlobal_PermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


/** columns and relationships of "global_package" */
export type Global_PackageGlobal_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


/** columns and relationships of "global_package" */
export type Global_PackageGlobal_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "global_package" */
export type Global_PackageGlobal_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};

/** aggregated selection of "global_package" */
export type Global_Package_Aggregate = {
  readonly __typename?: 'global_package_aggregate';
  readonly aggregate?: Maybe<Global_Package_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Global_Package>;
};

export type Global_Package_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Global_Package_Aggregate_Bool_Exp_Count>;
};

export type Global_Package_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Global_Package_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "global_package" */
export type Global_Package_Aggregate_Fields = {
  readonly __typename?: 'global_package_aggregate_fields';
  readonly avg?: Maybe<Global_Package_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Global_Package_Max_Fields>;
  readonly min?: Maybe<Global_Package_Min_Fields>;
  readonly stddev?: Maybe<Global_Package_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Global_Package_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Global_Package_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Global_Package_Sum_Fields>;
  readonly var_pop?: Maybe<Global_Package_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Global_Package_Var_Samp_Fields>;
  readonly variance?: Maybe<Global_Package_Variance_Fields>;
};


/** aggregate fields of "global_package" */
export type Global_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "global_package" */
export type Global_Package_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Global_Package_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Global_Package_Max_Order_By>;
  readonly min?: InputMaybe<Global_Package_Min_Order_By>;
  readonly stddev?: InputMaybe<Global_Package_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Global_Package_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Global_Package_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Global_Package_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Global_Package_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Global_Package_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Global_Package_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "global_package" */
export type Global_Package_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Global_Package_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Package_On_Conflict>;
};

/** aggregate avg on columns */
export type Global_Package_Avg_Fields = {
  readonly __typename?: 'global_package_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "global_package" */
export type Global_Package_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "global_package". All fields are combined with a logical 'AND'. */
export type Global_Package_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Global_Package_Bool_Exp>>;
  readonly _not?: InputMaybe<Global_Package_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Global_Package_Bool_Exp>>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly global_permissions?: InputMaybe<Global_Permission_Bool_Exp>;
  readonly global_permissions_aggregate?: InputMaybe<Global_Permission_Aggregate_Bool_Exp>;
  readonly global_products?: InputMaybe<Global_Product_Bool_Exp>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly package_type?: InputMaybe<String_Comparison_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
  readonly sourceBySource?: InputMaybe<Source_Bool_Exp>;
};

/** unique or primary key constraints on table "global_package" */
export type Global_Package_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'global_package_pkey';

/** input type for incrementing numeric columns in table "global_package" */
export type Global_Package_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "global_package" */
export type Global_Package_Insert_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly global_permissions?: InputMaybe<Global_Permission_Arr_Rel_Insert_Input>;
  readonly global_products?: InputMaybe<Global_Product_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package_type?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
  readonly sourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Global_Package_Max_Fields = {
  readonly __typename?: 'global_package_max_fields';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly package_type?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "global_package" */
export type Global_Package_Max_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package_type?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Global_Package_Min_Fields = {
  readonly __typename?: 'global_package_min_fields';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly package_type?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "global_package" */
export type Global_Package_Min_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package_type?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "global_package" */
export type Global_Package_Mutation_Response = {
  readonly __typename?: 'global_package_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Global_Package>;
};

/** input type for inserting object relation for remote table "global_package" */
export type Global_Package_Obj_Rel_Insert_Input = {
  readonly data: Global_Package_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Package_On_Conflict>;
};

/** on_conflict condition type for table "global_package" */
export type Global_Package_On_Conflict = {
  readonly constraint: Global_Package_Constraint;
  readonly update_columns?: ReadonlyArray<Global_Package_Update_Column>;
  readonly where?: InputMaybe<Global_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "global_package". */
export type Global_Package_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly global_permissions_aggregate?: InputMaybe<Global_Permission_Aggregate_Order_By>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package_type?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly sourceBySource?: InputMaybe<Source_Order_By>;
};

/** primary key columns input for table: global_package */
export type Global_Package_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "global_package" */
export type Global_Package_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'package_type'
  /** column name */
  | 'source';

/** input type for updating data in table "global_package" */
export type Global_Package_Set_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package_type?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Global_Package_Stddev_Fields = {
  readonly __typename?: 'global_package_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "global_package" */
export type Global_Package_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Global_Package_Stddev_Pop_Fields = {
  readonly __typename?: 'global_package_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "global_package" */
export type Global_Package_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Global_Package_Stddev_Samp_Fields = {
  readonly __typename?: 'global_package_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "global_package" */
export type Global_Package_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "global_package" */
export type Global_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Global_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Package_Stream_Cursor_Value_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package_type?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Global_Package_Sum_Fields = {
  readonly __typename?: 'global_package_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "global_package" */
export type Global_Package_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** update columns of table "global_package" */
export type Global_Package_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'package_type'
  /** column name */
  | 'source';

export type Global_Package_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Global_Package_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Global_Package_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Global_Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Package_Var_Pop_Fields = {
  readonly __typename?: 'global_package_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "global_package" */
export type Global_Package_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Global_Package_Var_Samp_Fields = {
  readonly __typename?: 'global_package_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "global_package" */
export type Global_Package_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Global_Package_Variance_Fields = {
  readonly __typename?: 'global_package_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "global_package" */
export type Global_Package_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** columns and relationships of "global_permission" */
export type Global_Permission = {
  readonly __typename?: 'global_permission';
  readonly folio_user: Scalars['String']['output'];
  /** An object relationship */
  readonly globalPackageByGlobalPackage: Global_Package;
  readonly global_package: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly permission: User_Right_Enum;
  /** An object relationship */
  readonly permission_folio_user?: Maybe<Folio_User>;
  /** An object relationship */
  readonly user_right: User_Right;
};

/** aggregated selection of "global_permission" */
export type Global_Permission_Aggregate = {
  readonly __typename?: 'global_permission_aggregate';
  readonly aggregate?: Maybe<Global_Permission_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Global_Permission>;
};

export type Global_Permission_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Global_Permission_Aggregate_Bool_Exp_Count>;
};

export type Global_Permission_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Global_Permission_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "global_permission" */
export type Global_Permission_Aggregate_Fields = {
  readonly __typename?: 'global_permission_aggregate_fields';
  readonly avg?: Maybe<Global_Permission_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Global_Permission_Max_Fields>;
  readonly min?: Maybe<Global_Permission_Min_Fields>;
  readonly stddev?: Maybe<Global_Permission_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Global_Permission_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Global_Permission_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Global_Permission_Sum_Fields>;
  readonly var_pop?: Maybe<Global_Permission_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Global_Permission_Var_Samp_Fields>;
  readonly variance?: Maybe<Global_Permission_Variance_Fields>;
};


/** aggregate fields of "global_permission" */
export type Global_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "global_permission" */
export type Global_Permission_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Global_Permission_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Global_Permission_Max_Order_By>;
  readonly min?: InputMaybe<Global_Permission_Min_Order_By>;
  readonly stddev?: InputMaybe<Global_Permission_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Global_Permission_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Global_Permission_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Global_Permission_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Global_Permission_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Global_Permission_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Global_Permission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "global_permission" */
export type Global_Permission_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Global_Permission_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Permission_On_Conflict>;
};

/** aggregate avg on columns */
export type Global_Permission_Avg_Fields = {
  readonly __typename?: 'global_permission_avg_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "global_permission" */
export type Global_Permission_Avg_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "global_permission". All fields are combined with a logical 'AND'. */
export type Global_Permission_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Global_Permission_Bool_Exp>>;
  readonly _not?: InputMaybe<Global_Permission_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Global_Permission_Bool_Exp>>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly globalPackageByGlobalPackage?: InputMaybe<Global_Package_Bool_Exp>;
  readonly global_package?: InputMaybe<Int_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly permission?: InputMaybe<User_Right_Enum_Comparison_Exp>;
  readonly permission_folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly user_right?: InputMaybe<User_Right_Bool_Exp>;
};

/** unique or primary key constraints on table "global_permission" */
export type Global_Permission_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'global_permission_id_key'
  /** unique or primary key constraint on columns "folio_user", "global_package" */
  | 'global_permission_pkey';

/** input type for incrementing numeric columns in table "global_permission" */
export type Global_Permission_Inc_Input = {
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "global_permission" */
export type Global_Permission_Insert_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly globalPackageByGlobalPackage?: InputMaybe<Global_Package_Obj_Rel_Insert_Input>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly permission?: InputMaybe<User_Right_Enum>;
  readonly permission_folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly user_right?: InputMaybe<User_Right_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Global_Permission_Max_Fields = {
  readonly __typename?: 'global_permission_max_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly global_package?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "global_permission" */
export type Global_Permission_Max_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Global_Permission_Min_Fields = {
  readonly __typename?: 'global_permission_min_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly global_package?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "global_permission" */
export type Global_Permission_Min_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "global_permission" */
export type Global_Permission_Mutation_Response = {
  readonly __typename?: 'global_permission_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Global_Permission>;
};

/** on_conflict condition type for table "global_permission" */
export type Global_Permission_On_Conflict = {
  readonly constraint: Global_Permission_Constraint;
  readonly update_columns?: ReadonlyArray<Global_Permission_Update_Column>;
  readonly where?: InputMaybe<Global_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "global_permission". */
export type Global_Permission_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly globalPackageByGlobalPackage?: InputMaybe<Global_Package_Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly permission?: InputMaybe<Order_By>;
  readonly permission_folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly user_right?: InputMaybe<User_Right_Order_By>;
};

/** primary key columns input for table: global_permission */
export type Global_Permission_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
  readonly global_package: Scalars['Int']['input'];
};

/** select columns of table "global_permission" */
export type Global_Permission_Select_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'global_package'
  /** column name */
  | 'id'
  /** column name */
  | 'permission';

/** input type for updating data in table "global_permission" */
export type Global_Permission_Set_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly permission?: InputMaybe<User_Right_Enum>;
};

/** aggregate stddev on columns */
export type Global_Permission_Stddev_Fields = {
  readonly __typename?: 'global_permission_stddev_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "global_permission" */
export type Global_Permission_Stddev_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Global_Permission_Stddev_Pop_Fields = {
  readonly __typename?: 'global_permission_stddev_pop_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "global_permission" */
export type Global_Permission_Stddev_Pop_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Global_Permission_Stddev_Samp_Fields = {
  readonly __typename?: 'global_permission_stddev_samp_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "global_permission" */
export type Global_Permission_Stddev_Samp_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "global_permission" */
export type Global_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Global_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Permission_Stream_Cursor_Value_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly permission?: InputMaybe<User_Right_Enum>;
};

/** aggregate sum on columns */
export type Global_Permission_Sum_Fields = {
  readonly __typename?: 'global_permission_sum_fields';
  readonly global_package?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "global_permission" */
export type Global_Permission_Sum_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** update columns of table "global_permission" */
export type Global_Permission_Update_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'global_package'
  /** column name */
  | 'id'
  /** column name */
  | 'permission';

export type Global_Permission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Global_Permission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Global_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Global_Permission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Permission_Var_Pop_Fields = {
  readonly __typename?: 'global_permission_var_pop_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "global_permission" */
export type Global_Permission_Var_Pop_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Global_Permission_Var_Samp_Fields = {
  readonly __typename?: 'global_permission_var_samp_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "global_permission" */
export type Global_Permission_Var_Samp_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Global_Permission_Variance_Fields = {
  readonly __typename?: 'global_permission_variance_fields';
  readonly global_package?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "global_permission" */
export type Global_Permission_Variance_Order_By = {
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** columns and relationships of "global_product" */
export type Global_Product = {
  readonly __typename?: 'global_product';
  /** An object relationship */
  readonly commodityGroupByCommodityGroup?: Maybe<Commodity_Group>;
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly curve_type: Product_Curve_Type_Enum;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly geographicalRegionByGeographicalRegion?: Maybe<Geographical_Region>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  readonly globalPackageByGlobalPackage: Global_Package;
  /** An array relationship */
  readonly global_instruments: ReadonlyArray<Global_Instrument>;
  /** An aggregate relationship */
  readonly global_instruments_aggregate: Global_Instrument_Aggregate;
  readonly global_package: Scalars['Int']['output'];
  /** An array relationship */
  readonly global_product_configs: ReadonlyArray<Global_Product_Config>;
  /** An aggregate relationship */
  readonly global_product_configs_aggregate: Global_Product_Config_Aggregate;
  readonly id: Scalars['uuid']['output'];
  readonly name: Scalars['String']['output'];
  /** An object relationship */
  readonly product_curve_type: Product_Curve_Type;
  /** An object relationship */
  readonly product_uom: Product_Uom;
  readonly uom: Product_Uom_Enum;
};


/** columns and relationships of "global_product" */
export type Global_ProductGlobal_InstrumentsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Instrument_Order_By>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


/** columns and relationships of "global_product" */
export type Global_ProductGlobal_Instruments_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Instrument_Order_By>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


/** columns and relationships of "global_product" */
export type Global_ProductGlobal_Product_ConfigsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Config_Order_By>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};


/** columns and relationships of "global_product" */
export type Global_ProductGlobal_Product_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Config_Order_By>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};

/** aggregated selection of "global_product" */
export type Global_Product_Aggregate = {
  readonly __typename?: 'global_product_aggregate';
  readonly aggregate?: Maybe<Global_Product_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Global_Product>;
};

export type Global_Product_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Global_Product_Aggregate_Bool_Exp_Count>;
};

export type Global_Product_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Global_Product_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "global_product" */
export type Global_Product_Aggregate_Fields = {
  readonly __typename?: 'global_product_aggregate_fields';
  readonly avg?: Maybe<Global_Product_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Global_Product_Max_Fields>;
  readonly min?: Maybe<Global_Product_Min_Fields>;
  readonly stddev?: Maybe<Global_Product_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Global_Product_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Global_Product_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Global_Product_Sum_Fields>;
  readonly var_pop?: Maybe<Global_Product_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Global_Product_Var_Samp_Fields>;
  readonly variance?: Maybe<Global_Product_Variance_Fields>;
};


/** aggregate fields of "global_product" */
export type Global_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "global_product" */
export type Global_Product_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Global_Product_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Global_Product_Max_Order_By>;
  readonly min?: InputMaybe<Global_Product_Min_Order_By>;
  readonly stddev?: InputMaybe<Global_Product_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Global_Product_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Global_Product_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Global_Product_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Global_Product_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Global_Product_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Global_Product_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "global_product" */
export type Global_Product_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Global_Product_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Product_On_Conflict>;
};

/** aggregate avg on columns */
export type Global_Product_Avg_Fields = {
  readonly __typename?: 'global_product_avg_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "global_product" */
export type Global_Product_Avg_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "global_product". All fields are combined with a logical 'AND'. */
export type Global_Product_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Global_Product_Bool_Exp>>;
  readonly _not?: InputMaybe<Global_Product_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Global_Product_Bool_Exp>>;
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Bool_Exp>;
  readonly commodity_group?: InputMaybe<Int_Comparison_Exp>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum_Comparison_Exp>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Bool_Exp>;
  readonly geographical_region?: InputMaybe<Int_Comparison_Exp>;
  readonly globalPackageByGlobalPackage?: InputMaybe<Global_Package_Bool_Exp>;
  readonly global_instruments?: InputMaybe<Global_Instrument_Bool_Exp>;
  readonly global_instruments_aggregate?: InputMaybe<Global_Instrument_Aggregate_Bool_Exp>;
  readonly global_package?: InputMaybe<Int_Comparison_Exp>;
  readonly global_product_configs?: InputMaybe<Global_Product_Config_Bool_Exp>;
  readonly global_product_configs_aggregate?: InputMaybe<Global_Product_Config_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Uuid_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly product_curve_type?: InputMaybe<Product_Curve_Type_Bool_Exp>;
  readonly product_uom?: InputMaybe<Product_Uom_Bool_Exp>;
  readonly uom?: InputMaybe<Product_Uom_Enum_Comparison_Exp>;
};

/** Product configs for global configs */
export type Global_Product_Config = {
  readonly __typename?: 'global_product_config';
  readonly created_at: Scalars['timestamptz']['output'];
  readonly formula?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly global_product: Global_Product;
  readonly id: Scalars['Int']['output'];
  readonly product: Scalars['uuid']['output'];
  readonly relative_month: Scalars['Int']['output'];
  readonly updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "global_product_config" */
export type Global_Product_Config_Aggregate = {
  readonly __typename?: 'global_product_config_aggregate';
  readonly aggregate?: Maybe<Global_Product_Config_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Global_Product_Config>;
};

export type Global_Product_Config_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Global_Product_Config_Aggregate_Bool_Exp_Count>;
};

export type Global_Product_Config_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Global_Product_Config_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "global_product_config" */
export type Global_Product_Config_Aggregate_Fields = {
  readonly __typename?: 'global_product_config_aggregate_fields';
  readonly avg?: Maybe<Global_Product_Config_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Global_Product_Config_Max_Fields>;
  readonly min?: Maybe<Global_Product_Config_Min_Fields>;
  readonly stddev?: Maybe<Global_Product_Config_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Global_Product_Config_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Global_Product_Config_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Global_Product_Config_Sum_Fields>;
  readonly var_pop?: Maybe<Global_Product_Config_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Global_Product_Config_Var_Samp_Fields>;
  readonly variance?: Maybe<Global_Product_Config_Variance_Fields>;
};


/** aggregate fields of "global_product_config" */
export type Global_Product_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "global_product_config" */
export type Global_Product_Config_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Global_Product_Config_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Global_Product_Config_Max_Order_By>;
  readonly min?: InputMaybe<Global_Product_Config_Min_Order_By>;
  readonly stddev?: InputMaybe<Global_Product_Config_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Global_Product_Config_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Global_Product_Config_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Global_Product_Config_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Global_Product_Config_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Global_Product_Config_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Global_Product_Config_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "global_product_config" */
export type Global_Product_Config_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Global_Product_Config_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Product_Config_On_Conflict>;
};

/** aggregate avg on columns */
export type Global_Product_Config_Avg_Fields = {
  readonly __typename?: 'global_product_config_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "global_product_config" */
export type Global_Product_Config_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "global_product_config". All fields are combined with a logical 'AND'. */
export type Global_Product_Config_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Global_Product_Config_Bool_Exp>>;
  readonly _not?: InputMaybe<Global_Product_Config_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Global_Product_Config_Bool_Exp>>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly formula?: InputMaybe<String_Comparison_Exp>;
  readonly global_product?: InputMaybe<Global_Product_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly relative_month?: InputMaybe<Int_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "global_product_config" */
export type Global_Product_Config_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'global_product_config_id_key'
  /** unique or primary key constraint on columns "product", "relative_month" */
  | 'global_product_config_pkey';

/** input type for incrementing numeric columns in table "global_product_config" */
export type Global_Product_Config_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "global_product_config" */
export type Global_Product_Config_Insert_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly formula?: InputMaybe<Scalars['String']['input']>;
  readonly global_product?: InputMaybe<Global_Product_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Global_Product_Config_Max_Fields = {
  readonly __typename?: 'global_product_config_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly formula?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly relative_month?: Maybe<Scalars['Int']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "global_product_config" */
export type Global_Product_Config_Max_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly formula?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Global_Product_Config_Min_Fields = {
  readonly __typename?: 'global_product_config_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly formula?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly relative_month?: Maybe<Scalars['Int']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "global_product_config" */
export type Global_Product_Config_Min_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly formula?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "global_product_config" */
export type Global_Product_Config_Mutation_Response = {
  readonly __typename?: 'global_product_config_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Global_Product_Config>;
};

/** on_conflict condition type for table "global_product_config" */
export type Global_Product_Config_On_Conflict = {
  readonly constraint: Global_Product_Config_Constraint;
  readonly update_columns?: ReadonlyArray<Global_Product_Config_Update_Column>;
  readonly where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "global_product_config". */
export type Global_Product_Config_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly formula?: InputMaybe<Order_By>;
  readonly global_product?: InputMaybe<Global_Product_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: global_product_config */
export type Global_Product_Config_Pk_Columns_Input = {
  readonly product: Scalars['uuid']['input'];
  readonly relative_month: Scalars['Int']['input'];
};

/** select columns of table "global_product_config" */
export type Global_Product_Config_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'formula'
  /** column name */
  | 'id'
  /** column name */
  | 'product'
  /** column name */
  | 'relative_month'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "global_product_config" */
export type Global_Product_Config_Set_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly formula?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Global_Product_Config_Stddev_Fields = {
  readonly __typename?: 'global_product_config_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "global_product_config" */
export type Global_Product_Config_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Global_Product_Config_Stddev_Pop_Fields = {
  readonly __typename?: 'global_product_config_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "global_product_config" */
export type Global_Product_Config_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Global_Product_Config_Stddev_Samp_Fields = {
  readonly __typename?: 'global_product_config_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "global_product_config" */
export type Global_Product_Config_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "global_product_config" */
export type Global_Product_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Global_Product_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Product_Config_Stream_Cursor_Value_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly formula?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Global_Product_Config_Sum_Fields = {
  readonly __typename?: 'global_product_config_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly relative_month?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "global_product_config" */
export type Global_Product_Config_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** update columns of table "global_product_config" */
export type Global_Product_Config_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'formula'
  /** column name */
  | 'id'
  /** column name */
  | 'product'
  /** column name */
  | 'relative_month'
  /** column name */
  | 'updated_at';

export type Global_Product_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Global_Product_Config_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Global_Product_Config_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Global_Product_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Product_Config_Var_Pop_Fields = {
  readonly __typename?: 'global_product_config_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "global_product_config" */
export type Global_Product_Config_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Global_Product_Config_Var_Samp_Fields = {
  readonly __typename?: 'global_product_config_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "global_product_config" */
export type Global_Product_Config_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Global_Product_Config_Variance_Fields = {
  readonly __typename?: 'global_product_config_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "global_product_config" */
export type Global_Product_Config_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "global_product" */
export type Global_Product_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'global_product_pkey';

/** input type for incrementing numeric columns in table "global_product" */
export type Global_Product_Inc_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "global_product" */
export type Global_Product_Insert_Input = {
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Obj_Rel_Insert_Input>;
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Obj_Rel_Insert_Input>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly globalPackageByGlobalPackage?: InputMaybe<Global_Package_Obj_Rel_Insert_Input>;
  readonly global_instruments?: InputMaybe<Global_Instrument_Arr_Rel_Insert_Input>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly global_product_configs?: InputMaybe<Global_Product_Config_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly product_curve_type?: InputMaybe<Product_Curve_Type_Obj_Rel_Insert_Input>;
  readonly product_uom?: InputMaybe<Product_Uom_Obj_Rel_Insert_Input>;
  readonly uom?: InputMaybe<Product_Uom_Enum>;
};

/** aggregate max on columns */
export type Global_Product_Max_Fields = {
  readonly __typename?: 'global_product_max_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly global_package?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "global_product" */
export type Global_Product_Max_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Global_Product_Min_Fields = {
  readonly __typename?: 'global_product_min_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly global_package?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "global_product" */
export type Global_Product_Min_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "global_product" */
export type Global_Product_Mutation_Response = {
  readonly __typename?: 'global_product_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Global_Product>;
};

/** input type for inserting object relation for remote table "global_product" */
export type Global_Product_Obj_Rel_Insert_Input = {
  readonly data: Global_Product_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Global_Product_On_Conflict>;
};

/** on_conflict condition type for table "global_product" */
export type Global_Product_On_Conflict = {
  readonly constraint: Global_Product_Constraint;
  readonly update_columns?: ReadonlyArray<Global_Product_Update_Column>;
  readonly where?: InputMaybe<Global_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "global_product". */
export type Global_Product_Order_By = {
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly curve_type?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly globalPackageByGlobalPackage?: InputMaybe<Global_Package_Order_By>;
  readonly global_instruments_aggregate?: InputMaybe<Global_Instrument_Aggregate_Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
  readonly global_product_configs_aggregate?: InputMaybe<Global_Product_Config_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly product_curve_type?: InputMaybe<Product_Curve_Type_Order_By>;
  readonly product_uom?: InputMaybe<Product_Uom_Order_By>;
  readonly uom?: InputMaybe<Order_By>;
};

/** primary key columns input for table: global_product */
export type Global_Product_Pk_Columns_Input = {
  readonly id: Scalars['uuid']['input'];
};

/** select columns of table "global_product" */
export type Global_Product_Select_Column =
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'curve_type'
  /** column name */
  | 'description'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'global_package'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'uom';

/** input type for updating data in table "global_product" */
export type Global_Product_Set_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly uom?: InputMaybe<Product_Uom_Enum>;
};

/** aggregate stddev on columns */
export type Global_Product_Stddev_Fields = {
  readonly __typename?: 'global_product_stddev_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "global_product" */
export type Global_Product_Stddev_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Global_Product_Stddev_Pop_Fields = {
  readonly __typename?: 'global_product_stddev_pop_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "global_product" */
export type Global_Product_Stddev_Pop_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Global_Product_Stddev_Samp_Fields = {
  readonly __typename?: 'global_product_stddev_samp_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "global_product" */
export type Global_Product_Stddev_Samp_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "global_product" */
export type Global_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Global_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Product_Stream_Cursor_Value_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly global_package?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly uom?: InputMaybe<Product_Uom_Enum>;
};

/** aggregate sum on columns */
export type Global_Product_Sum_Fields = {
  readonly __typename?: 'global_product_sum_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly global_package?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "global_product" */
export type Global_Product_Sum_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** update columns of table "global_product" */
export type Global_Product_Update_Column =
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'curve_type'
  /** column name */
  | 'description'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'global_package'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'uom';

export type Global_Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Global_Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Global_Product_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Global_Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Product_Var_Pop_Fields = {
  readonly __typename?: 'global_product_var_pop_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "global_product" */
export type Global_Product_Var_Pop_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Global_Product_Var_Samp_Fields = {
  readonly __typename?: 'global_product_var_samp_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "global_product" */
export type Global_Product_Var_Samp_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Global_Product_Variance_Fields = {
  readonly __typename?: 'global_product_variance_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly global_package?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "global_product" */
export type Global_Product_Variance_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_package?: InputMaybe<Order_By>;
};

/** columns and relationships of "grid_charts" */
export type Grid_Charts = {
  readonly __typename?: 'grid_charts';
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly id: Scalars['String']['output'];
  readonly idx: Scalars['Int']['output'];
  readonly period?: Maybe<Scalars['Int']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly selector?: Maybe<Scalars['String']['output']>;
  readonly user_id: Scalars['String']['output'];
};

/** aggregated selection of "grid_charts" */
export type Grid_Charts_Aggregate = {
  readonly __typename?: 'grid_charts_aggregate';
  readonly aggregate?: Maybe<Grid_Charts_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Grid_Charts>;
};

/** aggregate fields of "grid_charts" */
export type Grid_Charts_Aggregate_Fields = {
  readonly __typename?: 'grid_charts_aggregate_fields';
  readonly avg?: Maybe<Grid_Charts_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Grid_Charts_Max_Fields>;
  readonly min?: Maybe<Grid_Charts_Min_Fields>;
  readonly stddev?: Maybe<Grid_Charts_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Grid_Charts_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Grid_Charts_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Grid_Charts_Sum_Fields>;
  readonly var_pop?: Maybe<Grid_Charts_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Grid_Charts_Var_Samp_Fields>;
  readonly variance?: Maybe<Grid_Charts_Variance_Fields>;
};


/** aggregate fields of "grid_charts" */
export type Grid_Charts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Grid_Charts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Grid_Charts_Avg_Fields = {
  readonly __typename?: 'grid_charts_avg_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "grid_charts". All fields are combined with a logical 'AND'. */
export type Grid_Charts_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Grid_Charts_Bool_Exp>>;
  readonly _not?: InputMaybe<Grid_Charts_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Grid_Charts_Bool_Exp>>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly idx?: InputMaybe<Int_Comparison_Exp>;
  readonly period?: InputMaybe<Int_Comparison_Exp>;
  readonly product_id?: InputMaybe<String_Comparison_Exp>;
  readonly selector?: InputMaybe<String_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "grid_charts" */
export type Grid_Charts_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'grid_charts_pkey';

/** input type for incrementing numeric columns in table "grid_charts" */
export type Grid_Charts_Inc_Input = {
  readonly idx?: InputMaybe<Scalars['Int']['input']>;
  readonly period?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "grid_charts" */
export type Grid_Charts_Insert_Input = {
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['Int']['input']>;
  readonly period?: InputMaybe<Scalars['Int']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly selector?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Grid_Charts_Max_Fields = {
  readonly __typename?: 'grid_charts_max_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['Int']['output']>;
  readonly period?: Maybe<Scalars['Int']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly selector?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Grid_Charts_Min_Fields = {
  readonly __typename?: 'grid_charts_min_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['Int']['output']>;
  readonly period?: Maybe<Scalars['Int']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly selector?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "grid_charts" */
export type Grid_Charts_Mutation_Response = {
  readonly __typename?: 'grid_charts_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Grid_Charts>;
};

/** on_conflict condition type for table "grid_charts" */
export type Grid_Charts_On_Conflict = {
  readonly constraint: Grid_Charts_Constraint;
  readonly update_columns?: ReadonlyArray<Grid_Charts_Update_Column>;
  readonly where?: InputMaybe<Grid_Charts_Bool_Exp>;
};

/** Ordering options when selecting data from "grid_charts". */
export type Grid_Charts_Order_By = {
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly idx?: InputMaybe<Order_By>;
  readonly period?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly selector?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grid_charts */
export type Grid_Charts_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "grid_charts" */
export type Grid_Charts_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'period'
  /** column name */
  | 'product_id'
  /** column name */
  | 'selector'
  /** column name */
  | 'user_id';

/** input type for updating data in table "grid_charts" */
export type Grid_Charts_Set_Input = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['Int']['input']>;
  readonly period?: InputMaybe<Scalars['Int']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly selector?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Grid_Charts_Stddev_Fields = {
  readonly __typename?: 'grid_charts_stddev_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Grid_Charts_Stddev_Pop_Fields = {
  readonly __typename?: 'grid_charts_stddev_pop_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Grid_Charts_Stddev_Samp_Fields = {
  readonly __typename?: 'grid_charts_stddev_samp_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "grid_charts" */
export type Grid_Charts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Grid_Charts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grid_Charts_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['Int']['input']>;
  readonly period?: InputMaybe<Scalars['Int']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly selector?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Grid_Charts_Sum_Fields = {
  readonly __typename?: 'grid_charts_sum_fields';
  readonly idx?: Maybe<Scalars['Int']['output']>;
  readonly period?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "grid_charts" */
export type Grid_Charts_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'period'
  /** column name */
  | 'product_id'
  /** column name */
  | 'selector'
  /** column name */
  | 'user_id';

export type Grid_Charts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Grid_Charts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Grid_Charts_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Grid_Charts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grid_Charts_Var_Pop_Fields = {
  readonly __typename?: 'grid_charts_var_pop_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Grid_Charts_Var_Samp_Fields = {
  readonly __typename?: 'grid_charts_var_samp_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Grid_Charts_Variance_Fields = {
  readonly __typename?: 'grid_charts_variance_fields';
  readonly idx?: Maybe<Scalars['Float']['output']>;
  readonly period?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "grid_insert_position_enum". All fields are combined with logical 'AND'. */
export type Grid_Insert_Position_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly _gt?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly _gte?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['grid_insert_position_enum']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly _lte?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly _neq?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['grid_insert_position_enum']['input']>>;
};

/** columns and relationships of "grid_settings" */
export type Grid_Settings = {
  readonly __typename?: 'grid_settings';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Int']['output']>;
  readonly adhoc_spreads_switch?: Maybe<Scalars['Boolean']['output']>;
  readonly alternating_row_colours?: Maybe<Scalars['Boolean']['output']>;
  readonly anomaly_sensitivity_level: Scalars['numeric']['output'];
  readonly broadcast_colour?: Maybe<Scalars['String']['output']>;
  readonly cal_current?: Maybe<Scalars['Boolean']['output']>;
  readonly cal_switch?: Maybe<Scalars['Boolean']['output']>;
  readonly cals?: Maybe<Scalars['Int']['output']>;
  readonly commodity_group?: Maybe<Scalars['Boolean']['output']>;
  readonly commodity_parent_group?: Maybe<Scalars['Boolean']['output']>;
  readonly created_at: Scalars['timestamptz']['output'];
  readonly default_curve_column_width: Scalars['Int']['output'];
  readonly description?: Maybe<Scalars['Boolean']['output']>;
  readonly detailed_tooltip?: Maybe<Scalars['Boolean']['output']>;
  readonly display_name_map?: Maybe<Scalars['jsonb']['output']>;
  readonly display_negative_bracket?: Maybe<Scalars['Boolean']['output']>;
  readonly display_negative_color?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_anomaly_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_clear_multiple_values_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_clear_single_value_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_drag_multiple_values_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_paste_multiple_values_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_remove_curve_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_remove_multiple_curves_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly dont_show_remove_page_confirmation_dialog?: Maybe<Scalars['Boolean']['output']>;
  readonly enable_full_month_row_feature?: Maybe<Scalars['Boolean']['output']>;
  readonly enabled_snapshot_warnings?: Maybe<Scalars['jsonb']['output']>;
  readonly eod_colour?: Maybe<Scalars['String']['output']>;
  readonly eod_date?: Maybe<Scalars['String']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Int']['output']>;
  readonly field_name?: Maybe<Scalars['Boolean']['output']>;
  readonly flash_cell_updates?: Maybe<Scalars['Boolean']['output']>;
  readonly geographical_region?: Maybe<Scalars['Boolean']['output']>;
  readonly global_colour?: Maybe<Scalars['String']['output']>;
  readonly grid_scratchpad_switch?: Maybe<Scalars['Boolean']['output']>;
  readonly header_column_colour?: Maybe<Scalars['String']['output']>;
  readonly hide_broadcast?: Maybe<Scalars['Boolean']['output']>;
  readonly hide_eod?: Maybe<Scalars['Boolean']['output']>;
  readonly hide_global?: Maybe<Scalars['Boolean']['output']>;
  readonly hide_private?: Maybe<Scalars['Boolean']['output']>;
  readonly hide_status_row?: Maybe<Scalars['Boolean']['output']>;
  readonly hlv_current?: Maybe<Scalars['Boolean']['output']>;
  readonly hlv_switch?: Maybe<Scalars['Boolean']['output']>;
  readonly hlvs?: Maybe<Scalars['Int']['output']>;
  readonly hybrid_colour?: Maybe<Scalars['String']['output']>;
  readonly increment_map?: Maybe<Scalars['jsonb']['output']>;
  readonly indicator_colour?: Maybe<Scalars['String']['output']>;
  readonly insert_column_position: Scalars['grid_insert_position_enum']['output'];
  readonly insert_page_position: Scalars['grid_insert_position_enum']['output'];
  readonly listen_colour?: Maybe<Scalars['String']['output']>;
  readonly local_colour?: Maybe<Scalars['String']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Int']['output']>;
  readonly months?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Boolean']['output']>;
  readonly qtr_current?: Maybe<Scalars['Boolean']['output']>;
  readonly qtr_switch?: Maybe<Scalars['Boolean']['output']>;
  readonly qtrs?: Maybe<Scalars['Int']['output']>;
  readonly quarter_borders?: Maybe<Scalars['Boolean']['output']>;
  readonly range_summary_calc: Scalars['range_summary_calc_enum']['output'];
  readonly range_summary_dp: Scalars['Int']['output'];
  readonly saved_colours?: Maybe<Scalars['jsonb']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Int']['output']>;
  readonly season_current?: Maybe<Scalars['Boolean']['output']>;
  readonly season_switch?: Maybe<Scalars['Boolean']['output']>;
  readonly seasons?: Maybe<Scalars['Int']['output']>;
  readonly show_world_clock: Scalars['Boolean']['output'];
  readonly sound?: Maybe<Scalars['Boolean']['output']>;
  readonly source?: Maybe<Scalars['Boolean']['output']>;
  readonly source_colour_map?: Maybe<Scalars['jsonb']['output']>;
  readonly status_map?: Maybe<Scalars['jsonb']['output']>;
  readonly subheader_column_colour?: Maybe<Scalars['String']['output']>;
  readonly theme?: Maybe<Scalars['theme_enum']['output']>;
  readonly updated_at: Scalars['timestamptz']['output'];
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "grid_settings" */
export type Grid_SettingsDisplay_Name_MapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "grid_settings" */
export type Grid_SettingsEnabled_Snapshot_WarningsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "grid_settings" */
export type Grid_SettingsIncrement_MapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "grid_settings" */
export type Grid_SettingsSaved_ColoursArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "grid_settings" */
export type Grid_SettingsSource_Colour_MapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "grid_settings" */
export type Grid_SettingsStatus_MapArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "grid_settings" */
export type Grid_Settings_Aggregate = {
  readonly __typename?: 'grid_settings_aggregate';
  readonly aggregate?: Maybe<Grid_Settings_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Grid_Settings>;
};

/** aggregate fields of "grid_settings" */
export type Grid_Settings_Aggregate_Fields = {
  readonly __typename?: 'grid_settings_aggregate_fields';
  readonly avg?: Maybe<Grid_Settings_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Grid_Settings_Max_Fields>;
  readonly min?: Maybe<Grid_Settings_Min_Fields>;
  readonly stddev?: Maybe<Grid_Settings_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Grid_Settings_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Grid_Settings_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Grid_Settings_Sum_Fields>;
  readonly var_pop?: Maybe<Grid_Settings_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Grid_Settings_Var_Samp_Fields>;
  readonly variance?: Maybe<Grid_Settings_Variance_Fields>;
};


/** aggregate fields of "grid_settings" */
export type Grid_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Grid_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Grid_Settings_Append_Input = {
  readonly display_name_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly increment_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['jsonb']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly status_map?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Grid_Settings_Avg_Fields = {
  readonly __typename?: 'grid_settings_avg_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "grid_settings". All fields are combined with a logical 'AND'. */
export type Grid_Settings_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Grid_Settings_Bool_Exp>>;
  readonly _not?: InputMaybe<Grid_Settings_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Grid_Settings_Bool_Exp>>;
  readonly adhoc_spreads_rows?: InputMaybe<Int_Comparison_Exp>;
  readonly adhoc_spreads_switch?: InputMaybe<Boolean_Comparison_Exp>;
  readonly alternating_row_colours?: InputMaybe<Boolean_Comparison_Exp>;
  readonly anomaly_sensitivity_level?: InputMaybe<Numeric_Comparison_Exp>;
  readonly broadcast_colour?: InputMaybe<String_Comparison_Exp>;
  readonly cal_current?: InputMaybe<Boolean_Comparison_Exp>;
  readonly cal_switch?: InputMaybe<Boolean_Comparison_Exp>;
  readonly cals?: InputMaybe<Int_Comparison_Exp>;
  readonly commodity_group?: InputMaybe<Boolean_Comparison_Exp>;
  readonly commodity_parent_group?: InputMaybe<Boolean_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly default_curve_column_width?: InputMaybe<Int_Comparison_Exp>;
  readonly description?: InputMaybe<Boolean_Comparison_Exp>;
  readonly detailed_tooltip?: InputMaybe<Boolean_Comparison_Exp>;
  readonly display_name_map?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly display_negative_bracket?: InputMaybe<Boolean_Comparison_Exp>;
  readonly display_negative_color?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_anomaly_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_clear_multiple_values_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_clear_single_value_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_drag_multiple_values_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_paste_multiple_values_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_remove_curve_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_remove_multiple_curves_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly dont_show_remove_page_confirmation_dialog?: InputMaybe<Boolean_Comparison_Exp>;
  readonly enable_full_month_row_feature?: InputMaybe<Boolean_Comparison_Exp>;
  readonly enabled_snapshot_warnings?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly eod_colour?: InputMaybe<String_Comparison_Exp>;
  readonly eod_date?: InputMaybe<String_Comparison_Exp>;
  readonly extra_header_height?: InputMaybe<Int_Comparison_Exp>;
  readonly field_name?: InputMaybe<Boolean_Comparison_Exp>;
  readonly flash_cell_updates?: InputMaybe<Boolean_Comparison_Exp>;
  readonly geographical_region?: InputMaybe<Boolean_Comparison_Exp>;
  readonly global_colour?: InputMaybe<String_Comparison_Exp>;
  readonly grid_scratchpad_switch?: InputMaybe<Boolean_Comparison_Exp>;
  readonly header_column_colour?: InputMaybe<String_Comparison_Exp>;
  readonly hide_broadcast?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hide_eod?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hide_global?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hide_private?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hide_status_row?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hlv_current?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hlv_switch?: InputMaybe<Boolean_Comparison_Exp>;
  readonly hlvs?: InputMaybe<Int_Comparison_Exp>;
  readonly hybrid_colour?: InputMaybe<String_Comparison_Exp>;
  readonly increment_map?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly indicator_colour?: InputMaybe<String_Comparison_Exp>;
  readonly insert_column_position?: InputMaybe<Grid_Insert_Position_Enum_Comparison_Exp>;
  readonly insert_page_position?: InputMaybe<Grid_Insert_Position_Enum_Comparison_Exp>;
  readonly listen_colour?: InputMaybe<String_Comparison_Exp>;
  readonly local_colour?: InputMaybe<String_Comparison_Exp>;
  readonly main_month_column_width?: InputMaybe<Int_Comparison_Exp>;
  readonly months?: InputMaybe<Int_Comparison_Exp>;
  readonly package?: InputMaybe<Boolean_Comparison_Exp>;
  readonly qtr_current?: InputMaybe<Boolean_Comparison_Exp>;
  readonly qtr_switch?: InputMaybe<Boolean_Comparison_Exp>;
  readonly qtrs?: InputMaybe<Int_Comparison_Exp>;
  readonly quarter_borders?: InputMaybe<Boolean_Comparison_Exp>;
  readonly range_summary_calc?: InputMaybe<Range_Summary_Calc_Enum_Comparison_Exp>;
  readonly range_summary_dp?: InputMaybe<Int_Comparison_Exp>;
  readonly saved_colours?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly scratchpad_max_cols?: InputMaybe<Int_Comparison_Exp>;
  readonly scratchpad_max_rows?: InputMaybe<Int_Comparison_Exp>;
  readonly season_current?: InputMaybe<Boolean_Comparison_Exp>;
  readonly season_switch?: InputMaybe<Boolean_Comparison_Exp>;
  readonly seasons?: InputMaybe<Int_Comparison_Exp>;
  readonly show_world_clock?: InputMaybe<Boolean_Comparison_Exp>;
  readonly sound?: InputMaybe<Boolean_Comparison_Exp>;
  readonly source?: InputMaybe<Boolean_Comparison_Exp>;
  readonly source_colour_map?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly status_map?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly subheader_column_colour?: InputMaybe<String_Comparison_Exp>;
  readonly theme?: InputMaybe<Theme_Enum_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "grid_settings" */
export type Grid_Settings_Constraint =
  /** unique or primary key constraint on columns "user_id" */
  | 'grid_settings_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Grid_Settings_Delete_At_Path_Input = {
  readonly display_name_map?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly enabled_snapshot_warnings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly increment_map?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly saved_colours?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly source_colour_map?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly status_map?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Grid_Settings_Delete_Elem_Input = {
  readonly display_name_map?: InputMaybe<Scalars['Int']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['Int']['input']>;
  readonly increment_map?: InputMaybe<Scalars['Int']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['Int']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['Int']['input']>;
  readonly status_map?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Grid_Settings_Delete_Key_Input = {
  readonly display_name_map?: InputMaybe<Scalars['String']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['String']['input']>;
  readonly increment_map?: InputMaybe<Scalars['String']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['String']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['String']['input']>;
  readonly status_map?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "grid_settings" */
export type Grid_Settings_Inc_Input = {
  readonly adhoc_spreads_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly anomaly_sensitivity_level?: InputMaybe<Scalars['numeric']['input']>;
  readonly cals?: InputMaybe<Scalars['Int']['input']>;
  readonly default_curve_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Int']['input']>;
  readonly hlvs?: InputMaybe<Scalars['Int']['input']>;
  readonly main_month_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly months?: InputMaybe<Scalars['Int']['input']>;
  readonly qtrs?: InputMaybe<Scalars['Int']['input']>;
  readonly range_summary_dp?: InputMaybe<Scalars['Int']['input']>;
  readonly scratchpad_max_cols?: InputMaybe<Scalars['Int']['input']>;
  readonly scratchpad_max_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly seasons?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "grid_settings" */
export type Grid_Settings_Insert_Input = {
  readonly adhoc_spreads_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly adhoc_spreads_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alternating_row_colours?: InputMaybe<Scalars['Boolean']['input']>;
  readonly anomaly_sensitivity_level?: InputMaybe<Scalars['numeric']['input']>;
  readonly broadcast_colour?: InputMaybe<Scalars['String']['input']>;
  readonly cal_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cal_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cals?: InputMaybe<Scalars['Int']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly commodity_parent_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly default_curve_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly description?: InputMaybe<Scalars['Boolean']['input']>;
  readonly detailed_tooltip?: InputMaybe<Scalars['Boolean']['input']>;
  readonly display_name_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly display_negative_bracket?: InputMaybe<Scalars['Boolean']['input']>;
  readonly display_negative_color?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_anomaly_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_clear_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_clear_single_value_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_drag_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_paste_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_curve_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_multiple_curves_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_page_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enable_full_month_row_feature?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly eod_colour?: InputMaybe<Scalars['String']['input']>;
  readonly eod_date?: InputMaybe<Scalars['String']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Int']['input']>;
  readonly field_name?: InputMaybe<Scalars['Boolean']['input']>;
  readonly flash_cell_updates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Boolean']['input']>;
  readonly global_colour?: InputMaybe<Scalars['String']['input']>;
  readonly grid_scratchpad_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly header_column_colour?: InputMaybe<Scalars['String']['input']>;
  readonly hide_broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_eod?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_private?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_status_row?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlv_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlv_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlvs?: InputMaybe<Scalars['Int']['input']>;
  readonly hybrid_colour?: InputMaybe<Scalars['String']['input']>;
  readonly increment_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly indicator_colour?: InputMaybe<Scalars['String']['input']>;
  readonly insert_column_position?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly insert_page_position?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly listen_colour?: InputMaybe<Scalars['String']['input']>;
  readonly local_colour?: InputMaybe<Scalars['String']['input']>;
  readonly main_month_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly months?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtr_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtr_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtrs?: InputMaybe<Scalars['Int']['input']>;
  readonly quarter_borders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly range_summary_calc?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly range_summary_dp?: InputMaybe<Scalars['Int']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['jsonb']['input']>;
  readonly scratchpad_max_cols?: InputMaybe<Scalars['Int']['input']>;
  readonly scratchpad_max_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly season_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly season_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly seasons?: InputMaybe<Scalars['Int']['input']>;
  readonly show_world_clock?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sound?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly status_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly subheader_column_colour?: InputMaybe<Scalars['String']['input']>;
  readonly theme?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Grid_Settings_Max_Fields = {
  readonly __typename?: 'grid_settings_max_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Int']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['numeric']['output']>;
  readonly broadcast_colour?: Maybe<Scalars['String']['output']>;
  readonly cals?: Maybe<Scalars['Int']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Int']['output']>;
  readonly eod_colour?: Maybe<Scalars['String']['output']>;
  readonly eod_date?: Maybe<Scalars['String']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Int']['output']>;
  readonly global_colour?: Maybe<Scalars['String']['output']>;
  readonly header_column_colour?: Maybe<Scalars['String']['output']>;
  readonly hlvs?: Maybe<Scalars['Int']['output']>;
  readonly hybrid_colour?: Maybe<Scalars['String']['output']>;
  readonly indicator_colour?: Maybe<Scalars['String']['output']>;
  readonly insert_column_position?: Maybe<Scalars['grid_insert_position_enum']['output']>;
  readonly insert_page_position?: Maybe<Scalars['grid_insert_position_enum']['output']>;
  readonly listen_colour?: Maybe<Scalars['String']['output']>;
  readonly local_colour?: Maybe<Scalars['String']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Int']['output']>;
  readonly months?: Maybe<Scalars['Int']['output']>;
  readonly qtrs?: Maybe<Scalars['Int']['output']>;
  readonly range_summary_calc?: Maybe<Scalars['range_summary_calc_enum']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Int']['output']>;
  readonly seasons?: Maybe<Scalars['Int']['output']>;
  readonly subheader_column_colour?: Maybe<Scalars['String']['output']>;
  readonly theme?: Maybe<Scalars['theme_enum']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Grid_Settings_Min_Fields = {
  readonly __typename?: 'grid_settings_min_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Int']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['numeric']['output']>;
  readonly broadcast_colour?: Maybe<Scalars['String']['output']>;
  readonly cals?: Maybe<Scalars['Int']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Int']['output']>;
  readonly eod_colour?: Maybe<Scalars['String']['output']>;
  readonly eod_date?: Maybe<Scalars['String']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Int']['output']>;
  readonly global_colour?: Maybe<Scalars['String']['output']>;
  readonly header_column_colour?: Maybe<Scalars['String']['output']>;
  readonly hlvs?: Maybe<Scalars['Int']['output']>;
  readonly hybrid_colour?: Maybe<Scalars['String']['output']>;
  readonly indicator_colour?: Maybe<Scalars['String']['output']>;
  readonly insert_column_position?: Maybe<Scalars['grid_insert_position_enum']['output']>;
  readonly insert_page_position?: Maybe<Scalars['grid_insert_position_enum']['output']>;
  readonly listen_colour?: Maybe<Scalars['String']['output']>;
  readonly local_colour?: Maybe<Scalars['String']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Int']['output']>;
  readonly months?: Maybe<Scalars['Int']['output']>;
  readonly qtrs?: Maybe<Scalars['Int']['output']>;
  readonly range_summary_calc?: Maybe<Scalars['range_summary_calc_enum']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Int']['output']>;
  readonly seasons?: Maybe<Scalars['Int']['output']>;
  readonly subheader_column_colour?: Maybe<Scalars['String']['output']>;
  readonly theme?: Maybe<Scalars['theme_enum']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "grid_settings" */
export type Grid_Settings_Mutation_Response = {
  readonly __typename?: 'grid_settings_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Grid_Settings>;
};

/** on_conflict condition type for table "grid_settings" */
export type Grid_Settings_On_Conflict = {
  readonly constraint: Grid_Settings_Constraint;
  readonly update_columns?: ReadonlyArray<Grid_Settings_Update_Column>;
  readonly where?: InputMaybe<Grid_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "grid_settings". */
export type Grid_Settings_Order_By = {
  readonly adhoc_spreads_rows?: InputMaybe<Order_By>;
  readonly adhoc_spreads_switch?: InputMaybe<Order_By>;
  readonly alternating_row_colours?: InputMaybe<Order_By>;
  readonly anomaly_sensitivity_level?: InputMaybe<Order_By>;
  readonly broadcast_colour?: InputMaybe<Order_By>;
  readonly cal_current?: InputMaybe<Order_By>;
  readonly cal_switch?: InputMaybe<Order_By>;
  readonly cals?: InputMaybe<Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly commodity_parent_group?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly default_curve_column_width?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly detailed_tooltip?: InputMaybe<Order_By>;
  readonly display_name_map?: InputMaybe<Order_By>;
  readonly display_negative_bracket?: InputMaybe<Order_By>;
  readonly display_negative_color?: InputMaybe<Order_By>;
  readonly dont_show_anomaly_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_clear_multiple_values_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_clear_single_value_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_drag_multiple_values_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_paste_multiple_values_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_remove_curve_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_remove_multiple_curves_confirmation_dialog?: InputMaybe<Order_By>;
  readonly dont_show_remove_page_confirmation_dialog?: InputMaybe<Order_By>;
  readonly enable_full_month_row_feature?: InputMaybe<Order_By>;
  readonly enabled_snapshot_warnings?: InputMaybe<Order_By>;
  readonly eod_colour?: InputMaybe<Order_By>;
  readonly eod_date?: InputMaybe<Order_By>;
  readonly extra_header_height?: InputMaybe<Order_By>;
  readonly field_name?: InputMaybe<Order_By>;
  readonly flash_cell_updates?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly global_colour?: InputMaybe<Order_By>;
  readonly grid_scratchpad_switch?: InputMaybe<Order_By>;
  readonly header_column_colour?: InputMaybe<Order_By>;
  readonly hide_broadcast?: InputMaybe<Order_By>;
  readonly hide_eod?: InputMaybe<Order_By>;
  readonly hide_global?: InputMaybe<Order_By>;
  readonly hide_private?: InputMaybe<Order_By>;
  readonly hide_status_row?: InputMaybe<Order_By>;
  readonly hlv_current?: InputMaybe<Order_By>;
  readonly hlv_switch?: InputMaybe<Order_By>;
  readonly hlvs?: InputMaybe<Order_By>;
  readonly hybrid_colour?: InputMaybe<Order_By>;
  readonly increment_map?: InputMaybe<Order_By>;
  readonly indicator_colour?: InputMaybe<Order_By>;
  readonly insert_column_position?: InputMaybe<Order_By>;
  readonly insert_page_position?: InputMaybe<Order_By>;
  readonly listen_colour?: InputMaybe<Order_By>;
  readonly local_colour?: InputMaybe<Order_By>;
  readonly main_month_column_width?: InputMaybe<Order_By>;
  readonly months?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly qtr_current?: InputMaybe<Order_By>;
  readonly qtr_switch?: InputMaybe<Order_By>;
  readonly qtrs?: InputMaybe<Order_By>;
  readonly quarter_borders?: InputMaybe<Order_By>;
  readonly range_summary_calc?: InputMaybe<Order_By>;
  readonly range_summary_dp?: InputMaybe<Order_By>;
  readonly saved_colours?: InputMaybe<Order_By>;
  readonly scratchpad_max_cols?: InputMaybe<Order_By>;
  readonly scratchpad_max_rows?: InputMaybe<Order_By>;
  readonly season_current?: InputMaybe<Order_By>;
  readonly season_switch?: InputMaybe<Order_By>;
  readonly seasons?: InputMaybe<Order_By>;
  readonly show_world_clock?: InputMaybe<Order_By>;
  readonly sound?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly source_colour_map?: InputMaybe<Order_By>;
  readonly status_map?: InputMaybe<Order_By>;
  readonly subheader_column_colour?: InputMaybe<Order_By>;
  readonly theme?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grid_settings */
export type Grid_Settings_Pk_Columns_Input = {
  readonly user_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Grid_Settings_Prepend_Input = {
  readonly display_name_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly increment_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['jsonb']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly status_map?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "grid_settings" */
export type Grid_Settings_Select_Column =
  /** column name */
  | 'adhoc_spreads_rows'
  /** column name */
  | 'adhoc_spreads_switch'
  /** column name */
  | 'alternating_row_colours'
  /** column name */
  | 'anomaly_sensitivity_level'
  /** column name */
  | 'broadcast_colour'
  /** column name */
  | 'cal_current'
  /** column name */
  | 'cal_switch'
  /** column name */
  | 'cals'
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'commodity_parent_group'
  /** column name */
  | 'created_at'
  /** column name */
  | 'default_curve_column_width'
  /** column name */
  | 'description'
  /** column name */
  | 'detailed_tooltip'
  /** column name */
  | 'display_name_map'
  /** column name */
  | 'display_negative_bracket'
  /** column name */
  | 'display_negative_color'
  /** column name */
  | 'dont_show_anomaly_confirmation_dialog'
  /** column name */
  | 'dont_show_clear_multiple_values_confirmation_dialog'
  /** column name */
  | 'dont_show_clear_single_value_confirmation_dialog'
  /** column name */
  | 'dont_show_drag_multiple_values_confirmation_dialog'
  /** column name */
  | 'dont_show_paste_multiple_values_confirmation_dialog'
  /** column name */
  | 'dont_show_remove_curve_confirmation_dialog'
  /** column name */
  | 'dont_show_remove_multiple_curves_confirmation_dialog'
  /** column name */
  | 'dont_show_remove_page_confirmation_dialog'
  /** column name */
  | 'enable_full_month_row_feature'
  /** column name */
  | 'enabled_snapshot_warnings'
  /** column name */
  | 'eod_colour'
  /** column name */
  | 'eod_date'
  /** column name */
  | 'extra_header_height'
  /** column name */
  | 'field_name'
  /** column name */
  | 'flash_cell_updates'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'global_colour'
  /** column name */
  | 'grid_scratchpad_switch'
  /** column name */
  | 'header_column_colour'
  /** column name */
  | 'hide_broadcast'
  /** column name */
  | 'hide_eod'
  /** column name */
  | 'hide_global'
  /** column name */
  | 'hide_private'
  /** column name */
  | 'hide_status_row'
  /** column name */
  | 'hlv_current'
  /** column name */
  | 'hlv_switch'
  /** column name */
  | 'hlvs'
  /** column name */
  | 'hybrid_colour'
  /** column name */
  | 'increment_map'
  /** column name */
  | 'indicator_colour'
  /** column name */
  | 'insert_column_position'
  /** column name */
  | 'insert_page_position'
  /** column name */
  | 'listen_colour'
  /** column name */
  | 'local_colour'
  /** column name */
  | 'main_month_column_width'
  /** column name */
  | 'months'
  /** column name */
  | 'package'
  /** column name */
  | 'qtr_current'
  /** column name */
  | 'qtr_switch'
  /** column name */
  | 'qtrs'
  /** column name */
  | 'quarter_borders'
  /** column name */
  | 'range_summary_calc'
  /** column name */
  | 'range_summary_dp'
  /** column name */
  | 'saved_colours'
  /** column name */
  | 'scratchpad_max_cols'
  /** column name */
  | 'scratchpad_max_rows'
  /** column name */
  | 'season_current'
  /** column name */
  | 'season_switch'
  /** column name */
  | 'seasons'
  /** column name */
  | 'show_world_clock'
  /** column name */
  | 'sound'
  /** column name */
  | 'source'
  /** column name */
  | 'source_colour_map'
  /** column name */
  | 'status_map'
  /** column name */
  | 'subheader_column_colour'
  /** column name */
  | 'theme'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "grid_settings" */
export type Grid_Settings_Set_Input = {
  readonly adhoc_spreads_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly adhoc_spreads_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alternating_row_colours?: InputMaybe<Scalars['Boolean']['input']>;
  readonly anomaly_sensitivity_level?: InputMaybe<Scalars['numeric']['input']>;
  readonly broadcast_colour?: InputMaybe<Scalars['String']['input']>;
  readonly cal_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cal_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cals?: InputMaybe<Scalars['Int']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly commodity_parent_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly default_curve_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly description?: InputMaybe<Scalars['Boolean']['input']>;
  readonly detailed_tooltip?: InputMaybe<Scalars['Boolean']['input']>;
  readonly display_name_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly display_negative_bracket?: InputMaybe<Scalars['Boolean']['input']>;
  readonly display_negative_color?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_anomaly_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_clear_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_clear_single_value_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_drag_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_paste_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_curve_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_multiple_curves_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_page_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enable_full_month_row_feature?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly eod_colour?: InputMaybe<Scalars['String']['input']>;
  readonly eod_date?: InputMaybe<Scalars['String']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Int']['input']>;
  readonly field_name?: InputMaybe<Scalars['Boolean']['input']>;
  readonly flash_cell_updates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Boolean']['input']>;
  readonly global_colour?: InputMaybe<Scalars['String']['input']>;
  readonly grid_scratchpad_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly header_column_colour?: InputMaybe<Scalars['String']['input']>;
  readonly hide_broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_eod?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_private?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_status_row?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlv_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlv_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlvs?: InputMaybe<Scalars['Int']['input']>;
  readonly hybrid_colour?: InputMaybe<Scalars['String']['input']>;
  readonly increment_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly indicator_colour?: InputMaybe<Scalars['String']['input']>;
  readonly insert_column_position?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly insert_page_position?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly listen_colour?: InputMaybe<Scalars['String']['input']>;
  readonly local_colour?: InputMaybe<Scalars['String']['input']>;
  readonly main_month_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly months?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtr_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtr_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtrs?: InputMaybe<Scalars['Int']['input']>;
  readonly quarter_borders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly range_summary_calc?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly range_summary_dp?: InputMaybe<Scalars['Int']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['jsonb']['input']>;
  readonly scratchpad_max_cols?: InputMaybe<Scalars['Int']['input']>;
  readonly scratchpad_max_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly season_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly season_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly seasons?: InputMaybe<Scalars['Int']['input']>;
  readonly show_world_clock?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sound?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly status_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly subheader_column_colour?: InputMaybe<Scalars['String']['input']>;
  readonly theme?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Grid_Settings_Stddev_Fields = {
  readonly __typename?: 'grid_settings_stddev_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Grid_Settings_Stddev_Pop_Fields = {
  readonly __typename?: 'grid_settings_stddev_pop_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Grid_Settings_Stddev_Samp_Fields = {
  readonly __typename?: 'grid_settings_stddev_samp_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "grid_settings" */
export type Grid_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Grid_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grid_Settings_Stream_Cursor_Value_Input = {
  readonly adhoc_spreads_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly adhoc_spreads_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alternating_row_colours?: InputMaybe<Scalars['Boolean']['input']>;
  readonly anomaly_sensitivity_level?: InputMaybe<Scalars['numeric']['input']>;
  readonly broadcast_colour?: InputMaybe<Scalars['String']['input']>;
  readonly cal_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cal_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cals?: InputMaybe<Scalars['Int']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly commodity_parent_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly default_curve_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly description?: InputMaybe<Scalars['Boolean']['input']>;
  readonly detailed_tooltip?: InputMaybe<Scalars['Boolean']['input']>;
  readonly display_name_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly display_negative_bracket?: InputMaybe<Scalars['Boolean']['input']>;
  readonly display_negative_color?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_anomaly_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_clear_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_clear_single_value_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_drag_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_paste_multiple_values_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_curve_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_multiple_curves_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dont_show_remove_page_confirmation_dialog?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enable_full_month_row_feature?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabled_snapshot_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly eod_colour?: InputMaybe<Scalars['String']['input']>;
  readonly eod_date?: InputMaybe<Scalars['String']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Int']['input']>;
  readonly field_name?: InputMaybe<Scalars['Boolean']['input']>;
  readonly flash_cell_updates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Boolean']['input']>;
  readonly global_colour?: InputMaybe<Scalars['String']['input']>;
  readonly grid_scratchpad_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly header_column_colour?: InputMaybe<Scalars['String']['input']>;
  readonly hide_broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_eod?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_private?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hide_status_row?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlv_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlv_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hlvs?: InputMaybe<Scalars['Int']['input']>;
  readonly hybrid_colour?: InputMaybe<Scalars['String']['input']>;
  readonly increment_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly indicator_colour?: InputMaybe<Scalars['String']['input']>;
  readonly insert_column_position?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly insert_page_position?: InputMaybe<Scalars['grid_insert_position_enum']['input']>;
  readonly listen_colour?: InputMaybe<Scalars['String']['input']>;
  readonly local_colour?: InputMaybe<Scalars['String']['input']>;
  readonly main_month_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly months?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtr_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtr_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly qtrs?: InputMaybe<Scalars['Int']['input']>;
  readonly quarter_borders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly range_summary_calc?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly range_summary_dp?: InputMaybe<Scalars['Int']['input']>;
  readonly saved_colours?: InputMaybe<Scalars['jsonb']['input']>;
  readonly scratchpad_max_cols?: InputMaybe<Scalars['Int']['input']>;
  readonly scratchpad_max_rows?: InputMaybe<Scalars['Int']['input']>;
  readonly season_current?: InputMaybe<Scalars['Boolean']['input']>;
  readonly season_switch?: InputMaybe<Scalars['Boolean']['input']>;
  readonly seasons?: InputMaybe<Scalars['Int']['input']>;
  readonly show_world_clock?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sound?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source_colour_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly status_map?: InputMaybe<Scalars['jsonb']['input']>;
  readonly subheader_column_colour?: InputMaybe<Scalars['String']['input']>;
  readonly theme?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Grid_Settings_Sum_Fields = {
  readonly __typename?: 'grid_settings_sum_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Int']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['numeric']['output']>;
  readonly cals?: Maybe<Scalars['Int']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Int']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Int']['output']>;
  readonly hlvs?: Maybe<Scalars['Int']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Int']['output']>;
  readonly months?: Maybe<Scalars['Int']['output']>;
  readonly qtrs?: Maybe<Scalars['Int']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Int']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Int']['output']>;
  readonly seasons?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "grid_settings" */
export type Grid_Settings_Update_Column =
  /** column name */
  | 'adhoc_spreads_rows'
  /** column name */
  | 'adhoc_spreads_switch'
  /** column name */
  | 'alternating_row_colours'
  /** column name */
  | 'anomaly_sensitivity_level'
  /** column name */
  | 'broadcast_colour'
  /** column name */
  | 'cal_current'
  /** column name */
  | 'cal_switch'
  /** column name */
  | 'cals'
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'commodity_parent_group'
  /** column name */
  | 'created_at'
  /** column name */
  | 'default_curve_column_width'
  /** column name */
  | 'description'
  /** column name */
  | 'detailed_tooltip'
  /** column name */
  | 'display_name_map'
  /** column name */
  | 'display_negative_bracket'
  /** column name */
  | 'display_negative_color'
  /** column name */
  | 'dont_show_anomaly_confirmation_dialog'
  /** column name */
  | 'dont_show_clear_multiple_values_confirmation_dialog'
  /** column name */
  | 'dont_show_clear_single_value_confirmation_dialog'
  /** column name */
  | 'dont_show_drag_multiple_values_confirmation_dialog'
  /** column name */
  | 'dont_show_paste_multiple_values_confirmation_dialog'
  /** column name */
  | 'dont_show_remove_curve_confirmation_dialog'
  /** column name */
  | 'dont_show_remove_multiple_curves_confirmation_dialog'
  /** column name */
  | 'dont_show_remove_page_confirmation_dialog'
  /** column name */
  | 'enable_full_month_row_feature'
  /** column name */
  | 'enabled_snapshot_warnings'
  /** column name */
  | 'eod_colour'
  /** column name */
  | 'eod_date'
  /** column name */
  | 'extra_header_height'
  /** column name */
  | 'field_name'
  /** column name */
  | 'flash_cell_updates'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'global_colour'
  /** column name */
  | 'grid_scratchpad_switch'
  /** column name */
  | 'header_column_colour'
  /** column name */
  | 'hide_broadcast'
  /** column name */
  | 'hide_eod'
  /** column name */
  | 'hide_global'
  /** column name */
  | 'hide_private'
  /** column name */
  | 'hide_status_row'
  /** column name */
  | 'hlv_current'
  /** column name */
  | 'hlv_switch'
  /** column name */
  | 'hlvs'
  /** column name */
  | 'hybrid_colour'
  /** column name */
  | 'increment_map'
  /** column name */
  | 'indicator_colour'
  /** column name */
  | 'insert_column_position'
  /** column name */
  | 'insert_page_position'
  /** column name */
  | 'listen_colour'
  /** column name */
  | 'local_colour'
  /** column name */
  | 'main_month_column_width'
  /** column name */
  | 'months'
  /** column name */
  | 'package'
  /** column name */
  | 'qtr_current'
  /** column name */
  | 'qtr_switch'
  /** column name */
  | 'qtrs'
  /** column name */
  | 'quarter_borders'
  /** column name */
  | 'range_summary_calc'
  /** column name */
  | 'range_summary_dp'
  /** column name */
  | 'saved_colours'
  /** column name */
  | 'scratchpad_max_cols'
  /** column name */
  | 'scratchpad_max_rows'
  /** column name */
  | 'season_current'
  /** column name */
  | 'season_switch'
  /** column name */
  | 'seasons'
  /** column name */
  | 'show_world_clock'
  /** column name */
  | 'sound'
  /** column name */
  | 'source'
  /** column name */
  | 'source_colour_map'
  /** column name */
  | 'status_map'
  /** column name */
  | 'subheader_column_colour'
  /** column name */
  | 'theme'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export type Grid_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Grid_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Grid_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Grid_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Grid_Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Grid_Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Grid_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Grid_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Grid_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grid_Settings_Var_Pop_Fields = {
  readonly __typename?: 'grid_settings_var_pop_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Grid_Settings_Var_Samp_Fields = {
  readonly __typename?: 'grid_settings_var_samp_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Grid_Settings_Variance_Fields = {
  readonly __typename?: 'grid_settings_variance_fields';
  readonly adhoc_spreads_rows?: Maybe<Scalars['Float']['output']>;
  readonly anomaly_sensitivity_level?: Maybe<Scalars['Float']['output']>;
  readonly cals?: Maybe<Scalars['Float']['output']>;
  readonly default_curve_column_width?: Maybe<Scalars['Float']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Float']['output']>;
  readonly hlvs?: Maybe<Scalars['Float']['output']>;
  readonly main_month_column_width?: Maybe<Scalars['Float']['output']>;
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly qtrs?: Maybe<Scalars['Float']['output']>;
  readonly range_summary_dp?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_cols?: Maybe<Scalars['Float']['output']>;
  readonly scratchpad_max_rows?: Maybe<Scalars['Float']['output']>;
  readonly seasons?: Maybe<Scalars['Float']['output']>;
};

/** Saved card settings for each user */
export type Hfc_Card_Settings = {
  readonly __typename?: 'hfc_card_settings';
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly user: Scalars['String']['output'];
};

/** aggregated selection of "hfc_card_settings" */
export type Hfc_Card_Settings_Aggregate = {
  readonly __typename?: 'hfc_card_settings_aggregate';
  readonly aggregate?: Maybe<Hfc_Card_Settings_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Hfc_Card_Settings>;
};

/** aggregate fields of "hfc_card_settings" */
export type Hfc_Card_Settings_Aggregate_Fields = {
  readonly __typename?: 'hfc_card_settings_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Hfc_Card_Settings_Max_Fields>;
  readonly min?: Maybe<Hfc_Card_Settings_Min_Fields>;
};


/** aggregate fields of "hfc_card_settings" */
export type Hfc_Card_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "hfc_card_settings". All fields are combined with a logical 'AND'. */
export type Hfc_Card_Settings_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Bool_Exp>>;
  readonly _not?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Bool_Exp>>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly settings_blob?: InputMaybe<String_Comparison_Exp>;
  readonly user?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hfc_card_settings" */
export type Hfc_Card_Settings_Constraint =
  /** unique or primary key constraint on columns "user" */
  | 'hfc_card_settings_pkey';

/** input type for inserting data into table "hfc_card_settings" */
export type Hfc_Card_Settings_Insert_Input = {
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Hfc_Card_Settings_Max_Fields = {
  readonly __typename?: 'hfc_card_settings_max_fields';
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Hfc_Card_Settings_Min_Fields = {
  readonly __typename?: 'hfc_card_settings_min_fields';
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "hfc_card_settings" */
export type Hfc_Card_Settings_Mutation_Response = {
  readonly __typename?: 'hfc_card_settings_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Hfc_Card_Settings>;
};

/** input type for inserting object relation for remote table "hfc_card_settings" */
export type Hfc_Card_Settings_Obj_Rel_Insert_Input = {
  readonly data: Hfc_Card_Settings_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Hfc_Card_Settings_On_Conflict>;
};

/** on_conflict condition type for table "hfc_card_settings" */
export type Hfc_Card_Settings_On_Conflict = {
  readonly constraint: Hfc_Card_Settings_Constraint;
  readonly update_columns?: ReadonlyArray<Hfc_Card_Settings_Update_Column>;
  readonly where?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "hfc_card_settings". */
export type Hfc_Card_Settings_Order_By = {
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly settings_blob?: InputMaybe<Order_By>;
  readonly user?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hfc_card_settings */
export type Hfc_Card_Settings_Pk_Columns_Input = {
  readonly user: Scalars['String']['input'];
};

/** select columns of table "hfc_card_settings" */
export type Hfc_Card_Settings_Select_Column =
  /** column name */
  | 'settings_blob'
  /** column name */
  | 'user';

/** input type for updating data in table "hfc_card_settings" */
export type Hfc_Card_Settings_Set_Input = {
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "hfc_card_settings" */
export type Hfc_Card_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Hfc_Card_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hfc_Card_Settings_Stream_Cursor_Value_Input = {
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "hfc_card_settings" */
export type Hfc_Card_Settings_Update_Column =
  /** column name */
  | 'settings_blob'
  /** column name */
  | 'user';

export type Hfc_Card_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Hfc_Card_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Hfc_Card_Settings_Bool_Exp;
};

/** Track user settings. (i.e. colour scheme for years) */
export type Hfc_User_Settings = {
  readonly __typename?: 'hfc_user_settings';
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly user: Scalars['String']['output'];
};

/** aggregated selection of "hfc_user_settings" */
export type Hfc_User_Settings_Aggregate = {
  readonly __typename?: 'hfc_user_settings_aggregate';
  readonly aggregate?: Maybe<Hfc_User_Settings_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Hfc_User_Settings>;
};

/** aggregate fields of "hfc_user_settings" */
export type Hfc_User_Settings_Aggregate_Fields = {
  readonly __typename?: 'hfc_user_settings_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Hfc_User_Settings_Max_Fields>;
  readonly min?: Maybe<Hfc_User_Settings_Min_Fields>;
};


/** aggregate fields of "hfc_user_settings" */
export type Hfc_User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "hfc_user_settings". All fields are combined with a logical 'AND'. */
export type Hfc_User_Settings_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Bool_Exp>>;
  readonly _not?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Bool_Exp>>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly settings_blob?: InputMaybe<String_Comparison_Exp>;
  readonly user?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hfc_user_settings" */
export type Hfc_User_Settings_Constraint =
  /** unique or primary key constraint on columns "user" */
  | 'hfc_user_settings_pkey';

/** input type for inserting data into table "hfc_user_settings" */
export type Hfc_User_Settings_Insert_Input = {
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Hfc_User_Settings_Max_Fields = {
  readonly __typename?: 'hfc_user_settings_max_fields';
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Hfc_User_Settings_Min_Fields = {
  readonly __typename?: 'hfc_user_settings_min_fields';
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "hfc_user_settings" */
export type Hfc_User_Settings_Mutation_Response = {
  readonly __typename?: 'hfc_user_settings_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Hfc_User_Settings>;
};

/** input type for inserting object relation for remote table "hfc_user_settings" */
export type Hfc_User_Settings_Obj_Rel_Insert_Input = {
  readonly data: Hfc_User_Settings_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Hfc_User_Settings_On_Conflict>;
};

/** on_conflict condition type for table "hfc_user_settings" */
export type Hfc_User_Settings_On_Conflict = {
  readonly constraint: Hfc_User_Settings_Constraint;
  readonly update_columns?: ReadonlyArray<Hfc_User_Settings_Update_Column>;
  readonly where?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "hfc_user_settings". */
export type Hfc_User_Settings_Order_By = {
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly settings_blob?: InputMaybe<Order_By>;
  readonly user?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hfc_user_settings */
export type Hfc_User_Settings_Pk_Columns_Input = {
  readonly user: Scalars['String']['input'];
};

/** select columns of table "hfc_user_settings" */
export type Hfc_User_Settings_Select_Column =
  /** column name */
  | 'settings_blob'
  /** column name */
  | 'user';

/** input type for updating data in table "hfc_user_settings" */
export type Hfc_User_Settings_Set_Input = {
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "hfc_user_settings" */
export type Hfc_User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Hfc_User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hfc_User_Settings_Stream_Cursor_Value_Input = {
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "hfc_user_settings" */
export type Hfc_User_Settings_Update_Column =
  /** column name */
  | 'settings_blob'
  /** column name */
  | 'user';

export type Hfc_User_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Hfc_User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Hfc_User_Settings_Bool_Exp;
};

/** columns and relationships of "incident_banners" */
export type Incident_Banners = {
  readonly __typename?: 'incident_banners';
  readonly created_at: Scalars['timestamptz']['output'];
  readonly created_by?: Maybe<Scalars['String']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
  /** True when the current user is in the banner's org/user audience */
  readonly is_audience?: Maybe<Scalars['Boolean']['output']>;
  readonly message: Scalars['String']['output'];
  readonly org_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly severity: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly updated_at: Scalars['timestamptz']['output'];
  readonly user_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** aggregated selection of "incident_banners" */
export type Incident_Banners_Aggregate = {
  readonly __typename?: 'incident_banners_aggregate';
  readonly aggregate?: Maybe<Incident_Banners_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Incident_Banners>;
};

/** aggregate fields of "incident_banners" */
export type Incident_Banners_Aggregate_Fields = {
  readonly __typename?: 'incident_banners_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Incident_Banners_Max_Fields>;
  readonly min?: Maybe<Incident_Banners_Min_Fields>;
};


/** aggregate fields of "incident_banners" */
export type Incident_Banners_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Incident_Banners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "incident_banners". All fields are combined with a logical 'AND'. */
export type Incident_Banners_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Incident_Banners_Bool_Exp>>;
  readonly _not?: InputMaybe<Incident_Banners_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Incident_Banners_Bool_Exp>>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly created_by?: InputMaybe<String_Comparison_Exp>;
  readonly enabled?: InputMaybe<Boolean_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly is_audience?: InputMaybe<Boolean_Comparison_Exp>;
  readonly message?: InputMaybe<String_Comparison_Exp>;
  readonly org_ids?: InputMaybe<String_Array_Comparison_Exp>;
  readonly severity?: InputMaybe<String_Comparison_Exp>;
  readonly title?: InputMaybe<String_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_ids?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "incident_banners" */
export type Incident_Banners_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'incident_banners_pkey';

/** input type for inserting data into table "incident_banners" */
export type Incident_Banners_Insert_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly created_by?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly org_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly severity?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Incident_Banners_Max_Fields = {
  readonly __typename?: 'incident_banners_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly created_by?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly org_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly severity?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** aggregate min on columns */
export type Incident_Banners_Min_Fields = {
  readonly __typename?: 'incident_banners_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly created_by?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly org_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly severity?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_ids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** response of any mutation on the table "incident_banners" */
export type Incident_Banners_Mutation_Response = {
  readonly __typename?: 'incident_banners_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Incident_Banners>;
};

/** on_conflict condition type for table "incident_banners" */
export type Incident_Banners_On_Conflict = {
  readonly constraint: Incident_Banners_Constraint;
  readonly update_columns?: ReadonlyArray<Incident_Banners_Update_Column>;
  readonly where?: InputMaybe<Incident_Banners_Bool_Exp>;
};

/** Ordering options when selecting data from "incident_banners". */
export type Incident_Banners_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly created_by?: InputMaybe<Order_By>;
  readonly enabled?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_audience?: InputMaybe<Order_By>;
  readonly message?: InputMaybe<Order_By>;
  readonly org_ids?: InputMaybe<Order_By>;
  readonly severity?: InputMaybe<Order_By>;
  readonly title?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_ids?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incident_banners */
export type Incident_Banners_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "incident_banners" */
export type Incident_Banners_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'enabled'
  /** column name */
  | 'id'
  /** column name */
  | 'message'
  /** column name */
  | 'org_ids'
  /** column name */
  | 'severity'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_ids';

/** input type for updating data in table "incident_banners" */
export type Incident_Banners_Set_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly created_by?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly org_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly severity?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Streaming cursor of the table "incident_banners" */
export type Incident_Banners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Incident_Banners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incident_Banners_Stream_Cursor_Value_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly created_by?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly org_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly severity?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_ids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** update columns of table "incident_banners" */
export type Incident_Banners_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'enabled'
  /** column name */
  | 'id'
  /** column name */
  | 'message'
  /** column name */
  | 'org_ids'
  /** column name */
  | 'severity'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_ids';

export type Incident_Banners_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Incident_Banners_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Incident_Banners_Bool_Exp;
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type Inet_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['inet']['input']>;
  readonly _gt?: InputMaybe<Scalars['inet']['input']>;
  readonly _gte?: InputMaybe<Scalars['inet']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['inet']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['inet']['input']>;
  readonly _lte?: InputMaybe<Scalars['inet']['input']>;
  readonly _neq?: InputMaybe<Scalars['inet']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['inet']['input']>>;
};

export type Jsonb_Cast_Exp = {
  readonly String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  readonly _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  readonly _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  readonly _contains?: InputMaybe<Scalars['jsonb']['input']>;
  readonly _eq?: InputMaybe<Scalars['jsonb']['input']>;
  readonly _gt?: InputMaybe<Scalars['jsonb']['input']>;
  readonly _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  readonly _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  readonly _has_keys_all?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  readonly _has_keys_any?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['jsonb']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  readonly _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  readonly _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  readonly _lt?: InputMaybe<Scalars['jsonb']['input']>;
  readonly _lte?: InputMaybe<Scalars['jsonb']['input']>;
  readonly _neq?: InputMaybe<Scalars['jsonb']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "live_chart_annotations" */
export type Live_Chart_Annotations = {
  readonly __typename?: 'live_chart_annotations';
  /** An object relationship */
  readonly User?: Maybe<Folio_User>;
  readonly annotations?: Maybe<Scalars['jsonb']['output']>;
  readonly id: Scalars['String']['output'];
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "live_chart_annotations" */
export type Live_Chart_AnnotationsAnnotationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "live_chart_annotations" */
export type Live_Chart_Annotations_Aggregate = {
  readonly __typename?: 'live_chart_annotations_aggregate';
  readonly aggregate?: Maybe<Live_Chart_Annotations_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Live_Chart_Annotations>;
};

/** aggregate fields of "live_chart_annotations" */
export type Live_Chart_Annotations_Aggregate_Fields = {
  readonly __typename?: 'live_chart_annotations_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Live_Chart_Annotations_Max_Fields>;
  readonly min?: Maybe<Live_Chart_Annotations_Min_Fields>;
};


/** aggregate fields of "live_chart_annotations" */
export type Live_Chart_Annotations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Live_Chart_Annotations_Append_Input = {
  readonly annotations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "live_chart_annotations". All fields are combined with a logical 'AND'. */
export type Live_Chart_Annotations_Bool_Exp = {
  readonly User?: InputMaybe<Folio_User_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Bool_Exp>>;
  readonly _not?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Bool_Exp>>;
  readonly annotations?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_chart_annotations" */
export type Live_Chart_Annotations_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'live_chart_annotations_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Live_Chart_Annotations_Delete_At_Path_Input = {
  readonly annotations?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Live_Chart_Annotations_Delete_Elem_Input = {
  readonly annotations?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Live_Chart_Annotations_Delete_Key_Input = {
  readonly annotations?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "live_chart_annotations" */
export type Live_Chart_Annotations_Insert_Input = {
  readonly User?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly annotations?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Live_Chart_Annotations_Max_Fields = {
  readonly __typename?: 'live_chart_annotations_max_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Live_Chart_Annotations_Min_Fields = {
  readonly __typename?: 'live_chart_annotations_min_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "live_chart_annotations" */
export type Live_Chart_Annotations_Mutation_Response = {
  readonly __typename?: 'live_chart_annotations_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Live_Chart_Annotations>;
};

/** on_conflict condition type for table "live_chart_annotations" */
export type Live_Chart_Annotations_On_Conflict = {
  readonly constraint: Live_Chart_Annotations_Constraint;
  readonly update_columns?: ReadonlyArray<Live_Chart_Annotations_Update_Column>;
  readonly where?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
};

/** Ordering options when selecting data from "live_chart_annotations". */
export type Live_Chart_Annotations_Order_By = {
  readonly User?: InputMaybe<Folio_User_Order_By>;
  readonly annotations?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_chart_annotations */
export type Live_Chart_Annotations_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Live_Chart_Annotations_Prepend_Input = {
  readonly annotations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "live_chart_annotations" */
export type Live_Chart_Annotations_Select_Column =
  /** column name */
  | 'annotations'
  /** column name */
  | 'id'
  /** column name */
  | 'user_id';

/** input type for updating data in table "live_chart_annotations" */
export type Live_Chart_Annotations_Set_Input = {
  readonly annotations?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "live_chart_annotations" */
export type Live_Chart_Annotations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Live_Chart_Annotations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Chart_Annotations_Stream_Cursor_Value_Input = {
  readonly annotations?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "live_chart_annotations" */
export type Live_Chart_Annotations_Update_Column =
  /** column name */
  | 'annotations'
  /** column name */
  | 'id'
  /** column name */
  | 'user_id';

export type Live_Chart_Annotations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Live_Chart_Annotations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Live_Chart_Annotations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Live_Chart_Annotations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Live_Chart_Annotations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Live_Chart_Annotations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Live_Chart_Annotations_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Live_Chart_Annotations_Bool_Exp;
};

/** columns and relationships of "live_chart_page" */
export type Live_Chart_Page = {
  readonly __typename?: 'live_chart_page';
  readonly charts: Scalars['jsonb']['output'];
  readonly created_at: Scalars['timestamptz']['output'];
  readonly id: Scalars['String']['output'];
  readonly idx: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly page_type?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "live_chart_page" */
export type Live_Chart_PageChartsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "live_chart_page" */
export type Live_Chart_Page_Aggregate = {
  readonly __typename?: 'live_chart_page_aggregate';
  readonly aggregate?: Maybe<Live_Chart_Page_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Live_Chart_Page>;
};

/** aggregate fields of "live_chart_page" */
export type Live_Chart_Page_Aggregate_Fields = {
  readonly __typename?: 'live_chart_page_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Live_Chart_Page_Max_Fields>;
  readonly min?: Maybe<Live_Chart_Page_Min_Fields>;
};


/** aggregate fields of "live_chart_page" */
export type Live_Chart_Page_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Live_Chart_Page_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Live_Chart_Page_Append_Input = {
  readonly charts?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "live_chart_page". All fields are combined with a logical 'AND'. */
export type Live_Chart_Page_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Live_Chart_Page_Bool_Exp>>;
  readonly _not?: InputMaybe<Live_Chart_Page_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Live_Chart_Page_Bool_Exp>>;
  readonly charts?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly idx?: InputMaybe<String_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly page_type?: InputMaybe<String_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_chart_page" */
export type Live_Chart_Page_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'live_chart_page_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Live_Chart_Page_Delete_At_Path_Input = {
  readonly charts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Live_Chart_Page_Delete_Elem_Input = {
  readonly charts?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Live_Chart_Page_Delete_Key_Input = {
  readonly charts?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "live_chart_page" */
export type Live_Chart_Page_Insert_Input = {
  readonly charts?: InputMaybe<Scalars['jsonb']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly page_type?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Live_Chart_Page_Max_Fields = {
  readonly __typename?: 'live_chart_page_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly page_type?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Live_Chart_Page_Min_Fields = {
  readonly __typename?: 'live_chart_page_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly page_type?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "live_chart_page" */
export type Live_Chart_Page_Mutation_Response = {
  readonly __typename?: 'live_chart_page_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Live_Chart_Page>;
};

/** on_conflict condition type for table "live_chart_page" */
export type Live_Chart_Page_On_Conflict = {
  readonly constraint: Live_Chart_Page_Constraint;
  readonly update_columns?: ReadonlyArray<Live_Chart_Page_Update_Column>;
  readonly where?: InputMaybe<Live_Chart_Page_Bool_Exp>;
};

/** Ordering options when selecting data from "live_chart_page". */
export type Live_Chart_Page_Order_By = {
  readonly charts?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly idx?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly page_type?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_chart_page */
export type Live_Chart_Page_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Live_Chart_Page_Prepend_Input = {
  readonly charts?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "live_chart_page" */
export type Live_Chart_Page_Select_Column =
  /** column name */
  | 'charts'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'name'
  /** column name */
  | 'page_type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "live_chart_page" */
export type Live_Chart_Page_Set_Input = {
  readonly charts?: InputMaybe<Scalars['jsonb']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly page_type?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "live_chart_page" */
export type Live_Chart_Page_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Live_Chart_Page_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Chart_Page_Stream_Cursor_Value_Input = {
  readonly charts?: InputMaybe<Scalars['jsonb']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly page_type?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "live_chart_page" */
export type Live_Chart_Page_Update_Column =
  /** column name */
  | 'charts'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'name'
  /** column name */
  | 'page_type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export type Live_Chart_Page_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Live_Chart_Page_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Live_Chart_Page_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Live_Chart_Page_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Live_Chart_Page_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Live_Chart_Page_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Live_Chart_Page_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Live_Chart_Page_Bool_Exp;
};

/** columns and relationships of "live_chart_settings" */
export type Live_Chart_Settings = {
  readonly __typename?: 'live_chart_settings';
  readonly charts_state: Scalars['jsonb']['output'];
  readonly created_at: Scalars['timestamptz']['output'];
  readonly curve_settings?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly hfc_settings?: Maybe<Scalars['jsonb']['output']>;
  readonly updated_at: Scalars['timestamptz']['output'];
  readonly user_id: Scalars['String']['output'];
  readonly user_settings?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "live_chart_settings" */
export type Live_Chart_SettingsCharts_StateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "live_chart_settings" */
export type Live_Chart_SettingsCurve_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "live_chart_settings" */
export type Live_Chart_SettingsHfc_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "live_chart_settings" */
export type Live_Chart_SettingsUser_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "live_chart_settings" */
export type Live_Chart_Settings_Aggregate = {
  readonly __typename?: 'live_chart_settings_aggregate';
  readonly aggregate?: Maybe<Live_Chart_Settings_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Live_Chart_Settings>;
};

/** aggregate fields of "live_chart_settings" */
export type Live_Chart_Settings_Aggregate_Fields = {
  readonly __typename?: 'live_chart_settings_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Live_Chart_Settings_Max_Fields>;
  readonly min?: Maybe<Live_Chart_Settings_Min_Fields>;
};


/** aggregate fields of "live_chart_settings" */
export type Live_Chart_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Live_Chart_Settings_Append_Input = {
  readonly charts_state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly hfc_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly user_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "live_chart_settings". All fields are combined with a logical 'AND'. */
export type Live_Chart_Settings_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Bool_Exp>>;
  readonly _not?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Bool_Exp>>;
  readonly charts_state?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly curve_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly hfc_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
  readonly user_settings?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_chart_settings" */
export type Live_Chart_Settings_Constraint =
  /** unique or primary key constraint on columns "user_id" */
  | 'live_chart_settings_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Live_Chart_Settings_Delete_At_Path_Input = {
  readonly charts_state?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly curve_settings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly hfc_settings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly user_settings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Live_Chart_Settings_Delete_Elem_Input = {
  readonly charts_state?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['Int']['input']>;
  readonly hfc_settings?: InputMaybe<Scalars['Int']['input']>;
  readonly user_settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Live_Chart_Settings_Delete_Key_Input = {
  readonly charts_state?: InputMaybe<Scalars['String']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['String']['input']>;
  readonly hfc_settings?: InputMaybe<Scalars['String']['input']>;
  readonly user_settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "live_chart_settings" */
export type Live_Chart_Settings_Insert_Input = {
  readonly charts_state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly hfc_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly user_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Live_Chart_Settings_Max_Fields = {
  readonly __typename?: 'live_chart_settings_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Live_Chart_Settings_Min_Fields = {
  readonly __typename?: 'live_chart_settings_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "live_chart_settings" */
export type Live_Chart_Settings_Mutation_Response = {
  readonly __typename?: 'live_chart_settings_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Live_Chart_Settings>;
};

/** on_conflict condition type for table "live_chart_settings" */
export type Live_Chart_Settings_On_Conflict = {
  readonly constraint: Live_Chart_Settings_Constraint;
  readonly update_columns?: ReadonlyArray<Live_Chart_Settings_Update_Column>;
  readonly where?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "live_chart_settings". */
export type Live_Chart_Settings_Order_By = {
  readonly charts_state?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly curve_settings?: InputMaybe<Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly hfc_settings?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
  readonly user_settings?: InputMaybe<Order_By>;
};

/** primary key columns input for table: live_chart_settings */
export type Live_Chart_Settings_Pk_Columns_Input = {
  readonly user_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Live_Chart_Settings_Prepend_Input = {
  readonly charts_state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly hfc_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly user_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "live_chart_settings" */
export type Live_Chart_Settings_Select_Column =
  /** column name */
  | 'charts_state'
  /** column name */
  | 'created_at'
  /** column name */
  | 'curve_settings'
  /** column name */
  | 'hfc_settings'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'user_settings';

/** input type for updating data in table "live_chart_settings" */
export type Live_Chart_Settings_Set_Input = {
  readonly charts_state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly hfc_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly user_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "live_chart_settings" */
export type Live_Chart_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Live_Chart_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Chart_Settings_Stream_Cursor_Value_Input = {
  readonly charts_state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly curve_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly hfc_settings?: InputMaybe<Scalars['jsonb']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly user_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "live_chart_settings" */
export type Live_Chart_Settings_Update_Column =
  /** column name */
  | 'charts_state'
  /** column name */
  | 'created_at'
  /** column name */
  | 'curve_settings'
  /** column name */
  | 'hfc_settings'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'user_settings';

export type Live_Chart_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Live_Chart_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Live_Chart_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Live_Chart_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Live_Chart_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Live_Chart_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Live_Chart_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Live_Chart_Settings_Bool_Exp;
};

/** columns and relationships of "live_users_new" */
export type Live_Users_New = {
  readonly __typename?: 'live_users_new';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly is_mobile?: Maybe<Scalars['Boolean']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "live_users_new" */
export type Live_Users_New_Aggregate = {
  readonly __typename?: 'live_users_new_aggregate';
  readonly aggregate?: Maybe<Live_Users_New_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Live_Users_New>;
};

/** aggregate fields of "live_users_new" */
export type Live_Users_New_Aggregate_Fields = {
  readonly __typename?: 'live_users_new_aggregate_fields';
  readonly avg?: Maybe<Live_Users_New_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Live_Users_New_Max_Fields>;
  readonly min?: Maybe<Live_Users_New_Min_Fields>;
  readonly stddev?: Maybe<Live_Users_New_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Live_Users_New_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Live_Users_New_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Live_Users_New_Sum_Fields>;
  readonly var_pop?: Maybe<Live_Users_New_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Live_Users_New_Var_Samp_Fields>;
  readonly variance?: Maybe<Live_Users_New_Variance_Fields>;
};


/** aggregate fields of "live_users_new" */
export type Live_Users_New_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Live_Users_New_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Live_Users_New_Avg_Fields = {
  readonly __typename?: 'live_users_new_avg_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "live_users_new". All fields are combined with a logical 'AND'. */
export type Live_Users_New_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Live_Users_New_Bool_Exp>>;
  readonly _not?: InputMaybe<Live_Users_New_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Live_Users_New_Bool_Exp>>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly is_mobile?: InputMaybe<Boolean_Comparison_Exp>;
  readonly last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Live_Users_New_Max_Fields = {
  readonly __typename?: 'live_users_new_max_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Live_Users_New_Min_Fields = {
  readonly __typename?: 'live_users_new_min_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "live_users_new". */
export type Live_Users_New_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_mobile?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** select columns of table "live_users_new" */
export type Live_Users_New_Select_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'is_mobile'
  /** column name */
  | 'last_seen'
  /** column name */
  | 'organisation';

/** aggregate stddev on columns */
export type Live_Users_New_Stddev_Fields = {
  readonly __typename?: 'live_users_new_stddev_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Live_Users_New_Stddev_Pop_Fields = {
  readonly __typename?: 'live_users_new_stddev_pop_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Live_Users_New_Stddev_Samp_Fields = {
  readonly __typename?: 'live_users_new_stddev_samp_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "live_users_new" */
export type Live_Users_New_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Live_Users_New_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Users_New_Stream_Cursor_Value_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Live_Users_New_Sum_Fields = {
  readonly __typename?: 'live_users_new_sum_fields';
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Live_Users_New_Var_Pop_Fields = {
  readonly __typename?: 'live_users_new_var_pop_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Live_Users_New_Var_Samp_Fields = {
  readonly __typename?: 'live_users_new_var_samp_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Live_Users_New_Variance_Fields = {
  readonly __typename?: 'live_users_new_variance_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "local_instrument" */
export type Local_Instrument = {
  readonly __typename?: 'local_instrument';
  readonly edited_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly folio_user: Scalars['String']['output'];
  readonly id: Scalars['bigint']['output'];
  readonly month: Scalars['date']['output'];
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByProduct: Product;
  readonly storage_type: User_Storage_Enum;
  /** An object relationship */
  readonly user_storage: User_Storage;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "local_instrument" */
export type Local_Instrument_Aggregate = {
  readonly __typename?: 'local_instrument_aggregate';
  readonly aggregate?: Maybe<Local_Instrument_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Local_Instrument>;
};

export type Local_Instrument_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Local_Instrument_Aggregate_Bool_Exp_Count>;
};

export type Local_Instrument_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Local_Instrument_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "local_instrument" */
export type Local_Instrument_Aggregate_Fields = {
  readonly __typename?: 'local_instrument_aggregate_fields';
  readonly avg?: Maybe<Local_Instrument_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Local_Instrument_Max_Fields>;
  readonly min?: Maybe<Local_Instrument_Min_Fields>;
  readonly stddev?: Maybe<Local_Instrument_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Local_Instrument_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Local_Instrument_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Local_Instrument_Sum_Fields>;
  readonly var_pop?: Maybe<Local_Instrument_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Local_Instrument_Var_Samp_Fields>;
  readonly variance?: Maybe<Local_Instrument_Variance_Fields>;
};


/** aggregate fields of "local_instrument" */
export type Local_Instrument_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "local_instrument" */
export type Local_Instrument_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Local_Instrument_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Local_Instrument_Max_Order_By>;
  readonly min?: InputMaybe<Local_Instrument_Min_Order_By>;
  readonly stddev?: InputMaybe<Local_Instrument_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Local_Instrument_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Local_Instrument_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Local_Instrument_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Local_Instrument_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Local_Instrument_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Local_Instrument_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "local_instrument" */
export type Local_Instrument_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Local_Instrument_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Local_Instrument_On_Conflict>;
};

/** aggregate avg on columns */
export type Local_Instrument_Avg_Fields = {
  readonly __typename?: 'local_instrument_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "local_instrument" */
export type Local_Instrument_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "local_instrument". All fields are combined with a logical 'AND'. */
export type Local_Instrument_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Local_Instrument_Bool_Exp>>;
  readonly _not?: InputMaybe<Local_Instrument_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Local_Instrument_Bool_Exp>>;
  readonly edited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<Bigint_Comparison_Exp>;
  readonly month?: InputMaybe<Date_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
  readonly storage_type?: InputMaybe<User_Storage_Enum_Comparison_Exp>;
  readonly user_storage?: InputMaybe<User_Storage_Bool_Exp>;
  readonly value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "local_instrument" */
export type Local_Instrument_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'local_instrument_id_key'
  /** unique or primary key constraint on columns "product", "storage_type", "folio_user", "month" */
  | 'local_instrument_pkey';

/** input type for incrementing numeric columns in table "local_instrument" */
export type Local_Instrument_Inc_Input = {
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "local_instrument" */
export type Local_Instrument_Insert_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly storage_type?: InputMaybe<User_Storage_Enum>;
  readonly user_storage?: InputMaybe<User_Storage_Obj_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Local_Instrument_Max_Fields = {
  readonly __typename?: 'local_instrument_max_fields';
  readonly edited_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "local_instrument" */
export type Local_Instrument_Max_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Local_Instrument_Min_Fields = {
  readonly __typename?: 'local_instrument_min_fields';
  readonly edited_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "local_instrument" */
export type Local_Instrument_Min_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "local_instrument" */
export type Local_Instrument_Mutation_Response = {
  readonly __typename?: 'local_instrument_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Local_Instrument>;
};

/** on_conflict condition type for table "local_instrument" */
export type Local_Instrument_On_Conflict = {
  readonly constraint: Local_Instrument_Constraint;
  readonly update_columns?: ReadonlyArray<Local_Instrument_Update_Column>;
  readonly where?: InputMaybe<Local_Instrument_Bool_Exp>;
};

/** Ordering options when selecting data from "local_instrument". */
export type Local_Instrument_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
  readonly storage_type?: InputMaybe<Order_By>;
  readonly user_storage?: InputMaybe<User_Storage_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: local_instrument */
export type Local_Instrument_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
  readonly month: Scalars['date']['input'];
  readonly product: Scalars['uuid']['input'];
  readonly storage_type: User_Storage_Enum;
};

/** select columns of table "local_instrument" */
export type Local_Instrument_Select_Column =
  /** column name */
  | 'edited_at'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'product'
  /** column name */
  | 'storage_type'
  /** column name */
  | 'value';

/** input type for updating data in table "local_instrument" */
export type Local_Instrument_Set_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly storage_type?: InputMaybe<User_Storage_Enum>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Local_Instrument_Stddev_Fields = {
  readonly __typename?: 'local_instrument_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "local_instrument" */
export type Local_Instrument_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Local_Instrument_Stddev_Pop_Fields = {
  readonly __typename?: 'local_instrument_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "local_instrument" */
export type Local_Instrument_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Local_Instrument_Stddev_Samp_Fields = {
  readonly __typename?: 'local_instrument_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "local_instrument" */
export type Local_Instrument_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "local_instrument" */
export type Local_Instrument_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Local_Instrument_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Local_Instrument_Stream_Cursor_Value_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly storage_type?: InputMaybe<User_Storage_Enum>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Local_Instrument_Sum_Fields = {
  readonly __typename?: 'local_instrument_sum_fields';
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "local_instrument" */
export type Local_Instrument_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** update columns of table "local_instrument" */
export type Local_Instrument_Update_Column =
  /** column name */
  | 'edited_at'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'product'
  /** column name */
  | 'storage_type'
  /** column name */
  | 'value';

export type Local_Instrument_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Local_Instrument_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Local_Instrument_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Local_Instrument_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Local_Instrument_Var_Pop_Fields = {
  readonly __typename?: 'local_instrument_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "local_instrument" */
export type Local_Instrument_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Local_Instrument_Var_Samp_Fields = {
  readonly __typename?: 'local_instrument_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "local_instrument" */
export type Local_Instrument_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Local_Instrument_Variance_Fields = {
  readonly __typename?: 'local_instrument_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "local_instrument" */
export type Local_Instrument_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** columns and relationships of "logout_request" */
export type Logout_Request = {
  readonly __typename?: 'logout_request';
  readonly context?: Maybe<Scalars['String']['output']>;
  readonly folio_user: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  /** An object relationship */
  readonly logout_request_folio_user: Folio_User;
  readonly logout_requested_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  readonly session_type?: Maybe<Session_Type>;
};

/** aggregated selection of "logout_request" */
export type Logout_Request_Aggregate = {
  readonly __typename?: 'logout_request_aggregate';
  readonly aggregate?: Maybe<Logout_Request_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Logout_Request>;
};

export type Logout_Request_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Logout_Request_Aggregate_Bool_Exp_Count>;
};

export type Logout_Request_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Logout_Request_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "logout_request" */
export type Logout_Request_Aggregate_Fields = {
  readonly __typename?: 'logout_request_aggregate_fields';
  readonly avg?: Maybe<Logout_Request_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Logout_Request_Max_Fields>;
  readonly min?: Maybe<Logout_Request_Min_Fields>;
  readonly stddev?: Maybe<Logout_Request_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Logout_Request_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Logout_Request_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Logout_Request_Sum_Fields>;
  readonly var_pop?: Maybe<Logout_Request_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Logout_Request_Var_Samp_Fields>;
  readonly variance?: Maybe<Logout_Request_Variance_Fields>;
};


/** aggregate fields of "logout_request" */
export type Logout_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "logout_request" */
export type Logout_Request_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Logout_Request_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Logout_Request_Max_Order_By>;
  readonly min?: InputMaybe<Logout_Request_Min_Order_By>;
  readonly stddev?: InputMaybe<Logout_Request_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Logout_Request_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Logout_Request_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Logout_Request_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Logout_Request_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Logout_Request_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Logout_Request_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "logout_request" */
export type Logout_Request_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Logout_Request_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Logout_Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Logout_Request_Avg_Fields = {
  readonly __typename?: 'logout_request_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "logout_request" */
export type Logout_Request_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "logout_request". All fields are combined with a logical 'AND'. */
export type Logout_Request_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Logout_Request_Bool_Exp>>;
  readonly _not?: InputMaybe<Logout_Request_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Logout_Request_Bool_Exp>>;
  readonly context?: InputMaybe<String_Comparison_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly logout_request_folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly logout_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly session_type?: InputMaybe<Session_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "logout_request" */
export type Logout_Request_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'logout_request_pkey'
  /** unique or primary key constraint on columns "folio_user", "context" */
  | 'logout_request_user_context_unique';

/** input type for incrementing numeric columns in table "logout_request" */
export type Logout_Request_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "logout_request" */
export type Logout_Request_Insert_Input = {
  readonly context?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly logout_request_folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly logout_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly session_type?: InputMaybe<Session_Type_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Logout_Request_Max_Fields = {
  readonly __typename?: 'logout_request_max_fields';
  readonly context?: Maybe<Scalars['String']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly logout_requested_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "logout_request" */
export type Logout_Request_Max_Order_By = {
  readonly context?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly logout_requested_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Logout_Request_Min_Fields = {
  readonly __typename?: 'logout_request_min_fields';
  readonly context?: Maybe<Scalars['String']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly logout_requested_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "logout_request" */
export type Logout_Request_Min_Order_By = {
  readonly context?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly logout_requested_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "logout_request" */
export type Logout_Request_Mutation_Response = {
  readonly __typename?: 'logout_request_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Logout_Request>;
};

/** on_conflict condition type for table "logout_request" */
export type Logout_Request_On_Conflict = {
  readonly constraint: Logout_Request_Constraint;
  readonly update_columns?: ReadonlyArray<Logout_Request_Update_Column>;
  readonly where?: InputMaybe<Logout_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "logout_request". */
export type Logout_Request_Order_By = {
  readonly context?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly logout_request_folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly logout_requested_at?: InputMaybe<Order_By>;
  readonly session_type?: InputMaybe<Session_Type_Order_By>;
};

/** primary key columns input for table: logout_request */
export type Logout_Request_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "logout_request" */
export type Logout_Request_Select_Column =
  /** column name */
  | 'context'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'logout_requested_at';

/** input type for updating data in table "logout_request" */
export type Logout_Request_Set_Input = {
  readonly context?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly logout_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Logout_Request_Stddev_Fields = {
  readonly __typename?: 'logout_request_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "logout_request" */
export type Logout_Request_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Logout_Request_Stddev_Pop_Fields = {
  readonly __typename?: 'logout_request_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "logout_request" */
export type Logout_Request_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Logout_Request_Stddev_Samp_Fields = {
  readonly __typename?: 'logout_request_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "logout_request" */
export type Logout_Request_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "logout_request" */
export type Logout_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Logout_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Logout_Request_Stream_Cursor_Value_Input = {
  readonly context?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly logout_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Logout_Request_Sum_Fields = {
  readonly __typename?: 'logout_request_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "logout_request" */
export type Logout_Request_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** update columns of table "logout_request" */
export type Logout_Request_Update_Column =
  /** column name */
  | 'context'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'logout_requested_at';

export type Logout_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Logout_Request_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Logout_Request_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Logout_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Logout_Request_Var_Pop_Fields = {
  readonly __typename?: 'logout_request_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "logout_request" */
export type Logout_Request_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Logout_Request_Var_Samp_Fields = {
  readonly __typename?: 'logout_request_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "logout_request" */
export type Logout_Request_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Logout_Request_Variance_Fields = {
  readonly __typename?: 'logout_request_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "logout_request" */
export type Logout_Request_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "mfa_mode_enum". All fields are combined with logical 'AND'. */
export type Mfa_Mode_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly _gt?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly _gte?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['mfa_mode_enum']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly _lte?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly _neq?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['mfa_mode_enum']['input']>>;
};

/** columns and relationships of "module_storage" */
export type Module_Storage = {
  readonly __typename?: 'module_storage';
  readonly key: Scalars['String']['output'];
  readonly module: Scalars['String']['output'];
  readonly rev: Scalars['bigint']['output'];
  readonly updated_at: Scalars['timestamptz']['output'];
  readonly user_id: Scalars['String']['output'];
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "module_storage" */
export type Module_StorageValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "module_storage" */
export type Module_Storage_Aggregate = {
  readonly __typename?: 'module_storage_aggregate';
  readonly aggregate?: Maybe<Module_Storage_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Module_Storage>;
};

/** aggregate fields of "module_storage" */
export type Module_Storage_Aggregate_Fields = {
  readonly __typename?: 'module_storage_aggregate_fields';
  readonly avg?: Maybe<Module_Storage_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Module_Storage_Max_Fields>;
  readonly min?: Maybe<Module_Storage_Min_Fields>;
  readonly stddev?: Maybe<Module_Storage_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Module_Storage_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Module_Storage_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Module_Storage_Sum_Fields>;
  readonly var_pop?: Maybe<Module_Storage_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Module_Storage_Var_Samp_Fields>;
  readonly variance?: Maybe<Module_Storage_Variance_Fields>;
};


/** aggregate fields of "module_storage" */
export type Module_Storage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Module_Storage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Module_Storage_Append_Input = {
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Module_Storage_Avg_Fields = {
  readonly __typename?: 'module_storage_avg_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "module_storage". All fields are combined with a logical 'AND'. */
export type Module_Storage_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Module_Storage_Bool_Exp>>;
  readonly _not?: InputMaybe<Module_Storage_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Module_Storage_Bool_Exp>>;
  readonly key?: InputMaybe<String_Comparison_Exp>;
  readonly module?: InputMaybe<String_Comparison_Exp>;
  readonly rev?: InputMaybe<Bigint_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
  readonly value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_storage" */
export type Module_Storage_Constraint =
  /** unique or primary key constraint on columns "user_id", "key", "module" */
  | 'module_storage_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Module_Storage_Delete_At_Path_Input = {
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Module_Storage_Delete_Elem_Input = {
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Module_Storage_Delete_Key_Input = {
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "module_storage" */
export type Module_Storage_Inc_Input = {
  readonly rev?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "module_storage" */
export type Module_Storage_Insert_Input = {
  readonly key?: InputMaybe<Scalars['String']['input']>;
  readonly module?: InputMaybe<Scalars['String']['input']>;
  readonly rev?: InputMaybe<Scalars['bigint']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Module_Storage_Max_Fields = {
  readonly __typename?: 'module_storage_max_fields';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly module?: Maybe<Scalars['String']['output']>;
  readonly rev?: Maybe<Scalars['bigint']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Module_Storage_Min_Fields = {
  readonly __typename?: 'module_storage_min_fields';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly module?: Maybe<Scalars['String']['output']>;
  readonly rev?: Maybe<Scalars['bigint']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "module_storage" */
export type Module_Storage_Mutation_Response = {
  readonly __typename?: 'module_storage_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Module_Storage>;
};

/** on_conflict condition type for table "module_storage" */
export type Module_Storage_On_Conflict = {
  readonly constraint: Module_Storage_Constraint;
  readonly update_columns?: ReadonlyArray<Module_Storage_Update_Column>;
  readonly where?: InputMaybe<Module_Storage_Bool_Exp>;
};

/** Ordering options when selecting data from "module_storage". */
export type Module_Storage_Order_By = {
  readonly key?: InputMaybe<Order_By>;
  readonly module?: InputMaybe<Order_By>;
  readonly rev?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_storage */
export type Module_Storage_Pk_Columns_Input = {
  readonly key: Scalars['String']['input'];
  readonly module: Scalars['String']['input'];
  readonly user_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Module_Storage_Prepend_Input = {
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "module_storage" */
export type Module_Storage_Select_Column =
  /** column name */
  | 'key'
  /** column name */
  | 'module'
  /** column name */
  | 'rev'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'value';

/** input type for updating data in table "module_storage" */
export type Module_Storage_Set_Input = {
  readonly key?: InputMaybe<Scalars['String']['input']>;
  readonly module?: InputMaybe<Scalars['String']['input']>;
  readonly rev?: InputMaybe<Scalars['bigint']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Module_Storage_Stddev_Fields = {
  readonly __typename?: 'module_storage_stddev_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Module_Storage_Stddev_Pop_Fields = {
  readonly __typename?: 'module_storage_stddev_pop_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Module_Storage_Stddev_Samp_Fields = {
  readonly __typename?: 'module_storage_stddev_samp_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "module_storage" */
export type Module_Storage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Module_Storage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Storage_Stream_Cursor_Value_Input = {
  readonly key?: InputMaybe<Scalars['String']['input']>;
  readonly module?: InputMaybe<Scalars['String']['input']>;
  readonly rev?: InputMaybe<Scalars['bigint']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  /** a NULL value is a tombstone meaning the key was deleted. Rows are never removed by the application so deletions are visible to cursor-based subscribers (note: deleting a folio_user hard-deletes their rows via ON DELETE CASCADE) */
  readonly value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Module_Storage_Sum_Fields = {
  readonly __typename?: 'module_storage_sum_fields';
  readonly rev?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "module_storage" */
export type Module_Storage_Update_Column =
  /** column name */
  | 'key'
  /** column name */
  | 'module'
  /** column name */
  | 'rev'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'value';

export type Module_Storage_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Module_Storage_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Module_Storage_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Module_Storage_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Module_Storage_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Module_Storage_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Module_Storage_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Module_Storage_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Module_Storage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Module_Storage_Var_Pop_Fields = {
  readonly __typename?: 'module_storage_var_pop_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Module_Storage_Var_Samp_Fields = {
  readonly __typename?: 'module_storage_var_samp_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Module_Storage_Variance_Fields = {
  readonly __typename?: 'module_storage_variance_fields';
  readonly rev?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  readonly __typename?: 'mutation_root';
  /** delete data from the table: "alerts" */
  readonly delete_alerts?: Maybe<Alerts_Mutation_Response>;
  /** delete single row from the table: "alerts" */
  readonly delete_alerts_by_pk?: Maybe<Alerts>;
  /** delete data from the table: "audit.logged_actions" */
  readonly delete_audit_logged_actions?: Maybe<Audit_Logged_Actions_Mutation_Response>;
  /** delete single row from the table: "audit.logged_actions" */
  readonly delete_audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** delete data from the table: "audit.umi_actions" */
  readonly delete_audit_umi_actions?: Maybe<Audit_Umi_Actions_Mutation_Response>;
  /** delete single row from the table: "audit.umi_actions" */
  readonly delete_audit_umi_actions_by_pk?: Maybe<Audit_Umi_Actions>;
  /** delete data from the table: "commodity_group" */
  readonly delete_commodity_group?: Maybe<Commodity_Group_Mutation_Response>;
  /** delete single row from the table: "commodity_group" */
  readonly delete_commodity_group_by_pk?: Maybe<Commodity_Group>;
  /** delete data from the table: "commodity_parent_group" */
  readonly delete_commodity_parent_group?: Maybe<Commodity_Parent_Group_Mutation_Response>;
  /** delete single row from the table: "commodity_parent_group" */
  readonly delete_commodity_parent_group_by_pk?: Maybe<Commodity_Parent_Group>;
  /** delete data from the table: "conditional_formatting_rules" */
  readonly delete_conditional_formatting_rules?: Maybe<Conditional_Formatting_Rules_Mutation_Response>;
  /** delete single row from the table: "conditional_formatting_rules" */
  readonly delete_conditional_formatting_rules_by_pk?: Maybe<Conditional_Formatting_Rules>;
  /** delete data from the table: "eod" */
  readonly delete_eod?: Maybe<Eod_Mutation_Response>;
  /** delete single row from the table: "eod" */
  readonly delete_eod_by_pk?: Maybe<Eod>;
  /** delete data from the table: "eod_entry" */
  readonly delete_eod_entry?: Maybe<Eod_Entry_Mutation_Response>;
  /** delete single row from the table: "eod_entry" */
  readonly delete_eod_entry_by_pk?: Maybe<Eod_Entry>;
  /** delete data from the table: "exchange" */
  readonly delete_exchange?: Maybe<Exchange_Mutation_Response>;
  /** delete single row from the table: "exchange" */
  readonly delete_exchange_by_pk?: Maybe<Exchange>;
  /** delete data from the table: "exchange_event_type" */
  readonly delete_exchange_event_type?: Maybe<Exchange_Event_Type_Mutation_Response>;
  /** delete single row from the table: "exchange_event_type" */
  readonly delete_exchange_event_type_by_pk?: Maybe<Exchange_Event_Type>;
  /** delete data from the table: "exchange_usage" */
  readonly delete_exchange_usage?: Maybe<Exchange_Usage_Mutation_Response>;
  /** delete single row from the table: "exchange_usage" */
  readonly delete_exchange_usage_by_pk?: Maybe<Exchange_Usage>;
  /** delete data from the table: "feature_flags" */
  readonly delete_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "feature_flags" */
  readonly delete_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** delete data from the table: "folio_shadow_curves" */
  readonly delete_folio_shadow_curves?: Maybe<Folio_Shadow_Curves_Mutation_Response>;
  /** delete single row from the table: "folio_shadow_curves" */
  readonly delete_folio_shadow_curves_by_pk?: Maybe<Folio_Shadow_Curves>;
  /** delete data from the table: "folio_user" */
  readonly delete_folio_user?: Maybe<Folio_User_Mutation_Response>;
  /** delete data from the table: "folio_user_basic_profile" */
  readonly delete_folio_user_basic_profile?: Maybe<Folio_User_Basic_Profile_Mutation_Response>;
  /** delete single row from the table: "folio_user" */
  readonly delete_folio_user_by_pk?: Maybe<Folio_User>;
  /** delete data from the table: "geographical_region" */
  readonly delete_geographical_region?: Maybe<Geographical_Region_Mutation_Response>;
  /** delete single row from the table: "geographical_region" */
  readonly delete_geographical_region_by_pk?: Maybe<Geographical_Region>;
  /** delete data from the table: "global_instrument" */
  readonly delete_global_instrument?: Maybe<Global_Instrument_Mutation_Response>;
  /** delete single row from the table: "global_instrument" */
  readonly delete_global_instrument_by_pk?: Maybe<Global_Instrument>;
  /** delete data from the table: "global_package" */
  readonly delete_global_package?: Maybe<Global_Package_Mutation_Response>;
  /** delete single row from the table: "global_package" */
  readonly delete_global_package_by_pk?: Maybe<Global_Package>;
  /** delete data from the table: "global_permission" */
  readonly delete_global_permission?: Maybe<Global_Permission_Mutation_Response>;
  /** delete single row from the table: "global_permission" */
  readonly delete_global_permission_by_pk?: Maybe<Global_Permission>;
  /** delete data from the table: "global_product" */
  readonly delete_global_product?: Maybe<Global_Product_Mutation_Response>;
  /** delete single row from the table: "global_product" */
  readonly delete_global_product_by_pk?: Maybe<Global_Product>;
  /** delete data from the table: "global_product_config" */
  readonly delete_global_product_config?: Maybe<Global_Product_Config_Mutation_Response>;
  /** delete single row from the table: "global_product_config" */
  readonly delete_global_product_config_by_pk?: Maybe<Global_Product_Config>;
  /** delete data from the table: "grid_charts" */
  readonly delete_grid_charts?: Maybe<Grid_Charts_Mutation_Response>;
  /** delete single row from the table: "grid_charts" */
  readonly delete_grid_charts_by_pk?: Maybe<Grid_Charts>;
  /** delete data from the table: "grid_settings" */
  readonly delete_grid_settings?: Maybe<Grid_Settings_Mutation_Response>;
  /** delete single row from the table: "grid_settings" */
  readonly delete_grid_settings_by_pk?: Maybe<Grid_Settings>;
  /** delete data from the table: "hfc_card_settings" */
  readonly delete_hfc_card_settings?: Maybe<Hfc_Card_Settings_Mutation_Response>;
  /** delete single row from the table: "hfc_card_settings" */
  readonly delete_hfc_card_settings_by_pk?: Maybe<Hfc_Card_Settings>;
  /** delete data from the table: "hfc_user_settings" */
  readonly delete_hfc_user_settings?: Maybe<Hfc_User_Settings_Mutation_Response>;
  /** delete single row from the table: "hfc_user_settings" */
  readonly delete_hfc_user_settings_by_pk?: Maybe<Hfc_User_Settings>;
  /** delete data from the table: "incident_banners" */
  readonly delete_incident_banners?: Maybe<Incident_Banners_Mutation_Response>;
  /** delete single row from the table: "incident_banners" */
  readonly delete_incident_banners_by_pk?: Maybe<Incident_Banners>;
  /** delete data from the table: "live_chart_annotations" */
  readonly delete_live_chart_annotations?: Maybe<Live_Chart_Annotations_Mutation_Response>;
  /** delete single row from the table: "live_chart_annotations" */
  readonly delete_live_chart_annotations_by_pk?: Maybe<Live_Chart_Annotations>;
  /** delete data from the table: "live_chart_page" */
  readonly delete_live_chart_page?: Maybe<Live_Chart_Page_Mutation_Response>;
  /** delete single row from the table: "live_chart_page" */
  readonly delete_live_chart_page_by_pk?: Maybe<Live_Chart_Page>;
  /** delete data from the table: "live_chart_settings" */
  readonly delete_live_chart_settings?: Maybe<Live_Chart_Settings_Mutation_Response>;
  /** delete single row from the table: "live_chart_settings" */
  readonly delete_live_chart_settings_by_pk?: Maybe<Live_Chart_Settings>;
  /** delete data from the table: "local_instrument" */
  readonly delete_local_instrument?: Maybe<Local_Instrument_Mutation_Response>;
  /** delete single row from the table: "local_instrument" */
  readonly delete_local_instrument_by_pk?: Maybe<Local_Instrument>;
  /** delete data from the table: "logout_request" */
  readonly delete_logout_request?: Maybe<Logout_Request_Mutation_Response>;
  /** delete single row from the table: "logout_request" */
  readonly delete_logout_request_by_pk?: Maybe<Logout_Request>;
  /** delete data from the table: "module_storage" */
  readonly delete_module_storage?: Maybe<Module_Storage_Mutation_Response>;
  /** delete single row from the table: "module_storage" */
  readonly delete_module_storage_by_pk?: Maybe<Module_Storage>;
  /** delete data from the table: "organisation" */
  readonly delete_organisation?: Maybe<Organisation_Mutation_Response>;
  /** delete single row from the table: "organisation" */
  readonly delete_organisation_by_pk?: Maybe<Organisation>;
  /** delete data from the table: "package" */
  readonly delete_package?: Maybe<Package_Mutation_Response>;
  /** delete single row from the table: "package" */
  readonly delete_package_by_pk?: Maybe<Package>;
  /** delete data from the table: "package_type" */
  readonly delete_package_type?: Maybe<Package_Type_Mutation_Response>;
  /** delete single row from the table: "package_type" */
  readonly delete_package_type_by_pk?: Maybe<Package_Type>;
  /** delete data from the table: "page_member" */
  readonly delete_page_member?: Maybe<Page_Member_Mutation_Response>;
  /** delete single row from the table: "page_member" */
  readonly delete_page_member_by_pk?: Maybe<Page_Member>;
  /** delete data from the table: "page_products" */
  readonly delete_page_products?: Maybe<Page_Products_Mutation_Response>;
  /** delete single row from the table: "page_products" */
  readonly delete_page_products_by_pk?: Maybe<Page_Products>;
  /** delete data from the table: "page_settings" */
  readonly delete_page_settings?: Maybe<Page_Settings_Mutation_Response>;
  /** delete single row from the table: "page_settings" */
  readonly delete_page_settings_by_pk?: Maybe<Page_Settings>;
  /** delete data from the table: "pages" */
  readonly delete_pages?: Maybe<Pages_Mutation_Response>;
  /** delete single row from the table: "pages" */
  readonly delete_pages_by_pk?: Maybe<Pages>;
  /** delete data from the table: "permission" */
  readonly delete_permission?: Maybe<Permission_Mutation_Response>;
  /** delete single row from the table: "permission" */
  readonly delete_permission_by_pk?: Maybe<Permission>;
  /** delete data from the table: "product" */
  readonly delete_product?: Maybe<Product_Mutation_Response>;
  /** delete data from the table: "product_alerts" */
  readonly delete_product_alerts?: Maybe<Product_Alerts_Mutation_Response>;
  /** delete single row from the table: "product_alerts" */
  readonly delete_product_alerts_by_pk?: Maybe<Product_Alerts>;
  /** delete data from the table: "product_artis_type" */
  readonly delete_product_artis_type?: Maybe<Product_Artis_Type_Mutation_Response>;
  /** delete single row from the table: "product_artis_type" */
  readonly delete_product_artis_type_by_pk?: Maybe<Product_Artis_Type>;
  /** delete single row from the table: "product" */
  readonly delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_config" */
  readonly delete_product_config?: Maybe<Product_Config_Mutation_Response>;
  /** delete single row from the table: "product_config" */
  readonly delete_product_config_by_pk?: Maybe<Product_Config>;
  /** delete data from the table: "product_curve_type" */
  readonly delete_product_curve_type?: Maybe<Product_Curve_Type_Mutation_Response>;
  /** delete single row from the table: "product_curve_type" */
  readonly delete_product_curve_type_by_pk?: Maybe<Product_Curve_Type>;
  /** delete data from the table: "product_eod" */
  readonly delete_product_eod?: Maybe<Product_Eod_Mutation_Response>;
  /** delete single row from the table: "product_eod" */
  readonly delete_product_eod_by_pk?: Maybe<Product_Eod>;
  /** delete data from the table: "product_global_dependencies" */
  readonly delete_product_global_dependencies?: Maybe<Product_Global_Dependencies_Mutation_Response>;
  /** delete single row from the table: "product_global_dependencies" */
  readonly delete_product_global_dependencies_by_pk?: Maybe<Product_Global_Dependencies>;
  /** delete data from the table: "product_maturity" */
  readonly delete_product_maturity?: Maybe<Product_Maturity_Mutation_Response>;
  /** delete single row from the table: "product_maturity" */
  readonly delete_product_maturity_by_pk?: Maybe<Product_Maturity>;
  /** delete data from the table: "product_overrides" */
  readonly delete_product_overrides?: Maybe<Product_Overrides_Mutation_Response>;
  /** delete single row from the table: "product_overrides" */
  readonly delete_product_overrides_by_pk?: Maybe<Product_Overrides>;
  /** delete data from the table: "product_source" */
  readonly delete_product_source?: Maybe<Product_Source_Mutation_Response>;
  /** delete single row from the table: "product_source" */
  readonly delete_product_source_by_pk?: Maybe<Product_Source>;
  /** delete data from the table: "product_summary_type" */
  readonly delete_product_summary_type?: Maybe<Product_Summary_Type_Mutation_Response>;
  /** delete single row from the table: "product_summary_type" */
  readonly delete_product_summary_type_by_pk?: Maybe<Product_Summary_Type>;
  /** delete data from the table: "product_type" */
  readonly delete_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** delete single row from the table: "product_type" */
  readonly delete_product_type_by_pk?: Maybe<Product_Type>;
  /** delete data from the table: "product_uom" */
  readonly delete_product_uom?: Maybe<Product_Uom_Mutation_Response>;
  /** delete single row from the table: "product_uom" */
  readonly delete_product_uom_by_pk?: Maybe<Product_Uom>;
  /** delete data from the table: "product_user_settings" */
  readonly delete_product_user_settings?: Maybe<Product_User_Settings_Mutation_Response>;
  /** delete single row from the table: "product_user_settings" */
  readonly delete_product_user_settings_by_pk?: Maybe<Product_User_Settings>;
  /** delete data from the table: "push_subscriptions" */
  readonly delete_push_subscriptions?: Maybe<Push_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "push_subscriptions" */
  readonly delete_push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** delete data from the table: "quick_access" */
  readonly delete_quick_access?: Maybe<Quick_Access_Mutation_Response>;
  /** delete single row from the table: "quick_access" */
  readonly delete_quick_access_by_pk?: Maybe<Quick_Access>;
  /** delete data from the table: "scratchpad" */
  readonly delete_scratchpad?: Maybe<Scratchpad_Mutation_Response>;
  /** delete single row from the table: "scratchpad" */
  readonly delete_scratchpad_by_pk?: Maybe<Scratchpad>;
  /** delete data from the table: "session" */
  readonly delete_session?: Maybe<Session_Mutation_Response>;
  /** delete single row from the table: "session" */
  readonly delete_session_by_pk?: Maybe<Session>;
  /** delete data from the table: "session_type" */
  readonly delete_session_type?: Maybe<Session_Type_Mutation_Response>;
  /** delete single row from the table: "session_type" */
  readonly delete_session_type_by_pk?: Maybe<Session_Type>;
  /** delete data from the table: "shared_instrument" */
  readonly delete_shared_instrument?: Maybe<Shared_Instrument_Mutation_Response>;
  /** delete single row from the table: "shared_instrument" */
  readonly delete_shared_instrument_by_pk?: Maybe<Shared_Instrument>;
  /** delete data from the table: "sharing_agreement" */
  readonly delete_sharing_agreement?: Maybe<Sharing_Agreement_Mutation_Response>;
  /** delete single row from the table: "sharing_agreement" */
  readonly delete_sharing_agreement_by_pk?: Maybe<Sharing_Agreement>;
  /** delete data from the table: "source" */
  readonly delete_source?: Maybe<Source_Mutation_Response>;
  /** delete single row from the table: "source" */
  readonly delete_source_by_pk?: Maybe<Source>;
  /** delete data from the table: "spreader_state" */
  readonly delete_spreader_state?: Maybe<Spreader_State_Mutation_Response>;
  /** delete single row from the table: "spreader_state" */
  readonly delete_spreader_state_by_pk?: Maybe<Spreader_State>;
  /** delete data from the table: "subscription_tier" */
  readonly delete_subscription_tier?: Maybe<Subscription_Tier_Mutation_Response>;
  /** delete single row from the table: "subscription_tier" */
  readonly delete_subscription_tier_by_pk?: Maybe<Subscription_Tier>;
  /** delete data from the table: "umi_action" */
  readonly delete_umi_action?: Maybe<Umi_Action_Mutation_Response>;
  /** delete single row from the table: "umi_action" */
  readonly delete_umi_action_by_pk?: Maybe<Umi_Action>;
  /** delete data from the table: "umi_action_name" */
  readonly delete_umi_action_name?: Maybe<Umi_Action_Name_Mutation_Response>;
  /** delete single row from the table: "umi_action_name" */
  readonly delete_umi_action_name_by_pk?: Maybe<Umi_Action_Name>;
  /** delete data from the table: "user_entitlement" */
  readonly delete_user_entitlement?: Maybe<User_Entitlement_Mutation_Response>;
  /** delete single row from the table: "user_entitlement" */
  readonly delete_user_entitlement_by_pk?: Maybe<User_Entitlement>;
  /** delete data from the table: "user_entitlement_kind" */
  readonly delete_user_entitlement_kind?: Maybe<User_Entitlement_Kind_Mutation_Response>;
  /** delete single row from the table: "user_entitlement_kind" */
  readonly delete_user_entitlement_kind_by_pk?: Maybe<User_Entitlement_Kind>;
  /** delete data from the table: "user_entitlement_level" */
  readonly delete_user_entitlement_level?: Maybe<User_Entitlement_Level_Mutation_Response>;
  /** delete single row from the table: "user_entitlement_level" */
  readonly delete_user_entitlement_level_by_pk?: Maybe<User_Entitlement_Level>;
  /** delete data from the table: "user_groups" */
  readonly delete_user_groups?: Maybe<User_Groups_Mutation_Response>;
  /** delete single row from the table: "user_groups" */
  readonly delete_user_groups_by_pk?: Maybe<User_Groups>;
  /** delete data from the table: "user_right" */
  readonly delete_user_right?: Maybe<User_Right_Mutation_Response>;
  /** delete single row from the table: "user_right" */
  readonly delete_user_right_by_pk?: Maybe<User_Right>;
  /** delete data from the table: "user_storage" */
  readonly delete_user_storage?: Maybe<User_Storage_Mutation_Response>;
  /** delete single row from the table: "user_storage" */
  readonly delete_user_storage_by_pk?: Maybe<User_Storage>;
  /** delete data from the table: "viewed_announcements" */
  readonly delete_viewed_announcements?: Maybe<Viewed_Announcements_Mutation_Response>;
  /** delete single row from the table: "viewed_announcements" */
  readonly delete_viewed_announcements_by_pk?: Maybe<Viewed_Announcements>;
  /** insert data into the table: "alerts" */
  readonly insert_alerts?: Maybe<Alerts_Mutation_Response>;
  /** insert a single row into the table: "alerts" */
  readonly insert_alerts_one?: Maybe<Alerts>;
  /** insert data into the table: "audit.logged_actions" */
  readonly insert_audit_logged_actions?: Maybe<Audit_Logged_Actions_Mutation_Response>;
  /** insert a single row into the table: "audit.logged_actions" */
  readonly insert_audit_logged_actions_one?: Maybe<Audit_Logged_Actions>;
  /** insert data into the table: "audit.umi_actions" */
  readonly insert_audit_umi_actions?: Maybe<Audit_Umi_Actions_Mutation_Response>;
  /** insert a single row into the table: "audit.umi_actions" */
  readonly insert_audit_umi_actions_one?: Maybe<Audit_Umi_Actions>;
  /** insert data into the table: "commodity_group" */
  readonly insert_commodity_group?: Maybe<Commodity_Group_Mutation_Response>;
  /** insert a single row into the table: "commodity_group" */
  readonly insert_commodity_group_one?: Maybe<Commodity_Group>;
  /** insert data into the table: "commodity_parent_group" */
  readonly insert_commodity_parent_group?: Maybe<Commodity_Parent_Group_Mutation_Response>;
  /** insert a single row into the table: "commodity_parent_group" */
  readonly insert_commodity_parent_group_one?: Maybe<Commodity_Parent_Group>;
  /** insert data into the table: "conditional_formatting_rules" */
  readonly insert_conditional_formatting_rules?: Maybe<Conditional_Formatting_Rules_Mutation_Response>;
  /** insert a single row into the table: "conditional_formatting_rules" */
  readonly insert_conditional_formatting_rules_one?: Maybe<Conditional_Formatting_Rules>;
  /** insert data into the table: "eod" */
  readonly insert_eod?: Maybe<Eod_Mutation_Response>;
  /** insert data into the table: "eod_entry" */
  readonly insert_eod_entry?: Maybe<Eod_Entry_Mutation_Response>;
  /** insert a single row into the table: "eod_entry" */
  readonly insert_eod_entry_one?: Maybe<Eod_Entry>;
  /** insert a single row into the table: "eod" */
  readonly insert_eod_one?: Maybe<Eod>;
  /** insert data into the table: "exchange" */
  readonly insert_exchange?: Maybe<Exchange_Mutation_Response>;
  /** insert data into the table: "exchange_event_type" */
  readonly insert_exchange_event_type?: Maybe<Exchange_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "exchange_event_type" */
  readonly insert_exchange_event_type_one?: Maybe<Exchange_Event_Type>;
  /** insert a single row into the table: "exchange" */
  readonly insert_exchange_one?: Maybe<Exchange>;
  /** insert data into the table: "exchange_usage" */
  readonly insert_exchange_usage?: Maybe<Exchange_Usage_Mutation_Response>;
  /** insert a single row into the table: "exchange_usage" */
  readonly insert_exchange_usage_one?: Maybe<Exchange_Usage>;
  /** insert data into the table: "feature_flags" */
  readonly insert_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "feature_flags" */
  readonly insert_feature_flags_one?: Maybe<Feature_Flags>;
  /** insert data into the table: "folio_shadow_curves" */
  readonly insert_folio_shadow_curves?: Maybe<Folio_Shadow_Curves_Mutation_Response>;
  /** insert a single row into the table: "folio_shadow_curves" */
  readonly insert_folio_shadow_curves_one?: Maybe<Folio_Shadow_Curves>;
  /** insert data into the table: "folio_user" */
  readonly insert_folio_user?: Maybe<Folio_User_Mutation_Response>;
  /** insert data into the table: "folio_user_basic_profile" */
  readonly insert_folio_user_basic_profile?: Maybe<Folio_User_Basic_Profile_Mutation_Response>;
  /** insert a single row into the table: "folio_user_basic_profile" */
  readonly insert_folio_user_basic_profile_one?: Maybe<Folio_User_Basic_Profile>;
  /** insert a single row into the table: "folio_user" */
  readonly insert_folio_user_one?: Maybe<Folio_User>;
  /** insert data into the table: "geographical_region" */
  readonly insert_geographical_region?: Maybe<Geographical_Region_Mutation_Response>;
  /** insert a single row into the table: "geographical_region" */
  readonly insert_geographical_region_one?: Maybe<Geographical_Region>;
  /** insert data into the table: "global_instrument" */
  readonly insert_global_instrument?: Maybe<Global_Instrument_Mutation_Response>;
  /** insert a single row into the table: "global_instrument" */
  readonly insert_global_instrument_one?: Maybe<Global_Instrument>;
  /** insert data into the table: "global_package" */
  readonly insert_global_package?: Maybe<Global_Package_Mutation_Response>;
  /** insert a single row into the table: "global_package" */
  readonly insert_global_package_one?: Maybe<Global_Package>;
  /** insert data into the table: "global_permission" */
  readonly insert_global_permission?: Maybe<Global_Permission_Mutation_Response>;
  /** insert a single row into the table: "global_permission" */
  readonly insert_global_permission_one?: Maybe<Global_Permission>;
  /** insert data into the table: "global_product" */
  readonly insert_global_product?: Maybe<Global_Product_Mutation_Response>;
  /** insert data into the table: "global_product_config" */
  readonly insert_global_product_config?: Maybe<Global_Product_Config_Mutation_Response>;
  /** insert a single row into the table: "global_product_config" */
  readonly insert_global_product_config_one?: Maybe<Global_Product_Config>;
  /** insert a single row into the table: "global_product" */
  readonly insert_global_product_one?: Maybe<Global_Product>;
  /** insert data into the table: "grid_charts" */
  readonly insert_grid_charts?: Maybe<Grid_Charts_Mutation_Response>;
  /** insert a single row into the table: "grid_charts" */
  readonly insert_grid_charts_one?: Maybe<Grid_Charts>;
  /** insert data into the table: "grid_settings" */
  readonly insert_grid_settings?: Maybe<Grid_Settings_Mutation_Response>;
  /** insert a single row into the table: "grid_settings" */
  readonly insert_grid_settings_one?: Maybe<Grid_Settings>;
  /** insert data into the table: "hfc_card_settings" */
  readonly insert_hfc_card_settings?: Maybe<Hfc_Card_Settings_Mutation_Response>;
  /** insert a single row into the table: "hfc_card_settings" */
  readonly insert_hfc_card_settings_one?: Maybe<Hfc_Card_Settings>;
  /** insert data into the table: "hfc_user_settings" */
  readonly insert_hfc_user_settings?: Maybe<Hfc_User_Settings_Mutation_Response>;
  /** insert a single row into the table: "hfc_user_settings" */
  readonly insert_hfc_user_settings_one?: Maybe<Hfc_User_Settings>;
  /** insert data into the table: "incident_banners" */
  readonly insert_incident_banners?: Maybe<Incident_Banners_Mutation_Response>;
  /** insert a single row into the table: "incident_banners" */
  readonly insert_incident_banners_one?: Maybe<Incident_Banners>;
  /** insert data into the table: "live_chart_annotations" */
  readonly insert_live_chart_annotations?: Maybe<Live_Chart_Annotations_Mutation_Response>;
  /** insert a single row into the table: "live_chart_annotations" */
  readonly insert_live_chart_annotations_one?: Maybe<Live_Chart_Annotations>;
  /** insert data into the table: "live_chart_page" */
  readonly insert_live_chart_page?: Maybe<Live_Chart_Page_Mutation_Response>;
  /** insert a single row into the table: "live_chart_page" */
  readonly insert_live_chart_page_one?: Maybe<Live_Chart_Page>;
  /** insert data into the table: "live_chart_settings" */
  readonly insert_live_chart_settings?: Maybe<Live_Chart_Settings_Mutation_Response>;
  /** insert a single row into the table: "live_chart_settings" */
  readonly insert_live_chart_settings_one?: Maybe<Live_Chart_Settings>;
  /** insert data into the table: "local_instrument" */
  readonly insert_local_instrument?: Maybe<Local_Instrument_Mutation_Response>;
  /** insert a single row into the table: "local_instrument" */
  readonly insert_local_instrument_one?: Maybe<Local_Instrument>;
  /** insert data into the table: "logout_request" */
  readonly insert_logout_request?: Maybe<Logout_Request_Mutation_Response>;
  /** insert a single row into the table: "logout_request" */
  readonly insert_logout_request_one?: Maybe<Logout_Request>;
  /** insert data into the table: "module_storage" */
  readonly insert_module_storage?: Maybe<Module_Storage_Mutation_Response>;
  /** insert a single row into the table: "module_storage" */
  readonly insert_module_storage_one?: Maybe<Module_Storage>;
  /** insert data into the table: "organisation" */
  readonly insert_organisation?: Maybe<Organisation_Mutation_Response>;
  /** insert a single row into the table: "organisation" */
  readonly insert_organisation_one?: Maybe<Organisation>;
  /** insert data into the table: "package" */
  readonly insert_package?: Maybe<Package_Mutation_Response>;
  /** insert a single row into the table: "package" */
  readonly insert_package_one?: Maybe<Package>;
  /** insert data into the table: "package_type" */
  readonly insert_package_type?: Maybe<Package_Type_Mutation_Response>;
  /** insert a single row into the table: "package_type" */
  readonly insert_package_type_one?: Maybe<Package_Type>;
  /** insert data into the table: "page_member" */
  readonly insert_page_member?: Maybe<Page_Member_Mutation_Response>;
  /** insert a single row into the table: "page_member" */
  readonly insert_page_member_one?: Maybe<Page_Member>;
  /** insert data into the table: "page_products" */
  readonly insert_page_products?: Maybe<Page_Products_Mutation_Response>;
  /** insert a single row into the table: "page_products" */
  readonly insert_page_products_one?: Maybe<Page_Products>;
  /** insert data into the table: "page_settings" */
  readonly insert_page_settings?: Maybe<Page_Settings_Mutation_Response>;
  /** insert a single row into the table: "page_settings" */
  readonly insert_page_settings_one?: Maybe<Page_Settings>;
  /** insert data into the table: "pages" */
  readonly insert_pages?: Maybe<Pages_Mutation_Response>;
  /** insert a single row into the table: "pages" */
  readonly insert_pages_one?: Maybe<Pages>;
  /** insert data into the table: "permission" */
  readonly insert_permission?: Maybe<Permission_Mutation_Response>;
  /** insert a single row into the table: "permission" */
  readonly insert_permission_one?: Maybe<Permission>;
  /** insert data into the table: "product" */
  readonly insert_product?: Maybe<Product_Mutation_Response>;
  /** insert data into the table: "product_alerts" */
  readonly insert_product_alerts?: Maybe<Product_Alerts_Mutation_Response>;
  /** insert a single row into the table: "product_alerts" */
  readonly insert_product_alerts_one?: Maybe<Product_Alerts>;
  /** insert data into the table: "product_artis_type" */
  readonly insert_product_artis_type?: Maybe<Product_Artis_Type_Mutation_Response>;
  /** insert a single row into the table: "product_artis_type" */
  readonly insert_product_artis_type_one?: Maybe<Product_Artis_Type>;
  /** insert data into the table: "product_config" */
  readonly insert_product_config?: Maybe<Product_Config_Mutation_Response>;
  /** insert a single row into the table: "product_config" */
  readonly insert_product_config_one?: Maybe<Product_Config>;
  /** insert data into the table: "product_curve_type" */
  readonly insert_product_curve_type?: Maybe<Product_Curve_Type_Mutation_Response>;
  /** insert a single row into the table: "product_curve_type" */
  readonly insert_product_curve_type_one?: Maybe<Product_Curve_Type>;
  /** insert data into the table: "product_eod" */
  readonly insert_product_eod?: Maybe<Product_Eod_Mutation_Response>;
  /** insert a single row into the table: "product_eod" */
  readonly insert_product_eod_one?: Maybe<Product_Eod>;
  /** insert data into the table: "product_global_dependencies" */
  readonly insert_product_global_dependencies?: Maybe<Product_Global_Dependencies_Mutation_Response>;
  /** insert a single row into the table: "product_global_dependencies" */
  readonly insert_product_global_dependencies_one?: Maybe<Product_Global_Dependencies>;
  /** insert data into the table: "product_maturity" */
  readonly insert_product_maturity?: Maybe<Product_Maturity_Mutation_Response>;
  /** insert a single row into the table: "product_maturity" */
  readonly insert_product_maturity_one?: Maybe<Product_Maturity>;
  /** insert a single row into the table: "product" */
  readonly insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_overrides" */
  readonly insert_product_overrides?: Maybe<Product_Overrides_Mutation_Response>;
  /** insert a single row into the table: "product_overrides" */
  readonly insert_product_overrides_one?: Maybe<Product_Overrides>;
  /** insert data into the table: "product_source" */
  readonly insert_product_source?: Maybe<Product_Source_Mutation_Response>;
  /** insert a single row into the table: "product_source" */
  readonly insert_product_source_one?: Maybe<Product_Source>;
  /** insert data into the table: "product_summary_type" */
  readonly insert_product_summary_type?: Maybe<Product_Summary_Type_Mutation_Response>;
  /** insert a single row into the table: "product_summary_type" */
  readonly insert_product_summary_type_one?: Maybe<Product_Summary_Type>;
  /** insert data into the table: "product_type" */
  readonly insert_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** insert a single row into the table: "product_type" */
  readonly insert_product_type_one?: Maybe<Product_Type>;
  /** insert data into the table: "product_uom" */
  readonly insert_product_uom?: Maybe<Product_Uom_Mutation_Response>;
  /** insert a single row into the table: "product_uom" */
  readonly insert_product_uom_one?: Maybe<Product_Uom>;
  /** insert data into the table: "product_user_settings" */
  readonly insert_product_user_settings?: Maybe<Product_User_Settings_Mutation_Response>;
  /** insert a single row into the table: "product_user_settings" */
  readonly insert_product_user_settings_one?: Maybe<Product_User_Settings>;
  /** insert data into the table: "push_subscriptions" */
  readonly insert_push_subscriptions?: Maybe<Push_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "push_subscriptions" */
  readonly insert_push_subscriptions_one?: Maybe<Push_Subscriptions>;
  /** insert data into the table: "quick_access" */
  readonly insert_quick_access?: Maybe<Quick_Access_Mutation_Response>;
  /** insert a single row into the table: "quick_access" */
  readonly insert_quick_access_one?: Maybe<Quick_Access>;
  /** insert data into the table: "scratchpad" */
  readonly insert_scratchpad?: Maybe<Scratchpad_Mutation_Response>;
  /** insert a single row into the table: "scratchpad" */
  readonly insert_scratchpad_one?: Maybe<Scratchpad>;
  /** insert data into the table: "session" */
  readonly insert_session?: Maybe<Session_Mutation_Response>;
  /** insert a single row into the table: "session" */
  readonly insert_session_one?: Maybe<Session>;
  /** insert data into the table: "session_type" */
  readonly insert_session_type?: Maybe<Session_Type_Mutation_Response>;
  /** insert a single row into the table: "session_type" */
  readonly insert_session_type_one?: Maybe<Session_Type>;
  /** insert data into the table: "shared_instrument" */
  readonly insert_shared_instrument?: Maybe<Shared_Instrument_Mutation_Response>;
  /** insert a single row into the table: "shared_instrument" */
  readonly insert_shared_instrument_one?: Maybe<Shared_Instrument>;
  /** insert data into the table: "sharing_agreement" */
  readonly insert_sharing_agreement?: Maybe<Sharing_Agreement_Mutation_Response>;
  /** insert a single row into the table: "sharing_agreement" */
  readonly insert_sharing_agreement_one?: Maybe<Sharing_Agreement>;
  /** insert data into the table: "source" */
  readonly insert_source?: Maybe<Source_Mutation_Response>;
  /** insert a single row into the table: "source" */
  readonly insert_source_one?: Maybe<Source>;
  /** insert data into the table: "spreader_state" */
  readonly insert_spreader_state?: Maybe<Spreader_State_Mutation_Response>;
  /** insert a single row into the table: "spreader_state" */
  readonly insert_spreader_state_one?: Maybe<Spreader_State>;
  /** insert data into the table: "subscription_tier" */
  readonly insert_subscription_tier?: Maybe<Subscription_Tier_Mutation_Response>;
  /** insert a single row into the table: "subscription_tier" */
  readonly insert_subscription_tier_one?: Maybe<Subscription_Tier>;
  /** insert data into the table: "umi_action" */
  readonly insert_umi_action?: Maybe<Umi_Action_Mutation_Response>;
  /** insert data into the table: "umi_action_name" */
  readonly insert_umi_action_name?: Maybe<Umi_Action_Name_Mutation_Response>;
  /** insert a single row into the table: "umi_action_name" */
  readonly insert_umi_action_name_one?: Maybe<Umi_Action_Name>;
  /** insert a single row into the table: "umi_action" */
  readonly insert_umi_action_one?: Maybe<Umi_Action>;
  /** insert data into the table: "user_entitlement" */
  readonly insert_user_entitlement?: Maybe<User_Entitlement_Mutation_Response>;
  /** insert data into the table: "user_entitlement_kind" */
  readonly insert_user_entitlement_kind?: Maybe<User_Entitlement_Kind_Mutation_Response>;
  /** insert a single row into the table: "user_entitlement_kind" */
  readonly insert_user_entitlement_kind_one?: Maybe<User_Entitlement_Kind>;
  /** insert data into the table: "user_entitlement_level" */
  readonly insert_user_entitlement_level?: Maybe<User_Entitlement_Level_Mutation_Response>;
  /** insert a single row into the table: "user_entitlement_level" */
  readonly insert_user_entitlement_level_one?: Maybe<User_Entitlement_Level>;
  /** insert a single row into the table: "user_entitlement" */
  readonly insert_user_entitlement_one?: Maybe<User_Entitlement>;
  /** insert data into the table: "user_groups" */
  readonly insert_user_groups?: Maybe<User_Groups_Mutation_Response>;
  /** insert a single row into the table: "user_groups" */
  readonly insert_user_groups_one?: Maybe<User_Groups>;
  /** insert data into the table: "user_right" */
  readonly insert_user_right?: Maybe<User_Right_Mutation_Response>;
  /** insert a single row into the table: "user_right" */
  readonly insert_user_right_one?: Maybe<User_Right>;
  /** insert data into the table: "user_storage" */
  readonly insert_user_storage?: Maybe<User_Storage_Mutation_Response>;
  /** insert a single row into the table: "user_storage" */
  readonly insert_user_storage_one?: Maybe<User_Storage>;
  /** insert data into the table: "viewed_announcements" */
  readonly insert_viewed_announcements?: Maybe<Viewed_Announcements_Mutation_Response>;
  /** insert a single row into the table: "viewed_announcements" */
  readonly insert_viewed_announcements_one?: Maybe<Viewed_Announcements>;
  /** update data of the table: "alerts" */
  readonly update_alerts?: Maybe<Alerts_Mutation_Response>;
  /** update single row of the table: "alerts" */
  readonly update_alerts_by_pk?: Maybe<Alerts>;
  /** update multiples rows of table: "alerts" */
  readonly update_alerts_many?: Maybe<ReadonlyArray<Maybe<Alerts_Mutation_Response>>>;
  /** update data of the table: "audit.logged_actions" */
  readonly update_audit_logged_actions?: Maybe<Audit_Logged_Actions_Mutation_Response>;
  /** update single row of the table: "audit.logged_actions" */
  readonly update_audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** update multiples rows of table: "audit.logged_actions" */
  readonly update_audit_logged_actions_many?: Maybe<ReadonlyArray<Maybe<Audit_Logged_Actions_Mutation_Response>>>;
  /** update data of the table: "audit.umi_actions" */
  readonly update_audit_umi_actions?: Maybe<Audit_Umi_Actions_Mutation_Response>;
  /** update single row of the table: "audit.umi_actions" */
  readonly update_audit_umi_actions_by_pk?: Maybe<Audit_Umi_Actions>;
  /** update multiples rows of table: "audit.umi_actions" */
  readonly update_audit_umi_actions_many?: Maybe<ReadonlyArray<Maybe<Audit_Umi_Actions_Mutation_Response>>>;
  /** update data of the table: "commodity_group" */
  readonly update_commodity_group?: Maybe<Commodity_Group_Mutation_Response>;
  /** update single row of the table: "commodity_group" */
  readonly update_commodity_group_by_pk?: Maybe<Commodity_Group>;
  /** update multiples rows of table: "commodity_group" */
  readonly update_commodity_group_many?: Maybe<ReadonlyArray<Maybe<Commodity_Group_Mutation_Response>>>;
  /** update data of the table: "commodity_parent_group" */
  readonly update_commodity_parent_group?: Maybe<Commodity_Parent_Group_Mutation_Response>;
  /** update single row of the table: "commodity_parent_group" */
  readonly update_commodity_parent_group_by_pk?: Maybe<Commodity_Parent_Group>;
  /** update multiples rows of table: "commodity_parent_group" */
  readonly update_commodity_parent_group_many?: Maybe<ReadonlyArray<Maybe<Commodity_Parent_Group_Mutation_Response>>>;
  /** update data of the table: "conditional_formatting_rules" */
  readonly update_conditional_formatting_rules?: Maybe<Conditional_Formatting_Rules_Mutation_Response>;
  /** update single row of the table: "conditional_formatting_rules" */
  readonly update_conditional_formatting_rules_by_pk?: Maybe<Conditional_Formatting_Rules>;
  /** update multiples rows of table: "conditional_formatting_rules" */
  readonly update_conditional_formatting_rules_many?: Maybe<ReadonlyArray<Maybe<Conditional_Formatting_Rules_Mutation_Response>>>;
  /** update data of the table: "eod" */
  readonly update_eod?: Maybe<Eod_Mutation_Response>;
  /** update single row of the table: "eod" */
  readonly update_eod_by_pk?: Maybe<Eod>;
  /** update data of the table: "eod_entry" */
  readonly update_eod_entry?: Maybe<Eod_Entry_Mutation_Response>;
  /** update single row of the table: "eod_entry" */
  readonly update_eod_entry_by_pk?: Maybe<Eod_Entry>;
  /** update multiples rows of table: "eod_entry" */
  readonly update_eod_entry_many?: Maybe<ReadonlyArray<Maybe<Eod_Entry_Mutation_Response>>>;
  /** update multiples rows of table: "eod" */
  readonly update_eod_many?: Maybe<ReadonlyArray<Maybe<Eod_Mutation_Response>>>;
  /** update data of the table: "exchange" */
  readonly update_exchange?: Maybe<Exchange_Mutation_Response>;
  /** update single row of the table: "exchange" */
  readonly update_exchange_by_pk?: Maybe<Exchange>;
  /** update data of the table: "exchange_event_type" */
  readonly update_exchange_event_type?: Maybe<Exchange_Event_Type_Mutation_Response>;
  /** update single row of the table: "exchange_event_type" */
  readonly update_exchange_event_type_by_pk?: Maybe<Exchange_Event_Type>;
  /** update multiples rows of table: "exchange_event_type" */
  readonly update_exchange_event_type_many?: Maybe<ReadonlyArray<Maybe<Exchange_Event_Type_Mutation_Response>>>;
  /** update multiples rows of table: "exchange" */
  readonly update_exchange_many?: Maybe<ReadonlyArray<Maybe<Exchange_Mutation_Response>>>;
  /** update data of the table: "exchange_usage" */
  readonly update_exchange_usage?: Maybe<Exchange_Usage_Mutation_Response>;
  /** update single row of the table: "exchange_usage" */
  readonly update_exchange_usage_by_pk?: Maybe<Exchange_Usage>;
  /** update multiples rows of table: "exchange_usage" */
  readonly update_exchange_usage_many?: Maybe<ReadonlyArray<Maybe<Exchange_Usage_Mutation_Response>>>;
  /** update data of the table: "feature_flags" */
  readonly update_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** update single row of the table: "feature_flags" */
  readonly update_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** update multiples rows of table: "feature_flags" */
  readonly update_feature_flags_many?: Maybe<ReadonlyArray<Maybe<Feature_Flags_Mutation_Response>>>;
  /** update data of the table: "folio_shadow_curves" */
  readonly update_folio_shadow_curves?: Maybe<Folio_Shadow_Curves_Mutation_Response>;
  /** update single row of the table: "folio_shadow_curves" */
  readonly update_folio_shadow_curves_by_pk?: Maybe<Folio_Shadow_Curves>;
  /** update multiples rows of table: "folio_shadow_curves" */
  readonly update_folio_shadow_curves_many?: Maybe<ReadonlyArray<Maybe<Folio_Shadow_Curves_Mutation_Response>>>;
  /** update data of the table: "folio_user" */
  readonly update_folio_user?: Maybe<Folio_User_Mutation_Response>;
  /** update data of the table: "folio_user_basic_profile" */
  readonly update_folio_user_basic_profile?: Maybe<Folio_User_Basic_Profile_Mutation_Response>;
  /** update multiples rows of table: "folio_user_basic_profile" */
  readonly update_folio_user_basic_profile_many?: Maybe<ReadonlyArray<Maybe<Folio_User_Basic_Profile_Mutation_Response>>>;
  /** update single row of the table: "folio_user" */
  readonly update_folio_user_by_pk?: Maybe<Folio_User>;
  /** update multiples rows of table: "folio_user" */
  readonly update_folio_user_many?: Maybe<ReadonlyArray<Maybe<Folio_User_Mutation_Response>>>;
  /** update data of the table: "geographical_region" */
  readonly update_geographical_region?: Maybe<Geographical_Region_Mutation_Response>;
  /** update single row of the table: "geographical_region" */
  readonly update_geographical_region_by_pk?: Maybe<Geographical_Region>;
  /** update multiples rows of table: "geographical_region" */
  readonly update_geographical_region_many?: Maybe<ReadonlyArray<Maybe<Geographical_Region_Mutation_Response>>>;
  /** update data of the table: "global_instrument" */
  readonly update_global_instrument?: Maybe<Global_Instrument_Mutation_Response>;
  /** update single row of the table: "global_instrument" */
  readonly update_global_instrument_by_pk?: Maybe<Global_Instrument>;
  /** update multiples rows of table: "global_instrument" */
  readonly update_global_instrument_many?: Maybe<ReadonlyArray<Maybe<Global_Instrument_Mutation_Response>>>;
  /** update data of the table: "global_package" */
  readonly update_global_package?: Maybe<Global_Package_Mutation_Response>;
  /** update single row of the table: "global_package" */
  readonly update_global_package_by_pk?: Maybe<Global_Package>;
  /** update multiples rows of table: "global_package" */
  readonly update_global_package_many?: Maybe<ReadonlyArray<Maybe<Global_Package_Mutation_Response>>>;
  /** update data of the table: "global_permission" */
  readonly update_global_permission?: Maybe<Global_Permission_Mutation_Response>;
  /** update single row of the table: "global_permission" */
  readonly update_global_permission_by_pk?: Maybe<Global_Permission>;
  /** update multiples rows of table: "global_permission" */
  readonly update_global_permission_many?: Maybe<ReadonlyArray<Maybe<Global_Permission_Mutation_Response>>>;
  /** update data of the table: "global_product" */
  readonly update_global_product?: Maybe<Global_Product_Mutation_Response>;
  /** update single row of the table: "global_product" */
  readonly update_global_product_by_pk?: Maybe<Global_Product>;
  /** update data of the table: "global_product_config" */
  readonly update_global_product_config?: Maybe<Global_Product_Config_Mutation_Response>;
  /** update single row of the table: "global_product_config" */
  readonly update_global_product_config_by_pk?: Maybe<Global_Product_Config>;
  /** update multiples rows of table: "global_product_config" */
  readonly update_global_product_config_many?: Maybe<ReadonlyArray<Maybe<Global_Product_Config_Mutation_Response>>>;
  /** update multiples rows of table: "global_product" */
  readonly update_global_product_many?: Maybe<ReadonlyArray<Maybe<Global_Product_Mutation_Response>>>;
  /** update data of the table: "grid_charts" */
  readonly update_grid_charts?: Maybe<Grid_Charts_Mutation_Response>;
  /** update single row of the table: "grid_charts" */
  readonly update_grid_charts_by_pk?: Maybe<Grid_Charts>;
  /** update multiples rows of table: "grid_charts" */
  readonly update_grid_charts_many?: Maybe<ReadonlyArray<Maybe<Grid_Charts_Mutation_Response>>>;
  /** update data of the table: "grid_settings" */
  readonly update_grid_settings?: Maybe<Grid_Settings_Mutation_Response>;
  /** update single row of the table: "grid_settings" */
  readonly update_grid_settings_by_pk?: Maybe<Grid_Settings>;
  /** update multiples rows of table: "grid_settings" */
  readonly update_grid_settings_many?: Maybe<ReadonlyArray<Maybe<Grid_Settings_Mutation_Response>>>;
  /** update data of the table: "hfc_card_settings" */
  readonly update_hfc_card_settings?: Maybe<Hfc_Card_Settings_Mutation_Response>;
  /** update single row of the table: "hfc_card_settings" */
  readonly update_hfc_card_settings_by_pk?: Maybe<Hfc_Card_Settings>;
  /** update multiples rows of table: "hfc_card_settings" */
  readonly update_hfc_card_settings_many?: Maybe<ReadonlyArray<Maybe<Hfc_Card_Settings_Mutation_Response>>>;
  /** update data of the table: "hfc_user_settings" */
  readonly update_hfc_user_settings?: Maybe<Hfc_User_Settings_Mutation_Response>;
  /** update single row of the table: "hfc_user_settings" */
  readonly update_hfc_user_settings_by_pk?: Maybe<Hfc_User_Settings>;
  /** update multiples rows of table: "hfc_user_settings" */
  readonly update_hfc_user_settings_many?: Maybe<ReadonlyArray<Maybe<Hfc_User_Settings_Mutation_Response>>>;
  /** update data of the table: "incident_banners" */
  readonly update_incident_banners?: Maybe<Incident_Banners_Mutation_Response>;
  /** update single row of the table: "incident_banners" */
  readonly update_incident_banners_by_pk?: Maybe<Incident_Banners>;
  /** update multiples rows of table: "incident_banners" */
  readonly update_incident_banners_many?: Maybe<ReadonlyArray<Maybe<Incident_Banners_Mutation_Response>>>;
  /** update data of the table: "live_chart_annotations" */
  readonly update_live_chart_annotations?: Maybe<Live_Chart_Annotations_Mutation_Response>;
  /** update single row of the table: "live_chart_annotations" */
  readonly update_live_chart_annotations_by_pk?: Maybe<Live_Chart_Annotations>;
  /** update multiples rows of table: "live_chart_annotations" */
  readonly update_live_chart_annotations_many?: Maybe<ReadonlyArray<Maybe<Live_Chart_Annotations_Mutation_Response>>>;
  /** update data of the table: "live_chart_page" */
  readonly update_live_chart_page?: Maybe<Live_Chart_Page_Mutation_Response>;
  /** update single row of the table: "live_chart_page" */
  readonly update_live_chart_page_by_pk?: Maybe<Live_Chart_Page>;
  /** update multiples rows of table: "live_chart_page" */
  readonly update_live_chart_page_many?: Maybe<ReadonlyArray<Maybe<Live_Chart_Page_Mutation_Response>>>;
  /** update data of the table: "live_chart_settings" */
  readonly update_live_chart_settings?: Maybe<Live_Chart_Settings_Mutation_Response>;
  /** update single row of the table: "live_chart_settings" */
  readonly update_live_chart_settings_by_pk?: Maybe<Live_Chart_Settings>;
  /** update multiples rows of table: "live_chart_settings" */
  readonly update_live_chart_settings_many?: Maybe<ReadonlyArray<Maybe<Live_Chart_Settings_Mutation_Response>>>;
  /** update data of the table: "local_instrument" */
  readonly update_local_instrument?: Maybe<Local_Instrument_Mutation_Response>;
  /** update single row of the table: "local_instrument" */
  readonly update_local_instrument_by_pk?: Maybe<Local_Instrument>;
  /** update multiples rows of table: "local_instrument" */
  readonly update_local_instrument_many?: Maybe<ReadonlyArray<Maybe<Local_Instrument_Mutation_Response>>>;
  /** update data of the table: "logout_request" */
  readonly update_logout_request?: Maybe<Logout_Request_Mutation_Response>;
  /** update single row of the table: "logout_request" */
  readonly update_logout_request_by_pk?: Maybe<Logout_Request>;
  /** update multiples rows of table: "logout_request" */
  readonly update_logout_request_many?: Maybe<ReadonlyArray<Maybe<Logout_Request_Mutation_Response>>>;
  /** update data of the table: "module_storage" */
  readonly update_module_storage?: Maybe<Module_Storage_Mutation_Response>;
  /** update single row of the table: "module_storage" */
  readonly update_module_storage_by_pk?: Maybe<Module_Storage>;
  /** update multiples rows of table: "module_storage" */
  readonly update_module_storage_many?: Maybe<ReadonlyArray<Maybe<Module_Storage_Mutation_Response>>>;
  /** update data of the table: "organisation" */
  readonly update_organisation?: Maybe<Organisation_Mutation_Response>;
  /** update single row of the table: "organisation" */
  readonly update_organisation_by_pk?: Maybe<Organisation>;
  /** update multiples rows of table: "organisation" */
  readonly update_organisation_many?: Maybe<ReadonlyArray<Maybe<Organisation_Mutation_Response>>>;
  /** update data of the table: "package" */
  readonly update_package?: Maybe<Package_Mutation_Response>;
  /** update single row of the table: "package" */
  readonly update_package_by_pk?: Maybe<Package>;
  /** update multiples rows of table: "package" */
  readonly update_package_many?: Maybe<ReadonlyArray<Maybe<Package_Mutation_Response>>>;
  /** update data of the table: "package_type" */
  readonly update_package_type?: Maybe<Package_Type_Mutation_Response>;
  /** update single row of the table: "package_type" */
  readonly update_package_type_by_pk?: Maybe<Package_Type>;
  /** update multiples rows of table: "package_type" */
  readonly update_package_type_many?: Maybe<ReadonlyArray<Maybe<Package_Type_Mutation_Response>>>;
  /** update data of the table: "page_member" */
  readonly update_page_member?: Maybe<Page_Member_Mutation_Response>;
  /** update single row of the table: "page_member" */
  readonly update_page_member_by_pk?: Maybe<Page_Member>;
  /** update multiples rows of table: "page_member" */
  readonly update_page_member_many?: Maybe<ReadonlyArray<Maybe<Page_Member_Mutation_Response>>>;
  /** update data of the table: "page_products" */
  readonly update_page_products?: Maybe<Page_Products_Mutation_Response>;
  /** update single row of the table: "page_products" */
  readonly update_page_products_by_pk?: Maybe<Page_Products>;
  /** update multiples rows of table: "page_products" */
  readonly update_page_products_many?: Maybe<ReadonlyArray<Maybe<Page_Products_Mutation_Response>>>;
  /** update data of the table: "page_settings" */
  readonly update_page_settings?: Maybe<Page_Settings_Mutation_Response>;
  /** update single row of the table: "page_settings" */
  readonly update_page_settings_by_pk?: Maybe<Page_Settings>;
  /** update multiples rows of table: "page_settings" */
  readonly update_page_settings_many?: Maybe<ReadonlyArray<Maybe<Page_Settings_Mutation_Response>>>;
  /** update data of the table: "pages" */
  readonly update_pages?: Maybe<Pages_Mutation_Response>;
  /** update single row of the table: "pages" */
  readonly update_pages_by_pk?: Maybe<Pages>;
  /** update multiples rows of table: "pages" */
  readonly update_pages_many?: Maybe<ReadonlyArray<Maybe<Pages_Mutation_Response>>>;
  /** update data of the table: "permission" */
  readonly update_permission?: Maybe<Permission_Mutation_Response>;
  /** update single row of the table: "permission" */
  readonly update_permission_by_pk?: Maybe<Permission>;
  /** update multiples rows of table: "permission" */
  readonly update_permission_many?: Maybe<ReadonlyArray<Maybe<Permission_Mutation_Response>>>;
  /** update data of the table: "product" */
  readonly update_product?: Maybe<Product_Mutation_Response>;
  /** update data of the table: "product_alerts" */
  readonly update_product_alerts?: Maybe<Product_Alerts_Mutation_Response>;
  /** update single row of the table: "product_alerts" */
  readonly update_product_alerts_by_pk?: Maybe<Product_Alerts>;
  /** update multiples rows of table: "product_alerts" */
  readonly update_product_alerts_many?: Maybe<ReadonlyArray<Maybe<Product_Alerts_Mutation_Response>>>;
  /** update data of the table: "product_artis_type" */
  readonly update_product_artis_type?: Maybe<Product_Artis_Type_Mutation_Response>;
  /** update single row of the table: "product_artis_type" */
  readonly update_product_artis_type_by_pk?: Maybe<Product_Artis_Type>;
  /** update multiples rows of table: "product_artis_type" */
  readonly update_product_artis_type_many?: Maybe<ReadonlyArray<Maybe<Product_Artis_Type_Mutation_Response>>>;
  /** update single row of the table: "product" */
  readonly update_product_by_pk?: Maybe<Product>;
  /** update data of the table: "product_config" */
  readonly update_product_config?: Maybe<Product_Config_Mutation_Response>;
  /** update single row of the table: "product_config" */
  readonly update_product_config_by_pk?: Maybe<Product_Config>;
  /** update multiples rows of table: "product_config" */
  readonly update_product_config_many?: Maybe<ReadonlyArray<Maybe<Product_Config_Mutation_Response>>>;
  /** update data of the table: "product_curve_type" */
  readonly update_product_curve_type?: Maybe<Product_Curve_Type_Mutation_Response>;
  /** update single row of the table: "product_curve_type" */
  readonly update_product_curve_type_by_pk?: Maybe<Product_Curve_Type>;
  /** update multiples rows of table: "product_curve_type" */
  readonly update_product_curve_type_many?: Maybe<ReadonlyArray<Maybe<Product_Curve_Type_Mutation_Response>>>;
  /** update data of the table: "product_eod" */
  readonly update_product_eod?: Maybe<Product_Eod_Mutation_Response>;
  /** update single row of the table: "product_eod" */
  readonly update_product_eod_by_pk?: Maybe<Product_Eod>;
  /** update multiples rows of table: "product_eod" */
  readonly update_product_eod_many?: Maybe<ReadonlyArray<Maybe<Product_Eod_Mutation_Response>>>;
  /** update data of the table: "product_global_dependencies" */
  readonly update_product_global_dependencies?: Maybe<Product_Global_Dependencies_Mutation_Response>;
  /** update single row of the table: "product_global_dependencies" */
  readonly update_product_global_dependencies_by_pk?: Maybe<Product_Global_Dependencies>;
  /** update multiples rows of table: "product_global_dependencies" */
  readonly update_product_global_dependencies_many?: Maybe<ReadonlyArray<Maybe<Product_Global_Dependencies_Mutation_Response>>>;
  /** update multiples rows of table: "product" */
  readonly update_product_many?: Maybe<ReadonlyArray<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_maturity" */
  readonly update_product_maturity?: Maybe<Product_Maturity_Mutation_Response>;
  /** update single row of the table: "product_maturity" */
  readonly update_product_maturity_by_pk?: Maybe<Product_Maturity>;
  /** update multiples rows of table: "product_maturity" */
  readonly update_product_maturity_many?: Maybe<ReadonlyArray<Maybe<Product_Maturity_Mutation_Response>>>;
  /** update data of the table: "product_overrides" */
  readonly update_product_overrides?: Maybe<Product_Overrides_Mutation_Response>;
  /** update single row of the table: "product_overrides" */
  readonly update_product_overrides_by_pk?: Maybe<Product_Overrides>;
  /** update multiples rows of table: "product_overrides" */
  readonly update_product_overrides_many?: Maybe<ReadonlyArray<Maybe<Product_Overrides_Mutation_Response>>>;
  /** update data of the table: "product_source" */
  readonly update_product_source?: Maybe<Product_Source_Mutation_Response>;
  /** update single row of the table: "product_source" */
  readonly update_product_source_by_pk?: Maybe<Product_Source>;
  /** update multiples rows of table: "product_source" */
  readonly update_product_source_many?: Maybe<ReadonlyArray<Maybe<Product_Source_Mutation_Response>>>;
  /** update data of the table: "product_summary_type" */
  readonly update_product_summary_type?: Maybe<Product_Summary_Type_Mutation_Response>;
  /** update single row of the table: "product_summary_type" */
  readonly update_product_summary_type_by_pk?: Maybe<Product_Summary_Type>;
  /** update multiples rows of table: "product_summary_type" */
  readonly update_product_summary_type_many?: Maybe<ReadonlyArray<Maybe<Product_Summary_Type_Mutation_Response>>>;
  /** update data of the table: "product_type" */
  readonly update_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** update single row of the table: "product_type" */
  readonly update_product_type_by_pk?: Maybe<Product_Type>;
  /** update multiples rows of table: "product_type" */
  readonly update_product_type_many?: Maybe<ReadonlyArray<Maybe<Product_Type_Mutation_Response>>>;
  /** update data of the table: "product_uom" */
  readonly update_product_uom?: Maybe<Product_Uom_Mutation_Response>;
  /** update single row of the table: "product_uom" */
  readonly update_product_uom_by_pk?: Maybe<Product_Uom>;
  /** update multiples rows of table: "product_uom" */
  readonly update_product_uom_many?: Maybe<ReadonlyArray<Maybe<Product_Uom_Mutation_Response>>>;
  /** update data of the table: "product_user_settings" */
  readonly update_product_user_settings?: Maybe<Product_User_Settings_Mutation_Response>;
  /** update single row of the table: "product_user_settings" */
  readonly update_product_user_settings_by_pk?: Maybe<Product_User_Settings>;
  /** update multiples rows of table: "product_user_settings" */
  readonly update_product_user_settings_many?: Maybe<ReadonlyArray<Maybe<Product_User_Settings_Mutation_Response>>>;
  /** update data of the table: "push_subscriptions" */
  readonly update_push_subscriptions?: Maybe<Push_Subscriptions_Mutation_Response>;
  /** update single row of the table: "push_subscriptions" */
  readonly update_push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** update multiples rows of table: "push_subscriptions" */
  readonly update_push_subscriptions_many?: Maybe<ReadonlyArray<Maybe<Push_Subscriptions_Mutation_Response>>>;
  /** update data of the table: "quick_access" */
  readonly update_quick_access?: Maybe<Quick_Access_Mutation_Response>;
  /** update single row of the table: "quick_access" */
  readonly update_quick_access_by_pk?: Maybe<Quick_Access>;
  /** update multiples rows of table: "quick_access" */
  readonly update_quick_access_many?: Maybe<ReadonlyArray<Maybe<Quick_Access_Mutation_Response>>>;
  /** update data of the table: "scratchpad" */
  readonly update_scratchpad?: Maybe<Scratchpad_Mutation_Response>;
  /** update single row of the table: "scratchpad" */
  readonly update_scratchpad_by_pk?: Maybe<Scratchpad>;
  /** update multiples rows of table: "scratchpad" */
  readonly update_scratchpad_many?: Maybe<ReadonlyArray<Maybe<Scratchpad_Mutation_Response>>>;
  /** update data of the table: "session" */
  readonly update_session?: Maybe<Session_Mutation_Response>;
  /** update single row of the table: "session" */
  readonly update_session_by_pk?: Maybe<Session>;
  /** update multiples rows of table: "session" */
  readonly update_session_many?: Maybe<ReadonlyArray<Maybe<Session_Mutation_Response>>>;
  /** update data of the table: "session_type" */
  readonly update_session_type?: Maybe<Session_Type_Mutation_Response>;
  /** update single row of the table: "session_type" */
  readonly update_session_type_by_pk?: Maybe<Session_Type>;
  /** update multiples rows of table: "session_type" */
  readonly update_session_type_many?: Maybe<ReadonlyArray<Maybe<Session_Type_Mutation_Response>>>;
  /** update data of the table: "shared_instrument" */
  readonly update_shared_instrument?: Maybe<Shared_Instrument_Mutation_Response>;
  /** update single row of the table: "shared_instrument" */
  readonly update_shared_instrument_by_pk?: Maybe<Shared_Instrument>;
  /** update multiples rows of table: "shared_instrument" */
  readonly update_shared_instrument_many?: Maybe<ReadonlyArray<Maybe<Shared_Instrument_Mutation_Response>>>;
  /** update data of the table: "sharing_agreement" */
  readonly update_sharing_agreement?: Maybe<Sharing_Agreement_Mutation_Response>;
  /** update single row of the table: "sharing_agreement" */
  readonly update_sharing_agreement_by_pk?: Maybe<Sharing_Agreement>;
  /** update multiples rows of table: "sharing_agreement" */
  readonly update_sharing_agreement_many?: Maybe<ReadonlyArray<Maybe<Sharing_Agreement_Mutation_Response>>>;
  /** update data of the table: "source" */
  readonly update_source?: Maybe<Source_Mutation_Response>;
  /** update single row of the table: "source" */
  readonly update_source_by_pk?: Maybe<Source>;
  /** update multiples rows of table: "source" */
  readonly update_source_many?: Maybe<ReadonlyArray<Maybe<Source_Mutation_Response>>>;
  /** update data of the table: "spreader_state" */
  readonly update_spreader_state?: Maybe<Spreader_State_Mutation_Response>;
  /** update single row of the table: "spreader_state" */
  readonly update_spreader_state_by_pk?: Maybe<Spreader_State>;
  /** update multiples rows of table: "spreader_state" */
  readonly update_spreader_state_many?: Maybe<ReadonlyArray<Maybe<Spreader_State_Mutation_Response>>>;
  /** update data of the table: "subscription_tier" */
  readonly update_subscription_tier?: Maybe<Subscription_Tier_Mutation_Response>;
  /** update single row of the table: "subscription_tier" */
  readonly update_subscription_tier_by_pk?: Maybe<Subscription_Tier>;
  /** update multiples rows of table: "subscription_tier" */
  readonly update_subscription_tier_many?: Maybe<ReadonlyArray<Maybe<Subscription_Tier_Mutation_Response>>>;
  /** update data of the table: "umi_action" */
  readonly update_umi_action?: Maybe<Umi_Action_Mutation_Response>;
  /** update single row of the table: "umi_action" */
  readonly update_umi_action_by_pk?: Maybe<Umi_Action>;
  /** update multiples rows of table: "umi_action" */
  readonly update_umi_action_many?: Maybe<ReadonlyArray<Maybe<Umi_Action_Mutation_Response>>>;
  /** update data of the table: "umi_action_name" */
  readonly update_umi_action_name?: Maybe<Umi_Action_Name_Mutation_Response>;
  /** update single row of the table: "umi_action_name" */
  readonly update_umi_action_name_by_pk?: Maybe<Umi_Action_Name>;
  /** update multiples rows of table: "umi_action_name" */
  readonly update_umi_action_name_many?: Maybe<ReadonlyArray<Maybe<Umi_Action_Name_Mutation_Response>>>;
  /** update data of the table: "user_entitlement" */
  readonly update_user_entitlement?: Maybe<User_Entitlement_Mutation_Response>;
  /** update single row of the table: "user_entitlement" */
  readonly update_user_entitlement_by_pk?: Maybe<User_Entitlement>;
  /** update data of the table: "user_entitlement_kind" */
  readonly update_user_entitlement_kind?: Maybe<User_Entitlement_Kind_Mutation_Response>;
  /** update single row of the table: "user_entitlement_kind" */
  readonly update_user_entitlement_kind_by_pk?: Maybe<User_Entitlement_Kind>;
  /** update multiples rows of table: "user_entitlement_kind" */
  readonly update_user_entitlement_kind_many?: Maybe<ReadonlyArray<Maybe<User_Entitlement_Kind_Mutation_Response>>>;
  /** update data of the table: "user_entitlement_level" */
  readonly update_user_entitlement_level?: Maybe<User_Entitlement_Level_Mutation_Response>;
  /** update single row of the table: "user_entitlement_level" */
  readonly update_user_entitlement_level_by_pk?: Maybe<User_Entitlement_Level>;
  /** update multiples rows of table: "user_entitlement_level" */
  readonly update_user_entitlement_level_many?: Maybe<ReadonlyArray<Maybe<User_Entitlement_Level_Mutation_Response>>>;
  /** update multiples rows of table: "user_entitlement" */
  readonly update_user_entitlement_many?: Maybe<ReadonlyArray<Maybe<User_Entitlement_Mutation_Response>>>;
  /** update data of the table: "user_groups" */
  readonly update_user_groups?: Maybe<User_Groups_Mutation_Response>;
  /** update single row of the table: "user_groups" */
  readonly update_user_groups_by_pk?: Maybe<User_Groups>;
  /** update multiples rows of table: "user_groups" */
  readonly update_user_groups_many?: Maybe<ReadonlyArray<Maybe<User_Groups_Mutation_Response>>>;
  /** update data of the table: "user_right" */
  readonly update_user_right?: Maybe<User_Right_Mutation_Response>;
  /** update single row of the table: "user_right" */
  readonly update_user_right_by_pk?: Maybe<User_Right>;
  /** update multiples rows of table: "user_right" */
  readonly update_user_right_many?: Maybe<ReadonlyArray<Maybe<User_Right_Mutation_Response>>>;
  /** update data of the table: "user_storage" */
  readonly update_user_storage?: Maybe<User_Storage_Mutation_Response>;
  /** update single row of the table: "user_storage" */
  readonly update_user_storage_by_pk?: Maybe<User_Storage>;
  /** update multiples rows of table: "user_storage" */
  readonly update_user_storage_many?: Maybe<ReadonlyArray<Maybe<User_Storage_Mutation_Response>>>;
  /** update data of the table: "viewed_announcements" */
  readonly update_viewed_announcements?: Maybe<Viewed_Announcements_Mutation_Response>;
  /** update single row of the table: "viewed_announcements" */
  readonly update_viewed_announcements_by_pk?: Maybe<Viewed_Announcements>;
  /** update multiples rows of table: "viewed_announcements" */
  readonly update_viewed_announcements_many?: Maybe<ReadonlyArray<Maybe<Viewed_Announcements_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AlertsArgs = {
  where: Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alerts_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Audit_Logged_ActionsArgs = {
  where: Audit_Logged_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audit_Logged_Actions_By_PkArgs = {
  event_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Audit_Umi_ActionsArgs = {
  where: Audit_Umi_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audit_Umi_Actions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Commodity_GroupArgs = {
  where: Commodity_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Parent_GroupArgs = {
  where: Commodity_Parent_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Parent_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Conditional_Formatting_RulesArgs = {
  where: Conditional_Formatting_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Conditional_Formatting_Rules_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EodArgs = {
  where: Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eod_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eod_EntryArgs = {
  where: Eod_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eod_Entry_By_PkArgs = {
  evaluation_date: Scalars['date']['input'];
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ExchangeArgs = {
  where: Exchange_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exchange_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Exchange_Event_TypeArgs = {
  where: Exchange_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exchange_Event_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Exchange_UsageArgs = {
  where: Exchange_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exchange_Usage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_FlagsArgs = {
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Flags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folio_Shadow_CurvesArgs = {
  where: Folio_Shadow_Curves_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folio_Shadow_Curves_By_PkArgs = {
  folio_user: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Folio_UserArgs = {
  where: Folio_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folio_User_Basic_ProfileArgs = {
  where: Folio_User_Basic_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Folio_User_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Geographical_RegionArgs = {
  where: Geographical_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Geographical_Region_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Global_InstrumentArgs = {
  where: Global_Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Instrument_By_PkArgs = {
  global_product: Scalars['uuid']['input'];
  month: Scalars['date']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Global_PackageArgs = {
  where: Global_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Global_PermissionArgs = {
  where: Global_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Permission_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  global_package: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Global_ProductArgs = {
  where: Global_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Global_Product_ConfigArgs = {
  where: Global_Product_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Product_Config_By_PkArgs = {
  product: Scalars['uuid']['input'];
  relative_month: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Grid_ChartsArgs = {
  where: Grid_Charts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grid_Charts_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Grid_SettingsArgs = {
  where: Grid_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grid_Settings_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Hfc_Card_SettingsArgs = {
  where: Hfc_Card_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hfc_Card_Settings_By_PkArgs = {
  user: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Hfc_User_SettingsArgs = {
  where: Hfc_User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hfc_User_Settings_By_PkArgs = {
  user: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incident_BannersArgs = {
  where: Incident_Banners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incident_Banners_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Live_Chart_AnnotationsArgs = {
  where: Live_Chart_Annotations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Live_Chart_Annotations_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Live_Chart_PageArgs = {
  where: Live_Chart_Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Live_Chart_Page_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Live_Chart_SettingsArgs = {
  where: Live_Chart_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Live_Chart_Settings_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Local_InstrumentArgs = {
  where: Local_Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Local_Instrument_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
  storage_type: User_Storage_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Logout_RequestArgs = {
  where: Logout_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logout_Request_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Module_StorageArgs = {
  where: Module_Storage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_Storage_By_PkArgs = {
  key: Scalars['String']['input'];
  module: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationArgs = {
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PackageArgs = {
  where: Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Package_TypeArgs = {
  where: Package_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Package_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Page_MemberArgs = {
  where: Page_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_Member_By_PkArgs = {
  page_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Page_ProductsArgs = {
  where: Page_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_Products_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Page_SettingsArgs = {
  where: Page_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_Settings_By_PkArgs = {
  folio_user: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PagesArgs = {
  where: Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pages_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionArgs = {
  where: Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permission_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  package: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_AlertsArgs = {
  where: Product_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Alerts_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Artis_TypeArgs = {
  where: Product_Artis_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Artis_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_ConfigArgs = {
  where: Product_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Config_By_PkArgs = {
  product: Scalars['uuid']['input'];
  relative_month: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Curve_TypeArgs = {
  where: Product_Curve_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Curve_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_EodArgs = {
  where: Product_Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Eod_By_PkArgs = {
  eod_product: Scalars['uuid']['input'];
  product: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Global_DependenciesArgs = {
  where: Product_Global_Dependencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Global_Dependencies_By_PkArgs = {
  global_product: Scalars['uuid']['input'];
  product: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_MaturityArgs = {
  where: Product_Maturity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Maturity_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_OverridesArgs = {
  where: Product_Overrides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Overrides_By_PkArgs = {
  organisation: Scalars['Int']['input'];
  product: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_SourceArgs = {
  where: Product_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Summary_TypeArgs = {
  where: Product_Summary_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Summary_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_TypeArgs = {
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_UomArgs = {
  where: Product_Uom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Uom_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_User_SettingsArgs = {
  where: Product_User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_User_Settings_By_PkArgs = {
  product_id: Scalars['uuid']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Push_SubscriptionsArgs = {
  where: Push_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Push_Subscriptions_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quick_AccessArgs = {
  where: Quick_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quick_Access_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ScratchpadArgs = {
  where: Scratchpad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scratchpad_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  page_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SessionArgs = {
  where: Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Session_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  is_mobile: Scalars['Boolean']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Session_TypeArgs = {
  where: Session_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Session_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Shared_InstrumentArgs = {
  where: Shared_Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shared_Instrument_By_PkArgs = {
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sharing_AgreementArgs = {
  where: Sharing_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sharing_Agreement_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SourceArgs = {
  where: Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Source_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Spreader_StateArgs = {
  where: Spreader_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spreader_State_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_TierArgs = {
  where: Subscription_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Umi_ActionArgs = {
  where: Umi_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Umi_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Umi_Action_NameArgs = {
  where: Umi_Action_Name_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Umi_Action_Name_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_EntitlementArgs = {
  where: User_Entitlement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Entitlement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Entitlement_KindArgs = {
  where: User_Entitlement_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Entitlement_Kind_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Entitlement_LevelArgs = {
  where: User_Entitlement_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Entitlement_Level_By_PkArgs = {
  level: Scalars['smallint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_GroupsArgs = {
  where: User_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Groups_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_RightArgs = {
  where: User_Right_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Right_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_StorageArgs = {
  where: User_Storage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Storage_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Viewed_AnnouncementsArgs = {
  where: Viewed_Announcements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Viewed_Announcements_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AlertsArgs = {
  objects: ReadonlyArray<Alerts_Insert_Input>;
  on_conflict?: InputMaybe<Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alerts_OneArgs = {
  object: Alerts_Insert_Input;
  on_conflict?: InputMaybe<Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Logged_ActionsArgs = {
  objects: ReadonlyArray<Audit_Logged_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Audit_Logged_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Logged_Actions_OneArgs = {
  object: Audit_Logged_Actions_Insert_Input;
  on_conflict?: InputMaybe<Audit_Logged_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Umi_ActionsArgs = {
  objects: ReadonlyArray<Audit_Umi_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Audit_Umi_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Umi_Actions_OneArgs = {
  object: Audit_Umi_Actions_Insert_Input;
  on_conflict?: InputMaybe<Audit_Umi_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_GroupArgs = {
  objects: ReadonlyArray<Commodity_Group_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Group_OneArgs = {
  object: Commodity_Group_Insert_Input;
  on_conflict?: InputMaybe<Commodity_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Parent_GroupArgs = {
  objects: ReadonlyArray<Commodity_Parent_Group_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_Parent_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Parent_Group_OneArgs = {
  object: Commodity_Parent_Group_Insert_Input;
  on_conflict?: InputMaybe<Commodity_Parent_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Conditional_Formatting_RulesArgs = {
  objects: ReadonlyArray<Conditional_Formatting_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Conditional_Formatting_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Conditional_Formatting_Rules_OneArgs = {
  object: Conditional_Formatting_Rules_Insert_Input;
  on_conflict?: InputMaybe<Conditional_Formatting_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EodArgs = {
  objects: ReadonlyArray<Eod_Insert_Input>;
  on_conflict?: InputMaybe<Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eod_EntryArgs = {
  objects: ReadonlyArray<Eod_Entry_Insert_Input>;
  on_conflict?: InputMaybe<Eod_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eod_Entry_OneArgs = {
  object: Eod_Entry_Insert_Input;
  on_conflict?: InputMaybe<Eod_Entry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eod_OneArgs = {
  object: Eod_Insert_Input;
  on_conflict?: InputMaybe<Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExchangeArgs = {
  objects: ReadonlyArray<Exchange_Insert_Input>;
  on_conflict?: InputMaybe<Exchange_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_Event_TypeArgs = {
  objects: ReadonlyArray<Exchange_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Exchange_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_Event_Type_OneArgs = {
  object: Exchange_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Exchange_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_OneArgs = {
  object: Exchange_Insert_Input;
  on_conflict?: InputMaybe<Exchange_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_UsageArgs = {
  objects: ReadonlyArray<Exchange_Usage_Insert_Input>;
  on_conflict?: InputMaybe<Exchange_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_Usage_OneArgs = {
  object: Exchange_Usage_Insert_Input;
  on_conflict?: InputMaybe<Exchange_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_FlagsArgs = {
  objects: ReadonlyArray<Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Flags_OneArgs = {
  object: Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folio_Shadow_CurvesArgs = {
  objects: ReadonlyArray<Folio_Shadow_Curves_Insert_Input>;
  on_conflict?: InputMaybe<Folio_Shadow_Curves_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folio_Shadow_Curves_OneArgs = {
  object: Folio_Shadow_Curves_Insert_Input;
  on_conflict?: InputMaybe<Folio_Shadow_Curves_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folio_UserArgs = {
  objects: ReadonlyArray<Folio_User_Insert_Input>;
  on_conflict?: InputMaybe<Folio_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Folio_User_Basic_ProfileArgs = {
  objects: ReadonlyArray<Folio_User_Basic_Profile_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Folio_User_Basic_Profile_OneArgs = {
  object: Folio_User_Basic_Profile_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Folio_User_OneArgs = {
  object: Folio_User_Insert_Input;
  on_conflict?: InputMaybe<Folio_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geographical_RegionArgs = {
  objects: ReadonlyArray<Geographical_Region_Insert_Input>;
  on_conflict?: InputMaybe<Geographical_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geographical_Region_OneArgs = {
  object: Geographical_Region_Insert_Input;
  on_conflict?: InputMaybe<Geographical_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_InstrumentArgs = {
  objects: ReadonlyArray<Global_Instrument_Insert_Input>;
  on_conflict?: InputMaybe<Global_Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Instrument_OneArgs = {
  object: Global_Instrument_Insert_Input;
  on_conflict?: InputMaybe<Global_Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_PackageArgs = {
  objects: ReadonlyArray<Global_Package_Insert_Input>;
  on_conflict?: InputMaybe<Global_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Package_OneArgs = {
  object: Global_Package_Insert_Input;
  on_conflict?: InputMaybe<Global_Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_PermissionArgs = {
  objects: ReadonlyArray<Global_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Global_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Permission_OneArgs = {
  object: Global_Permission_Insert_Input;
  on_conflict?: InputMaybe<Global_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_ProductArgs = {
  objects: ReadonlyArray<Global_Product_Insert_Input>;
  on_conflict?: InputMaybe<Global_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Product_ConfigArgs = {
  objects: ReadonlyArray<Global_Product_Config_Insert_Input>;
  on_conflict?: InputMaybe<Global_Product_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Product_Config_OneArgs = {
  object: Global_Product_Config_Insert_Input;
  on_conflict?: InputMaybe<Global_Product_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Product_OneArgs = {
  object: Global_Product_Insert_Input;
  on_conflict?: InputMaybe<Global_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grid_ChartsArgs = {
  objects: ReadonlyArray<Grid_Charts_Insert_Input>;
  on_conflict?: InputMaybe<Grid_Charts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grid_Charts_OneArgs = {
  object: Grid_Charts_Insert_Input;
  on_conflict?: InputMaybe<Grid_Charts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grid_SettingsArgs = {
  objects: ReadonlyArray<Grid_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Grid_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grid_Settings_OneArgs = {
  object: Grid_Settings_Insert_Input;
  on_conflict?: InputMaybe<Grid_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hfc_Card_SettingsArgs = {
  objects: ReadonlyArray<Hfc_Card_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Hfc_Card_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hfc_Card_Settings_OneArgs = {
  object: Hfc_Card_Settings_Insert_Input;
  on_conflict?: InputMaybe<Hfc_Card_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hfc_User_SettingsArgs = {
  objects: ReadonlyArray<Hfc_User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Hfc_User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hfc_User_Settings_OneArgs = {
  object: Hfc_User_Settings_Insert_Input;
  on_conflict?: InputMaybe<Hfc_User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_BannersArgs = {
  objects: ReadonlyArray<Incident_Banners_Insert_Input>;
  on_conflict?: InputMaybe<Incident_Banners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_Banners_OneArgs = {
  object: Incident_Banners_Insert_Input;
  on_conflict?: InputMaybe<Incident_Banners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Chart_AnnotationsArgs = {
  objects: ReadonlyArray<Live_Chart_Annotations_Insert_Input>;
  on_conflict?: InputMaybe<Live_Chart_Annotations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Chart_Annotations_OneArgs = {
  object: Live_Chart_Annotations_Insert_Input;
  on_conflict?: InputMaybe<Live_Chart_Annotations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Chart_PageArgs = {
  objects: ReadonlyArray<Live_Chart_Page_Insert_Input>;
  on_conflict?: InputMaybe<Live_Chart_Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Chart_Page_OneArgs = {
  object: Live_Chart_Page_Insert_Input;
  on_conflict?: InputMaybe<Live_Chart_Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Chart_SettingsArgs = {
  objects: ReadonlyArray<Live_Chart_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Live_Chart_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Chart_Settings_OneArgs = {
  object: Live_Chart_Settings_Insert_Input;
  on_conflict?: InputMaybe<Live_Chart_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Local_InstrumentArgs = {
  objects: ReadonlyArray<Local_Instrument_Insert_Input>;
  on_conflict?: InputMaybe<Local_Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Local_Instrument_OneArgs = {
  object: Local_Instrument_Insert_Input;
  on_conflict?: InputMaybe<Local_Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logout_RequestArgs = {
  objects: ReadonlyArray<Logout_Request_Insert_Input>;
  on_conflict?: InputMaybe<Logout_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logout_Request_OneArgs = {
  object: Logout_Request_Insert_Input;
  on_conflict?: InputMaybe<Logout_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_StorageArgs = {
  objects: ReadonlyArray<Module_Storage_Insert_Input>;
  on_conflict?: InputMaybe<Module_Storage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Storage_OneArgs = {
  object: Module_Storage_Insert_Input;
  on_conflict?: InputMaybe<Module_Storage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationArgs = {
  objects: ReadonlyArray<Organisation_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_OneArgs = {
  object: Organisation_Insert_Input;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PackageArgs = {
  objects: ReadonlyArray<Package_Insert_Input>;
  on_conflict?: InputMaybe<Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Package_OneArgs = {
  object: Package_Insert_Input;
  on_conflict?: InputMaybe<Package_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Package_TypeArgs = {
  objects: ReadonlyArray<Package_Type_Insert_Input>;
  on_conflict?: InputMaybe<Package_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Package_Type_OneArgs = {
  object: Package_Type_Insert_Input;
  on_conflict?: InputMaybe<Package_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_MemberArgs = {
  objects: ReadonlyArray<Page_Member_Insert_Input>;
  on_conflict?: InputMaybe<Page_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_Member_OneArgs = {
  object: Page_Member_Insert_Input;
  on_conflict?: InputMaybe<Page_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_ProductsArgs = {
  objects: ReadonlyArray<Page_Products_Insert_Input>;
  on_conflict?: InputMaybe<Page_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_Products_OneArgs = {
  object: Page_Products_Insert_Input;
  on_conflict?: InputMaybe<Page_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_SettingsArgs = {
  objects: ReadonlyArray<Page_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Page_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_Settings_OneArgs = {
  object: Page_Settings_Insert_Input;
  on_conflict?: InputMaybe<Page_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PagesArgs = {
  objects: ReadonlyArray<Pages_Insert_Input>;
  on_conflict?: InputMaybe<Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pages_OneArgs = {
  object: Pages_Insert_Input;
  on_conflict?: InputMaybe<Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionArgs = {
  objects: ReadonlyArray<Permission_Insert_Input>;
  on_conflict?: InputMaybe<Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permission_OneArgs = {
  object: Permission_Insert_Input;
  on_conflict?: InputMaybe<Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: ReadonlyArray<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_AlertsArgs = {
  objects: ReadonlyArray<Product_Alerts_Insert_Input>;
  on_conflict?: InputMaybe<Product_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Alerts_OneArgs = {
  object: Product_Alerts_Insert_Input;
  on_conflict?: InputMaybe<Product_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Artis_TypeArgs = {
  objects: ReadonlyArray<Product_Artis_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Artis_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Artis_Type_OneArgs = {
  object: Product_Artis_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Artis_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_ConfigArgs = {
  objects: ReadonlyArray<Product_Config_Insert_Input>;
  on_conflict?: InputMaybe<Product_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Config_OneArgs = {
  object: Product_Config_Insert_Input;
  on_conflict?: InputMaybe<Product_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Curve_TypeArgs = {
  objects: ReadonlyArray<Product_Curve_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Curve_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Curve_Type_OneArgs = {
  object: Product_Curve_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Curve_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_EodArgs = {
  objects: ReadonlyArray<Product_Eod_Insert_Input>;
  on_conflict?: InputMaybe<Product_Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Eod_OneArgs = {
  object: Product_Eod_Insert_Input;
  on_conflict?: InputMaybe<Product_Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Global_DependenciesArgs = {
  objects: ReadonlyArray<Product_Global_Dependencies_Insert_Input>;
  on_conflict?: InputMaybe<Product_Global_Dependencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Global_Dependencies_OneArgs = {
  object: Product_Global_Dependencies_Insert_Input;
  on_conflict?: InputMaybe<Product_Global_Dependencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_MaturityArgs = {
  objects: ReadonlyArray<Product_Maturity_Insert_Input>;
  on_conflict?: InputMaybe<Product_Maturity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Maturity_OneArgs = {
  object: Product_Maturity_Insert_Input;
  on_conflict?: InputMaybe<Product_Maturity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OverridesArgs = {
  objects: ReadonlyArray<Product_Overrides_Insert_Input>;
  on_conflict?: InputMaybe<Product_Overrides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Overrides_OneArgs = {
  object: Product_Overrides_Insert_Input;
  on_conflict?: InputMaybe<Product_Overrides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_SourceArgs = {
  objects: ReadonlyArray<Product_Source_Insert_Input>;
  on_conflict?: InputMaybe<Product_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Source_OneArgs = {
  object: Product_Source_Insert_Input;
  on_conflict?: InputMaybe<Product_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Summary_TypeArgs = {
  objects: ReadonlyArray<Product_Summary_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Summary_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Summary_Type_OneArgs = {
  object: Product_Summary_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Summary_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_TypeArgs = {
  objects: ReadonlyArray<Product_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Type_OneArgs = {
  object: Product_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_UomArgs = {
  objects: ReadonlyArray<Product_Uom_Insert_Input>;
  on_conflict?: InputMaybe<Product_Uom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Uom_OneArgs = {
  object: Product_Uom_Insert_Input;
  on_conflict?: InputMaybe<Product_Uom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_User_SettingsArgs = {
  objects: ReadonlyArray<Product_User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Product_User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_User_Settings_OneArgs = {
  object: Product_User_Settings_Insert_Input;
  on_conflict?: InputMaybe<Product_User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_SubscriptionsArgs = {
  objects: ReadonlyArray<Push_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Push_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Subscriptions_OneArgs = {
  object: Push_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Push_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quick_AccessArgs = {
  objects: ReadonlyArray<Quick_Access_Insert_Input>;
  on_conflict?: InputMaybe<Quick_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quick_Access_OneArgs = {
  object: Quick_Access_Insert_Input;
  on_conflict?: InputMaybe<Quick_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScratchpadArgs = {
  objects: ReadonlyArray<Scratchpad_Insert_Input>;
  on_conflict?: InputMaybe<Scratchpad_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scratchpad_OneArgs = {
  object: Scratchpad_Insert_Input;
  on_conflict?: InputMaybe<Scratchpad_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SessionArgs = {
  objects: ReadonlyArray<Session_Insert_Input>;
  on_conflict?: InputMaybe<Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_OneArgs = {
  object: Session_Insert_Input;
  on_conflict?: InputMaybe<Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_TypeArgs = {
  objects: ReadonlyArray<Session_Type_Insert_Input>;
  on_conflict?: InputMaybe<Session_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_Type_OneArgs = {
  object: Session_Type_Insert_Input;
  on_conflict?: InputMaybe<Session_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shared_InstrumentArgs = {
  objects: ReadonlyArray<Shared_Instrument_Insert_Input>;
  on_conflict?: InputMaybe<Shared_Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shared_Instrument_OneArgs = {
  object: Shared_Instrument_Insert_Input;
  on_conflict?: InputMaybe<Shared_Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sharing_AgreementArgs = {
  objects: ReadonlyArray<Sharing_Agreement_Insert_Input>;
  on_conflict?: InputMaybe<Sharing_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sharing_Agreement_OneArgs = {
  object: Sharing_Agreement_Insert_Input;
  on_conflict?: InputMaybe<Sharing_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SourceArgs = {
  objects: ReadonlyArray<Source_Insert_Input>;
  on_conflict?: InputMaybe<Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Source_OneArgs = {
  object: Source_Insert_Input;
  on_conflict?: InputMaybe<Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spreader_StateArgs = {
  objects: ReadonlyArray<Spreader_State_Insert_Input>;
  on_conflict?: InputMaybe<Spreader_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spreader_State_OneArgs = {
  object: Spreader_State_Insert_Input;
  on_conflict?: InputMaybe<Spreader_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_TierArgs = {
  objects: ReadonlyArray<Subscription_Tier_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Tier_OneArgs = {
  object: Subscription_Tier_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Umi_ActionArgs = {
  objects: ReadonlyArray<Umi_Action_Insert_Input>;
  on_conflict?: InputMaybe<Umi_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Umi_Action_NameArgs = {
  objects: ReadonlyArray<Umi_Action_Name_Insert_Input>;
  on_conflict?: InputMaybe<Umi_Action_Name_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Umi_Action_Name_OneArgs = {
  object: Umi_Action_Name_Insert_Input;
  on_conflict?: InputMaybe<Umi_Action_Name_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Umi_Action_OneArgs = {
  object: Umi_Action_Insert_Input;
  on_conflict?: InputMaybe<Umi_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_EntitlementArgs = {
  objects: ReadonlyArray<User_Entitlement_Insert_Input>;
  on_conflict?: InputMaybe<User_Entitlement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Entitlement_KindArgs = {
  objects: ReadonlyArray<User_Entitlement_Kind_Insert_Input>;
  on_conflict?: InputMaybe<User_Entitlement_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Entitlement_Kind_OneArgs = {
  object: User_Entitlement_Kind_Insert_Input;
  on_conflict?: InputMaybe<User_Entitlement_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Entitlement_LevelArgs = {
  objects: ReadonlyArray<User_Entitlement_Level_Insert_Input>;
  on_conflict?: InputMaybe<User_Entitlement_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Entitlement_Level_OneArgs = {
  object: User_Entitlement_Level_Insert_Input;
  on_conflict?: InputMaybe<User_Entitlement_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Entitlement_OneArgs = {
  object: User_Entitlement_Insert_Input;
  on_conflict?: InputMaybe<User_Entitlement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_GroupsArgs = {
  objects: ReadonlyArray<User_Groups_Insert_Input>;
  on_conflict?: InputMaybe<User_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Groups_OneArgs = {
  object: User_Groups_Insert_Input;
  on_conflict?: InputMaybe<User_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RightArgs = {
  objects: ReadonlyArray<User_Right_Insert_Input>;
  on_conflict?: InputMaybe<User_Right_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Right_OneArgs = {
  object: User_Right_Insert_Input;
  on_conflict?: InputMaybe<User_Right_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_StorageArgs = {
  objects: ReadonlyArray<User_Storage_Insert_Input>;
  on_conflict?: InputMaybe<User_Storage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Storage_OneArgs = {
  object: User_Storage_Insert_Input;
  on_conflict?: InputMaybe<User_Storage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Viewed_AnnouncementsArgs = {
  objects: ReadonlyArray<Viewed_Announcements_Insert_Input>;
  on_conflict?: InputMaybe<Viewed_Announcements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Viewed_Announcements_OneArgs = {
  object: Viewed_Announcements_Insert_Input;
  on_conflict?: InputMaybe<Viewed_Announcements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AlertsArgs = {
  _set?: InputMaybe<Alerts_Set_Input>;
  where: Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alerts_By_PkArgs = {
  _set?: InputMaybe<Alerts_Set_Input>;
  pk_columns: Alerts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alerts_ManyArgs = {
  updates: ReadonlyArray<Alerts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logged_ActionsArgs = {
  _append?: InputMaybe<Audit_Logged_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Logged_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Logged_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Logged_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Logged_Actions_Inc_Input>;
  _prepend?: InputMaybe<Audit_Logged_Actions_Prepend_Input>;
  _set?: InputMaybe<Audit_Logged_Actions_Set_Input>;
  where: Audit_Logged_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logged_Actions_By_PkArgs = {
  _append?: InputMaybe<Audit_Logged_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Logged_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Logged_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Logged_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Logged_Actions_Inc_Input>;
  _prepend?: InputMaybe<Audit_Logged_Actions_Prepend_Input>;
  _set?: InputMaybe<Audit_Logged_Actions_Set_Input>;
  pk_columns: Audit_Logged_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logged_Actions_ManyArgs = {
  updates: ReadonlyArray<Audit_Logged_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Umi_ActionsArgs = {
  _append?: InputMaybe<Audit_Umi_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Umi_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Umi_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Umi_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Umi_Actions_Inc_Input>;
  _prepend?: InputMaybe<Audit_Umi_Actions_Prepend_Input>;
  _set?: InputMaybe<Audit_Umi_Actions_Set_Input>;
  where: Audit_Umi_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Umi_Actions_By_PkArgs = {
  _append?: InputMaybe<Audit_Umi_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Umi_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Umi_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Umi_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Umi_Actions_Inc_Input>;
  _prepend?: InputMaybe<Audit_Umi_Actions_Prepend_Input>;
  _set?: InputMaybe<Audit_Umi_Actions_Set_Input>;
  pk_columns: Audit_Umi_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Umi_Actions_ManyArgs = {
  updates: ReadonlyArray<Audit_Umi_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_GroupArgs = {
  _inc?: InputMaybe<Commodity_Group_Inc_Input>;
  _set?: InputMaybe<Commodity_Group_Set_Input>;
  where: Commodity_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Group_By_PkArgs = {
  _inc?: InputMaybe<Commodity_Group_Inc_Input>;
  _set?: InputMaybe<Commodity_Group_Set_Input>;
  pk_columns: Commodity_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Group_ManyArgs = {
  updates: ReadonlyArray<Commodity_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Parent_GroupArgs = {
  _inc?: InputMaybe<Commodity_Parent_Group_Inc_Input>;
  _set?: InputMaybe<Commodity_Parent_Group_Set_Input>;
  where: Commodity_Parent_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Parent_Group_By_PkArgs = {
  _inc?: InputMaybe<Commodity_Parent_Group_Inc_Input>;
  _set?: InputMaybe<Commodity_Parent_Group_Set_Input>;
  pk_columns: Commodity_Parent_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Parent_Group_ManyArgs = {
  updates: ReadonlyArray<Commodity_Parent_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Conditional_Formatting_RulesArgs = {
  _set?: InputMaybe<Conditional_Formatting_Rules_Set_Input>;
  where: Conditional_Formatting_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Conditional_Formatting_Rules_By_PkArgs = {
  _set?: InputMaybe<Conditional_Formatting_Rules_Set_Input>;
  pk_columns: Conditional_Formatting_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Conditional_Formatting_Rules_ManyArgs = {
  updates: ReadonlyArray<Conditional_Formatting_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EodArgs = {
  _inc?: InputMaybe<Eod_Inc_Input>;
  _set?: InputMaybe<Eod_Set_Input>;
  where: Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eod_By_PkArgs = {
  _inc?: InputMaybe<Eod_Inc_Input>;
  _set?: InputMaybe<Eod_Set_Input>;
  pk_columns: Eod_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eod_EntryArgs = {
  _inc?: InputMaybe<Eod_Entry_Inc_Input>;
  _set?: InputMaybe<Eod_Entry_Set_Input>;
  where: Eod_Entry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eod_Entry_By_PkArgs = {
  _inc?: InputMaybe<Eod_Entry_Inc_Input>;
  _set?: InputMaybe<Eod_Entry_Set_Input>;
  pk_columns: Eod_Entry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eod_Entry_ManyArgs = {
  updates: ReadonlyArray<Eod_Entry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eod_ManyArgs = {
  updates: ReadonlyArray<Eod_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExchangeArgs = {
  _inc?: InputMaybe<Exchange_Inc_Input>;
  _set?: InputMaybe<Exchange_Set_Input>;
  where: Exchange_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_By_PkArgs = {
  _inc?: InputMaybe<Exchange_Inc_Input>;
  _set?: InputMaybe<Exchange_Set_Input>;
  pk_columns: Exchange_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Event_TypeArgs = {
  _set?: InputMaybe<Exchange_Event_Type_Set_Input>;
  where: Exchange_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Event_Type_By_PkArgs = {
  _set?: InputMaybe<Exchange_Event_Type_Set_Input>;
  pk_columns: Exchange_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Event_Type_ManyArgs = {
  updates: ReadonlyArray<Exchange_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_ManyArgs = {
  updates: ReadonlyArray<Exchange_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_UsageArgs = {
  _inc?: InputMaybe<Exchange_Usage_Inc_Input>;
  _set?: InputMaybe<Exchange_Usage_Set_Input>;
  where: Exchange_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Usage_By_PkArgs = {
  _inc?: InputMaybe<Exchange_Usage_Inc_Input>;
  _set?: InputMaybe<Exchange_Usage_Set_Input>;
  pk_columns: Exchange_Usage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Usage_ManyArgs = {
  updates: ReadonlyArray<Exchange_Usage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_FlagsArgs = {
  _append?: InputMaybe<Feature_Flags_Append_Input>;
  _delete_at_path?: InputMaybe<Feature_Flags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feature_Flags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feature_Flags_Delete_Key_Input>;
  _prepend?: InputMaybe<Feature_Flags_Prepend_Input>;
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_By_PkArgs = {
  _append?: InputMaybe<Feature_Flags_Append_Input>;
  _delete_at_path?: InputMaybe<Feature_Flags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feature_Flags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feature_Flags_Delete_Key_Input>;
  _prepend?: InputMaybe<Feature_Flags_Prepend_Input>;
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  pk_columns: Feature_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_ManyArgs = {
  updates: ReadonlyArray<Feature_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_Shadow_CurvesArgs = {
  _append?: InputMaybe<Folio_Shadow_Curves_Append_Input>;
  _delete_at_path?: InputMaybe<Folio_Shadow_Curves_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Folio_Shadow_Curves_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Folio_Shadow_Curves_Delete_Key_Input>;
  _prepend?: InputMaybe<Folio_Shadow_Curves_Prepend_Input>;
  _set?: InputMaybe<Folio_Shadow_Curves_Set_Input>;
  where: Folio_Shadow_Curves_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_Shadow_Curves_By_PkArgs = {
  _append?: InputMaybe<Folio_Shadow_Curves_Append_Input>;
  _delete_at_path?: InputMaybe<Folio_Shadow_Curves_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Folio_Shadow_Curves_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Folio_Shadow_Curves_Delete_Key_Input>;
  _prepend?: InputMaybe<Folio_Shadow_Curves_Prepend_Input>;
  _set?: InputMaybe<Folio_Shadow_Curves_Set_Input>;
  pk_columns: Folio_Shadow_Curves_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_Shadow_Curves_ManyArgs = {
  updates: ReadonlyArray<Folio_Shadow_Curves_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_UserArgs = {
  _append?: InputMaybe<Folio_User_Append_Input>;
  _delete_at_path?: InputMaybe<Folio_User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Folio_User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Folio_User_Delete_Key_Input>;
  _inc?: InputMaybe<Folio_User_Inc_Input>;
  _prepend?: InputMaybe<Folio_User_Prepend_Input>;
  _set?: InputMaybe<Folio_User_Set_Input>;
  where: Folio_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_User_Basic_ProfileArgs = {
  _inc?: InputMaybe<Folio_User_Basic_Profile_Inc_Input>;
  _set?: InputMaybe<Folio_User_Basic_Profile_Set_Input>;
  where: Folio_User_Basic_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_User_Basic_Profile_ManyArgs = {
  updates: ReadonlyArray<Folio_User_Basic_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_User_By_PkArgs = {
  _append?: InputMaybe<Folio_User_Append_Input>;
  _delete_at_path?: InputMaybe<Folio_User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Folio_User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Folio_User_Delete_Key_Input>;
  _inc?: InputMaybe<Folio_User_Inc_Input>;
  _prepend?: InputMaybe<Folio_User_Prepend_Input>;
  _set?: InputMaybe<Folio_User_Set_Input>;
  pk_columns: Folio_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Folio_User_ManyArgs = {
  updates: ReadonlyArray<Folio_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Geographical_RegionArgs = {
  _inc?: InputMaybe<Geographical_Region_Inc_Input>;
  _set?: InputMaybe<Geographical_Region_Set_Input>;
  where: Geographical_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Geographical_Region_By_PkArgs = {
  _inc?: InputMaybe<Geographical_Region_Inc_Input>;
  _set?: InputMaybe<Geographical_Region_Set_Input>;
  pk_columns: Geographical_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Geographical_Region_ManyArgs = {
  updates: ReadonlyArray<Geographical_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_InstrumentArgs = {
  _inc?: InputMaybe<Global_Instrument_Inc_Input>;
  _set?: InputMaybe<Global_Instrument_Set_Input>;
  where: Global_Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Instrument_By_PkArgs = {
  _inc?: InputMaybe<Global_Instrument_Inc_Input>;
  _set?: InputMaybe<Global_Instrument_Set_Input>;
  pk_columns: Global_Instrument_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Instrument_ManyArgs = {
  updates: ReadonlyArray<Global_Instrument_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_PackageArgs = {
  _inc?: InputMaybe<Global_Package_Inc_Input>;
  _set?: InputMaybe<Global_Package_Set_Input>;
  where: Global_Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Package_By_PkArgs = {
  _inc?: InputMaybe<Global_Package_Inc_Input>;
  _set?: InputMaybe<Global_Package_Set_Input>;
  pk_columns: Global_Package_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Package_ManyArgs = {
  updates: ReadonlyArray<Global_Package_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_PermissionArgs = {
  _inc?: InputMaybe<Global_Permission_Inc_Input>;
  _set?: InputMaybe<Global_Permission_Set_Input>;
  where: Global_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Permission_By_PkArgs = {
  _inc?: InputMaybe<Global_Permission_Inc_Input>;
  _set?: InputMaybe<Global_Permission_Set_Input>;
  pk_columns: Global_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Permission_ManyArgs = {
  updates: ReadonlyArray<Global_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_ProductArgs = {
  _inc?: InputMaybe<Global_Product_Inc_Input>;
  _set?: InputMaybe<Global_Product_Set_Input>;
  where: Global_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Product_By_PkArgs = {
  _inc?: InputMaybe<Global_Product_Inc_Input>;
  _set?: InputMaybe<Global_Product_Set_Input>;
  pk_columns: Global_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Product_ConfigArgs = {
  _inc?: InputMaybe<Global_Product_Config_Inc_Input>;
  _set?: InputMaybe<Global_Product_Config_Set_Input>;
  where: Global_Product_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Product_Config_By_PkArgs = {
  _inc?: InputMaybe<Global_Product_Config_Inc_Input>;
  _set?: InputMaybe<Global_Product_Config_Set_Input>;
  pk_columns: Global_Product_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Product_Config_ManyArgs = {
  updates: ReadonlyArray<Global_Product_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Product_ManyArgs = {
  updates: ReadonlyArray<Global_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grid_ChartsArgs = {
  _inc?: InputMaybe<Grid_Charts_Inc_Input>;
  _set?: InputMaybe<Grid_Charts_Set_Input>;
  where: Grid_Charts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grid_Charts_By_PkArgs = {
  _inc?: InputMaybe<Grid_Charts_Inc_Input>;
  _set?: InputMaybe<Grid_Charts_Set_Input>;
  pk_columns: Grid_Charts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grid_Charts_ManyArgs = {
  updates: ReadonlyArray<Grid_Charts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grid_SettingsArgs = {
  _append?: InputMaybe<Grid_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Grid_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Grid_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Grid_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Grid_Settings_Inc_Input>;
  _prepend?: InputMaybe<Grid_Settings_Prepend_Input>;
  _set?: InputMaybe<Grid_Settings_Set_Input>;
  where: Grid_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grid_Settings_By_PkArgs = {
  _append?: InputMaybe<Grid_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Grid_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Grid_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Grid_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Grid_Settings_Inc_Input>;
  _prepend?: InputMaybe<Grid_Settings_Prepend_Input>;
  _set?: InputMaybe<Grid_Settings_Set_Input>;
  pk_columns: Grid_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grid_Settings_ManyArgs = {
  updates: ReadonlyArray<Grid_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hfc_Card_SettingsArgs = {
  _set?: InputMaybe<Hfc_Card_Settings_Set_Input>;
  where: Hfc_Card_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hfc_Card_Settings_By_PkArgs = {
  _set?: InputMaybe<Hfc_Card_Settings_Set_Input>;
  pk_columns: Hfc_Card_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hfc_Card_Settings_ManyArgs = {
  updates: ReadonlyArray<Hfc_Card_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hfc_User_SettingsArgs = {
  _set?: InputMaybe<Hfc_User_Settings_Set_Input>;
  where: Hfc_User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hfc_User_Settings_By_PkArgs = {
  _set?: InputMaybe<Hfc_User_Settings_Set_Input>;
  pk_columns: Hfc_User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hfc_User_Settings_ManyArgs = {
  updates: ReadonlyArray<Hfc_User_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_BannersArgs = {
  _set?: InputMaybe<Incident_Banners_Set_Input>;
  where: Incident_Banners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Banners_By_PkArgs = {
  _set?: InputMaybe<Incident_Banners_Set_Input>;
  pk_columns: Incident_Banners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Banners_ManyArgs = {
  updates: ReadonlyArray<Incident_Banners_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_AnnotationsArgs = {
  _append?: InputMaybe<Live_Chart_Annotations_Append_Input>;
  _delete_at_path?: InputMaybe<Live_Chart_Annotations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Live_Chart_Annotations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Live_Chart_Annotations_Delete_Key_Input>;
  _prepend?: InputMaybe<Live_Chart_Annotations_Prepend_Input>;
  _set?: InputMaybe<Live_Chart_Annotations_Set_Input>;
  where: Live_Chart_Annotations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_Annotations_By_PkArgs = {
  _append?: InputMaybe<Live_Chart_Annotations_Append_Input>;
  _delete_at_path?: InputMaybe<Live_Chart_Annotations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Live_Chart_Annotations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Live_Chart_Annotations_Delete_Key_Input>;
  _prepend?: InputMaybe<Live_Chart_Annotations_Prepend_Input>;
  _set?: InputMaybe<Live_Chart_Annotations_Set_Input>;
  pk_columns: Live_Chart_Annotations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_Annotations_ManyArgs = {
  updates: ReadonlyArray<Live_Chart_Annotations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_PageArgs = {
  _append?: InputMaybe<Live_Chart_Page_Append_Input>;
  _delete_at_path?: InputMaybe<Live_Chart_Page_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Live_Chart_Page_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Live_Chart_Page_Delete_Key_Input>;
  _prepend?: InputMaybe<Live_Chart_Page_Prepend_Input>;
  _set?: InputMaybe<Live_Chart_Page_Set_Input>;
  where: Live_Chart_Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_Page_By_PkArgs = {
  _append?: InputMaybe<Live_Chart_Page_Append_Input>;
  _delete_at_path?: InputMaybe<Live_Chart_Page_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Live_Chart_Page_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Live_Chart_Page_Delete_Key_Input>;
  _prepend?: InputMaybe<Live_Chart_Page_Prepend_Input>;
  _set?: InputMaybe<Live_Chart_Page_Set_Input>;
  pk_columns: Live_Chart_Page_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_Page_ManyArgs = {
  updates: ReadonlyArray<Live_Chart_Page_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_SettingsArgs = {
  _append?: InputMaybe<Live_Chart_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Live_Chart_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Live_Chart_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Live_Chart_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Live_Chart_Settings_Prepend_Input>;
  _set?: InputMaybe<Live_Chart_Settings_Set_Input>;
  where: Live_Chart_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_Settings_By_PkArgs = {
  _append?: InputMaybe<Live_Chart_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Live_Chart_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Live_Chart_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Live_Chart_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Live_Chart_Settings_Prepend_Input>;
  _set?: InputMaybe<Live_Chart_Settings_Set_Input>;
  pk_columns: Live_Chart_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Chart_Settings_ManyArgs = {
  updates: ReadonlyArray<Live_Chart_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Local_InstrumentArgs = {
  _inc?: InputMaybe<Local_Instrument_Inc_Input>;
  _set?: InputMaybe<Local_Instrument_Set_Input>;
  where: Local_Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Local_Instrument_By_PkArgs = {
  _inc?: InputMaybe<Local_Instrument_Inc_Input>;
  _set?: InputMaybe<Local_Instrument_Set_Input>;
  pk_columns: Local_Instrument_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Local_Instrument_ManyArgs = {
  updates: ReadonlyArray<Local_Instrument_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Logout_RequestArgs = {
  _inc?: InputMaybe<Logout_Request_Inc_Input>;
  _set?: InputMaybe<Logout_Request_Set_Input>;
  where: Logout_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logout_Request_By_PkArgs = {
  _inc?: InputMaybe<Logout_Request_Inc_Input>;
  _set?: InputMaybe<Logout_Request_Set_Input>;
  pk_columns: Logout_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Logout_Request_ManyArgs = {
  updates: ReadonlyArray<Logout_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_StorageArgs = {
  _append?: InputMaybe<Module_Storage_Append_Input>;
  _delete_at_path?: InputMaybe<Module_Storage_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Module_Storage_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Module_Storage_Delete_Key_Input>;
  _inc?: InputMaybe<Module_Storage_Inc_Input>;
  _prepend?: InputMaybe<Module_Storage_Prepend_Input>;
  _set?: InputMaybe<Module_Storage_Set_Input>;
  where: Module_Storage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Storage_By_PkArgs = {
  _append?: InputMaybe<Module_Storage_Append_Input>;
  _delete_at_path?: InputMaybe<Module_Storage_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Module_Storage_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Module_Storage_Delete_Key_Input>;
  _inc?: InputMaybe<Module_Storage_Inc_Input>;
  _prepend?: InputMaybe<Module_Storage_Prepend_Input>;
  _set?: InputMaybe<Module_Storage_Set_Input>;
  pk_columns: Module_Storage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Storage_ManyArgs = {
  updates: ReadonlyArray<Module_Storage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationArgs = {
  _inc?: InputMaybe<Organisation_Inc_Input>;
  _set?: InputMaybe<Organisation_Set_Input>;
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Inc_Input>;
  _set?: InputMaybe<Organisation_Set_Input>;
  pk_columns: Organisation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ManyArgs = {
  updates: ReadonlyArray<Organisation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PackageArgs = {
  _inc?: InputMaybe<Package_Inc_Input>;
  _set?: InputMaybe<Package_Set_Input>;
  where: Package_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Package_By_PkArgs = {
  _inc?: InputMaybe<Package_Inc_Input>;
  _set?: InputMaybe<Package_Set_Input>;
  pk_columns: Package_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Package_ManyArgs = {
  updates: ReadonlyArray<Package_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Package_TypeArgs = {
  _set?: InputMaybe<Package_Type_Set_Input>;
  where: Package_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Package_Type_By_PkArgs = {
  _set?: InputMaybe<Package_Type_Set_Input>;
  pk_columns: Package_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Package_Type_ManyArgs = {
  updates: ReadonlyArray<Package_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Page_MemberArgs = {
  _set?: InputMaybe<Page_Member_Set_Input>;
  where: Page_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Member_By_PkArgs = {
  _set?: InputMaybe<Page_Member_Set_Input>;
  pk_columns: Page_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Member_ManyArgs = {
  updates: ReadonlyArray<Page_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Page_ProductsArgs = {
  _inc?: InputMaybe<Page_Products_Inc_Input>;
  _set?: InputMaybe<Page_Products_Set_Input>;
  where: Page_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Products_By_PkArgs = {
  _inc?: InputMaybe<Page_Products_Inc_Input>;
  _set?: InputMaybe<Page_Products_Set_Input>;
  pk_columns: Page_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Products_ManyArgs = {
  updates: ReadonlyArray<Page_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Page_SettingsArgs = {
  _set?: InputMaybe<Page_Settings_Set_Input>;
  where: Page_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Settings_By_PkArgs = {
  _set?: InputMaybe<Page_Settings_Set_Input>;
  pk_columns: Page_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Settings_ManyArgs = {
  updates: ReadonlyArray<Page_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PagesArgs = {
  _inc?: InputMaybe<Pages_Inc_Input>;
  _set?: InputMaybe<Pages_Set_Input>;
  where: Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pages_By_PkArgs = {
  _inc?: InputMaybe<Pages_Inc_Input>;
  _set?: InputMaybe<Pages_Set_Input>;
  pk_columns: Pages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pages_ManyArgs = {
  updates: ReadonlyArray<Pages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionArgs = {
  _inc?: InputMaybe<Permission_Inc_Input>;
  _set?: InputMaybe<Permission_Set_Input>;
  where: Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permission_By_PkArgs = {
  _inc?: InputMaybe<Permission_Inc_Input>;
  _set?: InputMaybe<Permission_Set_Input>;
  pk_columns: Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permission_ManyArgs = {
  updates: ReadonlyArray<Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_AlertsArgs = {
  _set?: InputMaybe<Product_Alerts_Set_Input>;
  where: Product_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Alerts_By_PkArgs = {
  _set?: InputMaybe<Product_Alerts_Set_Input>;
  pk_columns: Product_Alerts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Alerts_ManyArgs = {
  updates: ReadonlyArray<Product_Alerts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Artis_TypeArgs = {
  _set?: InputMaybe<Product_Artis_Type_Set_Input>;
  where: Product_Artis_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Artis_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Artis_Type_Set_Input>;
  pk_columns: Product_Artis_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Artis_Type_ManyArgs = {
  updates: ReadonlyArray<Product_Artis_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ConfigArgs = {
  _append?: InputMaybe<Product_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Product_Config_Inc_Input>;
  _prepend?: InputMaybe<Product_Config_Prepend_Input>;
  _set?: InputMaybe<Product_Config_Set_Input>;
  where: Product_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Config_By_PkArgs = {
  _append?: InputMaybe<Product_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Product_Config_Inc_Input>;
  _prepend?: InputMaybe<Product_Config_Prepend_Input>;
  _set?: InputMaybe<Product_Config_Set_Input>;
  pk_columns: Product_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Config_ManyArgs = {
  updates: ReadonlyArray<Product_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Curve_TypeArgs = {
  _set?: InputMaybe<Product_Curve_Type_Set_Input>;
  where: Product_Curve_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Curve_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Curve_Type_Set_Input>;
  pk_columns: Product_Curve_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Curve_Type_ManyArgs = {
  updates: ReadonlyArray<Product_Curve_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_EodArgs = {
  _inc?: InputMaybe<Product_Eod_Inc_Input>;
  _set?: InputMaybe<Product_Eod_Set_Input>;
  where: Product_Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Eod_By_PkArgs = {
  _inc?: InputMaybe<Product_Eod_Inc_Input>;
  _set?: InputMaybe<Product_Eod_Set_Input>;
  pk_columns: Product_Eod_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Eod_ManyArgs = {
  updates: ReadonlyArray<Product_Eod_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Global_DependenciesArgs = {
  _set?: InputMaybe<Product_Global_Dependencies_Set_Input>;
  where: Product_Global_Dependencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Global_Dependencies_By_PkArgs = {
  _set?: InputMaybe<Product_Global_Dependencies_Set_Input>;
  pk_columns: Product_Global_Dependencies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Global_Dependencies_ManyArgs = {
  updates: ReadonlyArray<Product_Global_Dependencies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: ReadonlyArray<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_MaturityArgs = {
  _set?: InputMaybe<Product_Maturity_Set_Input>;
  where: Product_Maturity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Maturity_By_PkArgs = {
  _set?: InputMaybe<Product_Maturity_Set_Input>;
  pk_columns: Product_Maturity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Maturity_ManyArgs = {
  updates: ReadonlyArray<Product_Maturity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_OverridesArgs = {
  _inc?: InputMaybe<Product_Overrides_Inc_Input>;
  _set?: InputMaybe<Product_Overrides_Set_Input>;
  where: Product_Overrides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Overrides_By_PkArgs = {
  _inc?: InputMaybe<Product_Overrides_Inc_Input>;
  _set?: InputMaybe<Product_Overrides_Set_Input>;
  pk_columns: Product_Overrides_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Overrides_ManyArgs = {
  updates: ReadonlyArray<Product_Overrides_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_SourceArgs = {
  _set?: InputMaybe<Product_Source_Set_Input>;
  where: Product_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Source_By_PkArgs = {
  _set?: InputMaybe<Product_Source_Set_Input>;
  pk_columns: Product_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Source_ManyArgs = {
  updates: ReadonlyArray<Product_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Summary_TypeArgs = {
  _set?: InputMaybe<Product_Summary_Type_Set_Input>;
  where: Product_Summary_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Summary_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Summary_Type_Set_Input>;
  pk_columns: Product_Summary_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Summary_Type_ManyArgs = {
  updates: ReadonlyArray<Product_Summary_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_TypeArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  pk_columns: Product_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_ManyArgs = {
  updates: ReadonlyArray<Product_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_UomArgs = {
  _set?: InputMaybe<Product_Uom_Set_Input>;
  where: Product_Uom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Uom_By_PkArgs = {
  _set?: InputMaybe<Product_Uom_Set_Input>;
  pk_columns: Product_Uom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Uom_ManyArgs = {
  updates: ReadonlyArray<Product_Uom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_User_SettingsArgs = {
  _inc?: InputMaybe<Product_User_Settings_Inc_Input>;
  _set?: InputMaybe<Product_User_Settings_Set_Input>;
  where: Product_User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_User_Settings_By_PkArgs = {
  _inc?: InputMaybe<Product_User_Settings_Inc_Input>;
  _set?: InputMaybe<Product_User_Settings_Set_Input>;
  pk_columns: Product_User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_User_Settings_ManyArgs = {
  updates: ReadonlyArray<Product_User_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Push_SubscriptionsArgs = {
  _append?: InputMaybe<Push_Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Push_Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Push_Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Push_Subscriptions_Delete_Key_Input>;
  _prepend?: InputMaybe<Push_Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Push_Subscriptions_Set_Input>;
  where: Push_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Subscriptions_By_PkArgs = {
  _append?: InputMaybe<Push_Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Push_Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Push_Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Push_Subscriptions_Delete_Key_Input>;
  _prepend?: InputMaybe<Push_Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Push_Subscriptions_Set_Input>;
  pk_columns: Push_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Subscriptions_ManyArgs = {
  updates: ReadonlyArray<Push_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quick_AccessArgs = {
  _inc?: InputMaybe<Quick_Access_Inc_Input>;
  _set?: InputMaybe<Quick_Access_Set_Input>;
  where: Quick_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quick_Access_By_PkArgs = {
  _inc?: InputMaybe<Quick_Access_Inc_Input>;
  _set?: InputMaybe<Quick_Access_Set_Input>;
  pk_columns: Quick_Access_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quick_Access_ManyArgs = {
  updates: ReadonlyArray<Quick_Access_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScratchpadArgs = {
  _append?: InputMaybe<Scratchpad_Append_Input>;
  _delete_at_path?: InputMaybe<Scratchpad_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scratchpad_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scratchpad_Delete_Key_Input>;
  _prepend?: InputMaybe<Scratchpad_Prepend_Input>;
  _set?: InputMaybe<Scratchpad_Set_Input>;
  where: Scratchpad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scratchpad_By_PkArgs = {
  _append?: InputMaybe<Scratchpad_Append_Input>;
  _delete_at_path?: InputMaybe<Scratchpad_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scratchpad_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scratchpad_Delete_Key_Input>;
  _prepend?: InputMaybe<Scratchpad_Prepend_Input>;
  _set?: InputMaybe<Scratchpad_Set_Input>;
  pk_columns: Scratchpad_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scratchpad_ManyArgs = {
  updates: ReadonlyArray<Scratchpad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SessionArgs = {
  _set?: InputMaybe<Session_Set_Input>;
  where: Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Session_By_PkArgs = {
  _set?: InputMaybe<Session_Set_Input>;
  pk_columns: Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Session_ManyArgs = {
  updates: ReadonlyArray<Session_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Session_TypeArgs = {
  _set?: InputMaybe<Session_Type_Set_Input>;
  where: Session_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Type_By_PkArgs = {
  _set?: InputMaybe<Session_Type_Set_Input>;
  pk_columns: Session_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Type_ManyArgs = {
  updates: ReadonlyArray<Session_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_InstrumentArgs = {
  _inc?: InputMaybe<Shared_Instrument_Inc_Input>;
  _set?: InputMaybe<Shared_Instrument_Set_Input>;
  where: Shared_Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_Instrument_By_PkArgs = {
  _inc?: InputMaybe<Shared_Instrument_Inc_Input>;
  _set?: InputMaybe<Shared_Instrument_Set_Input>;
  pk_columns: Shared_Instrument_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_Instrument_ManyArgs = {
  updates: ReadonlyArray<Shared_Instrument_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sharing_AgreementArgs = {
  _inc?: InputMaybe<Sharing_Agreement_Inc_Input>;
  _set?: InputMaybe<Sharing_Agreement_Set_Input>;
  where: Sharing_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sharing_Agreement_By_PkArgs = {
  _inc?: InputMaybe<Sharing_Agreement_Inc_Input>;
  _set?: InputMaybe<Sharing_Agreement_Set_Input>;
  pk_columns: Sharing_Agreement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sharing_Agreement_ManyArgs = {
  updates: ReadonlyArray<Sharing_Agreement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SourceArgs = {
  _inc?: InputMaybe<Source_Inc_Input>;
  _set?: InputMaybe<Source_Set_Input>;
  where: Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Source_By_PkArgs = {
  _inc?: InputMaybe<Source_Inc_Input>;
  _set?: InputMaybe<Source_Set_Input>;
  pk_columns: Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Source_ManyArgs = {
  updates: ReadonlyArray<Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spreader_StateArgs = {
  _append?: InputMaybe<Spreader_State_Append_Input>;
  _delete_at_path?: InputMaybe<Spreader_State_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spreader_State_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spreader_State_Delete_Key_Input>;
  _inc?: InputMaybe<Spreader_State_Inc_Input>;
  _prepend?: InputMaybe<Spreader_State_Prepend_Input>;
  _set?: InputMaybe<Spreader_State_Set_Input>;
  where: Spreader_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spreader_State_By_PkArgs = {
  _append?: InputMaybe<Spreader_State_Append_Input>;
  _delete_at_path?: InputMaybe<Spreader_State_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spreader_State_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spreader_State_Delete_Key_Input>;
  _inc?: InputMaybe<Spreader_State_Inc_Input>;
  _prepend?: InputMaybe<Spreader_State_Prepend_Input>;
  _set?: InputMaybe<Spreader_State_Set_Input>;
  pk_columns: Spreader_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spreader_State_ManyArgs = {
  updates: ReadonlyArray<Spreader_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_TierArgs = {
  _set?: InputMaybe<Subscription_Tier_Set_Input>;
  where: Subscription_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Tier_By_PkArgs = {
  _set?: InputMaybe<Subscription_Tier_Set_Input>;
  pk_columns: Subscription_Tier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Tier_ManyArgs = {
  updates: ReadonlyArray<Subscription_Tier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Umi_ActionArgs = {
  _append?: InputMaybe<Umi_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Umi_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Umi_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Umi_Action_Delete_Key_Input>;
  _inc?: InputMaybe<Umi_Action_Inc_Input>;
  _prepend?: InputMaybe<Umi_Action_Prepend_Input>;
  _set?: InputMaybe<Umi_Action_Set_Input>;
  where: Umi_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Umi_Action_By_PkArgs = {
  _append?: InputMaybe<Umi_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Umi_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Umi_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Umi_Action_Delete_Key_Input>;
  _inc?: InputMaybe<Umi_Action_Inc_Input>;
  _prepend?: InputMaybe<Umi_Action_Prepend_Input>;
  _set?: InputMaybe<Umi_Action_Set_Input>;
  pk_columns: Umi_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Umi_Action_ManyArgs = {
  updates: ReadonlyArray<Umi_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Umi_Action_NameArgs = {
  _set?: InputMaybe<Umi_Action_Name_Set_Input>;
  where: Umi_Action_Name_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Umi_Action_Name_By_PkArgs = {
  _set?: InputMaybe<Umi_Action_Name_Set_Input>;
  pk_columns: Umi_Action_Name_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Umi_Action_Name_ManyArgs = {
  updates: ReadonlyArray<Umi_Action_Name_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_EntitlementArgs = {
  _inc?: InputMaybe<User_Entitlement_Inc_Input>;
  _set?: InputMaybe<User_Entitlement_Set_Input>;
  where: User_Entitlement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_By_PkArgs = {
  _inc?: InputMaybe<User_Entitlement_Inc_Input>;
  _set?: InputMaybe<User_Entitlement_Set_Input>;
  pk_columns: User_Entitlement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_KindArgs = {
  _set?: InputMaybe<User_Entitlement_Kind_Set_Input>;
  where: User_Entitlement_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_Kind_By_PkArgs = {
  _set?: InputMaybe<User_Entitlement_Kind_Set_Input>;
  pk_columns: User_Entitlement_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_Kind_ManyArgs = {
  updates: ReadonlyArray<User_Entitlement_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_LevelArgs = {
  _inc?: InputMaybe<User_Entitlement_Level_Inc_Input>;
  _set?: InputMaybe<User_Entitlement_Level_Set_Input>;
  where: User_Entitlement_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_Level_By_PkArgs = {
  _inc?: InputMaybe<User_Entitlement_Level_Inc_Input>;
  _set?: InputMaybe<User_Entitlement_Level_Set_Input>;
  pk_columns: User_Entitlement_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_Level_ManyArgs = {
  updates: ReadonlyArray<User_Entitlement_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Entitlement_ManyArgs = {
  updates: ReadonlyArray<User_Entitlement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_GroupsArgs = {
  _append?: InputMaybe<User_Groups_Append_Input>;
  _delete_at_path?: InputMaybe<User_Groups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Groups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Groups_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Groups_Prepend_Input>;
  _set?: InputMaybe<User_Groups_Set_Input>;
  where: User_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Groups_By_PkArgs = {
  _append?: InputMaybe<User_Groups_Append_Input>;
  _delete_at_path?: InputMaybe<User_Groups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Groups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Groups_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Groups_Prepend_Input>;
  _set?: InputMaybe<User_Groups_Set_Input>;
  pk_columns: User_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Groups_ManyArgs = {
  updates: ReadonlyArray<User_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RightArgs = {
  _set?: InputMaybe<User_Right_Set_Input>;
  where: User_Right_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Right_By_PkArgs = {
  _set?: InputMaybe<User_Right_Set_Input>;
  pk_columns: User_Right_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Right_ManyArgs = {
  updates: ReadonlyArray<User_Right_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_StorageArgs = {
  _set?: InputMaybe<User_Storage_Set_Input>;
  where: User_Storage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Storage_By_PkArgs = {
  _set?: InputMaybe<User_Storage_Set_Input>;
  pk_columns: User_Storage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Storage_ManyArgs = {
  updates: ReadonlyArray<User_Storage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Viewed_AnnouncementsArgs = {
  _set?: InputMaybe<Viewed_Announcements_Set_Input>;
  where: Viewed_Announcements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Viewed_Announcements_By_PkArgs = {
  _set?: InputMaybe<Viewed_Announcements_Set_Input>;
  pk_columns: Viewed_Announcements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Viewed_Announcements_ManyArgs = {
  updates: ReadonlyArray<Viewed_Announcements_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['numeric']['input']>;
  readonly _gt?: InputMaybe<Scalars['numeric']['input']>;
  readonly _gte?: InputMaybe<Scalars['numeric']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['numeric']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['numeric']['input']>;
  readonly _lte?: InputMaybe<Scalars['numeric']['input']>;
  readonly _neq?: InputMaybe<Scalars['numeric']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['numeric']['input']>>;
};

/** column ordering options */
export type Order_By =
  /** in ascending order, nulls last */
  | 'asc'
  /** in ascending order, nulls first */
  | 'asc_nulls_first'
  /** in ascending order, nulls last */
  | 'asc_nulls_last'
  /** in descending order, nulls first */
  | 'desc'
  /** in descending order, nulls first */
  | 'desc_nulls_first'
  /** in descending order, nulls last */
  | 'desc_nulls_last';

/** columns and relationships of "organisation" */
export type Organisation = {
  readonly __typename?: 'organisation';
  /** An array relationship */
  readonly commodity_parent_groups: ReadonlyArray<Commodity_Parent_Group>;
  /** An aggregate relationship */
  readonly commodity_parent_groups_aggregate: Commodity_Parent_Group_Aggregate;
  /** An array relationship */
  readonly folio_users: ReadonlyArray<Folio_User>;
  /** An aggregate relationship */
  readonly folio_users_aggregate: Folio_User_Aggregate;
  /** An array relationship */
  readonly geographical_regions: ReadonlyArray<Geographical_Region>;
  /** An aggregate relationship */
  readonly geographical_regions_aggregate: Geographical_Region_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly is_allowed_global_packages?: Maybe<Scalars['Boolean']['output']>;
  readonly mfa_mode: Scalars['mfa_mode_enum']['output'];
  readonly needs_historical_data: Scalars['Boolean']['output'];
  /** An array relationship */
  readonly product_overrides: ReadonlyArray<Product_Overrides>;
  /** An aggregate relationship */
  readonly product_overrides_aggregate: Product_Overrides_Aggregate;
  readonly source: Scalars['Int']['output'];
  /** An object relationship */
  readonly sourceBySource: Source;
};


/** columns and relationships of "organisation" */
export type OrganisationCommodity_Parent_GroupsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Order_By>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationCommodity_Parent_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Order_By>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationFolio_UsersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationFolio_Users_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationGeographical_RegionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Geographical_Region_Order_By>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationGeographical_Regions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Geographical_Region_Order_By>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationProduct_OverridesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationProduct_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};

/** aggregated selection of "organisation" */
export type Organisation_Aggregate = {
  readonly __typename?: 'organisation_aggregate';
  readonly aggregate?: Maybe<Organisation_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Organisation>;
};

export type Organisation_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Organisation_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Organisation_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Organisation_Aggregate_Bool_Exp_Count>;
};

export type Organisation_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Organisation_Select_Column_Organisation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Organisation_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Organisation_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Organisation_Select_Column_Organisation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Organisation_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Organisation_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Organisation_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation" */
export type Organisation_Aggregate_Fields = {
  readonly __typename?: 'organisation_aggregate_fields';
  readonly avg?: Maybe<Organisation_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Organisation_Max_Fields>;
  readonly min?: Maybe<Organisation_Min_Fields>;
  readonly stddev?: Maybe<Organisation_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Organisation_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Organisation_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Organisation_Sum_Fields>;
  readonly var_pop?: Maybe<Organisation_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Organisation_Var_Samp_Fields>;
  readonly variance?: Maybe<Organisation_Variance_Fields>;
};


/** aggregate fields of "organisation" */
export type Organisation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation" */
export type Organisation_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Organisation_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Organisation_Max_Order_By>;
  readonly min?: InputMaybe<Organisation_Min_Order_By>;
  readonly stddev?: InputMaybe<Organisation_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Organisation_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Organisation_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Organisation_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Organisation_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Organisation_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Organisation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation" */
export type Organisation_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Organisation_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Organisation_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Avg_Fields = {
  readonly __typename?: 'organisation_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organisation" */
export type Organisation_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation". All fields are combined with a logical 'AND'. */
export type Organisation_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Organisation_Bool_Exp>>;
  readonly _not?: InputMaybe<Organisation_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Organisation_Bool_Exp>>;
  readonly commodity_parent_groups?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
  readonly commodity_parent_groups_aggregate?: InputMaybe<Commodity_Parent_Group_Aggregate_Bool_Exp>;
  readonly folio_users?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_users_aggregate?: InputMaybe<Folio_User_Aggregate_Bool_Exp>;
  readonly geographical_regions?: InputMaybe<Geographical_Region_Bool_Exp>;
  readonly geographical_regions_aggregate?: InputMaybe<Geographical_Region_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly is_allowed_global_packages?: InputMaybe<Boolean_Comparison_Exp>;
  readonly mfa_mode?: InputMaybe<Mfa_Mode_Enum_Comparison_Exp>;
  readonly needs_historical_data?: InputMaybe<Boolean_Comparison_Exp>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Bool_Exp>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Bool_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
  readonly sourceBySource?: InputMaybe<Source_Bool_Exp>;
};

/** unique or primary key constraints on table "organisation" */
export type Organisation_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'organisation_pkey'
  /** unique or primary key constraint on columns "source" */
  | 'organisation_source_key';

/** input type for incrementing numeric columns in table "organisation" */
export type Organisation_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organisation" */
export type Organisation_Insert_Input = {
  readonly commodity_parent_groups?: InputMaybe<Commodity_Parent_Group_Arr_Rel_Insert_Input>;
  readonly folio_users?: InputMaybe<Folio_User_Arr_Rel_Insert_Input>;
  readonly geographical_regions?: InputMaybe<Geographical_Region_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly is_allowed_global_packages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mfa_mode?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly needs_historical_data?: InputMaybe<Scalars['Boolean']['input']>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Arr_Rel_Insert_Input>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
  readonly sourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organisation_Max_Fields = {
  readonly __typename?: 'organisation_max_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly mfa_mode?: Maybe<Scalars['mfa_mode_enum']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "organisation" */
export type Organisation_Max_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly mfa_mode?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Min_Fields = {
  readonly __typename?: 'organisation_min_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly mfa_mode?: Maybe<Scalars['mfa_mode_enum']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "organisation" */
export type Organisation_Min_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly mfa_mode?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation" */
export type Organisation_Mutation_Response = {
  readonly __typename?: 'organisation_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Organisation>;
};

/** input type for inserting object relation for remote table "organisation" */
export type Organisation_Obj_Rel_Insert_Input = {
  readonly data: Organisation_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Organisation_On_Conflict>;
};

/** on_conflict condition type for table "organisation" */
export type Organisation_On_Conflict = {
  readonly constraint: Organisation_Constraint;
  readonly update_columns?: ReadonlyArray<Organisation_Update_Column>;
  readonly where?: InputMaybe<Organisation_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation". */
export type Organisation_Order_By = {
  readonly commodity_parent_groups_aggregate?: InputMaybe<Commodity_Parent_Group_Aggregate_Order_By>;
  readonly folio_users_aggregate?: InputMaybe<Folio_User_Aggregate_Order_By>;
  readonly geographical_regions_aggregate?: InputMaybe<Geographical_Region_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_allowed_global_packages?: InputMaybe<Order_By>;
  readonly mfa_mode?: InputMaybe<Order_By>;
  readonly needs_historical_data?: InputMaybe<Order_By>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly sourceBySource?: InputMaybe<Source_Order_By>;
};

/** primary key columns input for table: organisation */
export type Organisation_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "organisation" */
export type Organisation_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'is_allowed_global_packages'
  /** column name */
  | 'mfa_mode'
  /** column name */
  | 'needs_historical_data'
  /** column name */
  | 'source';

/** select "organisation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation" */
export type Organisation_Select_Column_Organisation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_allowed_global_packages'
  /** column name */
  | 'needs_historical_data';

/** select "organisation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation" */
export type Organisation_Select_Column_Organisation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_allowed_global_packages'
  /** column name */
  | 'needs_historical_data';

/** input type for updating data in table "organisation" */
export type Organisation_Set_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly is_allowed_global_packages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mfa_mode?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly needs_historical_data?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Organisation_Stddev_Fields = {
  readonly __typename?: 'organisation_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organisation" */
export type Organisation_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Stddev_Pop_Fields = {
  readonly __typename?: 'organisation_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organisation" */
export type Organisation_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Stddev_Samp_Fields = {
  readonly __typename?: 'organisation_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organisation" */
export type Organisation_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation" */
export type Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly is_allowed_global_packages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mfa_mode?: InputMaybe<Scalars['mfa_mode_enum']['input']>;
  readonly needs_historical_data?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Organisation_Sum_Fields = {
  readonly __typename?: 'organisation_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organisation" */
export type Organisation_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** update columns of table "organisation" */
export type Organisation_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'is_allowed_global_packages'
  /** column name */
  | 'mfa_mode'
  /** column name */
  | 'needs_historical_data'
  /** column name */
  | 'source';

export type Organisation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Organisation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Organisation_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Organisation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Var_Pop_Fields = {
  readonly __typename?: 'organisation_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organisation" */
export type Organisation_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Var_Samp_Fields = {
  readonly __typename?: 'organisation_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organisation" */
export type Organisation_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Variance_Fields = {
  readonly __typename?: 'organisation_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organisation" */
export type Organisation_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** columns and relationships of "package" */
export type Package = {
  readonly __typename?: 'package';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  readonly folio_users: ReadonlyArray<Folio_User>;
  /** An aggregate relationship */
  readonly folio_users_aggregate: Folio_User_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly is_global?: Maybe<Scalars['Boolean']['output']>;
  readonly name: Scalars['String']['output'];
  /** An object relationship */
  readonly packageTypeByPackageType?: Maybe<Package_Type>;
  readonly package_type?: Maybe<Package_Type_Enum>;
  /** An array relationship */
  readonly permissions: ReadonlyArray<Permission>;
  /** An aggregate relationship */
  readonly permissions_aggregate: Permission_Aggregate;
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly source: Scalars['Int']['output'];
  /** An object relationship */
  readonly sourceBySource: Source;
};


/** columns and relationships of "package" */
export type PackageFolio_UsersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


/** columns and relationships of "package" */
export type PackageFolio_Users_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


/** columns and relationships of "package" */
export type PackagePermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "package" */
export type PackagePermissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "package" */
export type PackageProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "package" */
export type PackageProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "package" */
export type Package_Aggregate = {
  readonly __typename?: 'package_aggregate';
  readonly aggregate?: Maybe<Package_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Package>;
};

export type Package_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Package_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Package_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Package_Aggregate_Bool_Exp_Count>;
};

export type Package_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Package_Select_Column_Package_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Package_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Package_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Package_Select_Column_Package_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Package_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Package_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Package_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "package" */
export type Package_Aggregate_Fields = {
  readonly __typename?: 'package_aggregate_fields';
  readonly avg?: Maybe<Package_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Package_Max_Fields>;
  readonly min?: Maybe<Package_Min_Fields>;
  readonly stddev?: Maybe<Package_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Package_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Package_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Package_Sum_Fields>;
  readonly var_pop?: Maybe<Package_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Package_Var_Samp_Fields>;
  readonly variance?: Maybe<Package_Variance_Fields>;
};


/** aggregate fields of "package" */
export type Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "package" */
export type Package_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Package_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Package_Max_Order_By>;
  readonly min?: InputMaybe<Package_Min_Order_By>;
  readonly stddev?: InputMaybe<Package_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Package_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Package_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Package_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Package_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Package_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Package_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "package" */
export type Package_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Package_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Package_On_Conflict>;
};

/** aggregate avg on columns */
export type Package_Avg_Fields = {
  readonly __typename?: 'package_avg_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "package" */
export type Package_Avg_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "package". All fields are combined with a logical 'AND'. */
export type Package_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Package_Bool_Exp>>;
  readonly _not?: InputMaybe<Package_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Package_Bool_Exp>>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly dp?: InputMaybe<Int_Comparison_Exp>;
  readonly folio_users?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_users_aggregate?: InputMaybe<Folio_User_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly is_global?: InputMaybe<Boolean_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly packageTypeByPackageType?: InputMaybe<Package_Type_Bool_Exp>;
  readonly package_type?: InputMaybe<Package_Type_Enum_Comparison_Exp>;
  readonly permissions?: InputMaybe<Permission_Bool_Exp>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Bool_Exp>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly source?: InputMaybe<Int_Comparison_Exp>;
  readonly sourceBySource?: InputMaybe<Source_Bool_Exp>;
};

/** unique or primary key constraints on table "package" */
export type Package_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'package_pkey'
  /** unique or primary key constraint on columns "name", "source" */
  | 'package_source_name_key';

/** input type for incrementing numeric columns in table "package" */
export type Package_Inc_Input = {
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "package" */
export type Package_Insert_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly folio_users?: InputMaybe<Folio_User_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly is_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly packageTypeByPackageType?: InputMaybe<Package_Type_Obj_Rel_Insert_Input>;
  readonly package_type?: InputMaybe<Package_Type_Enum>;
  readonly permissions?: InputMaybe<Permission_Arr_Rel_Insert_Input>;
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
  readonly sourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Package_Max_Fields = {
  readonly __typename?: 'package_max_fields';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "package" */
export type Package_Max_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Package_Min_Fields = {
  readonly __typename?: 'package_min_fields';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "package" */
export type Package_Min_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "package" */
export type Package_Mutation_Response = {
  readonly __typename?: 'package_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Package>;
};

/** input type for inserting object relation for remote table "package" */
export type Package_Obj_Rel_Insert_Input = {
  readonly data: Package_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Package_On_Conflict>;
};

/** on_conflict condition type for table "package" */
export type Package_On_Conflict = {
  readonly constraint: Package_Constraint;
  readonly update_columns?: ReadonlyArray<Package_Update_Column>;
  readonly where?: InputMaybe<Package_Bool_Exp>;
};

/** Ordering options when selecting data from "package". */
export type Package_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly folio_users_aggregate?: InputMaybe<Folio_User_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_global?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly packageTypeByPackageType?: InputMaybe<Package_Type_Order_By>;
  readonly package_type?: InputMaybe<Order_By>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Order_By>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly sourceBySource?: InputMaybe<Source_Order_By>;
};

/** primary key columns input for table: package */
export type Package_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "package" */
export type Package_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'dp'
  /** column name */
  | 'id'
  /** column name */
  | 'is_global'
  /** column name */
  | 'name'
  /** column name */
  | 'package_type'
  /** column name */
  | 'source';

/** select "package_aggregate_bool_exp_bool_and_arguments_columns" columns of table "package" */
export type Package_Select_Column_Package_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_global';

/** select "package_aggregate_bool_exp_bool_or_arguments_columns" columns of table "package" */
export type Package_Select_Column_Package_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_global';

/** input type for updating data in table "package" */
export type Package_Set_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly is_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package_type?: InputMaybe<Package_Type_Enum>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Package_Stddev_Fields = {
  readonly __typename?: 'package_stddev_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "package" */
export type Package_Stddev_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Package_Stddev_Pop_Fields = {
  readonly __typename?: 'package_stddev_pop_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "package" */
export type Package_Stddev_Pop_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Package_Stddev_Samp_Fields = {
  readonly __typename?: 'package_stddev_samp_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "package" */
export type Package_Stddev_Samp_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "package" */
export type Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Package_Stream_Cursor_Value_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly is_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package_type?: InputMaybe<Package_Type_Enum>;
  readonly source?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Package_Sum_Fields = {
  readonly __typename?: 'package_sum_fields';
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly source?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "package" */
export type Package_Sum_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** columns and relationships of "package_type" */
export type Package_Type = {
  readonly __typename?: 'package_type';
  /** An array relationship */
  readonly packages: ReadonlyArray<Package>;
  /** An aggregate relationship */
  readonly packages_aggregate: Package_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "package_type" */
export type Package_TypePackagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


/** columns and relationships of "package_type" */
export type Package_TypePackages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};

/** aggregated selection of "package_type" */
export type Package_Type_Aggregate = {
  readonly __typename?: 'package_type_aggregate';
  readonly aggregate?: Maybe<Package_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Package_Type>;
};

/** aggregate fields of "package_type" */
export type Package_Type_Aggregate_Fields = {
  readonly __typename?: 'package_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Package_Type_Max_Fields>;
  readonly min?: Maybe<Package_Type_Min_Fields>;
};


/** aggregate fields of "package_type" */
export type Package_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Package_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "package_type". All fields are combined with a logical 'AND'. */
export type Package_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Package_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Package_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Package_Type_Bool_Exp>>;
  readonly packages?: InputMaybe<Package_Bool_Exp>;
  readonly packages_aggregate?: InputMaybe<Package_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "package_type" */
export type Package_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'package_type_pkey';

export type Package_Type_Enum =
  | 'official'
  | 'user';

/** Boolean expression to compare columns of type "package_type_enum". All fields are combined with logical 'AND'. */
export type Package_Type_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Package_Type_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Package_Type_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Package_Type_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Package_Type_Enum>>;
};

/** input type for inserting data into table "package_type" */
export type Package_Type_Insert_Input = {
  readonly packages?: InputMaybe<Package_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Package_Type_Max_Fields = {
  readonly __typename?: 'package_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Package_Type_Min_Fields = {
  readonly __typename?: 'package_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "package_type" */
export type Package_Type_Mutation_Response = {
  readonly __typename?: 'package_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Package_Type>;
};

/** input type for inserting object relation for remote table "package_type" */
export type Package_Type_Obj_Rel_Insert_Input = {
  readonly data: Package_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Package_Type_On_Conflict>;
};

/** on_conflict condition type for table "package_type" */
export type Package_Type_On_Conflict = {
  readonly constraint: Package_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Package_Type_Update_Column>;
  readonly where?: InputMaybe<Package_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "package_type". */
export type Package_Type_Order_By = {
  readonly packages_aggregate?: InputMaybe<Package_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: package_type */
export type Package_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "package_type" */
export type Package_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "package_type" */
export type Package_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "package_type" */
export type Package_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Package_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Package_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "package_type" */
export type Package_Type_Update_Column =
  /** column name */
  | 'value';

export type Package_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Package_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Package_Type_Bool_Exp;
};

/** update columns of table "package" */
export type Package_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'dp'
  /** column name */
  | 'id'
  /** column name */
  | 'is_global'
  /** column name */
  | 'name'
  /** column name */
  | 'package_type'
  /** column name */
  | 'source';

export type Package_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Package_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Package_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Package_Var_Pop_Fields = {
  readonly __typename?: 'package_var_pop_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "package" */
export type Package_Var_Pop_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Package_Var_Samp_Fields = {
  readonly __typename?: 'package_var_samp_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "package" */
export type Package_Var_Samp_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Package_Variance_Fields = {
  readonly __typename?: 'package_variance_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly source?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "package" */
export type Package_Variance_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "page_main_column_type". All fields are combined with logical 'AND'. */
export type Page_Main_Column_Type_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly _gt?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly _gte?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['page_main_column_type']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly _lte?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly _neq?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['page_main_column_type']['input']>>;
};

/** columns and relationships of "page_member" */
export type Page_Member = {
  readonly __typename?: 'page_member';
  /** An object relationship */
  readonly Page: Pages;
  /** An object relationship */
  readonly User: Folio_User;
  readonly page_id: Scalars['String']['output'];
  readonly page_order: Scalars['String']['output'];
  readonly user_id: Scalars['String']['output'];
};

/** aggregated selection of "page_member" */
export type Page_Member_Aggregate = {
  readonly __typename?: 'page_member_aggregate';
  readonly aggregate?: Maybe<Page_Member_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Page_Member>;
};

export type Page_Member_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Page_Member_Aggregate_Bool_Exp_Count>;
};

export type Page_Member_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Page_Member_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "page_member" */
export type Page_Member_Aggregate_Fields = {
  readonly __typename?: 'page_member_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Page_Member_Max_Fields>;
  readonly min?: Maybe<Page_Member_Min_Fields>;
};


/** aggregate fields of "page_member" */
export type Page_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "page_member" */
export type Page_Member_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Page_Member_Max_Order_By>;
  readonly min?: InputMaybe<Page_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "page_member" */
export type Page_Member_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Page_Member_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Page_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "page_member". All fields are combined with a logical 'AND'. */
export type Page_Member_Bool_Exp = {
  readonly Page?: InputMaybe<Pages_Bool_Exp>;
  readonly User?: InputMaybe<Folio_User_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Page_Member_Bool_Exp>>;
  readonly _not?: InputMaybe<Page_Member_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Page_Member_Bool_Exp>>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly page_order?: InputMaybe<String_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "page_member" */
export type Page_Member_Constraint =
  /** unique or primary key constraint on columns "user_id", "page_id" */
  | 'page_member_pkey';

/** input type for inserting data into table "page_member" */
export type Page_Member_Insert_Input = {
  readonly Page?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly User?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly page_order?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Page_Member_Max_Fields = {
  readonly __typename?: 'page_member_max_fields';
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly page_order?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "page_member" */
export type Page_Member_Max_Order_By = {
  readonly page_id?: InputMaybe<Order_By>;
  readonly page_order?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Page_Member_Min_Fields = {
  readonly __typename?: 'page_member_min_fields';
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly page_order?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "page_member" */
export type Page_Member_Min_Order_By = {
  readonly page_id?: InputMaybe<Order_By>;
  readonly page_order?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "page_member" */
export type Page_Member_Mutation_Response = {
  readonly __typename?: 'page_member_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Page_Member>;
};

/** input type for inserting object relation for remote table "page_member" */
export type Page_Member_Obj_Rel_Insert_Input = {
  readonly data: Page_Member_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Page_Member_On_Conflict>;
};

/** on_conflict condition type for table "page_member" */
export type Page_Member_On_Conflict = {
  readonly constraint: Page_Member_Constraint;
  readonly update_columns?: ReadonlyArray<Page_Member_Update_Column>;
  readonly where?: InputMaybe<Page_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "page_member". */
export type Page_Member_Order_By = {
  readonly Page?: InputMaybe<Pages_Order_By>;
  readonly User?: InputMaybe<Folio_User_Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly page_order?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: page_member */
export type Page_Member_Pk_Columns_Input = {
  readonly page_id: Scalars['String']['input'];
  readonly user_id: Scalars['String']['input'];
};

/** select columns of table "page_member" */
export type Page_Member_Select_Column =
  /** column name */
  | 'page_id'
  /** column name */
  | 'page_order'
  /** column name */
  | 'user_id';

/** input type for updating data in table "page_member" */
export type Page_Member_Set_Input = {
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly page_order?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "page_member" */
export type Page_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Page_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Member_Stream_Cursor_Value_Input = {
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly page_order?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "page_member" */
export type Page_Member_Update_Column =
  /** column name */
  | 'page_id'
  /** column name */
  | 'page_order'
  /** column name */
  | 'user_id';

export type Page_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Page_Member_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Page_Member_Bool_Exp;
};

/** columns and relationships of "page_products" */
export type Page_Products = {
  readonly __typename?: 'page_products';
  /** An array relationship */
  readonly Members: ReadonlyArray<Page_Member>;
  /** An aggregate relationship */
  readonly Members_aggregate: Page_Member_Aggregate;
  /** An object relationship */
  readonly Page: Pages;
  readonly column_field_selector?: Maybe<Scalars['String']['output']>;
  readonly column_type: Scalars['String']['output'];
  readonly column_width: Scalars['Int']['output'];
  readonly decimal_places?: Maybe<Scalars['Int']['output']>;
  readonly deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly grid_id?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly idx: Scalars['String']['output'];
  readonly page_id: Scalars['String']['output'];
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly thousands_separator?: Maybe<Scalars['Boolean']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "page_products" */
export type Page_ProductsMembersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


/** columns and relationships of "page_products" */
export type Page_ProductsMembers_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};

/** aggregated selection of "page_products" */
export type Page_Products_Aggregate = {
  readonly __typename?: 'page_products_aggregate';
  readonly aggregate?: Maybe<Page_Products_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Page_Products>;
};

export type Page_Products_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Page_Products_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Page_Products_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Page_Products_Aggregate_Bool_Exp_Count>;
};

export type Page_Products_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Page_Products_Select_Column_Page_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Page_Products_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Page_Products_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Page_Products_Select_Column_Page_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Page_Products_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Page_Products_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Page_Products_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "page_products" */
export type Page_Products_Aggregate_Fields = {
  readonly __typename?: 'page_products_aggregate_fields';
  readonly avg?: Maybe<Page_Products_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Page_Products_Max_Fields>;
  readonly min?: Maybe<Page_Products_Min_Fields>;
  readonly stddev?: Maybe<Page_Products_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Page_Products_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Page_Products_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Page_Products_Sum_Fields>;
  readonly var_pop?: Maybe<Page_Products_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Page_Products_Var_Samp_Fields>;
  readonly variance?: Maybe<Page_Products_Variance_Fields>;
};


/** aggregate fields of "page_products" */
export type Page_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "page_products" */
export type Page_Products_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Page_Products_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Page_Products_Max_Order_By>;
  readonly min?: InputMaybe<Page_Products_Min_Order_By>;
  readonly stddev?: InputMaybe<Page_Products_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Page_Products_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Page_Products_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Page_Products_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Page_Products_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Page_Products_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Page_Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "page_products" */
export type Page_Products_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Page_Products_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Page_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Page_Products_Avg_Fields = {
  readonly __typename?: 'page_products_avg_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "page_products" */
export type Page_Products_Avg_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "page_products". All fields are combined with a logical 'AND'. */
export type Page_Products_Bool_Exp = {
  readonly Members?: InputMaybe<Page_Member_Bool_Exp>;
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Bool_Exp>;
  readonly Page?: InputMaybe<Pages_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Page_Products_Bool_Exp>>;
  readonly _not?: InputMaybe<Page_Products_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Page_Products_Bool_Exp>>;
  readonly column_field_selector?: InputMaybe<String_Comparison_Exp>;
  readonly column_type?: InputMaybe<String_Comparison_Exp>;
  readonly column_width?: InputMaybe<Int_Comparison_Exp>;
  readonly decimal_places?: InputMaybe<Int_Comparison_Exp>;
  readonly deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly grid_id?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly idx?: InputMaybe<String_Comparison_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly product_id?: InputMaybe<String_Comparison_Exp>;
  readonly thousands_separator?: InputMaybe<Boolean_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "page_products" */
export type Page_Products_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'page_products_pkey';

/** input type for incrementing numeric columns in table "page_products" */
export type Page_Products_Inc_Input = {
  readonly column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly decimal_places?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "page_products" */
export type Page_Products_Insert_Input = {
  readonly Members?: InputMaybe<Page_Member_Arr_Rel_Insert_Input>;
  readonly Page?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly column_field_selector?: InputMaybe<Scalars['String']['input']>;
  readonly column_type?: InputMaybe<Scalars['String']['input']>;
  readonly column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly decimal_places?: InputMaybe<Scalars['Int']['input']>;
  readonly deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly grid_id?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly thousands_separator?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Page_Products_Max_Fields = {
  readonly __typename?: 'page_products_max_fields';
  readonly column_field_selector?: Maybe<Scalars['String']['output']>;
  readonly column_type?: Maybe<Scalars['String']['output']>;
  readonly column_width?: Maybe<Scalars['Int']['output']>;
  readonly decimal_places?: Maybe<Scalars['Int']['output']>;
  readonly deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly grid_id?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "page_products" */
export type Page_Products_Max_Order_By = {
  readonly column_field_selector?: InputMaybe<Order_By>;
  readonly column_type?: InputMaybe<Order_By>;
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
  readonly deleted_at?: InputMaybe<Order_By>;
  readonly grid_id?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly idx?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Page_Products_Min_Fields = {
  readonly __typename?: 'page_products_min_fields';
  readonly column_field_selector?: Maybe<Scalars['String']['output']>;
  readonly column_type?: Maybe<Scalars['String']['output']>;
  readonly column_width?: Maybe<Scalars['Int']['output']>;
  readonly decimal_places?: Maybe<Scalars['Int']['output']>;
  readonly deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly grid_id?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "page_products" */
export type Page_Products_Min_Order_By = {
  readonly column_field_selector?: InputMaybe<Order_By>;
  readonly column_type?: InputMaybe<Order_By>;
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
  readonly deleted_at?: InputMaybe<Order_By>;
  readonly grid_id?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly idx?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "page_products" */
export type Page_Products_Mutation_Response = {
  readonly __typename?: 'page_products_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Page_Products>;
};

/** input type for inserting object relation for remote table "page_products" */
export type Page_Products_Obj_Rel_Insert_Input = {
  readonly data: Page_Products_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Page_Products_On_Conflict>;
};

/** on_conflict condition type for table "page_products" */
export type Page_Products_On_Conflict = {
  readonly constraint: Page_Products_Constraint;
  readonly update_columns?: ReadonlyArray<Page_Products_Update_Column>;
  readonly where?: InputMaybe<Page_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "page_products". */
export type Page_Products_Order_By = {
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Order_By>;
  readonly Page?: InputMaybe<Pages_Order_By>;
  readonly column_field_selector?: InputMaybe<Order_By>;
  readonly column_type?: InputMaybe<Order_By>;
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
  readonly deleted_at?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly grid_id?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly idx?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly thousands_separator?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: page_products */
export type Page_Products_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "page_products" */
export type Page_Products_Select_Column =
  /** column name */
  | 'column_field_selector'
  /** column name */
  | 'column_type'
  /** column name */
  | 'column_width'
  /** column name */
  | 'decimal_places'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'grid_id'
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'thousands_separator'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** select "page_products_aggregate_bool_exp_bool_and_arguments_columns" columns of table "page_products" */
export type Page_Products_Select_Column_Page_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'thousands_separator';

/** select "page_products_aggregate_bool_exp_bool_or_arguments_columns" columns of table "page_products" */
export type Page_Products_Select_Column_Page_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'thousands_separator';

/** input type for updating data in table "page_products" */
export type Page_Products_Set_Input = {
  readonly column_field_selector?: InputMaybe<Scalars['String']['input']>;
  readonly column_type?: InputMaybe<Scalars['String']['input']>;
  readonly column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly decimal_places?: InputMaybe<Scalars['Int']['input']>;
  readonly deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly grid_id?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly thousands_separator?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Page_Products_Stddev_Fields = {
  readonly __typename?: 'page_products_stddev_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "page_products" */
export type Page_Products_Stddev_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Page_Products_Stddev_Pop_Fields = {
  readonly __typename?: 'page_products_stddev_pop_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "page_products" */
export type Page_Products_Stddev_Pop_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Page_Products_Stddev_Samp_Fields = {
  readonly __typename?: 'page_products_stddev_samp_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "page_products" */
export type Page_Products_Stddev_Samp_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "page_products" */
export type Page_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Page_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Products_Stream_Cursor_Value_Input = {
  readonly column_field_selector?: InputMaybe<Scalars['String']['input']>;
  readonly column_type?: InputMaybe<Scalars['String']['input']>;
  readonly column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly decimal_places?: InputMaybe<Scalars['Int']['input']>;
  readonly deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly grid_id?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly thousands_separator?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Page_Products_Sum_Fields = {
  readonly __typename?: 'page_products_sum_fields';
  readonly column_width?: Maybe<Scalars['Int']['output']>;
  readonly decimal_places?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "page_products" */
export type Page_Products_Sum_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** update columns of table "page_products" */
export type Page_Products_Update_Column =
  /** column name */
  | 'column_field_selector'
  /** column name */
  | 'column_type'
  /** column name */
  | 'column_width'
  /** column name */
  | 'decimal_places'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'grid_id'
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'thousands_separator'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export type Page_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Page_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Page_Products_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Page_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Page_Products_Var_Pop_Fields = {
  readonly __typename?: 'page_products_var_pop_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "page_products" */
export type Page_Products_Var_Pop_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Page_Products_Var_Samp_Fields = {
  readonly __typename?: 'page_products_var_samp_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "page_products" */
export type Page_Products_Var_Samp_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Page_Products_Variance_Fields = {
  readonly __typename?: 'page_products_variance_fields';
  readonly column_width?: Maybe<Scalars['Float']['output']>;
  readonly decimal_places?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "page_products" */
export type Page_Products_Variance_Order_By = {
  readonly column_width?: InputMaybe<Order_By>;
  readonly decimal_places?: InputMaybe<Order_By>;
};

/** columns and relationships of "page_settings" */
export type Page_Settings = {
  readonly __typename?: 'page_settings';
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly folio_user: Scalars['String']['output'];
  readonly settings_blob: Scalars['String']['output'];
  readonly updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "page_settings" */
export type Page_Settings_Aggregate = {
  readonly __typename?: 'page_settings_aggregate';
  readonly aggregate?: Maybe<Page_Settings_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Page_Settings>;
};

export type Page_Settings_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Page_Settings_Aggregate_Bool_Exp_Count>;
};

export type Page_Settings_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Page_Settings_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "page_settings" */
export type Page_Settings_Aggregate_Fields = {
  readonly __typename?: 'page_settings_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Page_Settings_Max_Fields>;
  readonly min?: Maybe<Page_Settings_Min_Fields>;
};


/** aggregate fields of "page_settings" */
export type Page_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "page_settings" */
export type Page_Settings_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Page_Settings_Max_Order_By>;
  readonly min?: InputMaybe<Page_Settings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "page_settings" */
export type Page_Settings_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Page_Settings_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Page_Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "page_settings". All fields are combined with a logical 'AND'. */
export type Page_Settings_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Page_Settings_Bool_Exp>>;
  readonly _not?: InputMaybe<Page_Settings_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Page_Settings_Bool_Exp>>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly settings_blob?: InputMaybe<String_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "page_settings" */
export type Page_Settings_Constraint =
  /** unique or primary key constraint on columns "folio_user" */
  | 'page_settings_pkey';

/** input type for inserting data into table "page_settings" */
export type Page_Settings_Insert_Input = {
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Page_Settings_Max_Fields = {
  readonly __typename?: 'page_settings_max_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "page_settings" */
export type Page_Settings_Max_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly settings_blob?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Page_Settings_Min_Fields = {
  readonly __typename?: 'page_settings_min_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly settings_blob?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "page_settings" */
export type Page_Settings_Min_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly settings_blob?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "page_settings" */
export type Page_Settings_Mutation_Response = {
  readonly __typename?: 'page_settings_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Page_Settings>;
};

/** input type for inserting object relation for remote table "page_settings" */
export type Page_Settings_Obj_Rel_Insert_Input = {
  readonly data: Page_Settings_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Page_Settings_On_Conflict>;
};

/** on_conflict condition type for table "page_settings" */
export type Page_Settings_On_Conflict = {
  readonly constraint: Page_Settings_Constraint;
  readonly update_columns?: ReadonlyArray<Page_Settings_Update_Column>;
  readonly where?: InputMaybe<Page_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "page_settings". */
export type Page_Settings_Order_By = {
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly settings_blob?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: page_settings */
export type Page_Settings_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
};

/** select columns of table "page_settings" */
export type Page_Settings_Select_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'settings_blob'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "page_settings" */
export type Page_Settings_Set_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "page_settings" */
export type Page_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Page_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Settings_Stream_Cursor_Value_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly settings_blob?: InputMaybe<Scalars['String']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "page_settings" */
export type Page_Settings_Update_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'settings_blob'
  /** column name */
  | 'updated_at';

export type Page_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Page_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Page_Settings_Bool_Exp;
};

/** Boolean expression to compare columns of type "page_type". All fields are combined with logical 'AND'. */
export type Page_Type_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['page_type']['input']>;
  readonly _gt?: InputMaybe<Scalars['page_type']['input']>;
  readonly _gte?: InputMaybe<Scalars['page_type']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['page_type']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['page_type']['input']>;
  readonly _lte?: InputMaybe<Scalars['page_type']['input']>;
  readonly _neq?: InputMaybe<Scalars['page_type']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['page_type']['input']>>;
};

/** columns and relationships of "pages" */
export type Pages = {
  readonly __typename?: 'pages';
  /** An array relationship */
  readonly Members: ReadonlyArray<Page_Member>;
  /** An aggregate relationship */
  readonly Members_aggregate: Page_Member_Aggregate;
  readonly adhoc_spreads?: Maybe<Scalars['String']['output']>;
  readonly cell_highlights?: Maybe<Scalars['String']['output']>;
  readonly column_highlights?: Maybe<Scalars['String']['output']>;
  readonly commodity_group?: Maybe<Scalars['Boolean']['output']>;
  readonly commodity_parent_group?: Maybe<Scalars['Boolean']['output']>;
  readonly created_at: Scalars['timestamptz']['output'];
  readonly description?: Maybe<Scalars['Boolean']['output']>;
  readonly extra_header_height?: Maybe<Scalars['Boolean']['output']>;
  readonly field_name?: Maybe<Scalars['Boolean']['output']>;
  readonly geographical_region?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['String']['output'];
  readonly idx: Scalars['String']['output'];
  readonly main_column_type?: Maybe<Scalars['page_main_column_type']['output']>;
  readonly main_column_width?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly package?: Maybe<Scalars['Boolean']['output']>;
  readonly period_highlights?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['Boolean']['output']>;
  readonly type: Scalars['page_type']['output'];
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "pages" */
export type PagesMembersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


/** columns and relationships of "pages" */
export type PagesMembers_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};

/** aggregated selection of "pages" */
export type Pages_Aggregate = {
  readonly __typename?: 'pages_aggregate';
  readonly aggregate?: Maybe<Pages_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Pages>;
};

/** aggregate fields of "pages" */
export type Pages_Aggregate_Fields = {
  readonly __typename?: 'pages_aggregate_fields';
  readonly avg?: Maybe<Pages_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Pages_Max_Fields>;
  readonly min?: Maybe<Pages_Min_Fields>;
  readonly stddev?: Maybe<Pages_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Pages_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Pages_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Pages_Sum_Fields>;
  readonly var_pop?: Maybe<Pages_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Pages_Var_Samp_Fields>;
  readonly variance?: Maybe<Pages_Variance_Fields>;
};


/** aggregate fields of "pages" */
export type Pages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pages_Avg_Fields = {
  readonly __typename?: 'pages_avg_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "pages". All fields are combined with a logical 'AND'. */
export type Pages_Bool_Exp = {
  readonly Members?: InputMaybe<Page_Member_Bool_Exp>;
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Pages_Bool_Exp>>;
  readonly _not?: InputMaybe<Pages_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Pages_Bool_Exp>>;
  readonly adhoc_spreads?: InputMaybe<String_Comparison_Exp>;
  readonly cell_highlights?: InputMaybe<String_Comparison_Exp>;
  readonly column_highlights?: InputMaybe<String_Comparison_Exp>;
  readonly commodity_group?: InputMaybe<Boolean_Comparison_Exp>;
  readonly commodity_parent_group?: InputMaybe<Boolean_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly description?: InputMaybe<Boolean_Comparison_Exp>;
  readonly extra_header_height?: InputMaybe<Boolean_Comparison_Exp>;
  readonly field_name?: InputMaybe<Boolean_Comparison_Exp>;
  readonly geographical_region?: InputMaybe<Boolean_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly idx?: InputMaybe<String_Comparison_Exp>;
  readonly main_column_type?: InputMaybe<Page_Main_Column_Type_Comparison_Exp>;
  readonly main_column_width?: InputMaybe<Int_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly package?: InputMaybe<Boolean_Comparison_Exp>;
  readonly period_highlights?: InputMaybe<String_Comparison_Exp>;
  readonly source?: InputMaybe<Boolean_Comparison_Exp>;
  readonly type?: InputMaybe<Page_Type_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pages" */
export type Pages_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'pages_pkey';

/** input type for incrementing numeric columns in table "pages" */
export type Pages_Inc_Input = {
  readonly main_column_width?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "pages" */
export type Pages_Insert_Input = {
  readonly Members?: InputMaybe<Page_Member_Arr_Rel_Insert_Input>;
  readonly adhoc_spreads?: InputMaybe<Scalars['String']['input']>;
  readonly cell_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly column_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly commodity_parent_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly description?: InputMaybe<Scalars['Boolean']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Boolean']['input']>;
  readonly field_name?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly main_column_type?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly main_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package?: InputMaybe<Scalars['Boolean']['input']>;
  readonly period_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Boolean']['input']>;
  readonly type?: InputMaybe<Scalars['page_type']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pages_Max_Fields = {
  readonly __typename?: 'pages_max_fields';
  readonly adhoc_spreads?: Maybe<Scalars['String']['output']>;
  readonly cell_highlights?: Maybe<Scalars['String']['output']>;
  readonly column_highlights?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['String']['output']>;
  readonly main_column_type?: Maybe<Scalars['page_main_column_type']['output']>;
  readonly main_column_width?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly period_highlights?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['page_type']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pages_Min_Fields = {
  readonly __typename?: 'pages_min_fields';
  readonly adhoc_spreads?: Maybe<Scalars['String']['output']>;
  readonly cell_highlights?: Maybe<Scalars['String']['output']>;
  readonly column_highlights?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly idx?: Maybe<Scalars['String']['output']>;
  readonly main_column_type?: Maybe<Scalars['page_main_column_type']['output']>;
  readonly main_column_width?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly period_highlights?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['page_type']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pages" */
export type Pages_Mutation_Response = {
  readonly __typename?: 'pages_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Pages>;
};

/** input type for inserting object relation for remote table "pages" */
export type Pages_Obj_Rel_Insert_Input = {
  readonly data: Pages_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Pages_On_Conflict>;
};

/** on_conflict condition type for table "pages" */
export type Pages_On_Conflict = {
  readonly constraint: Pages_Constraint;
  readonly update_columns?: ReadonlyArray<Pages_Update_Column>;
  readonly where?: InputMaybe<Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "pages". */
export type Pages_Order_By = {
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Order_By>;
  readonly adhoc_spreads?: InputMaybe<Order_By>;
  readonly cell_highlights?: InputMaybe<Order_By>;
  readonly column_highlights?: InputMaybe<Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly commodity_parent_group?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly extra_header_height?: InputMaybe<Order_By>;
  readonly field_name?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly idx?: InputMaybe<Order_By>;
  readonly main_column_type?: InputMaybe<Order_By>;
  readonly main_column_width?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly period_highlights?: InputMaybe<Order_By>;
  readonly source?: InputMaybe<Order_By>;
  readonly type?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pages */
export type Pages_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "pages" */
export type Pages_Select_Column =
  /** column name */
  | 'adhoc_spreads'
  /** column name */
  | 'cell_highlights'
  /** column name */
  | 'column_highlights'
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'commodity_parent_group'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'extra_header_height'
  /** column name */
  | 'field_name'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'main_column_type'
  /** column name */
  | 'main_column_width'
  /** column name */
  | 'name'
  /** column name */
  | 'package'
  /** column name */
  | 'period_highlights'
  /** column name */
  | 'source'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** input type for updating data in table "pages" */
export type Pages_Set_Input = {
  readonly adhoc_spreads?: InputMaybe<Scalars['String']['input']>;
  readonly cell_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly column_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly commodity_parent_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly description?: InputMaybe<Scalars['Boolean']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Boolean']['input']>;
  readonly field_name?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly main_column_type?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly main_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package?: InputMaybe<Scalars['Boolean']['input']>;
  readonly period_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Boolean']['input']>;
  readonly type?: InputMaybe<Scalars['page_type']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Pages_Stddev_Fields = {
  readonly __typename?: 'pages_stddev_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pages_Stddev_Pop_Fields = {
  readonly __typename?: 'pages_stddev_pop_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pages_Stddev_Samp_Fields = {
  readonly __typename?: 'pages_stddev_samp_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "pages" */
export type Pages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Pages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pages_Stream_Cursor_Value_Input = {
  readonly adhoc_spreads?: InputMaybe<Scalars['String']['input']>;
  readonly cell_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly column_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly commodity_parent_group?: InputMaybe<Scalars['Boolean']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly description?: InputMaybe<Scalars['Boolean']['input']>;
  readonly extra_header_height?: InputMaybe<Scalars['Boolean']['input']>;
  readonly field_name?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly idx?: InputMaybe<Scalars['String']['input']>;
  readonly main_column_type?: InputMaybe<Scalars['page_main_column_type']['input']>;
  readonly main_column_width?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package?: InputMaybe<Scalars['Boolean']['input']>;
  readonly period_highlights?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<Scalars['Boolean']['input']>;
  readonly type?: InputMaybe<Scalars['page_type']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pages_Sum_Fields = {
  readonly __typename?: 'pages_sum_fields';
  readonly main_column_width?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "pages" */
export type Pages_Update_Column =
  /** column name */
  | 'adhoc_spreads'
  /** column name */
  | 'cell_highlights'
  /** column name */
  | 'column_highlights'
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'commodity_parent_group'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'extra_header_height'
  /** column name */
  | 'field_name'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'id'
  /** column name */
  | 'idx'
  /** column name */
  | 'main_column_type'
  /** column name */
  | 'main_column_width'
  /** column name */
  | 'name'
  /** column name */
  | 'package'
  /** column name */
  | 'period_highlights'
  /** column name */
  | 'source'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export type Pages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Pages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Pages_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Pages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pages_Var_Pop_Fields = {
  readonly __typename?: 'pages_var_pop_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pages_Var_Samp_Fields = {
  readonly __typename?: 'pages_var_samp_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pages_Variance_Fields = {
  readonly __typename?: 'pages_variance_fields';
  readonly main_column_width?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "permission" */
export type Permission = {
  readonly __typename?: 'permission';
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly folio_user: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly package: Scalars['Int']['output'];
  /** An object relationship */
  readonly packageByPackage: Package;
  readonly permission: User_Right_Enum;
  /** An object relationship */
  readonly user_right: User_Right;
};

/** aggregated selection of "permission" */
export type Permission_Aggregate = {
  readonly __typename?: 'permission_aggregate';
  readonly aggregate?: Maybe<Permission_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Permission>;
};

export type Permission_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Permission_Aggregate_Bool_Exp_Count>;
};

export type Permission_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Permission_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "permission" */
export type Permission_Aggregate_Fields = {
  readonly __typename?: 'permission_aggregate_fields';
  readonly avg?: Maybe<Permission_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Permission_Max_Fields>;
  readonly min?: Maybe<Permission_Min_Fields>;
  readonly stddev?: Maybe<Permission_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Permission_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Permission_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Permission_Sum_Fields>;
  readonly var_pop?: Maybe<Permission_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Permission_Var_Samp_Fields>;
  readonly variance?: Maybe<Permission_Variance_Fields>;
};


/** aggregate fields of "permission" */
export type Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "permission" */
export type Permission_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Permission_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Permission_Max_Order_By>;
  readonly min?: InputMaybe<Permission_Min_Order_By>;
  readonly stddev?: InputMaybe<Permission_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Permission_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Permission_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Permission_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Permission_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Permission_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Permission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "permission" */
export type Permission_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Permission_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Permission_On_Conflict>;
};

/** aggregate avg on columns */
export type Permission_Avg_Fields = {
  readonly __typename?: 'permission_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "permission" */
export type Permission_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "permission". All fields are combined with a logical 'AND'. */
export type Permission_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Permission_Bool_Exp>>;
  readonly _not?: InputMaybe<Permission_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Permission_Bool_Exp>>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly package?: InputMaybe<Int_Comparison_Exp>;
  readonly packageByPackage?: InputMaybe<Package_Bool_Exp>;
  readonly permission?: InputMaybe<User_Right_Enum_Comparison_Exp>;
  readonly user_right?: InputMaybe<User_Right_Bool_Exp>;
};

/** unique or primary key constraints on table "permission" */
export type Permission_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'permission_id_key'
  /** unique or primary key constraint on columns "folio_user", "package" */
  | 'permission_pkey';

/** input type for incrementing numeric columns in table "permission" */
export type Permission_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "permission" */
export type Permission_Insert_Input = {
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly packageByPackage?: InputMaybe<Package_Obj_Rel_Insert_Input>;
  readonly permission?: InputMaybe<User_Right_Enum>;
  readonly user_right?: InputMaybe<User_Right_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Permission_Max_Fields = {
  readonly __typename?: 'permission_max_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "permission" */
export type Permission_Max_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Permission_Min_Fields = {
  readonly __typename?: 'permission_min_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "permission" */
export type Permission_Min_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "permission" */
export type Permission_Mutation_Response = {
  readonly __typename?: 'permission_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Permission>;
};

/** on_conflict condition type for table "permission" */
export type Permission_On_Conflict = {
  readonly constraint: Permission_Constraint;
  readonly update_columns?: ReadonlyArray<Permission_Update_Column>;
  readonly where?: InputMaybe<Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "permission". */
export type Permission_Order_By = {
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly packageByPackage?: InputMaybe<Package_Order_By>;
  readonly permission?: InputMaybe<Order_By>;
  readonly user_right?: InputMaybe<User_Right_Order_By>;
};

/** primary key columns input for table: permission */
export type Permission_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
  readonly package: Scalars['Int']['input'];
};

/** select columns of table "permission" */
export type Permission_Select_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'package'
  /** column name */
  | 'permission';

/** input type for updating data in table "permission" */
export type Permission_Set_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly permission?: InputMaybe<User_Right_Enum>;
};

/** aggregate stddev on columns */
export type Permission_Stddev_Fields = {
  readonly __typename?: 'permission_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "permission" */
export type Permission_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Permission_Stddev_Pop_Fields = {
  readonly __typename?: 'permission_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "permission" */
export type Permission_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Permission_Stddev_Samp_Fields = {
  readonly __typename?: 'permission_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "permission" */
export type Permission_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "permission" */
export type Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permission_Stream_Cursor_Value_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly permission?: InputMaybe<User_Right_Enum>;
};

/** aggregate sum on columns */
export type Permission_Sum_Fields = {
  readonly __typename?: 'permission_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "permission" */
export type Permission_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** update columns of table "permission" */
export type Permission_Update_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'package'
  /** column name */
  | 'permission';

export type Permission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Permission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Permission_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Permission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permission_Var_Pop_Fields = {
  readonly __typename?: 'permission_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "permission" */
export type Permission_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Permission_Var_Samp_Fields = {
  readonly __typename?: 'permission_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "permission" */
export type Permission_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Permission_Variance_Fields = {
  readonly __typename?: 'permission_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "permission" */
export type Permission_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "persona_enum". All fields are combined with logical 'AND'. */
export type Persona_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly _gt?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly _gte?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['persona_enum']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly _lte?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly _neq?: InputMaybe<Scalars['persona_enum']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['persona_enum']['input']>>;
};

/** columns and relationships of "product" */
export type Product = {
  readonly __typename?: 'product';
  readonly artis_type: Product_Artis_Type_Enum;
  readonly code?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly commodityGroupByCommodityGroup?: Maybe<Commodity_Group>;
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly curve_type: Product_Curve_Type_Enum;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  readonly eod_entries: ReadonlyArray<Eod_Entry>;
  /** An aggregate relationship */
  readonly eod_entries_aggregate: Eod_Entry_Aggregate;
  readonly eod_product_dep?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  readonly geographicalRegionByGeographicalRegion?: Maybe<Geographical_Region>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly has_shared_cell?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['uuid']['output'];
  readonly is_chartable: Scalars['Boolean']['output'];
  readonly kt_kb_conversion_factor?: Maybe<Scalars['numeric']['output']>;
  readonly last_shared?: Maybe<ReadonlyArray<Shared_Instrument>>;
  /** An array relationship */
  readonly local_instruments: ReadonlyArray<Local_Instrument>;
  /** An aggregate relationship */
  readonly local_instruments_aggregate: Local_Instrument_Aggregate;
  readonly logical_code?: Maybe<Scalars['String']['output']>;
  readonly maturity: Product_Maturity_Enum;
  readonly name: Scalars['String']['output'];
  readonly package: Scalars['Int']['output'];
  /** An object relationship */
  readonly packageByPackage: Package;
  /** An array relationship */
  readonly permissions: ReadonlyArray<Permission>;
  /** An aggregate relationship */
  readonly permissions_aggregate: Permission_Aggregate;
  /** An array relationship */
  readonly productEodsByEodProduct: ReadonlyArray<Product_Eod>;
  /** An aggregate relationship */
  readonly productEodsByEodProduct_aggregate: Product_Eod_Aggregate;
  /** An object relationship */
  readonly productTypeByProductType?: Maybe<Product_Type>;
  /** An object relationship */
  readonly product_artis_type: Product_Artis_Type;
  /** An array relationship */
  readonly product_configs: ReadonlyArray<Product_Config>;
  /** An aggregate relationship */
  readonly product_configs_aggregate: Product_Config_Aggregate;
  /** An object relationship */
  readonly product_curve_type: Product_Curve_Type;
  /** An array relationship */
  readonly product_eods: ReadonlyArray<Product_Eod>;
  /** An aggregate relationship */
  readonly product_eods_aggregate: Product_Eod_Aggregate;
  /** An array relationship */
  readonly product_global_dependencies: ReadonlyArray<Product_Global_Dependencies>;
  /** An aggregate relationship */
  readonly product_global_dependencies_aggregate: Product_Global_Dependencies_Aggregate;
  /** An object relationship */
  readonly product_maturity: Product_Maturity;
  /** An array relationship */
  readonly product_overrides: ReadonlyArray<Product_Overrides>;
  /** An aggregate relationship */
  readonly product_overrides_aggregate: Product_Overrides_Aggregate;
  /** An object relationship */
  readonly product_summary_type: Product_Summary_Type;
  readonly product_type?: Maybe<Product_Type_Enum>;
  /** An object relationship */
  readonly product_uom: Product_Uom;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  readonly shared_instruments: ReadonlyArray<Shared_Instrument>;
  /** An aggregate relationship */
  readonly shared_instruments_aggregate: Shared_Instrument_Aggregate;
  readonly summary_type: Product_Summary_Type_Enum;
  readonly uom: Product_Uom_Enum;
};


/** columns and relationships of "product" */
export type ProductEod_EntriesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Entry_Order_By>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEod_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Entry_Order_By>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductLast_SharedArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductLocal_InstrumentsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductLocal_Instruments_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductEodsByEodProductArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductEodsByEodProduct_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_ConfigsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Config_Order_By>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Config_Order_By>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_EodsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Eods_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Global_DependenciesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Order_By>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Global_Dependencies_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Order_By>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_OverridesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductShared_InstrumentsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductShared_Instruments_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  readonly __typename?: 'product_aggregate';
  readonly aggregate?: Maybe<Product_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product>;
};

export type Product_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Product_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Product_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Product_Aggregate_Bool_Exp_Count>;
};

export type Product_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  readonly __typename?: 'product_aggregate_fields';
  readonly avg?: Maybe<Product_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Max_Fields>;
  readonly min?: Maybe<Product_Min_Fields>;
  readonly stddev?: Maybe<Product_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Product_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Product_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Product_Sum_Fields>;
  readonly var_pop?: Maybe<Product_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Product_Var_Samp_Fields>;
  readonly variance?: Maybe<Product_Variance_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product" */
export type Product_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Product_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Product_Max_Order_By>;
  readonly min?: InputMaybe<Product_Min_Order_By>;
  readonly stddev?: InputMaybe<Product_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Product_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Product_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Product_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Product_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Product_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Product_Variance_Order_By>;
};

/** columns and relationships of "product_alerts" */
export type Product_Alerts = {
  readonly __typename?: 'product_alerts';
  /** An array relationship */
  readonly Members: ReadonlyArray<Page_Member>;
  /** An aggregate relationship */
  readonly Members_aggregate: Page_Member_Aggregate;
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly id: Scalars['String']['output'];
  /** An object relationship */
  readonly pageByPageId: Pages;
  readonly page_id: Scalars['String']['output'];
  readonly product_id: Scalars['String']['output'];
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "product_alerts" */
export type Product_AlertsMembersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


/** columns and relationships of "product_alerts" */
export type Product_AlertsMembers_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};

/** aggregated selection of "product_alerts" */
export type Product_Alerts_Aggregate = {
  readonly __typename?: 'product_alerts_aggregate';
  readonly aggregate?: Maybe<Product_Alerts_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Alerts>;
};

/** aggregate fields of "product_alerts" */
export type Product_Alerts_Aggregate_Fields = {
  readonly __typename?: 'product_alerts_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Alerts_Max_Fields>;
  readonly min?: Maybe<Product_Alerts_Min_Fields>;
};


/** aggregate fields of "product_alerts" */
export type Product_Alerts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Alerts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_alerts". All fields are combined with a logical 'AND'. */
export type Product_Alerts_Bool_Exp = {
  readonly Members?: InputMaybe<Page_Member_Bool_Exp>;
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Product_Alerts_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Alerts_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Alerts_Bool_Exp>>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly pageByPageId?: InputMaybe<Pages_Bool_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly product_id?: InputMaybe<String_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_alerts" */
export type Product_Alerts_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_alerts_pkey';

/** input type for inserting data into table "product_alerts" */
export type Product_Alerts_Insert_Input = {
  readonly Members?: InputMaybe<Page_Member_Arr_Rel_Insert_Input>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly pageByPageId?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Alerts_Max_Fields = {
  readonly __typename?: 'product_alerts_max_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Alerts_Min_Fields = {
  readonly __typename?: 'product_alerts_min_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_alerts" */
export type Product_Alerts_Mutation_Response = {
  readonly __typename?: 'product_alerts_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Alerts>;
};

/** on_conflict condition type for table "product_alerts" */
export type Product_Alerts_On_Conflict = {
  readonly constraint: Product_Alerts_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Alerts_Update_Column>;
  readonly where?: InputMaybe<Product_Alerts_Bool_Exp>;
};

/** Ordering options when selecting data from "product_alerts". */
export type Product_Alerts_Order_By = {
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly pageByPageId?: InputMaybe<Pages_Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_alerts */
export type Product_Alerts_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "product_alerts" */
export type Product_Alerts_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'user_id';

/** input type for updating data in table "product_alerts" */
export type Product_Alerts_Set_Input = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_alerts" */
export type Product_Alerts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Alerts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Alerts_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_alerts" */
export type Product_Alerts_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'user_id';

export type Product_Alerts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Alerts_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Alerts_Bool_Exp;
};

/** input type for inserting array relation for remote table "product" */
export type Product_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Product_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** columns and relationships of "product_artis_type" */
export type Product_Artis_Type = {
  readonly __typename?: 'product_artis_type';
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "product_artis_type" */
export type Product_Artis_TypeProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "product_artis_type" */
export type Product_Artis_TypeProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "product_artis_type" */
export type Product_Artis_Type_Aggregate = {
  readonly __typename?: 'product_artis_type_aggregate';
  readonly aggregate?: Maybe<Product_Artis_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Artis_Type>;
};

/** aggregate fields of "product_artis_type" */
export type Product_Artis_Type_Aggregate_Fields = {
  readonly __typename?: 'product_artis_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Artis_Type_Max_Fields>;
  readonly min?: Maybe<Product_Artis_Type_Min_Fields>;
};


/** aggregate fields of "product_artis_type" */
export type Product_Artis_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Artis_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_artis_type". All fields are combined with a logical 'AND'. */
export type Product_Artis_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Artis_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Artis_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Artis_Type_Bool_Exp>>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_artis_type" */
export type Product_Artis_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_artis_type_pkey';

export type Product_Artis_Type_Enum =
  | 'canned'
  | 'customer_curve'
  | 'eod'
  | 'sourced';

/** Boolean expression to compare columns of type "product_artis_type_enum". All fields are combined with logical 'AND'. */
export type Product_Artis_Type_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Artis_Type_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Artis_Type_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Artis_Type_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Artis_Type_Enum>>;
};

/** input type for inserting data into table "product_artis_type" */
export type Product_Artis_Type_Insert_Input = {
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Artis_Type_Max_Fields = {
  readonly __typename?: 'product_artis_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Artis_Type_Min_Fields = {
  readonly __typename?: 'product_artis_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_artis_type" */
export type Product_Artis_Type_Mutation_Response = {
  readonly __typename?: 'product_artis_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Artis_Type>;
};

/** input type for inserting object relation for remote table "product_artis_type" */
export type Product_Artis_Type_Obj_Rel_Insert_Input = {
  readonly data: Product_Artis_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Artis_Type_On_Conflict>;
};

/** on_conflict condition type for table "product_artis_type" */
export type Product_Artis_Type_On_Conflict = {
  readonly constraint: Product_Artis_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Artis_Type_Update_Column>;
  readonly where?: InputMaybe<Product_Artis_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_artis_type". */
export type Product_Artis_Type_Order_By = {
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_artis_type */
export type Product_Artis_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_artis_type" */
export type Product_Artis_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "product_artis_type" */
export type Product_Artis_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_artis_type" */
export type Product_Artis_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Artis_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Artis_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_artis_type" */
export type Product_Artis_Type_Update_Column =
  /** column name */
  | 'value';

export type Product_Artis_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Artis_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Artis_Type_Bool_Exp;
};

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  readonly __typename?: 'product_avg_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by avg() on columns of table "product" */
export type Product_Avg_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Bool_Exp>>;
  readonly artis_type?: InputMaybe<Product_Artis_Type_Enum_Comparison_Exp>;
  readonly code?: InputMaybe<String_Comparison_Exp>;
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Bool_Exp>;
  readonly commodity_group?: InputMaybe<Int_Comparison_Exp>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum_Comparison_Exp>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly dp?: InputMaybe<Int_Comparison_Exp>;
  readonly eod_entries?: InputMaybe<Eod_Entry_Bool_Exp>;
  readonly eod_entries_aggregate?: InputMaybe<Eod_Entry_Aggregate_Bool_Exp>;
  readonly eod_product_dep?: InputMaybe<Uuid_Comparison_Exp>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Bool_Exp>;
  readonly geographical_region?: InputMaybe<Int_Comparison_Exp>;
  readonly has_shared_cell?: InputMaybe<Boolean_Comparison_Exp>;
  readonly id?: InputMaybe<Uuid_Comparison_Exp>;
  readonly is_chartable?: InputMaybe<Boolean_Comparison_Exp>;
  readonly kt_kb_conversion_factor?: InputMaybe<Numeric_Comparison_Exp>;
  readonly last_shared?: InputMaybe<Shared_Instrument_Bool_Exp>;
  readonly local_instruments?: InputMaybe<Local_Instrument_Bool_Exp>;
  readonly local_instruments_aggregate?: InputMaybe<Local_Instrument_Aggregate_Bool_Exp>;
  readonly logical_code?: InputMaybe<String_Comparison_Exp>;
  readonly maturity?: InputMaybe<Product_Maturity_Enum_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly package?: InputMaybe<Int_Comparison_Exp>;
  readonly packageByPackage?: InputMaybe<Package_Bool_Exp>;
  readonly permissions?: InputMaybe<Permission_Bool_Exp>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Bool_Exp>;
  readonly productEodsByEodProduct?: InputMaybe<Product_Eod_Bool_Exp>;
  readonly productEodsByEodProduct_aggregate?: InputMaybe<Product_Eod_Aggregate_Bool_Exp>;
  readonly productTypeByProductType?: InputMaybe<Product_Type_Bool_Exp>;
  readonly product_artis_type?: InputMaybe<Product_Artis_Type_Bool_Exp>;
  readonly product_configs?: InputMaybe<Product_Config_Bool_Exp>;
  readonly product_configs_aggregate?: InputMaybe<Product_Config_Aggregate_Bool_Exp>;
  readonly product_curve_type?: InputMaybe<Product_Curve_Type_Bool_Exp>;
  readonly product_eods?: InputMaybe<Product_Eod_Bool_Exp>;
  readonly product_eods_aggregate?: InputMaybe<Product_Eod_Aggregate_Bool_Exp>;
  readonly product_global_dependencies?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
  readonly product_global_dependencies_aggregate?: InputMaybe<Product_Global_Dependencies_Aggregate_Bool_Exp>;
  readonly product_maturity?: InputMaybe<Product_Maturity_Bool_Exp>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Bool_Exp>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Bool_Exp>;
  readonly product_summary_type?: InputMaybe<Product_Summary_Type_Bool_Exp>;
  readonly product_type?: InputMaybe<Product_Type_Enum_Comparison_Exp>;
  readonly product_uom?: InputMaybe<Product_Uom_Bool_Exp>;
  readonly shared_instrument_count?: InputMaybe<Bigint_Comparison_Exp>;
  readonly shared_instruments?: InputMaybe<Shared_Instrument_Bool_Exp>;
  readonly shared_instruments_aggregate?: InputMaybe<Shared_Instrument_Aggregate_Bool_Exp>;
  readonly summary_type?: InputMaybe<Product_Summary_Type_Enum_Comparison_Exp>;
  readonly uom?: InputMaybe<Product_Uom_Enum_Comparison_Exp>;
};

/** columns and relationships of "product_config" */
export type Product_Config = {
  readonly __typename?: 'product_config';
  readonly formula?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly package_deps?: Maybe<Scalars['jsonb']['output']>;
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByProduct: Product;
  readonly relative_month: Scalars['Int']['output'];
};


/** columns and relationships of "product_config" */
export type Product_ConfigPackage_DepsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "product_config" */
export type Product_Config_Aggregate = {
  readonly __typename?: 'product_config_aggregate';
  readonly aggregate?: Maybe<Product_Config_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Config>;
};

export type Product_Config_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Product_Config_Aggregate_Bool_Exp_Count>;
};

export type Product_Config_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Config_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_config" */
export type Product_Config_Aggregate_Fields = {
  readonly __typename?: 'product_config_aggregate_fields';
  readonly avg?: Maybe<Product_Config_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Config_Max_Fields>;
  readonly min?: Maybe<Product_Config_Min_Fields>;
  readonly stddev?: Maybe<Product_Config_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Product_Config_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Product_Config_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Product_Config_Sum_Fields>;
  readonly var_pop?: Maybe<Product_Config_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Product_Config_Var_Samp_Fields>;
  readonly variance?: Maybe<Product_Config_Variance_Fields>;
};


/** aggregate fields of "product_config" */
export type Product_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_config" */
export type Product_Config_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Product_Config_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Product_Config_Max_Order_By>;
  readonly min?: InputMaybe<Product_Config_Min_Order_By>;
  readonly stddev?: InputMaybe<Product_Config_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Product_Config_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Product_Config_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Product_Config_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Product_Config_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Product_Config_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Product_Config_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Product_Config_Append_Input = {
  readonly package_deps?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "product_config" */
export type Product_Config_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Product_Config_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Config_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Config_Avg_Fields = {
  readonly __typename?: 'product_config_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_config" */
export type Product_Config_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_config". All fields are combined with a logical 'AND'. */
export type Product_Config_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Config_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Config_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Config_Bool_Exp>>;
  readonly formula?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly package_deps?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
  readonly relative_month?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_config" */
export type Product_Config_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_config_id_key'
  /** unique or primary key constraint on columns "product", "relative_month" */
  | 'product_config_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Product_Config_Delete_At_Path_Input = {
  readonly package_deps?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Product_Config_Delete_Elem_Input = {
  readonly package_deps?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Product_Config_Delete_Key_Input = {
  readonly package_deps?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "product_config" */
export type Product_Config_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_config" */
export type Product_Config_Insert_Input = {
  readonly formula?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package_deps?: InputMaybe<Scalars['jsonb']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Product_Config_Max_Fields = {
  readonly __typename?: 'product_config_max_fields';
  readonly formula?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly relative_month?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "product_config" */
export type Product_Config_Max_Order_By = {
  readonly formula?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Config_Min_Fields = {
  readonly __typename?: 'product_config_min_fields';
  readonly formula?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly relative_month?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "product_config" */
export type Product_Config_Min_Order_By = {
  readonly formula?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_config" */
export type Product_Config_Mutation_Response = {
  readonly __typename?: 'product_config_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Config>;
};

/** on_conflict condition type for table "product_config" */
export type Product_Config_On_Conflict = {
  readonly constraint: Product_Config_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Config_Update_Column>;
  readonly where?: InputMaybe<Product_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "product_config". */
export type Product_Config_Order_By = {
  readonly formula?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly package_deps?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_config */
export type Product_Config_Pk_Columns_Input = {
  readonly product: Scalars['uuid']['input'];
  readonly relative_month: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Product_Config_Prepend_Input = {
  readonly package_deps?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "product_config" */
export type Product_Config_Select_Column =
  /** column name */
  | 'formula'
  /** column name */
  | 'id'
  /** column name */
  | 'package_deps'
  /** column name */
  | 'product'
  /** column name */
  | 'relative_month';

/** input type for updating data in table "product_config" */
export type Product_Config_Set_Input = {
  readonly formula?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package_deps?: InputMaybe<Scalars['jsonb']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Product_Config_Stddev_Fields = {
  readonly __typename?: 'product_config_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_config" */
export type Product_Config_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Config_Stddev_Pop_Fields = {
  readonly __typename?: 'product_config_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_config" */
export type Product_Config_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Config_Stddev_Samp_Fields = {
  readonly __typename?: 'product_config_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_config" */
export type Product_Config_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_config" */
export type Product_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Config_Stream_Cursor_Value_Input = {
  readonly formula?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly package_deps?: InputMaybe<Scalars['jsonb']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly relative_month?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Product_Config_Sum_Fields = {
  readonly __typename?: 'product_config_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly relative_month?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "product_config" */
export type Product_Config_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** update columns of table "product_config" */
export type Product_Config_Update_Column =
  /** column name */
  | 'formula'
  /** column name */
  | 'id'
  /** column name */
  | 'package_deps'
  /** column name */
  | 'product'
  /** column name */
  | 'relative_month';

export type Product_Config_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Product_Config_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Product_Config_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Product_Config_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Product_Config_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Product_Config_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Product_Config_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Config_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Config_Var_Pop_Fields = {
  readonly __typename?: 'product_config_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_config" */
export type Product_Config_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Config_Var_Samp_Fields = {
  readonly __typename?: 'product_config_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_config" */
export type Product_Config_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Config_Variance_Fields = {
  readonly __typename?: 'product_config_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly relative_month?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_config" */
export type Product_Config_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly relative_month?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "product" */
export type Product_Constraint =
  /** unique or primary key constraint on columns "package", "description" */
  | 'product_description_package_key'
  /** unique or primary key constraint on columns "id" */
  | 'product_pkey';

/** columns and relationships of "product_curve_type" */
export type Product_Curve_Type = {
  readonly __typename?: 'product_curve_type';
  readonly value: Scalars['String']['output'];
};

/** aggregated selection of "product_curve_type" */
export type Product_Curve_Type_Aggregate = {
  readonly __typename?: 'product_curve_type_aggregate';
  readonly aggregate?: Maybe<Product_Curve_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Curve_Type>;
};

/** aggregate fields of "product_curve_type" */
export type Product_Curve_Type_Aggregate_Fields = {
  readonly __typename?: 'product_curve_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Curve_Type_Max_Fields>;
  readonly min?: Maybe<Product_Curve_Type_Min_Fields>;
};


/** aggregate fields of "product_curve_type" */
export type Product_Curve_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Curve_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_curve_type". All fields are combined with a logical 'AND'. */
export type Product_Curve_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Curve_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Curve_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Curve_Type_Bool_Exp>>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_curve_type" */
export type Product_Curve_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_curve_type_pkey';

export type Product_Curve_Type_Enum =
  | 'delta'
  | 'live'
  | 'snapshot';

/** Boolean expression to compare columns of type "product_curve_type_enum". All fields are combined with logical 'AND'. */
export type Product_Curve_Type_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Curve_Type_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Curve_Type_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Curve_Type_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Curve_Type_Enum>>;
};

/** input type for inserting data into table "product_curve_type" */
export type Product_Curve_Type_Insert_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Curve_Type_Max_Fields = {
  readonly __typename?: 'product_curve_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Curve_Type_Min_Fields = {
  readonly __typename?: 'product_curve_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_curve_type" */
export type Product_Curve_Type_Mutation_Response = {
  readonly __typename?: 'product_curve_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Curve_Type>;
};

/** input type for inserting object relation for remote table "product_curve_type" */
export type Product_Curve_Type_Obj_Rel_Insert_Input = {
  readonly data: Product_Curve_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Curve_Type_On_Conflict>;
};

/** on_conflict condition type for table "product_curve_type" */
export type Product_Curve_Type_On_Conflict = {
  readonly constraint: Product_Curve_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Curve_Type_Update_Column>;
  readonly where?: InputMaybe<Product_Curve_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_curve_type". */
export type Product_Curve_Type_Order_By = {
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_curve_type */
export type Product_Curve_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_curve_type" */
export type Product_Curve_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "product_curve_type" */
export type Product_Curve_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_curve_type" */
export type Product_Curve_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Curve_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Curve_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_curve_type" */
export type Product_Curve_Type_Update_Column =
  /** column name */
  | 'value';

export type Product_Curve_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Curve_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Curve_Type_Bool_Exp;
};

/** columns and relationships of "product_eod" */
export type Product_Eod = {
  readonly __typename?: 'product_eod';
  readonly eod_product: Scalars['uuid']['output'];
  readonly id: Scalars['Int']['output'];
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByEodProduct: Product;
  /** An object relationship */
  readonly productByProduct: Product;
};

/** aggregated selection of "product_eod" */
export type Product_Eod_Aggregate = {
  readonly __typename?: 'product_eod_aggregate';
  readonly aggregate?: Maybe<Product_Eod_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Eod>;
};

export type Product_Eod_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Product_Eod_Aggregate_Bool_Exp_Count>;
};

export type Product_Eod_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Eod_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_eod" */
export type Product_Eod_Aggregate_Fields = {
  readonly __typename?: 'product_eod_aggregate_fields';
  readonly avg?: Maybe<Product_Eod_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Eod_Max_Fields>;
  readonly min?: Maybe<Product_Eod_Min_Fields>;
  readonly stddev?: Maybe<Product_Eod_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Product_Eod_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Product_Eod_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Product_Eod_Sum_Fields>;
  readonly var_pop?: Maybe<Product_Eod_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Product_Eod_Var_Samp_Fields>;
  readonly variance?: Maybe<Product_Eod_Variance_Fields>;
};


/** aggregate fields of "product_eod" */
export type Product_Eod_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_eod" */
export type Product_Eod_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Product_Eod_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Product_Eod_Max_Order_By>;
  readonly min?: InputMaybe<Product_Eod_Min_Order_By>;
  readonly stddev?: InputMaybe<Product_Eod_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Product_Eod_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Product_Eod_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Product_Eod_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Product_Eod_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Product_Eod_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Product_Eod_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_eod" */
export type Product_Eod_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Product_Eod_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Eod_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Eod_Avg_Fields = {
  readonly __typename?: 'product_eod_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_eod" */
export type Product_Eod_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_eod". All fields are combined with a logical 'AND'. */
export type Product_Eod_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Eod_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Eod_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Eod_Bool_Exp>>;
  readonly eod_product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByEodProduct?: InputMaybe<Product_Bool_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
};

/** unique or primary key constraints on table "product_eod" */
export type Product_Eod_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_eod_id_key'
  /** unique or primary key constraint on columns "eod_product", "product" */
  | 'product_eod_pkey';

/** input type for incrementing numeric columns in table "product_eod" */
export type Product_Eod_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_eod" */
export type Product_Eod_Insert_Input = {
  readonly eod_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByEodProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Eod_Max_Fields = {
  readonly __typename?: 'product_eod_max_fields';
  readonly eod_product?: Maybe<Scalars['uuid']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_eod" */
export type Product_Eod_Max_Order_By = {
  readonly eod_product?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Eod_Min_Fields = {
  readonly __typename?: 'product_eod_min_fields';
  readonly eod_product?: Maybe<Scalars['uuid']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_eod" */
export type Product_Eod_Min_Order_By = {
  readonly eod_product?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_eod" */
export type Product_Eod_Mutation_Response = {
  readonly __typename?: 'product_eod_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Eod>;
};

/** on_conflict condition type for table "product_eod" */
export type Product_Eod_On_Conflict = {
  readonly constraint: Product_Eod_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Eod_Update_Column>;
  readonly where?: InputMaybe<Product_Eod_Bool_Exp>;
};

/** Ordering options when selecting data from "product_eod". */
export type Product_Eod_Order_By = {
  readonly eod_product?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByEodProduct?: InputMaybe<Product_Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
};

/** primary key columns input for table: product_eod */
export type Product_Eod_Pk_Columns_Input = {
  readonly eod_product: Scalars['uuid']['input'];
  readonly product: Scalars['uuid']['input'];
};

/** select columns of table "product_eod" */
export type Product_Eod_Select_Column =
  /** column name */
  | 'eod_product'
  /** column name */
  | 'id'
  /** column name */
  | 'product';

/** input type for updating data in table "product_eod" */
export type Product_Eod_Set_Input = {
  readonly eod_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Product_Eod_Stddev_Fields = {
  readonly __typename?: 'product_eod_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_eod" */
export type Product_Eod_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Eod_Stddev_Pop_Fields = {
  readonly __typename?: 'product_eod_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_eod" */
export type Product_Eod_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Eod_Stddev_Samp_Fields = {
  readonly __typename?: 'product_eod_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_eod" */
export type Product_Eod_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_eod" */
export type Product_Eod_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Eod_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Eod_Stream_Cursor_Value_Input = {
  readonly eod_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Product_Eod_Sum_Fields = {
  readonly __typename?: 'product_eod_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "product_eod" */
export type Product_Eod_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** update columns of table "product_eod" */
export type Product_Eod_Update_Column =
  /** column name */
  | 'eod_product'
  /** column name */
  | 'id'
  /** column name */
  | 'product';

export type Product_Eod_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Product_Eod_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Eod_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Eod_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Eod_Var_Pop_Fields = {
  readonly __typename?: 'product_eod_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_eod" */
export type Product_Eod_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Eod_Var_Samp_Fields = {
  readonly __typename?: 'product_eod_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_eod" */
export type Product_Eod_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Eod_Variance_Fields = {
  readonly __typename?: 'product_eod_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_eod" */
export type Product_Eod_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Maps dependency between products and the global dependencies selected. */
export type Product_Global_Dependencies = {
  readonly __typename?: 'product_global_dependencies';
  readonly created_at: Scalars['timestamptz']['output'];
  readonly global_product: Scalars['uuid']['output'];
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByProduct: Product;
  readonly updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "product_global_dependencies" */
export type Product_Global_Dependencies_Aggregate = {
  readonly __typename?: 'product_global_dependencies_aggregate';
  readonly aggregate?: Maybe<Product_Global_Dependencies_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Global_Dependencies>;
};

export type Product_Global_Dependencies_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Product_Global_Dependencies_Aggregate_Bool_Exp_Count>;
};

export type Product_Global_Dependencies_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_global_dependencies" */
export type Product_Global_Dependencies_Aggregate_Fields = {
  readonly __typename?: 'product_global_dependencies_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Global_Dependencies_Max_Fields>;
  readonly min?: Maybe<Product_Global_Dependencies_Min_Fields>;
};


/** aggregate fields of "product_global_dependencies" */
export type Product_Global_Dependencies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_global_dependencies" */
export type Product_Global_Dependencies_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Product_Global_Dependencies_Max_Order_By>;
  readonly min?: InputMaybe<Product_Global_Dependencies_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_global_dependencies" */
export type Product_Global_Dependencies_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Product_Global_Dependencies_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Global_Dependencies_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_global_dependencies". All fields are combined with a logical 'AND'. */
export type Product_Global_Dependencies_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Bool_Exp>>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly global_product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_global_dependencies" */
export type Product_Global_Dependencies_Constraint =
  /** unique or primary key constraint on columns "product", "global_product" */
  | 'product_global_dependencies_pkey';

/** input type for inserting data into table "product_global_dependencies" */
export type Product_Global_Dependencies_Insert_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly global_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Product_Global_Dependencies_Max_Fields = {
  readonly __typename?: 'product_global_dependencies_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly global_product?: Maybe<Scalars['uuid']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "product_global_dependencies" */
export type Product_Global_Dependencies_Max_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly global_product?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Global_Dependencies_Min_Fields = {
  readonly __typename?: 'product_global_dependencies_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly global_product?: Maybe<Scalars['uuid']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "product_global_dependencies" */
export type Product_Global_Dependencies_Min_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly global_product?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_global_dependencies" */
export type Product_Global_Dependencies_Mutation_Response = {
  readonly __typename?: 'product_global_dependencies_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Global_Dependencies>;
};

/** on_conflict condition type for table "product_global_dependencies" */
export type Product_Global_Dependencies_On_Conflict = {
  readonly constraint: Product_Global_Dependencies_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Global_Dependencies_Update_Column>;
  readonly where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};

/** Ordering options when selecting data from "product_global_dependencies". */
export type Product_Global_Dependencies_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly global_product?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_global_dependencies */
export type Product_Global_Dependencies_Pk_Columns_Input = {
  readonly global_product: Scalars['uuid']['input'];
  readonly product: Scalars['uuid']['input'];
};

/** select columns of table "product_global_dependencies" */
export type Product_Global_Dependencies_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'global_product'
  /** column name */
  | 'product'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "product_global_dependencies" */
export type Product_Global_Dependencies_Set_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly global_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "product_global_dependencies" */
export type Product_Global_Dependencies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Global_Dependencies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Global_Dependencies_Stream_Cursor_Value_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly global_product?: InputMaybe<Scalars['uuid']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "product_global_dependencies" */
export type Product_Global_Dependencies_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'global_product'
  /** column name */
  | 'product'
  /** column name */
  | 'updated_at';

export type Product_Global_Dependencies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Global_Dependencies_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Global_Dependencies_Bool_Exp;
};

/** input type for incrementing numeric columns in table "product" */
export type Product_Inc_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly kt_kb_conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  readonly artis_type?: InputMaybe<Product_Artis_Type_Enum>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Obj_Rel_Insert_Input>;
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly eod_entries?: InputMaybe<Eod_Entry_Arr_Rel_Insert_Input>;
  readonly eod_product_dep?: InputMaybe<Scalars['uuid']['input']>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Obj_Rel_Insert_Input>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly is_chartable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly kt_kb_conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  readonly local_instruments?: InputMaybe<Local_Instrument_Arr_Rel_Insert_Input>;
  readonly logical_code?: InputMaybe<Scalars['String']['input']>;
  readonly maturity?: InputMaybe<Product_Maturity_Enum>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly packageByPackage?: InputMaybe<Package_Obj_Rel_Insert_Input>;
  readonly permissions?: InputMaybe<Permission_Arr_Rel_Insert_Input>;
  readonly productEodsByEodProduct?: InputMaybe<Product_Eod_Arr_Rel_Insert_Input>;
  readonly productTypeByProductType?: InputMaybe<Product_Type_Obj_Rel_Insert_Input>;
  readonly product_artis_type?: InputMaybe<Product_Artis_Type_Obj_Rel_Insert_Input>;
  readonly product_configs?: InputMaybe<Product_Config_Arr_Rel_Insert_Input>;
  readonly product_curve_type?: InputMaybe<Product_Curve_Type_Obj_Rel_Insert_Input>;
  readonly product_eods?: InputMaybe<Product_Eod_Arr_Rel_Insert_Input>;
  readonly product_global_dependencies?: InputMaybe<Product_Global_Dependencies_Arr_Rel_Insert_Input>;
  readonly product_maturity?: InputMaybe<Product_Maturity_Obj_Rel_Insert_Input>;
  readonly product_overrides?: InputMaybe<Product_Overrides_Arr_Rel_Insert_Input>;
  readonly product_summary_type?: InputMaybe<Product_Summary_Type_Obj_Rel_Insert_Input>;
  readonly product_type?: InputMaybe<Product_Type_Enum>;
  readonly product_uom?: InputMaybe<Product_Uom_Obj_Rel_Insert_Input>;
  readonly shared_instruments?: InputMaybe<Shared_Instrument_Arr_Rel_Insert_Input>;
  readonly summary_type?: InputMaybe<Product_Summary_Type_Enum>;
  readonly uom?: InputMaybe<Product_Uom_Enum>;
};

/** columns and relationships of "product_maturity" */
export type Product_Maturity = {
  readonly __typename?: 'product_maturity';
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "product_maturity" */
export type Product_MaturityProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "product_maturity" */
export type Product_MaturityProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "product_maturity" */
export type Product_Maturity_Aggregate = {
  readonly __typename?: 'product_maturity_aggregate';
  readonly aggregate?: Maybe<Product_Maturity_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Maturity>;
};

/** aggregate fields of "product_maturity" */
export type Product_Maturity_Aggregate_Fields = {
  readonly __typename?: 'product_maturity_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Maturity_Max_Fields>;
  readonly min?: Maybe<Product_Maturity_Min_Fields>;
};


/** aggregate fields of "product_maturity" */
export type Product_Maturity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Maturity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_maturity". All fields are combined with a logical 'AND'. */
export type Product_Maturity_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Maturity_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Maturity_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Maturity_Bool_Exp>>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_maturity" */
export type Product_Maturity_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_maturity_pkey';

export type Product_Maturity_Enum =
  | 'future'
  | 'inter_month_spreads'
  | 'monthly';

/** Boolean expression to compare columns of type "product_maturity_enum". All fields are combined with logical 'AND'. */
export type Product_Maturity_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Maturity_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Maturity_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Maturity_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Maturity_Enum>>;
};

/** input type for inserting data into table "product_maturity" */
export type Product_Maturity_Insert_Input = {
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Maturity_Max_Fields = {
  readonly __typename?: 'product_maturity_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Maturity_Min_Fields = {
  readonly __typename?: 'product_maturity_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_maturity" */
export type Product_Maturity_Mutation_Response = {
  readonly __typename?: 'product_maturity_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Maturity>;
};

/** input type for inserting object relation for remote table "product_maturity" */
export type Product_Maturity_Obj_Rel_Insert_Input = {
  readonly data: Product_Maturity_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Maturity_On_Conflict>;
};

/** on_conflict condition type for table "product_maturity" */
export type Product_Maturity_On_Conflict = {
  readonly constraint: Product_Maturity_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Maturity_Update_Column>;
  readonly where?: InputMaybe<Product_Maturity_Bool_Exp>;
};

/** Ordering options when selecting data from "product_maturity". */
export type Product_Maturity_Order_By = {
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_maturity */
export type Product_Maturity_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_maturity" */
export type Product_Maturity_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "product_maturity" */
export type Product_Maturity_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_maturity" */
export type Product_Maturity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Maturity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Maturity_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_maturity" */
export type Product_Maturity_Update_Column =
  /** column name */
  | 'value';

export type Product_Maturity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Maturity_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Maturity_Bool_Exp;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  readonly __typename?: 'product_max_fields';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly eod_product_dep?: Maybe<Scalars['uuid']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['numeric']['output']>;
  readonly logical_code?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "product" */
export type Product_Max_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly eod_product_dep?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly logical_code?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  readonly __typename?: 'product_min_fields';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly eod_product_dep?: Maybe<Scalars['uuid']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['numeric']['output']>;
  readonly logical_code?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "product" */
export type Product_Min_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly eod_product_dep?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly logical_code?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  readonly __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  readonly data: Product_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  readonly constraint: Product_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Update_Column>;
  readonly where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  readonly artis_type?: InputMaybe<Order_By>;
  readonly code?: InputMaybe<Order_By>;
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly curve_type?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly eod_entries_aggregate?: InputMaybe<Eod_Entry_Aggregate_Order_By>;
  readonly eod_product_dep?: InputMaybe<Order_By>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly has_shared_cell?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_chartable?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly last_shared_aggregate?: InputMaybe<Shared_Instrument_Aggregate_Order_By>;
  readonly local_instruments_aggregate?: InputMaybe<Local_Instrument_Aggregate_Order_By>;
  readonly logical_code?: InputMaybe<Order_By>;
  readonly maturity?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
  readonly packageByPackage?: InputMaybe<Package_Order_By>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Order_By>;
  readonly productEodsByEodProduct_aggregate?: InputMaybe<Product_Eod_Aggregate_Order_By>;
  readonly productTypeByProductType?: InputMaybe<Product_Type_Order_By>;
  readonly product_artis_type?: InputMaybe<Product_Artis_Type_Order_By>;
  readonly product_configs_aggregate?: InputMaybe<Product_Config_Aggregate_Order_By>;
  readonly product_curve_type?: InputMaybe<Product_Curve_Type_Order_By>;
  readonly product_eods_aggregate?: InputMaybe<Product_Eod_Aggregate_Order_By>;
  readonly product_global_dependencies_aggregate?: InputMaybe<Product_Global_Dependencies_Aggregate_Order_By>;
  readonly product_maturity?: InputMaybe<Product_Maturity_Order_By>;
  readonly product_overrides_aggregate?: InputMaybe<Product_Overrides_Aggregate_Order_By>;
  readonly product_summary_type?: InputMaybe<Product_Summary_Type_Order_By>;
  readonly product_type?: InputMaybe<Order_By>;
  readonly product_uom?: InputMaybe<Product_Uom_Order_By>;
  readonly shared_instrument_count?: InputMaybe<Order_By>;
  readonly shared_instruments_aggregate?: InputMaybe<Shared_Instrument_Aggregate_Order_By>;
  readonly summary_type?: InputMaybe<Order_By>;
  readonly uom?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_overrides" */
export type Product_Overrides = {
  readonly __typename?: 'product_overrides';
  /** An object relationship */
  readonly commodityGroupByCommodityGroup?: Maybe<Commodity_Group>;
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly custom_group1?: Maybe<Scalars['String']['output']>;
  readonly custom_group2?: Maybe<Scalars['String']['output']>;
  readonly custom_group3?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly geographicalRegionByGeographicalRegion?: Maybe<Geographical_Region>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly organisation: Scalars['Int']['output'];
  /** An object relationship */
  readonly organisationByOrganisation: Organisation;
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByProduct: Product;
};

/** aggregated selection of "product_overrides" */
export type Product_Overrides_Aggregate = {
  readonly __typename?: 'product_overrides_aggregate';
  readonly aggregate?: Maybe<Product_Overrides_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Overrides>;
};

export type Product_Overrides_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Product_Overrides_Aggregate_Bool_Exp_Count>;
};

export type Product_Overrides_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Product_Overrides_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_overrides" */
export type Product_Overrides_Aggregate_Fields = {
  readonly __typename?: 'product_overrides_aggregate_fields';
  readonly avg?: Maybe<Product_Overrides_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Overrides_Max_Fields>;
  readonly min?: Maybe<Product_Overrides_Min_Fields>;
  readonly stddev?: Maybe<Product_Overrides_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Product_Overrides_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Product_Overrides_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Product_Overrides_Sum_Fields>;
  readonly var_pop?: Maybe<Product_Overrides_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Product_Overrides_Var_Samp_Fields>;
  readonly variance?: Maybe<Product_Overrides_Variance_Fields>;
};


/** aggregate fields of "product_overrides" */
export type Product_Overrides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_overrides" */
export type Product_Overrides_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Product_Overrides_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Product_Overrides_Max_Order_By>;
  readonly min?: InputMaybe<Product_Overrides_Min_Order_By>;
  readonly stddev?: InputMaybe<Product_Overrides_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Product_Overrides_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Product_Overrides_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Product_Overrides_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Product_Overrides_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Product_Overrides_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Product_Overrides_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_overrides" */
export type Product_Overrides_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Product_Overrides_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Overrides_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Overrides_Avg_Fields = {
  readonly __typename?: 'product_overrides_avg_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_overrides" */
export type Product_Overrides_Avg_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_overrides". All fields are combined with a logical 'AND'. */
export type Product_Overrides_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Overrides_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Overrides_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Overrides_Bool_Exp>>;
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Bool_Exp>;
  readonly commodity_group?: InputMaybe<Int_Comparison_Exp>;
  readonly custom_group1?: InputMaybe<String_Comparison_Exp>;
  readonly custom_group2?: InputMaybe<String_Comparison_Exp>;
  readonly custom_group3?: InputMaybe<String_Comparison_Exp>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Bool_Exp>;
  readonly geographical_region?: InputMaybe<Int_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Bool_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
};

/** unique or primary key constraints on table "product_overrides" */
export type Product_Overrides_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_overrides_id_key'
  /** unique or primary key constraint on columns "organisation", "name" */
  | 'product_overrides_name_organisation_key'
  /** unique or primary key constraint on columns "product", "organisation" */
  | 'product_overrides_pkey';

/** input type for incrementing numeric columns in table "product_overrides" */
export type Product_Overrides_Inc_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_overrides" */
export type Product_Overrides_Insert_Input = {
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Obj_Rel_Insert_Input>;
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly custom_group1?: InputMaybe<Scalars['String']['input']>;
  readonly custom_group2?: InputMaybe<Scalars['String']['input']>;
  readonly custom_group3?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Obj_Rel_Insert_Input>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Overrides_Max_Fields = {
  readonly __typename?: 'product_overrides_max_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly custom_group1?: Maybe<Scalars['String']['output']>;
  readonly custom_group2?: Maybe<Scalars['String']['output']>;
  readonly custom_group3?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_overrides" */
export type Product_Overrides_Max_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly custom_group1?: InputMaybe<Order_By>;
  readonly custom_group2?: InputMaybe<Order_By>;
  readonly custom_group3?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Overrides_Min_Fields = {
  readonly __typename?: 'product_overrides_min_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly custom_group1?: Maybe<Scalars['String']['output']>;
  readonly custom_group2?: Maybe<Scalars['String']['output']>;
  readonly custom_group3?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_overrides" */
export type Product_Overrides_Min_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly custom_group1?: InputMaybe<Order_By>;
  readonly custom_group2?: InputMaybe<Order_By>;
  readonly custom_group3?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_overrides" */
export type Product_Overrides_Mutation_Response = {
  readonly __typename?: 'product_overrides_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Overrides>;
};

/** on_conflict condition type for table "product_overrides" */
export type Product_Overrides_On_Conflict = {
  readonly constraint: Product_Overrides_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Overrides_Update_Column>;
  readonly where?: InputMaybe<Product_Overrides_Bool_Exp>;
};

/** Ordering options when selecting data from "product_overrides". */
export type Product_Overrides_Order_By = {
  readonly commodityGroupByCommodityGroup?: InputMaybe<Commodity_Group_Order_By>;
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly custom_group1?: InputMaybe<Order_By>;
  readonly custom_group2?: InputMaybe<Order_By>;
  readonly custom_group3?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly geographicalRegionByGeographicalRegion?: InputMaybe<Geographical_Region_Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
  readonly organisationByOrganisation?: InputMaybe<Organisation_Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
};

/** primary key columns input for table: product_overrides */
export type Product_Overrides_Pk_Columns_Input = {
  readonly organisation: Scalars['Int']['input'];
  readonly product: Scalars['uuid']['input'];
};

/** select columns of table "product_overrides" */
export type Product_Overrides_Select_Column =
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'custom_group1'
  /** column name */
  | 'custom_group2'
  /** column name */
  | 'custom_group3'
  /** column name */
  | 'description'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'organisation'
  /** column name */
  | 'product';

/** input type for updating data in table "product_overrides" */
export type Product_Overrides_Set_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly custom_group1?: InputMaybe<Scalars['String']['input']>;
  readonly custom_group2?: InputMaybe<Scalars['String']['input']>;
  readonly custom_group3?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Product_Overrides_Stddev_Fields = {
  readonly __typename?: 'product_overrides_stddev_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_overrides" */
export type Product_Overrides_Stddev_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Overrides_Stddev_Pop_Fields = {
  readonly __typename?: 'product_overrides_stddev_pop_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_overrides" */
export type Product_Overrides_Stddev_Pop_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Overrides_Stddev_Samp_Fields = {
  readonly __typename?: 'product_overrides_stddev_samp_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_overrides" */
export type Product_Overrides_Stddev_Samp_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_overrides" */
export type Product_Overrides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Overrides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Overrides_Stream_Cursor_Value_Input = {
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly custom_group1?: InputMaybe<Scalars['String']['input']>;
  readonly custom_group2?: InputMaybe<Scalars['String']['input']>;
  readonly custom_group3?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Product_Overrides_Sum_Fields = {
  readonly __typename?: 'product_overrides_sum_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "product_overrides" */
export type Product_Overrides_Sum_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** update columns of table "product_overrides" */
export type Product_Overrides_Update_Column =
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'custom_group1'
  /** column name */
  | 'custom_group2'
  /** column name */
  | 'custom_group3'
  /** column name */
  | 'description'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'organisation'
  /** column name */
  | 'product';

export type Product_Overrides_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Product_Overrides_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Overrides_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Overrides_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Overrides_Var_Pop_Fields = {
  readonly __typename?: 'product_overrides_var_pop_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_overrides" */
export type Product_Overrides_Var_Pop_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Overrides_Var_Samp_Fields = {
  readonly __typename?: 'product_overrides_var_samp_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_overrides" */
export type Product_Overrides_Var_Samp_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Overrides_Variance_Fields = {
  readonly __typename?: 'product_overrides_variance_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_overrides" */
export type Product_Overrides_Variance_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  readonly id: Scalars['uuid']['input'];
};

/** select columns of table "product" */
export type Product_Select_Column =
  /** column name */
  | 'artis_type'
  /** column name */
  | 'code'
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'curve_type'
  /** column name */
  | 'description'
  /** column name */
  | 'dp'
  /** column name */
  | 'eod_product_dep'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'id'
  /** column name */
  | 'is_chartable'
  /** column name */
  | 'kt_kb_conversion_factor'
  /** column name */
  | 'logical_code'
  /** column name */
  | 'maturity'
  /** column name */
  | 'name'
  /** column name */
  | 'package'
  /** column name */
  | 'product_type'
  /** column name */
  | 'summary_type'
  /** column name */
  | 'uom';

/** select "product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product" */
export type Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_chartable';

/** select "product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product" */
export type Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_chartable';

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  readonly artis_type?: InputMaybe<Product_Artis_Type_Enum>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly eod_product_dep?: InputMaybe<Scalars['uuid']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly is_chartable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly kt_kb_conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  readonly logical_code?: InputMaybe<Scalars['String']['input']>;
  readonly maturity?: InputMaybe<Product_Maturity_Enum>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly product_type?: InputMaybe<Product_Type_Enum>;
  readonly summary_type?: InputMaybe<Product_Summary_Type_Enum>;
  readonly uom?: InputMaybe<Product_Uom_Enum>;
};

/** columns and relationships of "product_source" */
export type Product_Source = {
  readonly __typename?: 'product_source';
  /** An array relationship */
  readonly sources: ReadonlyArray<Source>;
  /** An aggregate relationship */
  readonly sources_aggregate: Source_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "product_source" */
export type Product_SourceSourcesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Source_Order_By>>;
  where?: InputMaybe<Source_Bool_Exp>;
};


/** columns and relationships of "product_source" */
export type Product_SourceSources_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Source_Order_By>>;
  where?: InputMaybe<Source_Bool_Exp>;
};

/** aggregated selection of "product_source" */
export type Product_Source_Aggregate = {
  readonly __typename?: 'product_source_aggregate';
  readonly aggregate?: Maybe<Product_Source_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Source>;
};

/** aggregate fields of "product_source" */
export type Product_Source_Aggregate_Fields = {
  readonly __typename?: 'product_source_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Source_Max_Fields>;
  readonly min?: Maybe<Product_Source_Min_Fields>;
};


/** aggregate fields of "product_source" */
export type Product_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_source". All fields are combined with a logical 'AND'. */
export type Product_Source_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Source_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Source_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Source_Bool_Exp>>;
  readonly sources?: InputMaybe<Source_Bool_Exp>;
  readonly sources_aggregate?: InputMaybe<Source_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_source" */
export type Product_Source_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_source_pkey';

export type Product_Source_Enum =
  | 'eod'
  | 'exchange'
  | 'global'
  | 'organisation';

/** Boolean expression to compare columns of type "product_source_enum". All fields are combined with logical 'AND'. */
export type Product_Source_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Source_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Source_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Source_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Source_Enum>>;
};

/** input type for inserting data into table "product_source" */
export type Product_Source_Insert_Input = {
  readonly sources?: InputMaybe<Source_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Source_Max_Fields = {
  readonly __typename?: 'product_source_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Source_Min_Fields = {
  readonly __typename?: 'product_source_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_source" */
export type Product_Source_Mutation_Response = {
  readonly __typename?: 'product_source_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Source>;
};

/** input type for inserting object relation for remote table "product_source" */
export type Product_Source_Obj_Rel_Insert_Input = {
  readonly data: Product_Source_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Source_On_Conflict>;
};

/** on_conflict condition type for table "product_source" */
export type Product_Source_On_Conflict = {
  readonly constraint: Product_Source_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Source_Update_Column>;
  readonly where?: InputMaybe<Product_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "product_source". */
export type Product_Source_Order_By = {
  readonly sources_aggregate?: InputMaybe<Source_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_source */
export type Product_Source_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_source" */
export type Product_Source_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "product_source" */
export type Product_Source_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_source" */
export type Product_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Source_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_source" */
export type Product_Source_Update_Column =
  /** column name */
  | 'value';

export type Product_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Source_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Source_Bool_Exp;
};

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  readonly __typename?: 'product_stddev_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev() on columns of table "product" */
export type Product_Stddev_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  readonly __typename?: 'product_stddev_pop_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev_pop() on columns of table "product" */
export type Product_Stddev_Pop_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  readonly __typename?: 'product_stddev_samp_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by stddev_samp() on columns of table "product" */
export type Product_Stddev_Samp_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  readonly artis_type?: InputMaybe<Product_Artis_Type_Enum>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly commodity_group?: InputMaybe<Scalars['Int']['input']>;
  readonly curve_type?: InputMaybe<Product_Curve_Type_Enum>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly eod_product_dep?: InputMaybe<Scalars['uuid']['input']>;
  readonly geographical_region?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly is_chartable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly kt_kb_conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  readonly logical_code?: InputMaybe<Scalars['String']['input']>;
  readonly maturity?: InputMaybe<Product_Maturity_Enum>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly package?: InputMaybe<Scalars['Int']['input']>;
  readonly product_type?: InputMaybe<Product_Type_Enum>;
  readonly summary_type?: InputMaybe<Product_Summary_Type_Enum>;
  readonly uom?: InputMaybe<Product_Uom_Enum>;
};

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  readonly __typename?: 'product_sum_fields';
  readonly commodity_group?: Maybe<Scalars['Int']['output']>;
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly geographical_region?: Maybe<Scalars['Int']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['numeric']['output']>;
  readonly package?: Maybe<Scalars['Int']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "product" */
export type Product_Sum_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_summary_type" */
export type Product_Summary_Type = {
  readonly __typename?: 'product_summary_type';
  /** An array relationship */
  readonly summary_types: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly summary_types_aggregate: Product_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "product_summary_type" */
export type Product_Summary_TypeSummary_TypesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "product_summary_type" */
export type Product_Summary_TypeSummary_Types_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "product_summary_type" */
export type Product_Summary_Type_Aggregate = {
  readonly __typename?: 'product_summary_type_aggregate';
  readonly aggregate?: Maybe<Product_Summary_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Summary_Type>;
};

/** aggregate fields of "product_summary_type" */
export type Product_Summary_Type_Aggregate_Fields = {
  readonly __typename?: 'product_summary_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Summary_Type_Max_Fields>;
  readonly min?: Maybe<Product_Summary_Type_Min_Fields>;
};


/** aggregate fields of "product_summary_type" */
export type Product_Summary_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Summary_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_summary_type". All fields are combined with a logical 'AND'. */
export type Product_Summary_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Summary_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Summary_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Summary_Type_Bool_Exp>>;
  readonly summary_types?: InputMaybe<Product_Bool_Exp>;
  readonly summary_types_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_summary_type" */
export type Product_Summary_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_summary_type_pkey';

export type Product_Summary_Type_Enum =
  | 'average'
  | 'hourly_weighted_average'
  | 'hourly_weighted_timespread'
  | 'none'
  | 'sum'
  | 'timespread';

/** Boolean expression to compare columns of type "product_summary_type_enum". All fields are combined with logical 'AND'. */
export type Product_Summary_Type_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Summary_Type_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Summary_Type_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Summary_Type_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Summary_Type_Enum>>;
};

/** input type for inserting data into table "product_summary_type" */
export type Product_Summary_Type_Insert_Input = {
  readonly summary_types?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Summary_Type_Max_Fields = {
  readonly __typename?: 'product_summary_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Summary_Type_Min_Fields = {
  readonly __typename?: 'product_summary_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_summary_type" */
export type Product_Summary_Type_Mutation_Response = {
  readonly __typename?: 'product_summary_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Summary_Type>;
};

/** input type for inserting object relation for remote table "product_summary_type" */
export type Product_Summary_Type_Obj_Rel_Insert_Input = {
  readonly data: Product_Summary_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Summary_Type_On_Conflict>;
};

/** on_conflict condition type for table "product_summary_type" */
export type Product_Summary_Type_On_Conflict = {
  readonly constraint: Product_Summary_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Summary_Type_Update_Column>;
  readonly where?: InputMaybe<Product_Summary_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_summary_type". */
export type Product_Summary_Type_Order_By = {
  readonly summary_types_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_summary_type */
export type Product_Summary_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_summary_type" */
export type Product_Summary_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "product_summary_type" */
export type Product_Summary_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_summary_type" */
export type Product_Summary_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Summary_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Summary_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_summary_type" */
export type Product_Summary_Type_Update_Column =
  /** column name */
  | 'value';

export type Product_Summary_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Summary_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Summary_Type_Bool_Exp;
};

/** columns and relationships of "product_type" */
export type Product_Type = {
  readonly __typename?: 'product_type';
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "product_type" */
export type Product_TypeProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "product_type" */
export type Product_TypeProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "product_type" */
export type Product_Type_Aggregate = {
  readonly __typename?: 'product_type_aggregate';
  readonly aggregate?: Maybe<Product_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Type>;
};

/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_Fields = {
  readonly __typename?: 'product_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Type_Max_Fields>;
  readonly min?: Maybe<Product_Type_Min_Fields>;
};


/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_type". All fields are combined with a logical 'AND'. */
export type Product_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Type_Bool_Exp>>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_type" */
export type Product_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_type_pkey';

export type Product_Type_Enum =
  | 'arb'
  | 'box'
  | 'crack'
  | 'diff'
  | 'misc'
  | 'outright'
  | 'pnl'
  | 'position'
  | 'refmgn'
  | 'timespread';

/** Boolean expression to compare columns of type "product_type_enum". All fields are combined with logical 'AND'. */
export type Product_Type_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Type_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Type_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Type_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Type_Enum>>;
};

/** input type for inserting data into table "product_type" */
export type Product_Type_Insert_Input = {
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Type_Max_Fields = {
  readonly __typename?: 'product_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Type_Min_Fields = {
  readonly __typename?: 'product_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_type" */
export type Product_Type_Mutation_Response = {
  readonly __typename?: 'product_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Type>;
};

/** input type for inserting object relation for remote table "product_type" */
export type Product_Type_Obj_Rel_Insert_Input = {
  readonly data: Product_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};

/** on_conflict condition type for table "product_type" */
export type Product_Type_On_Conflict = {
  readonly constraint: Product_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Type_Update_Column>;
  readonly where?: InputMaybe<Product_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_type". */
export type Product_Type_Order_By = {
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_type */
export type Product_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_type" */
export type Product_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "product_type" */
export type Product_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_type" */
export type Product_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_type" */
export type Product_Type_Update_Column =
  /** column name */
  | 'value';

export type Product_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Type_Bool_Exp;
};

/** columns and relationships of "product_uom" */
export type Product_Uom = {
  readonly __typename?: 'product_uom';
  readonly description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  readonly global_products: ReadonlyArray<Global_Product>;
  /** An aggregate relationship */
  readonly global_products_aggregate: Global_Product_Aggregate;
  /** An array relationship */
  readonly products: ReadonlyArray<Product>;
  /** An aggregate relationship */
  readonly products_aggregate: Product_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "product_uom" */
export type Product_UomGlobal_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "product_uom" */
export type Product_UomGlobal_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


/** columns and relationships of "product_uom" */
export type Product_UomProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "product_uom" */
export type Product_UomProducts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "product_uom" */
export type Product_Uom_Aggregate = {
  readonly __typename?: 'product_uom_aggregate';
  readonly aggregate?: Maybe<Product_Uom_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_Uom>;
};

/** aggregate fields of "product_uom" */
export type Product_Uom_Aggregate_Fields = {
  readonly __typename?: 'product_uom_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_Uom_Max_Fields>;
  readonly min?: Maybe<Product_Uom_Min_Fields>;
};


/** aggregate fields of "product_uom" */
export type Product_Uom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_Uom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_uom". All fields are combined with a logical 'AND'. */
export type Product_Uom_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_Uom_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_Uom_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_Uom_Bool_Exp>>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly global_products?: InputMaybe<Global_Product_Bool_Exp>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Bool_Exp>;
  readonly products?: InputMaybe<Product_Bool_Exp>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_uom" */
export type Product_Uom_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_uom_pkey';

export type Product_Uom_Enum =
  /** BRL/MT */
  | 'brl_mt'
  /** CAD */
  | 'cad'
  /** chn */
  | 'chn'
  /** days */
  | 'days'
  | 'eur'
  /** €/m³ */
  | 'eur_m3'
  /** €/mt */
  | 'eur_mt'
  /** €/MWh */
  | 'eur_mwh'
  /** EUR/Seb */
  | 'euro_mwh'
  /** Factor */
  | 'factor'
  | 'flatr'
  | 'gbp'
  | 'kb'
  | 'kbd'
  | 'kcbm'
  /** kg/m³ */
  | 'kg_m3'
  | 'kgal'
  | 'kt'
  | 'lots'
  /** MYR */
  | 'myr'
  /** Misc */
  | 'none'
  /** p/thm */
  | 'p_thm'
  /**  % */
  | 'percent'
  /** pts/gal */
  | 'points_gal'
  | 'rmb_bbl'
  /** CN¥/ton */
  | 'rmb_ton'
  /** c/bbl */
  | 'usc_bbl'
  /** c/bsh */
  | 'usc_bsh'
  /** c/gal */
  | 'usc_gal'
  /** c/lb */
  | 'usc_lb'
  | 'usd'
  /** $/bbl */
  | 'usd_bbl'
  /** $/day */
  | 'usd_day'
  /** $/gal */
  | 'usd_gal'
  /** $/kg */
  | 'usd_kg'
  /** $/mmbtu */
  | 'usd_mmbtu'
  /** $'000s */
  | 'usd_thousands'
  /** $/ton */
  | 'usd_ton'
  /** $mm */
  | 'usdmm'
  | 'ws'
  /** ws & $/ton */
  | 'ws_and_usd_ton'
  /** ZAR */
  | 'zar';

/** Boolean expression to compare columns of type "product_uom_enum". All fields are combined with logical 'AND'. */
export type Product_Uom_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Product_Uom_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Product_Uom_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Product_Uom_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Product_Uom_Enum>>;
};

/** input type for inserting data into table "product_uom" */
export type Product_Uom_Insert_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly global_products?: InputMaybe<Global_Product_Arr_Rel_Insert_Input>;
  readonly products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Uom_Max_Fields = {
  readonly __typename?: 'product_uom_max_fields';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Uom_Min_Fields = {
  readonly __typename?: 'product_uom_min_fields';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_uom" */
export type Product_Uom_Mutation_Response = {
  readonly __typename?: 'product_uom_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_Uom>;
};

/** input type for inserting object relation for remote table "product_uom" */
export type Product_Uom_Obj_Rel_Insert_Input = {
  readonly data: Product_Uom_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Product_Uom_On_Conflict>;
};

/** on_conflict condition type for table "product_uom" */
export type Product_Uom_On_Conflict = {
  readonly constraint: Product_Uom_Constraint;
  readonly update_columns?: ReadonlyArray<Product_Uom_Update_Column>;
  readonly where?: InputMaybe<Product_Uom_Bool_Exp>;
};

/** Ordering options when selecting data from "product_uom". */
export type Product_Uom_Order_By = {
  readonly description?: InputMaybe<Order_By>;
  readonly global_products_aggregate?: InputMaybe<Global_Product_Aggregate_Order_By>;
  readonly products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_uom */
export type Product_Uom_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "product_uom" */
export type Product_Uom_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "product_uom" */
export type Product_Uom_Set_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_uom" */
export type Product_Uom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_Uom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Uom_Stream_Cursor_Value_Input = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_uom" */
export type Product_Uom_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Product_Uom_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Uom_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Uom_Bool_Exp;
};

/** update columns of table "product" */
export type Product_Update_Column =
  /** column name */
  | 'artis_type'
  /** column name */
  | 'code'
  /** column name */
  | 'commodity_group'
  /** column name */
  | 'curve_type'
  /** column name */
  | 'description'
  /** column name */
  | 'dp'
  /** column name */
  | 'eod_product_dep'
  /** column name */
  | 'geographical_region'
  /** column name */
  | 'id'
  /** column name */
  | 'is_chartable'
  /** column name */
  | 'kt_kb_conversion_factor'
  /** column name */
  | 'logical_code'
  /** column name */
  | 'maturity'
  /** column name */
  | 'name'
  /** column name */
  | 'package'
  /** column name */
  | 'product_type'
  /** column name */
  | 'summary_type'
  /** column name */
  | 'uom';

export type Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_Bool_Exp;
};

/** columns and relationships of "product_user_settings" */
export type Product_User_Settings = {
  readonly __typename?: 'product_user_settings';
  readonly dp?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  readonly productByProductId: Product;
  readonly product_id: Scalars['uuid']['output'];
  /** An object relationship */
  readonly userByUserId: Folio_User;
  readonly user_id: Scalars['String']['output'];
};

/** aggregated selection of "product_user_settings" */
export type Product_User_Settings_Aggregate = {
  readonly __typename?: 'product_user_settings_aggregate';
  readonly aggregate?: Maybe<Product_User_Settings_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Product_User_Settings>;
};

/** aggregate fields of "product_user_settings" */
export type Product_User_Settings_Aggregate_Fields = {
  readonly __typename?: 'product_user_settings_aggregate_fields';
  readonly avg?: Maybe<Product_User_Settings_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Product_User_Settings_Max_Fields>;
  readonly min?: Maybe<Product_User_Settings_Min_Fields>;
  readonly stddev?: Maybe<Product_User_Settings_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Product_User_Settings_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Product_User_Settings_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Product_User_Settings_Sum_Fields>;
  readonly var_pop?: Maybe<Product_User_Settings_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Product_User_Settings_Var_Samp_Fields>;
  readonly variance?: Maybe<Product_User_Settings_Variance_Fields>;
};


/** aggregate fields of "product_user_settings" */
export type Product_User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Product_User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Product_User_Settings_Avg_Fields = {
  readonly __typename?: 'product_user_settings_avg_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "product_user_settings". All fields are combined with a logical 'AND'. */
export type Product_User_Settings_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Product_User_Settings_Bool_Exp>>;
  readonly _not?: InputMaybe<Product_User_Settings_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Product_User_Settings_Bool_Exp>>;
  readonly dp?: InputMaybe<Int_Comparison_Exp>;
  readonly productByProductId?: InputMaybe<Product_Bool_Exp>;
  readonly product_id?: InputMaybe<Uuid_Comparison_Exp>;
  readonly userByUserId?: InputMaybe<Folio_User_Bool_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_user_settings" */
export type Product_User_Settings_Constraint =
  /** unique or primary key constraint on columns "user_id", "product_id" */
  | 'product_user_settings_pkey';

/** input type for incrementing numeric columns in table "product_user_settings" */
export type Product_User_Settings_Inc_Input = {
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_user_settings" */
export type Product_User_Settings_Insert_Input = {
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly productByProductId?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly product_id?: InputMaybe<Scalars['uuid']['input']>;
  readonly userByUserId?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_User_Settings_Max_Fields = {
  readonly __typename?: 'product_user_settings_max_fields';
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly product_id?: Maybe<Scalars['uuid']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_User_Settings_Min_Fields = {
  readonly __typename?: 'product_user_settings_min_fields';
  readonly dp?: Maybe<Scalars['Int']['output']>;
  readonly product_id?: Maybe<Scalars['uuid']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_user_settings" */
export type Product_User_Settings_Mutation_Response = {
  readonly __typename?: 'product_user_settings_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Product_User_Settings>;
};

/** on_conflict condition type for table "product_user_settings" */
export type Product_User_Settings_On_Conflict = {
  readonly constraint: Product_User_Settings_Constraint;
  readonly update_columns?: ReadonlyArray<Product_User_Settings_Update_Column>;
  readonly where?: InputMaybe<Product_User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "product_user_settings". */
export type Product_User_Settings_Order_By = {
  readonly dp?: InputMaybe<Order_By>;
  readonly productByProductId?: InputMaybe<Product_Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly userByUserId?: InputMaybe<Folio_User_Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_user_settings */
export type Product_User_Settings_Pk_Columns_Input = {
  readonly product_id: Scalars['uuid']['input'];
  readonly user_id: Scalars['String']['input'];
};

/** select columns of table "product_user_settings" */
export type Product_User_Settings_Select_Column =
  /** column name */
  | 'dp'
  /** column name */
  | 'product_id'
  /** column name */
  | 'user_id';

/** input type for updating data in table "product_user_settings" */
export type Product_User_Settings_Set_Input = {
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly product_id?: InputMaybe<Scalars['uuid']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Product_User_Settings_Stddev_Fields = {
  readonly __typename?: 'product_user_settings_stddev_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Product_User_Settings_Stddev_Pop_Fields = {
  readonly __typename?: 'product_user_settings_stddev_pop_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Product_User_Settings_Stddev_Samp_Fields = {
  readonly __typename?: 'product_user_settings_stddev_samp_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "product_user_settings" */
export type Product_User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Product_User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_User_Settings_Stream_Cursor_Value_Input = {
  readonly dp?: InputMaybe<Scalars['Int']['input']>;
  readonly product_id?: InputMaybe<Scalars['uuid']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Product_User_Settings_Sum_Fields = {
  readonly __typename?: 'product_user_settings_sum_fields';
  readonly dp?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "product_user_settings" */
export type Product_User_Settings_Update_Column =
  /** column name */
  | 'dp'
  /** column name */
  | 'product_id'
  /** column name */
  | 'user_id';

export type Product_User_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Product_User_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Product_User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Product_User_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_User_Settings_Var_Pop_Fields = {
  readonly __typename?: 'product_user_settings_var_pop_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Product_User_Settings_Var_Samp_Fields = {
  readonly __typename?: 'product_user_settings_var_samp_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Product_User_Settings_Variance_Fields = {
  readonly __typename?: 'product_user_settings_variance_fields';
  readonly dp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  readonly __typename?: 'product_var_pop_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by var_pop() on columns of table "product" */
export type Product_Var_Pop_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  readonly __typename?: 'product_var_samp_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by var_samp() on columns of table "product" */
export type Product_Var_Samp_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  readonly __typename?: 'product_variance_fields';
  readonly commodity_group?: Maybe<Scalars['Float']['output']>;
  readonly dp?: Maybe<Scalars['Float']['output']>;
  readonly geographical_region?: Maybe<Scalars['Float']['output']>;
  readonly kt_kb_conversion_factor?: Maybe<Scalars['Float']['output']>;
  readonly package?: Maybe<Scalars['Float']['output']>;
  /** Gets number of shared_instruments */
  readonly shared_instrument_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by variance() on columns of table "product" */
export type Product_Variance_Order_By = {
  readonly commodity_group?: InputMaybe<Order_By>;
  readonly dp?: InputMaybe<Order_By>;
  readonly geographical_region?: InputMaybe<Order_By>;
  readonly kt_kb_conversion_factor?: InputMaybe<Order_By>;
  readonly package?: InputMaybe<Order_By>;
};

/** columns and relationships of "push_subscriptions" */
export type Push_Subscriptions = {
  readonly __typename?: 'push_subscriptions';
  readonly subscriptions: Scalars['jsonb']['output'];
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "push_subscriptions" */
export type Push_SubscriptionsSubscriptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "push_subscriptions" */
export type Push_Subscriptions_Aggregate = {
  readonly __typename?: 'push_subscriptions_aggregate';
  readonly aggregate?: Maybe<Push_Subscriptions_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Push_Subscriptions>;
};

/** aggregate fields of "push_subscriptions" */
export type Push_Subscriptions_Aggregate_Fields = {
  readonly __typename?: 'push_subscriptions_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Push_Subscriptions_Max_Fields>;
  readonly min?: Maybe<Push_Subscriptions_Min_Fields>;
};


/** aggregate fields of "push_subscriptions" */
export type Push_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Push_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Push_Subscriptions_Append_Input = {
  readonly subscriptions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "push_subscriptions". All fields are combined with a logical 'AND'. */
export type Push_Subscriptions_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Push_Subscriptions_Bool_Exp>>;
  readonly _not?: InputMaybe<Push_Subscriptions_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Push_Subscriptions_Bool_Exp>>;
  readonly subscriptions?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "push_subscriptions" */
export type Push_Subscriptions_Constraint =
  /** unique or primary key constraint on columns "user_id" */
  | 'push_subscriptions_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Push_Subscriptions_Delete_At_Path_Input = {
  readonly subscriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Push_Subscriptions_Delete_Elem_Input = {
  readonly subscriptions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Push_Subscriptions_Delete_Key_Input = {
  readonly subscriptions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "push_subscriptions" */
export type Push_Subscriptions_Insert_Input = {
  readonly subscriptions?: InputMaybe<Scalars['jsonb']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Push_Subscriptions_Max_Fields = {
  readonly __typename?: 'push_subscriptions_max_fields';
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Push_Subscriptions_Min_Fields = {
  readonly __typename?: 'push_subscriptions_min_fields';
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "push_subscriptions" */
export type Push_Subscriptions_Mutation_Response = {
  readonly __typename?: 'push_subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Push_Subscriptions>;
};

/** on_conflict condition type for table "push_subscriptions" */
export type Push_Subscriptions_On_Conflict = {
  readonly constraint: Push_Subscriptions_Constraint;
  readonly update_columns?: ReadonlyArray<Push_Subscriptions_Update_Column>;
  readonly where?: InputMaybe<Push_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "push_subscriptions". */
export type Push_Subscriptions_Order_By = {
  readonly subscriptions?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: push_subscriptions */
export type Push_Subscriptions_Pk_Columns_Input = {
  readonly user_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Push_Subscriptions_Prepend_Input = {
  readonly subscriptions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "push_subscriptions" */
export type Push_Subscriptions_Select_Column =
  /** column name */
  | 'subscriptions'
  /** column name */
  | 'user_id';

/** input type for updating data in table "push_subscriptions" */
export type Push_Subscriptions_Set_Input = {
  readonly subscriptions?: InputMaybe<Scalars['jsonb']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "push_subscriptions" */
export type Push_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Push_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Push_Subscriptions_Stream_Cursor_Value_Input = {
  readonly subscriptions?: InputMaybe<Scalars['jsonb']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "push_subscriptions" */
export type Push_Subscriptions_Update_Column =
  /** column name */
  | 'subscriptions'
  /** column name */
  | 'user_id';

export type Push_Subscriptions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Push_Subscriptions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Push_Subscriptions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Push_Subscriptions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Push_Subscriptions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Push_Subscriptions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Push_Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Push_Subscriptions_Bool_Exp;
};

export type Query_Root = {
  readonly __typename?: 'query_root';
  /** An array relationship */
  readonly alerts: ReadonlyArray<Alerts>;
  /** An aggregate relationship */
  readonly alerts_aggregate: Alerts_Aggregate;
  /** fetch data from the table: "alerts" using primary key columns */
  readonly alerts_by_pk?: Maybe<Alerts>;
  /** fetch data from the table: "audit.logged_actions" */
  readonly audit_logged_actions: ReadonlyArray<Audit_Logged_Actions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  readonly audit_logged_actions_aggregate: Audit_Logged_Actions_Aggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  readonly audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** fetch data from the table: "audit.umi_actions" */
  readonly audit_umi_actions: ReadonlyArray<Audit_Umi_Actions>;
  /** fetch aggregated fields from the table: "audit.umi_actions" */
  readonly audit_umi_actions_aggregate: Audit_Umi_Actions_Aggregate;
  /** fetch data from the table: "audit.umi_actions" using primary key columns */
  readonly audit_umi_actions_by_pk?: Maybe<Audit_Umi_Actions>;
  /** fetch data from the table: "commodity_group" */
  readonly commodity_group: ReadonlyArray<Commodity_Group>;
  /** fetch aggregated fields from the table: "commodity_group" */
  readonly commodity_group_aggregate: Commodity_Group_Aggregate;
  /** fetch data from the table: "commodity_group" using primary key columns */
  readonly commodity_group_by_pk?: Maybe<Commodity_Group>;
  /** fetch data from the table: "commodity_parent_group" */
  readonly commodity_parent_group: ReadonlyArray<Commodity_Parent_Group>;
  /** fetch aggregated fields from the table: "commodity_parent_group" */
  readonly commodity_parent_group_aggregate: Commodity_Parent_Group_Aggregate;
  /** fetch data from the table: "commodity_parent_group" using primary key columns */
  readonly commodity_parent_group_by_pk?: Maybe<Commodity_Parent_Group>;
  /** An array relationship */
  readonly conditional_formatting_rules: ReadonlyArray<Conditional_Formatting_Rules>;
  /** An aggregate relationship */
  readonly conditional_formatting_rules_aggregate: Conditional_Formatting_Rules_Aggregate;
  /** fetch data from the table: "conditional_formatting_rules" using primary key columns */
  readonly conditional_formatting_rules_by_pk?: Maybe<Conditional_Formatting_Rules>;
  /** fetch data from the table: "eod" */
  readonly eod: ReadonlyArray<Eod>;
  /** fetch aggregated fields from the table: "eod" */
  readonly eod_aggregate: Eod_Aggregate;
  /** fetch data from the table: "eod" using primary key columns */
  readonly eod_by_pk?: Maybe<Eod>;
  /** fetch data from the table: "eod_entry" */
  readonly eod_entry: ReadonlyArray<Eod_Entry>;
  /** fetch aggregated fields from the table: "eod_entry" */
  readonly eod_entry_aggregate: Eod_Entry_Aggregate;
  /** fetch data from the table: "eod_entry" using primary key columns */
  readonly eod_entry_by_pk?: Maybe<Eod_Entry>;
  /** fetch data from the table: "exchange" */
  readonly exchange: ReadonlyArray<Exchange>;
  /** fetch aggregated fields from the table: "exchange" */
  readonly exchange_aggregate: Exchange_Aggregate;
  /** fetch data from the table: "exchange" using primary key columns */
  readonly exchange_by_pk?: Maybe<Exchange>;
  /** fetch data from the table: "exchange_event_type" */
  readonly exchange_event_type: ReadonlyArray<Exchange_Event_Type>;
  /** fetch aggregated fields from the table: "exchange_event_type" */
  readonly exchange_event_type_aggregate: Exchange_Event_Type_Aggregate;
  /** fetch data from the table: "exchange_event_type" using primary key columns */
  readonly exchange_event_type_by_pk?: Maybe<Exchange_Event_Type>;
  /** fetch data from the table: "exchange_usage" */
  readonly exchange_usage: ReadonlyArray<Exchange_Usage>;
  /** fetch aggregated fields from the table: "exchange_usage" */
  readonly exchange_usage_aggregate: Exchange_Usage_Aggregate;
  /** fetch data from the table: "exchange_usage" using primary key columns */
  readonly exchange_usage_by_pk?: Maybe<Exchange_Usage>;
  /** fetch data from the table: "exchange_usage_last" */
  readonly exchange_usage_last: ReadonlyArray<Exchange_Usage_Last>;
  /** fetch aggregated fields from the table: "exchange_usage_last" */
  readonly exchange_usage_last_aggregate: Exchange_Usage_Last_Aggregate;
  /** fetch data from the table: "exchange_usage_start" */
  readonly exchange_usage_start: ReadonlyArray<Exchange_Usage_Start>;
  /** fetch aggregated fields from the table: "exchange_usage_start" */
  readonly exchange_usage_start_aggregate: Exchange_Usage_Start_Aggregate;
  /** fetch data from the table: "feature_flags" */
  readonly feature_flags: ReadonlyArray<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  readonly feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  readonly feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table: "folio_shadow_curves" */
  readonly folio_shadow_curves: ReadonlyArray<Folio_Shadow_Curves>;
  /** fetch aggregated fields from the table: "folio_shadow_curves" */
  readonly folio_shadow_curves_aggregate: Folio_Shadow_Curves_Aggregate;
  /** fetch data from the table: "folio_shadow_curves" using primary key columns */
  readonly folio_shadow_curves_by_pk?: Maybe<Folio_Shadow_Curves>;
  /** fetch data from the table: "folio_user" */
  readonly folio_user: ReadonlyArray<Folio_User>;
  /** fetch aggregated fields from the table: "folio_user" */
  readonly folio_user_aggregate: Folio_User_Aggregate;
  /** fetch data from the table: "folio_user_basic_profile" */
  readonly folio_user_basic_profile: ReadonlyArray<Folio_User_Basic_Profile>;
  /** fetch aggregated fields from the table: "folio_user_basic_profile" */
  readonly folio_user_basic_profile_aggregate: Folio_User_Basic_Profile_Aggregate;
  /** fetch data from the table: "folio_user" using primary key columns */
  readonly folio_user_by_pk?: Maybe<Folio_User>;
  /** fetch data from the table: "geographical_region" */
  readonly geographical_region: ReadonlyArray<Geographical_Region>;
  /** fetch aggregated fields from the table: "geographical_region" */
  readonly geographical_region_aggregate: Geographical_Region_Aggregate;
  /** fetch data from the table: "geographical_region" using primary key columns */
  readonly geographical_region_by_pk?: Maybe<Geographical_Region>;
  /** fetch data from the table: "global_instrument" */
  readonly global_instrument: ReadonlyArray<Global_Instrument>;
  /** fetch aggregated fields from the table: "global_instrument" */
  readonly global_instrument_aggregate: Global_Instrument_Aggregate;
  /** fetch data from the table: "global_instrument" using primary key columns */
  readonly global_instrument_by_pk?: Maybe<Global_Instrument>;
  /** fetch data from the table: "global_package" */
  readonly global_package: ReadonlyArray<Global_Package>;
  /** fetch aggregated fields from the table: "global_package" */
  readonly global_package_aggregate: Global_Package_Aggregate;
  /** fetch data from the table: "global_package" using primary key columns */
  readonly global_package_by_pk?: Maybe<Global_Package>;
  /** fetch data from the table: "global_permission" */
  readonly global_permission: ReadonlyArray<Global_Permission>;
  /** fetch aggregated fields from the table: "global_permission" */
  readonly global_permission_aggregate: Global_Permission_Aggregate;
  /** fetch data from the table: "global_permission" using primary key columns */
  readonly global_permission_by_pk?: Maybe<Global_Permission>;
  /** fetch data from the table: "global_product" */
  readonly global_product: ReadonlyArray<Global_Product>;
  /** fetch aggregated fields from the table: "global_product" */
  readonly global_product_aggregate: Global_Product_Aggregate;
  /** fetch data from the table: "global_product" using primary key columns */
  readonly global_product_by_pk?: Maybe<Global_Product>;
  /** fetch data from the table: "global_product_config" */
  readonly global_product_config: ReadonlyArray<Global_Product_Config>;
  /** fetch aggregated fields from the table: "global_product_config" */
  readonly global_product_config_aggregate: Global_Product_Config_Aggregate;
  /** fetch data from the table: "global_product_config" using primary key columns */
  readonly global_product_config_by_pk?: Maybe<Global_Product_Config>;
  /** fetch data from the table: "grid_charts" */
  readonly grid_charts: ReadonlyArray<Grid_Charts>;
  /** fetch aggregated fields from the table: "grid_charts" */
  readonly grid_charts_aggregate: Grid_Charts_Aggregate;
  /** fetch data from the table: "grid_charts" using primary key columns */
  readonly grid_charts_by_pk?: Maybe<Grid_Charts>;
  /** fetch data from the table: "grid_settings" */
  readonly grid_settings: ReadonlyArray<Grid_Settings>;
  /** fetch aggregated fields from the table: "grid_settings" */
  readonly grid_settings_aggregate: Grid_Settings_Aggregate;
  /** fetch data from the table: "grid_settings" using primary key columns */
  readonly grid_settings_by_pk?: Maybe<Grid_Settings>;
  /** fetch data from the table: "hfc_card_settings" */
  readonly hfc_card_settings: ReadonlyArray<Hfc_Card_Settings>;
  /** fetch aggregated fields from the table: "hfc_card_settings" */
  readonly hfc_card_settings_aggregate: Hfc_Card_Settings_Aggregate;
  /** fetch data from the table: "hfc_card_settings" using primary key columns */
  readonly hfc_card_settings_by_pk?: Maybe<Hfc_Card_Settings>;
  /** fetch data from the table: "hfc_user_settings" */
  readonly hfc_user_settings: ReadonlyArray<Hfc_User_Settings>;
  /** fetch aggregated fields from the table: "hfc_user_settings" */
  readonly hfc_user_settings_aggregate: Hfc_User_Settings_Aggregate;
  /** fetch data from the table: "hfc_user_settings" using primary key columns */
  readonly hfc_user_settings_by_pk?: Maybe<Hfc_User_Settings>;
  /** fetch data from the table: "incident_banners" */
  readonly incident_banners: ReadonlyArray<Incident_Banners>;
  /** fetch aggregated fields from the table: "incident_banners" */
  readonly incident_banners_aggregate: Incident_Banners_Aggregate;
  /** fetch data from the table: "incident_banners" using primary key columns */
  readonly incident_banners_by_pk?: Maybe<Incident_Banners>;
  /** fetch data from the table: "live_chart_annotations" */
  readonly live_chart_annotations: ReadonlyArray<Live_Chart_Annotations>;
  /** fetch aggregated fields from the table: "live_chart_annotations" */
  readonly live_chart_annotations_aggregate: Live_Chart_Annotations_Aggregate;
  /** fetch data from the table: "live_chart_annotations" using primary key columns */
  readonly live_chart_annotations_by_pk?: Maybe<Live_Chart_Annotations>;
  /** fetch data from the table: "live_chart_page" */
  readonly live_chart_page: ReadonlyArray<Live_Chart_Page>;
  /** fetch aggregated fields from the table: "live_chart_page" */
  readonly live_chart_page_aggregate: Live_Chart_Page_Aggregate;
  /** fetch data from the table: "live_chart_page" using primary key columns */
  readonly live_chart_page_by_pk?: Maybe<Live_Chart_Page>;
  /** fetch data from the table: "live_chart_settings" */
  readonly live_chart_settings: ReadonlyArray<Live_Chart_Settings>;
  /** fetch aggregated fields from the table: "live_chart_settings" */
  readonly live_chart_settings_aggregate: Live_Chart_Settings_Aggregate;
  /** fetch data from the table: "live_chart_settings" using primary key columns */
  readonly live_chart_settings_by_pk?: Maybe<Live_Chart_Settings>;
  /** fetch data from the table: "live_users_new" */
  readonly live_users_new: ReadonlyArray<Live_Users_New>;
  /** fetch aggregated fields from the table: "live_users_new" */
  readonly live_users_new_aggregate: Live_Users_New_Aggregate;
  /** fetch data from the table: "local_instrument" */
  readonly local_instrument: ReadonlyArray<Local_Instrument>;
  /** fetch aggregated fields from the table: "local_instrument" */
  readonly local_instrument_aggregate: Local_Instrument_Aggregate;
  /** fetch data from the table: "local_instrument" using primary key columns */
  readonly local_instrument_by_pk?: Maybe<Local_Instrument>;
  /** fetch data from the table: "logout_request" */
  readonly logout_request: ReadonlyArray<Logout_Request>;
  /** fetch aggregated fields from the table: "logout_request" */
  readonly logout_request_aggregate: Logout_Request_Aggregate;
  /** fetch data from the table: "logout_request" using primary key columns */
  readonly logout_request_by_pk?: Maybe<Logout_Request>;
  /** fetch data from the table: "module_storage" */
  readonly module_storage: ReadonlyArray<Module_Storage>;
  /** fetch aggregated fields from the table: "module_storage" */
  readonly module_storage_aggregate: Module_Storage_Aggregate;
  /** fetch data from the table: "module_storage" using primary key columns */
  readonly module_storage_by_pk?: Maybe<Module_Storage>;
  /** fetch data from the table: "organisation" */
  readonly organisation: ReadonlyArray<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  readonly organisation_aggregate: Organisation_Aggregate;
  /** fetch data from the table: "organisation" using primary key columns */
  readonly organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table: "package" */
  readonly package: ReadonlyArray<Package>;
  /** fetch aggregated fields from the table: "package" */
  readonly package_aggregate: Package_Aggregate;
  /** fetch data from the table: "package" using primary key columns */
  readonly package_by_pk?: Maybe<Package>;
  /** fetch data from the table: "package_type" */
  readonly package_type: ReadonlyArray<Package_Type>;
  /** fetch aggregated fields from the table: "package_type" */
  readonly package_type_aggregate: Package_Type_Aggregate;
  /** fetch data from the table: "package_type" using primary key columns */
  readonly package_type_by_pk?: Maybe<Package_Type>;
  /** fetch data from the table: "page_member" */
  readonly page_member: ReadonlyArray<Page_Member>;
  /** fetch aggregated fields from the table: "page_member" */
  readonly page_member_aggregate: Page_Member_Aggregate;
  /** fetch data from the table: "page_member" using primary key columns */
  readonly page_member_by_pk?: Maybe<Page_Member>;
  /** An array relationship */
  readonly page_products: ReadonlyArray<Page_Products>;
  /** An aggregate relationship */
  readonly page_products_aggregate: Page_Products_Aggregate;
  /** fetch data from the table: "page_products" using primary key columns */
  readonly page_products_by_pk?: Maybe<Page_Products>;
  /** An array relationship */
  readonly page_settings: ReadonlyArray<Page_Settings>;
  /** An aggregate relationship */
  readonly page_settings_aggregate: Page_Settings_Aggregate;
  /** fetch data from the table: "page_settings" using primary key columns */
  readonly page_settings_by_pk?: Maybe<Page_Settings>;
  /** fetch data from the table: "pages" */
  readonly pages: ReadonlyArray<Pages>;
  /** fetch aggregated fields from the table: "pages" */
  readonly pages_aggregate: Pages_Aggregate;
  /** fetch data from the table: "pages" using primary key columns */
  readonly pages_by_pk?: Maybe<Pages>;
  /** fetch data from the table: "permission" */
  readonly permission: ReadonlyArray<Permission>;
  /** fetch aggregated fields from the table: "permission" */
  readonly permission_aggregate: Permission_Aggregate;
  /** fetch data from the table: "permission" using primary key columns */
  readonly permission_by_pk?: Maybe<Permission>;
  /** fetch data from the table: "product" */
  readonly product: ReadonlyArray<Product>;
  /** fetch aggregated fields from the table: "product" */
  readonly product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product_alerts" */
  readonly product_alerts: ReadonlyArray<Product_Alerts>;
  /** fetch aggregated fields from the table: "product_alerts" */
  readonly product_alerts_aggregate: Product_Alerts_Aggregate;
  /** fetch data from the table: "product_alerts" using primary key columns */
  readonly product_alerts_by_pk?: Maybe<Product_Alerts>;
  /** fetch data from the table: "product_artis_type" */
  readonly product_artis_type: ReadonlyArray<Product_Artis_Type>;
  /** fetch aggregated fields from the table: "product_artis_type" */
  readonly product_artis_type_aggregate: Product_Artis_Type_Aggregate;
  /** fetch data from the table: "product_artis_type" using primary key columns */
  readonly product_artis_type_by_pk?: Maybe<Product_Artis_Type>;
  /** fetch data from the table: "product" using primary key columns */
  readonly product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_config" */
  readonly product_config: ReadonlyArray<Product_Config>;
  /** fetch aggregated fields from the table: "product_config" */
  readonly product_config_aggregate: Product_Config_Aggregate;
  /** fetch data from the table: "product_config" using primary key columns */
  readonly product_config_by_pk?: Maybe<Product_Config>;
  /** fetch data from the table: "product_curve_type" */
  readonly product_curve_type: ReadonlyArray<Product_Curve_Type>;
  /** fetch aggregated fields from the table: "product_curve_type" */
  readonly product_curve_type_aggregate: Product_Curve_Type_Aggregate;
  /** fetch data from the table: "product_curve_type" using primary key columns */
  readonly product_curve_type_by_pk?: Maybe<Product_Curve_Type>;
  /** fetch data from the table: "product_eod" */
  readonly product_eod: ReadonlyArray<Product_Eod>;
  /** fetch aggregated fields from the table: "product_eod" */
  readonly product_eod_aggregate: Product_Eod_Aggregate;
  /** fetch data from the table: "product_eod" using primary key columns */
  readonly product_eod_by_pk?: Maybe<Product_Eod>;
  /** An array relationship */
  readonly product_global_dependencies: ReadonlyArray<Product_Global_Dependencies>;
  /** An aggregate relationship */
  readonly product_global_dependencies_aggregate: Product_Global_Dependencies_Aggregate;
  /** fetch data from the table: "product_global_dependencies" using primary key columns */
  readonly product_global_dependencies_by_pk?: Maybe<Product_Global_Dependencies>;
  /** fetch data from the table: "product_maturity" */
  readonly product_maturity: ReadonlyArray<Product_Maturity>;
  /** fetch aggregated fields from the table: "product_maturity" */
  readonly product_maturity_aggregate: Product_Maturity_Aggregate;
  /** fetch data from the table: "product_maturity" using primary key columns */
  readonly product_maturity_by_pk?: Maybe<Product_Maturity>;
  /** An array relationship */
  readonly product_overrides: ReadonlyArray<Product_Overrides>;
  /** An aggregate relationship */
  readonly product_overrides_aggregate: Product_Overrides_Aggregate;
  /** fetch data from the table: "product_overrides" using primary key columns */
  readonly product_overrides_by_pk?: Maybe<Product_Overrides>;
  /** fetch data from the table: "product_source" */
  readonly product_source: ReadonlyArray<Product_Source>;
  /** fetch aggregated fields from the table: "product_source" */
  readonly product_source_aggregate: Product_Source_Aggregate;
  /** fetch data from the table: "product_source" using primary key columns */
  readonly product_source_by_pk?: Maybe<Product_Source>;
  /** fetch data from the table: "product_summary_type" */
  readonly product_summary_type: ReadonlyArray<Product_Summary_Type>;
  /** fetch aggregated fields from the table: "product_summary_type" */
  readonly product_summary_type_aggregate: Product_Summary_Type_Aggregate;
  /** fetch data from the table: "product_summary_type" using primary key columns */
  readonly product_summary_type_by_pk?: Maybe<Product_Summary_Type>;
  /** fetch data from the table: "product_type" */
  readonly product_type: ReadonlyArray<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  readonly product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  readonly product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table: "product_uom" */
  readonly product_uom: ReadonlyArray<Product_Uom>;
  /** fetch aggregated fields from the table: "product_uom" */
  readonly product_uom_aggregate: Product_Uom_Aggregate;
  /** fetch data from the table: "product_uom" using primary key columns */
  readonly product_uom_by_pk?: Maybe<Product_Uom>;
  /** fetch data from the table: "product_user_settings" */
  readonly product_user_settings: ReadonlyArray<Product_User_Settings>;
  /** fetch aggregated fields from the table: "product_user_settings" */
  readonly product_user_settings_aggregate: Product_User_Settings_Aggregate;
  /** fetch data from the table: "product_user_settings" using primary key columns */
  readonly product_user_settings_by_pk?: Maybe<Product_User_Settings>;
  /** fetch data from the table: "push_subscriptions" */
  readonly push_subscriptions: ReadonlyArray<Push_Subscriptions>;
  /** fetch aggregated fields from the table: "push_subscriptions" */
  readonly push_subscriptions_aggregate: Push_Subscriptions_Aggregate;
  /** fetch data from the table: "push_subscriptions" using primary key columns */
  readonly push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** fetch data from the table: "quick_access" */
  readonly quick_access: ReadonlyArray<Quick_Access>;
  /** fetch aggregated fields from the table: "quick_access" */
  readonly quick_access_aggregate: Quick_Access_Aggregate;
  /** fetch data from the table: "quick_access" using primary key columns */
  readonly quick_access_by_pk?: Maybe<Quick_Access>;
  /** fetch data from the table: "scratchpad" */
  readonly scratchpad: ReadonlyArray<Scratchpad>;
  /** fetch aggregated fields from the table: "scratchpad" */
  readonly scratchpad_aggregate: Scratchpad_Aggregate;
  /** fetch data from the table: "scratchpad" using primary key columns */
  readonly scratchpad_by_pk?: Maybe<Scratchpad>;
  /** fetch data from the table: "session" */
  readonly session: ReadonlyArray<Session>;
  /** fetch aggregated fields from the table: "session" */
  readonly session_aggregate: Session_Aggregate;
  /** fetch data from the table: "session" using primary key columns */
  readonly session_by_pk?: Maybe<Session>;
  /** fetch data from the table: "session_type" */
  readonly session_type: ReadonlyArray<Session_Type>;
  /** fetch aggregated fields from the table: "session_type" */
  readonly session_type_aggregate: Session_Type_Aggregate;
  /** fetch data from the table: "session_type" using primary key columns */
  readonly session_type_by_pk?: Maybe<Session_Type>;
  /** fetch data from the table: "shared_instrument" */
  readonly shared_instrument: ReadonlyArray<Shared_Instrument>;
  /** fetch aggregated fields from the table: "shared_instrument" */
  readonly shared_instrument_aggregate: Shared_Instrument_Aggregate;
  /** fetch data from the table: "shared_instrument" using primary key columns */
  readonly shared_instrument_by_pk?: Maybe<Shared_Instrument>;
  /** fetch data from the table: "sharing_agreement" */
  readonly sharing_agreement: ReadonlyArray<Sharing_Agreement>;
  /** fetch aggregated fields from the table: "sharing_agreement" */
  readonly sharing_agreement_aggregate: Sharing_Agreement_Aggregate;
  /** fetch data from the table: "sharing_agreement" using primary key columns */
  readonly sharing_agreement_by_pk?: Maybe<Sharing_Agreement>;
  /** fetch data from the table: "source" */
  readonly source: ReadonlyArray<Source>;
  /** fetch aggregated fields from the table: "source" */
  readonly source_aggregate: Source_Aggregate;
  /** fetch data from the table: "source" using primary key columns */
  readonly source_by_pk?: Maybe<Source>;
  /** fetch data from the table: "spreader_state" */
  readonly spreader_state: ReadonlyArray<Spreader_State>;
  /** fetch aggregated fields from the table: "spreader_state" */
  readonly spreader_state_aggregate: Spreader_State_Aggregate;
  /** fetch data from the table: "spreader_state" using primary key columns */
  readonly spreader_state_by_pk?: Maybe<Spreader_State>;
  /** fetch data from the table: "subscription_tier" */
  readonly subscription_tier: ReadonlyArray<Subscription_Tier>;
  /** fetch aggregated fields from the table: "subscription_tier" */
  readonly subscription_tier_aggregate: Subscription_Tier_Aggregate;
  /** fetch data from the table: "subscription_tier" using primary key columns */
  readonly subscription_tier_by_pk?: Maybe<Subscription_Tier>;
  /** An array relationship */
  readonly umi_action: ReadonlyArray<Umi_Action>;
  /** An aggregate relationship */
  readonly umi_action_aggregate: Umi_Action_Aggregate;
  /** fetch data from the table: "umi_action" using primary key columns */
  readonly umi_action_by_pk?: Maybe<Umi_Action>;
  /** fetch data from the table: "umi_action_name" */
  readonly umi_action_name: ReadonlyArray<Umi_Action_Name>;
  /** fetch aggregated fields from the table: "umi_action_name" */
  readonly umi_action_name_aggregate: Umi_Action_Name_Aggregate;
  /** fetch data from the table: "umi_action_name" using primary key columns */
  readonly umi_action_name_by_pk?: Maybe<Umi_Action_Name>;
  /** fetch data from the table: "user_entitlement" */
  readonly user_entitlement: ReadonlyArray<User_Entitlement>;
  /** fetch data from the table: "user_entitlement_active" */
  readonly user_entitlement_active: ReadonlyArray<User_Entitlement_Active>;
  /** fetch aggregated fields from the table: "user_entitlement_active" */
  readonly user_entitlement_active_aggregate: User_Entitlement_Active_Aggregate;
  /** fetch aggregated fields from the table: "user_entitlement" */
  readonly user_entitlement_aggregate: User_Entitlement_Aggregate;
  /** fetch data from the table: "user_entitlement" using primary key columns */
  readonly user_entitlement_by_pk?: Maybe<User_Entitlement>;
  /** fetch data from the table: "user_entitlement_kind" */
  readonly user_entitlement_kind: ReadonlyArray<User_Entitlement_Kind>;
  /** fetch aggregated fields from the table: "user_entitlement_kind" */
  readonly user_entitlement_kind_aggregate: User_Entitlement_Kind_Aggregate;
  /** fetch data from the table: "user_entitlement_kind" using primary key columns */
  readonly user_entitlement_kind_by_pk?: Maybe<User_Entitlement_Kind>;
  /** fetch data from the table: "user_entitlement_level" */
  readonly user_entitlement_level: ReadonlyArray<User_Entitlement_Level>;
  /** fetch aggregated fields from the table: "user_entitlement_level" */
  readonly user_entitlement_level_aggregate: User_Entitlement_Level_Aggregate;
  /** fetch data from the table: "user_entitlement_level" using primary key columns */
  readonly user_entitlement_level_by_pk?: Maybe<User_Entitlement_Level>;
  /** fetch data from the table: "user_groups" */
  readonly user_groups: ReadonlyArray<User_Groups>;
  /** fetch aggregated fields from the table: "user_groups" */
  readonly user_groups_aggregate: User_Groups_Aggregate;
  /** fetch data from the table: "user_groups" using primary key columns */
  readonly user_groups_by_pk?: Maybe<User_Groups>;
  /** fetch data from the table: "user_right" */
  readonly user_right: ReadonlyArray<User_Right>;
  /** fetch aggregated fields from the table: "user_right" */
  readonly user_right_aggregate: User_Right_Aggregate;
  /** fetch data from the table: "user_right" using primary key columns */
  readonly user_right_by_pk?: Maybe<User_Right>;
  /** fetch data from the table: "user_storage" */
  readonly user_storage: ReadonlyArray<User_Storage>;
  /** fetch aggregated fields from the table: "user_storage" */
  readonly user_storage_aggregate: User_Storage_Aggregate;
  /** fetch data from the table: "user_storage" using primary key columns */
  readonly user_storage_by_pk?: Maybe<User_Storage>;
  /** fetch data from the table: "users_active_last_day" */
  readonly users_active_last_day: ReadonlyArray<Users_Active_Last_Day>;
  /** fetch aggregated fields from the table: "users_active_last_day" */
  readonly users_active_last_day_aggregate: Users_Active_Last_Day_Aggregate;
  /** fetch data from the table: "viewed_announcements" */
  readonly viewed_announcements: ReadonlyArray<Viewed_Announcements>;
  /** fetch aggregated fields from the table: "viewed_announcements" */
  readonly viewed_announcements_aggregate: Viewed_Announcements_Aggregate;
  /** fetch data from the table: "viewed_announcements" using primary key columns */
  readonly viewed_announcements_by_pk?: Maybe<Viewed_Announcements>;
};


export type Query_RootAlertsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Query_RootAlerts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Query_RootAlerts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAudit_Logged_ActionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Query_RootAudit_Logged_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Query_RootAudit_Logged_Actions_By_PkArgs = {
  event_id: Scalars['bigint']['input'];
};


export type Query_RootAudit_Umi_ActionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Order_By>>;
  where?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
};


export type Query_RootAudit_Umi_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Order_By>>;
  where?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
};


export type Query_RootAudit_Umi_Actions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCommodity_GroupArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Group_Order_By>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};


export type Query_RootCommodity_Group_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Group_Order_By>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};


export type Query_RootCommodity_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCommodity_Parent_GroupArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Order_By>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


export type Query_RootCommodity_Parent_Group_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Order_By>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


export type Query_RootCommodity_Parent_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootConditional_Formatting_RulesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Order_By>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


export type Query_RootConditional_Formatting_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Order_By>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


export type Query_RootConditional_Formatting_Rules_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootEodArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Order_By>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


export type Query_RootEod_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Order_By>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


export type Query_RootEod_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEod_EntryArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Entry_Order_By>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


export type Query_RootEod_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Entry_Order_By>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


export type Query_RootEod_Entry_By_PkArgs = {
  evaluation_date: Scalars['date']['input'];
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
};


export type Query_RootExchangeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Order_By>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


export type Query_RootExchange_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Order_By>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


export type Query_RootExchange_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExchange_Event_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Order_By>>;
  where?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
};


export type Query_RootExchange_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Order_By>>;
  where?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
};


export type Query_RootExchange_Event_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootExchange_UsageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


export type Query_RootExchange_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


export type Query_RootExchange_Usage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExchange_Usage_LastArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Last_Bool_Exp>;
};


export type Query_RootExchange_Usage_Last_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Last_Bool_Exp>;
};


export type Query_RootExchange_Usage_StartArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Start_Bool_Exp>;
};


export type Query_RootExchange_Usage_Start_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Start_Bool_Exp>;
};


export type Query_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolio_Shadow_CurvesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Order_By>>;
  where?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
};


export type Query_RootFolio_Shadow_Curves_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Order_By>>;
  where?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
};


export type Query_RootFolio_Shadow_Curves_By_PkArgs = {
  folio_user: Scalars['String']['input'];
};


export type Query_RootFolio_UserArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


export type Query_RootFolio_User_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


export type Query_RootFolio_User_Basic_ProfileArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Order_By>>;
  where?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
};


export type Query_RootFolio_User_Basic_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Order_By>>;
  where?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
};


export type Query_RootFolio_User_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootGeographical_RegionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Geographical_Region_Order_By>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


export type Query_RootGeographical_Region_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Geographical_Region_Order_By>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


export type Query_RootGeographical_Region_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGlobal_InstrumentArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Instrument_Order_By>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


export type Query_RootGlobal_Instrument_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Instrument_Order_By>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


export type Query_RootGlobal_Instrument_By_PkArgs = {
  global_product: Scalars['uuid']['input'];
  month: Scalars['date']['input'];
};


export type Query_RootGlobal_PackageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Package_Order_By>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


export type Query_RootGlobal_Package_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Package_Order_By>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


export type Query_RootGlobal_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGlobal_PermissionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


export type Query_RootGlobal_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


export type Query_RootGlobal_Permission_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  global_package: Scalars['Int']['input'];
};


export type Query_RootGlobal_ProductArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


export type Query_RootGlobal_Product_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


export type Query_RootGlobal_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGlobal_Product_ConfigArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Config_Order_By>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};


export type Query_RootGlobal_Product_Config_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Config_Order_By>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};


export type Query_RootGlobal_Product_Config_By_PkArgs = {
  product: Scalars['uuid']['input'];
  relative_month: Scalars['Int']['input'];
};


export type Query_RootGrid_ChartsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Charts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Charts_Order_By>>;
  where?: InputMaybe<Grid_Charts_Bool_Exp>;
};


export type Query_RootGrid_Charts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Charts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Charts_Order_By>>;
  where?: InputMaybe<Grid_Charts_Bool_Exp>;
};


export type Query_RootGrid_Charts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootGrid_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Settings_Order_By>>;
  where?: InputMaybe<Grid_Settings_Bool_Exp>;
};


export type Query_RootGrid_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Settings_Order_By>>;
  where?: InputMaybe<Grid_Settings_Bool_Exp>;
};


export type Query_RootGrid_Settings_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


export type Query_RootHfc_Card_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Order_By>>;
  where?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
};


export type Query_RootHfc_Card_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Order_By>>;
  where?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
};


export type Query_RootHfc_Card_Settings_By_PkArgs = {
  user: Scalars['String']['input'];
};


export type Query_RootHfc_User_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Order_By>>;
  where?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
};


export type Query_RootHfc_User_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Order_By>>;
  where?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
};


export type Query_RootHfc_User_Settings_By_PkArgs = {
  user: Scalars['String']['input'];
};


export type Query_RootIncident_BannersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Incident_Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Incident_Banners_Order_By>>;
  where?: InputMaybe<Incident_Banners_Bool_Exp>;
};


export type Query_RootIncident_Banners_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Incident_Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Incident_Banners_Order_By>>;
  where?: InputMaybe<Incident_Banners_Bool_Exp>;
};


export type Query_RootIncident_Banners_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootLive_Chart_AnnotationsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Order_By>>;
  where?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
};


export type Query_RootLive_Chart_Annotations_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Order_By>>;
  where?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
};


export type Query_RootLive_Chart_Annotations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootLive_Chart_PageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Page_Order_By>>;
  where?: InputMaybe<Live_Chart_Page_Bool_Exp>;
};


export type Query_RootLive_Chart_Page_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Page_Order_By>>;
  where?: InputMaybe<Live_Chart_Page_Bool_Exp>;
};


export type Query_RootLive_Chart_Page_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootLive_Chart_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Order_By>>;
  where?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
};


export type Query_RootLive_Chart_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Order_By>>;
  where?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
};


export type Query_RootLive_Chart_Settings_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


export type Query_RootLive_Users_NewArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Users_New_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Users_New_Order_By>>;
  where?: InputMaybe<Live_Users_New_Bool_Exp>;
};


export type Query_RootLive_Users_New_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Users_New_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Users_New_Order_By>>;
  where?: InputMaybe<Live_Users_New_Bool_Exp>;
};


export type Query_RootLocal_InstrumentArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


export type Query_RootLocal_Instrument_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


export type Query_RootLocal_Instrument_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
  storage_type: User_Storage_Enum;
};


export type Query_RootLogout_RequestArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


export type Query_RootLogout_Request_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


export type Query_RootLogout_Request_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootModule_StorageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Module_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Module_Storage_Order_By>>;
  where?: InputMaybe<Module_Storage_Bool_Exp>;
};


export type Query_RootModule_Storage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Module_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Module_Storage_Order_By>>;
  where?: InputMaybe<Module_Storage_Bool_Exp>;
};


export type Query_RootModule_Storage_By_PkArgs = {
  key: Scalars['String']['input'];
  module: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type Query_RootOrganisationArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPackageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


export type Query_RootPackage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


export type Query_RootPackage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPackage_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Type_Order_By>>;
  where?: InputMaybe<Package_Type_Bool_Exp>;
};


export type Query_RootPackage_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Type_Order_By>>;
  where?: InputMaybe<Package_Type_Bool_Exp>;
};


export type Query_RootPackage_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPage_MemberArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


export type Query_RootPage_Member_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


export type Query_RootPage_Member_By_PkArgs = {
  page_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type Query_RootPage_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Products_Order_By>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


export type Query_RootPage_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Products_Order_By>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


export type Query_RootPage_Products_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPage_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Settings_Order_By>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


export type Query_RootPage_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Settings_Order_By>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


export type Query_RootPage_Settings_By_PkArgs = {
  folio_user: Scalars['String']['input'];
};


export type Query_RootPagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Query_RootPages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Query_RootPages_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPermissionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Query_RootPermission_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Query_RootPermission_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  package: Scalars['Int']['input'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AlertsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Alerts_Order_By>>;
  where?: InputMaybe<Product_Alerts_Bool_Exp>;
};


export type Query_RootProduct_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Alerts_Order_By>>;
  where?: InputMaybe<Product_Alerts_Bool_Exp>;
};


export type Query_RootProduct_Alerts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootProduct_Artis_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Artis_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Artis_Type_Order_By>>;
  where?: InputMaybe<Product_Artis_Type_Bool_Exp>;
};


export type Query_RootProduct_Artis_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Artis_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Artis_Type_Order_By>>;
  where?: InputMaybe<Product_Artis_Type_Bool_Exp>;
};


export type Query_RootProduct_Artis_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_ConfigArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Config_Order_By>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


export type Query_RootProduct_Config_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Config_Order_By>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


export type Query_RootProduct_Config_By_PkArgs = {
  product: Scalars['uuid']['input'];
  relative_month: Scalars['Int']['input'];
};


export type Query_RootProduct_Curve_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Curve_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Curve_Type_Order_By>>;
  where?: InputMaybe<Product_Curve_Type_Bool_Exp>;
};


export type Query_RootProduct_Curve_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Curve_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Curve_Type_Order_By>>;
  where?: InputMaybe<Product_Curve_Type_Bool_Exp>;
};


export type Query_RootProduct_Curve_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_EodArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


export type Query_RootProduct_Eod_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


export type Query_RootProduct_Eod_By_PkArgs = {
  eod_product: Scalars['uuid']['input'];
  product: Scalars['uuid']['input'];
};


export type Query_RootProduct_Global_DependenciesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Order_By>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


export type Query_RootProduct_Global_Dependencies_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Order_By>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


export type Query_RootProduct_Global_Dependencies_By_PkArgs = {
  global_product: Scalars['uuid']['input'];
  product: Scalars['uuid']['input'];
};


export type Query_RootProduct_MaturityArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Maturity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Maturity_Order_By>>;
  where?: InputMaybe<Product_Maturity_Bool_Exp>;
};


export type Query_RootProduct_Maturity_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Maturity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Maturity_Order_By>>;
  where?: InputMaybe<Product_Maturity_Bool_Exp>;
};


export type Query_RootProduct_Maturity_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_OverridesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


export type Query_RootProduct_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


export type Query_RootProduct_Overrides_By_PkArgs = {
  organisation: Scalars['Int']['input'];
  product: Scalars['uuid']['input'];
};


export type Query_RootProduct_SourceArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Source_Order_By>>;
  where?: InputMaybe<Product_Source_Bool_Exp>;
};


export type Query_RootProduct_Source_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Source_Order_By>>;
  where?: InputMaybe<Product_Source_Bool_Exp>;
};


export type Query_RootProduct_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_Summary_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Summary_Type_Order_By>>;
  where?: InputMaybe<Product_Summary_Type_Bool_Exp>;
};


export type Query_RootProduct_Summary_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Summary_Type_Order_By>>;
  where?: InputMaybe<Product_Summary_Type_Bool_Exp>;
};


export type Query_RootProduct_Summary_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_UomArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Uom_Order_By>>;
  where?: InputMaybe<Product_Uom_Bool_Exp>;
};


export type Query_RootProduct_Uom_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Uom_Order_By>>;
  where?: InputMaybe<Product_Uom_Bool_Exp>;
};


export type Query_RootProduct_Uom_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_User_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_User_Settings_Order_By>>;
  where?: InputMaybe<Product_User_Settings_Bool_Exp>;
};


export type Query_RootProduct_User_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_User_Settings_Order_By>>;
  where?: InputMaybe<Product_User_Settings_Bool_Exp>;
};


export type Query_RootProduct_User_Settings_By_PkArgs = {
  product_id: Scalars['uuid']['input'];
  user_id: Scalars['String']['input'];
};


export type Query_RootPush_SubscriptionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Push_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Push_Subscriptions_Order_By>>;
  where?: InputMaybe<Push_Subscriptions_Bool_Exp>;
};


export type Query_RootPush_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Push_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Push_Subscriptions_Order_By>>;
  where?: InputMaybe<Push_Subscriptions_Bool_Exp>;
};


export type Query_RootPush_Subscriptions_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


export type Query_RootQuick_AccessArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Quick_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Quick_Access_Order_By>>;
  where?: InputMaybe<Quick_Access_Bool_Exp>;
};


export type Query_RootQuick_Access_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Quick_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Quick_Access_Order_By>>;
  where?: InputMaybe<Quick_Access_Bool_Exp>;
};


export type Query_RootQuick_Access_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootScratchpadArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Scratchpad_Order_By>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


export type Query_RootScratchpad_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Scratchpad_Order_By>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


export type Query_RootScratchpad_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  page_id: Scalars['String']['input'];
};


export type Query_RootSessionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Order_By>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


export type Query_RootSession_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Order_By>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


export type Query_RootSession_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  is_mobile: Scalars['Boolean']['input'];
};


export type Query_RootSession_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Type_Order_By>>;
  where?: InputMaybe<Session_Type_Bool_Exp>;
};


export type Query_RootSession_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Type_Order_By>>;
  where?: InputMaybe<Session_Type_Bool_Exp>;
};


export type Query_RootSession_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootShared_InstrumentArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


export type Query_RootShared_Instrument_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


export type Query_RootShared_Instrument_By_PkArgs = {
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
};


export type Query_RootSharing_AgreementArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


export type Query_RootSharing_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


export type Query_RootSharing_Agreement_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSourceArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Source_Order_By>>;
  where?: InputMaybe<Source_Bool_Exp>;
};


export type Query_RootSource_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Source_Order_By>>;
  where?: InputMaybe<Source_Bool_Exp>;
};


export type Query_RootSource_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSpreader_StateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Spreader_State_Order_By>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};


export type Query_RootSpreader_State_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Spreader_State_Order_By>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};


export type Query_RootSpreader_State_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootSubscription_TierArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Subscription_Tier_Order_By>>;
  where?: InputMaybe<Subscription_Tier_Bool_Exp>;
};


export type Query_RootSubscription_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Subscription_Tier_Order_By>>;
  where?: InputMaybe<Subscription_Tier_Bool_Exp>;
};


export type Query_RootSubscription_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUmi_ActionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Order_By>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};


export type Query_RootUmi_Action_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Order_By>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};


export type Query_RootUmi_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUmi_Action_NameArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Name_Order_By>>;
  where?: InputMaybe<Umi_Action_Name_Bool_Exp>;
};


export type Query_RootUmi_Action_Name_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Name_Order_By>>;
  where?: InputMaybe<Umi_Action_Name_Bool_Exp>;
};


export type Query_RootUmi_Action_Name_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_EntitlementArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


export type Query_RootUser_Entitlement_ActiveArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Order_By>>;
  where?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
};


export type Query_RootUser_Entitlement_Active_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Order_By>>;
  where?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
};


export type Query_RootUser_Entitlement_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


export type Query_RootUser_Entitlement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Entitlement_KindArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Order_By>>;
  where?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
};


export type Query_RootUser_Entitlement_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Order_By>>;
  where?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
};


export type Query_RootUser_Entitlement_Kind_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_Entitlement_LevelArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Order_By>>;
  where?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
};


export type Query_RootUser_Entitlement_Level_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Order_By>>;
  where?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
};


export type Query_RootUser_Entitlement_Level_By_PkArgs = {
  level: Scalars['smallint']['input'];
};


export type Query_RootUser_GroupsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Groups_Order_By>>;
  where?: InputMaybe<User_Groups_Bool_Exp>;
};


export type Query_RootUser_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Groups_Order_By>>;
  where?: InputMaybe<User_Groups_Bool_Exp>;
};


export type Query_RootUser_Groups_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootUser_RightArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Right_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Right_Order_By>>;
  where?: InputMaybe<User_Right_Bool_Exp>;
};


export type Query_RootUser_Right_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Right_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Right_Order_By>>;
  where?: InputMaybe<User_Right_Bool_Exp>;
};


export type Query_RootUser_Right_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_StorageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Storage_Order_By>>;
  where?: InputMaybe<User_Storage_Bool_Exp>;
};


export type Query_RootUser_Storage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Storage_Order_By>>;
  where?: InputMaybe<User_Storage_Bool_Exp>;
};


export type Query_RootUser_Storage_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUsers_Active_Last_DayArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Order_By>>;
  where?: InputMaybe<Users_Active_Last_Day_Bool_Exp>;
};


export type Query_RootUsers_Active_Last_Day_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Order_By>>;
  where?: InputMaybe<Users_Active_Last_Day_Bool_Exp>;
};


export type Query_RootViewed_AnnouncementsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Viewed_Announcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Viewed_Announcements_Order_By>>;
  where?: InputMaybe<Viewed_Announcements_Bool_Exp>;
};


export type Query_RootViewed_Announcements_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Viewed_Announcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Viewed_Announcements_Order_By>>;
  where?: InputMaybe<Viewed_Announcements_Bool_Exp>;
};


export type Query_RootViewed_Announcements_By_PkArgs = {
  id: Scalars['String']['input'];
};

/** columns and relationships of "quick_access" */
export type Quick_Access = {
  readonly __typename?: 'quick_access';
  readonly column_id: Scalars['String']['output'];
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly id: Scalars['String']['output'];
  /** An object relationship */
  readonly pageByPageId: Pages;
  /** An object relationship */
  readonly pageProductByColumnId: Page_Products;
  readonly page_id: Scalars['String']['output'];
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly shortcut_number: Scalars['Int']['output'];
  readonly user_id: Scalars['String']['output'];
};

/** aggregated selection of "quick_access" */
export type Quick_Access_Aggregate = {
  readonly __typename?: 'quick_access_aggregate';
  readonly aggregate?: Maybe<Quick_Access_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Quick_Access>;
};

/** aggregate fields of "quick_access" */
export type Quick_Access_Aggregate_Fields = {
  readonly __typename?: 'quick_access_aggregate_fields';
  readonly avg?: Maybe<Quick_Access_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Quick_Access_Max_Fields>;
  readonly min?: Maybe<Quick_Access_Min_Fields>;
  readonly stddev?: Maybe<Quick_Access_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Quick_Access_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Quick_Access_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Quick_Access_Sum_Fields>;
  readonly var_pop?: Maybe<Quick_Access_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Quick_Access_Var_Samp_Fields>;
  readonly variance?: Maybe<Quick_Access_Variance_Fields>;
};


/** aggregate fields of "quick_access" */
export type Quick_Access_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Quick_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quick_Access_Avg_Fields = {
  readonly __typename?: 'quick_access_avg_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quick_access". All fields are combined with a logical 'AND'. */
export type Quick_Access_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Quick_Access_Bool_Exp>>;
  readonly _not?: InputMaybe<Quick_Access_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Quick_Access_Bool_Exp>>;
  readonly column_id?: InputMaybe<String_Comparison_Exp>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly pageByPageId?: InputMaybe<Pages_Bool_Exp>;
  readonly pageProductByColumnId?: InputMaybe<Page_Products_Bool_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly product_id?: InputMaybe<String_Comparison_Exp>;
  readonly shortcut_number?: InputMaybe<Int_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quick_access" */
export type Quick_Access_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'quick_access_pkey';

/** input type for incrementing numeric columns in table "quick_access" */
export type Quick_Access_Inc_Input = {
  readonly shortcut_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quick_access" */
export type Quick_Access_Insert_Input = {
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly pageByPageId?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly pageProductByColumnId?: InputMaybe<Page_Products_Obj_Rel_Insert_Input>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly shortcut_number?: InputMaybe<Scalars['Int']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quick_Access_Max_Fields = {
  readonly __typename?: 'quick_access_max_fields';
  readonly column_id?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly shortcut_number?: Maybe<Scalars['Int']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quick_Access_Min_Fields = {
  readonly __typename?: 'quick_access_min_fields';
  readonly column_id?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly product_id?: Maybe<Scalars['String']['output']>;
  readonly shortcut_number?: Maybe<Scalars['Int']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quick_access" */
export type Quick_Access_Mutation_Response = {
  readonly __typename?: 'quick_access_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Quick_Access>;
};

/** on_conflict condition type for table "quick_access" */
export type Quick_Access_On_Conflict = {
  readonly constraint: Quick_Access_Constraint;
  readonly update_columns?: ReadonlyArray<Quick_Access_Update_Column>;
  readonly where?: InputMaybe<Quick_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "quick_access". */
export type Quick_Access_Order_By = {
  readonly column_id?: InputMaybe<Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly pageByPageId?: InputMaybe<Pages_Order_By>;
  readonly pageProductByColumnId?: InputMaybe<Page_Products_Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly product_id?: InputMaybe<Order_By>;
  readonly shortcut_number?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quick_access */
export type Quick_Access_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "quick_access" */
export type Quick_Access_Select_Column =
  /** column name */
  | 'column_id'
  /** column name */
  | 'id'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'shortcut_number'
  /** column name */
  | 'user_id';

/** input type for updating data in table "quick_access" */
export type Quick_Access_Set_Input = {
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly shortcut_number?: InputMaybe<Scalars['Int']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Quick_Access_Stddev_Fields = {
  readonly __typename?: 'quick_access_stddev_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quick_Access_Stddev_Pop_Fields = {
  readonly __typename?: 'quick_access_stddev_pop_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quick_Access_Stddev_Samp_Fields = {
  readonly __typename?: 'quick_access_stddev_samp_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quick_access" */
export type Quick_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Quick_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quick_Access_Stream_Cursor_Value_Input = {
  readonly column_id?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly product_id?: InputMaybe<Scalars['String']['input']>;
  readonly shortcut_number?: InputMaybe<Scalars['Int']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Quick_Access_Sum_Fields = {
  readonly __typename?: 'quick_access_sum_fields';
  readonly shortcut_number?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "quick_access" */
export type Quick_Access_Update_Column =
  /** column name */
  | 'column_id'
  /** column name */
  | 'id'
  /** column name */
  | 'page_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'shortcut_number'
  /** column name */
  | 'user_id';

export type Quick_Access_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Quick_Access_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Quick_Access_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Quick_Access_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quick_Access_Var_Pop_Fields = {
  readonly __typename?: 'quick_access_var_pop_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quick_Access_Var_Samp_Fields = {
  readonly __typename?: 'quick_access_var_samp_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quick_Access_Variance_Fields = {
  readonly __typename?: 'quick_access_variance_fields';
  readonly shortcut_number?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "range_summary_calc_enum". All fields are combined with logical 'AND'. */
export type Range_Summary_Calc_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly _gt?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly _gte?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['range_summary_calc_enum']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly _lte?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly _neq?: InputMaybe<Scalars['range_summary_calc_enum']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['range_summary_calc_enum']['input']>>;
};

/** For the data json needed in scratchpad. */
export type Scratchpad = {
  readonly __typename?: 'scratchpad';
  readonly created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly folio_user: Scalars['String']['output'];
  readonly page_id: Scalars['String']['output'];
  readonly state?: Maybe<Scalars['jsonb']['output']>;
  readonly style?: Maybe<Scalars['jsonb']['output']>;
  readonly updated_at: Scalars['timestamptz']['output'];
  readonly user_updated_at: Scalars['timestamptz']['output'];
};


/** For the data json needed in scratchpad. */
export type ScratchpadStateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** For the data json needed in scratchpad. */
export type ScratchpadStyleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "scratchpad" */
export type Scratchpad_Aggregate = {
  readonly __typename?: 'scratchpad_aggregate';
  readonly aggregate?: Maybe<Scratchpad_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Scratchpad>;
};

export type Scratchpad_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Scratchpad_Aggregate_Bool_Exp_Count>;
};

export type Scratchpad_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Scratchpad_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scratchpad" */
export type Scratchpad_Aggregate_Fields = {
  readonly __typename?: 'scratchpad_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Scratchpad_Max_Fields>;
  readonly min?: Maybe<Scratchpad_Min_Fields>;
};


/** aggregate fields of "scratchpad" */
export type Scratchpad_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scratchpad" */
export type Scratchpad_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Scratchpad_Max_Order_By>;
  readonly min?: InputMaybe<Scratchpad_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scratchpad_Append_Input = {
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly style?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "scratchpad" */
export type Scratchpad_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Scratchpad_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Scratchpad_On_Conflict>;
};

/** Boolean expression to filter rows from the table "scratchpad". All fields are combined with a logical 'AND'. */
export type Scratchpad_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Scratchpad_Bool_Exp>>;
  readonly _not?: InputMaybe<Scratchpad_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Scratchpad_Bool_Exp>>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly state?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly style?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "scratchpad" */
export type Scratchpad_Constraint =
  /** unique or primary key constraint on columns "page_id", "folio_user" */
  | 'scratchpad_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scratchpad_Delete_At_Path_Input = {
  readonly state?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly style?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scratchpad_Delete_Elem_Input = {
  readonly state?: InputMaybe<Scalars['Int']['input']>;
  readonly style?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scratchpad_Delete_Key_Input = {
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly style?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "scratchpad" */
export type Scratchpad_Insert_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly style?: InputMaybe<Scalars['jsonb']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scratchpad_Max_Fields = {
  readonly __typename?: 'scratchpad_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scratchpad" */
export type Scratchpad_Max_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scratchpad_Min_Fields = {
  readonly __typename?: 'scratchpad_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scratchpad" */
export type Scratchpad_Min_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scratchpad" */
export type Scratchpad_Mutation_Response = {
  readonly __typename?: 'scratchpad_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Scratchpad>;
};

/** on_conflict condition type for table "scratchpad" */
export type Scratchpad_On_Conflict = {
  readonly constraint: Scratchpad_Constraint;
  readonly update_columns?: ReadonlyArray<Scratchpad_Update_Column>;
  readonly where?: InputMaybe<Scratchpad_Bool_Exp>;
};

/** Ordering options when selecting data from "scratchpad". */
export type Scratchpad_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly state?: InputMaybe<Order_By>;
  readonly style?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scratchpad */
export type Scratchpad_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
  readonly page_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scratchpad_Prepend_Input = {
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly style?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "scratchpad" */
export type Scratchpad_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'page_id'
  /** column name */
  | 'state'
  /** column name */
  | 'style'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_updated_at';

/** input type for updating data in table "scratchpad" */
export type Scratchpad_Set_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly style?: InputMaybe<Scalars['jsonb']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "scratchpad" */
export type Scratchpad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Scratchpad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scratchpad_Stream_Cursor_Value_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['jsonb']['input']>;
  readonly style?: InputMaybe<Scalars['jsonb']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "scratchpad" */
export type Scratchpad_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'page_id'
  /** column name */
  | 'state'
  /** column name */
  | 'style'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_updated_at';

export type Scratchpad_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Scratchpad_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Scratchpad_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Scratchpad_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Scratchpad_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Scratchpad_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Scratchpad_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Scratchpad_Bool_Exp;
};

/** Stores data about user sessions and when they were last seen - we only allow one mobile and one desktop/non-mobile session per user. */
export type Session = {
  readonly __typename?: 'session';
  readonly excel: Scalars['Boolean']['output'];
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly folio_user: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly is_mobile: Scalars['Boolean']['output'];
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly session_start?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "session" */
export type Session_Aggregate = {
  readonly __typename?: 'session_aggregate';
  readonly aggregate?: Maybe<Session_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Session>;
};

export type Session_Aggregate_Bool_Exp = {
  readonly bool_and?: InputMaybe<Session_Aggregate_Bool_Exp_Bool_And>;
  readonly bool_or?: InputMaybe<Session_Aggregate_Bool_Exp_Bool_Or>;
  readonly count?: InputMaybe<Session_Aggregate_Bool_Exp_Count>;
};

export type Session_Aggregate_Bool_Exp_Bool_And = {
  readonly arguments: Session_Select_Column_Session_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Session_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Session_Aggregate_Bool_Exp_Bool_Or = {
  readonly arguments: Session_Select_Column_Session_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Session_Bool_Exp>;
  readonly predicate: Boolean_Comparison_Exp;
};

export type Session_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Session_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "session" */
export type Session_Aggregate_Fields = {
  readonly __typename?: 'session_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Session_Max_Fields>;
  readonly min?: Maybe<Session_Min_Fields>;
};


/** aggregate fields of "session" */
export type Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "session" */
export type Session_Aggregate_Order_By = {
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Session_Max_Order_By>;
  readonly min?: InputMaybe<Session_Min_Order_By>;
};

/** input type for inserting array relation for remote table "session" */
export type Session_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Session_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Session_On_Conflict>;
};

/** Boolean expression to filter rows from the table "session". All fields are combined with a logical 'AND'. */
export type Session_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Session_Bool_Exp>>;
  readonly _not?: InputMaybe<Session_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Session_Bool_Exp>>;
  readonly excel?: InputMaybe<Boolean_Comparison_Exp>;
  readonly excel_session_id?: InputMaybe<String_Comparison_Exp>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly is_mobile?: InputMaybe<Boolean_Comparison_Exp>;
  readonly last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly session_start?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "session" */
export type Session_Constraint =
  /** unique or primary key constraint on columns "is_mobile", "folio_user" */
  | 'session_pkey';

/** input type for inserting data into table "session" */
export type Session_Insert_Input = {
  readonly excel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: InputMaybe<Scalars['String']['input']>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly session_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Session_Max_Fields = {
  readonly __typename?: 'session_max_fields';
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: Maybe<Scalars['String']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly session_start?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "session" */
export type Session_Max_Order_By = {
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly session_start?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Session_Min_Fields = {
  readonly __typename?: 'session_min_fields';
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: Maybe<Scalars['String']['output']>;
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly last_seen?: Maybe<Scalars['timestamptz']['output']>;
  readonly session_start?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "session" */
export type Session_Min_Order_By = {
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly session_start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "session" */
export type Session_Mutation_Response = {
  readonly __typename?: 'session_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Session>;
};

/** on_conflict condition type for table "session" */
export type Session_On_Conflict = {
  readonly constraint: Session_Constraint;
  readonly update_columns?: ReadonlyArray<Session_Update_Column>;
  readonly where?: InputMaybe<Session_Bool_Exp>;
};

/** Ordering options when selecting data from "session". */
export type Session_Order_By = {
  readonly excel?: InputMaybe<Order_By>;
  readonly excel_session_id?: InputMaybe<Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly folio_user?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly is_mobile?: InputMaybe<Order_By>;
  readonly last_seen?: InputMaybe<Order_By>;
  readonly session_start?: InputMaybe<Order_By>;
};

/** primary key columns input for table: session */
export type Session_Pk_Columns_Input = {
  readonly folio_user: Scalars['String']['input'];
  readonly is_mobile: Scalars['Boolean']['input'];
};

/** select columns of table "session" */
export type Session_Select_Column =
  /** column name */
  | 'excel'
  /** column name */
  | 'excel_session_id'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'is_mobile'
  /** column name */
  | 'last_seen'
  /** column name */
  | 'session_start';

/** select "session_aggregate_bool_exp_bool_and_arguments_columns" columns of table "session" */
export type Session_Select_Column_Session_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'excel'
  /** column name */
  | 'is_mobile';

/** select "session_aggregate_bool_exp_bool_or_arguments_columns" columns of table "session" */
export type Session_Select_Column_Session_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'excel'
  /** column name */
  | 'is_mobile';

/** input type for updating data in table "session" */
export type Session_Set_Input = {
  readonly excel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly session_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "session" */
export type Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Session_Stream_Cursor_Value_Input = {
  readonly excel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Excel instance ID (used for Excel-to-Excel takeover) */
  readonly excel_session_id?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly is_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly session_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "session_type" */
export type Session_Type = {
  readonly __typename?: 'session_type';
  /** An array relationship */
  readonly logout_requests: ReadonlyArray<Logout_Request>;
  /** An aggregate relationship */
  readonly logout_requests_aggregate: Logout_Request_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "session_type" */
export type Session_TypeLogout_RequestsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


/** columns and relationships of "session_type" */
export type Session_TypeLogout_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};

/** aggregated selection of "session_type" */
export type Session_Type_Aggregate = {
  readonly __typename?: 'session_type_aggregate';
  readonly aggregate?: Maybe<Session_Type_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Session_Type>;
};

/** aggregate fields of "session_type" */
export type Session_Type_Aggregate_Fields = {
  readonly __typename?: 'session_type_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Session_Type_Max_Fields>;
  readonly min?: Maybe<Session_Type_Min_Fields>;
};


/** aggregate fields of "session_type" */
export type Session_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Session_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "session_type". All fields are combined with a logical 'AND'. */
export type Session_Type_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Session_Type_Bool_Exp>>;
  readonly _not?: InputMaybe<Session_Type_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Session_Type_Bool_Exp>>;
  readonly logout_requests?: InputMaybe<Logout_Request_Bool_Exp>;
  readonly logout_requests_aggregate?: InputMaybe<Logout_Request_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "session_type" */
export type Session_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'session_type_pkey';

/** input type for inserting data into table "session_type" */
export type Session_Type_Insert_Input = {
  readonly logout_requests?: InputMaybe<Logout_Request_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Session_Type_Max_Fields = {
  readonly __typename?: 'session_type_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Session_Type_Min_Fields = {
  readonly __typename?: 'session_type_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "session_type" */
export type Session_Type_Mutation_Response = {
  readonly __typename?: 'session_type_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Session_Type>;
};

/** input type for inserting object relation for remote table "session_type" */
export type Session_Type_Obj_Rel_Insert_Input = {
  readonly data: Session_Type_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Session_Type_On_Conflict>;
};

/** on_conflict condition type for table "session_type" */
export type Session_Type_On_Conflict = {
  readonly constraint: Session_Type_Constraint;
  readonly update_columns?: ReadonlyArray<Session_Type_Update_Column>;
  readonly where?: InputMaybe<Session_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "session_type". */
export type Session_Type_Order_By = {
  readonly logout_requests_aggregate?: InputMaybe<Logout_Request_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: session_type */
export type Session_Type_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "session_type" */
export type Session_Type_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "session_type" */
export type Session_Type_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "session_type" */
export type Session_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Session_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Session_Type_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "session_type" */
export type Session_Type_Update_Column =
  /** column name */
  | 'value';

export type Session_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Session_Type_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Session_Type_Bool_Exp;
};

/** update columns of table "session" */
export type Session_Update_Column =
  /** column name */
  | 'excel'
  /** column name */
  | 'excel_session_id'
  /** column name */
  | 'folio_user'
  /** column name */
  | 'id'
  /** column name */
  | 'is_mobile'
  /** column name */
  | 'last_seen'
  /** column name */
  | 'session_start';

export type Session_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Session_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Session_Bool_Exp;
};

/** columns and relationships of "shared_instrument" */
export type Shared_Instrument = {
  readonly __typename?: 'shared_instrument';
  readonly edited_at: Scalars['timestamptz']['output'];
  readonly edited_by: Scalars['String']['output'];
  /** An object relationship */
  readonly folio_user?: Maybe<Folio_User_Basic_Profile>;
  readonly id: Scalars['bigint']['output'];
  readonly month: Scalars['date']['output'];
  readonly product: Scalars['uuid']['output'];
  /** An object relationship */
  readonly productByProduct: Product;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "shared_instrument" */
export type Shared_Instrument_Aggregate = {
  readonly __typename?: 'shared_instrument_aggregate';
  readonly aggregate?: Maybe<Shared_Instrument_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Shared_Instrument>;
};

export type Shared_Instrument_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Shared_Instrument_Aggregate_Bool_Exp_Count>;
};

export type Shared_Instrument_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Shared_Instrument_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared_instrument" */
export type Shared_Instrument_Aggregate_Fields = {
  readonly __typename?: 'shared_instrument_aggregate_fields';
  readonly avg?: Maybe<Shared_Instrument_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Shared_Instrument_Max_Fields>;
  readonly min?: Maybe<Shared_Instrument_Min_Fields>;
  readonly stddev?: Maybe<Shared_Instrument_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Shared_Instrument_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Shared_Instrument_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Shared_Instrument_Sum_Fields>;
  readonly var_pop?: Maybe<Shared_Instrument_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Shared_Instrument_Var_Samp_Fields>;
  readonly variance?: Maybe<Shared_Instrument_Variance_Fields>;
};


/** aggregate fields of "shared_instrument" */
export type Shared_Instrument_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "shared_instrument" */
export type Shared_Instrument_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Shared_Instrument_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Shared_Instrument_Max_Order_By>;
  readonly min?: InputMaybe<Shared_Instrument_Min_Order_By>;
  readonly stddev?: InputMaybe<Shared_Instrument_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Shared_Instrument_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Shared_Instrument_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Shared_Instrument_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Shared_Instrument_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Shared_Instrument_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Shared_Instrument_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shared_instrument" */
export type Shared_Instrument_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Shared_Instrument_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Shared_Instrument_On_Conflict>;
};

/** aggregate avg on columns */
export type Shared_Instrument_Avg_Fields = {
  readonly __typename?: 'shared_instrument_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "shared_instrument" */
export type Shared_Instrument_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shared_instrument". All fields are combined with a logical 'AND'. */
export type Shared_Instrument_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Shared_Instrument_Bool_Exp>>;
  readonly _not?: InputMaybe<Shared_Instrument_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Shared_Instrument_Bool_Exp>>;
  readonly edited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly edited_by?: InputMaybe<String_Comparison_Exp>;
  readonly folio_user?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
  readonly id?: InputMaybe<Bigint_Comparison_Exp>;
  readonly month?: InputMaybe<Date_Comparison_Exp>;
  readonly product?: InputMaybe<Uuid_Comparison_Exp>;
  readonly productByProduct?: InputMaybe<Product_Bool_Exp>;
  readonly value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared_instrument" */
export type Shared_Instrument_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'shared_instrument_id_key'
  /** unique or primary key constraint on columns "product", "month" */
  | 'shared_instrument_pkey';

/** input type for incrementing numeric columns in table "shared_instrument" */
export type Shared_Instrument_Inc_Input = {
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "shared_instrument" */
export type Shared_Instrument_Insert_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly edited_by?: InputMaybe<Scalars['String']['input']>;
  readonly folio_user?: InputMaybe<Folio_User_Basic_Profile_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Shared_Instrument_Max_Fields = {
  readonly __typename?: 'shared_instrument_max_fields';
  readonly edited_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly edited_by?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "shared_instrument" */
export type Shared_Instrument_Max_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly edited_by?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shared_Instrument_Min_Fields = {
  readonly __typename?: 'shared_instrument_min_fields';
  readonly edited_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly edited_by?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly month?: Maybe<Scalars['date']['output']>;
  readonly product?: Maybe<Scalars['uuid']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "shared_instrument" */
export type Shared_Instrument_Min_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly edited_by?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared_instrument" */
export type Shared_Instrument_Mutation_Response = {
  readonly __typename?: 'shared_instrument_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Shared_Instrument>;
};

/** on_conflict condition type for table "shared_instrument" */
export type Shared_Instrument_On_Conflict = {
  readonly constraint: Shared_Instrument_Constraint;
  readonly update_columns?: ReadonlyArray<Shared_Instrument_Update_Column>;
  readonly where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};

/** Ordering options when selecting data from "shared_instrument". */
export type Shared_Instrument_Order_By = {
  readonly edited_at?: InputMaybe<Order_By>;
  readonly edited_by?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Folio_User_Basic_Profile_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly month?: InputMaybe<Order_By>;
  readonly product?: InputMaybe<Order_By>;
  readonly productByProduct?: InputMaybe<Product_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared_instrument */
export type Shared_Instrument_Pk_Columns_Input = {
  readonly month: Scalars['date']['input'];
  readonly product: Scalars['uuid']['input'];
};

/** select columns of table "shared_instrument" */
export type Shared_Instrument_Select_Column =
  /** column name */
  | 'edited_at'
  /** column name */
  | 'edited_by'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'product'
  /** column name */
  | 'value';

/** input type for updating data in table "shared_instrument" */
export type Shared_Instrument_Set_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly edited_by?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Shared_Instrument_Stddev_Fields = {
  readonly __typename?: 'shared_instrument_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "shared_instrument" */
export type Shared_Instrument_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shared_Instrument_Stddev_Pop_Fields = {
  readonly __typename?: 'shared_instrument_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "shared_instrument" */
export type Shared_Instrument_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shared_Instrument_Stddev_Samp_Fields = {
  readonly __typename?: 'shared_instrument_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "shared_instrument" */
export type Shared_Instrument_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shared_instrument" */
export type Shared_Instrument_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Shared_Instrument_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shared_Instrument_Stream_Cursor_Value_Input = {
  readonly edited_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly edited_by?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['bigint']['input']>;
  readonly month?: InputMaybe<Scalars['date']['input']>;
  readonly product?: InputMaybe<Scalars['uuid']['input']>;
  readonly value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Shared_Instrument_Sum_Fields = {
  readonly __typename?: 'shared_instrument_sum_fields';
  readonly id?: Maybe<Scalars['bigint']['output']>;
  readonly value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "shared_instrument" */
export type Shared_Instrument_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** update columns of table "shared_instrument" */
export type Shared_Instrument_Update_Column =
  /** column name */
  | 'edited_at'
  /** column name */
  | 'edited_by'
  /** column name */
  | 'id'
  /** column name */
  | 'month'
  /** column name */
  | 'product'
  /** column name */
  | 'value';

export type Shared_Instrument_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Shared_Instrument_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Shared_Instrument_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Shared_Instrument_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shared_Instrument_Var_Pop_Fields = {
  readonly __typename?: 'shared_instrument_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "shared_instrument" */
export type Shared_Instrument_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shared_Instrument_Var_Samp_Fields = {
  readonly __typename?: 'shared_instrument_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "shared_instrument" */
export type Shared_Instrument_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shared_Instrument_Variance_Fields = {
  readonly __typename?: 'shared_instrument_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "shared_instrument" */
export type Shared_Instrument_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** columns and relationships of "sharing_agreement" */
export type Sharing_Agreement = {
  readonly __typename?: 'sharing_agreement';
  /** An object relationship */
  readonly broadcasterSourceBySource: Source;
  readonly broadcaster_source: Scalars['Int']['output'];
  /** An object relationship */
  readonly consumerSourceBySource: Source;
  readonly consumer_source: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
};

/** aggregated selection of "sharing_agreement" */
export type Sharing_Agreement_Aggregate = {
  readonly __typename?: 'sharing_agreement_aggregate';
  readonly aggregate?: Maybe<Sharing_Agreement_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Sharing_Agreement>;
};

export type Sharing_Agreement_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Sharing_Agreement_Aggregate_Bool_Exp_Count>;
};

export type Sharing_Agreement_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Sharing_Agreement_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sharing_agreement" */
export type Sharing_Agreement_Aggregate_Fields = {
  readonly __typename?: 'sharing_agreement_aggregate_fields';
  readonly avg?: Maybe<Sharing_Agreement_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Sharing_Agreement_Max_Fields>;
  readonly min?: Maybe<Sharing_Agreement_Min_Fields>;
  readonly stddev?: Maybe<Sharing_Agreement_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Sharing_Agreement_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Sharing_Agreement_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Sharing_Agreement_Sum_Fields>;
  readonly var_pop?: Maybe<Sharing_Agreement_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Sharing_Agreement_Var_Samp_Fields>;
  readonly variance?: Maybe<Sharing_Agreement_Variance_Fields>;
};


/** aggregate fields of "sharing_agreement" */
export type Sharing_Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sharing_agreement" */
export type Sharing_Agreement_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Sharing_Agreement_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Sharing_Agreement_Max_Order_By>;
  readonly min?: InputMaybe<Sharing_Agreement_Min_Order_By>;
  readonly stddev?: InputMaybe<Sharing_Agreement_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Sharing_Agreement_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Sharing_Agreement_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Sharing_Agreement_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Sharing_Agreement_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Sharing_Agreement_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Sharing_Agreement_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sharing_agreement" */
export type Sharing_Agreement_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Sharing_Agreement_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Sharing_Agreement_On_Conflict>;
};

/** aggregate avg on columns */
export type Sharing_Agreement_Avg_Fields = {
  readonly __typename?: 'sharing_agreement_avg_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Avg_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sharing_agreement". All fields are combined with a logical 'AND'. */
export type Sharing_Agreement_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Sharing_Agreement_Bool_Exp>>;
  readonly _not?: InputMaybe<Sharing_Agreement_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Sharing_Agreement_Bool_Exp>>;
  readonly broadcasterSourceBySource?: InputMaybe<Source_Bool_Exp>;
  readonly broadcaster_source?: InputMaybe<Int_Comparison_Exp>;
  readonly consumerSourceBySource?: InputMaybe<Source_Bool_Exp>;
  readonly consumer_source?: InputMaybe<Int_Comparison_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "sharing_agreement" */
export type Sharing_Agreement_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'sharing_agreement_pk'
  /** unique or primary key constraint on columns "consumer_source", "broadcaster_source" */
  | 'sharing_agreement_unique_bcast_cons';

/** input type for incrementing numeric columns in table "sharing_agreement" */
export type Sharing_Agreement_Inc_Input = {
  readonly broadcaster_source?: InputMaybe<Scalars['Int']['input']>;
  readonly consumer_source?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sharing_agreement" */
export type Sharing_Agreement_Insert_Input = {
  readonly broadcasterSourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
  readonly broadcaster_source?: InputMaybe<Scalars['Int']['input']>;
  readonly consumerSourceBySource?: InputMaybe<Source_Obj_Rel_Insert_Input>;
  readonly consumer_source?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Sharing_Agreement_Max_Fields = {
  readonly __typename?: 'sharing_agreement_max_fields';
  readonly broadcaster_source?: Maybe<Scalars['Int']['output']>;
  readonly consumer_source?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Max_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sharing_Agreement_Min_Fields = {
  readonly __typename?: 'sharing_agreement_min_fields';
  readonly broadcaster_source?: Maybe<Scalars['Int']['output']>;
  readonly consumer_source?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Min_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sharing_agreement" */
export type Sharing_Agreement_Mutation_Response = {
  readonly __typename?: 'sharing_agreement_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Sharing_Agreement>;
};

/** on_conflict condition type for table "sharing_agreement" */
export type Sharing_Agreement_On_Conflict = {
  readonly constraint: Sharing_Agreement_Constraint;
  readonly update_columns?: ReadonlyArray<Sharing_Agreement_Update_Column>;
  readonly where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};

/** Ordering options when selecting data from "sharing_agreement". */
export type Sharing_Agreement_Order_By = {
  readonly broadcasterSourceBySource?: InputMaybe<Source_Order_By>;
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumerSourceBySource?: InputMaybe<Source_Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sharing_agreement */
export type Sharing_Agreement_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "sharing_agreement" */
export type Sharing_Agreement_Select_Column =
  /** column name */
  | 'broadcaster_source'
  /** column name */
  | 'consumer_source'
  /** column name */
  | 'id';

/** input type for updating data in table "sharing_agreement" */
export type Sharing_Agreement_Set_Input = {
  readonly broadcaster_source?: InputMaybe<Scalars['Int']['input']>;
  readonly consumer_source?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Sharing_Agreement_Stddev_Fields = {
  readonly __typename?: 'sharing_agreement_stddev_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Stddev_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sharing_Agreement_Stddev_Pop_Fields = {
  readonly __typename?: 'sharing_agreement_stddev_pop_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Stddev_Pop_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sharing_Agreement_Stddev_Samp_Fields = {
  readonly __typename?: 'sharing_agreement_stddev_samp_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Stddev_Samp_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sharing_agreement" */
export type Sharing_Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Sharing_Agreement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sharing_Agreement_Stream_Cursor_Value_Input = {
  readonly broadcaster_source?: InputMaybe<Scalars['Int']['input']>;
  readonly consumer_source?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Sharing_Agreement_Sum_Fields = {
  readonly __typename?: 'sharing_agreement_sum_fields';
  readonly broadcaster_source?: Maybe<Scalars['Int']['output']>;
  readonly consumer_source?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Sum_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** update columns of table "sharing_agreement" */
export type Sharing_Agreement_Update_Column =
  /** column name */
  | 'broadcaster_source'
  /** column name */
  | 'consumer_source'
  /** column name */
  | 'id';

export type Sharing_Agreement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Sharing_Agreement_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Sharing_Agreement_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Sharing_Agreement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sharing_Agreement_Var_Pop_Fields = {
  readonly __typename?: 'sharing_agreement_var_pop_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Var_Pop_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sharing_Agreement_Var_Samp_Fields = {
  readonly __typename?: 'sharing_agreement_var_samp_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Var_Samp_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sharing_Agreement_Variance_Fields = {
  readonly __typename?: 'sharing_agreement_variance_fields';
  readonly broadcaster_source?: Maybe<Scalars['Float']['output']>;
  readonly consumer_source?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sharing_agreement" */
export type Sharing_Agreement_Variance_Order_By = {
  readonly broadcaster_source?: InputMaybe<Order_By>;
  readonly consumer_source?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['smallint']['input']>;
  readonly _gt?: InputMaybe<Scalars['smallint']['input']>;
  readonly _gte?: InputMaybe<Scalars['smallint']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['smallint']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['smallint']['input']>;
  readonly _lte?: InputMaybe<Scalars['smallint']['input']>;
  readonly _neq?: InputMaybe<Scalars['smallint']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['smallint']['input']>>;
};

/** columns and relationships of "source" */
export type Source = {
  readonly __typename?: 'source';
  readonly alias?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  readonly eod?: Maybe<Eod>;
  /** An array relationship */
  readonly eods: ReadonlyArray<Eod>;
  /** An aggregate relationship */
  readonly eods_aggregate: Eod_Aggregate;
  /** An object relationship */
  readonly exchange?: Maybe<Exchange>;
  /** An array relationship */
  readonly exchange_usages: ReadonlyArray<Exchange_Usage>;
  /** An aggregate relationship */
  readonly exchange_usages_aggregate: Exchange_Usage_Aggregate;
  /** An array relationship */
  readonly exchanges: ReadonlyArray<Exchange>;
  /** An aggregate relationship */
  readonly exchanges_aggregate: Exchange_Aggregate;
  /** An array relationship */
  readonly global_packages: ReadonlyArray<Global_Package>;
  /** An aggregate relationship */
  readonly global_packages_aggregate: Global_Package_Aggregate;
  readonly id: Scalars['Int']['output'];
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  /** An object relationship */
  readonly organisation?: Maybe<Organisation>;
  /** An array relationship */
  readonly organisations: ReadonlyArray<Organisation>;
  /** An aggregate relationship */
  readonly organisations_aggregate: Organisation_Aggregate;
  /** An array relationship */
  readonly packages: ReadonlyArray<Package>;
  /** An aggregate relationship */
  readonly packages_aggregate: Package_Aggregate;
  /** An object relationship */
  readonly product_source: Product_Source;
  /** An array relationship */
  readonly sharingAgreementsByConsumerSource: ReadonlyArray<Sharing_Agreement>;
  /** An aggregate relationship */
  readonly sharingAgreementsByConsumerSource_aggregate: Sharing_Agreement_Aggregate;
  /** An array relationship */
  readonly sharing_agreements: ReadonlyArray<Sharing_Agreement>;
  /** An aggregate relationship */
  readonly sharing_agreements_aggregate: Sharing_Agreement_Aggregate;
  readonly source_type: Product_Source_Enum;
};


/** columns and relationships of "source" */
export type SourceEodsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Order_By>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceEods_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Order_By>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceExchange_UsagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceExchange_Usages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceExchangesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Order_By>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceExchanges_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Order_By>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceGlobal_PackagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Package_Order_By>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceGlobal_Packages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Package_Order_By>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceOrganisationsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourcePackagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourcePackages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceSharingAgreementsByConsumerSourceArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceSharingAgreementsByConsumerSource_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceSharing_AgreementsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


/** columns and relationships of "source" */
export type SourceSharing_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};

/** aggregated selection of "source" */
export type Source_Aggregate = {
  readonly __typename?: 'source_aggregate';
  readonly aggregate?: Maybe<Source_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Source>;
};

export type Source_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Source_Aggregate_Bool_Exp_Count>;
};

export type Source_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Source_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "source" */
export type Source_Aggregate_Fields = {
  readonly __typename?: 'source_aggregate_fields';
  readonly avg?: Maybe<Source_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Source_Max_Fields>;
  readonly min?: Maybe<Source_Min_Fields>;
  readonly stddev?: Maybe<Source_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Source_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Source_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Source_Sum_Fields>;
  readonly var_pop?: Maybe<Source_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Source_Var_Samp_Fields>;
  readonly variance?: Maybe<Source_Variance_Fields>;
};


/** aggregate fields of "source" */
export type Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "source" */
export type Source_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Source_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Source_Max_Order_By>;
  readonly min?: InputMaybe<Source_Min_Order_By>;
  readonly stddev?: InputMaybe<Source_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Source_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Source_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Source_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Source_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Source_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Source_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "source" */
export type Source_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Source_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Source_On_Conflict>;
};

/** aggregate avg on columns */
export type Source_Avg_Fields = {
  readonly __typename?: 'source_avg_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "source" */
export type Source_Avg_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "source". All fields are combined with a logical 'AND'. */
export type Source_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Source_Bool_Exp>>;
  readonly _not?: InputMaybe<Source_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Source_Bool_Exp>>;
  readonly alias?: InputMaybe<String_Comparison_Exp>;
  readonly description?: InputMaybe<String_Comparison_Exp>;
  readonly eod?: InputMaybe<Eod_Bool_Exp>;
  readonly eods?: InputMaybe<Eod_Bool_Exp>;
  readonly eods_aggregate?: InputMaybe<Eod_Aggregate_Bool_Exp>;
  readonly exchange?: InputMaybe<Exchange_Bool_Exp>;
  readonly exchange_usages?: InputMaybe<Exchange_Usage_Bool_Exp>;
  readonly exchange_usages_aggregate?: InputMaybe<Exchange_Usage_Aggregate_Bool_Exp>;
  readonly exchanges?: InputMaybe<Exchange_Bool_Exp>;
  readonly exchanges_aggregate?: InputMaybe<Exchange_Aggregate_Bool_Exp>;
  readonly global_packages?: InputMaybe<Global_Package_Bool_Exp>;
  readonly global_packages_aggregate?: InputMaybe<Global_Package_Aggregate_Bool_Exp>;
  readonly id?: InputMaybe<Int_Comparison_Exp>;
  readonly logo?: InputMaybe<String_Comparison_Exp>;
  readonly name?: InputMaybe<String_Comparison_Exp>;
  readonly organisation?: InputMaybe<Organisation_Bool_Exp>;
  readonly organisations?: InputMaybe<Organisation_Bool_Exp>;
  readonly organisations_aggregate?: InputMaybe<Organisation_Aggregate_Bool_Exp>;
  readonly packages?: InputMaybe<Package_Bool_Exp>;
  readonly packages_aggregate?: InputMaybe<Package_Aggregate_Bool_Exp>;
  readonly product_source?: InputMaybe<Product_Source_Bool_Exp>;
  readonly sharingAgreementsByConsumerSource?: InputMaybe<Sharing_Agreement_Bool_Exp>;
  readonly sharingAgreementsByConsumerSource_aggregate?: InputMaybe<Sharing_Agreement_Aggregate_Bool_Exp>;
  readonly sharing_agreements?: InputMaybe<Sharing_Agreement_Bool_Exp>;
  readonly sharing_agreements_aggregate?: InputMaybe<Sharing_Agreement_Aggregate_Bool_Exp>;
  readonly source_type?: InputMaybe<Product_Source_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "source" */
export type Source_Constraint =
  /** unique or primary key constraint on columns "source_type", "name" */
  | 'source_name_source_type_key'
  /** unique or primary key constraint on columns "id" */
  | 'source_pkey';

/** input type for incrementing numeric columns in table "source" */
export type Source_Inc_Input = {
  readonly id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "source" */
export type Source_Insert_Input = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly eod?: InputMaybe<Eod_Obj_Rel_Insert_Input>;
  readonly eods?: InputMaybe<Eod_Arr_Rel_Insert_Input>;
  readonly exchange?: InputMaybe<Exchange_Obj_Rel_Insert_Input>;
  readonly exchange_usages?: InputMaybe<Exchange_Usage_Arr_Rel_Insert_Input>;
  readonly exchanges?: InputMaybe<Exchange_Arr_Rel_Insert_Input>;
  readonly global_packages?: InputMaybe<Global_Package_Arr_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly logo?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  readonly organisations?: InputMaybe<Organisation_Arr_Rel_Insert_Input>;
  readonly packages?: InputMaybe<Package_Arr_Rel_Insert_Input>;
  readonly product_source?: InputMaybe<Product_Source_Obj_Rel_Insert_Input>;
  readonly sharingAgreementsByConsumerSource?: InputMaybe<Sharing_Agreement_Arr_Rel_Insert_Input>;
  readonly sharing_agreements?: InputMaybe<Sharing_Agreement_Arr_Rel_Insert_Input>;
  readonly source_type?: InputMaybe<Product_Source_Enum>;
};

/** aggregate max on columns */
export type Source_Max_Fields = {
  readonly __typename?: 'source_max_fields';
  readonly alias?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "source" */
export type Source_Max_Order_By = {
  readonly alias?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly logo?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Source_Min_Fields = {
  readonly __typename?: 'source_min_fields';
  readonly alias?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "source" */
export type Source_Min_Order_By = {
  readonly alias?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly logo?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "source" */
export type Source_Mutation_Response = {
  readonly __typename?: 'source_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Source>;
};

/** input type for inserting object relation for remote table "source" */
export type Source_Obj_Rel_Insert_Input = {
  readonly data: Source_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Source_On_Conflict>;
};

/** on_conflict condition type for table "source" */
export type Source_On_Conflict = {
  readonly constraint: Source_Constraint;
  readonly update_columns?: ReadonlyArray<Source_Update_Column>;
  readonly where?: InputMaybe<Source_Bool_Exp>;
};

/** Ordering options when selecting data from "source". */
export type Source_Order_By = {
  readonly alias?: InputMaybe<Order_By>;
  readonly description?: InputMaybe<Order_By>;
  readonly eod?: InputMaybe<Eod_Order_By>;
  readonly eods_aggregate?: InputMaybe<Eod_Aggregate_Order_By>;
  readonly exchange?: InputMaybe<Exchange_Order_By>;
  readonly exchange_usages_aggregate?: InputMaybe<Exchange_Usage_Aggregate_Order_By>;
  readonly exchanges_aggregate?: InputMaybe<Exchange_Aggregate_Order_By>;
  readonly global_packages_aggregate?: InputMaybe<Global_Package_Aggregate_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly logo?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Organisation_Order_By>;
  readonly organisations_aggregate?: InputMaybe<Organisation_Aggregate_Order_By>;
  readonly packages_aggregate?: InputMaybe<Package_Aggregate_Order_By>;
  readonly product_source?: InputMaybe<Product_Source_Order_By>;
  readonly sharingAgreementsByConsumerSource_aggregate?: InputMaybe<Sharing_Agreement_Aggregate_Order_By>;
  readonly sharing_agreements_aggregate?: InputMaybe<Sharing_Agreement_Aggregate_Order_By>;
  readonly source_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: source */
export type Source_Pk_Columns_Input = {
  readonly id: Scalars['Int']['input'];
};

/** select columns of table "source" */
export type Source_Select_Column =
  /** column name */
  | 'alias'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'logo'
  /** column name */
  | 'name'
  /** column name */
  | 'source_type';

/** input type for updating data in table "source" */
export type Source_Set_Input = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly logo?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly source_type?: InputMaybe<Product_Source_Enum>;
};

/** aggregate stddev on columns */
export type Source_Stddev_Fields = {
  readonly __typename?: 'source_stddev_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "source" */
export type Source_Stddev_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Source_Stddev_Pop_Fields = {
  readonly __typename?: 'source_stddev_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "source" */
export type Source_Stddev_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Source_Stddev_Samp_Fields = {
  readonly __typename?: 'source_stddev_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "source" */
export type Source_Stddev_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "source" */
export type Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Source_Stream_Cursor_Value_Input = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['Int']['input']>;
  readonly logo?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly source_type?: InputMaybe<Product_Source_Enum>;
};

/** aggregate sum on columns */
export type Source_Sum_Fields = {
  readonly __typename?: 'source_sum_fields';
  readonly id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "source" */
export type Source_Sum_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** update columns of table "source" */
export type Source_Update_Column =
  /** column name */
  | 'alias'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'logo'
  /** column name */
  | 'name'
  /** column name */
  | 'source_type';

export type Source_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Source_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Source_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Source_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Source_Var_Pop_Fields = {
  readonly __typename?: 'source_var_pop_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "source" */
export type Source_Var_Pop_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Source_Var_Samp_Fields = {
  readonly __typename?: 'source_var_samp_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "source" */
export type Source_Var_Samp_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Source_Variance_Fields = {
  readonly __typename?: 'source_variance_fields';
  readonly id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "source" */
export type Source_Variance_Order_By = {
  readonly id?: InputMaybe<Order_By>;
};

/** columns and relationships of "spreader_state" */
export type Spreader_State = {
  readonly __typename?: 'spreader_state';
  /** An array relationship */
  readonly Members: ReadonlyArray<Page_Member>;
  /** An aggregate relationship */
  readonly Members_aggregate: Page_Member_Aggregate;
  /** An object relationship */
  readonly Page: Pages;
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly id: Scalars['String']['output'];
  readonly page_id: Scalars['String']['output'];
  readonly row_data?: Maybe<Scalars['jsonb']['output']>;
  readonly row_idx: Scalars['Int']['output'];
  readonly user_id: Scalars['String']['output'];
};


/** columns and relationships of "spreader_state" */
export type Spreader_StateMembersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


/** columns and relationships of "spreader_state" */
export type Spreader_StateMembers_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


/** columns and relationships of "spreader_state" */
export type Spreader_StateRow_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "spreader_state" */
export type Spreader_State_Aggregate = {
  readonly __typename?: 'spreader_state_aggregate';
  readonly aggregate?: Maybe<Spreader_State_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Spreader_State>;
};

export type Spreader_State_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Spreader_State_Aggregate_Bool_Exp_Count>;
};

export type Spreader_State_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Spreader_State_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spreader_state" */
export type Spreader_State_Aggregate_Fields = {
  readonly __typename?: 'spreader_state_aggregate_fields';
  readonly avg?: Maybe<Spreader_State_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Spreader_State_Max_Fields>;
  readonly min?: Maybe<Spreader_State_Min_Fields>;
  readonly stddev?: Maybe<Spreader_State_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Spreader_State_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Spreader_State_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Spreader_State_Sum_Fields>;
  readonly var_pop?: Maybe<Spreader_State_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Spreader_State_Var_Samp_Fields>;
  readonly variance?: Maybe<Spreader_State_Variance_Fields>;
};


/** aggregate fields of "spreader_state" */
export type Spreader_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "spreader_state" */
export type Spreader_State_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Spreader_State_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Spreader_State_Max_Order_By>;
  readonly min?: InputMaybe<Spreader_State_Min_Order_By>;
  readonly stddev?: InputMaybe<Spreader_State_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Spreader_State_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Spreader_State_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Spreader_State_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Spreader_State_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Spreader_State_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Spreader_State_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Spreader_State_Append_Input = {
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "spreader_state" */
export type Spreader_State_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Spreader_State_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Spreader_State_On_Conflict>;
};

/** aggregate avg on columns */
export type Spreader_State_Avg_Fields = {
  readonly __typename?: 'spreader_state_avg_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "spreader_state" */
export type Spreader_State_Avg_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spreader_state". All fields are combined with a logical 'AND'. */
export type Spreader_State_Bool_Exp = {
  readonly Members?: InputMaybe<Page_Member_Bool_Exp>;
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Bool_Exp>;
  readonly Page?: InputMaybe<Pages_Bool_Exp>;
  readonly _and?: InputMaybe<ReadonlyArray<Spreader_State_Bool_Exp>>;
  readonly _not?: InputMaybe<Spreader_State_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Spreader_State_Bool_Exp>>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly page_id?: InputMaybe<String_Comparison_Exp>;
  readonly row_data?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly row_idx?: InputMaybe<Int_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spreader_state" */
export type Spreader_State_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'spreader_state_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Spreader_State_Delete_At_Path_Input = {
  readonly row_data?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Spreader_State_Delete_Elem_Input = {
  readonly row_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Spreader_State_Delete_Key_Input = {
  readonly row_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "spreader_state" */
export type Spreader_State_Inc_Input = {
  readonly row_idx?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spreader_state" */
export type Spreader_State_Insert_Input = {
  readonly Members?: InputMaybe<Page_Member_Arr_Rel_Insert_Input>;
  readonly Page?: InputMaybe<Pages_Obj_Rel_Insert_Input>;
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly row_idx?: InputMaybe<Scalars['Int']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spreader_State_Max_Fields = {
  readonly __typename?: 'spreader_state_max_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly row_idx?: Maybe<Scalars['Int']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "spreader_state" */
export type Spreader_State_Max_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly row_idx?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spreader_State_Min_Fields = {
  readonly __typename?: 'spreader_state_min_fields';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly page_id?: Maybe<Scalars['String']['output']>;
  readonly row_idx?: Maybe<Scalars['Int']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "spreader_state" */
export type Spreader_State_Min_Order_By = {
  readonly id?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly row_idx?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spreader_state" */
export type Spreader_State_Mutation_Response = {
  readonly __typename?: 'spreader_state_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Spreader_State>;
};

/** on_conflict condition type for table "spreader_state" */
export type Spreader_State_On_Conflict = {
  readonly constraint: Spreader_State_Constraint;
  readonly update_columns?: ReadonlyArray<Spreader_State_Update_Column>;
  readonly where?: InputMaybe<Spreader_State_Bool_Exp>;
};

/** Ordering options when selecting data from "spreader_state". */
export type Spreader_State_Order_By = {
  readonly Members_aggregate?: InputMaybe<Page_Member_Aggregate_Order_By>;
  readonly Page?: InputMaybe<Pages_Order_By>;
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly page_id?: InputMaybe<Order_By>;
  readonly row_data?: InputMaybe<Order_By>;
  readonly row_idx?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spreader_state */
export type Spreader_State_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Spreader_State_Prepend_Input = {
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "spreader_state" */
export type Spreader_State_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'page_id'
  /** column name */
  | 'row_data'
  /** column name */
  | 'row_idx'
  /** column name */
  | 'user_id';

/** input type for updating data in table "spreader_state" */
export type Spreader_State_Set_Input = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly row_idx?: InputMaybe<Scalars['Int']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Spreader_State_Stddev_Fields = {
  readonly __typename?: 'spreader_state_stddev_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "spreader_state" */
export type Spreader_State_Stddev_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spreader_State_Stddev_Pop_Fields = {
  readonly __typename?: 'spreader_state_stddev_pop_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "spreader_state" */
export type Spreader_State_Stddev_Pop_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spreader_State_Stddev_Samp_Fields = {
  readonly __typename?: 'spreader_state_stddev_samp_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "spreader_state" */
export type Spreader_State_Stddev_Samp_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spreader_state" */
export type Spreader_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Spreader_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spreader_State_Stream_Cursor_Value_Input = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly page_id?: InputMaybe<Scalars['String']['input']>;
  readonly row_data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly row_idx?: InputMaybe<Scalars['Int']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Spreader_State_Sum_Fields = {
  readonly __typename?: 'spreader_state_sum_fields';
  readonly row_idx?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "spreader_state" */
export type Spreader_State_Sum_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** update columns of table "spreader_state" */
export type Spreader_State_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'page_id'
  /** column name */
  | 'row_data'
  /** column name */
  | 'row_idx'
  /** column name */
  | 'user_id';

export type Spreader_State_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Spreader_State_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Spreader_State_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Spreader_State_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Spreader_State_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Spreader_State_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Spreader_State_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Spreader_State_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Spreader_State_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spreader_State_Var_Pop_Fields = {
  readonly __typename?: 'spreader_state_var_pop_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "spreader_state" */
export type Spreader_State_Var_Pop_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spreader_State_Var_Samp_Fields = {
  readonly __typename?: 'spreader_state_var_samp_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "spreader_state" */
export type Spreader_State_Var_Samp_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spreader_State_Variance_Fields = {
  readonly __typename?: 'spreader_state_variance_fields';
  readonly row_idx?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "spreader_state" */
export type Spreader_State_Variance_Order_By = {
  readonly row_idx?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  readonly __typename?: 'subscription_root';
  /** An array relationship */
  readonly alerts: ReadonlyArray<Alerts>;
  /** An aggregate relationship */
  readonly alerts_aggregate: Alerts_Aggregate;
  /** fetch data from the table: "alerts" using primary key columns */
  readonly alerts_by_pk?: Maybe<Alerts>;
  /** fetch data from the table in a streaming manner: "alerts" */
  readonly alerts_stream: ReadonlyArray<Alerts>;
  /** fetch data from the table: "audit.logged_actions" */
  readonly audit_logged_actions: ReadonlyArray<Audit_Logged_Actions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  readonly audit_logged_actions_aggregate: Audit_Logged_Actions_Aggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  readonly audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** fetch data from the table in a streaming manner: "audit.logged_actions" */
  readonly audit_logged_actions_stream: ReadonlyArray<Audit_Logged_Actions>;
  /** fetch data from the table: "audit.umi_actions" */
  readonly audit_umi_actions: ReadonlyArray<Audit_Umi_Actions>;
  /** fetch aggregated fields from the table: "audit.umi_actions" */
  readonly audit_umi_actions_aggregate: Audit_Umi_Actions_Aggregate;
  /** fetch data from the table: "audit.umi_actions" using primary key columns */
  readonly audit_umi_actions_by_pk?: Maybe<Audit_Umi_Actions>;
  /** fetch data from the table in a streaming manner: "audit.umi_actions" */
  readonly audit_umi_actions_stream: ReadonlyArray<Audit_Umi_Actions>;
  /** fetch data from the table: "commodity_group" */
  readonly commodity_group: ReadonlyArray<Commodity_Group>;
  /** fetch aggregated fields from the table: "commodity_group" */
  readonly commodity_group_aggregate: Commodity_Group_Aggregate;
  /** fetch data from the table: "commodity_group" using primary key columns */
  readonly commodity_group_by_pk?: Maybe<Commodity_Group>;
  /** fetch data from the table in a streaming manner: "commodity_group" */
  readonly commodity_group_stream: ReadonlyArray<Commodity_Group>;
  /** fetch data from the table: "commodity_parent_group" */
  readonly commodity_parent_group: ReadonlyArray<Commodity_Parent_Group>;
  /** fetch aggregated fields from the table: "commodity_parent_group" */
  readonly commodity_parent_group_aggregate: Commodity_Parent_Group_Aggregate;
  /** fetch data from the table: "commodity_parent_group" using primary key columns */
  readonly commodity_parent_group_by_pk?: Maybe<Commodity_Parent_Group>;
  /** fetch data from the table in a streaming manner: "commodity_parent_group" */
  readonly commodity_parent_group_stream: ReadonlyArray<Commodity_Parent_Group>;
  /** An array relationship */
  readonly conditional_formatting_rules: ReadonlyArray<Conditional_Formatting_Rules>;
  /** An aggregate relationship */
  readonly conditional_formatting_rules_aggregate: Conditional_Formatting_Rules_Aggregate;
  /** fetch data from the table: "conditional_formatting_rules" using primary key columns */
  readonly conditional_formatting_rules_by_pk?: Maybe<Conditional_Formatting_Rules>;
  /** fetch data from the table in a streaming manner: "conditional_formatting_rules" */
  readonly conditional_formatting_rules_stream: ReadonlyArray<Conditional_Formatting_Rules>;
  /** fetch data from the table: "eod" */
  readonly eod: ReadonlyArray<Eod>;
  /** fetch aggregated fields from the table: "eod" */
  readonly eod_aggregate: Eod_Aggregate;
  /** fetch data from the table: "eod" using primary key columns */
  readonly eod_by_pk?: Maybe<Eod>;
  /** fetch data from the table: "eod_entry" */
  readonly eod_entry: ReadonlyArray<Eod_Entry>;
  /** fetch aggregated fields from the table: "eod_entry" */
  readonly eod_entry_aggregate: Eod_Entry_Aggregate;
  /** fetch data from the table: "eod_entry" using primary key columns */
  readonly eod_entry_by_pk?: Maybe<Eod_Entry>;
  /** fetch data from the table in a streaming manner: "eod_entry" */
  readonly eod_entry_stream: ReadonlyArray<Eod_Entry>;
  /** fetch data from the table in a streaming manner: "eod" */
  readonly eod_stream: ReadonlyArray<Eod>;
  /** fetch data from the table: "exchange" */
  readonly exchange: ReadonlyArray<Exchange>;
  /** fetch aggregated fields from the table: "exchange" */
  readonly exchange_aggregate: Exchange_Aggregate;
  /** fetch data from the table: "exchange" using primary key columns */
  readonly exchange_by_pk?: Maybe<Exchange>;
  /** fetch data from the table: "exchange_event_type" */
  readonly exchange_event_type: ReadonlyArray<Exchange_Event_Type>;
  /** fetch aggregated fields from the table: "exchange_event_type" */
  readonly exchange_event_type_aggregate: Exchange_Event_Type_Aggregate;
  /** fetch data from the table: "exchange_event_type" using primary key columns */
  readonly exchange_event_type_by_pk?: Maybe<Exchange_Event_Type>;
  /** fetch data from the table in a streaming manner: "exchange_event_type" */
  readonly exchange_event_type_stream: ReadonlyArray<Exchange_Event_Type>;
  /** fetch data from the table in a streaming manner: "exchange" */
  readonly exchange_stream: ReadonlyArray<Exchange>;
  /** fetch data from the table: "exchange_usage" */
  readonly exchange_usage: ReadonlyArray<Exchange_Usage>;
  /** fetch aggregated fields from the table: "exchange_usage" */
  readonly exchange_usage_aggregate: Exchange_Usage_Aggregate;
  /** fetch data from the table: "exchange_usage" using primary key columns */
  readonly exchange_usage_by_pk?: Maybe<Exchange_Usage>;
  /** fetch data from the table: "exchange_usage_last" */
  readonly exchange_usage_last: ReadonlyArray<Exchange_Usage_Last>;
  /** fetch aggregated fields from the table: "exchange_usage_last" */
  readonly exchange_usage_last_aggregate: Exchange_Usage_Last_Aggregate;
  /** fetch data from the table in a streaming manner: "exchange_usage_last" */
  readonly exchange_usage_last_stream: ReadonlyArray<Exchange_Usage_Last>;
  /** fetch data from the table: "exchange_usage_start" */
  readonly exchange_usage_start: ReadonlyArray<Exchange_Usage_Start>;
  /** fetch aggregated fields from the table: "exchange_usage_start" */
  readonly exchange_usage_start_aggregate: Exchange_Usage_Start_Aggregate;
  /** fetch data from the table in a streaming manner: "exchange_usage_start" */
  readonly exchange_usage_start_stream: ReadonlyArray<Exchange_Usage_Start>;
  /** fetch data from the table in a streaming manner: "exchange_usage" */
  readonly exchange_usage_stream: ReadonlyArray<Exchange_Usage>;
  /** fetch data from the table: "feature_flags" */
  readonly feature_flags: ReadonlyArray<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  readonly feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  readonly feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table in a streaming manner: "feature_flags" */
  readonly feature_flags_stream: ReadonlyArray<Feature_Flags>;
  /** fetch data from the table: "folio_shadow_curves" */
  readonly folio_shadow_curves: ReadonlyArray<Folio_Shadow_Curves>;
  /** fetch aggregated fields from the table: "folio_shadow_curves" */
  readonly folio_shadow_curves_aggregate: Folio_Shadow_Curves_Aggregate;
  /** fetch data from the table: "folio_shadow_curves" using primary key columns */
  readonly folio_shadow_curves_by_pk?: Maybe<Folio_Shadow_Curves>;
  /** fetch data from the table in a streaming manner: "folio_shadow_curves" */
  readonly folio_shadow_curves_stream: ReadonlyArray<Folio_Shadow_Curves>;
  /** fetch data from the table: "folio_user" */
  readonly folio_user: ReadonlyArray<Folio_User>;
  /** fetch aggregated fields from the table: "folio_user" */
  readonly folio_user_aggregate: Folio_User_Aggregate;
  /** fetch data from the table: "folio_user_basic_profile" */
  readonly folio_user_basic_profile: ReadonlyArray<Folio_User_Basic_Profile>;
  /** fetch aggregated fields from the table: "folio_user_basic_profile" */
  readonly folio_user_basic_profile_aggregate: Folio_User_Basic_Profile_Aggregate;
  /** fetch data from the table in a streaming manner: "folio_user_basic_profile" */
  readonly folio_user_basic_profile_stream: ReadonlyArray<Folio_User_Basic_Profile>;
  /** fetch data from the table: "folio_user" using primary key columns */
  readonly folio_user_by_pk?: Maybe<Folio_User>;
  /** fetch data from the table in a streaming manner: "folio_user" */
  readonly folio_user_stream: ReadonlyArray<Folio_User>;
  /** fetch data from the table: "geographical_region" */
  readonly geographical_region: ReadonlyArray<Geographical_Region>;
  /** fetch aggregated fields from the table: "geographical_region" */
  readonly geographical_region_aggregate: Geographical_Region_Aggregate;
  /** fetch data from the table: "geographical_region" using primary key columns */
  readonly geographical_region_by_pk?: Maybe<Geographical_Region>;
  /** fetch data from the table in a streaming manner: "geographical_region" */
  readonly geographical_region_stream: ReadonlyArray<Geographical_Region>;
  /** fetch data from the table: "global_instrument" */
  readonly global_instrument: ReadonlyArray<Global_Instrument>;
  /** fetch aggregated fields from the table: "global_instrument" */
  readonly global_instrument_aggregate: Global_Instrument_Aggregate;
  /** fetch data from the table: "global_instrument" using primary key columns */
  readonly global_instrument_by_pk?: Maybe<Global_Instrument>;
  /** fetch data from the table in a streaming manner: "global_instrument" */
  readonly global_instrument_stream: ReadonlyArray<Global_Instrument>;
  /** fetch data from the table: "global_package" */
  readonly global_package: ReadonlyArray<Global_Package>;
  /** fetch aggregated fields from the table: "global_package" */
  readonly global_package_aggregate: Global_Package_Aggregate;
  /** fetch data from the table: "global_package" using primary key columns */
  readonly global_package_by_pk?: Maybe<Global_Package>;
  /** fetch data from the table in a streaming manner: "global_package" */
  readonly global_package_stream: ReadonlyArray<Global_Package>;
  /** fetch data from the table: "global_permission" */
  readonly global_permission: ReadonlyArray<Global_Permission>;
  /** fetch aggregated fields from the table: "global_permission" */
  readonly global_permission_aggregate: Global_Permission_Aggregate;
  /** fetch data from the table: "global_permission" using primary key columns */
  readonly global_permission_by_pk?: Maybe<Global_Permission>;
  /** fetch data from the table in a streaming manner: "global_permission" */
  readonly global_permission_stream: ReadonlyArray<Global_Permission>;
  /** fetch data from the table: "global_product" */
  readonly global_product: ReadonlyArray<Global_Product>;
  /** fetch aggregated fields from the table: "global_product" */
  readonly global_product_aggregate: Global_Product_Aggregate;
  /** fetch data from the table: "global_product" using primary key columns */
  readonly global_product_by_pk?: Maybe<Global_Product>;
  /** fetch data from the table: "global_product_config" */
  readonly global_product_config: ReadonlyArray<Global_Product_Config>;
  /** fetch aggregated fields from the table: "global_product_config" */
  readonly global_product_config_aggregate: Global_Product_Config_Aggregate;
  /** fetch data from the table: "global_product_config" using primary key columns */
  readonly global_product_config_by_pk?: Maybe<Global_Product_Config>;
  /** fetch data from the table in a streaming manner: "global_product_config" */
  readonly global_product_config_stream: ReadonlyArray<Global_Product_Config>;
  /** fetch data from the table in a streaming manner: "global_product" */
  readonly global_product_stream: ReadonlyArray<Global_Product>;
  /** fetch data from the table: "grid_charts" */
  readonly grid_charts: ReadonlyArray<Grid_Charts>;
  /** fetch aggregated fields from the table: "grid_charts" */
  readonly grid_charts_aggregate: Grid_Charts_Aggregate;
  /** fetch data from the table: "grid_charts" using primary key columns */
  readonly grid_charts_by_pk?: Maybe<Grid_Charts>;
  /** fetch data from the table in a streaming manner: "grid_charts" */
  readonly grid_charts_stream: ReadonlyArray<Grid_Charts>;
  /** fetch data from the table: "grid_settings" */
  readonly grid_settings: ReadonlyArray<Grid_Settings>;
  /** fetch aggregated fields from the table: "grid_settings" */
  readonly grid_settings_aggregate: Grid_Settings_Aggregate;
  /** fetch data from the table: "grid_settings" using primary key columns */
  readonly grid_settings_by_pk?: Maybe<Grid_Settings>;
  /** fetch data from the table in a streaming manner: "grid_settings" */
  readonly grid_settings_stream: ReadonlyArray<Grid_Settings>;
  /** fetch data from the table: "hfc_card_settings" */
  readonly hfc_card_settings: ReadonlyArray<Hfc_Card_Settings>;
  /** fetch aggregated fields from the table: "hfc_card_settings" */
  readonly hfc_card_settings_aggregate: Hfc_Card_Settings_Aggregate;
  /** fetch data from the table: "hfc_card_settings" using primary key columns */
  readonly hfc_card_settings_by_pk?: Maybe<Hfc_Card_Settings>;
  /** fetch data from the table in a streaming manner: "hfc_card_settings" */
  readonly hfc_card_settings_stream: ReadonlyArray<Hfc_Card_Settings>;
  /** fetch data from the table: "hfc_user_settings" */
  readonly hfc_user_settings: ReadonlyArray<Hfc_User_Settings>;
  /** fetch aggregated fields from the table: "hfc_user_settings" */
  readonly hfc_user_settings_aggregate: Hfc_User_Settings_Aggregate;
  /** fetch data from the table: "hfc_user_settings" using primary key columns */
  readonly hfc_user_settings_by_pk?: Maybe<Hfc_User_Settings>;
  /** fetch data from the table in a streaming manner: "hfc_user_settings" */
  readonly hfc_user_settings_stream: ReadonlyArray<Hfc_User_Settings>;
  /** fetch data from the table: "incident_banners" */
  readonly incident_banners: ReadonlyArray<Incident_Banners>;
  /** fetch aggregated fields from the table: "incident_banners" */
  readonly incident_banners_aggregate: Incident_Banners_Aggregate;
  /** fetch data from the table: "incident_banners" using primary key columns */
  readonly incident_banners_by_pk?: Maybe<Incident_Banners>;
  /** fetch data from the table in a streaming manner: "incident_banners" */
  readonly incident_banners_stream: ReadonlyArray<Incident_Banners>;
  /** fetch data from the table: "live_chart_annotations" */
  readonly live_chart_annotations: ReadonlyArray<Live_Chart_Annotations>;
  /** fetch aggregated fields from the table: "live_chart_annotations" */
  readonly live_chart_annotations_aggregate: Live_Chart_Annotations_Aggregate;
  /** fetch data from the table: "live_chart_annotations" using primary key columns */
  readonly live_chart_annotations_by_pk?: Maybe<Live_Chart_Annotations>;
  /** fetch data from the table in a streaming manner: "live_chart_annotations" */
  readonly live_chart_annotations_stream: ReadonlyArray<Live_Chart_Annotations>;
  /** fetch data from the table: "live_chart_page" */
  readonly live_chart_page: ReadonlyArray<Live_Chart_Page>;
  /** fetch aggregated fields from the table: "live_chart_page" */
  readonly live_chart_page_aggregate: Live_Chart_Page_Aggregate;
  /** fetch data from the table: "live_chart_page" using primary key columns */
  readonly live_chart_page_by_pk?: Maybe<Live_Chart_Page>;
  /** fetch data from the table in a streaming manner: "live_chart_page" */
  readonly live_chart_page_stream: ReadonlyArray<Live_Chart_Page>;
  /** fetch data from the table: "live_chart_settings" */
  readonly live_chart_settings: ReadonlyArray<Live_Chart_Settings>;
  /** fetch aggregated fields from the table: "live_chart_settings" */
  readonly live_chart_settings_aggregate: Live_Chart_Settings_Aggregate;
  /** fetch data from the table: "live_chart_settings" using primary key columns */
  readonly live_chart_settings_by_pk?: Maybe<Live_Chart_Settings>;
  /** fetch data from the table in a streaming manner: "live_chart_settings" */
  readonly live_chart_settings_stream: ReadonlyArray<Live_Chart_Settings>;
  /** fetch data from the table: "live_users_new" */
  readonly live_users_new: ReadonlyArray<Live_Users_New>;
  /** fetch aggregated fields from the table: "live_users_new" */
  readonly live_users_new_aggregate: Live_Users_New_Aggregate;
  /** fetch data from the table in a streaming manner: "live_users_new" */
  readonly live_users_new_stream: ReadonlyArray<Live_Users_New>;
  /** fetch data from the table: "local_instrument" */
  readonly local_instrument: ReadonlyArray<Local_Instrument>;
  /** fetch aggregated fields from the table: "local_instrument" */
  readonly local_instrument_aggregate: Local_Instrument_Aggregate;
  /** fetch data from the table: "local_instrument" using primary key columns */
  readonly local_instrument_by_pk?: Maybe<Local_Instrument>;
  /** fetch data from the table in a streaming manner: "local_instrument" */
  readonly local_instrument_stream: ReadonlyArray<Local_Instrument>;
  /** fetch data from the table: "logout_request" */
  readonly logout_request: ReadonlyArray<Logout_Request>;
  /** fetch aggregated fields from the table: "logout_request" */
  readonly logout_request_aggregate: Logout_Request_Aggregate;
  /** fetch data from the table: "logout_request" using primary key columns */
  readonly logout_request_by_pk?: Maybe<Logout_Request>;
  /** fetch data from the table in a streaming manner: "logout_request" */
  readonly logout_request_stream: ReadonlyArray<Logout_Request>;
  /** fetch data from the table: "module_storage" */
  readonly module_storage: ReadonlyArray<Module_Storage>;
  /** fetch aggregated fields from the table: "module_storage" */
  readonly module_storage_aggregate: Module_Storage_Aggregate;
  /** fetch data from the table: "module_storage" using primary key columns */
  readonly module_storage_by_pk?: Maybe<Module_Storage>;
  /** fetch data from the table in a streaming manner: "module_storage" */
  readonly module_storage_stream: ReadonlyArray<Module_Storage>;
  /** fetch data from the table: "organisation" */
  readonly organisation: ReadonlyArray<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  readonly organisation_aggregate: Organisation_Aggregate;
  /** fetch data from the table: "organisation" using primary key columns */
  readonly organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table in a streaming manner: "organisation" */
  readonly organisation_stream: ReadonlyArray<Organisation>;
  /** fetch data from the table: "package" */
  readonly package: ReadonlyArray<Package>;
  /** fetch aggregated fields from the table: "package" */
  readonly package_aggregate: Package_Aggregate;
  /** fetch data from the table: "package" using primary key columns */
  readonly package_by_pk?: Maybe<Package>;
  /** fetch data from the table in a streaming manner: "package" */
  readonly package_stream: ReadonlyArray<Package>;
  /** fetch data from the table: "package_type" */
  readonly package_type: ReadonlyArray<Package_Type>;
  /** fetch aggregated fields from the table: "package_type" */
  readonly package_type_aggregate: Package_Type_Aggregate;
  /** fetch data from the table: "package_type" using primary key columns */
  readonly package_type_by_pk?: Maybe<Package_Type>;
  /** fetch data from the table in a streaming manner: "package_type" */
  readonly package_type_stream: ReadonlyArray<Package_Type>;
  /** fetch data from the table: "page_member" */
  readonly page_member: ReadonlyArray<Page_Member>;
  /** fetch aggregated fields from the table: "page_member" */
  readonly page_member_aggregate: Page_Member_Aggregate;
  /** fetch data from the table: "page_member" using primary key columns */
  readonly page_member_by_pk?: Maybe<Page_Member>;
  /** fetch data from the table in a streaming manner: "page_member" */
  readonly page_member_stream: ReadonlyArray<Page_Member>;
  /** An array relationship */
  readonly page_products: ReadonlyArray<Page_Products>;
  /** An aggregate relationship */
  readonly page_products_aggregate: Page_Products_Aggregate;
  /** fetch data from the table: "page_products" using primary key columns */
  readonly page_products_by_pk?: Maybe<Page_Products>;
  /** fetch data from the table in a streaming manner: "page_products" */
  readonly page_products_stream: ReadonlyArray<Page_Products>;
  /** An array relationship */
  readonly page_settings: ReadonlyArray<Page_Settings>;
  /** An aggregate relationship */
  readonly page_settings_aggregate: Page_Settings_Aggregate;
  /** fetch data from the table: "page_settings" using primary key columns */
  readonly page_settings_by_pk?: Maybe<Page_Settings>;
  /** fetch data from the table in a streaming manner: "page_settings" */
  readonly page_settings_stream: ReadonlyArray<Page_Settings>;
  /** fetch data from the table: "pages" */
  readonly pages: ReadonlyArray<Pages>;
  /** fetch aggregated fields from the table: "pages" */
  readonly pages_aggregate: Pages_Aggregate;
  /** fetch data from the table: "pages" using primary key columns */
  readonly pages_by_pk?: Maybe<Pages>;
  /** fetch data from the table in a streaming manner: "pages" */
  readonly pages_stream: ReadonlyArray<Pages>;
  /** fetch data from the table: "permission" */
  readonly permission: ReadonlyArray<Permission>;
  /** fetch aggregated fields from the table: "permission" */
  readonly permission_aggregate: Permission_Aggregate;
  /** fetch data from the table: "permission" using primary key columns */
  readonly permission_by_pk?: Maybe<Permission>;
  /** fetch data from the table in a streaming manner: "permission" */
  readonly permission_stream: ReadonlyArray<Permission>;
  /** fetch data from the table: "product" */
  readonly product: ReadonlyArray<Product>;
  /** fetch aggregated fields from the table: "product" */
  readonly product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product_alerts" */
  readonly product_alerts: ReadonlyArray<Product_Alerts>;
  /** fetch aggregated fields from the table: "product_alerts" */
  readonly product_alerts_aggregate: Product_Alerts_Aggregate;
  /** fetch data from the table: "product_alerts" using primary key columns */
  readonly product_alerts_by_pk?: Maybe<Product_Alerts>;
  /** fetch data from the table in a streaming manner: "product_alerts" */
  readonly product_alerts_stream: ReadonlyArray<Product_Alerts>;
  /** fetch data from the table: "product_artis_type" */
  readonly product_artis_type: ReadonlyArray<Product_Artis_Type>;
  /** fetch aggregated fields from the table: "product_artis_type" */
  readonly product_artis_type_aggregate: Product_Artis_Type_Aggregate;
  /** fetch data from the table: "product_artis_type" using primary key columns */
  readonly product_artis_type_by_pk?: Maybe<Product_Artis_Type>;
  /** fetch data from the table in a streaming manner: "product_artis_type" */
  readonly product_artis_type_stream: ReadonlyArray<Product_Artis_Type>;
  /** fetch data from the table: "product" using primary key columns */
  readonly product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_config" */
  readonly product_config: ReadonlyArray<Product_Config>;
  /** fetch aggregated fields from the table: "product_config" */
  readonly product_config_aggregate: Product_Config_Aggregate;
  /** fetch data from the table: "product_config" using primary key columns */
  readonly product_config_by_pk?: Maybe<Product_Config>;
  /** fetch data from the table in a streaming manner: "product_config" */
  readonly product_config_stream: ReadonlyArray<Product_Config>;
  /** fetch data from the table: "product_curve_type" */
  readonly product_curve_type: ReadonlyArray<Product_Curve_Type>;
  /** fetch aggregated fields from the table: "product_curve_type" */
  readonly product_curve_type_aggregate: Product_Curve_Type_Aggregate;
  /** fetch data from the table: "product_curve_type" using primary key columns */
  readonly product_curve_type_by_pk?: Maybe<Product_Curve_Type>;
  /** fetch data from the table in a streaming manner: "product_curve_type" */
  readonly product_curve_type_stream: ReadonlyArray<Product_Curve_Type>;
  /** fetch data from the table: "product_eod" */
  readonly product_eod: ReadonlyArray<Product_Eod>;
  /** fetch aggregated fields from the table: "product_eod" */
  readonly product_eod_aggregate: Product_Eod_Aggregate;
  /** fetch data from the table: "product_eod" using primary key columns */
  readonly product_eod_by_pk?: Maybe<Product_Eod>;
  /** fetch data from the table in a streaming manner: "product_eod" */
  readonly product_eod_stream: ReadonlyArray<Product_Eod>;
  /** An array relationship */
  readonly product_global_dependencies: ReadonlyArray<Product_Global_Dependencies>;
  /** An aggregate relationship */
  readonly product_global_dependencies_aggregate: Product_Global_Dependencies_Aggregate;
  /** fetch data from the table: "product_global_dependencies" using primary key columns */
  readonly product_global_dependencies_by_pk?: Maybe<Product_Global_Dependencies>;
  /** fetch data from the table in a streaming manner: "product_global_dependencies" */
  readonly product_global_dependencies_stream: ReadonlyArray<Product_Global_Dependencies>;
  /** fetch data from the table: "product_maturity" */
  readonly product_maturity: ReadonlyArray<Product_Maturity>;
  /** fetch aggregated fields from the table: "product_maturity" */
  readonly product_maturity_aggregate: Product_Maturity_Aggregate;
  /** fetch data from the table: "product_maturity" using primary key columns */
  readonly product_maturity_by_pk?: Maybe<Product_Maturity>;
  /** fetch data from the table in a streaming manner: "product_maturity" */
  readonly product_maturity_stream: ReadonlyArray<Product_Maturity>;
  /** An array relationship */
  readonly product_overrides: ReadonlyArray<Product_Overrides>;
  /** An aggregate relationship */
  readonly product_overrides_aggregate: Product_Overrides_Aggregate;
  /** fetch data from the table: "product_overrides" using primary key columns */
  readonly product_overrides_by_pk?: Maybe<Product_Overrides>;
  /** fetch data from the table in a streaming manner: "product_overrides" */
  readonly product_overrides_stream: ReadonlyArray<Product_Overrides>;
  /** fetch data from the table: "product_source" */
  readonly product_source: ReadonlyArray<Product_Source>;
  /** fetch aggregated fields from the table: "product_source" */
  readonly product_source_aggregate: Product_Source_Aggregate;
  /** fetch data from the table: "product_source" using primary key columns */
  readonly product_source_by_pk?: Maybe<Product_Source>;
  /** fetch data from the table in a streaming manner: "product_source" */
  readonly product_source_stream: ReadonlyArray<Product_Source>;
  /** fetch data from the table in a streaming manner: "product" */
  readonly product_stream: ReadonlyArray<Product>;
  /** fetch data from the table: "product_summary_type" */
  readonly product_summary_type: ReadonlyArray<Product_Summary_Type>;
  /** fetch aggregated fields from the table: "product_summary_type" */
  readonly product_summary_type_aggregate: Product_Summary_Type_Aggregate;
  /** fetch data from the table: "product_summary_type" using primary key columns */
  readonly product_summary_type_by_pk?: Maybe<Product_Summary_Type>;
  /** fetch data from the table in a streaming manner: "product_summary_type" */
  readonly product_summary_type_stream: ReadonlyArray<Product_Summary_Type>;
  /** fetch data from the table: "product_type" */
  readonly product_type: ReadonlyArray<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  readonly product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  readonly product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table in a streaming manner: "product_type" */
  readonly product_type_stream: ReadonlyArray<Product_Type>;
  /** fetch data from the table: "product_uom" */
  readonly product_uom: ReadonlyArray<Product_Uom>;
  /** fetch aggregated fields from the table: "product_uom" */
  readonly product_uom_aggregate: Product_Uom_Aggregate;
  /** fetch data from the table: "product_uom" using primary key columns */
  readonly product_uom_by_pk?: Maybe<Product_Uom>;
  /** fetch data from the table in a streaming manner: "product_uom" */
  readonly product_uom_stream: ReadonlyArray<Product_Uom>;
  /** fetch data from the table: "product_user_settings" */
  readonly product_user_settings: ReadonlyArray<Product_User_Settings>;
  /** fetch aggregated fields from the table: "product_user_settings" */
  readonly product_user_settings_aggregate: Product_User_Settings_Aggregate;
  /** fetch data from the table: "product_user_settings" using primary key columns */
  readonly product_user_settings_by_pk?: Maybe<Product_User_Settings>;
  /** fetch data from the table in a streaming manner: "product_user_settings" */
  readonly product_user_settings_stream: ReadonlyArray<Product_User_Settings>;
  /** fetch data from the table: "push_subscriptions" */
  readonly push_subscriptions: ReadonlyArray<Push_Subscriptions>;
  /** fetch aggregated fields from the table: "push_subscriptions" */
  readonly push_subscriptions_aggregate: Push_Subscriptions_Aggregate;
  /** fetch data from the table: "push_subscriptions" using primary key columns */
  readonly push_subscriptions_by_pk?: Maybe<Push_Subscriptions>;
  /** fetch data from the table in a streaming manner: "push_subscriptions" */
  readonly push_subscriptions_stream: ReadonlyArray<Push_Subscriptions>;
  /** fetch data from the table: "quick_access" */
  readonly quick_access: ReadonlyArray<Quick_Access>;
  /** fetch aggregated fields from the table: "quick_access" */
  readonly quick_access_aggregate: Quick_Access_Aggregate;
  /** fetch data from the table: "quick_access" using primary key columns */
  readonly quick_access_by_pk?: Maybe<Quick_Access>;
  /** fetch data from the table in a streaming manner: "quick_access" */
  readonly quick_access_stream: ReadonlyArray<Quick_Access>;
  /** fetch data from the table: "scratchpad" */
  readonly scratchpad: ReadonlyArray<Scratchpad>;
  /** fetch aggregated fields from the table: "scratchpad" */
  readonly scratchpad_aggregate: Scratchpad_Aggregate;
  /** fetch data from the table: "scratchpad" using primary key columns */
  readonly scratchpad_by_pk?: Maybe<Scratchpad>;
  /** fetch data from the table in a streaming manner: "scratchpad" */
  readonly scratchpad_stream: ReadonlyArray<Scratchpad>;
  /** fetch data from the table: "session" */
  readonly session: ReadonlyArray<Session>;
  /** fetch aggregated fields from the table: "session" */
  readonly session_aggregate: Session_Aggregate;
  /** fetch data from the table: "session" using primary key columns */
  readonly session_by_pk?: Maybe<Session>;
  /** fetch data from the table in a streaming manner: "session" */
  readonly session_stream: ReadonlyArray<Session>;
  /** fetch data from the table: "session_type" */
  readonly session_type: ReadonlyArray<Session_Type>;
  /** fetch aggregated fields from the table: "session_type" */
  readonly session_type_aggregate: Session_Type_Aggregate;
  /** fetch data from the table: "session_type" using primary key columns */
  readonly session_type_by_pk?: Maybe<Session_Type>;
  /** fetch data from the table in a streaming manner: "session_type" */
  readonly session_type_stream: ReadonlyArray<Session_Type>;
  /** fetch data from the table: "shared_instrument" */
  readonly shared_instrument: ReadonlyArray<Shared_Instrument>;
  /** fetch aggregated fields from the table: "shared_instrument" */
  readonly shared_instrument_aggregate: Shared_Instrument_Aggregate;
  /** fetch data from the table: "shared_instrument" using primary key columns */
  readonly shared_instrument_by_pk?: Maybe<Shared_Instrument>;
  /** fetch data from the table in a streaming manner: "shared_instrument" */
  readonly shared_instrument_stream: ReadonlyArray<Shared_Instrument>;
  /** fetch data from the table: "sharing_agreement" */
  readonly sharing_agreement: ReadonlyArray<Sharing_Agreement>;
  /** fetch aggregated fields from the table: "sharing_agreement" */
  readonly sharing_agreement_aggregate: Sharing_Agreement_Aggregate;
  /** fetch data from the table: "sharing_agreement" using primary key columns */
  readonly sharing_agreement_by_pk?: Maybe<Sharing_Agreement>;
  /** fetch data from the table in a streaming manner: "sharing_agreement" */
  readonly sharing_agreement_stream: ReadonlyArray<Sharing_Agreement>;
  /** fetch data from the table: "source" */
  readonly source: ReadonlyArray<Source>;
  /** fetch aggregated fields from the table: "source" */
  readonly source_aggregate: Source_Aggregate;
  /** fetch data from the table: "source" using primary key columns */
  readonly source_by_pk?: Maybe<Source>;
  /** fetch data from the table in a streaming manner: "source" */
  readonly source_stream: ReadonlyArray<Source>;
  /** fetch data from the table: "spreader_state" */
  readonly spreader_state: ReadonlyArray<Spreader_State>;
  /** fetch aggregated fields from the table: "spreader_state" */
  readonly spreader_state_aggregate: Spreader_State_Aggregate;
  /** fetch data from the table: "spreader_state" using primary key columns */
  readonly spreader_state_by_pk?: Maybe<Spreader_State>;
  /** fetch data from the table in a streaming manner: "spreader_state" */
  readonly spreader_state_stream: ReadonlyArray<Spreader_State>;
  /** fetch data from the table: "subscription_tier" */
  readonly subscription_tier: ReadonlyArray<Subscription_Tier>;
  /** fetch aggregated fields from the table: "subscription_tier" */
  readonly subscription_tier_aggregate: Subscription_Tier_Aggregate;
  /** fetch data from the table: "subscription_tier" using primary key columns */
  readonly subscription_tier_by_pk?: Maybe<Subscription_Tier>;
  /** fetch data from the table in a streaming manner: "subscription_tier" */
  readonly subscription_tier_stream: ReadonlyArray<Subscription_Tier>;
  /** An array relationship */
  readonly umi_action: ReadonlyArray<Umi_Action>;
  /** An aggregate relationship */
  readonly umi_action_aggregate: Umi_Action_Aggregate;
  /** fetch data from the table: "umi_action" using primary key columns */
  readonly umi_action_by_pk?: Maybe<Umi_Action>;
  /** fetch data from the table: "umi_action_name" */
  readonly umi_action_name: ReadonlyArray<Umi_Action_Name>;
  /** fetch aggregated fields from the table: "umi_action_name" */
  readonly umi_action_name_aggregate: Umi_Action_Name_Aggregate;
  /** fetch data from the table: "umi_action_name" using primary key columns */
  readonly umi_action_name_by_pk?: Maybe<Umi_Action_Name>;
  /** fetch data from the table in a streaming manner: "umi_action_name" */
  readonly umi_action_name_stream: ReadonlyArray<Umi_Action_Name>;
  /** fetch data from the table in a streaming manner: "umi_action" */
  readonly umi_action_stream: ReadonlyArray<Umi_Action>;
  /** fetch data from the table: "user_entitlement" */
  readonly user_entitlement: ReadonlyArray<User_Entitlement>;
  /** fetch data from the table: "user_entitlement_active" */
  readonly user_entitlement_active: ReadonlyArray<User_Entitlement_Active>;
  /** fetch aggregated fields from the table: "user_entitlement_active" */
  readonly user_entitlement_active_aggregate: User_Entitlement_Active_Aggregate;
  /** fetch data from the table in a streaming manner: "user_entitlement_active" */
  readonly user_entitlement_active_stream: ReadonlyArray<User_Entitlement_Active>;
  /** fetch aggregated fields from the table: "user_entitlement" */
  readonly user_entitlement_aggregate: User_Entitlement_Aggregate;
  /** fetch data from the table: "user_entitlement" using primary key columns */
  readonly user_entitlement_by_pk?: Maybe<User_Entitlement>;
  /** fetch data from the table: "user_entitlement_kind" */
  readonly user_entitlement_kind: ReadonlyArray<User_Entitlement_Kind>;
  /** fetch aggregated fields from the table: "user_entitlement_kind" */
  readonly user_entitlement_kind_aggregate: User_Entitlement_Kind_Aggregate;
  /** fetch data from the table: "user_entitlement_kind" using primary key columns */
  readonly user_entitlement_kind_by_pk?: Maybe<User_Entitlement_Kind>;
  /** fetch data from the table in a streaming manner: "user_entitlement_kind" */
  readonly user_entitlement_kind_stream: ReadonlyArray<User_Entitlement_Kind>;
  /** fetch data from the table: "user_entitlement_level" */
  readonly user_entitlement_level: ReadonlyArray<User_Entitlement_Level>;
  /** fetch aggregated fields from the table: "user_entitlement_level" */
  readonly user_entitlement_level_aggregate: User_Entitlement_Level_Aggregate;
  /** fetch data from the table: "user_entitlement_level" using primary key columns */
  readonly user_entitlement_level_by_pk?: Maybe<User_Entitlement_Level>;
  /** fetch data from the table in a streaming manner: "user_entitlement_level" */
  readonly user_entitlement_level_stream: ReadonlyArray<User_Entitlement_Level>;
  /** fetch data from the table in a streaming manner: "user_entitlement" */
  readonly user_entitlement_stream: ReadonlyArray<User_Entitlement>;
  /** fetch data from the table: "user_groups" */
  readonly user_groups: ReadonlyArray<User_Groups>;
  /** fetch aggregated fields from the table: "user_groups" */
  readonly user_groups_aggregate: User_Groups_Aggregate;
  /** fetch data from the table: "user_groups" using primary key columns */
  readonly user_groups_by_pk?: Maybe<User_Groups>;
  /** fetch data from the table in a streaming manner: "user_groups" */
  readonly user_groups_stream: ReadonlyArray<User_Groups>;
  /** fetch data from the table: "user_right" */
  readonly user_right: ReadonlyArray<User_Right>;
  /** fetch aggregated fields from the table: "user_right" */
  readonly user_right_aggregate: User_Right_Aggregate;
  /** fetch data from the table: "user_right" using primary key columns */
  readonly user_right_by_pk?: Maybe<User_Right>;
  /** fetch data from the table in a streaming manner: "user_right" */
  readonly user_right_stream: ReadonlyArray<User_Right>;
  /** fetch data from the table: "user_storage" */
  readonly user_storage: ReadonlyArray<User_Storage>;
  /** fetch aggregated fields from the table: "user_storage" */
  readonly user_storage_aggregate: User_Storage_Aggregate;
  /** fetch data from the table: "user_storage" using primary key columns */
  readonly user_storage_by_pk?: Maybe<User_Storage>;
  /** fetch data from the table in a streaming manner: "user_storage" */
  readonly user_storage_stream: ReadonlyArray<User_Storage>;
  /** fetch data from the table: "users_active_last_day" */
  readonly users_active_last_day: ReadonlyArray<Users_Active_Last_Day>;
  /** fetch aggregated fields from the table: "users_active_last_day" */
  readonly users_active_last_day_aggregate: Users_Active_Last_Day_Aggregate;
  /** fetch data from the table in a streaming manner: "users_active_last_day" */
  readonly users_active_last_day_stream: ReadonlyArray<Users_Active_Last_Day>;
  /** fetch data from the table: "viewed_announcements" */
  readonly viewed_announcements: ReadonlyArray<Viewed_Announcements>;
  /** fetch aggregated fields from the table: "viewed_announcements" */
  readonly viewed_announcements_aggregate: Viewed_Announcements_Aggregate;
  /** fetch data from the table: "viewed_announcements" using primary key columns */
  readonly viewed_announcements_by_pk?: Maybe<Viewed_Announcements>;
  /** fetch data from the table in a streaming manner: "viewed_announcements" */
  readonly viewed_announcements_stream: ReadonlyArray<Viewed_Announcements>;
};


export type Subscription_RootAlertsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Subscription_RootAlerts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Subscription_RootAlerts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAlerts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Alerts_Stream_Cursor_Input>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Subscription_RootAudit_Logged_ActionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Logged_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Logged_Actions_By_PkArgs = {
  event_id: Scalars['bigint']['input'];
};


export type Subscription_RootAudit_Logged_Actions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Audit_Logged_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Umi_ActionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Order_By>>;
  where?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Umi_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Audit_Umi_Actions_Order_By>>;
  where?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Umi_Actions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAudit_Umi_Actions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Audit_Umi_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Umi_Actions_Bool_Exp>;
};


export type Subscription_RootCommodity_GroupArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Group_Order_By>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};


export type Subscription_RootCommodity_Group_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Group_Order_By>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};


export type Subscription_RootCommodity_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCommodity_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Commodity_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Group_Bool_Exp>;
};


export type Subscription_RootCommodity_Parent_GroupArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Order_By>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


export type Subscription_RootCommodity_Parent_Group_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Commodity_Parent_Group_Order_By>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


export type Subscription_RootCommodity_Parent_Group_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCommodity_Parent_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Commodity_Parent_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Parent_Group_Bool_Exp>;
};


export type Subscription_RootConditional_Formatting_RulesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Order_By>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


export type Subscription_RootConditional_Formatting_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Conditional_Formatting_Rules_Order_By>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


export type Subscription_RootConditional_Formatting_Rules_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootConditional_Formatting_Rules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Conditional_Formatting_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Conditional_Formatting_Rules_Bool_Exp>;
};


export type Subscription_RootEodArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Order_By>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


export type Subscription_RootEod_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Order_By>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


export type Subscription_RootEod_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEod_EntryArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Entry_Order_By>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


export type Subscription_RootEod_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Eod_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Eod_Entry_Order_By>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


export type Subscription_RootEod_Entry_By_PkArgs = {
  evaluation_date: Scalars['date']['input'];
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
};


export type Subscription_RootEod_Entry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Eod_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Eod_Entry_Bool_Exp>;
};


export type Subscription_RootEod_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Eod_Stream_Cursor_Input>>;
  where?: InputMaybe<Eod_Bool_Exp>;
};


export type Subscription_RootExchangeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Order_By>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


export type Subscription_RootExchange_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Order_By>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


export type Subscription_RootExchange_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExchange_Event_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Order_By>>;
  where?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
};


export type Subscription_RootExchange_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Event_Type_Order_By>>;
  where?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
};


export type Subscription_RootExchange_Event_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootExchange_Event_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Exchange_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Event_Type_Bool_Exp>;
};


export type Subscription_RootExchange_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Exchange_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Bool_Exp>;
};


export type Subscription_RootExchange_UsageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExchange_Usage_LastArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Last_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_Last_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Last_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Last_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_Last_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Exchange_Usage_Last_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Usage_Last_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_StartArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Start_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_Start_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Exchange_Usage_Start_Order_By>>;
  where?: InputMaybe<Exchange_Usage_Start_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_Start_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Exchange_Usage_Start_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Usage_Start_Bool_Exp>;
};


export type Subscription_RootExchange_Usage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Exchange_Usage_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Usage_Bool_Exp>;
};


export type Subscription_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFeature_Flags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFolio_Shadow_CurvesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Order_By>>;
  where?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
};


export type Subscription_RootFolio_Shadow_Curves_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_Shadow_Curves_Order_By>>;
  where?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
};


export type Subscription_RootFolio_Shadow_Curves_By_PkArgs = {
  folio_user: Scalars['String']['input'];
};


export type Subscription_RootFolio_Shadow_Curves_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Folio_Shadow_Curves_Stream_Cursor_Input>>;
  where?: InputMaybe<Folio_Shadow_Curves_Bool_Exp>;
};


export type Subscription_RootFolio_UserArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


export type Subscription_RootFolio_User_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


export type Subscription_RootFolio_User_Basic_ProfileArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Order_By>>;
  where?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
};


export type Subscription_RootFolio_User_Basic_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Basic_Profile_Order_By>>;
  where?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
};


export type Subscription_RootFolio_User_Basic_Profile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Folio_User_Basic_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Folio_User_Basic_Profile_Bool_Exp>;
};


export type Subscription_RootFolio_User_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootFolio_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Folio_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


export type Subscription_RootGeographical_RegionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Geographical_Region_Order_By>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


export type Subscription_RootGeographical_Region_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Geographical_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Geographical_Region_Order_By>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


export type Subscription_RootGeographical_Region_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootGeographical_Region_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Geographical_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Geographical_Region_Bool_Exp>;
};


export type Subscription_RootGlobal_InstrumentArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Instrument_Order_By>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


export type Subscription_RootGlobal_Instrument_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Instrument_Order_By>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


export type Subscription_RootGlobal_Instrument_By_PkArgs = {
  global_product: Scalars['uuid']['input'];
  month: Scalars['date']['input'];
};


export type Subscription_RootGlobal_Instrument_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Global_Instrument_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Instrument_Bool_Exp>;
};


export type Subscription_RootGlobal_PackageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Package_Order_By>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


export type Subscription_RootGlobal_Package_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Package_Order_By>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


export type Subscription_RootGlobal_Package_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootGlobal_Package_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Global_Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Package_Bool_Exp>;
};


export type Subscription_RootGlobal_PermissionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


export type Subscription_RootGlobal_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


export type Subscription_RootGlobal_Permission_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  global_package: Scalars['Int']['input'];
};


export type Subscription_RootGlobal_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Global_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


export type Subscription_RootGlobal_ProductArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


export type Subscription_RootGlobal_Product_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Order_By>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


export type Subscription_RootGlobal_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootGlobal_Product_ConfigArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Config_Order_By>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};


export type Subscription_RootGlobal_Product_Config_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Product_Config_Order_By>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};


export type Subscription_RootGlobal_Product_Config_By_PkArgs = {
  product: Scalars['uuid']['input'];
  relative_month: Scalars['Int']['input'];
};


export type Subscription_RootGlobal_Product_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Global_Product_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Product_Config_Bool_Exp>;
};


export type Subscription_RootGlobal_Product_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Global_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Product_Bool_Exp>;
};


export type Subscription_RootGrid_ChartsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Charts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Charts_Order_By>>;
  where?: InputMaybe<Grid_Charts_Bool_Exp>;
};


export type Subscription_RootGrid_Charts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Charts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Charts_Order_By>>;
  where?: InputMaybe<Grid_Charts_Bool_Exp>;
};


export type Subscription_RootGrid_Charts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootGrid_Charts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Grid_Charts_Stream_Cursor_Input>>;
  where?: InputMaybe<Grid_Charts_Bool_Exp>;
};


export type Subscription_RootGrid_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Settings_Order_By>>;
  where?: InputMaybe<Grid_Settings_Bool_Exp>;
};


export type Subscription_RootGrid_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Grid_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Grid_Settings_Order_By>>;
  where?: InputMaybe<Grid_Settings_Bool_Exp>;
};


export type Subscription_RootGrid_Settings_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


export type Subscription_RootGrid_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Grid_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Grid_Settings_Bool_Exp>;
};


export type Subscription_RootHfc_Card_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Order_By>>;
  where?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
};


export type Subscription_RootHfc_Card_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_Card_Settings_Order_By>>;
  where?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
};


export type Subscription_RootHfc_Card_Settings_By_PkArgs = {
  user: Scalars['String']['input'];
};


export type Subscription_RootHfc_Card_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Hfc_Card_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Hfc_Card_Settings_Bool_Exp>;
};


export type Subscription_RootHfc_User_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Order_By>>;
  where?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
};


export type Subscription_RootHfc_User_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Hfc_User_Settings_Order_By>>;
  where?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
};


export type Subscription_RootHfc_User_Settings_By_PkArgs = {
  user: Scalars['String']['input'];
};


export type Subscription_RootHfc_User_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Hfc_User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Hfc_User_Settings_Bool_Exp>;
};


export type Subscription_RootIncident_BannersArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Incident_Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Incident_Banners_Order_By>>;
  where?: InputMaybe<Incident_Banners_Bool_Exp>;
};


export type Subscription_RootIncident_Banners_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Incident_Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Incident_Banners_Order_By>>;
  where?: InputMaybe<Incident_Banners_Bool_Exp>;
};


export type Subscription_RootIncident_Banners_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootIncident_Banners_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Incident_Banners_Stream_Cursor_Input>>;
  where?: InputMaybe<Incident_Banners_Bool_Exp>;
};


export type Subscription_RootLive_Chart_AnnotationsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Order_By>>;
  where?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
};


export type Subscription_RootLive_Chart_Annotations_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Annotations_Order_By>>;
  where?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
};


export type Subscription_RootLive_Chart_Annotations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootLive_Chart_Annotations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Live_Chart_Annotations_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Chart_Annotations_Bool_Exp>;
};


export type Subscription_RootLive_Chart_PageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Page_Order_By>>;
  where?: InputMaybe<Live_Chart_Page_Bool_Exp>;
};


export type Subscription_RootLive_Chart_Page_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Page_Order_By>>;
  where?: InputMaybe<Live_Chart_Page_Bool_Exp>;
};


export type Subscription_RootLive_Chart_Page_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootLive_Chart_Page_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Live_Chart_Page_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Chart_Page_Bool_Exp>;
};


export type Subscription_RootLive_Chart_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Order_By>>;
  where?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
};


export type Subscription_RootLive_Chart_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Chart_Settings_Order_By>>;
  where?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
};


export type Subscription_RootLive_Chart_Settings_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


export type Subscription_RootLive_Chart_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Live_Chart_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Chart_Settings_Bool_Exp>;
};


export type Subscription_RootLive_Users_NewArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Users_New_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Users_New_Order_By>>;
  where?: InputMaybe<Live_Users_New_Bool_Exp>;
};


export type Subscription_RootLive_Users_New_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Live_Users_New_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Live_Users_New_Order_By>>;
  where?: InputMaybe<Live_Users_New_Bool_Exp>;
};


export type Subscription_RootLive_Users_New_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Live_Users_New_Stream_Cursor_Input>>;
  where?: InputMaybe<Live_Users_New_Bool_Exp>;
};


export type Subscription_RootLocal_InstrumentArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


export type Subscription_RootLocal_Instrument_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


export type Subscription_RootLocal_Instrument_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
  storage_type: User_Storage_Enum;
};


export type Subscription_RootLocal_Instrument_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Local_Instrument_Stream_Cursor_Input>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


export type Subscription_RootLogout_RequestArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


export type Subscription_RootLogout_Request_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Logout_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Logout_Request_Order_By>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


export type Subscription_RootLogout_Request_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLogout_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Logout_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Logout_Request_Bool_Exp>;
};


export type Subscription_RootModule_StorageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Module_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Module_Storage_Order_By>>;
  where?: InputMaybe<Module_Storage_Bool_Exp>;
};


export type Subscription_RootModule_Storage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Module_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Module_Storage_Order_By>>;
  where?: InputMaybe<Module_Storage_Bool_Exp>;
};


export type Subscription_RootModule_Storage_By_PkArgs = {
  key: Scalars['String']['input'];
  module: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type Subscription_RootModule_Storage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Module_Storage_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Storage_Bool_Exp>;
};


export type Subscription_RootOrganisationArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganisation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootPackageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


export type Subscription_RootPackage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Order_By>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


export type Subscription_RootPackage_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPackage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Package_Stream_Cursor_Input>>;
  where?: InputMaybe<Package_Bool_Exp>;
};


export type Subscription_RootPackage_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Type_Order_By>>;
  where?: InputMaybe<Package_Type_Bool_Exp>;
};


export type Subscription_RootPackage_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Package_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Package_Type_Order_By>>;
  where?: InputMaybe<Package_Type_Bool_Exp>;
};


export type Subscription_RootPackage_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPackage_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Package_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Package_Type_Bool_Exp>;
};


export type Subscription_RootPage_MemberArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


export type Subscription_RootPage_Member_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Member_Order_By>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


export type Subscription_RootPage_Member_By_PkArgs = {
  page_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type Subscription_RootPage_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Page_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Member_Bool_Exp>;
};


export type Subscription_RootPage_ProductsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Products_Order_By>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


export type Subscription_RootPage_Products_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Products_Order_By>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


export type Subscription_RootPage_Products_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPage_Products_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Page_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Products_Bool_Exp>;
};


export type Subscription_RootPage_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Settings_Order_By>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


export type Subscription_RootPage_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Page_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Page_Settings_Order_By>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


export type Subscription_RootPage_Settings_By_PkArgs = {
  folio_user: Scalars['String']['input'];
};


export type Subscription_RootPage_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Page_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Settings_Bool_Exp>;
};


export type Subscription_RootPagesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Subscription_RootPages_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Subscription_RootPages_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Pages_Stream_Cursor_Input>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Subscription_RootPermissionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Subscription_RootPermission_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Subscription_RootPermission_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  package: Scalars['Int']['input'];
};


export type Subscription_RootPermission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AlertsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Alerts_Order_By>>;
  where?: InputMaybe<Product_Alerts_Bool_Exp>;
};


export type Subscription_RootProduct_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Alerts_Order_By>>;
  where?: InputMaybe<Product_Alerts_Bool_Exp>;
};


export type Subscription_RootProduct_Alerts_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProduct_Alerts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Alerts_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Alerts_Bool_Exp>;
};


export type Subscription_RootProduct_Artis_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Artis_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Artis_Type_Order_By>>;
  where?: InputMaybe<Product_Artis_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Artis_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Artis_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Artis_Type_Order_By>>;
  where?: InputMaybe<Product_Artis_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Artis_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Artis_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Artis_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Artis_Type_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_ConfigArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Config_Order_By>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


export type Subscription_RootProduct_Config_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Config_Order_By>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


export type Subscription_RootProduct_Config_By_PkArgs = {
  product: Scalars['uuid']['input'];
  relative_month: Scalars['Int']['input'];
};


export type Subscription_RootProduct_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Config_Bool_Exp>;
};


export type Subscription_RootProduct_Curve_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Curve_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Curve_Type_Order_By>>;
  where?: InputMaybe<Product_Curve_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Curve_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Curve_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Curve_Type_Order_By>>;
  where?: InputMaybe<Product_Curve_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Curve_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Curve_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Curve_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Curve_Type_Bool_Exp>;
};


export type Subscription_RootProduct_EodArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


export type Subscription_RootProduct_Eod_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Eod_Order_By>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


export type Subscription_RootProduct_Eod_By_PkArgs = {
  eod_product: Scalars['uuid']['input'];
  product: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Eod_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Eod_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Eod_Bool_Exp>;
};


export type Subscription_RootProduct_Global_DependenciesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Order_By>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


export type Subscription_RootProduct_Global_Dependencies_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Global_Dependencies_Order_By>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


export type Subscription_RootProduct_Global_Dependencies_By_PkArgs = {
  global_product: Scalars['uuid']['input'];
  product: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Global_Dependencies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Global_Dependencies_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Global_Dependencies_Bool_Exp>;
};


export type Subscription_RootProduct_MaturityArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Maturity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Maturity_Order_By>>;
  where?: InputMaybe<Product_Maturity_Bool_Exp>;
};


export type Subscription_RootProduct_Maturity_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Maturity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Maturity_Order_By>>;
  where?: InputMaybe<Product_Maturity_Bool_Exp>;
};


export type Subscription_RootProduct_Maturity_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Maturity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Maturity_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Maturity_Bool_Exp>;
};


export type Subscription_RootProduct_OverridesArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


export type Subscription_RootProduct_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Overrides_Order_By>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


export type Subscription_RootProduct_Overrides_By_PkArgs = {
  organisation: Scalars['Int']['input'];
  product: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Overrides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Overrides_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Overrides_Bool_Exp>;
};


export type Subscription_RootProduct_SourceArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Source_Order_By>>;
  where?: InputMaybe<Product_Source_Bool_Exp>;
};


export type Subscription_RootProduct_Source_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Source_Order_By>>;
  where?: InputMaybe<Product_Source_Bool_Exp>;
};


export type Subscription_RootProduct_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Source_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_Summary_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Summary_Type_Order_By>>;
  where?: InputMaybe<Product_Summary_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Summary_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Summary_Type_Order_By>>;
  where?: InputMaybe<Product_Summary_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Summary_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Summary_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Summary_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Summary_Type_Bool_Exp>;
};


export type Subscription_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_UomArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Uom_Order_By>>;
  where?: InputMaybe<Product_Uom_Bool_Exp>;
};


export type Subscription_RootProduct_Uom_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_Uom_Order_By>>;
  where?: InputMaybe<Product_Uom_Bool_Exp>;
};


export type Subscription_RootProduct_Uom_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Uom_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_Uom_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Uom_Bool_Exp>;
};


export type Subscription_RootProduct_User_SettingsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_User_Settings_Order_By>>;
  where?: InputMaybe<Product_User_Settings_Bool_Exp>;
};


export type Subscription_RootProduct_User_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Product_User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Product_User_Settings_Order_By>>;
  where?: InputMaybe<Product_User_Settings_Bool_Exp>;
};


export type Subscription_RootProduct_User_Settings_By_PkArgs = {
  product_id: Scalars['uuid']['input'];
  user_id: Scalars['String']['input'];
};


export type Subscription_RootProduct_User_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Product_User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_User_Settings_Bool_Exp>;
};


export type Subscription_RootPush_SubscriptionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Push_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Push_Subscriptions_Order_By>>;
  where?: InputMaybe<Push_Subscriptions_Bool_Exp>;
};


export type Subscription_RootPush_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Push_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Push_Subscriptions_Order_By>>;
  where?: InputMaybe<Push_Subscriptions_Bool_Exp>;
};


export type Subscription_RootPush_Subscriptions_By_PkArgs = {
  user_id: Scalars['String']['input'];
};


export type Subscription_RootPush_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Push_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Push_Subscriptions_Bool_Exp>;
};


export type Subscription_RootQuick_AccessArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Quick_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Quick_Access_Order_By>>;
  where?: InputMaybe<Quick_Access_Bool_Exp>;
};


export type Subscription_RootQuick_Access_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Quick_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Quick_Access_Order_By>>;
  where?: InputMaybe<Quick_Access_Bool_Exp>;
};


export type Subscription_RootQuick_Access_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootQuick_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Quick_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Quick_Access_Bool_Exp>;
};


export type Subscription_RootScratchpadArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Scratchpad_Order_By>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


export type Subscription_RootScratchpad_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Scratchpad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Scratchpad_Order_By>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


export type Subscription_RootScratchpad_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  page_id: Scalars['String']['input'];
};


export type Subscription_RootScratchpad_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Scratchpad_Stream_Cursor_Input>>;
  where?: InputMaybe<Scratchpad_Bool_Exp>;
};


export type Subscription_RootSessionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Order_By>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


export type Subscription_RootSession_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Order_By>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


export type Subscription_RootSession_By_PkArgs = {
  folio_user: Scalars['String']['input'];
  is_mobile: Scalars['Boolean']['input'];
};


export type Subscription_RootSession_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Session_Bool_Exp>;
};


export type Subscription_RootSession_TypeArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Type_Order_By>>;
  where?: InputMaybe<Session_Type_Bool_Exp>;
};


export type Subscription_RootSession_Type_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Session_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Session_Type_Order_By>>;
  where?: InputMaybe<Session_Type_Bool_Exp>;
};


export type Subscription_RootSession_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSession_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Session_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Session_Type_Bool_Exp>;
};


export type Subscription_RootShared_InstrumentArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


export type Subscription_RootShared_Instrument_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Shared_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Shared_Instrument_Order_By>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


export type Subscription_RootShared_Instrument_By_PkArgs = {
  month: Scalars['date']['input'];
  product: Scalars['uuid']['input'];
};


export type Subscription_RootShared_Instrument_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Shared_Instrument_Stream_Cursor_Input>>;
  where?: InputMaybe<Shared_Instrument_Bool_Exp>;
};


export type Subscription_RootSharing_AgreementArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


export type Subscription_RootSharing_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Sharing_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Sharing_Agreement_Order_By>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


export type Subscription_RootSharing_Agreement_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSharing_Agreement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Sharing_Agreement_Stream_Cursor_Input>>;
  where?: InputMaybe<Sharing_Agreement_Bool_Exp>;
};


export type Subscription_RootSourceArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Source_Order_By>>;
  where?: InputMaybe<Source_Bool_Exp>;
};


export type Subscription_RootSource_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Source_Order_By>>;
  where?: InputMaybe<Source_Bool_Exp>;
};


export type Subscription_RootSource_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Source_Bool_Exp>;
};


export type Subscription_RootSpreader_StateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Spreader_State_Order_By>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};


export type Subscription_RootSpreader_State_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Spreader_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Spreader_State_Order_By>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};


export type Subscription_RootSpreader_State_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootSpreader_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Spreader_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Spreader_State_Bool_Exp>;
};


export type Subscription_RootSubscription_TierArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Subscription_Tier_Order_By>>;
  where?: InputMaybe<Subscription_Tier_Bool_Exp>;
};


export type Subscription_RootSubscription_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Subscription_Tier_Order_By>>;
  where?: InputMaybe<Subscription_Tier_Bool_Exp>;
};


export type Subscription_RootSubscription_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSubscription_Tier_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Subscription_Tier_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Tier_Bool_Exp>;
};


export type Subscription_RootUmi_ActionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Order_By>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};


export type Subscription_RootUmi_Action_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Order_By>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};


export type Subscription_RootUmi_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUmi_Action_NameArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Name_Order_By>>;
  where?: InputMaybe<Umi_Action_Name_Bool_Exp>;
};


export type Subscription_RootUmi_Action_Name_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Name_Order_By>>;
  where?: InputMaybe<Umi_Action_Name_Bool_Exp>;
};


export type Subscription_RootUmi_Action_Name_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUmi_Action_Name_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Umi_Action_Name_Stream_Cursor_Input>>;
  where?: InputMaybe<Umi_Action_Name_Bool_Exp>;
};


export type Subscription_RootUmi_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Umi_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};


export type Subscription_RootUser_EntitlementArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_ActiveArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Order_By>>;
  where?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_Active_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Order_By>>;
  where?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_Active_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Entitlement_Active_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Entitlement_KindArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Order_By>>;
  where?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Order_By>>;
  where?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_Kind_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUser_Entitlement_Kind_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Entitlement_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_LevelArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Order_By>>;
  where?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_Level_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Order_By>>;
  where?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_Level_By_PkArgs = {
  level: Scalars['smallint']['input'];
};


export type Subscription_RootUser_Entitlement_Level_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Entitlement_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
};


export type Subscription_RootUser_Entitlement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Entitlement_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


export type Subscription_RootUser_GroupsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Groups_Order_By>>;
  where?: InputMaybe<User_Groups_Bool_Exp>;
};


export type Subscription_RootUser_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Groups_Order_By>>;
  where?: InputMaybe<User_Groups_Bool_Exp>;
};


export type Subscription_RootUser_Groups_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootUser_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Groups_Bool_Exp>;
};


export type Subscription_RootUser_RightArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Right_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Right_Order_By>>;
  where?: InputMaybe<User_Right_Bool_Exp>;
};


export type Subscription_RootUser_Right_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Right_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Right_Order_By>>;
  where?: InputMaybe<User_Right_Bool_Exp>;
};


export type Subscription_RootUser_Right_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUser_Right_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Right_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Right_Bool_Exp>;
};


export type Subscription_RootUser_StorageArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Storage_Order_By>>;
  where?: InputMaybe<User_Storage_Bool_Exp>;
};


export type Subscription_RootUser_Storage_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Storage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Storage_Order_By>>;
  where?: InputMaybe<User_Storage_Bool_Exp>;
};


export type Subscription_RootUser_Storage_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUser_Storage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<User_Storage_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Storage_Bool_Exp>;
};


export type Subscription_RootUsers_Active_Last_DayArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Order_By>>;
  where?: InputMaybe<Users_Active_Last_Day_Bool_Exp>;
};


export type Subscription_RootUsers_Active_Last_Day_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Order_By>>;
  where?: InputMaybe<Users_Active_Last_Day_Bool_Exp>;
};


export type Subscription_RootUsers_Active_Last_Day_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Users_Active_Last_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Active_Last_Day_Bool_Exp>;
};


export type Subscription_RootViewed_AnnouncementsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Viewed_Announcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Viewed_Announcements_Order_By>>;
  where?: InputMaybe<Viewed_Announcements_Bool_Exp>;
};


export type Subscription_RootViewed_Announcements_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Viewed_Announcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Viewed_Announcements_Order_By>>;
  where?: InputMaybe<Viewed_Announcements_Bool_Exp>;
};


export type Subscription_RootViewed_Announcements_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootViewed_Announcements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: ReadonlyArray<InputMaybe<Viewed_Announcements_Stream_Cursor_Input>>;
  where?: InputMaybe<Viewed_Announcements_Bool_Exp>;
};

/** columns and relationships of "subscription_tier" */
export type Subscription_Tier = {
  readonly __typename?: 'subscription_tier';
  /** An array relationship */
  readonly user_subscription_tier: ReadonlyArray<Folio_User>;
  /** An aggregate relationship */
  readonly user_subscription_tier_aggregate: Folio_User_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "subscription_tier" */
export type Subscription_TierUser_Subscription_TierArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};


/** columns and relationships of "subscription_tier" */
export type Subscription_TierUser_Subscription_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Folio_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Folio_User_Order_By>>;
  where?: InputMaybe<Folio_User_Bool_Exp>;
};

/** aggregated selection of "subscription_tier" */
export type Subscription_Tier_Aggregate = {
  readonly __typename?: 'subscription_tier_aggregate';
  readonly aggregate?: Maybe<Subscription_Tier_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Subscription_Tier>;
};

/** aggregate fields of "subscription_tier" */
export type Subscription_Tier_Aggregate_Fields = {
  readonly __typename?: 'subscription_tier_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Subscription_Tier_Max_Fields>;
  readonly min?: Maybe<Subscription_Tier_Min_Fields>;
};


/** aggregate fields of "subscription_tier" */
export type Subscription_Tier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Subscription_Tier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "subscription_tier". All fields are combined with a logical 'AND'. */
export type Subscription_Tier_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Subscription_Tier_Bool_Exp>>;
  readonly _not?: InputMaybe<Subscription_Tier_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Subscription_Tier_Bool_Exp>>;
  readonly user_subscription_tier?: InputMaybe<Folio_User_Bool_Exp>;
  readonly user_subscription_tier_aggregate?: InputMaybe<Folio_User_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_tier" */
export type Subscription_Tier_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'subscription_tier_pkey';

export type Subscription_Tier_Enum =
  | 'artis_enhanced'
  | 'artis_enhanced_noexch'
  | 'artis_internal'
  | 'artis_lite'
  | 'artis_professional';

/** Boolean expression to compare columns of type "subscription_tier_enum". All fields are combined with logical 'AND'. */
export type Subscription_Tier_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Subscription_Tier_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Subscription_Tier_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Subscription_Tier_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Subscription_Tier_Enum>>;
};

/** input type for inserting data into table "subscription_tier" */
export type Subscription_Tier_Insert_Input = {
  readonly user_subscription_tier?: InputMaybe<Folio_User_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Subscription_Tier_Max_Fields = {
  readonly __typename?: 'subscription_tier_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Subscription_Tier_Min_Fields = {
  readonly __typename?: 'subscription_tier_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "subscription_tier" */
export type Subscription_Tier_Mutation_Response = {
  readonly __typename?: 'subscription_tier_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Subscription_Tier>;
};

/** input type for inserting object relation for remote table "subscription_tier" */
export type Subscription_Tier_Obj_Rel_Insert_Input = {
  readonly data: Subscription_Tier_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Subscription_Tier_On_Conflict>;
};

/** on_conflict condition type for table "subscription_tier" */
export type Subscription_Tier_On_Conflict = {
  readonly constraint: Subscription_Tier_Constraint;
  readonly update_columns?: ReadonlyArray<Subscription_Tier_Update_Column>;
  readonly where?: InputMaybe<Subscription_Tier_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_tier". */
export type Subscription_Tier_Order_By = {
  readonly user_subscription_tier_aggregate?: InputMaybe<Folio_User_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_tier */
export type Subscription_Tier_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "subscription_tier" */
export type Subscription_Tier_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "subscription_tier" */
export type Subscription_Tier_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "subscription_tier" */
export type Subscription_Tier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Subscription_Tier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Tier_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "subscription_tier" */
export type Subscription_Tier_Update_Column =
  /** column name */
  | 'value';

export type Subscription_Tier_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Subscription_Tier_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Subscription_Tier_Bool_Exp;
};

/** Boolean expression to compare columns of type "theme_enum". All fields are combined with logical 'AND'. */
export type Theme_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly _gt?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly _gte?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['theme_enum']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly _lte?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly _neq?: InputMaybe<Scalars['theme_enum']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['theme_enum']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['timestamptz']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "tstzrange". All fields are combined with logical 'AND'. */
export type Tstzrange_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['tstzrange']['input']>;
  readonly _gt?: InputMaybe<Scalars['tstzrange']['input']>;
  readonly _gte?: InputMaybe<Scalars['tstzrange']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['tstzrange']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['tstzrange']['input']>;
  readonly _lte?: InputMaybe<Scalars['tstzrange']['input']>;
  readonly _neq?: InputMaybe<Scalars['tstzrange']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['tstzrange']['input']>>;
};

/** High level UI actions performed in the umi admin interface with effected organization and specific users when applicable */
export type Umi_Action = {
  readonly __typename?: 'umi_action';
  readonly author: Scalars['String']['output'];
  readonly created_at: Scalars['timestamptz']['output'];
  readonly data?: Maybe<Scalars['jsonb']['output']>;
  readonly id: Scalars['uuid']['output'];
  readonly name: Umi_Action_Name_Enum;
  readonly org?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  readonly umi_action_name: Umi_Action_Name;
  readonly users?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};


/** High level UI actions performed in the umi admin interface with effected organization and specific users when applicable */
export type Umi_ActionDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "umi_action" */
export type Umi_Action_Aggregate = {
  readonly __typename?: 'umi_action_aggregate';
  readonly aggregate?: Maybe<Umi_Action_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Umi_Action>;
};

export type Umi_Action_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<Umi_Action_Aggregate_Bool_Exp_Count>;
};

export type Umi_Action_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<Umi_Action_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "umi_action" */
export type Umi_Action_Aggregate_Fields = {
  readonly __typename?: 'umi_action_aggregate_fields';
  readonly avg?: Maybe<Umi_Action_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Umi_Action_Max_Fields>;
  readonly min?: Maybe<Umi_Action_Min_Fields>;
  readonly stddev?: Maybe<Umi_Action_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Umi_Action_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Umi_Action_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Umi_Action_Sum_Fields>;
  readonly var_pop?: Maybe<Umi_Action_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Umi_Action_Var_Samp_Fields>;
  readonly variance?: Maybe<Umi_Action_Variance_Fields>;
};


/** aggregate fields of "umi_action" */
export type Umi_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "umi_action" */
export type Umi_Action_Aggregate_Order_By = {
  readonly avg?: InputMaybe<Umi_Action_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<Umi_Action_Max_Order_By>;
  readonly min?: InputMaybe<Umi_Action_Min_Order_By>;
  readonly stddev?: InputMaybe<Umi_Action_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<Umi_Action_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<Umi_Action_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<Umi_Action_Sum_Order_By>;
  readonly var_pop?: InputMaybe<Umi_Action_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<Umi_Action_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<Umi_Action_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Umi_Action_Append_Input = {
  readonly data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "umi_action" */
export type Umi_Action_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<Umi_Action_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Umi_Action_On_Conflict>;
};

/** aggregate avg on columns */
export type Umi_Action_Avg_Fields = {
  readonly __typename?: 'umi_action_avg_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "umi_action" */
export type Umi_Action_Avg_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "umi_action". All fields are combined with a logical 'AND'. */
export type Umi_Action_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Umi_Action_Bool_Exp>>;
  readonly _not?: InputMaybe<Umi_Action_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Umi_Action_Bool_Exp>>;
  readonly author?: InputMaybe<String_Comparison_Exp>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly data?: InputMaybe<Jsonb_Comparison_Exp>;
  readonly id?: InputMaybe<Uuid_Comparison_Exp>;
  readonly name?: InputMaybe<Umi_Action_Name_Enum_Comparison_Exp>;
  readonly org?: InputMaybe<Int_Comparison_Exp>;
  readonly umi_action_name?: InputMaybe<Umi_Action_Name_Bool_Exp>;
  readonly users?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "umi_action" */
export type Umi_Action_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'umi_action_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Umi_Action_Delete_At_Path_Input = {
  readonly data?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Umi_Action_Delete_Elem_Input = {
  readonly data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Umi_Action_Delete_Key_Input = {
  readonly data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "umi_action" */
export type Umi_Action_Inc_Input = {
  readonly org?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "umi_action" */
export type Umi_Action_Insert_Input = {
  readonly author?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly name?: InputMaybe<Umi_Action_Name_Enum>;
  readonly org?: InputMaybe<Scalars['Int']['input']>;
  readonly umi_action_name?: InputMaybe<Umi_Action_Name_Obj_Rel_Insert_Input>;
  readonly users?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Umi_Action_Max_Fields = {
  readonly __typename?: 'umi_action_max_fields';
  readonly author?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly org?: Maybe<Scalars['Int']['output']>;
  readonly users?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** order by max() on columns of table "umi_action" */
export type Umi_Action_Max_Order_By = {
  readonly author?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly org?: InputMaybe<Order_By>;
  readonly users?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Umi_Action_Min_Fields = {
  readonly __typename?: 'umi_action_min_fields';
  readonly author?: Maybe<Scalars['String']['output']>;
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly org?: Maybe<Scalars['Int']['output']>;
  readonly users?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** order by min() on columns of table "umi_action" */
export type Umi_Action_Min_Order_By = {
  readonly author?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly org?: InputMaybe<Order_By>;
  readonly users?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "umi_action" */
export type Umi_Action_Mutation_Response = {
  readonly __typename?: 'umi_action_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Umi_Action>;
};

/** columns and relationships of "umi_action_name" */
export type Umi_Action_Name = {
  readonly __typename?: 'umi_action_name';
  /** An array relationship */
  readonly umi_action: ReadonlyArray<Umi_Action>;
  /** An aggregate relationship */
  readonly umi_action_aggregate: Umi_Action_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "umi_action_name" */
export type Umi_Action_NameUmi_ActionArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Order_By>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};


/** columns and relationships of "umi_action_name" */
export type Umi_Action_NameUmi_Action_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Umi_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Umi_Action_Order_By>>;
  where?: InputMaybe<Umi_Action_Bool_Exp>;
};

/** aggregated selection of "umi_action_name" */
export type Umi_Action_Name_Aggregate = {
  readonly __typename?: 'umi_action_name_aggregate';
  readonly aggregate?: Maybe<Umi_Action_Name_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Umi_Action_Name>;
};

/** aggregate fields of "umi_action_name" */
export type Umi_Action_Name_Aggregate_Fields = {
  readonly __typename?: 'umi_action_name_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Umi_Action_Name_Max_Fields>;
  readonly min?: Maybe<Umi_Action_Name_Min_Fields>;
};


/** aggregate fields of "umi_action_name" */
export type Umi_Action_Name_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Umi_Action_Name_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "umi_action_name". All fields are combined with a logical 'AND'. */
export type Umi_Action_Name_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Umi_Action_Name_Bool_Exp>>;
  readonly _not?: InputMaybe<Umi_Action_Name_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Umi_Action_Name_Bool_Exp>>;
  readonly umi_action?: InputMaybe<Umi_Action_Bool_Exp>;
  readonly umi_action_aggregate?: InputMaybe<Umi_Action_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "umi_action_name" */
export type Umi_Action_Name_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'umi_action_name_pkey';

export type Umi_Action_Name_Enum =
  | 'create_sharing_agreement'
  | 'folder_created'
  | 'folder_updated'
  | 'logout_org_users'
  | 'org_created'
  | 'org_updated'
  | 'user_created'
  | 'user_entitlement_created'
  | 'user_entitlement_deleted'
  | 'user_entitlement_updated'
  | 'user_logged_out'
  | 'user_mfa_reset'
  | 'user_password_updated'
  | 'user_permission_updated'
  | 'user_refresh_requested'
  | 'user_settings_copied'
  | 'user_settings_deleted'
  | 'user_updated';

/** Boolean expression to compare columns of type "umi_action_name_enum". All fields are combined with logical 'AND'. */
export type Umi_Action_Name_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<Umi_Action_Name_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<Umi_Action_Name_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Umi_Action_Name_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<Umi_Action_Name_Enum>>;
};

/** input type for inserting data into table "umi_action_name" */
export type Umi_Action_Name_Insert_Input = {
  readonly umi_action?: InputMaybe<Umi_Action_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Umi_Action_Name_Max_Fields = {
  readonly __typename?: 'umi_action_name_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Umi_Action_Name_Min_Fields = {
  readonly __typename?: 'umi_action_name_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "umi_action_name" */
export type Umi_Action_Name_Mutation_Response = {
  readonly __typename?: 'umi_action_name_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Umi_Action_Name>;
};

/** input type for inserting object relation for remote table "umi_action_name" */
export type Umi_Action_Name_Obj_Rel_Insert_Input = {
  readonly data: Umi_Action_Name_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<Umi_Action_Name_On_Conflict>;
};

/** on_conflict condition type for table "umi_action_name" */
export type Umi_Action_Name_On_Conflict = {
  readonly constraint: Umi_Action_Name_Constraint;
  readonly update_columns?: ReadonlyArray<Umi_Action_Name_Update_Column>;
  readonly where?: InputMaybe<Umi_Action_Name_Bool_Exp>;
};

/** Ordering options when selecting data from "umi_action_name". */
export type Umi_Action_Name_Order_By = {
  readonly umi_action_aggregate?: InputMaybe<Umi_Action_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: umi_action_name */
export type Umi_Action_Name_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "umi_action_name" */
export type Umi_Action_Name_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "umi_action_name" */
export type Umi_Action_Name_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "umi_action_name" */
export type Umi_Action_Name_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Umi_Action_Name_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Umi_Action_Name_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "umi_action_name" */
export type Umi_Action_Name_Update_Column =
  /** column name */
  | 'value';

export type Umi_Action_Name_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Umi_Action_Name_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Umi_Action_Name_Bool_Exp;
};

/** on_conflict condition type for table "umi_action" */
export type Umi_Action_On_Conflict = {
  readonly constraint: Umi_Action_Constraint;
  readonly update_columns?: ReadonlyArray<Umi_Action_Update_Column>;
  readonly where?: InputMaybe<Umi_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "umi_action". */
export type Umi_Action_Order_By = {
  readonly author?: InputMaybe<Order_By>;
  readonly created_at?: InputMaybe<Order_By>;
  readonly data?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly name?: InputMaybe<Order_By>;
  readonly org?: InputMaybe<Order_By>;
  readonly umi_action_name?: InputMaybe<Umi_Action_Name_Order_By>;
  readonly users?: InputMaybe<Order_By>;
};

/** primary key columns input for table: umi_action */
export type Umi_Action_Pk_Columns_Input = {
  readonly id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Umi_Action_Prepend_Input = {
  readonly data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "umi_action" */
export type Umi_Action_Select_Column =
  /** column name */
  | 'author'
  /** column name */
  | 'created_at'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'org'
  /** column name */
  | 'users';

/** input type for updating data in table "umi_action" */
export type Umi_Action_Set_Input = {
  readonly author?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly name?: InputMaybe<Umi_Action_Name_Enum>;
  readonly org?: InputMaybe<Scalars['Int']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** aggregate stddev on columns */
export type Umi_Action_Stddev_Fields = {
  readonly __typename?: 'umi_action_stddev_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "umi_action" */
export type Umi_Action_Stddev_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Umi_Action_Stddev_Pop_Fields = {
  readonly __typename?: 'umi_action_stddev_pop_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "umi_action" */
export type Umi_Action_Stddev_Pop_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Umi_Action_Stddev_Samp_Fields = {
  readonly __typename?: 'umi_action_stddev_samp_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "umi_action" */
export type Umi_Action_Stddev_Samp_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "umi_action" */
export type Umi_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Umi_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Umi_Action_Stream_Cursor_Value_Input = {
  readonly author?: InputMaybe<Scalars['String']['input']>;
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly data?: InputMaybe<Scalars['jsonb']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly name?: InputMaybe<Umi_Action_Name_Enum>;
  readonly org?: InputMaybe<Scalars['Int']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** aggregate sum on columns */
export type Umi_Action_Sum_Fields = {
  readonly __typename?: 'umi_action_sum_fields';
  readonly org?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "umi_action" */
export type Umi_Action_Sum_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** update columns of table "umi_action" */
export type Umi_Action_Update_Column =
  /** column name */
  | 'author'
  /** column name */
  | 'created_at'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'org'
  /** column name */
  | 'users';

export type Umi_Action_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<Umi_Action_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<Umi_Action_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<Umi_Action_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<Umi_Action_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<Umi_Action_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<Umi_Action_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Umi_Action_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Umi_Action_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Umi_Action_Var_Pop_Fields = {
  readonly __typename?: 'umi_action_var_pop_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "umi_action" */
export type Umi_Action_Var_Pop_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Umi_Action_Var_Samp_Fields = {
  readonly __typename?: 'umi_action_var_samp_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "umi_action" */
export type Umi_Action_Var_Samp_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Umi_Action_Variance_Fields = {
  readonly __typename?: 'umi_action_variance_fields';
  readonly org?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "umi_action" */
export type Umi_Action_Variance_Order_By = {
  readonly org?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_entitlement" */
export type User_Entitlement = {
  readonly __typename?: 'user_entitlement';
  readonly created_at: Scalars['timestamptz']['output'];
  readonly end_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  readonly folio_user: Folio_User;
  readonly id: Scalars['uuid']['output'];
  readonly kind: User_Entitlement_Kind_Enum;
  readonly level: Scalars['smallint']['output'];
  readonly start_date: Scalars['timestamptz']['output'];
  readonly updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  readonly user_entitlement_kind: User_Entitlement_Kind;
  /** An object relationship */
  readonly user_entitlement_level: User_Entitlement_Level;
  readonly user_id: Scalars['String']['output'];
  readonly validity: Scalars['tstzrange']['output'];
};

/** columns and relationships of "user_entitlement_active" */
export type User_Entitlement_Active = {
  readonly __typename?: 'user_entitlement_active';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly expires_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
  /** An object relationship */
  readonly user?: Maybe<Folio_User>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_entitlement_active" */
export type User_Entitlement_Active_Aggregate = {
  readonly __typename?: 'user_entitlement_active_aggregate';
  readonly aggregate?: Maybe<User_Entitlement_Active_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Entitlement_Active>;
};

/** aggregate fields of "user_entitlement_active" */
export type User_Entitlement_Active_Aggregate_Fields = {
  readonly __typename?: 'user_entitlement_active_aggregate_fields';
  readonly avg?: Maybe<User_Entitlement_Active_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Entitlement_Active_Max_Fields>;
  readonly min?: Maybe<User_Entitlement_Active_Min_Fields>;
  readonly stddev?: Maybe<User_Entitlement_Active_Stddev_Fields>;
  readonly stddev_pop?: Maybe<User_Entitlement_Active_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<User_Entitlement_Active_Stddev_Samp_Fields>;
  readonly sum?: Maybe<User_Entitlement_Active_Sum_Fields>;
  readonly var_pop?: Maybe<User_Entitlement_Active_Var_Pop_Fields>;
  readonly var_samp?: Maybe<User_Entitlement_Active_Var_Samp_Fields>;
  readonly variance?: Maybe<User_Entitlement_Active_Variance_Fields>;
};


/** aggregate fields of "user_entitlement_active" */
export type User_Entitlement_Active_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Entitlement_Active_Avg_Fields = {
  readonly __typename?: 'user_entitlement_active_avg_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_entitlement_active". All fields are combined with a logical 'AND'. */
export type User_Entitlement_Active_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Entitlement_Active_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Entitlement_Active_Bool_Exp>>;
  readonly code?: InputMaybe<String_Comparison_Exp>;
  readonly expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly level?: InputMaybe<Smallint_Comparison_Exp>;
  readonly user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "user_entitlement_active" */
export type User_Entitlement_Active_Insert_Input = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
  readonly user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Entitlement_Active_Max_Fields = {
  readonly __typename?: 'user_entitlement_active_max_fields';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly expires_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Entitlement_Active_Min_Fields = {
  readonly __typename?: 'user_entitlement_active_min_fields';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly expires_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "user_entitlement_active" */
export type User_Entitlement_Active_Obj_Rel_Insert_Input = {
  readonly data: User_Entitlement_Active_Insert_Input;
};

/** Ordering options when selecting data from "user_entitlement_active". */
export type User_Entitlement_Active_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly expires_at?: InputMaybe<Order_By>;
  readonly level?: InputMaybe<Order_By>;
  readonly user?: InputMaybe<Folio_User_Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_entitlement_active" */
export type User_Entitlement_Active_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'level'
  /** column name */
  | 'user_id';

/** aggregate stddev on columns */
export type User_Entitlement_Active_Stddev_Fields = {
  readonly __typename?: 'user_entitlement_active_stddev_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Entitlement_Active_Stddev_Pop_Fields = {
  readonly __typename?: 'user_entitlement_active_stddev_pop_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Entitlement_Active_Stddev_Samp_Fields = {
  readonly __typename?: 'user_entitlement_active_stddev_samp_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_entitlement_active" */
export type User_Entitlement_Active_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Entitlement_Active_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Entitlement_Active_Stream_Cursor_Value_Input = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Entitlement_Active_Sum_Fields = {
  readonly __typename?: 'user_entitlement_active_sum_fields';
  readonly level?: Maybe<Scalars['smallint']['output']>;
};

/** aggregate var_pop on columns */
export type User_Entitlement_Active_Var_Pop_Fields = {
  readonly __typename?: 'user_entitlement_active_var_pop_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Entitlement_Active_Var_Samp_Fields = {
  readonly __typename?: 'user_entitlement_active_var_samp_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Entitlement_Active_Variance_Fields = {
  readonly __typename?: 'user_entitlement_active_variance_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "user_entitlement" */
export type User_Entitlement_Aggregate = {
  readonly __typename?: 'user_entitlement_aggregate';
  readonly aggregate?: Maybe<User_Entitlement_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Entitlement>;
};

export type User_Entitlement_Aggregate_Bool_Exp = {
  readonly count?: InputMaybe<User_Entitlement_Aggregate_Bool_Exp_Count>;
};

export type User_Entitlement_Aggregate_Bool_Exp_Count = {
  readonly arguments?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  readonly distinct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filter?: InputMaybe<User_Entitlement_Bool_Exp>;
  readonly predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_entitlement" */
export type User_Entitlement_Aggregate_Fields = {
  readonly __typename?: 'user_entitlement_aggregate_fields';
  readonly avg?: Maybe<User_Entitlement_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Entitlement_Max_Fields>;
  readonly min?: Maybe<User_Entitlement_Min_Fields>;
  readonly stddev?: Maybe<User_Entitlement_Stddev_Fields>;
  readonly stddev_pop?: Maybe<User_Entitlement_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<User_Entitlement_Stddev_Samp_Fields>;
  readonly sum?: Maybe<User_Entitlement_Sum_Fields>;
  readonly var_pop?: Maybe<User_Entitlement_Var_Pop_Fields>;
  readonly var_samp?: Maybe<User_Entitlement_Var_Samp_Fields>;
  readonly variance?: Maybe<User_Entitlement_Variance_Fields>;
};


/** aggregate fields of "user_entitlement" */
export type User_Entitlement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_entitlement" */
export type User_Entitlement_Aggregate_Order_By = {
  readonly avg?: InputMaybe<User_Entitlement_Avg_Order_By>;
  readonly count?: InputMaybe<Order_By>;
  readonly max?: InputMaybe<User_Entitlement_Max_Order_By>;
  readonly min?: InputMaybe<User_Entitlement_Min_Order_By>;
  readonly stddev?: InputMaybe<User_Entitlement_Stddev_Order_By>;
  readonly stddev_pop?: InputMaybe<User_Entitlement_Stddev_Pop_Order_By>;
  readonly stddev_samp?: InputMaybe<User_Entitlement_Stddev_Samp_Order_By>;
  readonly sum?: InputMaybe<User_Entitlement_Sum_Order_By>;
  readonly var_pop?: InputMaybe<User_Entitlement_Var_Pop_Order_By>;
  readonly var_samp?: InputMaybe<User_Entitlement_Var_Samp_Order_By>;
  readonly variance?: InputMaybe<User_Entitlement_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_entitlement" */
export type User_Entitlement_Arr_Rel_Insert_Input = {
  readonly data: ReadonlyArray<User_Entitlement_Insert_Input>;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<User_Entitlement_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Entitlement_Avg_Fields = {
  readonly __typename?: 'user_entitlement_avg_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_entitlement" */
export type User_Entitlement_Avg_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_entitlement". All fields are combined with a logical 'AND'. */
export type User_Entitlement_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Entitlement_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Entitlement_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Entitlement_Bool_Exp>>;
  readonly created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folio_user?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<Uuid_Comparison_Exp>;
  readonly kind?: InputMaybe<User_Entitlement_Kind_Enum_Comparison_Exp>;
  readonly level?: InputMaybe<Smallint_Comparison_Exp>;
  readonly start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly user_entitlement_kind?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
  readonly user_entitlement_level?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
  readonly validity?: InputMaybe<Tstzrange_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_entitlement" */
export type User_Entitlement_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_entitlement_pkey';

/** input type for incrementing numeric columns in table "user_entitlement" */
export type User_Entitlement_Inc_Input = {
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "user_entitlement" */
export type User_Entitlement_Insert_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folio_user?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly kind?: InputMaybe<User_Entitlement_Kind_Enum>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
  readonly start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_entitlement_kind?: InputMaybe<User_Entitlement_Kind_Obj_Rel_Insert_Input>;
  readonly user_entitlement_level?: InputMaybe<User_Entitlement_Level_Obj_Rel_Insert_Input>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "user_entitlement_kind" */
export type User_Entitlement_Kind = {
  readonly __typename?: 'user_entitlement_kind';
  /** An array relationship */
  readonly grants: ReadonlyArray<User_Entitlement>;
  /** An aggregate relationship */
  readonly grants_aggregate: User_Entitlement_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "user_entitlement_kind" */
export type User_Entitlement_KindGrantsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


/** columns and relationships of "user_entitlement_kind" */
export type User_Entitlement_KindGrants_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};

/** aggregated selection of "user_entitlement_kind" */
export type User_Entitlement_Kind_Aggregate = {
  readonly __typename?: 'user_entitlement_kind_aggregate';
  readonly aggregate?: Maybe<User_Entitlement_Kind_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Entitlement_Kind>;
};

/** aggregate fields of "user_entitlement_kind" */
export type User_Entitlement_Kind_Aggregate_Fields = {
  readonly __typename?: 'user_entitlement_kind_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Entitlement_Kind_Max_Fields>;
  readonly min?: Maybe<User_Entitlement_Kind_Min_Fields>;
};


/** aggregate fields of "user_entitlement_kind" */
export type User_Entitlement_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_entitlement_kind". All fields are combined with a logical 'AND'. */
export type User_Entitlement_Kind_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Bool_Exp>>;
  readonly grants?: InputMaybe<User_Entitlement_Bool_Exp>;
  readonly grants_aggregate?: InputMaybe<User_Entitlement_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_entitlement_kind" */
export type User_Entitlement_Kind_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_entitlement_kind_pkey';

export type User_Entitlement_Kind_Enum =
  | 'paid'
  | 'trial';

/** Boolean expression to compare columns of type "user_entitlement_kind_enum". All fields are combined with logical 'AND'. */
export type User_Entitlement_Kind_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<User_Entitlement_Kind_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<User_Entitlement_Kind_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<User_Entitlement_Kind_Enum>>;
};

/** input type for inserting data into table "user_entitlement_kind" */
export type User_Entitlement_Kind_Insert_Input = {
  readonly grants?: InputMaybe<User_Entitlement_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Entitlement_Kind_Max_Fields = {
  readonly __typename?: 'user_entitlement_kind_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Entitlement_Kind_Min_Fields = {
  readonly __typename?: 'user_entitlement_kind_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_entitlement_kind" */
export type User_Entitlement_Kind_Mutation_Response = {
  readonly __typename?: 'user_entitlement_kind_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<User_Entitlement_Kind>;
};

/** input type for inserting object relation for remote table "user_entitlement_kind" */
export type User_Entitlement_Kind_Obj_Rel_Insert_Input = {
  readonly data: User_Entitlement_Kind_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<User_Entitlement_Kind_On_Conflict>;
};

/** on_conflict condition type for table "user_entitlement_kind" */
export type User_Entitlement_Kind_On_Conflict = {
  readonly constraint: User_Entitlement_Kind_Constraint;
  readonly update_columns?: ReadonlyArray<User_Entitlement_Kind_Update_Column>;
  readonly where?: InputMaybe<User_Entitlement_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "user_entitlement_kind". */
export type User_Entitlement_Kind_Order_By = {
  readonly grants_aggregate?: InputMaybe<User_Entitlement_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_entitlement_kind */
export type User_Entitlement_Kind_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "user_entitlement_kind" */
export type User_Entitlement_Kind_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "user_entitlement_kind" */
export type User_Entitlement_Kind_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_entitlement_kind" */
export type User_Entitlement_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Entitlement_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Entitlement_Kind_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_entitlement_kind" */
export type User_Entitlement_Kind_Update_Column =
  /** column name */
  | 'value';

export type User_Entitlement_Kind_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<User_Entitlement_Kind_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: User_Entitlement_Kind_Bool_Exp;
};

/** columns and relationships of "user_entitlement_level" */
export type User_Entitlement_Level = {
  readonly __typename?: 'user_entitlement_level';
  readonly code: Scalars['String']['output'];
  /** An array relationship */
  readonly grants: ReadonlyArray<User_Entitlement>;
  /** An aggregate relationship */
  readonly grants_aggregate: User_Entitlement_Aggregate;
  readonly level: Scalars['smallint']['output'];
};


/** columns and relationships of "user_entitlement_level" */
export type User_Entitlement_LevelGrantsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};


/** columns and relationships of "user_entitlement_level" */
export type User_Entitlement_LevelGrants_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<User_Entitlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<User_Entitlement_Order_By>>;
  where?: InputMaybe<User_Entitlement_Bool_Exp>;
};

/** aggregated selection of "user_entitlement_level" */
export type User_Entitlement_Level_Aggregate = {
  readonly __typename?: 'user_entitlement_level_aggregate';
  readonly aggregate?: Maybe<User_Entitlement_Level_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Entitlement_Level>;
};

/** aggregate fields of "user_entitlement_level" */
export type User_Entitlement_Level_Aggregate_Fields = {
  readonly __typename?: 'user_entitlement_level_aggregate_fields';
  readonly avg?: Maybe<User_Entitlement_Level_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Entitlement_Level_Max_Fields>;
  readonly min?: Maybe<User_Entitlement_Level_Min_Fields>;
  readonly stddev?: Maybe<User_Entitlement_Level_Stddev_Fields>;
  readonly stddev_pop?: Maybe<User_Entitlement_Level_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<User_Entitlement_Level_Stddev_Samp_Fields>;
  readonly sum?: Maybe<User_Entitlement_Level_Sum_Fields>;
  readonly var_pop?: Maybe<User_Entitlement_Level_Var_Pop_Fields>;
  readonly var_samp?: Maybe<User_Entitlement_Level_Var_Samp_Fields>;
  readonly variance?: Maybe<User_Entitlement_Level_Variance_Fields>;
};


/** aggregate fields of "user_entitlement_level" */
export type User_Entitlement_Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Entitlement_Level_Avg_Fields = {
  readonly __typename?: 'user_entitlement_level_avg_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_entitlement_level". All fields are combined with a logical 'AND'. */
export type User_Entitlement_Level_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Entitlement_Level_Bool_Exp>>;
  readonly code?: InputMaybe<String_Comparison_Exp>;
  readonly grants?: InputMaybe<User_Entitlement_Bool_Exp>;
  readonly grants_aggregate?: InputMaybe<User_Entitlement_Aggregate_Bool_Exp>;
  readonly level?: InputMaybe<Smallint_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_entitlement_level" */
export type User_Entitlement_Level_Constraint =
  /** unique or primary key constraint on columns "code" */
  | 'user_entitlement_level_code_key'
  /** unique or primary key constraint on columns "level" */
  | 'user_entitlement_level_pkey';

/** input type for incrementing numeric columns in table "user_entitlement_level" */
export type User_Entitlement_Level_Inc_Input = {
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "user_entitlement_level" */
export type User_Entitlement_Level_Insert_Input = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly grants?: InputMaybe<User_Entitlement_Arr_Rel_Insert_Input>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate max on columns */
export type User_Entitlement_Level_Max_Fields = {
  readonly __typename?: 'user_entitlement_level_max_fields';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
};

/** aggregate min on columns */
export type User_Entitlement_Level_Min_Fields = {
  readonly __typename?: 'user_entitlement_level_min_fields';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
};

/** response of any mutation on the table "user_entitlement_level" */
export type User_Entitlement_Level_Mutation_Response = {
  readonly __typename?: 'user_entitlement_level_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<User_Entitlement_Level>;
};

/** input type for inserting object relation for remote table "user_entitlement_level" */
export type User_Entitlement_Level_Obj_Rel_Insert_Input = {
  readonly data: User_Entitlement_Level_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<User_Entitlement_Level_On_Conflict>;
};

/** on_conflict condition type for table "user_entitlement_level" */
export type User_Entitlement_Level_On_Conflict = {
  readonly constraint: User_Entitlement_Level_Constraint;
  readonly update_columns?: ReadonlyArray<User_Entitlement_Level_Update_Column>;
  readonly where?: InputMaybe<User_Entitlement_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "user_entitlement_level". */
export type User_Entitlement_Level_Order_By = {
  readonly code?: InputMaybe<Order_By>;
  readonly grants_aggregate?: InputMaybe<User_Entitlement_Aggregate_Order_By>;
  readonly level?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_entitlement_level */
export type User_Entitlement_Level_Pk_Columns_Input = {
  readonly level: Scalars['smallint']['input'];
};

/** select columns of table "user_entitlement_level" */
export type User_Entitlement_Level_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'level';

/** input type for updating data in table "user_entitlement_level" */
export type User_Entitlement_Level_Set_Input = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate stddev on columns */
export type User_Entitlement_Level_Stddev_Fields = {
  readonly __typename?: 'user_entitlement_level_stddev_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Entitlement_Level_Stddev_Pop_Fields = {
  readonly __typename?: 'user_entitlement_level_stddev_pop_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Entitlement_Level_Stddev_Samp_Fields = {
  readonly __typename?: 'user_entitlement_level_stddev_samp_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_entitlement_level" */
export type User_Entitlement_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Entitlement_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Entitlement_Level_Stream_Cursor_Value_Input = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type User_Entitlement_Level_Sum_Fields = {
  readonly __typename?: 'user_entitlement_level_sum_fields';
  readonly level?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "user_entitlement_level" */
export type User_Entitlement_Level_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'level';

export type User_Entitlement_Level_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<User_Entitlement_Level_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<User_Entitlement_Level_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: User_Entitlement_Level_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Entitlement_Level_Var_Pop_Fields = {
  readonly __typename?: 'user_entitlement_level_var_pop_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Entitlement_Level_Var_Samp_Fields = {
  readonly __typename?: 'user_entitlement_level_var_samp_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Entitlement_Level_Variance_Fields = {
  readonly __typename?: 'user_entitlement_level_variance_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type User_Entitlement_Max_Fields = {
  readonly __typename?: 'user_entitlement_max_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly end_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
  readonly start_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_entitlement" */
export type User_Entitlement_Max_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly end_date?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly level?: InputMaybe<Order_By>;
  readonly start_date?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Entitlement_Min_Fields = {
  readonly __typename?: 'user_entitlement_min_fields';
  readonly created_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly end_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['uuid']['output']>;
  readonly level?: Maybe<Scalars['smallint']['output']>;
  readonly start_date?: Maybe<Scalars['timestamptz']['output']>;
  readonly updated_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_entitlement" */
export type User_Entitlement_Min_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly end_date?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly level?: InputMaybe<Order_By>;
  readonly start_date?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_entitlement" */
export type User_Entitlement_Mutation_Response = {
  readonly __typename?: 'user_entitlement_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<User_Entitlement>;
};

/** on_conflict condition type for table "user_entitlement" */
export type User_Entitlement_On_Conflict = {
  readonly constraint: User_Entitlement_Constraint;
  readonly update_columns?: ReadonlyArray<User_Entitlement_Update_Column>;
  readonly where?: InputMaybe<User_Entitlement_Bool_Exp>;
};

/** Ordering options when selecting data from "user_entitlement". */
export type User_Entitlement_Order_By = {
  readonly created_at?: InputMaybe<Order_By>;
  readonly end_date?: InputMaybe<Order_By>;
  readonly folio_user?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly kind?: InputMaybe<Order_By>;
  readonly level?: InputMaybe<Order_By>;
  readonly start_date?: InputMaybe<Order_By>;
  readonly updated_at?: InputMaybe<Order_By>;
  readonly user_entitlement_kind?: InputMaybe<User_Entitlement_Kind_Order_By>;
  readonly user_entitlement_level?: InputMaybe<User_Entitlement_Level_Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
  readonly validity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_entitlement */
export type User_Entitlement_Pk_Columns_Input = {
  readonly id: Scalars['uuid']['input'];
};

/** select columns of table "user_entitlement" */
export type User_Entitlement_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'end_date'
  /** column name */
  | 'id'
  /** column name */
  | 'kind'
  /** column name */
  | 'level'
  /** column name */
  | 'start_date'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id'
  /** column name */
  | 'validity';

/** input type for updating data in table "user_entitlement" */
export type User_Entitlement_Set_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly kind?: InputMaybe<User_Entitlement_Kind_Enum>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
  readonly start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Entitlement_Stddev_Fields = {
  readonly __typename?: 'user_entitlement_stddev_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_entitlement" */
export type User_Entitlement_Stddev_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Entitlement_Stddev_Pop_Fields = {
  readonly __typename?: 'user_entitlement_stddev_pop_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_entitlement" */
export type User_Entitlement_Stddev_Pop_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Entitlement_Stddev_Samp_Fields = {
  readonly __typename?: 'user_entitlement_stddev_samp_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_entitlement" */
export type User_Entitlement_Stddev_Samp_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_entitlement" */
export type User_Entitlement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Entitlement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Entitlement_Stream_Cursor_Value_Input = {
  readonly created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['uuid']['input']>;
  readonly kind?: InputMaybe<User_Entitlement_Kind_Enum>;
  readonly level?: InputMaybe<Scalars['smallint']['input']>;
  readonly start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly validity?: InputMaybe<Scalars['tstzrange']['input']>;
};

/** aggregate sum on columns */
export type User_Entitlement_Sum_Fields = {
  readonly __typename?: 'user_entitlement_sum_fields';
  readonly level?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "user_entitlement" */
export type User_Entitlement_Sum_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** update columns of table "user_entitlement" */
export type User_Entitlement_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'end_date'
  /** column name */
  | 'id'
  /** column name */
  | 'kind'
  /** column name */
  | 'level'
  /** column name */
  | 'start_date'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export type User_Entitlement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  readonly _inc?: InputMaybe<User_Entitlement_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<User_Entitlement_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: User_Entitlement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Entitlement_Var_Pop_Fields = {
  readonly __typename?: 'user_entitlement_var_pop_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_entitlement" */
export type User_Entitlement_Var_Pop_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Entitlement_Var_Samp_Fields = {
  readonly __typename?: 'user_entitlement_var_samp_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_entitlement" */
export type User_Entitlement_Var_Samp_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Entitlement_Variance_Fields = {
  readonly __typename?: 'user_entitlement_variance_fields';
  readonly level?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_entitlement" */
export type User_Entitlement_Variance_Order_By = {
  readonly level?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_groups" */
export type User_Groups = {
  readonly __typename?: 'user_groups';
  readonly display_name: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly users?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "user_groups" */
export type User_GroupsUsersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_groups" */
export type User_Groups_Aggregate = {
  readonly __typename?: 'user_groups_aggregate';
  readonly aggregate?: Maybe<User_Groups_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Groups>;
};

/** aggregate fields of "user_groups" */
export type User_Groups_Aggregate_Fields = {
  readonly __typename?: 'user_groups_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Groups_Max_Fields>;
  readonly min?: Maybe<User_Groups_Min_Fields>;
};


/** aggregate fields of "user_groups" */
export type User_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Groups_Append_Input = {
  readonly users?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type User_Groups_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Groups_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Groups_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Groups_Bool_Exp>>;
  readonly display_name?: InputMaybe<String_Comparison_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly users?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_groups" */
export type User_Groups_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_groups_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Groups_Delete_At_Path_Input = {
  readonly users?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Groups_Delete_Elem_Input = {
  readonly users?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Groups_Delete_Key_Input = {
  readonly users?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "user_groups" */
export type User_Groups_Insert_Input = {
  readonly display_name?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type User_Groups_Max_Fields = {
  readonly __typename?: 'user_groups_max_fields';
  readonly display_name?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Groups_Min_Fields = {
  readonly __typename?: 'user_groups_min_fields';
  readonly display_name?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_groups" */
export type User_Groups_Mutation_Response = {
  readonly __typename?: 'user_groups_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<User_Groups>;
};

/** on_conflict condition type for table "user_groups" */
export type User_Groups_On_Conflict = {
  readonly constraint: User_Groups_Constraint;
  readonly update_columns?: ReadonlyArray<User_Groups_Update_Column>;
  readonly where?: InputMaybe<User_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "user_groups". */
export type User_Groups_Order_By = {
  readonly display_name?: InputMaybe<Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly users?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_groups */
export type User_Groups_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Groups_Prepend_Input = {
  readonly users?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_groups" */
export type User_Groups_Select_Column =
  /** column name */
  | 'display_name'
  /** column name */
  | 'id'
  /** column name */
  | 'users';

/** input type for updating data in table "user_groups" */
export type User_Groups_Set_Input = {
  readonly display_name?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "user_groups" */
export type User_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Groups_Stream_Cursor_Value_Input = {
  readonly display_name?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "user_groups" */
export type User_Groups_Update_Column =
  /** column name */
  | 'display_name'
  /** column name */
  | 'id'
  /** column name */
  | 'users';

export type User_Groups_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  readonly _append?: InputMaybe<User_Groups_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  readonly _delete_at_path?: InputMaybe<User_Groups_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  readonly _delete_elem?: InputMaybe<User_Groups_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  readonly _delete_key?: InputMaybe<User_Groups_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  readonly _prepend?: InputMaybe<User_Groups_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<User_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: User_Groups_Bool_Exp;
};

/** columns and relationships of "user_right" */
export type User_Right = {
  readonly __typename?: 'user_right';
  /** An array relationship */
  readonly global_permissions: ReadonlyArray<Global_Permission>;
  /** An aggregate relationship */
  readonly global_permissions_aggregate: Global_Permission_Aggregate;
  /** An array relationship */
  readonly permissions: ReadonlyArray<Permission>;
  /** An aggregate relationship */
  readonly permissions_aggregate: Permission_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "user_right" */
export type User_RightGlobal_PermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


/** columns and relationships of "user_right" */
export type User_RightGlobal_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Global_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Global_Permission_Order_By>>;
  where?: InputMaybe<Global_Permission_Bool_Exp>;
};


/** columns and relationships of "user_right" */
export type User_RightPermissionsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


/** columns and relationships of "user_right" */
export type User_RightPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};

/** aggregated selection of "user_right" */
export type User_Right_Aggregate = {
  readonly __typename?: 'user_right_aggregate';
  readonly aggregate?: Maybe<User_Right_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Right>;
};

/** aggregate fields of "user_right" */
export type User_Right_Aggregate_Fields = {
  readonly __typename?: 'user_right_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Right_Max_Fields>;
  readonly min?: Maybe<User_Right_Min_Fields>;
};


/** aggregate fields of "user_right" */
export type User_Right_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Right_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_right". All fields are combined with a logical 'AND'. */
export type User_Right_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Right_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Right_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Right_Bool_Exp>>;
  readonly global_permissions?: InputMaybe<Global_Permission_Bool_Exp>;
  readonly global_permissions_aggregate?: InputMaybe<Global_Permission_Aggregate_Bool_Exp>;
  readonly permissions?: InputMaybe<Permission_Bool_Exp>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_right" */
export type User_Right_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_right_pkey';

export type User_Right_Enum =
  | 'broadcast'
  | 'list'
  | 'read'
  | 'write';

/** Boolean expression to compare columns of type "user_right_enum". All fields are combined with logical 'AND'. */
export type User_Right_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<User_Right_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<User_Right_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<User_Right_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<User_Right_Enum>>;
};

/** input type for inserting data into table "user_right" */
export type User_Right_Insert_Input = {
  readonly global_permissions?: InputMaybe<Global_Permission_Arr_Rel_Insert_Input>;
  readonly permissions?: InputMaybe<Permission_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Right_Max_Fields = {
  readonly __typename?: 'user_right_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Right_Min_Fields = {
  readonly __typename?: 'user_right_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_right" */
export type User_Right_Mutation_Response = {
  readonly __typename?: 'user_right_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<User_Right>;
};

/** input type for inserting object relation for remote table "user_right" */
export type User_Right_Obj_Rel_Insert_Input = {
  readonly data: User_Right_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<User_Right_On_Conflict>;
};

/** on_conflict condition type for table "user_right" */
export type User_Right_On_Conflict = {
  readonly constraint: User_Right_Constraint;
  readonly update_columns?: ReadonlyArray<User_Right_Update_Column>;
  readonly where?: InputMaybe<User_Right_Bool_Exp>;
};

/** Ordering options when selecting data from "user_right". */
export type User_Right_Order_By = {
  readonly global_permissions_aggregate?: InputMaybe<Global_Permission_Aggregate_Order_By>;
  readonly permissions_aggregate?: InputMaybe<Permission_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_right */
export type User_Right_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "user_right" */
export type User_Right_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "user_right" */
export type User_Right_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_right" */
export type User_Right_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Right_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Right_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_right" */
export type User_Right_Update_Column =
  /** column name */
  | 'value';

export type User_Right_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<User_Right_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: User_Right_Bool_Exp;
};

/** columns and relationships of "user_storage" */
export type User_Storage = {
  readonly __typename?: 'user_storage';
  /** An array relationship */
  readonly local_instruments: ReadonlyArray<Local_Instrument>;
  /** An aggregate relationship */
  readonly local_instruments_aggregate: Local_Instrument_Aggregate;
  readonly value: Scalars['String']['output'];
};


/** columns and relationships of "user_storage" */
export type User_StorageLocal_InstrumentsArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};


/** columns and relationships of "user_storage" */
export type User_StorageLocal_Instruments_AggregateArgs = {
  distinct_on?: InputMaybe<ReadonlyArray<Local_Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<Local_Instrument_Order_By>>;
  where?: InputMaybe<Local_Instrument_Bool_Exp>;
};

/** aggregated selection of "user_storage" */
export type User_Storage_Aggregate = {
  readonly __typename?: 'user_storage_aggregate';
  readonly aggregate?: Maybe<User_Storage_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<User_Storage>;
};

/** aggregate fields of "user_storage" */
export type User_Storage_Aggregate_Fields = {
  readonly __typename?: 'user_storage_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<User_Storage_Max_Fields>;
  readonly min?: Maybe<User_Storage_Min_Fields>;
};


/** aggregate fields of "user_storage" */
export type User_Storage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<User_Storage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_storage". All fields are combined with a logical 'AND'. */
export type User_Storage_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<User_Storage_Bool_Exp>>;
  readonly _not?: InputMaybe<User_Storage_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<User_Storage_Bool_Exp>>;
  readonly local_instruments?: InputMaybe<Local_Instrument_Bool_Exp>;
  readonly local_instruments_aggregate?: InputMaybe<Local_Instrument_Aggregate_Bool_Exp>;
  readonly value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_storage" */
export type User_Storage_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_storage_pkey';

export type User_Storage_Enum =
  | 'broadcast'
  | 'local';

/** Boolean expression to compare columns of type "user_storage_enum". All fields are combined with logical 'AND'. */
export type User_Storage_Enum_Comparison_Exp = {
  readonly _eq?: InputMaybe<User_Storage_Enum>;
  readonly _in?: InputMaybe<ReadonlyArray<User_Storage_Enum>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<User_Storage_Enum>;
  readonly _nin?: InputMaybe<ReadonlyArray<User_Storage_Enum>>;
};

/** input type for inserting data into table "user_storage" */
export type User_Storage_Insert_Input = {
  readonly local_instruments?: InputMaybe<Local_Instrument_Arr_Rel_Insert_Input>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Storage_Max_Fields = {
  readonly __typename?: 'user_storage_max_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Storage_Min_Fields = {
  readonly __typename?: 'user_storage_min_fields';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_storage" */
export type User_Storage_Mutation_Response = {
  readonly __typename?: 'user_storage_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<User_Storage>;
};

/** input type for inserting object relation for remote table "user_storage" */
export type User_Storage_Obj_Rel_Insert_Input = {
  readonly data: User_Storage_Insert_Input;
  /** upsert condition */
  readonly on_conflict?: InputMaybe<User_Storage_On_Conflict>;
};

/** on_conflict condition type for table "user_storage" */
export type User_Storage_On_Conflict = {
  readonly constraint: User_Storage_Constraint;
  readonly update_columns?: ReadonlyArray<User_Storage_Update_Column>;
  readonly where?: InputMaybe<User_Storage_Bool_Exp>;
};

/** Ordering options when selecting data from "user_storage". */
export type User_Storage_Order_By = {
  readonly local_instruments_aggregate?: InputMaybe<Local_Instrument_Aggregate_Order_By>;
  readonly value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_storage */
export type User_Storage_Pk_Columns_Input = {
  readonly value: Scalars['String']['input'];
};

/** select columns of table "user_storage" */
export type User_Storage_Select_Column =
  /** column name */
  | 'value';

/** input type for updating data in table "user_storage" */
export type User_Storage_Set_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_storage" */
export type User_Storage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: User_Storage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Storage_Stream_Cursor_Value_Input = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_storage" */
export type User_Storage_Update_Column =
  /** column name */
  | 'value';

export type User_Storage_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<User_Storage_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: User_Storage_Bool_Exp;
};

/** columns and relationships of "users_active_last_day" */
export type Users_Active_Last_Day = {
  readonly __typename?: 'users_active_last_day';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "users_active_last_day" */
export type Users_Active_Last_Day_Aggregate = {
  readonly __typename?: 'users_active_last_day_aggregate';
  readonly aggregate?: Maybe<Users_Active_Last_Day_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Users_Active_Last_Day>;
};

/** aggregate fields of "users_active_last_day" */
export type Users_Active_Last_Day_Aggregate_Fields = {
  readonly __typename?: 'users_active_last_day_aggregate_fields';
  readonly avg?: Maybe<Users_Active_Last_Day_Avg_Fields>;
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Users_Active_Last_Day_Max_Fields>;
  readonly min?: Maybe<Users_Active_Last_Day_Min_Fields>;
  readonly stddev?: Maybe<Users_Active_Last_Day_Stddev_Fields>;
  readonly stddev_pop?: Maybe<Users_Active_Last_Day_Stddev_Pop_Fields>;
  readonly stddev_samp?: Maybe<Users_Active_Last_Day_Stddev_Samp_Fields>;
  readonly sum?: Maybe<Users_Active_Last_Day_Sum_Fields>;
  readonly var_pop?: Maybe<Users_Active_Last_Day_Var_Pop_Fields>;
  readonly var_samp?: Maybe<Users_Active_Last_Day_Var_Samp_Fields>;
  readonly variance?: Maybe<Users_Active_Last_Day_Variance_Fields>;
};


/** aggregate fields of "users_active_last_day" */
export type Users_Active_Last_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Active_Last_Day_Avg_Fields = {
  readonly __typename?: 'users_active_last_day_avg_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users_active_last_day". All fields are combined with a logical 'AND'. */
export type Users_Active_Last_Day_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Bool_Exp>>;
  readonly _not?: InputMaybe<Users_Active_Last_Day_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Users_Active_Last_Day_Bool_Exp>>;
  readonly folio_user?: InputMaybe<String_Comparison_Exp>;
  readonly organisation?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Users_Active_Last_Day_Max_Fields = {
  readonly __typename?: 'users_active_last_day_max_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Users_Active_Last_Day_Min_Fields = {
  readonly __typename?: 'users_active_last_day_min_fields';
  readonly folio_user?: Maybe<Scalars['String']['output']>;
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "users_active_last_day". */
export type Users_Active_Last_Day_Order_By = {
  readonly folio_user?: InputMaybe<Order_By>;
  readonly organisation?: InputMaybe<Order_By>;
};

/** select columns of table "users_active_last_day" */
export type Users_Active_Last_Day_Select_Column =
  /** column name */
  | 'folio_user'
  /** column name */
  | 'organisation';

/** aggregate stddev on columns */
export type Users_Active_Last_Day_Stddev_Fields = {
  readonly __typename?: 'users_active_last_day_stddev_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Active_Last_Day_Stddev_Pop_Fields = {
  readonly __typename?: 'users_active_last_day_stddev_pop_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Active_Last_Day_Stddev_Samp_Fields = {
  readonly __typename?: 'users_active_last_day_stddev_samp_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users_active_last_day" */
export type Users_Active_Last_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Users_Active_Last_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Active_Last_Day_Stream_Cursor_Value_Input = {
  readonly folio_user?: InputMaybe<Scalars['String']['input']>;
  readonly organisation?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_Active_Last_Day_Sum_Fields = {
  readonly __typename?: 'users_active_last_day_sum_fields';
  readonly organisation?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Users_Active_Last_Day_Var_Pop_Fields = {
  readonly __typename?: 'users_active_last_day_var_pop_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Active_Last_Day_Var_Samp_Fields = {
  readonly __typename?: 'users_active_last_day_var_samp_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Active_Last_Day_Variance_Fields = {
  readonly __typename?: 'users_active_last_day_variance_fields';
  readonly organisation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  readonly _eq?: InputMaybe<Scalars['uuid']['input']>;
  readonly _gt?: InputMaybe<Scalars['uuid']['input']>;
  readonly _gte?: InputMaybe<Scalars['uuid']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['uuid']['input']>>;
  readonly _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _lt?: InputMaybe<Scalars['uuid']['input']>;
  readonly _lte?: InputMaybe<Scalars['uuid']['input']>;
  readonly _neq?: InputMaybe<Scalars['uuid']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['uuid']['input']>>;
};

/** columns and relationships of "viewed_announcements" */
export type Viewed_Announcements = {
  readonly __typename?: 'viewed_announcements';
  readonly announcement_id: Scalars['String']['output'];
  readonly dismissed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  readonly folioUserByFolioUser: Folio_User;
  readonly id: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly user_id: Scalars['String']['output'];
  readonly viewed_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "viewed_announcements" */
export type Viewed_Announcements_Aggregate = {
  readonly __typename?: 'viewed_announcements_aggregate';
  readonly aggregate?: Maybe<Viewed_Announcements_Aggregate_Fields>;
  readonly nodes: ReadonlyArray<Viewed_Announcements>;
};

/** aggregate fields of "viewed_announcements" */
export type Viewed_Announcements_Aggregate_Fields = {
  readonly __typename?: 'viewed_announcements_aggregate_fields';
  readonly count: Scalars['Int']['output'];
  readonly max?: Maybe<Viewed_Announcements_Max_Fields>;
  readonly min?: Maybe<Viewed_Announcements_Min_Fields>;
};


/** aggregate fields of "viewed_announcements" */
export type Viewed_Announcements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<ReadonlyArray<Viewed_Announcements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "viewed_announcements". All fields are combined with a logical 'AND'. */
export type Viewed_Announcements_Bool_Exp = {
  readonly _and?: InputMaybe<ReadonlyArray<Viewed_Announcements_Bool_Exp>>;
  readonly _not?: InputMaybe<Viewed_Announcements_Bool_Exp>;
  readonly _or?: InputMaybe<ReadonlyArray<Viewed_Announcements_Bool_Exp>>;
  readonly announcement_id?: InputMaybe<String_Comparison_Exp>;
  readonly dismissed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Bool_Exp>;
  readonly id?: InputMaybe<String_Comparison_Exp>;
  readonly title?: InputMaybe<String_Comparison_Exp>;
  readonly user_id?: InputMaybe<String_Comparison_Exp>;
  readonly viewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "viewed_announcements" */
export type Viewed_Announcements_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'viewed_announcements_pkey';

/** input type for inserting data into table "viewed_announcements" */
export type Viewed_Announcements_Insert_Input = {
  readonly announcement_id?: InputMaybe<Scalars['String']['input']>;
  readonly dismissed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Obj_Rel_Insert_Input>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Viewed_Announcements_Max_Fields = {
  readonly __typename?: 'viewed_announcements_max_fields';
  readonly announcement_id?: Maybe<Scalars['String']['output']>;
  readonly dismissed_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
  readonly viewed_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Viewed_Announcements_Min_Fields = {
  readonly __typename?: 'viewed_announcements_min_fields';
  readonly announcement_id?: Maybe<Scalars['String']['output']>;
  readonly dismissed_at?: Maybe<Scalars['timestamptz']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly user_id?: Maybe<Scalars['String']['output']>;
  readonly viewed_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "viewed_announcements" */
export type Viewed_Announcements_Mutation_Response = {
  readonly __typename?: 'viewed_announcements_mutation_response';
  /** number of rows affected by the mutation */
  readonly affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  readonly returning: ReadonlyArray<Viewed_Announcements>;
};

/** on_conflict condition type for table "viewed_announcements" */
export type Viewed_Announcements_On_Conflict = {
  readonly constraint: Viewed_Announcements_Constraint;
  readonly update_columns?: ReadonlyArray<Viewed_Announcements_Update_Column>;
  readonly where?: InputMaybe<Viewed_Announcements_Bool_Exp>;
};

/** Ordering options when selecting data from "viewed_announcements". */
export type Viewed_Announcements_Order_By = {
  readonly announcement_id?: InputMaybe<Order_By>;
  readonly dismissed_at?: InputMaybe<Order_By>;
  readonly folioUserByFolioUser?: InputMaybe<Folio_User_Order_By>;
  readonly id?: InputMaybe<Order_By>;
  readonly title?: InputMaybe<Order_By>;
  readonly user_id?: InputMaybe<Order_By>;
  readonly viewed_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: viewed_announcements */
export type Viewed_Announcements_Pk_Columns_Input = {
  readonly id: Scalars['String']['input'];
};

/** select columns of table "viewed_announcements" */
export type Viewed_Announcements_Select_Column =
  /** column name */
  | 'announcement_id'
  /** column name */
  | 'dismissed_at'
  /** column name */
  | 'id'
  /** column name */
  | 'title'
  /** column name */
  | 'user_id'
  /** column name */
  | 'viewed_at';

/** input type for updating data in table "viewed_announcements" */
export type Viewed_Announcements_Set_Input = {
  readonly announcement_id?: InputMaybe<Scalars['String']['input']>;
  readonly dismissed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "viewed_announcements" */
export type Viewed_Announcements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  readonly initial_value: Viewed_Announcements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  readonly ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Viewed_Announcements_Stream_Cursor_Value_Input = {
  readonly announcement_id?: InputMaybe<Scalars['String']['input']>;
  readonly dismissed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly user_id?: InputMaybe<Scalars['String']['input']>;
  readonly viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "viewed_announcements" */
export type Viewed_Announcements_Update_Column =
  /** column name */
  | 'announcement_id'
  /** column name */
  | 'dismissed_at'
  /** column name */
  | 'id'
  /** column name */
  | 'title'
  /** column name */
  | 'user_id'
  /** column name */
  | 'viewed_at';

export type Viewed_Announcements_Updates = {
  /** sets the columns of the filtered rows to the given values */
  readonly _set?: InputMaybe<Viewed_Announcements_Set_Input>;
  /** filter the rows which have to be updated */
  readonly where: Viewed_Announcements_Bool_Exp;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  readonly __typename?: '__Type';
  readonly kind: __TypeKind;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly specifiedByURL?: Maybe<Scalars['String']['output']>;
  readonly fields?: Maybe<ReadonlyArray<__Field>>;
  readonly interfaces?: Maybe<ReadonlyArray<__Type>>;
  readonly possibleTypes?: Maybe<ReadonlyArray<__Type>>;
  readonly enumValues?: Maybe<ReadonlyArray<__EnumValue>>;
  readonly inputFields?: Maybe<ReadonlyArray<__InputValue>>;
  readonly ofType?: Maybe<__Type>;
  readonly isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export type __TypeKind =
  /** Indicates this type is a scalar. */
  | 'SCALAR'
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  | 'OBJECT'
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  | 'INTERFACE'
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  | 'UNION'
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  | 'ENUM'
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  | 'INPUT_OBJECT'
  /** Indicates this type is a list. `ofType` is a valid field. */
  | 'LIST'
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  | 'NON_NULL';

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  readonly __typename?: '__Field';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly args: ReadonlyArray<__InputValue>;
  readonly type: __Type;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  readonly __typename?: '__InputValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  readonly defaultValue?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  readonly __typename?: '__EnumValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};

export type MemberQueryQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type MemberQueryQuery = { readonly __typename?: 'query_root', readonly page_member: ReadonlyArray<{ readonly __typename?: 'page_member', readonly page_id: string, readonly user_id: string }> };

export type GetPageQueryQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetPageQueryQuery = { readonly __typename?: 'query_root', readonly pages_by_pk?: { readonly __typename?: 'pages', readonly id: string, readonly name?: string | null, readonly idx: string } | null };

export type CreatePageMutationMutationVariables = Exact<{
  object: Pages_Insert_Input;
}>;


export type CreatePageMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_pages_one?: { readonly __typename?: 'pages', readonly id: string } | null };

export type CreatePageMemberMutationMutationVariables = Exact<{
  object: Page_Member_Insert_Input;
}>;


export type CreatePageMemberMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_page_member_one?: { readonly __typename?: 'page_member', readonly page_id: string, readonly user_id: string } | null };

export type RollbackPageMutationMutationVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type RollbackPageMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_pages_by_pk?: { readonly __typename?: 'pages', readonly id: string } | null };

export type PageMembersQueryQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type PageMembersQueryQuery = { readonly __typename?: 'query_root', readonly page_member: ReadonlyArray<{ readonly __typename?: 'page_member', readonly page_id: string, readonly user_id: string }> };

export type DeletePageMutationMutationVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type DeletePageMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_pages_by_pk?: { readonly __typename?: 'pages', readonly id: string } | null };

export type DeletePageMemberMutationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;


export type DeletePageMemberMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_page_member?: { readonly __typename?: 'page_member_mutation_response', readonly affected_rows: number } | null };

export type PageMembersBulkQueryQueryVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PageMembersBulkQueryQuery = { readonly __typename?: 'query_root', readonly page_member: ReadonlyArray<{ readonly __typename?: 'page_member', readonly page_id: string, readonly user_id: string }> };

export type DeletePageBulkMutationMutationVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type DeletePageBulkMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_pages_by_pk?: { readonly __typename?: 'pages', readonly id: string } | null };

export type DeletePageMemberBulkMutationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;


export type DeletePageMemberBulkMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_page_member?: { readonly __typename?: 'page_member_mutation_response', readonly affected_rows: number } | null };

export type InsertInstrumentsMutationVariables = Exact<{
  shared_instruments: ReadonlyArray<Shared_Instrument_Insert_Input> | Shared_Instrument_Insert_Input;
}>;


export type InsertInstrumentsMutation = { readonly __typename?: 'mutation_root', readonly insert_shared_instrument?: { readonly __typename?: 'shared_instrument_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'shared_instrument', readonly id: string, readonly month: string, readonly edited_by: string, readonly edited_at: string, readonly value?: number | null, readonly product: string }> } | null };

export type DeleteInstrumentsMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type DeleteInstrumentsMutation = { readonly __typename?: 'mutation_root', readonly delete_shared_instrument?: { readonly __typename?: 'shared_instrument_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'shared_instrument', readonly id: string }> } | null };

export type TestUserByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TestUserByIdQuery = { readonly __typename?: 'query_root', readonly folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string, readonly roles: JSONValue } | null };

export type MyMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  edited_at: Scalars['timestamptz']['input'];
  edited_by: Scalars['String']['input'];
  global_product: Scalars['uuid']['input'];
  month: Scalars['date']['input'];
  value: Scalars['numeric']['input'];
}>;


export type MyMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_global_instrument_one?: { readonly __typename?: 'global_instrument', readonly id: number, readonly month: string, readonly value?: number | null, readonly edited_by: string, readonly edited_at: string, readonly global_product: string, readonly shared_at: string } | null };

export type UpsertInstrumentsMutationVariables = Exact<{
  shared_instruments: ReadonlyArray<Shared_Instrument_Insert_Input> | Shared_Instrument_Insert_Input;
  local_instruments: ReadonlyArray<Local_Instrument_Insert_Input> | Local_Instrument_Insert_Input;
}>;


export type UpsertInstrumentsMutation = { readonly __typename?: 'mutation_root', readonly insert_shared_instrument?: { readonly __typename?: 'shared_instrument_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'shared_instrument', readonly id: string, readonly month: string, readonly edited_by: string, readonly edited_at: string, readonly value?: number | null, readonly product: string }> } | null, readonly insert_local_instrument?: { readonly __typename?: 'local_instrument_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'local_instrument', readonly id: string, readonly storage_type: User_Storage_Enum, readonly month: string, readonly edited_at: string, readonly value?: number | null, readonly product: string, readonly folio_user: string }> } | null };

export type GetGlobalProductIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalProductIdsQuery = { readonly __typename?: 'query_root', readonly global_product: ReadonlyArray<{ readonly __typename?: 'global_product', readonly id: string }> };

export type UserSessionSubscriptionVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
}>;


export type UserSessionSubscription = { readonly __typename?: 'subscription_root', readonly session: ReadonlyArray<{ readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null, readonly session_start?: string | null, readonly is_mobile: boolean, readonly excel: boolean }> };

export type UserExcelSessionSubscriptionVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type UserExcelSessionSubscription = { readonly __typename?: 'subscription_root', readonly session: ReadonlyArray<{ readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null, readonly session_start?: string | null, readonly is_mobile: boolean, readonly excel: boolean, readonly excel_session_id?: string | null }> };

export type StartSessionMutationVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
  session_id: Scalars['String']['input'];
  last_seen: Scalars['timestamptz']['input'];
  session_start: Scalars['timestamptz']['input'];
}>;


export type StartSessionMutation = { readonly __typename?: 'mutation_root', readonly insert_session_one?: { readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null } | null, readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string } | null };

export type StartExcelSessionMutationVariables = Exact<{
  user: Scalars['String']['input'];
  last_seen: Scalars['timestamptz']['input'];
  session_start: Scalars['timestamptz']['input'];
  excel_session_id: Scalars['String']['input'];
}>;


export type StartExcelSessionMutation = { readonly __typename?: 'mutation_root', readonly insert_session_one?: { readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null, readonly excel_session_id?: string | null } | null, readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string } | null };

export type LivenessProbeMutationMutationVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
}>;


export type LivenessProbeMutationMutation = { readonly __typename?: 'mutation_root', readonly update_session_by_pk?: { readonly __typename?: 'session', readonly id: string } | null, readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string } | null };

export type ExcelLivenessProbeMutationMutationVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type ExcelLivenessProbeMutationMutation = { readonly __typename?: 'mutation_root', readonly update_session_by_pk?: { readonly __typename?: 'session', readonly id: string } | null, readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string } | null };

export type DeleteSessionMutationVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
}>;


export type DeleteSessionMutation = { readonly __typename?: 'mutation_root', readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string } | null, readonly delete_session?: { readonly __typename?: 'session_mutation_response', readonly affected_rows: number } | null };

export type ClearExcelSessionMutationVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type ClearExcelSessionMutation = { readonly __typename?: 'mutation_root', readonly update_session_by_pk?: { readonly __typename?: 'session', readonly id: string, readonly excel_session_id?: string | null, readonly excel: boolean } | null, readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string } | null };

export type DeleteAlertsMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteAlertsMutation = { readonly __typename?: 'mutation_root', readonly delete_alerts?: { readonly __typename?: 'alerts_mutation_response', readonly affected_rows: number } | null };

export type UpsertAlertsMutationVariables = Exact<{
  objects: ReadonlyArray<Alerts_Insert_Input> | Alerts_Insert_Input;
}>;


export type UpsertAlertsMutation = { readonly __typename?: 'mutation_root', readonly insert_alerts?: { readonly __typename?: 'alerts_mutation_response', readonly affected_rows: number } | null };

export type AlertFragmentFragment = { readonly __typename?: 'alerts', readonly id: string, readonly limit: string, readonly _id?: string | null, readonly column_id: string, readonly desktop_notification_sent?: boolean | null, readonly field_selector?: string | null, readonly note?: string | null, readonly page_id: string, readonly product_id: string, readonly push_notification_sent?: boolean | null, readonly recurring?: boolean | null, readonly row_id: string, readonly sound?: boolean | null, readonly status: string, readonly triggered_at?: string | null, readonly user_id: string, readonly value_below_limit: boolean, readonly created_at?: string | null, readonly expired_at?: string | null } & { ' $fragmentName'?: 'AlertFragmentFragment' };

export type AlertsQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AlertsQueryQuery = { readonly __typename?: 'query_root', readonly alerts: ReadonlyArray<(
    { readonly __typename?: 'alerts' }
    & { ' $fragmentRefs'?: { 'AlertFragmentFragment': AlertFragmentFragment } }
  )> };

export type AlertsQueryByPageIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;


export type AlertsQueryByPageIdQuery = { readonly __typename?: 'query_root', readonly alerts: ReadonlyArray<(
    { readonly __typename?: 'alerts' }
    & { ' $fragmentRefs'?: { 'AlertFragmentFragment': AlertFragmentFragment } }
  )> };

export type AlertsQueryByPageIdsQueryVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlertsQueryByPageIdsQuery = { readonly __typename?: 'query_root', readonly alerts: ReadonlyArray<(
    { readonly __typename?: 'alerts' }
    & { ' $fragmentRefs'?: { 'AlertFragmentFragment': AlertFragmentFragment } }
  )> };

export type AlertExistsQueryByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertExistsQueryByIdQuery = { readonly __typename?: 'query_root', readonly alerts_by_pk?: { readonly __typename?: 'alerts', readonly id: string, readonly status: string, readonly triggered_at?: string | null, readonly desktop_notification_sent?: boolean | null, readonly push_notification_sent?: boolean | null } | null };

export type AlertQueryByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertQueryByIdQuery = { readonly __typename?: 'query_root', readonly alerts_by_pk?: (
    { readonly __typename?: 'alerts' }
    & { ' $fragmentRefs'?: { 'AlertFragmentFragment': AlertFragmentFragment } }
  ) | null };

export type AlertsInsertManyMutationVariables = Exact<{
  objects: ReadonlyArray<Alerts_Insert_Input> | Alerts_Insert_Input;
}>;


export type AlertsInsertManyMutation = { readonly __typename?: 'mutation_root', readonly insert_alerts?: { readonly __typename?: 'alerts_mutation_response', readonly affected_rows: number } | null };

export type AlertsUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  values?: InputMaybe<Alerts_Set_Input>;
}>;


export type AlertsUpdateMutation = { readonly __typename?: 'mutation_root', readonly update_alerts_by_pk?: { readonly __typename?: 'alerts', readonly id: string } | null };

export type AlertDeleteMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertDeleteMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_alerts_by_pk?: { readonly __typename?: 'alerts', readonly id: string } | null };

export type UserPushSubscriptionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserPushSubscriptionsQuery = { readonly __typename?: 'query_root', readonly push_subscriptions: ReadonlyArray<{ readonly __typename?: 'push_subscriptions', readonly user_id: string, readonly subscriptions: JSONValue }> };

export type UserPushSubscriptionsUpsertMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  subscriptions: Scalars['jsonb']['input'];
}>;


export type UserPushSubscriptionsUpsertMutation = { readonly __typename?: 'mutation_root', readonly insert_push_subscriptions_one?: { readonly __typename?: 'push_subscriptions', readonly user_id: string, readonly subscriptions: JSONValue } | null };

export type FeatureFlagsSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
}>;


export type FeatureFlagsSubscriptionSubscription = { readonly __typename?: 'subscription_root', readonly feature_flags: ReadonlyArray<{ readonly __typename?: 'feature_flags', readonly id: string, readonly name: string, readonly metadata?: JSONValue | null }> };

export type AllFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFeatureFlagsQuery = { readonly __typename?: 'query_root', readonly feature_flags: ReadonlyArray<{ readonly __typename?: 'feature_flags', readonly id: string, readonly name: string, readonly metadata?: JSONValue | null, readonly enabled: boolean }> };

export type UpsertConditionalFormattingRulesMutationVariables = Exact<{
  objects: ReadonlyArray<Conditional_Formatting_Rules_Insert_Input> | Conditional_Formatting_Rules_Insert_Input;
}>;


export type UpsertConditionalFormattingRulesMutation = { readonly __typename?: 'mutation_root', readonly insert_conditional_formatting_rules?: { readonly __typename?: 'conditional_formatting_rules_mutation_response', readonly affected_rows: number } | null };

export type ConditionalFormattingRulesFragmentFragment = { readonly __typename?: 'conditional_formatting_rules', readonly id: string, readonly _id?: string | null, readonly bg_color?: string | null, readonly bold_text: boolean, readonly column_id: string, readonly invert_text_color: boolean, readonly limit: string, readonly note: string, readonly page_id: string, readonly priority_idx: string, readonly row_id: string, readonly rule: string, readonly stop_if_true: boolean, readonly user_id: string } & { ' $fragmentName'?: 'ConditionalFormattingRulesFragmentFragment' };

export type ConditionalFormattingQueryQueryVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ConditionalFormattingQueryQuery = { readonly __typename?: 'query_root', readonly conditional_formatting_rules: ReadonlyArray<(
    { readonly __typename?: 'conditional_formatting_rules' }
    & { ' $fragmentRefs'?: { 'ConditionalFormattingRulesFragmentFragment': ConditionalFormattingRulesFragmentFragment } }
  )> };

export type ConditionalFormattingSubSubscriptionVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type ConditionalFormattingSubSubscription = { readonly __typename?: 'subscription_root', readonly conditional_formatting_rules: ReadonlyArray<(
    { readonly __typename?: 'conditional_formatting_rules' }
    & { ' $fragmentRefs'?: { 'ConditionalFormattingRulesFragmentFragment': ConditionalFormattingRulesFragmentFragment } }
  )> };

export type ConditionalFormattingInsertManyMutationVariables = Exact<{
  objects: ReadonlyArray<Conditional_Formatting_Rules_Insert_Input> | Conditional_Formatting_Rules_Insert_Input;
}>;


export type ConditionalFormattingInsertManyMutation = { readonly __typename?: 'mutation_root', readonly insert_conditional_formatting_rules?: { readonly __typename?: 'conditional_formatting_rules_mutation_response', readonly affected_rows: number } | null };

export type Insert_Conditional_Formatting_Rules_OneMutationVariables = Exact<{
  rule: Conditional_Formatting_Rules_Insert_Input;
}>;


export type Insert_Conditional_Formatting_Rules_OneMutation = { readonly __typename?: 'mutation_root', readonly insert_conditional_formatting_rules_one?: { readonly __typename?: 'conditional_formatting_rules', readonly id: string } | null };

export type ConditionalFormattingRulesByPageIdQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type ConditionalFormattingRulesByPageIdQuery = { readonly __typename?: 'query_root', readonly conditional_formatting_rules: ReadonlyArray<(
    { readonly __typename?: 'conditional_formatting_rules' }
    & { ' $fragmentRefs'?: { 'ConditionalFormattingRulesFragmentFragment': ConditionalFormattingRulesFragmentFragment } }
  )> };

export type DeleteConditionalFormattingRulesMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteConditionalFormattingRulesMutation = { readonly __typename?: 'mutation_root', readonly delete_conditional_formatting_rules?: { readonly __typename?: 'conditional_formatting_rules_mutation_response', readonly affected_rows: number } | null };

export type GridSettingsFragment = { readonly __typename?: 'grid_settings', readonly user_id: string, readonly adhoc_spreads_rows?: number | null, readonly adhoc_spreads_switch?: boolean | null, readonly alternating_row_colours?: boolean | null, readonly broadcast_colour?: string | null, readonly cal_current?: boolean | null, readonly cal_switch?: boolean | null, readonly cals?: number | null, readonly enable_full_month_row_feature?: boolean | null, readonly eod_colour?: string | null, readonly extra_header_height?: number | null, readonly flash_cell_updates?: boolean | null, readonly global_colour?: string | null, readonly grid_scratchpad_switch?: boolean | null, readonly header_column_colour?: string | null, readonly hide_broadcast?: boolean | null, readonly hide_eod?: boolean | null, readonly hide_global?: boolean | null, readonly hide_private?: boolean | null, readonly hide_status_row?: boolean | null, readonly hlv_current?: boolean | null, readonly hlv_switch?: boolean | null, readonly hlvs?: number | null, readonly hybrid_colour?: string | null, readonly increment_map?: JSONValue | null, readonly display_name_map?: JSONValue | null, readonly indicator_colour?: string | null, readonly listen_colour?: string | null, readonly local_colour?: string | null, readonly main_month_column_width?: number | null, readonly months?: number | null, readonly qtr_current?: boolean | null, readonly qtr_switch?: boolean | null, readonly qtrs?: number | null, readonly quarter_borders?: boolean | null, readonly scratchpad_max_cols?: number | null, readonly scratchpad_max_rows?: number | null, readonly season_current?: boolean | null, readonly season_switch?: boolean | null, readonly seasons?: number | null, readonly sound?: boolean | null, readonly status_map?: JSONValue | null, readonly subheader_column_colour?: string | null, readonly updated_at: string, readonly eod_date?: string | null, readonly display_negative_bracket?: boolean | null, readonly enabled_snapshot_warnings?: JSONValue | null, readonly display_negative_color?: boolean | null, readonly commodity_parent_group?: boolean | null, readonly geographical_region?: boolean | null, readonly commodity_group?: boolean | null, readonly package?: boolean | null, readonly description?: boolean | null, readonly source?: boolean | null, readonly field_name?: boolean | null, readonly detailed_tooltip?: boolean | null, readonly dont_show_remove_curve_confirmation_dialog?: boolean | null, readonly dont_show_remove_multiple_curves_confirmation_dialog?: boolean | null, readonly dont_show_clear_single_value_confirmation_dialog?: boolean | null, readonly dont_show_clear_multiple_values_confirmation_dialog?: boolean | null, readonly dont_show_anomaly_confirmation_dialog?: boolean | null, readonly dont_show_paste_multiple_values_confirmation_dialog?: boolean | null, readonly dont_show_drag_multiple_values_confirmation_dialog?: boolean | null, readonly dont_show_remove_page_confirmation_dialog?: boolean | null, readonly show_world_clock: boolean, readonly insert_page_position: string, readonly insert_column_position: string, readonly default_curve_column_width: number, readonly anomaly_sensitivity_level: number, readonly range_summary_dp: number, readonly range_summary_calc: string, readonly saved_colours?: JSONValue | null } & { ' $fragmentName'?: 'GridSettingsFragment' };

export type GridSettingsQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GridSettingsQueryQuery = { readonly __typename?: 'query_root', readonly grid_settings: ReadonlyArray<(
    { readonly __typename?: 'grid_settings' }
    & { ' $fragmentRefs'?: { 'GridSettingsFragment': GridSettingsFragment } }
  )> };

export type GridSettingsSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GridSettingsSubscriptionSubscription = { readonly __typename?: 'subscription_root', readonly grid_settings: ReadonlyArray<(
    { readonly __typename?: 'grid_settings' }
    & { ' $fragmentRefs'?: { 'GridSettingsFragment': GridSettingsFragment } }
  )> };

export type GridSettingsUpdateMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  values?: InputMaybe<Grid_Settings_Set_Input>;
}>;


export type GridSettingsUpdateMutation = { readonly __typename?: 'mutation_root', readonly update_grid_settings_by_pk?: { readonly __typename?: 'grid_settings', readonly user_id: string } | null };

export type GridSettingsInsertMutationVariables = Exact<{
  object: Grid_Settings_Insert_Input;
}>;


export type GridSettingsInsertMutation = { readonly __typename?: 'mutation_root', readonly insert_grid_settings_one?: (
    { readonly __typename?: 'grid_settings' }
    & { ' $fragmentRefs'?: { 'GridSettingsFragment': GridSettingsFragment } }
  ) | null };

export type SnapshotDateQueryQueryVariables = Exact<{
  from: Scalars['date']['input'];
  to: Scalars['date']['input'];
}>;


export type SnapshotDateQueryQuery = { readonly __typename?: 'query_root', readonly eod_entry: ReadonlyArray<{ readonly __typename?: 'eod_entry', readonly evaluation_date: string }> };

export type GridSettingsThemeFragment = { readonly __typename?: 'grid_settings', readonly user_id: string, readonly theme?: string | null } & { ' $fragmentName'?: 'GridSettingsThemeFragment' };

export type GridSettingsThemeQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GridSettingsThemeQueryQuery = { readonly __typename?: 'query_root', readonly grid_settings: ReadonlyArray<(
    { readonly __typename?: 'grid_settings' }
    & { ' $fragmentRefs'?: { 'GridSettingsThemeFragment': GridSettingsThemeFragment } }
  )> };

export type GridSettingsThemeUpdateMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  theme?: InputMaybe<Scalars['theme_enum']['input']>;
}>;


export type GridSettingsThemeUpdateMutation = { readonly __typename?: 'mutation_root', readonly update_grid_settings_by_pk?: { readonly __typename?: 'grid_settings', readonly user_id: string, readonly theme?: string | null } | null };

export type HfcAbsoluteFragmentFragment = { readonly __typename?: 'eod_entry', readonly product: string, readonly month: string, readonly evaluation_date: string, readonly value: number, readonly productByProduct: { readonly __typename?: 'product', readonly name: string, readonly uom: Product_Uom_Enum } } & { ' $fragmentName'?: 'HfcAbsoluteFragmentFragment' };

export type HfcAbsoluteQueryVariables = Exact<{
  product?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Scalars['date']['input']>;
  eval_start?: InputMaybe<Scalars['date']['input']>;
}>;


export type HfcAbsoluteQuery = { readonly __typename?: 'query_root', readonly eod_entry: ReadonlyArray<(
    { readonly __typename?: 'eod_entry' }
    & { ' $fragmentRefs'?: { 'HfcAbsoluteFragmentFragment': HfcAbsoluteFragmentFragment } }
  )> };

export type HfcRelativeFragmentFragment = { readonly __typename?: 'eod_entry', readonly product: string, readonly month: string, readonly evaluation_date: string, readonly relative_period?: number | null, readonly value: number, readonly productByProduct: { readonly __typename?: 'product', readonly name: string, readonly uom: Product_Uom_Enum } } & { ' $fragmentName'?: 'HfcRelativeFragmentFragment' };

export type HfcRelativeQueryVariables = Exact<{
  product?: InputMaybe<Scalars['uuid']['input']>;
  relative_period?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<ReadonlyArray<Scalars['date']['input']> | Scalars['date']['input']>;
}>;


export type HfcRelativeQuery = { readonly __typename?: 'query_root', readonly eod_entry: ReadonlyArray<(
    { readonly __typename?: 'eod_entry' }
    & { ' $fragmentRefs'?: { 'HfcRelativeFragmentFragment': HfcRelativeFragmentFragment } }
  )> };

export type IncidentBannersSubscriptionSubscriptionVariables = Exact<{
  orgId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type IncidentBannersSubscriptionSubscription = { readonly __typename?: 'subscription_root', readonly incident_banners: ReadonlyArray<{ readonly __typename?: 'incident_banners', readonly id: string, readonly title: string, readonly message: string, readonly severity: string }> };

export type LiveChartPageFragmentFragment = { readonly __typename?: 'live_chart_page', readonly id: string, readonly idx: string, readonly name: string, readonly charts: JSONValue, readonly page_type?: string | null } & { ' $fragmentName'?: 'LiveChartPageFragmentFragment' };

export type LiveChartPageQueryQueryVariables = Exact<{
  user_id: Scalars['String']['input'];
}>;


export type LiveChartPageQueryQuery = { readonly __typename?: 'query_root', readonly live_chart_page: ReadonlyArray<(
    { readonly __typename?: 'live_chart_page' }
    & { ' $fragmentRefs'?: { 'LiveChartPageFragmentFragment': LiveChartPageFragmentFragment } }
  )> };

export type LiveChartPageInsertMutationVariables = Exact<{
  object: Live_Chart_Page_Insert_Input;
}>;


export type LiveChartPageInsertMutation = { readonly __typename?: 'mutation_root', readonly insert_live_chart_page_one?: (
    { readonly __typename?: 'live_chart_page' }
    & { ' $fragmentRefs'?: { 'LiveChartPageFragmentFragment': LiveChartPageFragmentFragment } }
  ) | null };

export type LiveChartPageUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updates: Live_Chart_Page_Set_Input;
}>;


export type LiveChartPageUpdateMutation = { readonly __typename?: 'mutation_root', readonly update_live_chart_page_by_pk?: { readonly __typename?: 'live_chart_page', readonly user_id: string } | null };

export type LiveChartPageDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LiveChartPageDeleteMutation = { readonly __typename?: 'mutation_root', readonly delete_live_chart_page_by_pk?: { readonly __typename?: 'live_chart_page', readonly user_id: string } | null };

export type LiveChartSettingsFragmentFragment = { readonly __typename?: 'live_chart_settings', readonly user_id: string, readonly updated_at: string, readonly created_at: string, readonly curve_settings?: JSONValue | null, readonly charts_state: JSONValue, readonly user_settings?: JSONValue | null } & { ' $fragmentName'?: 'LiveChartSettingsFragmentFragment' };

export type LiveChartSettingsInsertMutationVariables = Exact<{
  object: Live_Chart_Settings_Insert_Input;
}>;


export type LiveChartSettingsInsertMutation = { readonly __typename?: 'mutation_root', readonly insert_live_chart_settings_one?: (
    { readonly __typename?: 'live_chart_settings' }
    & { ' $fragmentRefs'?: { 'LiveChartSettingsFragmentFragment': LiveChartSettingsFragmentFragment } }
  ) | null };

export type LiveChartSettingsQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type LiveChartSettingsQueryQuery = { readonly __typename?: 'query_root', readonly live_chart_settings: ReadonlyArray<(
    { readonly __typename?: 'live_chart_settings' }
    & { ' $fragmentRefs'?: { 'LiveChartSettingsFragmentFragment': LiveChartSettingsFragmentFragment } }
  )> };

export type LiveChartSettingsUpdateMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  updates: Live_Chart_Settings_Set_Input;
}>;


export type LiveChartSettingsUpdateMutation = { readonly __typename?: 'mutation_root', readonly update_live_chart_settings_by_pk?: { readonly __typename?: 'live_chart_settings', readonly user_id: string } | null };

export type LiveChartAnnotationsFragmentFragment = { readonly __typename?: 'live_chart_annotations', readonly id: string, readonly user_id: string, readonly annotations?: JSONValue | null } & { ' $fragmentName'?: 'LiveChartAnnotationsFragmentFragment' };

export type LiveChartAnnotationsQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type LiveChartAnnotationsQueryQuery = { readonly __typename?: 'query_root', readonly live_chart_annotations: ReadonlyArray<(
    { readonly __typename?: 'live_chart_annotations' }
    & { ' $fragmentRefs'?: { 'LiveChartAnnotationsFragmentFragment': LiveChartAnnotationsFragmentFragment } }
  )> };

export type UpsertAnnotationMutationVariables = Exact<{
  object: Live_Chart_Annotations_Insert_Input;
}>;


export type UpsertAnnotationMutation = { readonly __typename?: 'mutation_root', readonly insert_live_chart_annotations_one?: (
    { readonly __typename?: 'live_chart_annotations' }
    & { ' $fragmentRefs'?: { 'LiveChartAnnotationsFragmentFragment': LiveChartAnnotationsFragmentFragment } }
  ) | null };

export type MfaStateQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  orgId: Scalars['Int']['input'];
}>;


export type MfaStateQuery = { readonly __typename?: 'query_root', readonly folio_user: ReadonlyArray<{ readonly __typename?: 'folio_user', readonly mfa_opted_out: boolean }>, readonly organisation: ReadonlyArray<{ readonly __typename?: 'organisation', readonly mfa_mode: string }> };

export type SetMfaOptOutMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type SetMfaOptOutMutation = { readonly __typename?: 'mutation_root', readonly update_folio_user?: { readonly __typename?: 'folio_user_mutation_response', readonly affected_rows: number } | null };

export type ModuleStorageGetQueryVariables = Exact<{
  module: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type ModuleStorageGetQuery = { readonly __typename?: 'query_root', readonly module_storage: ReadonlyArray<{ readonly __typename?: 'module_storage', readonly value?: JSONValue | null, readonly rev: string }> };

export type ModuleStorageSetMutationVariables = Exact<{
  module: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type ModuleStorageSetMutation = { readonly __typename?: 'mutation_root', readonly insert_module_storage_one?: { readonly __typename?: 'module_storage', readonly rev: string } | null };

export type ModuleStorageStreamSubscriptionVariables = Exact<{
  cursorRev: Scalars['bigint']['input'];
}>;


export type ModuleStorageStreamSubscription = { readonly __typename?: 'subscription_root', readonly module_storage_stream: ReadonlyArray<{ readonly __typename?: 'module_storage', readonly module: string, readonly key: string, readonly value?: JSONValue | null, readonly rev: string }> };

export type OrgByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrgByIdQuery = { readonly __typename?: 'query_root', readonly organisation_by_pk?: { readonly __typename?: 'organisation', readonly needs_historical_data: boolean, readonly sourceBySource: { readonly __typename?: 'source', readonly name: string, readonly description?: string | null, readonly alias?: string | null, readonly source_type: Product_Source_Enum } } | null };

export type PageFragmentFragment = { readonly __typename?: 'pages', readonly id: string, readonly idx: string, readonly name?: string | null, readonly type: string, readonly period_highlights?: string | null, readonly updated_at?: string | null, readonly user_id: string, readonly extra_header_height?: boolean | null, readonly created_at: string, readonly column_highlights?: string | null, readonly cell_highlights?: string | null, readonly adhoc_spreads?: string | null, readonly commodity_parent_group?: boolean | null, readonly geographical_region?: boolean | null, readonly commodity_group?: boolean | null, readonly package?: boolean | null, readonly description?: boolean | null, readonly source?: boolean | null, readonly field_name?: boolean | null, readonly main_column_type?: string | null, readonly main_column_width?: number | null } & { ' $fragmentName'?: 'PageFragmentFragment' };

export type PageMemberFragmentFragment = { readonly __typename?: 'page_member', readonly page_id: string, readonly user_id: string, readonly page_order: string, readonly Page: (
    { readonly __typename?: 'pages' }
    & { ' $fragmentRefs'?: { 'PageFragmentFragment': PageFragmentFragment } }
  ) } & { ' $fragmentName'?: 'PageMemberFragmentFragment' };

export type PagesQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PagesQueryQuery = { readonly __typename?: 'query_root', readonly pages: ReadonlyArray<(
    { readonly __typename?: 'pages' }
    & { ' $fragmentRefs'?: { 'PageFragmentFragment': PageFragmentFragment } }
  )> };

export type PagesByPageIdsQueryQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PagesByPageIdsQueryQuery = { readonly __typename?: 'query_root', readonly pages: ReadonlyArray<(
    { readonly __typename?: 'pages' }
    & { ' $fragmentRefs'?: { 'PageFragmentFragment': PageFragmentFragment } }
  )> };

export type PageMembersByPageIdsQueryQueryVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PageMembersByPageIdsQueryQuery = { readonly __typename?: 'query_root', readonly page_member: ReadonlyArray<(
    { readonly __typename?: 'page_member' }
    & { ' $fragmentRefs'?: { 'PageMemberFragmentFragment': PageMemberFragmentFragment } }
  )> };

export type PageMembersByUserIdQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PageMembersByUserIdQueryQuery = { readonly __typename?: 'query_root', readonly page_member: ReadonlyArray<(
    { readonly __typename?: 'page_member' }
    & { ' $fragmentRefs'?: { 'PageMemberFragmentFragment': PageMemberFragmentFragment } }
  )> };

export type PagesSubscriptionSubscriptionVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PagesSubscriptionSubscription = { readonly __typename?: 'subscription_root', readonly pages: ReadonlyArray<(
    { readonly __typename?: 'pages' }
    & { ' $fragmentRefs'?: { 'PageFragmentFragment': PageFragmentFragment } }
  )> };

export type PageMemberQueryQueryVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PageMemberQueryQuery = { readonly __typename?: 'query_root', readonly page_member: ReadonlyArray<(
    { readonly __typename?: 'page_member' }
    & { ' $fragmentRefs'?: { 'PageMemberFragmentFragment': PageMemberFragmentFragment } }
  )> };

export type PageMemberSubscriptionSubscriptionVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PageMemberSubscriptionSubscription = { readonly __typename?: 'subscription_root', readonly page_member: ReadonlyArray<(
    { readonly __typename?: 'page_member' }
    & { ' $fragmentRefs'?: { 'PageMemberFragmentFragment': PageMemberFragmentFragment } }
  )> };

export type Update_Pages_By_PkMutationVariables = Exact<{
  pageId: Scalars['String']['input'];
  values?: InputMaybe<Pages_Set_Input>;
}>;


export type Update_Pages_By_PkMutation = { readonly __typename?: 'mutation_root', readonly update_pages_by_pk?: { readonly __typename?: 'pages', readonly id: string } | null };

export type Update_Page_MemberMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  pageOrder: Scalars['String']['input'];
}>;


export type Update_Page_MemberMutation = { readonly __typename?: 'mutation_root', readonly update_page_member?: { readonly __typename?: 'page_member_mutation_response', readonly affected_rows: number } | null };

export type PageInsertMutationVariables = Exact<{
  page: Pages_Insert_Input;
}>;


export type PageInsertMutation = { readonly __typename?: 'mutation_root', readonly insert_pages_one?: { readonly __typename?: 'pages', readonly name?: string | null, readonly idx: string } | null };

export type PageMemberInsertMutationVariables = Exact<{
  member: Page_Member_Insert_Input;
}>;


export type PageMemberInsertMutation = { readonly __typename?: 'mutation_root', readonly insert_page_member_one?: { readonly __typename?: 'page_member', readonly page_id: string, readonly user_id: string, readonly page_order: string } | null };

export type PageInsertManyMutationVariables = Exact<{
  objects: ReadonlyArray<Pages_Insert_Input> | Pages_Insert_Input;
}>;


export type PageInsertManyMutation = { readonly __typename?: 'mutation_root', readonly insert_pages?: { readonly __typename?: 'pages_mutation_response', readonly affected_rows: number } | null };

export type PageMemberInsertManyMutationVariables = Exact<{
  objects: ReadonlyArray<Page_Member_Insert_Input> | Page_Member_Insert_Input;
}>;


export type PageMemberInsertManyMutation = { readonly __typename?: 'mutation_root', readonly insert_page_member?: { readonly __typename?: 'page_member_mutation_response', readonly affected_rows: number } | null };

export type PageDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PageDeleteMutation = { readonly __typename?: 'mutation_root', readonly delete_pages_by_pk?: { readonly __typename?: 'pages', readonly id: string } | null };

export type PageMemberDeleteMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;


export type PageMemberDeleteMutation = { readonly __typename?: 'mutation_root', readonly delete_page_member?: { readonly __typename?: 'page_member_mutation_response', readonly affected_rows: number } | null };

export type PageMembersDeleteByUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PageMembersDeleteByUserMutation = { readonly __typename?: 'mutation_root', readonly delete_page_member?: { readonly __typename?: 'page_member_mutation_response', readonly affected_rows: number } | null };

export type PageProductsFragmentFragment = { readonly __typename?: 'page_products', readonly id: string, readonly grid_id?: string | null, readonly idx: string, readonly decimal_places?: number | null, readonly column_width: number, readonly column_type: string, readonly column_field_selector?: string | null, readonly page_id: string, readonly product_id?: string | null, readonly thousands_separator?: boolean | null, readonly user_id: string, readonly updated_at?: string | null, readonly deleted_at?: string | null } & { ' $fragmentName'?: 'PageProductsFragmentFragment' };

export type AllPageProductsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPageProductsQueryQuery = { readonly __typename?: 'query_root', readonly page_products: ReadonlyArray<(
    { readonly __typename?: 'page_products' }
    & { ' $fragmentRefs'?: { 'PageProductsFragmentFragment': PageProductsFragmentFragment } }
  )> };

export type AllPageProductsSubSubscriptionVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AllPageProductsSubSubscription = { readonly __typename?: 'subscription_root', readonly page_products: ReadonlyArray<(
    { readonly __typename?: 'page_products' }
    & { ' $fragmentRefs'?: { 'PageProductsFragmentFragment': PageProductsFragmentFragment } }
  )> };

export type PageProductsQueryByIdsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PageProductsQueryByIdsQuery = { readonly __typename?: 'query_root', readonly page_products: ReadonlyArray<(
    { readonly __typename?: 'page_products' }
    & { ' $fragmentRefs'?: { 'PageProductsFragmentFragment': PageProductsFragmentFragment } }
  )> };

export type PageProductUpdateSubSubscriptionVariables = Exact<{
  since: Scalars['timestamptz']['input'];
}>;


export type PageProductUpdateSubSubscription = { readonly __typename?: 'subscription_root', readonly page_products: ReadonlyArray<(
    { readonly __typename?: 'page_products' }
    & { ' $fragmentRefs'?: { 'PageProductsFragmentFragment': PageProductsFragmentFragment } }
  )> };

export type PageProductsSubscriptionSubscriptionVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type PageProductsSubscriptionSubscription = { readonly __typename?: 'subscription_root', readonly page_products: ReadonlyArray<(
    { readonly __typename?: 'page_products' }
    & { ' $fragmentRefs'?: { 'PageProductsFragmentFragment': PageProductsFragmentFragment } }
  )> };

export type PageProductUpdateManyMutationVariables = Exact<{
  updates: ReadonlyArray<Page_Products_Updates> | Page_Products_Updates;
}>;


export type PageProductUpdateManyMutation = { readonly __typename?: 'mutation_root', readonly update_page_products_many?: ReadonlyArray<{ readonly __typename?: 'page_products_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'page_products', readonly id: string }> } | null> | null };

export type PageProductsInsertMutationVariables = Exact<{
  objects: ReadonlyArray<Page_Products_Insert_Input> | Page_Products_Insert_Input;
}>;


export type PageProductsInsertMutation = { readonly __typename?: 'mutation_root', readonly insert_page_products?: { readonly __typename?: 'page_products_mutation_response', readonly affected_rows: number } | null };

export type PageProductsHardDeleteMutationVariables = Exact<{
  products: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PageProductsHardDeleteMutation = { readonly __typename?: 'mutation_root', readonly delete_page_products?: { readonly __typename?: 'page_products_mutation_response', readonly affected_rows: number } | null };

export type AllSourcesForProductsQueryVariables = Exact<{
  products: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  month: Scalars['date']['input'];
}>;


export type AllSourcesForProductsQuery = { readonly __typename?: 'query_root', readonly global_instrument: ReadonlyArray<{ readonly __typename?: 'global_instrument', readonly id: number, readonly month: string, readonly value?: number | null, readonly edited_at: string, readonly edited_by: string, readonly globalProductByGlobalProduct: { readonly __typename?: 'global_product', readonly id: string, readonly globalPackageByGlobalPackage: { readonly __typename?: 'global_package', readonly source: number } } }> };

export type ProductInfoFragmentFragment = { readonly __typename?: 'product', readonly id: string, readonly artis_type: Product_Artis_Type_Enum, readonly curve_type: Product_Curve_Type_Enum, readonly code?: string | null, readonly commodity_group?: number | null, readonly description?: string | null, readonly eod_product_dep?: string | null, readonly geographical_region?: number | null, readonly has_shared_cell?: boolean | null, readonly logical_code?: string | null, readonly maturity: Product_Maturity_Enum, readonly name: string, readonly package: number, readonly product_type?: Product_Type_Enum | null, readonly summary_type: Product_Summary_Type_Enum, readonly uom: Product_Uom_Enum, readonly dp?: number | null, readonly product_uom: { readonly __typename?: 'product_uom', readonly value: string, readonly description?: string | null }, readonly packageByPackage: { readonly __typename?: 'package', readonly package_type?: Package_Type_Enum | null, readonly name: string, readonly permissions: ReadonlyArray<{ readonly __typename?: 'permission', readonly permission: User_Right_Enum, readonly folio_user: string }>, readonly sourceBySource: { readonly __typename?: 'source', readonly id: number, readonly name: string, readonly alias?: string | null, readonly logo?: string | null, readonly source_type: Product_Source_Enum, readonly exchange?: { readonly __typename?: 'exchange', readonly code: number } | null } }, readonly commodityGroupByCommodityGroup?: { readonly __typename?: 'commodity_group', readonly parent: number, readonly commodity_group?: string | null, readonly commodity_parent_group: { readonly __typename?: 'commodity_parent_group', readonly commodity_parent_group?: string | null } } | null, readonly geographicalRegionByGeographicalRegion?: { readonly __typename?: 'geographical_region', readonly geographical_region?: string | null } | null, readonly product_global_dependencies: ReadonlyArray<{ readonly __typename?: 'product_global_dependencies', readonly global_product: string }> } & { ' $fragmentName'?: 'ProductInfoFragmentFragment' };

export type ConfigsQueryQueryVariables = Exact<{
  maxRelMonth: Scalars['Int']['input'];
}>;


export type ConfigsQueryQuery = { readonly __typename?: 'query_root', readonly product_config: ReadonlyArray<{ readonly __typename?: 'product_config', readonly formula?: string | null, readonly product: string, readonly offset: number }> };

export type ConfigsSubSubscriptionVariables = Exact<{
  maxRelMonth: Scalars['Int']['input'];
}>;


export type ConfigsSubSubscription = { readonly __typename?: 'subscription_root', readonly product_config: ReadonlyArray<{ readonly __typename?: 'product_config', readonly formula?: string | null, readonly product: string, readonly offset: number }> };

export type ProductInfoQueryVariables = Exact<{
  folioUser: Scalars['String']['input'];
}>;


export type ProductInfoQuery = { readonly __typename?: 'query_root', readonly product: ReadonlyArray<(
    { readonly __typename?: 'product' }
    & { ' $fragmentRefs'?: { 'ProductInfoFragmentFragment': ProductInfoFragmentFragment } }
  )> };

export type ProductInfoSubSubscriptionVariables = Exact<{
  folioUser: Scalars['String']['input'];
}>;


export type ProductInfoSubSubscription = { readonly __typename?: 'subscription_root', readonly product: ReadonlyArray<(
    { readonly __typename?: 'product' }
    & { ' $fragmentRefs'?: { 'ProductInfoFragmentFragment': ProductInfoFragmentFragment } }
  )> };

export type GridProductsByIdsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  folioUser: Scalars['String']['input'];
}>;


export type GridProductsByIdsQuery = { readonly __typename?: 'query_root', readonly product: ReadonlyArray<(
    { readonly __typename?: 'product' }
    & { ' $fragmentRefs'?: { 'ProductInfoFragmentFragment': ProductInfoFragmentFragment } }
  )> };

export type PackageFolderAccessQueryVariables = Exact<{
  packageId: Scalars['Int']['input'];
  folioUser: Scalars['String']['input'];
}>;


export type PackageFolderAccessQuery = { readonly __typename?: 'query_root', readonly package_by_pk?: { readonly __typename?: 'package', readonly id: number, readonly name: string, readonly permissions: ReadonlyArray<{ readonly __typename?: 'permission', readonly permission: User_Right_Enum }> } | null };

export type GlobalProductInfoFragmentFragment = { readonly __typename: 'global_product', readonly id: string, readonly name: string, readonly description?: string | null, readonly uom: Product_Uom_Enum, readonly geographical_region?: number | null, readonly commodity_group?: number | null, readonly global_package: number, readonly globalPackageByGlobalPackage: { readonly __typename?: 'global_package', readonly id: number, readonly name: string, readonly source: number, readonly description?: string | null, readonly package_type?: string | null, readonly sourceBySource?: { readonly __typename?: 'source', readonly id: number, readonly name: string, readonly alias?: string | null, readonly logo?: string | null, readonly source_type: Product_Source_Enum } | null, readonly global_permissions: ReadonlyArray<{ readonly __typename?: 'global_permission', readonly permission: User_Right_Enum, readonly folio_user: string }> } } & { ' $fragmentName'?: 'GlobalProductInfoFragmentFragment' };

export type GlobalProductsForLiveChartsQueryVariables = Exact<{
  folioUser: Scalars['String']['input'];
}>;


export type GlobalProductsForLiveChartsQuery = { readonly __typename?: 'query_root', readonly global_product: ReadonlyArray<(
    { readonly __typename?: 'global_product' }
    & { ' $fragmentRefs'?: { 'GlobalProductInfoFragmentFragment': GlobalProductInfoFragmentFragment } }
  )> };

export type GlobalPackagesByProductIdsQueryVariables = Exact<{
  productIds: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GlobalPackagesByProductIdsQuery = { readonly __typename?: 'query_root', readonly global_package: ReadonlyArray<{ readonly __typename?: 'global_package', readonly id: number, readonly source: number, readonly description?: string | null }> };

export type GlobalProductsByProductsIdsQueryVariables = Exact<{
  productIds: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GlobalProductsByProductsIdsQuery = { readonly __typename?: 'query_root', readonly global_product: ReadonlyArray<{ readonly __typename?: 'global_product', readonly id: string, readonly global_package: number }> };

export type PackagesFragmentFragment = { readonly __typename?: 'package', readonly id: number, readonly name: string, readonly source: number, readonly package_type?: Package_Type_Enum | null, readonly dp?: number | null } & { ' $fragmentName'?: 'PackagesFragmentFragment' };

export type PackagesDpQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PackagesDpQueryQuery = { readonly __typename?: 'query_root', readonly package: ReadonlyArray<{ readonly __typename?: 'package', readonly id: number, readonly dp?: number | null }> };

export type ProductUserSettingsFragmentFragment = { readonly __typename?: 'product_user_settings', readonly user_id: string, readonly product_id: string, readonly dp?: number | null } & { ' $fragmentName'?: 'ProductUserSettingsFragmentFragment' };

export type ProductUserSettingsByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ProductUserSettingsByUserIdQuery = { readonly __typename?: 'query_root', readonly product_user_settings: ReadonlyArray<(
    { readonly __typename?: 'product_user_settings' }
    & { ' $fragmentRefs'?: { 'ProductUserSettingsFragmentFragment': ProductUserSettingsFragmentFragment } }
  )> };

export type UpsertProductUserSettingsMutationVariables = Exact<{
  productId: Scalars['uuid']['input'];
  userId: Scalars['String']['input'];
  dp?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpsertProductUserSettingsMutation = { readonly __typename?: 'mutation_root', readonly insert_product_user_settings?: { readonly __typename?: 'product_user_settings_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'product_user_settings', readonly product_id: string, readonly user_id: string, readonly dp?: number | null }> } | null };

export type UserSessionSubSubscriptionVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
}>;


export type UserSessionSubSubscription = { readonly __typename?: 'subscription_root', readonly session_by_pk?: { readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null } | null };

export type Insert_Logout_Request_OneMutationVariables = Exact<{
  logout_request: Logout_Request_Insert_Input;
}>;


export type Insert_Logout_Request_OneMutation = { readonly __typename?: 'mutation_root', readonly insert_logout_request_one?: { readonly __typename?: 'logout_request', readonly logout_requested_at: string } | null };

export type UpdateUserSessionMutationVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
  session: Scalars['String']['input'];
}>;


export type UpdateUserSessionMutation = { readonly __typename?: 'mutation_root', readonly insert_session_one?: { readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null } | null, readonly delete_logout_request?: { readonly __typename?: 'logout_request_mutation_response', readonly affected_rows: number } | null };

export type UserSessionQueryQueryVariables = Exact<{
  user: Scalars['String']['input'];
  mobile: Scalars['Boolean']['input'];
}>;


export type UserSessionQueryQuery = { readonly __typename?: 'query_root', readonly session_by_pk?: { readonly __typename?: 'session', readonly id: string, readonly last_seen?: string | null } | null };

export type SourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type SourcesQuery = { readonly __typename?: 'query_root', readonly source: ReadonlyArray<{ readonly __typename?: 'source', readonly id: number, readonly name: string }> };

export type MarketUserPermissionsSubSubscriptionVariables = Exact<{
  folio_user: Scalars['String']['input'];
}>;


export type MarketUserPermissionsSubSubscription = { readonly __typename?: 'subscription_root', readonly permission: ReadonlyArray<{ readonly __typename?: 'permission', readonly id: number, readonly folio_user: string, readonly permission: User_Right_Enum, readonly package: number }> };

export type PermissionFolderDetailsQueryQueryVariables = Exact<{
  folio_user: Scalars['String']['input'];
  packages: ReadonlyArray<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type PermissionFolderDetailsQueryQuery = { readonly __typename?: 'query_root', readonly permission: ReadonlyArray<{ readonly __typename?: 'permission', readonly package: number, readonly packageByPackage: { readonly __typename?: 'package', readonly name: string, readonly package_type?: Package_Type_Enum | null, readonly products: ReadonlyArray<{ readonly __typename?: 'product', readonly id: string, readonly name: string }>, readonly products_aggregate: { readonly __typename?: 'product_aggregate', readonly aggregate?: { readonly __typename?: 'product_aggregate_fields', readonly count: number } | null } } }> };

export type CurrentUserFragmentFragment = { readonly __typename: 'folio_user', readonly id: string, readonly username: string, readonly email: string, readonly firstname: string, readonly lastname: string, readonly roles: JSONValue, readonly organisation: number, readonly subscription_tier: Subscription_Tier_Enum, readonly multisession_check_disabled?: boolean | null, readonly webapp2?: boolean | null, readonly persona?: string | null, readonly logout_requested_at?: string | null, readonly entitlement?: { readonly __typename?: 'user_entitlement_active', readonly level?: number | null, readonly code?: string | null, readonly expires_at?: string | null } | null } & { ' $fragmentName'?: 'CurrentUserFragmentFragment' };

export type CurrentUserSubSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CurrentUserSubSubscription = { readonly __typename?: 'subscription_root', readonly folio_user_by_pk?: (
    { readonly __typename?: 'folio_user' }
    & { ' $fragmentRefs'?: { 'CurrentUserFragmentFragment': CurrentUserFragmentFragment } }
  ) | null };

export type CurrentUserQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CurrentUserQueryQuery = { readonly __typename?: 'query_root', readonly folio_user_by_pk?: (
    { readonly __typename?: 'folio_user' }
    & { ' $fragmentRefs'?: { 'CurrentUserFragmentFragment': CurrentUserFragmentFragment } }
  ) | null };

export type BlockedUserSubSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlockedUserSubSubscription = { readonly __typename?: 'subscription_root', readonly folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string, readonly blocked: boolean } | null };

export type UserExchangePermissionsSubSubscriptionVariables = Exact<{
  folio_user: Scalars['String']['input'];
}>;


export type UserExchangePermissionsSubSubscription = { readonly __typename?: 'subscription_root', readonly permission: ReadonlyArray<{ readonly __typename?: 'permission', readonly id: number }> };

export type UserPermissionsDetailedSubSubscriptionVariables = Exact<{
  folio_user: Scalars['String']['input'];
}>;


export type UserPermissionsDetailedSubSubscription = { readonly __typename?: 'subscription_root', readonly permission: ReadonlyArray<{ readonly __typename?: 'permission', readonly id: number, readonly folio_user: string, readonly permission: User_Right_Enum, readonly package: number, readonly packageByPackage: { readonly __typename?: 'package', readonly id: number, readonly name: string, readonly package_type?: Package_Type_Enum | null, readonly sourceBySource: { readonly __typename?: 'source', readonly id: number, readonly name: string, readonly source_type: Product_Source_Enum, readonly exchange?: { readonly __typename?: 'exchange', readonly id: number, readonly code: number } | null } } }> };

export type UpdateUserPersonaMutationVariables = Exact<{
  id: Scalars['String']['input'];
  persona?: InputMaybe<Scalars['persona_enum']['input']>;
}>;


export type UpdateUserPersonaMutation = { readonly __typename?: 'mutation_root', readonly update_folio_user_by_pk?: { readonly __typename?: 'folio_user', readonly id: string, readonly persona?: string | null } | null };

export type LastExchangeUsageForSingleUserSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type LastExchangeUsageForSingleUserSubscription = { readonly __typename?: 'subscription_root', readonly exchange_usage_last: ReadonlyArray<{ readonly __typename?: 'exchange_usage_last', readonly source?: number | null, readonly event?: string | null }> };

export type AmendExchangeUsageMutationVariables = Exact<{
  exchangeUsages: ReadonlyArray<Exchange_Usage_Insert_Input> | Exchange_Usage_Insert_Input;
}>;


export type AmendExchangeUsageMutation = { readonly __typename?: 'mutation_root', readonly insert_exchange_usage?: { readonly __typename?: 'exchange_usage_mutation_response', readonly affected_rows: number } | null };

export type UserGroupsFragmentFragment = { readonly __typename?: 'user_groups', readonly id: string, readonly display_name: string, readonly users?: JSONValue | null } & { ' $fragmentName'?: 'UserGroupsFragmentFragment' };

export type UserGroupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGroupsQueryQuery = { readonly __typename?: 'query_root', readonly user_groups: ReadonlyArray<(
    { readonly __typename?: 'user_groups' }
    & { ' $fragmentRefs'?: { 'UserGroupsFragmentFragment': UserGroupsFragmentFragment } }
  )> };

export type OrgUserFragmentFragment = { readonly __typename?: 'folio_user_basic_profile', readonly id?: string | null, readonly firstname?: string | null, readonly lastname?: string | null, readonly username?: string | null, readonly subscription_tier?: string | null, readonly blocked?: boolean | null, readonly is_staff?: boolean | null } & { ' $fragmentName'?: 'OrgUserFragmentFragment' };

export type OrgUserProfilesQueryQueryVariables = Exact<{
  orgId: Scalars['Int']['input'];
}>;


export type OrgUserProfilesQueryQuery = { readonly __typename?: 'query_root', readonly folio_user_basic_profile: ReadonlyArray<(
    { readonly __typename?: 'folio_user_basic_profile' }
    & { ' $fragmentRefs'?: { 'OrgUserFragmentFragment': OrgUserFragmentFragment } }
  )> };

export type UserProfilesByIdsQueryQueryVariables = Exact<{
  userIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UserProfilesByIdsQueryQuery = { readonly __typename?: 'query_root', readonly folio_user_basic_profile: ReadonlyArray<(
    { readonly __typename?: 'folio_user_basic_profile' }
    & { ' $fragmentRefs'?: { 'OrgUserFragmentFragment': OrgUserFragmentFragment } }
  )> };

export type PersonaEnumQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonaEnumQueryQuery = { readonly __typename?: 'query_root', readonly __type?: { readonly __typename?: '__Type', readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string }> | null } | null };

export type AlertFragFragment = { readonly __typename?: 'alerts', readonly id: string, readonly limit: string, readonly _id?: string | null, readonly column_id: string, readonly desktop_notification_sent?: boolean | null, readonly field_selector?: string | null, readonly note?: string | null, readonly page_id: string, readonly product_id: string, readonly push_notification_sent?: boolean | null, readonly recurring?: boolean | null, readonly row_id: string, readonly sound?: boolean | null, readonly status: string, readonly triggered_at?: string | null, readonly user_id: string, readonly value_below_limit: boolean, readonly created_at?: string | null, readonly expired_at?: string | null } & { ' $fragmentName'?: 'AlertFragFragment' };

export type AlertSubSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AlertSubSubscription = { readonly __typename?: 'subscription_root', readonly alerts: ReadonlyArray<(
    { readonly __typename?: 'alerts' }
    & { ' $fragmentRefs'?: { 'AlertFragFragment': AlertFragFragment } }
  )> };

export type AlertChangeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  values: Alerts_Set_Input;
}>;


export type AlertChangeMutation = { readonly __typename?: 'mutation_root', readonly update_alerts_by_pk?: { readonly __typename?: 'alerts', readonly id: string } | null };

export type AlertRemoveMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertRemoveMutation = { readonly __typename?: 'mutation_root', readonly delete_alerts_by_pk?: { readonly __typename?: 'alerts', readonly id: string } | null };

export type PageProductIdsSubSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PageProductIdsSubSubscription = { readonly __typename?: 'subscription_root', readonly page_products: ReadonlyArray<{ readonly __typename?: 'page_products', readonly product_id?: string | null }> };

export type PriorEodDateQueryQueryVariables = Exact<{
  from: Scalars['date']['input'];
  to: Scalars['date']['input'];
}>;


export type PriorEodDateQueryQuery = { readonly __typename?: 'query_root', readonly prior: ReadonlyArray<{ readonly __typename?: 'eod_entry', readonly evaluation_date: string }> };

export type EodSnapshotQueryQueryVariables = Exact<{
  from: Scalars['date']['input'];
  to: Scalars['date']['input'];
  eval_date: Scalars['date']['input'];
  month: Scalars['date']['input'];
}>;


export type EodSnapshotQueryQuery = { readonly __typename?: 'query_root', readonly prior: ReadonlyArray<{ readonly __typename?: 'eod_entry', readonly evaluation_date: string }>, readonly entries: ReadonlyArray<{ readonly __typename?: 'eod_entry', readonly month: string, readonly product: string, readonly value: number }> };

export type LocalFragFragment = { readonly __typename?: 'local_instrument', readonly product: string, readonly storage_type: User_Storage_Enum, readonly folio_user: string, readonly edited_at: string, readonly month: string, readonly value?: number | null } & { ' $fragmentName'?: 'LocalFragFragment' };

export type LocalQueryQueryVariables = Exact<{
  latest_date: Scalars['timestamptz']['input'];
  current_month: Scalars['date']['input'];
  latest_month: Scalars['date']['input'];
}>;


export type LocalQueryQuery = { readonly __typename?: 'query_root', readonly local_instrument: ReadonlyArray<(
    { readonly __typename?: 'local_instrument' }
    & { ' $fragmentRefs'?: { 'LocalFragFragment': LocalFragFragment } }
  )> };

export type LocalSubSubscriptionVariables = Exact<{
  latest_date: Scalars['timestamptz']['input'];
  current_month: Scalars['date']['input'];
  latest_month: Scalars['date']['input'];
}>;


export type LocalSubSubscription = { readonly __typename?: 'subscription_root', readonly local_instrument: ReadonlyArray<(
    { readonly __typename?: 'local_instrument' }
    & { ' $fragmentRefs'?: { 'LocalFragFragment': LocalFragFragment } }
  )> };

export type SharedFragFragment = { readonly __typename?: 'shared_instrument', readonly product: string, readonly edited_at: string, readonly edited_by: string, readonly month: string, readonly value?: number | null, readonly folio_user?: { readonly __typename?: 'folio_user_basic_profile', readonly id?: string | null, readonly username?: string | null, readonly firstname?: string | null, readonly lastname?: string | null } | null } & { ' $fragmentName'?: 'SharedFragFragment' };

export type SharedQueryQueryVariables = Exact<{
  current_month: Scalars['date']['input'];
  latest_month: Scalars['date']['input'];
}>;


export type SharedQueryQuery = { readonly __typename?: 'query_root', readonly shared_instrument: ReadonlyArray<(
    { readonly __typename?: 'shared_instrument' }
    & { ' $fragmentRefs'?: { 'SharedFragFragment': SharedFragFragment } }
  )> };

export type SharedSubSubscriptionVariables = Exact<{
  current_date?: InputMaybe<Scalars['timestamptz']['input']>;
  current_month: Scalars['date']['input'];
  latest_month: Scalars['date']['input'];
}>;


export type SharedSubSubscription = { readonly __typename?: 'subscription_root', readonly shared_instrument_stream: ReadonlyArray<(
    { readonly __typename?: 'shared_instrument' }
    & { ' $fragmentRefs'?: { 'SharedFragFragment': SharedFragFragment } }
  )> };

export type GlobalFragFragment = { readonly __typename?: 'global_instrument', readonly id: number, readonly month: string, readonly value?: number | null, readonly edited_at: string, readonly edited_by: string, readonly product: string } & { ' $fragmentName'?: 'GlobalFragFragment' };

export type GlobalQueryQueryVariables = Exact<{
  current_month: Scalars['date']['input'];
  latest_month: Scalars['date']['input'];
}>;


export type GlobalQueryQuery = { readonly __typename?: 'query_root', readonly global_instrument: ReadonlyArray<(
    { readonly __typename?: 'global_instrument' }
    & { ' $fragmentRefs'?: { 'GlobalFragFragment': GlobalFragFragment } }
  )> };

export type GlobalSubSubscriptionVariables = Exact<{
  current_date?: InputMaybe<Scalars['timestamptz']['input']>;
  current_month: Scalars['date']['input'];
  latest_month: Scalars['date']['input'];
}>;


export type GlobalSubSubscription = { readonly __typename?: 'subscription_root', readonly global_instrument_stream: ReadonlyArray<(
    { readonly __typename?: 'global_instrument' }
    & { ' $fragmentRefs'?: { 'GlobalFragFragment': GlobalFragFragment } }
  )> };

export type SpreaderStateFragmentFragment = { readonly __typename?: 'spreader_state', readonly id: string, readonly page_id: string, readonly row_data?: JSONValue | null, readonly row_idx: number, readonly user_id: string } & { ' $fragmentName'?: 'SpreaderStateFragmentFragment' };

export type SpreaderStateByPageIdQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type SpreaderStateByPageIdQuery = { readonly __typename?: 'query_root', readonly spreader_state: ReadonlyArray<(
    { readonly __typename?: 'spreader_state' }
    & { ' $fragmentRefs'?: { 'SpreaderStateFragmentFragment': SpreaderStateFragmentFragment } }
  )> };

export type SpreaderStateByPageIdsQueryVariables = Exact<{
  pageIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SpreaderStateByPageIdsQuery = { readonly __typename?: 'query_root', readonly spreader_state: ReadonlyArray<(
    { readonly __typename?: 'spreader_state' }
    & { ' $fragmentRefs'?: { 'SpreaderStateFragmentFragment': SpreaderStateFragmentFragment } }
  )> };

export type DeleteSpreaderStateByUserIdMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteSpreaderStateByUserIdMutation = { readonly __typename?: 'mutation_root', readonly delete_spreader_state?: { readonly __typename?: 'spreader_state_mutation_response', readonly affected_rows: number } | null };

export type InsertSpreaderStateManyMutationVariables = Exact<{
  objects: ReadonlyArray<Spreader_State_Insert_Input> | Spreader_State_Insert_Input;
}>;


export type InsertSpreaderStateManyMutation = { readonly __typename?: 'mutation_root', readonly insert_spreader_state?: { readonly __typename?: 'spreader_state_mutation_response', readonly affected_rows: number } | null };

export type SpreaderStateSubSubscriptionVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type SpreaderStateSubSubscription = { readonly __typename?: 'subscription_root', readonly spreader_state: ReadonlyArray<(
    { readonly __typename?: 'spreader_state' }
    & { ' $fragmentRefs'?: { 'SpreaderStateFragmentFragment': SpreaderStateFragmentFragment } }
  )> };

export type UpsertSpreaderStateMutationVariables = Exact<{
  row: Spreader_State_Insert_Input;
}>;


export type UpsertSpreaderStateMutation = { readonly __typename?: 'mutation_root', readonly insert_spreader_state_one?: (
    { readonly __typename?: 'spreader_state' }
    & { ' $fragmentRefs'?: { 'SpreaderStateFragmentFragment': SpreaderStateFragmentFragment } }
  ) | null };

export type SpreaderStateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SpreaderStateDeleteMutation = { readonly __typename?: 'mutation_root', readonly delete_spreader_state_by_pk?: { readonly __typename?: 'spreader_state', readonly id: string } | null };

export type CurvePackageFragmentFragment = { readonly __typename?: 'package', readonly id: number, readonly name: string, readonly package_type?: Package_Type_Enum | null, readonly permissions: ReadonlyArray<{ readonly __typename?: 'permission', readonly permission: User_Right_Enum }>, readonly folio_users: ReadonlyArray<{ readonly __typename?: 'folio_user', readonly id: string }> } & { ' $fragmentName'?: 'CurvePackageFragmentFragment' };

export type CurvePackageQueryVariables = Exact<{ [key: string]: never; }>;


export type CurvePackageQuery = { readonly __typename?: 'query_root', readonly package: ReadonlyArray<(
    { readonly __typename?: 'package' }
    & { ' $fragmentRefs'?: { 'CurvePackageFragmentFragment': CurvePackageFragmentFragment } }
  )> };

export type CurveEodProductsQueryVariables = Exact<{
  folioUser: Scalars['String']['input'];
}>;


export type CurveEodProductsQuery = { readonly __typename?: 'query_root', readonly product: ReadonlyArray<(
    { readonly __typename?: 'product' }
    & { ' $fragmentRefs'?: { 'ProductInfoFragmentFragment': ProductInfoFragmentFragment } }
  )> };

export type GlobalCurvesQueryVariables = Exact<{
  folioUser: Scalars['String']['input'];
}>;


export type GlobalCurvesQuery = { readonly __typename?: 'query_root', readonly global_product: ReadonlyArray<(
    { readonly __typename?: 'global_product' }
    & { ' $fragmentRefs'?: { 'GlobalProductInfoFragmentFragment': GlobalProductInfoFragmentFragment } }
  )> };

export type CurvePackagesFragmentFragment = { readonly __typename?: 'package', readonly id: number, readonly name: string, readonly package_type?: Package_Type_Enum | null } & { ' $fragmentName'?: 'CurvePackagesFragmentFragment' };

export type CurvePackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurvePackagesQuery = { readonly __typename?: 'query_root', readonly package: ReadonlyArray<(
    { readonly __typename?: 'package' }
    & { ' $fragmentRefs'?: { 'CurvePackagesFragmentFragment': CurvePackagesFragmentFragment } }
  )> };

export type CurveUomFragmentFragment = { readonly __typename?: 'product_uom', readonly value: string, readonly description?: string | null } & { ' $fragmentName'?: 'CurveUomFragmentFragment' };

export type CurveUomQueryVariables = Exact<{ [key: string]: never; }>;


export type CurveUomQuery = { readonly __typename?: 'query_root', readonly product_uom: ReadonlyArray<(
    { readonly __typename?: 'product_uom' }
    & { ' $fragmentRefs'?: { 'CurveUomFragmentFragment': CurveUomFragmentFragment } }
  )> };

export type CurveProductTypeFragmentFragment = { readonly __typename?: 'product_type', readonly value: string } & { ' $fragmentName'?: 'CurveProductTypeFragmentFragment' };

export type CurveProductTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type CurveProductTypeQuery = { readonly __typename?: 'query_root', readonly product_type: ReadonlyArray<(
    { readonly __typename?: 'product_type' }
    & { ' $fragmentRefs'?: { 'CurveProductTypeFragmentFragment': CurveProductTypeFragmentFragment } }
  )> };

export type CurveCommodityParentGroupFragmentFragment = { readonly __typename?: 'commodity_parent_group', readonly id: number, readonly value?: string | null } & { ' $fragmentName'?: 'CurveCommodityParentGroupFragmentFragment' };

export type CurveCommodityParentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurveCommodityParentGroupsQuery = { readonly __typename?: 'query_root', readonly commodity_parent_group: ReadonlyArray<(
    { readonly __typename?: 'commodity_parent_group' }
    & { ' $fragmentRefs'?: { 'CurveCommodityParentGroupFragmentFragment': CurveCommodityParentGroupFragmentFragment } }
  )> };

export type CurveRegionsFragmentFragment = { readonly __typename?: 'geographical_region', readonly id: number, readonly value?: string | null } & { ' $fragmentName'?: 'CurveRegionsFragmentFragment' };

export type CurveRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurveRegionsQuery = { readonly __typename?: 'query_root', readonly geographical_region: ReadonlyArray<(
    { readonly __typename?: 'geographical_region' }
    & { ' $fragmentRefs'?: { 'CurveRegionsFragmentFragment': CurveRegionsFragmentFragment } }
  )> };

export type CurveCommodityGroupFragmentFragment = { readonly __typename?: 'commodity_group', readonly id: number, readonly value?: string | null, readonly parent: number } & { ' $fragmentName'?: 'CurveCommodityGroupFragmentFragment' };

export type CurveCommodityGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurveCommodityGroupsQuery = { readonly __typename?: 'query_root', readonly commodity_group: ReadonlyArray<(
    { readonly __typename?: 'commodity_group' }
    & { ' $fragmentRefs'?: { 'CurveCommodityGroupFragmentFragment': CurveCommodityGroupFragmentFragment } }
  )> };

export type CurveUpsertMutationMutationVariables = Exact<{
  products: ReadonlyArray<Product_Insert_Input> | Product_Insert_Input;
  product_configs: ReadonlyArray<Product_Config_Insert_Input> | Product_Config_Insert_Input;
  offsets_to_delete: ReadonlyArray<Scalars['Int']['input']> | Scalars['Int']['input'];
  product_id: Scalars['uuid']['input'];
}>;


export type CurveUpsertMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_product?: { readonly __typename?: 'product_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'product', readonly id: string }> } | null, readonly delete_product_config?: { readonly __typename?: 'product_config_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'product_config', readonly id: number }> } | null, readonly insert_product_config?: { readonly __typename?: 'product_config_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'product_config', readonly id: number }> } | null };

export type CurveGlobalDependenciesQueryVariables = Exact<{
  product: Scalars['uuid']['input'];
}>;


export type CurveGlobalDependenciesQuery = { readonly __typename?: 'query_root', readonly product_global_dependencies: ReadonlyArray<{ readonly __typename?: 'product_global_dependencies', readonly global_product: string, readonly product: string }> };

export type CurveGlobalInsertMutationMutationVariables = Exact<{
  objects: ReadonlyArray<Product_Global_Dependencies_Insert_Input> | Product_Global_Dependencies_Insert_Input;
}>;


export type CurveGlobalInsertMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_product_global_dependencies?: { readonly __typename?: 'product_global_dependencies_mutation_response', readonly affected_rows: number } | null };

export type CurveGlobalDeleteMutationMutationVariables = Exact<{
  global_products?: InputMaybe<ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  product?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CurveGlobalDeleteMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_product_global_dependencies?: { readonly __typename?: 'product_global_dependencies_mutation_response', readonly returning: ReadonlyArray<{ readonly __typename?: 'product_global_dependencies', readonly product: string, readonly global_product: string }> } | null };

export type GlobalPackagesByIdsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GlobalPackagesByIdsQuery = { readonly __typename?: 'query_root', readonly global_package: ReadonlyArray<{ readonly __typename?: 'global_package', readonly id: number }> };

export type AllGlobalisedPackageIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGlobalisedPackageIdsQuery = { readonly __typename?: 'query_root', readonly global_package: ReadonlyArray<{ readonly __typename?: 'global_package', readonly id: number }> };

export type GlobalisedPackageFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalisedPackageFlagsQuery = { readonly __typename?: 'query_root', readonly package: ReadonlyArray<{ readonly __typename?: 'package', readonly id: number }> };

export type GlobalCurveMirrorsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GlobalCurveMirrorsQuery = { readonly __typename?: 'query_root', readonly global_product: ReadonlyArray<{ readonly __typename?: 'global_product', readonly id: string, readonly global_package: number }> };

export type UpsertGlobalCurvesMutationVariables = Exact<{
  globalProducts: ReadonlyArray<Global_Product_Insert_Input> | Global_Product_Insert_Input;
  globalProductConfigs: ReadonlyArray<Global_Product_Config_Insert_Input> | Global_Product_Config_Insert_Input;
  offsetsToDelete: ReadonlyArray<Scalars['Int']['input']> | Scalars['Int']['input'];
  productIds: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpsertGlobalCurvesMutation = { readonly __typename?: 'mutation_root', readonly insert_global_product?: { readonly __typename?: 'global_product_mutation_response', readonly affected_rows: number } | null, readonly delete_global_product_config?: { readonly __typename?: 'global_product_config_mutation_response', readonly affected_rows: number } | null, readonly insert_global_product_config?: { readonly __typename?: 'global_product_config_mutation_response', readonly affected_rows: number } | null };

export type InsertGlobalCurveSelfDepsMutationVariables = Exact<{
  objects: ReadonlyArray<Product_Global_Dependencies_Insert_Input> | Product_Global_Dependencies_Insert_Input;
}>;


export type InsertGlobalCurveSelfDepsMutation = { readonly __typename?: 'mutation_root', readonly insert_product_global_dependencies?: { readonly __typename?: 'product_global_dependencies_mutation_response', readonly affected_rows: number } | null };

export type RemoveGlobalCurvesMutationVariables = Exact<{
  globalProductIds: ReadonlyArray<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type RemoveGlobalCurvesMutation = { readonly __typename?: 'mutation_root', readonly delete_global_product_config?: { readonly __typename?: 'global_product_config_mutation_response', readonly affected_rows: number } | null, readonly delete_product_global_dependencies?: { readonly __typename?: 'product_global_dependencies_mutation_response', readonly affected_rows: number } | null, readonly delete_global_product?: { readonly __typename?: 'global_product_mutation_response', readonly affected_rows: number } | null };

export type GridChartsFragmentFragment = { readonly __typename?: 'grid_charts', readonly id: string, readonly idx: number, readonly user_id: string, readonly product_id?: string | null, readonly selector?: string | null, readonly period?: number | null } & { ' $fragmentName'?: 'GridChartsFragmentFragment' };

export type GridChartsQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GridChartsQueryQuery = { readonly __typename?: 'query_root', readonly grid_charts: ReadonlyArray<(
    { readonly __typename?: 'grid_charts' }
    & { ' $fragmentRefs'?: { 'GridChartsFragmentFragment': GridChartsFragmentFragment } }
  )> };

export type GridChartsDeleteMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GridChartsDeleteMutationMutation = { readonly __typename?: 'mutation_root', readonly delete_grid_charts?: { readonly __typename?: 'grid_charts_mutation_response', readonly affected_rows: number } | null };

export type GridChartsDeleteByUserIdMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GridChartsDeleteByUserIdMutation = { readonly __typename?: 'mutation_root', readonly delete_grid_charts?: { readonly __typename?: 'grid_charts_mutation_response', readonly affected_rows: number } | null };

export type GridChartsInsertManyMutationVariables = Exact<{
  objects: ReadonlyArray<Grid_Charts_Insert_Input> | Grid_Charts_Insert_Input;
}>;


export type GridChartsInsertManyMutation = { readonly __typename?: 'mutation_root', readonly insert_grid_charts?: { readonly __typename?: 'grid_charts_mutation_response', readonly affected_rows: number } | null };

export type GridChartsUpsertMutationMutationVariables = Exact<{
  object: Grid_Charts_Insert_Input;
}>;


export type GridChartsUpsertMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_grid_charts_one?: { readonly __typename?: 'grid_charts', readonly id: string } | null };

export type ViewedAnnouncementsFragmentFragment = { readonly __typename?: 'viewed_announcements', readonly id: string, readonly user_id: string, readonly announcement_id: string, readonly title: string, readonly viewed_at?: string | null, readonly dismissed_at?: string | null } & { ' $fragmentName'?: 'ViewedAnnouncementsFragmentFragment' };

export type ViewedAnnouncementsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ViewedAnnouncementsQuery = { readonly __typename?: 'query_root', readonly viewed_announcements: ReadonlyArray<(
    { readonly __typename?: 'viewed_announcements' }
    & { ' $fragmentRefs'?: { 'ViewedAnnouncementsFragmentFragment': ViewedAnnouncementsFragmentFragment } }
  )> };

export type InsertAnnouncementStateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  announcementId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type InsertAnnouncementStateMutation = { readonly __typename?: 'mutation_root', readonly insert_viewed_announcements_one?: (
    { readonly __typename?: 'viewed_announcements' }
    & { ' $fragmentRefs'?: { 'ViewedAnnouncementsFragmentFragment': ViewedAnnouncementsFragmentFragment } }
  ) | null };

export type UpdateAnnouncementStateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  set: Viewed_Announcements_Set_Input;
}>;


export type UpdateAnnouncementStateMutation = { readonly __typename?: 'mutation_root', readonly update_viewed_announcements_by_pk?: (
    { readonly __typename?: 'viewed_announcements' }
    & { ' $fragmentRefs'?: { 'ViewedAnnouncementsFragmentFragment': ViewedAnnouncementsFragmentFragment } }
  ) | null };

export type QuickAccessFragmentFragment = { readonly __typename?: 'quick_access', readonly id: string, readonly user_id: string, readonly page_id: string, readonly column_id: string, readonly product_id?: string | null, readonly shortcut_number: number } & { ' $fragmentName'?: 'QuickAccessFragmentFragment' };

export type QuickAccessQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type QuickAccessQueryQuery = { readonly __typename?: 'query_root', readonly quick_access: ReadonlyArray<(
    { readonly __typename?: 'quick_access' }
    & { ' $fragmentRefs'?: { 'QuickAccessFragmentFragment': QuickAccessFragmentFragment } }
  )> };

export type QuickAccessUpsertMutationMutationVariables = Exact<{
  object: Quick_Access_Insert_Input;
}>;


export type QuickAccessUpsertMutationMutation = { readonly __typename?: 'mutation_root', readonly insert_quick_access_one?: { readonly __typename?: 'quick_access', readonly id: string } | null };

export type PushSubscriptionFragmentFragment = { readonly __typename?: 'push_subscriptions', readonly user_id: string, readonly subscriptions: JSONValue } & { ' $fragmentName'?: 'PushSubscriptionFragmentFragment' };

export type PushSubscriptionQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PushSubscriptionQuery = { readonly __typename?: 'query_root', readonly push_subscriptions: ReadonlyArray<(
    { readonly __typename?: 'push_subscriptions' }
    & { ' $fragmentRefs'?: { 'PushSubscriptionFragmentFragment': PushSubscriptionFragmentFragment } }
  )> };

export type UpsertPushSubscriptionMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  subscriptions: Scalars['jsonb']['input'];
}>;


export type UpsertPushSubscriptionMutation = { readonly __typename?: 'mutation_root', readonly insert_push_subscriptions_one?: (
    { readonly __typename?: 'push_subscriptions' }
    & { ' $fragmentRefs'?: { 'PushSubscriptionFragmentFragment': PushSubscriptionFragmentFragment } }
  ) | null };

export const AlertFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertFragmentFragment, unknown>;
export const ConditionalFormattingRulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"bg_color"}},{"kind":"Field","name":{"kind":"Name","value":"bold_text"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"invert_text_color"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority_idx"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"stop_if_true"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<ConditionalFormattingRulesFragmentFragment, unknown>;
export const GridSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_rows"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_switch"}},{"kind":"Field","name":{"kind":"Name","value":"alternating_row_colours"}},{"kind":"Field","name":{"kind":"Name","value":"broadcast_colour"}},{"kind":"Field","name":{"kind":"Name","value":"cal_current"}},{"kind":"Field","name":{"kind":"Name","value":"cal_switch"}},{"kind":"Field","name":{"kind":"Name","value":"cals"}},{"kind":"Field","name":{"kind":"Name","value":"enable_full_month_row_feature"}},{"kind":"Field","name":{"kind":"Name","value":"eod_colour"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"flash_cell_updates"}},{"kind":"Field","name":{"kind":"Name","value":"global_colour"}},{"kind":"Field","name":{"kind":"Name","value":"grid_scratchpad_switch"}},{"kind":"Field","name":{"kind":"Name","value":"header_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"hide_broadcast"}},{"kind":"Field","name":{"kind":"Name","value":"hide_eod"}},{"kind":"Field","name":{"kind":"Name","value":"hide_global"}},{"kind":"Field","name":{"kind":"Name","value":"hide_private"}},{"kind":"Field","name":{"kind":"Name","value":"hide_status_row"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_current"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_switch"}},{"kind":"Field","name":{"kind":"Name","value":"hlvs"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_colour"}},{"kind":"Field","name":{"kind":"Name","value":"increment_map"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_map"}},{"kind":"Field","name":{"kind":"Name","value":"indicator_colour"}},{"kind":"Field","name":{"kind":"Name","value":"listen_colour"}},{"kind":"Field","name":{"kind":"Name","value":"local_colour"}},{"kind":"Field","name":{"kind":"Name","value":"main_month_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_current"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_switch"}},{"kind":"Field","name":{"kind":"Name","value":"qtrs"}},{"kind":"Field","name":{"kind":"Name","value":"quarter_borders"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_cols"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_rows"}},{"kind":"Field","name":{"kind":"Name","value":"season_current"}},{"kind":"Field","name":{"kind":"Name","value":"season_switch"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status_map"}},{"kind":"Field","name":{"kind":"Name","value":"subheader_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"eod_date"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_bracket"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_snapshot_warnings"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_color"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"detailed_tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_curve_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_multiple_curves_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_single_value_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_anomaly_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_paste_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_drag_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_page_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"show_world_clock"}},{"kind":"Field","name":{"kind":"Name","value":"insert_page_position"}},{"kind":"Field","name":{"kind":"Name","value":"insert_column_position"}},{"kind":"Field","name":{"kind":"Name","value":"default_curve_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"anomaly_sensitivity_level"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_dp"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_calc"}},{"kind":"Field","name":{"kind":"Name","value":"saved_colours"}}]}}]} as unknown as DocumentNode<GridSettingsFragment, unknown>;
export const GridSettingsThemeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridSettingsTheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}}]}}]} as unknown as DocumentNode<GridSettingsThemeFragment, unknown>;
export const HfcAbsoluteFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HFCAbsoluteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eod_entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"productByProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}}]}}]}}]} as unknown as DocumentNode<HfcAbsoluteFragmentFragment, unknown>;
export const HfcRelativeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HFCRelativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eod_entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}},{"kind":"Field","name":{"kind":"Name","value":"relative_period"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"productByProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}}]}}]}}]} as unknown as DocumentNode<HfcRelativeFragmentFragment, unknown>;
export const LiveChartPageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_page"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charts"}},{"kind":"Field","name":{"kind":"Name","value":"page_type"}}]}}]} as unknown as DocumentNode<LiveChartPageFragmentFragment, unknown>;
export const LiveChartSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"curve_settings"}},{"kind":"Field","name":{"kind":"Name","value":"charts_state"}},{"kind":"Field","name":{"kind":"Name","value":"user_settings"}}]}}]} as unknown as DocumentNode<LiveChartSettingsFragmentFragment, unknown>;
export const LiveChartAnnotationsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartAnnotationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_annotations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"}}]}}]} as unknown as DocumentNode<LiveChartAnnotationsFragmentFragment, unknown>;
export const PageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}}]} as unknown as DocumentNode<PageFragmentFragment, unknown>;
export const PageMemberFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_order"}},{"kind":"Field","name":{"kind":"Name","value":"Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}}]} as unknown as DocumentNode<PageMemberFragmentFragment, unknown>;
export const PageProductsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageProductsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_products"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grid_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_places"}},{"kind":"Field","name":{"kind":"Name","value":"column_width"}},{"kind":"Field","name":{"kind":"Name","value":"column_type"}},{"kind":"Field","name":{"kind":"Name","value":"column_field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<PageProductsFragmentFragment, unknown>;
export const ProductInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"artis_type"}},{"kind":"Field","name":{"kind":"Name","value":"curve_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"eod_product_dep"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"has_shared_cell"}},{"kind":"Field","name":{"kind":"Name","value":"logical_code"}},{"kind":"Field","name":{"kind":"Name","value":"maturity"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"summary_type"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}},{"kind":"Field","name":{"kind":"Name","value":"product_uom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupByCommodityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","alias":{"kind":"Name","value":"commodity_group"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"commodity_parent_group"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalRegionByGeographicalRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"geographical_region"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_global_dependencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"}}]}}]}}]} as unknown as DocumentNode<ProductInfoFragmentFragment, unknown>;
export const GlobalProductInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"global_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"global_package"}},{"kind":"Field","name":{"kind":"Name","value":"globalPackageByGlobalPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"global_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}}]}}]}}]} as unknown as DocumentNode<GlobalProductInfoFragmentFragment, unknown>;
export const PackagesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}}]}}]} as unknown as DocumentNode<PackagesFragmentFragment, unknown>;
export const ProductUserSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product_user_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}}]}}]} as unknown as DocumentNode<ProductUserSettingsFragmentFragment, unknown>;
export const CurrentUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folio_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"}},{"kind":"Field","name":{"kind":"Name","value":"multisession_check_disabled"}},{"kind":"Field","name":{"kind":"Name","value":"webapp2"}},{"kind":"Field","name":{"kind":"Name","value":"persona"}},{"kind":"Field","name":{"kind":"Name","value":"logout_requested_at"}},{"kind":"Field","name":{"kind":"Name","value":"entitlement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}}]}}]}}]} as unknown as DocumentNode<CurrentUserFragmentFragment, unknown>;
export const UserGroupsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"users"}}]}}]} as unknown as DocumentNode<UserGroupsFragmentFragment, unknown>;
export const OrgUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folio_user_basic_profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"is_staff"}}]}}]} as unknown as DocumentNode<OrgUserFragmentFragment, unknown>;
export const AlertFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertFragFragment, unknown>;
export const LocalFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"local_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"storage_type"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<LocalFragFragment, unknown>;
export const SharedFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"shared_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]} as unknown as DocumentNode<SharedFragFragment, unknown>;
export const GlobalFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"global_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"global_product"}}]}}]} as unknown as DocumentNode<GlobalFragFragment, unknown>;
export const SpreaderStateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpreaderStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"row_data"}},{"kind":"Field","name":{"kind":"Name","value":"row_idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<SpreaderStateFragmentFragment, unknown>;
export const CurvePackageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurvePackageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folio_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CurvePackageFragmentFragment, unknown>;
export const CurvePackagesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurvePackagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}}]}}]} as unknown as DocumentNode<CurvePackagesFragmentFragment, unknown>;
export const CurveUomFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveUOMFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product_uom"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<CurveUomFragmentFragment, unknown>;
export const CurveProductTypeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CurveProductTypeFragmentFragment, unknown>;
export const CurveCommodityParentGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveCommodityParentGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"commodity_parent_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CurveCommodityParentGroupFragmentFragment, unknown>;
export const CurveRegionsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveRegionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"geographical_region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CurveRegionsFragmentFragment, unknown>;
export const CurveCommodityGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveCommodityGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"commodity_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}}]}}]} as unknown as DocumentNode<CurveCommodityGroupFragmentFragment, unknown>;
export const GridChartsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridChartsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_charts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"selector"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]} as unknown as DocumentNode<GridChartsFragmentFragment, unknown>;
export const ViewedAnnouncementsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"viewed_announcements"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"announcement_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"dismissed_at"}}]}}]} as unknown as DocumentNode<ViewedAnnouncementsFragmentFragment, unknown>;
export const QuickAccessFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickAccessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"quick_access"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"shortcut_number"}}]}}]} as unknown as DocumentNode<QuickAccessFragmentFragment, unknown>;
export const PushSubscriptionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PushSubscriptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"push_subscriptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"}}]}}]} as unknown as DocumentNode<PushSubscriptionFragmentFragment, unknown>;
export const MemberQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<MemberQueryQuery, MemberQueryQueryVariables>;
export const GetPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}}]}}]}}]} as unknown as DocumentNode<GetPageQueryQuery, GetPageQueryQueryVariables>;
export const CreatePageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pages_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pages_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePageMutationMutation, CreatePageMutationMutationVariables>;
export const CreatePageMemberMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePageMemberMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"page_member_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_page_member_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<CreatePageMemberMutationMutation, CreatePageMemberMutationMutationVariables>;
export const RollbackPageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RollbackPageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_pages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RollbackPageMutationMutation, RollbackPageMutationMutationVariables>;
export const PageMembersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMembersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<PageMembersQueryQuery, PageMembersQueryQueryVariables>;
export const DeletePageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_pages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePageMutationMutation, DeletePageMutationMutationVariables>;
export const DeletePageMemberMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePageMemberMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeletePageMemberMutationMutation, DeletePageMemberMutationMutationVariables>;
export const PageMembersBulkQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMembersBulkQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<PageMembersBulkQueryQuery, PageMembersBulkQueryQueryVariables>;
export const DeletePageBulkMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePageBulkMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_pages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePageBulkMutationMutation, DeletePageBulkMutationMutationVariables>;
export const DeletePageMemberBulkMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePageMemberBulkMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeletePageMemberBulkMutationMutation, DeletePageMemberBulkMutationMutationVariables>;
export const InsertInstrumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertInstruments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shared_instruments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"shared_instrument_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_shared_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shared_instruments"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"shared_instrument_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"},{"kind":"EnumValue","value":"edited_by"},{"kind":"EnumValue","value":"edited_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"}}]}}]}}]}}]} as unknown as DocumentNode<InsertInstrumentsMutation, InsertInstrumentsMutationVariables>;
export const DeleteInstrumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteInstruments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_shared_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteInstrumentsMutation, DeleteInstrumentsMutationVariables>;
export const TestUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"testUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}}]} as unknown as DocumentNode<TestUserByIdQuery, TestUserByIdQueryVariables>;
export const MyMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MyMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"edited_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"edited_by"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"global_product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_global_instrument_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"edited_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edited_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"edited_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edited_by"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"global_product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"global_product"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"global_instrument_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"},{"kind":"EnumValue","value":"edited_by"},{"kind":"EnumValue","value":"edited_at"},{"kind":"EnumValue","value":"id"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edited_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edited_at"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"global_product"}},{"kind":"Field","name":{"kind":"Name","value":"shared_at"}}]}}]}}]} as unknown as DocumentNode<MyMutationMutation, MyMutationMutationVariables>;
export const UpsertInstrumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertInstruments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shared_instruments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"shared_instrument_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"local_instruments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"local_instrument_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_shared_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shared_instruments"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"shared_instrument_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"},{"kind":"EnumValue","value":"edited_by"},{"kind":"EnumValue","value":"edited_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_local_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"local_instruments"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"local_instrument_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"},{"kind":"EnumValue","value":"edited_at"},{"kind":"EnumValue","value":"storage_type"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storage_type"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertInstrumentsMutation, UpsertInstrumentsMutationVariables>;
export const GetGlobalProductIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGlobalProductIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetGlobalProductIdsQuery, GetGlobalProductIdsQueryVariables>;
export const UserSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}},{"kind":"Field","name":{"kind":"Name","value":"session_start"}},{"kind":"Field","name":{"kind":"Name","value":"is_mobile"}},{"kind":"Field","name":{"kind":"Name","value":"excel"}}]}}]}}]} as unknown as DocumentNode<UserSessionSubscription, UserSessionSubscriptionVariables>;
export const UserExcelSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserExcelSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel_session_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}},{"kind":"Field","name":{"kind":"Name","value":"session_start"}},{"kind":"Field","name":{"kind":"Name","value":"is_mobile"}},{"kind":"Field","name":{"kind":"Name","value":"excel"}},{"kind":"Field","name":{"kind":"Name","value":"excel_session_id"}}]}}]}}]} as unknown as DocumentNode<UserExcelSessionSubscription, UserExcelSessionSubscriptionVariables>;
export const StartSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"session_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_seen"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"session_start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_session_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"session_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_seen"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"session_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"session_start"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"session_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"id"},{"kind":"EnumValue","value":"last_seen"},{"kind":"EnumValue","value":"session_start"},{"kind":"EnumValue","value":"excel"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logout_requested_at"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StartSessionMutation, StartSessionMutationVariables>;
export const StartExcelSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartExcelSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_seen"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"session_start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excel_session_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_session_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excel_session_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_seen"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"session_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"session_start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel_session_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excel_session_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"session_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"last_seen"},{"kind":"EnumValue","value":"session_start"},{"kind":"EnumValue","value":"excel"},{"kind":"EnumValue","value":"excel_session_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}},{"kind":"Field","name":{"kind":"Name","value":"excel_session_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logout_requested_at"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StartExcelSessionMutation, StartExcelSessionMutationVariables>;
export const LivenessProbeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LivenessProbeMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_session_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LivenessProbeMutationMutation, LivenessProbeMutationMutationVariables>;
export const ExcelLivenessProbeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExcelLivenessProbeMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_session_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExcelLivenessProbeMutationMutation, ExcelLivenessProbeMutationMutationVariables>;
export const DeleteSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logout_requested_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_session"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteSessionMutation, DeleteSessionMutationVariables>;
export const ClearExcelSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearExcelSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_session_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"excel_session_id"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"excel"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excel_session_id"}},{"kind":"Field","name":{"kind":"Name","value":"excel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logout_requested_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClearExcelSessionMutation, ClearExcelSessionMutationVariables>;
export const DeleteAlertsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAlerts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteAlertsMutation, DeleteAlertsMutationVariables>;
export const UpsertAlertsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAlerts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alerts_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"alerts_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"limit"},{"kind":"EnumValue","value":"_id"},{"kind":"EnumValue","value":"column_id"},{"kind":"EnumValue","value":"desktop_notification_sent"},{"kind":"EnumValue","value":"field_selector"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"page_id"},{"kind":"EnumValue","value":"product_id"},{"kind":"EnumValue","value":"push_notification_sent"},{"kind":"EnumValue","value":"recurring"},{"kind":"EnumValue","value":"row_id"},{"kind":"EnumValue","value":"sound"},{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"triggered_at"},{"kind":"EnumValue","value":"user_id"},{"kind":"EnumValue","value":"value_below_limit"},{"kind":"EnumValue","value":"created_at"},{"kind":"EnumValue","value":"expired_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpsertAlertsMutation, UpsertAlertsMutationVariables>;
export const AlertsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AlertFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertsQueryQuery, AlertsQueryQueryVariables>;
export const AlertsQueryByPageIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertsQueryByPageId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AlertFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertsQueryByPageIdQuery, AlertsQueryByPageIdQueryVariables>;
export const AlertsQueryByPageIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertsQueryByPageIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AlertFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertsQueryByPageIdsQuery, AlertsQueryByPageIdsQueryVariables>;
export const AlertExistsQueryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertExistsQueryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}}]}}]}}]} as unknown as DocumentNode<AlertExistsQueryByIdQuery, AlertExistsQueryByIdQueryVariables>;
export const AlertQueryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertQueryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AlertFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertQueryByIdQuery, AlertQueryByIdQueryVariables>;
export const AlertsInsertManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AlertsInsertMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alerts_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AlertsInsertManyMutation, AlertsInsertManyMutationVariables>;
export const AlertsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AlertsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"alerts_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AlertsUpdateMutation, AlertsUpdateMutationVariables>;
export const AlertDeleteMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AlertDeleteMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AlertDeleteMutationMutation, AlertDeleteMutationMutationVariables>;
export const UserPushSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPushSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"push_subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"}}]}}]}}]} as unknown as DocumentNode<UserPushSubscriptionsQuery, UserPushSubscriptionsQueryVariables>;
export const UserPushSubscriptionsUpsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserPushSubscriptionsUpsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_push_subscriptions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptions"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"push_subscriptions_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"subscriptions"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"}}]}}]}}]} as unknown as DocumentNode<UserPushSubscriptionsUpsertMutation, UserPushSubscriptionsUpsertMutationVariables>;
export const FeatureFlagsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FeatureFlagsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature_flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<FeatureFlagsSubscriptionSubscription, FeatureFlagsSubscriptionSubscriptionVariables>;
export const AllFeatureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllFeatureFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature_flags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<AllFeatureFlagsQuery, AllFeatureFlagsQueryVariables>;
export const UpsertConditionalFormattingRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertConditionalFormattingRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_conditional_formatting_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"conditional_formatting_rules_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"_id"},{"kind":"EnumValue","value":"bg_color"},{"kind":"EnumValue","value":"bold_text"},{"kind":"EnumValue","value":"column_id"},{"kind":"EnumValue","value":"invert_text_color"},{"kind":"EnumValue","value":"limit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"page_id"},{"kind":"EnumValue","value":"priority_idx"},{"kind":"EnumValue","value":"row_id"},{"kind":"EnumValue","value":"rule"},{"kind":"EnumValue","value":"stop_if_true"},{"kind":"EnumValue","value":"user_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpsertConditionalFormattingRulesMutation, UpsertConditionalFormattingRulesMutationVariables>;
export const ConditionalFormattingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConditionalFormattingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditional_formatting_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"bg_color"}},{"kind":"Field","name":{"kind":"Name","value":"bold_text"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"invert_text_color"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority_idx"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"stop_if_true"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<ConditionalFormattingQueryQuery, ConditionalFormattingQueryQueryVariables>;
export const ConditionalFormattingSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ConditionalFormattingSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditional_formatting_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"bg_color"}},{"kind":"Field","name":{"kind":"Name","value":"bold_text"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"invert_text_color"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority_idx"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"stop_if_true"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<ConditionalFormattingSubSubscription, ConditionalFormattingSubSubscriptionVariables>;
export const ConditionalFormattingInsertManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConditionalFormattingInsertMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_conditional_formatting_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ConditionalFormattingInsertManyMutation, ConditionalFormattingInsertManyMutationVariables>;
export const Insert_Conditional_Formatting_Rules_OneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Insert_conditional_formatting_rules_one"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rule"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_conditional_formatting_rules_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rule"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Insert_Conditional_Formatting_Rules_OneMutation, Insert_Conditional_Formatting_Rules_OneMutationVariables>;
export const ConditionalFormattingRulesByPageIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConditionalFormattingRulesByPageId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditional_formatting_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority_idx"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConditionalFormattingRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"conditional_formatting_rules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"bg_color"}},{"kind":"Field","name":{"kind":"Name","value":"bold_text"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"invert_text_color"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority_idx"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"stop_if_true"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<ConditionalFormattingRulesByPageIdQuery, ConditionalFormattingRulesByPageIdQueryVariables>;
export const DeleteConditionalFormattingRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConditionalFormattingRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_conditional_formatting_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteConditionalFormattingRulesMutation, DeleteConditionalFormattingRulesMutationVariables>;
export const GridSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GridSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GridSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_rows"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_switch"}},{"kind":"Field","name":{"kind":"Name","value":"alternating_row_colours"}},{"kind":"Field","name":{"kind":"Name","value":"broadcast_colour"}},{"kind":"Field","name":{"kind":"Name","value":"cal_current"}},{"kind":"Field","name":{"kind":"Name","value":"cal_switch"}},{"kind":"Field","name":{"kind":"Name","value":"cals"}},{"kind":"Field","name":{"kind":"Name","value":"enable_full_month_row_feature"}},{"kind":"Field","name":{"kind":"Name","value":"eod_colour"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"flash_cell_updates"}},{"kind":"Field","name":{"kind":"Name","value":"global_colour"}},{"kind":"Field","name":{"kind":"Name","value":"grid_scratchpad_switch"}},{"kind":"Field","name":{"kind":"Name","value":"header_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"hide_broadcast"}},{"kind":"Field","name":{"kind":"Name","value":"hide_eod"}},{"kind":"Field","name":{"kind":"Name","value":"hide_global"}},{"kind":"Field","name":{"kind":"Name","value":"hide_private"}},{"kind":"Field","name":{"kind":"Name","value":"hide_status_row"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_current"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_switch"}},{"kind":"Field","name":{"kind":"Name","value":"hlvs"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_colour"}},{"kind":"Field","name":{"kind":"Name","value":"increment_map"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_map"}},{"kind":"Field","name":{"kind":"Name","value":"indicator_colour"}},{"kind":"Field","name":{"kind":"Name","value":"listen_colour"}},{"kind":"Field","name":{"kind":"Name","value":"local_colour"}},{"kind":"Field","name":{"kind":"Name","value":"main_month_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_current"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_switch"}},{"kind":"Field","name":{"kind":"Name","value":"qtrs"}},{"kind":"Field","name":{"kind":"Name","value":"quarter_borders"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_cols"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_rows"}},{"kind":"Field","name":{"kind":"Name","value":"season_current"}},{"kind":"Field","name":{"kind":"Name","value":"season_switch"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status_map"}},{"kind":"Field","name":{"kind":"Name","value":"subheader_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"eod_date"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_bracket"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_snapshot_warnings"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_color"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"detailed_tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_curve_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_multiple_curves_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_single_value_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_anomaly_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_paste_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_drag_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_page_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"show_world_clock"}},{"kind":"Field","name":{"kind":"Name","value":"insert_page_position"}},{"kind":"Field","name":{"kind":"Name","value":"insert_column_position"}},{"kind":"Field","name":{"kind":"Name","value":"default_curve_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"anomaly_sensitivity_level"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_dp"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_calc"}},{"kind":"Field","name":{"kind":"Name","value":"saved_colours"}}]}}]} as unknown as DocumentNode<GridSettingsQueryQuery, GridSettingsQueryQueryVariables>;
export const GridSettingsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GridSettingsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GridSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_rows"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_switch"}},{"kind":"Field","name":{"kind":"Name","value":"alternating_row_colours"}},{"kind":"Field","name":{"kind":"Name","value":"broadcast_colour"}},{"kind":"Field","name":{"kind":"Name","value":"cal_current"}},{"kind":"Field","name":{"kind":"Name","value":"cal_switch"}},{"kind":"Field","name":{"kind":"Name","value":"cals"}},{"kind":"Field","name":{"kind":"Name","value":"enable_full_month_row_feature"}},{"kind":"Field","name":{"kind":"Name","value":"eod_colour"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"flash_cell_updates"}},{"kind":"Field","name":{"kind":"Name","value":"global_colour"}},{"kind":"Field","name":{"kind":"Name","value":"grid_scratchpad_switch"}},{"kind":"Field","name":{"kind":"Name","value":"header_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"hide_broadcast"}},{"kind":"Field","name":{"kind":"Name","value":"hide_eod"}},{"kind":"Field","name":{"kind":"Name","value":"hide_global"}},{"kind":"Field","name":{"kind":"Name","value":"hide_private"}},{"kind":"Field","name":{"kind":"Name","value":"hide_status_row"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_current"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_switch"}},{"kind":"Field","name":{"kind":"Name","value":"hlvs"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_colour"}},{"kind":"Field","name":{"kind":"Name","value":"increment_map"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_map"}},{"kind":"Field","name":{"kind":"Name","value":"indicator_colour"}},{"kind":"Field","name":{"kind":"Name","value":"listen_colour"}},{"kind":"Field","name":{"kind":"Name","value":"local_colour"}},{"kind":"Field","name":{"kind":"Name","value":"main_month_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_current"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_switch"}},{"kind":"Field","name":{"kind":"Name","value":"qtrs"}},{"kind":"Field","name":{"kind":"Name","value":"quarter_borders"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_cols"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_rows"}},{"kind":"Field","name":{"kind":"Name","value":"season_current"}},{"kind":"Field","name":{"kind":"Name","value":"season_switch"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status_map"}},{"kind":"Field","name":{"kind":"Name","value":"subheader_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"eod_date"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_bracket"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_snapshot_warnings"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_color"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"detailed_tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_curve_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_multiple_curves_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_single_value_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_anomaly_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_paste_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_drag_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_page_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"show_world_clock"}},{"kind":"Field","name":{"kind":"Name","value":"insert_page_position"}},{"kind":"Field","name":{"kind":"Name","value":"insert_column_position"}},{"kind":"Field","name":{"kind":"Name","value":"default_curve_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"anomaly_sensitivity_level"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_dp"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_calc"}},{"kind":"Field","name":{"kind":"Name","value":"saved_colours"}}]}}]} as unknown as DocumentNode<GridSettingsSubscriptionSubscription, GridSettingsSubscriptionSubscriptionVariables>;
export const GridSettingsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridSettingsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_grid_settings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<GridSettingsUpdateMutation, GridSettingsUpdateMutationVariables>;
export const GridSettingsInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridSettingsInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_grid_settings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"grid_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"adhoc_spreads_rows"},{"kind":"EnumValue","value":"adhoc_spreads_switch"},{"kind":"EnumValue","value":"alternating_row_colours"},{"kind":"EnumValue","value":"broadcast_colour"},{"kind":"EnumValue","value":"cal_current"},{"kind":"EnumValue","value":"cal_switch"},{"kind":"EnumValue","value":"cals"},{"kind":"EnumValue","value":"enable_full_month_row_feature"},{"kind":"EnumValue","value":"eod_colour"},{"kind":"EnumValue","value":"extra_header_height"},{"kind":"EnumValue","value":"flash_cell_updates"},{"kind":"EnumValue","value":"global_colour"},{"kind":"EnumValue","value":"grid_scratchpad_switch"},{"kind":"EnumValue","value":"header_column_colour"},{"kind":"EnumValue","value":"hide_broadcast"},{"kind":"EnumValue","value":"hide_eod"},{"kind":"EnumValue","value":"hide_global"},{"kind":"EnumValue","value":"hide_private"},{"kind":"EnumValue","value":"hide_status_row"},{"kind":"EnumValue","value":"hlv_current"},{"kind":"EnumValue","value":"hlv_switch"},{"kind":"EnumValue","value":"hlvs"},{"kind":"EnumValue","value":"hybrid_colour"},{"kind":"EnumValue","value":"increment_map"},{"kind":"EnumValue","value":"display_name_map"},{"kind":"EnumValue","value":"indicator_colour"},{"kind":"EnumValue","value":"listen_colour"},{"kind":"EnumValue","value":"local_colour"},{"kind":"EnumValue","value":"main_month_column_width"},{"kind":"EnumValue","value":"months"},{"kind":"EnumValue","value":"qtr_current"},{"kind":"EnumValue","value":"qtr_switch"},{"kind":"EnumValue","value":"qtrs"},{"kind":"EnumValue","value":"quarter_borders"},{"kind":"EnumValue","value":"scratchpad_max_cols"},{"kind":"EnumValue","value":"scratchpad_max_rows"},{"kind":"EnumValue","value":"season_current"},{"kind":"EnumValue","value":"season_switch"},{"kind":"EnumValue","value":"seasons"},{"kind":"EnumValue","value":"sound"},{"kind":"EnumValue","value":"status_map"},{"kind":"EnumValue","value":"subheader_column_colour"},{"kind":"EnumValue","value":"updated_at"},{"kind":"EnumValue","value":"eod_date"},{"kind":"EnumValue","value":"enabled_snapshot_warnings"},{"kind":"EnumValue","value":"commodity_parent_group"},{"kind":"EnumValue","value":"geographical_region"},{"kind":"EnumValue","value":"commodity_group"},{"kind":"EnumValue","value":"package"},{"kind":"EnumValue","value":"description"},{"kind":"EnumValue","value":"source"},{"kind":"EnumValue","value":"field_name"},{"kind":"EnumValue","value":"detailed_tooltip"},{"kind":"EnumValue","value":"dont_show_remove_curve_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_remove_multiple_curves_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_clear_single_value_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_clear_multiple_values_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_anomaly_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_paste_multiple_values_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_drag_multiple_values_confirmation_dialog"},{"kind":"EnumValue","value":"dont_show_remove_page_confirmation_dialog"},{"kind":"EnumValue","value":"show_world_clock"},{"kind":"EnumValue","value":"insert_page_position"},{"kind":"EnumValue","value":"insert_column_position"},{"kind":"EnumValue","value":"default_curve_column_width"},{"kind":"EnumValue","value":"anomaly_sensitivity_level"},{"kind":"EnumValue","value":"range_summary_dp"},{"kind":"EnumValue","value":"range_summary_calc"},{"kind":"EnumValue","value":"display_negative_color"},{"kind":"EnumValue","value":"display_negative_bracket"},{"kind":"EnumValue","value":"saved_colours"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GridSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_rows"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads_switch"}},{"kind":"Field","name":{"kind":"Name","value":"alternating_row_colours"}},{"kind":"Field","name":{"kind":"Name","value":"broadcast_colour"}},{"kind":"Field","name":{"kind":"Name","value":"cal_current"}},{"kind":"Field","name":{"kind":"Name","value":"cal_switch"}},{"kind":"Field","name":{"kind":"Name","value":"cals"}},{"kind":"Field","name":{"kind":"Name","value":"enable_full_month_row_feature"}},{"kind":"Field","name":{"kind":"Name","value":"eod_colour"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"flash_cell_updates"}},{"kind":"Field","name":{"kind":"Name","value":"global_colour"}},{"kind":"Field","name":{"kind":"Name","value":"grid_scratchpad_switch"}},{"kind":"Field","name":{"kind":"Name","value":"header_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"hide_broadcast"}},{"kind":"Field","name":{"kind":"Name","value":"hide_eod"}},{"kind":"Field","name":{"kind":"Name","value":"hide_global"}},{"kind":"Field","name":{"kind":"Name","value":"hide_private"}},{"kind":"Field","name":{"kind":"Name","value":"hide_status_row"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_current"}},{"kind":"Field","name":{"kind":"Name","value":"hlv_switch"}},{"kind":"Field","name":{"kind":"Name","value":"hlvs"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_colour"}},{"kind":"Field","name":{"kind":"Name","value":"increment_map"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_map"}},{"kind":"Field","name":{"kind":"Name","value":"indicator_colour"}},{"kind":"Field","name":{"kind":"Name","value":"listen_colour"}},{"kind":"Field","name":{"kind":"Name","value":"local_colour"}},{"kind":"Field","name":{"kind":"Name","value":"main_month_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_current"}},{"kind":"Field","name":{"kind":"Name","value":"qtr_switch"}},{"kind":"Field","name":{"kind":"Name","value":"qtrs"}},{"kind":"Field","name":{"kind":"Name","value":"quarter_borders"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_cols"}},{"kind":"Field","name":{"kind":"Name","value":"scratchpad_max_rows"}},{"kind":"Field","name":{"kind":"Name","value":"season_current"}},{"kind":"Field","name":{"kind":"Name","value":"season_switch"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status_map"}},{"kind":"Field","name":{"kind":"Name","value":"subheader_column_colour"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"eod_date"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_bracket"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_snapshot_warnings"}},{"kind":"Field","name":{"kind":"Name","value":"display_negative_color"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"detailed_tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_curve_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_multiple_curves_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_single_value_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_clear_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_anomaly_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_paste_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_drag_multiple_values_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"dont_show_remove_page_confirmation_dialog"}},{"kind":"Field","name":{"kind":"Name","value":"show_world_clock"}},{"kind":"Field","name":{"kind":"Name","value":"insert_page_position"}},{"kind":"Field","name":{"kind":"Name","value":"insert_column_position"}},{"kind":"Field","name":{"kind":"Name","value":"default_curve_column_width"}},{"kind":"Field","name":{"kind":"Name","value":"anomaly_sensitivity_level"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_dp"}},{"kind":"Field","name":{"kind":"Name","value":"range_summary_calc"}},{"kind":"Field","name":{"kind":"Name","value":"saved_colours"}}]}}]} as unknown as DocumentNode<GridSettingsInsertMutation, GridSettingsInsertMutationVariables>;
export const SnapshotDateQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SnapshotDateQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eod_entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"evaluation_date"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}}]}}]}}]} as unknown as DocumentNode<SnapshotDateQueryQuery, SnapshotDateQueryQueryVariables>;
export const GridSettingsThemeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GridSettingsThemeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GridSettingsTheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridSettingsTheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}}]}}]} as unknown as DocumentNode<GridSettingsThemeQueryQuery, GridSettingsThemeQueryQueryVariables>;
export const GridSettingsThemeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridSettingsThemeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"theme"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"theme_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_grid_settings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theme"},"value":{"kind":"Variable","name":{"kind":"Name","value":"theme"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}}]}}]}}]} as unknown as DocumentNode<GridSettingsThemeUpdateMutation, GridSettingsThemeUpdateMutationVariables>;
export const HfcAbsoluteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HFCAbsolute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eval_start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eod_entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eval_start"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HFCAbsoluteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HFCAbsoluteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eod_entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"productByProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}}]}}]}}]} as unknown as DocumentNode<HfcAbsoluteQuery, HfcAbsoluteQueryVariables>;
export const HfcRelativeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HFCRelative"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relative_period"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"months"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eod_entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"relative_period"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relative_period"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"months"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HFCRelativeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HFCRelativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eod_entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}},{"kind":"Field","name":{"kind":"Name","value":"relative_period"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"productByProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}}]}}]}}]} as unknown as DocumentNode<HfcRelativeQuery, HfcRelativeQueryVariables>;
export const IncidentBannersSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"IncidentBannersSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident_banners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}}]}}]}}]} as unknown as DocumentNode<IncidentBannersSubscriptionSubscription, IncidentBannersSubscriptionSubscriptionVariables>;
export const LiveChartPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveChartPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"live_chart_page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiveChartPageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_page"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charts"}},{"kind":"Field","name":{"kind":"Name","value":"page_type"}}]}}]} as unknown as DocumentNode<LiveChartPageQueryQuery, LiveChartPageQueryQueryVariables>;
export const LiveChartPageInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LiveChartPageInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_page_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_live_chart_page_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiveChartPageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_page"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charts"}},{"kind":"Field","name":{"kind":"Name","value":"page_type"}}]}}]} as unknown as DocumentNode<LiveChartPageInsertMutation, LiveChartPageInsertMutationVariables>;
export const LiveChartPageUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LiveChartPageUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_page_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_live_chart_page_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<LiveChartPageUpdateMutation, LiveChartPageUpdateMutationVariables>;
export const LiveChartPageDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LiveChartPageDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_live_chart_page_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<LiveChartPageDeleteMutation, LiveChartPageDeleteMutationVariables>;
export const LiveChartSettingsInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LiveChartSettingsInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_settings_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_live_chart_settings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiveChartSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"curve_settings"}},{"kind":"Field","name":{"kind":"Name","value":"charts_state"}},{"kind":"Field","name":{"kind":"Name","value":"user_settings"}}]}}]} as unknown as DocumentNode<LiveChartSettingsInsertMutation, LiveChartSettingsInsertMutationVariables>;
export const LiveChartSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveChartSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"live_chart_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiveChartSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"curve_settings"}},{"kind":"Field","name":{"kind":"Name","value":"charts_state"}},{"kind":"Field","name":{"kind":"Name","value":"user_settings"}}]}}]} as unknown as DocumentNode<LiveChartSettingsQueryQuery, LiveChartSettingsQueryQueryVariables>;
export const LiveChartSettingsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LiveChartSettingsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_settings_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_live_chart_settings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<LiveChartSettingsUpdateMutation, LiveChartSettingsUpdateMutationVariables>;
export const LiveChartAnnotationsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveChartAnnotationsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"live_chart_annotations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiveChartAnnotationsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartAnnotationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_annotations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"}}]}}]} as unknown as DocumentNode<LiveChartAnnotationsQueryQuery, LiveChartAnnotationsQueryQueryVariables>;
export const UpsertAnnotationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAnnotation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_annotations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_live_chart_annotations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"live_chart_annotations_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"annotations"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiveChartAnnotationsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiveChartAnnotationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"live_chart_annotations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"}}]}}]} as unknown as DocumentNode<UpsertAnnotationMutation, UpsertAnnotationMutationVariables>;
export const MfaStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MfaState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfa_opted_out"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfa_mode"}}]}}]}}]} as unknown as DocumentNode<MfaStateQuery, MfaStateQueryVariables>;
export const SetMfaOptOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMfaOptOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_folio_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mfa_opted_out"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<SetMfaOptOutMutation, SetMfaOptOutMutationVariables>;
export const ModuleStorageGetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModuleStorageGet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"module"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_storage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"module"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rev"}}]}}]}}]} as unknown as DocumentNode<ModuleStorageGetQuery, ModuleStorageGetQueryVariables>;
export const ModuleStorageSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ModuleStorageSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"module"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_module_storage_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module"},"value":{"kind":"Variable","name":{"kind":"Name","value":"module"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"module_storage_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rev"}}]}}]}}]} as unknown as DocumentNode<ModuleStorageSetMutation, ModuleStorageSetMutationVariables>;
export const ModuleStorageStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ModuleStorageStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursorRev"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_storage_stream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"batch_size"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initial_value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rev"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursorRev"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ordering"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rev"}}]}}]}}]} as unknown as DocumentNode<ModuleStorageStreamSubscription, ModuleStorageStreamSubscriptionVariables>;
export const OrgByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orgById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needs_historical_data"}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}}]}}]}}]}}]} as unknown as DocumentNode<OrgByIdQuery, OrgByIdQueryVariables>;
export const PagesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PagesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}}]} as unknown as DocumentNode<PagesQueryQuery, PagesQueryQueryVariables>;
export const PagesByPageIdsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PagesByPageIdsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}}]} as unknown as DocumentNode<PagesByPageIdsQueryQuery, PagesByPageIdsQueryQueryVariables>;
export const PageMembersByPageIdsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMembersByPageIdsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageMemberFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_order"}},{"kind":"Field","name":{"kind":"Name","value":"Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}}]} as unknown as DocumentNode<PageMembersByPageIdsQueryQuery, PageMembersByPageIdsQueryQueryVariables>;
export const PageMembersByUserIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMembersByUserIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageMemberFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_order"}},{"kind":"Field","name":{"kind":"Name","value":"Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}}]} as unknown as DocumentNode<PageMembersByUserIdQueryQuery, PageMembersByUserIdQueryQueryVariables>;
export const PagesSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PagesSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}}]} as unknown as DocumentNode<PagesSubscriptionSubscription, PagesSubscriptionSubscriptionVariables>;
export const PageMemberQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMemberQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageMemberFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_order"}},{"kind":"Field","name":{"kind":"Name","value":"Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}}]} as unknown as DocumentNode<PageMemberQueryQuery, PageMemberQueryQueryVariables>;
export const PageMemberSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PageMemberSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageMemberFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"period_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_header_height"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"column_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"cell_highlights"}},{"kind":"Field","name":{"kind":"Name","value":"adhoc_spreads"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"field_name"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_column_width"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_order"}},{"kind":"Field","name":{"kind":"Name","value":"Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageFragment"}}]}}]}}]} as unknown as DocumentNode<PageMemberSubscriptionSubscription, PageMemberSubscriptionSubscriptionVariables>;
export const Update_Pages_By_PkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Update_pages_by_pk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pages_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_pages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Update_Pages_By_PkMutation, Update_Pages_By_PkMutationVariables>;
export const Update_Page_MemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Update_page_member"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageOrder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageOrder"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<Update_Page_MemberMutation, Update_Page_MemberMutationVariables>;
export const PageInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pages_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pages_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}}]}}]}}]} as unknown as DocumentNode<PageInsertMutation, PageInsertMutationVariables>;
export const PageMemberInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageMemberInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"member"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"page_member_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_page_member_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"member"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_order"}}]}}]}}]} as unknown as DocumentNode<PageMemberInsertMutation, PageMemberInsertMutationVariables>;
export const PageInsertManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageInsertMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pages_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PageInsertManyMutation, PageInsertManyMutationVariables>;
export const PageMemberInsertManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageMemberInsertMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"page_member_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PageMemberInsertManyMutation, PageMemberInsertManyMutationVariables>;
export const PageDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_pages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PageDeleteMutation, PageDeleteMutationVariables>;
export const PageMemberDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageMemberDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PageMemberDeleteMutation, PageMemberDeleteMutationVariables>;
export const PageMembersDeleteByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageMembersDeleteByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_page_member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PageMembersDeleteByUserMutation, PageMembersDeleteByUserMutationVariables>;
export const AllPageProductsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPageProductsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageProductsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageProductsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_products"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grid_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_places"}},{"kind":"Field","name":{"kind":"Name","value":"column_width"}},{"kind":"Field","name":{"kind":"Name","value":"column_type"}},{"kind":"Field","name":{"kind":"Name","value":"column_field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<AllPageProductsQueryQuery, AllPageProductsQueryQueryVariables>;
export const AllPageProductsSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AllPageProductsSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageProductsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageProductsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_products"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grid_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_places"}},{"kind":"Field","name":{"kind":"Name","value":"column_width"}},{"kind":"Field","name":{"kind":"Name","value":"column_type"}},{"kind":"Field","name":{"kind":"Name","value":"column_field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<AllPageProductsSubSubscription, AllPageProductsSubSubscriptionVariables>;
export const PageProductsQueryByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageProductsQueryByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageProductsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageProductsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_products"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grid_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_places"}},{"kind":"Field","name":{"kind":"Name","value":"column_width"}},{"kind":"Field","name":{"kind":"Name","value":"column_type"}},{"kind":"Field","name":{"kind":"Name","value":"column_field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<PageProductsQueryByIdsQuery, PageProductsQueryByIdsQueryVariables>;
export const PageProductUpdateSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PageProductUpdateSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageProductsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageProductsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_products"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grid_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_places"}},{"kind":"Field","name":{"kind":"Name","value":"column_width"}},{"kind":"Field","name":{"kind":"Name","value":"column_type"}},{"kind":"Field","name":{"kind":"Name","value":"column_field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<PageProductUpdateSubSubscription, PageProductUpdateSubSubscriptionVariables>;
export const PageProductsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PageProductsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageProductsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageProductsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_products"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grid_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_places"}},{"kind":"Field","name":{"kind":"Name","value":"column_width"}},{"kind":"Field","name":{"kind":"Name","value":"column_type"}},{"kind":"Field","name":{"kind":"Name","value":"column_field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<PageProductsSubscriptionSubscription, PageProductsSubscriptionSubscriptionVariables>;
export const PageProductUpdateManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageProductUpdateMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"page_products_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_page_products_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PageProductUpdateManyMutation, PageProductUpdateManyMutationVariables>;
export const PageProductsInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageProductsInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"page_products_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_page_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PageProductsInsertMutation, PageProductsInsertMutationVariables>;
export const PageProductsHardDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PageProductsHardDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_page_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PageProductsHardDeleteMutation, PageProductsHardDeleteMutationVariables>;
export const AllSourcesForProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllSourcesForProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"global_product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"globalProductByGlobalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalPackageByGlobalPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllSourcesForProductsQuery, AllSourcesForProductsQueryVariables>;
export const ConfigsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxRelMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relative_month"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relative_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxRelMonth"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","alias":{"kind":"Name","value":"offset"},"name":{"kind":"Name","value":"relative_month"}}]}}]}}]} as unknown as DocumentNode<ConfigsQueryQuery, ConfigsQueryQueryVariables>;
export const ConfigsSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ConfigsSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxRelMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relative_month"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relative_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxRelMonth"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","alias":{"kind":"Name","value":"offset"},"name":{"kind":"Name","value":"relative_month"}}]}}]}}]} as unknown as DocumentNode<ConfigsSubSubscription, ConfigsSubSubscriptionVariables>;
export const ProductInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"artis_type"}},{"kind":"Field","name":{"kind":"Name","value":"curve_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"eod_product_dep"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"has_shared_cell"}},{"kind":"Field","name":{"kind":"Name","value":"logical_code"}},{"kind":"Field","name":{"kind":"Name","value":"maturity"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"summary_type"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}},{"kind":"Field","name":{"kind":"Name","value":"product_uom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupByCommodityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","alias":{"kind":"Name","value":"commodity_group"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"commodity_parent_group"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalRegionByGeographicalRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"geographical_region"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_global_dependencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"}}]}}]}}]} as unknown as DocumentNode<ProductInfoQuery, ProductInfoQueryVariables>;
export const ProductInfoSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ProductInfoSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"artis_type"}},{"kind":"Field","name":{"kind":"Name","value":"curve_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"eod_product_dep"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"has_shared_cell"}},{"kind":"Field","name":{"kind":"Name","value":"logical_code"}},{"kind":"Field","name":{"kind":"Name","value":"maturity"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"summary_type"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}},{"kind":"Field","name":{"kind":"Name","value":"product_uom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupByCommodityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","alias":{"kind":"Name","value":"commodity_group"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"commodity_parent_group"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalRegionByGeographicalRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"geographical_region"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_global_dependencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"}}]}}]}}]} as unknown as DocumentNode<ProductInfoSubSubscription, ProductInfoSubSubscriptionVariables>;
export const GridProductsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GridProductsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"artis_type"}},{"kind":"Field","name":{"kind":"Name","value":"curve_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"eod_product_dep"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"has_shared_cell"}},{"kind":"Field","name":{"kind":"Name","value":"logical_code"}},{"kind":"Field","name":{"kind":"Name","value":"maturity"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"summary_type"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}},{"kind":"Field","name":{"kind":"Name","value":"product_uom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupByCommodityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","alias":{"kind":"Name","value":"commodity_group"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"commodity_parent_group"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalRegionByGeographicalRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"geographical_region"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_global_dependencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"}}]}}]}}]} as unknown as DocumentNode<GridProductsByIdsQuery, GridProductsByIdsQueryVariables>;
export const PackageFolderAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PackageFolderAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}}]}}]}}]} as unknown as DocumentNode<PackageFolderAccessQuery, PackageFolderAccessQueryVariables>;
export const GlobalProductsForLiveChartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalProductsForLiveCharts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalProductInfoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"global_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"global_package"}},{"kind":"Field","name":{"kind":"Name","value":"globalPackageByGlobalPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"global_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}}]}}]}}]} as unknown as DocumentNode<GlobalProductsForLiveChartsQuery, GlobalProductsForLiveChartsQueryVariables>;
export const GlobalPackagesByProductIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalPackagesByProductIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"global_products"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GlobalPackagesByProductIdsQuery, GlobalPackagesByProductIdsQueryVariables>;
export const GlobalProductsByProductsIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalProductsByProductsIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"global_package"}}]}}]}}]} as unknown as DocumentNode<GlobalProductsByProductsIdsQuery, GlobalProductsByProductsIdsQueryVariables>;
export const PackagesDpQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PackagesDpQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}}]}}]}}]} as unknown as DocumentNode<PackagesDpQueryQuery, PackagesDpQueryQueryVariables>;
export const ProductUserSettingsByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductUserSettingsByUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_user_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUserSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product_user_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}}]}}]} as unknown as DocumentNode<ProductUserSettingsByUserIdQuery, ProductUserSettingsByUserIdQueryVariables>;
export const UpsertProductUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertProductUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_product_user_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dp"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"product_user_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"dp"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertProductUserSettingsMutation, UpsertProductUserSettingsMutationVariables>;
export const UserSessionSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserSessionSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}}]}}]}}]} as unknown as DocumentNode<UserSessionSubSubscription, UserSessionSubSubscriptionVariables>;
export const Insert_Logout_Request_OneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Insert_logout_request_one"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logout_request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"logout_request_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_logout_request_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logout_request"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"logout_request_user_context_unique"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout_requested_at"}}]}}]}}]} as unknown as DocumentNode<Insert_Logout_Request_OneMutation, Insert_Logout_Request_OneMutationVariables>;
export const UpdateUserSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"session"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_session_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"session"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_seen"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"session_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"id"},{"kind":"EnumValue","value":"last_seen"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_logout_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSessionMutation, UpdateUserSessionMutationVariables>;
export const UserSessionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSessionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen"}}]}}]}}]} as unknown as DocumentNode<UserSessionQueryQuery, UserSessionQueryQueryVariables>;
export const SourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SourcesQuery, SourcesQueryVariables>;
export const MarketUserPermissionsSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MarketUserPermissionsSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"package"}}]}}]}}]} as unknown as DocumentNode<MarketUserPermissionsSubSubscription, MarketUserPermissionsSubSubscriptionVariables>;
export const PermissionFolderDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PermissionFolderDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packages"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"package"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packages"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PermissionFolderDetailsQueryQuery, PermissionFolderDetailsQueryQueryVariables>;
export const CurrentUserSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CurrentUserSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folio_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"}},{"kind":"Field","name":{"kind":"Name","value":"multisession_check_disabled"}},{"kind":"Field","name":{"kind":"Name","value":"webapp2"}},{"kind":"Field","name":{"kind":"Name","value":"persona"}},{"kind":"Field","name":{"kind":"Name","value":"logout_requested_at"}},{"kind":"Field","name":{"kind":"Name","value":"entitlement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}}]}}]}}]} as unknown as DocumentNode<CurrentUserSubSubscription, CurrentUserSubSubscriptionVariables>;
export const CurrentUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folio_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"}},{"kind":"Field","name":{"kind":"Name","value":"multisession_check_disabled"}},{"kind":"Field","name":{"kind":"Name","value":"webapp2"}},{"kind":"Field","name":{"kind":"Name","value":"persona"}},{"kind":"Field","name":{"kind":"Name","value":"logout_requested_at"}},{"kind":"Field","name":{"kind":"Name","value":"entitlement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}}]}}]}}]} as unknown as DocumentNode<CurrentUserQueryQuery, CurrentUserQueryQueryVariables>;
export const BlockedUserSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"BlockedUserSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}}]}}]} as unknown as DocumentNode<BlockedUserSubSubscription, BlockedUserSubSubscriptionVariables>;
export const UserExchangePermissionsSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserExchangePermissionsSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"packageByPackage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceBySource"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"exchange"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UserExchangePermissionsSubSubscription, UserExchangePermissionsSubSubscriptionVariables>;
export const UserPermissionsDetailedSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserPermissionsDetailedSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folio_user"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserPermissionsDetailedSubSubscription, UserPermissionsDetailedSubSubscriptionVariables>;
export const UpdateUserPersonaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserPersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"persona"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"persona_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_folio_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"persona"},"value":{"kind":"Variable","name":{"kind":"Name","value":"persona"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"persona"}}]}}]}}]} as unknown as DocumentNode<UpdateUserPersonaMutation, UpdateUserPersonaMutationVariables>;
export const LastExchangeUsageForSingleUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LastExchangeUsageForSingleUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchange_usage_last"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"event"}}]}}]}}]} as unknown as DocumentNode<LastExchangeUsageForSingleUserSubscription, LastExchangeUsageForSingleUserSubscriptionVariables>;
export const AmendExchangeUsageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AmendExchangeUsage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exchangeUsages"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"exchange_usage_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_exchange_usage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exchangeUsages"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AmendExchangeUsageMutation, AmendExchangeUsageMutationVariables>;
export const UserGroupsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserGroupsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGroupsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"users"}}]}}]} as unknown as DocumentNode<UserGroupsQueryQuery, UserGroupsQueryQueryVariables>;
export const OrgUserProfilesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgUserProfilesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user_basic_profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folio_user_basic_profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"is_staff"}}]}}]} as unknown as DocumentNode<OrgUserProfilesQueryQuery, OrgUserProfilesQueryQueryVariables>;
export const UserProfilesByIdsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfilesByIdsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folio_user_basic_profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folio_user_basic_profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"is_staff"}}]}}]} as unknown as DocumentNode<UserProfilesByIdsQueryQuery, UserProfilesByIdsQueryQueryVariables>;
export const PersonaEnumQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonaEnumQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"persona_enum","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enumValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PersonaEnumQueryQuery, PersonaEnumQueryQueryVariables>;
export const AlertSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AlertSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AlertFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"alerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"desktop_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"field_selector"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"push_notification_sent"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"row_id"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggered_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value_below_limit"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}}]}}]} as unknown as DocumentNode<AlertSubSubscription, AlertSubSubscriptionVariables>;
export const AlertChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AlertChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alerts_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AlertChangeMutation, AlertChangeMutationVariables>;
export const AlertRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AlertRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AlertRemoveMutation, AlertRemoveMutationVariables>;
export const PageProductIdsSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PageProductIdsSub"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_id"}}]}}]}}]} as unknown as DocumentNode<PageProductIdsSubSubscription, PageProductIdsSubSubscriptionVariables>;
export const PriorEodDateQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriorEodDateQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"prior"},"name":{"kind":"Name","value":"eod_entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"evaluation_date"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}}]}}]}}]} as unknown as DocumentNode<PriorEodDateQueryQuery, PriorEodDateQueryQueryVariables>;
export const EodSnapshotQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EodSnapshotQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eval_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"prior"},"name":{"kind":"Name","value":"eod_entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"evaluation_date"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluation_date"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"entries"},"name":{"kind":"Name","value":"eod_entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"evaluation_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eval_date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EodSnapshotQueryQuery, EodSnapshotQueryQueryVariables>;
export const LocalQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"local_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edited_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"local_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"storage_type"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<LocalQueryQuery, LocalQueryQueryVariables>;
export const LocalSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LocalSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"local_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edited_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"local_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"storage_type"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<LocalSubSubscription, LocalSubSubscriptionVariables>;
export const SharedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SharedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shared_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"shared_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]} as unknown as DocumentNode<SharedQueryQuery, SharedQueryQueryVariables>;
export const SharedSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SharedSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shared_instrument_stream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initial_value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edited_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ordering"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"batch_size"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"shared_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]} as unknown as DocumentNode<SharedSubSubscription, SharedSubSubscriptionVariables>;
export const GlobalQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"global_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"global_product"}}]}}]} as unknown as DocumentNode<GlobalQueryQuery, GlobalQueryQueryVariables>;
export const GlobalSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GlobalSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_instrument_stream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initial_value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edited_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ordering"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_month"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latest_month"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"batch_size"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"global_instrument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"edited_at"}},{"kind":"Field","name":{"kind":"Name","value":"edited_by"}},{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"global_product"}}]}}]} as unknown as DocumentNode<GlobalSubSubscription, GlobalSubSubscriptionVariables>;
export const SpreaderStateByPageIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpreaderStateByPageId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreader_state"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpreaderStateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpreaderStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"row_data"}},{"kind":"Field","name":{"kind":"Name","value":"row_idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<SpreaderStateByPageIdQuery, SpreaderStateByPageIdQueryVariables>;
export const SpreaderStateByPageIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpreaderStateByPageIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreader_state"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpreaderStateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpreaderStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"row_data"}},{"kind":"Field","name":{"kind":"Name","value":"row_idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<SpreaderStateByPageIdsQuery, SpreaderStateByPageIdsQueryVariables>;
export const DeleteSpreaderStateByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpreaderStateByUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_spreader_state"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteSpreaderStateByUserIdMutation, DeleteSpreaderStateByUserIdMutationVariables>;
export const InsertSpreaderStateManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSpreaderStateMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_spreader_state"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertSpreaderStateManyMutation, InsertSpreaderStateManyMutationVariables>;
export const SpreaderStateSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SpreaderStateSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spreader_state"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpreaderStateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpreaderStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"row_data"}},{"kind":"Field","name":{"kind":"Name","value":"row_idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<SpreaderStateSubSubscription, SpreaderStateSubSubscriptionVariables>;
export const UpsertSpreaderStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSpreaderState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"row"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_spreader_state_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"row"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"spreader_state_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"row_data"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpreaderStateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpreaderStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spreader_state"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"row_data"}},{"kind":"Field","name":{"kind":"Name","value":"row_idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<UpsertSpreaderStateMutation, UpsertSpreaderStateMutationVariables>;
export const SpreaderStateDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpreaderStateDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_spreader_state_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SpreaderStateDeleteMutation, SpreaderStateDeleteMutationVariables>;
export const CurvePackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurvePackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurvePackageFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurvePackageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folio_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CurvePackageQuery, CurvePackageQueryVariables>;
export const CurveEodProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveEODProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artis_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"eod"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"curve_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"snapshot"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"artis_type"}},{"kind":"Field","name":{"kind":"Name","value":"curve_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"eod_product_dep"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"has_shared_cell"}},{"kind":"Field","name":{"kind":"Name","value":"logical_code"}},{"kind":"Field","name":{"kind":"Name","value":"maturity"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"summary_type"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"dp"}},{"kind":"Field","name":{"kind":"Name","value":"product_uom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageByPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupByCommodityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","alias":{"kind":"Name","value":"commodity_group"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"commodity_parent_group"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalRegionByGeographicalRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"geographical_region"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_global_dependencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"}}]}}]}}]} as unknown as DocumentNode<CurveEodProductsQuery, CurveEodProductsQueryVariables>;
export const GlobalCurvesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalCurves"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalProductInfoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalProductInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"global_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"uom"}},{"kind":"Field","name":{"kind":"Name","value":"geographical_region"}},{"kind":"Field","name":{"kind":"Name","value":"commodity_group"}},{"kind":"Field","name":{"kind":"Name","value":"global_package"}},{"kind":"Field","name":{"kind":"Name","value":"globalPackageByGlobalPackage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceBySource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"source_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"global_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folio_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folioUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"folio_user"}}]}}]}}]}}]} as unknown as DocumentNode<GlobalCurvesQuery, GlobalCurvesQueryVariables>;
export const CurvePackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurvePackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurvePackagesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurvePackagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}}]}}]} as unknown as DocumentNode<CurvePackagesQuery, CurvePackagesQueryVariables>;
export const CurveUomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveUOM"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_uom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurveUOMFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveUOMFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product_uom"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<CurveUomQuery, CurveUomQueryVariables>;
export const CurveProductTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveProductType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurveProductTypeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"product_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CurveProductTypeQuery, CurveProductTypeQueryVariables>;
export const CurveCommodityParentGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveCommodityParentGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodity_parent_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurveCommodityParentGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveCommodityParentGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"commodity_parent_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CurveCommodityParentGroupsQuery, CurveCommodityParentGroupsQueryVariables>;
export const CurveRegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographical_region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurveRegionsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveRegionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"geographical_region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CurveRegionsQuery, CurveRegionsQueryVariables>;
export const CurveCommodityGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveCommodityGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodity_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurveCommodityGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurveCommodityGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"commodity_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}}]}}]} as unknown as DocumentNode<CurveCommodityGroupsQuery, CurveCommodityGroupsQueryVariables>;
export const CurveUpsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CurveUpsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"product_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product_configs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"product_config_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offsets_to_delete"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"product_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"description"},{"kind":"EnumValue","value":"code"},{"kind":"EnumValue","value":"maturity"},{"kind":"EnumValue","value":"summary_type"},{"kind":"EnumValue","value":"uom"},{"kind":"EnumValue","value":"geographical_region"},{"kind":"EnumValue","value":"commodity_group"},{"kind":"EnumValue","value":"eod_product_dep"},{"kind":"EnumValue","value":"package"},{"kind":"EnumValue","value":"curve_type"},{"kind":"EnumValue","value":"product_type"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"relative_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offsets_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product_configs"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"product_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"formula"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CurveUpsertMutationMutation, CurveUpsertMutationMutationVariables>;
export const CurveGlobalDependenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveGlobalDependencies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_global_dependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"}},{"kind":"Field","name":{"kind":"Name","value":"product"}}]}}]}}]} as unknown as DocumentNode<CurveGlobalDependenciesQuery, CurveGlobalDependenciesQueryVariables>;
export const CurveGlobalInsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CurveGlobalInsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"product_global_dependencies_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_product_global_dependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CurveGlobalInsertMutationMutation, CurveGlobalInsertMutationMutationVariables>;
export const CurveGlobalDeleteMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CurveGlobalDeleteMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"global_products"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_product_global_dependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"global_product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"global_products"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"global_product"}}]}}]}}]}}]} as unknown as DocumentNode<CurveGlobalDeleteMutationMutation, CurveGlobalDeleteMutationMutationVariables>;
export const GlobalPackagesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalPackagesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GlobalPackagesByIdsQuery, GlobalPackagesByIdsQueryVariables>;
export const AllGlobalisedPackageIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllGlobalisedPackageIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AllGlobalisedPackageIdsQuery, AllGlobalisedPackageIdsQueryVariables>;
export const GlobalisedPackageFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalisedPackageFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_global"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GlobalisedPackageFlagsQuery, GlobalisedPackageFlagsQueryVariables>;
export const GlobalCurveMirrorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalCurveMirrors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"global_package"}}]}}]}}]} as unknown as DocumentNode<GlobalCurveMirrorsQuery, GlobalCurveMirrorsQueryVariables>;
export const UpsertGlobalCurvesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertGlobalCurves"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalProducts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"global_product_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalProductConfigs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"global_product_config_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offsetsToDelete"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_global_product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalProducts"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"global_product_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"description"},{"kind":"EnumValue","value":"uom"},{"kind":"EnumValue","value":"geographical_region"},{"kind":"EnumValue","value":"commodity_group"},{"kind":"EnumValue","value":"curve_type"},{"kind":"EnumValue","value":"global_package"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_global_product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"relative_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offsetsToDelete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_global_product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalProductConfigs"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"global_product_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"formula"},{"kind":"EnumValue","value":"relative_month"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpsertGlobalCurvesMutation, UpsertGlobalCurvesMutationVariables>;
export const InsertGlobalCurveSelfDepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertGlobalCurveSelfDeps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"product_global_dependencies_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_product_global_dependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"product_global_dependencies_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertGlobalCurveSelfDepsMutation, InsertGlobalCurveSelfDepsMutationVariables>;
export const RemoveGlobalCurvesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGlobalCurves"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalProductIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_global_product_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalProductIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_product_global_dependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"global_product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalProductIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_global_product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalProductIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<RemoveGlobalCurvesMutation, RemoveGlobalCurvesMutationVariables>;
export const GridChartsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GridChartsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid_charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GridChartsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridChartsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"grid_charts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idx"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"selector"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]} as unknown as DocumentNode<GridChartsQueryQuery, GridChartsQueryQueryVariables>;
export const GridChartsDeleteMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridChartsDeleteMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_grid_charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<GridChartsDeleteMutationMutation, GridChartsDeleteMutationMutationVariables>;
export const GridChartsDeleteByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridChartsDeleteByUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_grid_charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<GridChartsDeleteByUserIdMutation, GridChartsDeleteByUserIdMutationVariables>;
export const GridChartsInsertManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridChartsInsertMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"grid_charts_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_grid_charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<GridChartsInsertManyMutation, GridChartsInsertManyMutationVariables>;
export const GridChartsUpsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GridChartsUpsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"grid_charts_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_grid_charts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"grid_charts_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"period"},{"kind":"EnumValue","value":"product_id"},{"kind":"EnumValue","value":"selector"},{"kind":"EnumValue","value":"idx"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GridChartsUpsertMutationMutation, GridChartsUpsertMutationMutationVariables>;
export const ViewedAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewedAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewed_announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"viewed_announcements"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"announcement_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"dismissed_at"}}]}}]} as unknown as DocumentNode<ViewedAnnouncementsQuery, ViewedAnnouncementsQueryVariables>;
export const InsertAnnouncementStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertAnnouncementState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dismissedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_viewed_announcements_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"announcement_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewed_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dismissed_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dismissedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"viewed_announcements"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"announcement_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"dismissed_at"}}]}}]} as unknown as DocumentNode<InsertAnnouncementStateMutation, InsertAnnouncementStateMutationVariables>;
export const UpdateAnnouncementStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAnnouncementState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"viewed_announcements_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_viewed_announcements_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewedAnnouncementsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"viewed_announcements"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"announcement_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"dismissed_at"}}]}}]} as unknown as DocumentNode<UpdateAnnouncementStateMutation, UpdateAnnouncementStateMutationVariables>;
export const QuickAccessQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuickAccessQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quick_access"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickAccessFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickAccessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"quick_access"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"column_id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"shortcut_number"}}]}}]} as unknown as DocumentNode<QuickAccessQueryQuery, QuickAccessQueryQueryVariables>;
export const QuickAccessUpsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QuickAccessUpsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"quick_access_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_quick_access_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"quick_access_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"page_id"},{"kind":"EnumValue","value":"column_id"},{"kind":"EnumValue","value":"product_id"},{"kind":"EnumValue","value":"shortcut_number"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<QuickAccessUpsertMutationMutation, QuickAccessUpsertMutationMutationVariables>;
export const PushSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PushSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"push_subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PushSubscriptionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PushSubscriptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"push_subscriptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"}}]}}]} as unknown as DocumentNode<PushSubscriptionQuery, PushSubscriptionQueryVariables>;
export const UpsertPushSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPushSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_push_subscriptions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptions"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"push_subscriptions_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"subscriptions"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PushSubscriptionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PushSubscriptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"push_subscriptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"}}]}}]} as unknown as DocumentNode<UpsertPushSubscriptionMutation, UpsertPushSubscriptionMutationVariables>;